export default JSON.parse(`{
  "fd4f28bb-9114-46b4-92d2-5dfcaaf7d65b": {
    "name": "pin",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "pin": {
        "type": "\`V\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "unit",
      "description": "reference \`unit\` pin with \`type\` and \`name\`",
      "tags": [
        "platform",
        "unit"
      ]
    },
    "id": "fd4f28bb-9114-46b4-92d2-5dfcaaf7d65b",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "0c6703a1-e949-4b55-9e84-71e6c9addd64": {
    "name": "worker",
    "inputs": {
      "init": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {
      "system": {
        "type": "\`S\`",
        "ref": true,
        "icon": "circle"
      }
    },
    "metadata": {
      "icon": "server",
      "description": "remote control a new worker system",
      "tags": [
        "platform",
        "process"
      ]
    },
    "id": "0c6703a1-e949-4b55-9e84-71e6c9addd64",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "98ab5ee1-0997-4ad2-bc77-776208b6bb25": {
    "name": "write",
    "inputs": {
      "value": {
        "type": "\`W<T>\`",
        "ref": true
      },
      "data": {
        "type": "<T>"
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`unit\` property \`name\` to \`data\`",
      "tags": [
        "platform",
        "method",
        "value"
      ]
    },
    "id": "98ab5ee1-0997-4ad2-bc77-776208b6bb25",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "752a3a19-bb1e-4e6d-b363-cfa98e8864be": {
    "name": "read",
    "inputs": {
      "value": {
        "type": "\`V\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "type": "any",
        "ref": true
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`unit\` property \`name\`",
      "tags": [
        "platform",
        "method",
        "value"
      ]
    },
    "id": "752a3a19-bb1e-4e6d-b363-cfa98e8864be",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c6da6b9f-a783-4e58-a252-e543aef109fb": {
    "name": "read",
    "inputs": {
      "value": {
        "type": "\`V<T>\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "type": "<T>"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`unit\` property \`name\`",
      "tags": [
        "platform",
        "method",
        "value"
      ]
    },
    "id": "c6da6b9f-a783-4e58-a252-e543aef109fb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7fe5b907-e9d3-4427-96cf-1b3be39a9bba": {
    "name": "start",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      },
      "opt": {
        "type": "{paused?:boolean}",
        "metadata": {
          "examples": [
            "{}",
            "{paused:true}",
            "{paused:false}"
          ]
        }
      },
      "system": {
        "type": "\`S\`",
        "ref": true
      }
    },
    "outputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true,
        "icon": "graph"
      }
    },
    "metadata": {
      "icon": "server",
      "description": "start a new graph",
      "tags": [
        "platform",
        "method",
        "process"
      ]
    },
    "id": "7fe5b907-e9d3-4427-96cf-1b3be39a9bba",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "324b9c5e-5810-11eb-bf7c-634b3bb07f8c": {
    "name": "new",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "metadata": {
          "examples": [
            "\${unit:{id:'e33e7dcd-9715-461c-a474-15ed2bda899e'}}"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true,
        "icon": "graph"
      }
    },
    "metadata": {
      "icon": "server",
      "description": "start a new graph",
      "tags": [
        "platform",
        "method",
        "process"
      ]
    },
    "id": "324b9c5e-5810-11eb-bf7c-634b3bb07f8c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "23acb820-8820-4c4f-8e28-ee4daa4cc056": {
    "name": "from unit bundle",
    "inputs": {
      "bundle": {
        "type": "{spec?:object,specs?:object}",
        "metadata": {
          "examples": [
            "{spec:{},specs:{}}"
          ]
        }
      }
    },
    "outputs": {
      "unit": {
        "type": "\`U\`"
      }
    },
    "metadata": {
      "icon": "server",
      "description": "create \`unit\` class from unit \`bundle\` spec",
      "tags": [
        "platform",
        "method",
        "process"
      ]
    },
    "id": "23acb820-8820-4c4f-8e28-ee4daa4cc056",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "de2d42e2-4fca-4a3f-8783-3585c546e88b": {
    "name": "from bundle",
    "inputs": {
      "bundle": {
        "type": "{spec?:object,specs?:object}",
        "metadata": {
          "examples": [
            "{spec:{},specs:{}}"
          ]
        }
      }
    },
    "outputs": {
      "graph": {
        "type": "\`G\`",
        "icon": "graph"
      }
    },
    "metadata": {
      "icon": "server",
      "description": "create \`graph\` class from \`bundle\` spec",
      "tags": [
        "platform",
        "method",
        "process"
      ]
    },
    "id": "de2d42e2-4fca-4a3f-8783-3585c546e88b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "bddaba6f-83c8-4d25-97e2-ef1cdecd19e4": {
    "name": "boot",
    "inputs": {
      "init": {
        "type": "{path?:string}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {
      "system": {
        "type": "\`S\`",
        "ref": true,
        "icon": "server"
      }
    },
    "metadata": {
      "icon": "server",
      "description": "boot a new sub system",
      "tags": [
        "platform",
        "method",
        "process"
      ]
    },
    "id": "bddaba6f-83c8-4d25-97e2-ef1cdecd19e4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "eaf5e67b-6c48-4a27-85e1-9d5a8aa72e24": {
    "name": "subscribe",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "path": {
        "type": "string[]",
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      },
      "key": {
        "type": "string",
        "metadata": {
          "examples": [
            "'*'"
          ]
        }
      }
    },
    "outputs": {
      "type": {
        "type": "'set'|'delete'"
      },
      "key": {
        "type": "string"
      },
      "path": {
        "type": "string[]"
      },
      "data": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "subscribe to changes to object \`obj\` at \`path\` and \`key\` (possibly *)",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "eaf5e67b-6c48-4a27-85e1-9d5a8aa72e24",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "610b35bc-a709-4eed-a655-9ee0baa860f8": {
    "name": "set",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "data": {
        "type": "any",
        "ref": true
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`unit\` property \`name\` to \`data\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "610b35bc-a709-4eed-a655-9ee0baa860f8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c": {
    "name": "set",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "data": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "_type": "<T>['S',N]",
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`unit\` property \`name\` to \`data\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e4fb7815-95e1-4cbc-b2e2-750605e30258": {
    "name": "keys",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "keys": {
        "type": "string[]"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "get \`obj\` \`keys\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "e4fb7815-95e1-4cbc-b2e2-750605e30258",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b409ff98-1c9e-4990-b2c2-d7f32fda50eb": {
    "name": "has key",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "key": {
        "type": "string"
      }
    },
    "outputs": {
      "has": {
        "_type": "<T>['S',N]",
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "check whether \`obj\` has \`key\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "b409ff98-1c9e-4990-b2c2-d7f32fda50eb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "936820bc-9e27-4aad-b96b-cb19250e4ad3": {
    "name": "get",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "name": {
        "type": "string",
        "_init": "N"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "value": {
        "_type": "<T>['S',N]",
        "type": "any",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` property \`name\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "936820bc-9e27-4aad-b96b-cb19250e4ad3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "bc0320e2-2eb8-11eb-a38f-a779bfe81645": {
    "name": "get",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "name": {
        "type": "string",
        "_init": "N"
      }
    },
    "outputs": {
      "value": {
        "_type": "<T>['S',N]",
        "type": "any"
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` property \`name\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "275af55d-9fcf-4b53-9087-d97455cbe528": {
    "name": "delete",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "name": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "delete \`obj\` property \`name\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "275af55d-9fcf-4b53-9087-d97455cbe528",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "64f8e8bc-124d-49f6-a143-625265eafe68": {
    "name": "deep set",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "path": {
        "type": "string[]"
      },
      "value": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` property at \`path\` to \`value\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "64f8e8bc-124d-49f6-a143-625265eafe68",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "dfb2c4fb-2536-4cd1-bece-1c1bd3796c3f": {
    "name": "deep has key",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "path": {
        "type": "string[]"
      },
      "key": {
        "type": "string"
      }
    },
    "outputs": {
      "has": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "check whether \`obj\` has \`key\` property at \`path\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "dfb2c4fb-2536-4cd1-bece-1c1bd3796c3f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f0779efd-237f-476d-bddc-205d7c28cfb5": {
    "name": "deep get",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "path": {
        "type": "string[]"
      }
    },
    "outputs": {
      "value": {
        "type": "any",
        "ref": true
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`value\` \`obj\` property at \`path\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "f0779efd-237f-476d-bddc-205d7c28cfb5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8e6a00bf-2fb7-4252-adb4-7ffedde69b47": {
    "name": "deep get",
    "inputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      },
      "path": {
        "type": "string[]"
      }
    },
    "outputs": {
      "value": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`value\` \`obj\` property at \`path\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "8e6a00bf-2fb7-4252-adb4-7ffedde69b47",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ae6e44d8-2c41-496a-ad98-035468622cfa": {
    "name": "deep delete",
    "inputs": {
      "obj": {
        "type": "object"
      },
      "path": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "brackets-curly",
      "description": "remove \`obj\` key-value pair for given \`path\`",
      "tags": [
        "platform",
        "method",
        "object"
      ]
    },
    "id": "ae6e44d8-2c41-496a-ad98-035468622cfa",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f615f030-15dc-44be-9889-c4a68092d400": {
    "name": "append",
    "inputs": {
      "form": {
        "type": "\`FD\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "value": {
        "type": "any",
        "ref": true
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "append a \`value\` to a form data with \`name\`",
      "tags": [
        "platform",
        "method",
        "form"
      ]
    },
    "id": "f615f030-15dc-44be-9889-c4a68092d400",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d0f94e4e-43f4-4c0a-b07e-ca40c82f48f4": {
    "name": "stop propagation",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "prevent \`name\` event from bubbling up",
      "tags": [
        "platform",
        "method",
        "component"
      ]
    },
    "id": "d0f94e4e-43f4-4c0a-b07e-ca40c82f48f4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "12d1e7be-a5a6-45ba-82d7-cce3d03b96e2": {
    "name": "focus",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "focus on \`component\`",
      "tags": [
        "platform",
        "method",
        "component"
      ]
    },
    "id": "12d1e7be-a5a6-45ba-82d7-cce3d03b96e2",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0f49972c-fcbc-424a-90e5-d4c02ae07409": {
    "name": "click",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "click on \`component\`",
      "tags": [
        "platform",
        "method",
        "component"
      ]
    },
    "id": "0f49972c-fcbc-424a-90e5-d4c02ae07409",
    "type": "\`U\`",
    "system": true
  },
  "b51db03f-4d2d-44f9-bbd9-116aa0b086d0": {
    "name": "blur",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "remove focus from \`component\`",
      "tags": [
        "platform",
        "method",
        "component"
      ]
    },
    "id": "b51db03f-4d2d-44f9-bbd9-116aa0b086d0",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "05b6f707-a009-40aa-aacb-a15888c2a8b3": {
    "name": "attach text",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "text": {
        "type": "string"
      },
      "type": {
        "type": "string",
        "metadata": {
          "examples": [
            "text/plain",
            "text/uri-list",
            "text/html"
          ]
        }
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "add drag and drop \`text\` data to this \`component\`",
      "tags": [
        "platform",
        "method",
        "component"
      ]
    },
    "id": "05b6f707-a009-40aa-aacb-a15888c2a8b3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "05169310-5447-4cf8-a90f-fda957de4891": {
    "name": "attach drop target",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "object"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "items": {
        "type": "string[]"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "make \`component\` a text drag and drop target",
      "tags": [
        "platform",
        "method",
        "component"
      ]
    },
    "id": "05169310-5447-4cf8-a90f-fda957de4891",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4730fbc1-dd24-4b6a-adc2-d71e2b2df22d": {
    "name": "shift",
    "inputs": {
      "a": {
        "type": "\`A<T>\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "first": {
        "type": "<T>"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "remove \`first\` element of \`a\`",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "4730fbc1-dd24-4b6a-adc2-d71e2b2df22d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "04e8b64e-7fed-49a0-af48-eba025be3fbc": {
    "name": "put",
    "inputs": {
      "a": {
        "type": "\`A<T>\`",
        "ref": true
      },
      "i": {
        "type": "number"
      },
      "v": {
        "type": "<T>"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "info-square",
      "description": "set element of \`a\` at position \`i\` to \`v\`",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "04e8b64e-7fed-49a0-af48-eba025be3fbc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "dff853f8-7bb4-48dc-a792-5efdead94640": {
    "name": "pop",
    "inputs": {
      "a": {
        "type": "\`A<T>\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "last": {
        "type": "<T>"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "remove \`last\` element of \`a\`",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "dff853f8-7bb4-48dc-a792-5efdead94640",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ec482aaf-0029-4b85-b03a-de5bd361d706": {
    "name": "length",
    "inputs": {
      "a": {
        "type": "\`A\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "length": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "get \`a\`'s length",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "ec482aaf-0029-4b85-b03a-de5bd361d706",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "26b06e21-798c-4bc4-96e1-12a4351c083d": {
    "name": "index of",
    "inputs": {
      "a[]": {
        "type": "A",
        "ref": true
      },
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "i": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "find index \`i\` of the element \`a\` on array \`a[]\` or -1 if not found",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "26b06e21-798c-4bc4-96e1-12a4351c083d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1625eaa0-a56c-4d35-919b-bc68ed626815": {
    "name": "at",
    "inputs": {
      "a": {
        "type": "\`A<T>\`",
        "ref": true
      },
      "i": {
        "type": "number"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "a[i]": {
        "type": "<T>",
        "ref": true
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "\`a\` element at position \`i\`",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "1625eaa0-a56c-4d35-919b-bc68ed626815",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c320b1b2-c130-4d69-b172-0c737b72c6b5": {
    "name": "at",
    "inputs": {
      "a": {
        "type": "\`A<T>\`",
        "ref": true
      },
      "i": {
        "type": "number"
      }
    },
    "outputs": {
      "a[i]": {
        "type": "<T>"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "\`a\` element at position \`i\`",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "c320b1b2-c130-4d69-b172-0c737b72c6b5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "cf4db91a-f8b2-454f-a763-12005d71cb9d": {
    "name": "append",
    "inputs": {
      "a[]": {
        "type": "\`A\`",
        "ref": true
      },
      "a": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "chevrons-left",
      "description": "append an element to an array",
      "tags": [
        "platform",
        "method",
        "array"
      ]
    },
    "id": "cf4db91a-f8b2-454f-a763-12005d71cb9d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "355b5332-0cc9-4a5c-989e-043d717215ec": {
    "name": "parent child",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "at": {
        "type": "number"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "child": {
        "type": "\`U\`&\`C\`&\`V\`&\`J\`",
        "ref": true,
        "icon": "square"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "reference a child element inside \`element\`",
      "tags": [
        "platform",
        "meta",
        "component"
      ]
    },
    "id": "355b5332-0cc9-4a5c-989e-043d717215ec",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d4945010-686d-431b-a884-1a4db0bfafc4": {
    "name": "children",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true
      }
    },
    "outputs": {
      "children": {
        "type": "\`C\`[]",
        "ref": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "reference \`parent\`'s \`children\` array",
      "tags": [
        "platform",
        "meta",
        "component"
      ]
    },
    "id": "d4945010-686d-431b-a884-1a4db0bfafc4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "59afce80-30e7-4322-84e6-955767bb5106": {
    "name": "child",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true
      },
      "at": {
        "type": "number"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "child": {
        "type": "\`U\`&\`C\`&\`V\`&\`J\`",
        "ref": true,
        "icon": "square"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "reference a child element inside \`element\`",
      "tags": [
        "platform",
        "meta",
        "component"
      ]
    },
    "id": "59afce80-30e7-4322-84e6-955767bb5106",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "04953fed-157a-479d-91ac-005174b9b85e": {
    "name": "write input",
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "input",
            "pinId": "name"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -118,
                "y": -33
              }
            }
          }
        }
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "write",
            "pinId": "data",
            "kind": "input"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 119,
                "y": -1
              }
            }
          }
        }
      },
      "unit": {
        "plug": {
          "0": {
            "unitId": "input",
            "pinId": "unit"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -119,
                "y": 33
              }
            }
          }
        }
      }
    },
    "outputs": {
      "done": {
        "plug": {
          "0": {
            "unitId": "input",
            "pinId": "done"
          }
        },
        "defaultIgnored": true
      }
    },
    "units": {
      "write": {
        "id": "98ab5ee1-0997-4ad2-bc77-776208b6bb25",
        "input": {
          "value": {},
          "data": {
            "metadata": {
              "position": {
                "x": 96,
                "y": 0
              }
            }
          }
        },
        "output": {
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 47,
            "y": 1
          }
        }
      },
      "input": {
        "id": "4ae69887-a087-4d37-8743-d83ca48184d1",
        "input": {
          "unit": {
            "metadata": {
              "position": {
                "x": -101,
                "y": 18
              }
            }
          },
          "name": {
            "metadata": {
              "position": {
                "x": -100,
                "y": -17
              }
            }
          },
          "done": {
            "ignored": false
          }
        },
        "output": {
          "pin": {
            "metadata": {
              "position": {
                "x": -2,
                "y": 19
              }
            }
          },
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -54,
            "y": 1
          }
        }
      }
    },
    "merges": {
      "0": {
        "write": {
          "input": {
            "value": true
          }
        },
        "input": {
          "output": {
            "pin": true
          }
        }
      },
      "1": {
        "write": {
          "output": {
            "done": true
          }
        },
        "input": {
          "input": {
            "done": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "object-set",
      "description": "write \`data\` to \`unit\` input \`name\`",
      "tags": [
        "platform",
        "core",
        "unit"
      ],
      "position": {
        "merge": {
          "1": {
            "x": -2,
            "y": -11
          },
          "2": {
            "x": -80,
            "y": -13
          }
        }
      }
    },
    "id": "04953fed-157a-479d-91ac-005174b9b85e",
    "system": true
  },
  "850a3303-cdf7-4232-996f-760743e4f068": {
    "name": "read input",
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "input",
            "pinId": "name"
          },
          "1": {
            "unitId": "read",
            "pinId": "any"
          }
        }
      },
      "unit": {
        "plug": {
          "0": {
            "unitId": "input",
            "pinId": "unit"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "data": {
        "plug": {
          "0": {
            "unitId": "read",
            "pinId": "data"
          }
        }
      }
    },
    "units": {
      "read": {
        "id": "c6da6b9f-a783-4e58-a252-e543aef109fb",
        "input": {
          "value": {}
        },
        "output": {
          "data": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 58,
            "y": -1
          }
        }
      },
      "input": {
        "id": "4ae69887-a087-4d37-8743-d83ca48184d1",
        "input": {
          "unit": {},
          "name": {},
          "done": {
            "ignored": true
          }
        },
        "output": {
          "pin": {}
        },
        "metadata": {
          "position": {
            "x": -59,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "read": {
          "input": {
            "value": true
          }
        },
        "input": {
          "output": {
            "pin": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "object-set",
      "description": "read \`unit\` input \`name\`",
      "tags": [
        "platform",
        "core",
        "unit"
      ]
    },
    "id": "850a3303-cdf7-4232-996f-760743e4f068",
    "system": true
  },
  "6ba29720-ab8e-462a-941f-b36d24da8ab2": {
    "type": "\`U\`&\`G\`",
    "name": "pin names",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {
            "ignored": false,
            "constant": false
          },
          "key": {
            "ignored": false,
            "constant": false
          }
        },
        "output": {
          "value": {
            "ignored": false,
            "constant": false,
            "metadata": {
              "position": {
                "x": 112,
                "y": 52
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 62,
            "y": 43
          }
        }
      },
      "spec": {
        "id": "ae1f7fc0-d6e7-489c-94ed-dee71c68dbb7",
        "input": {
          "unit": {
            "ignored": false,
            "constant": false,
            "metadata": {
              "position": {
                "x": -81,
                "y": 99
              }
            }
          },
          "any": {
            "ignored": false,
            "constant": false,
            "metadata": {
              "position": {
                "x": -85,
                "y": 63
              }
            }
          }
        },
        "output": {
          "spec": {
            "ignored": false,
            "constant": false
          }
        },
        "metadata": {
          "position": {
            "x": -38,
            "y": 77
          }
        }
      },
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 88,
                "y": -70
              }
            }
          },
          "b": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "s"
            },
            "metadata": {
              "position": {
                "x": -5,
                "y": -69
              },
              "data": {
                "position": {
                  "x": -37,
                  "y": -86
                }
              }
            }
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": 42,
            "y": -54
          }
        }
      }
    },
    "merges": {
      "0": {
        "concat": {
          "output": {
            "ab": true
          }
        },
        "get": {
          "input": {
            "key": true
          }
        }
      },
      "1": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "spec": {
          "output": {
            "spec": true
          }
        }
      }
    },
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "spec",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -94,
                "y": 118
              }
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "spec",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -104,
                "y": 50
              }
            }
          }
        }
      },
      "type": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 103,
                "y": -88
              }
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 132,
                "y": 64
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "list unit pin names of \`type\`",
      "position": {
        "merge": {
          "0": {
            "x": 57,
            "y": -6
          },
          "1": {
            "x": 14,
            "y": 65
          }
        },
        "data": {
          "x": 129,
          "y": -115
        }
      },
      "tags": [
        "platform",
        "core",
        "unit"
      ]
    },
    "id": "6ba29720-ab8e-462a-941f-b36d24da8ab2",
    "system": true
  },
  "353799bc-5546-4556-b404-8b17a23bc86a": {
    "type": "\`U\`&\`G\`",
    "name": "output names",
    "units": {
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {}
        },
        "output": {
          "keys": {
            "metadata": {
              "position": {
                "x": 118,
                "y": 30
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 69,
            "y": 28
          }
        }
      },
      "pinnames": {
        "id": "6ba29720-ab8e-462a-941f-b36d24da8ab2",
        "input": {
          "type": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "output"
            },
            "metadata": {
              "position": {
                "x": 0,
                "y": -20
              },
              "data": {
                "position": {
                  "x": 22,
                  "y": -50
                }
              }
            }
          },
          "unit": {
            "metadata": {
              "position": {
                "x": -83,
                "y": 27
              }
            }
          },
          "any": {
            "metadata": {
              "position": {
                "x": -84,
                "y": -8
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -37,
            "y": 8
          }
        }
      }
    },
    "merges": {
      "0": {
        "pinnames": {
          "output": {
            "value": true
          }
        },
        "keys": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "pinnames",
            "pinId": "any"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -103,
                "y": -22
              }
            }
          }
        }
      },
      "unit": {
        "plug": {
          "0": {
            "unitId": "pinnames",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -100,
                "y": 43
              }
            }
          }
        }
      }
    },
    "outputs": {
      "names": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "keys",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 141,
                "y": 33
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "list unit output names",
      "position": {
        "merge": {
          "0": {
            "x": 16,
            "y": 22
          }
        },
        "data": {
          "x": -134,
          "y": -47
        }
      },
      "tags": [
        "platform",
        "core",
        "unit"
      ]
    },
    "id": "353799bc-5546-4556-b404-8b17a23bc86a",
    "system": true
  },
  "ed78b920-3f43-47df-840c-60c5297cdb2e": {
    "type": "\`U\`&\`G\`",
    "name": "output",
    "units": {
      "pin": {
        "id": "fd4f28bb-9114-46b4-92d2-5dfcaaf7d65b",
        "input": {
          "unit": {},
          "name": {
            "constant": false
          },
          "type": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "output"
            }
          },
          "done": {
            "ignored": false
          }
        },
        "output": {
          "pin": {},
          "done": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true
      },
      "name": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "name",
            "kind": "input"
          }
        },
        "ref": false
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "pin": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "pin",
            "kind": "output"
          }
        },
        "ref": true
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "done"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "reference \`unit\` output \`name\`",
      "tags": [
        "platform",
        "core",
        "unit"
      ]
    },
    "id": "ed78b920-3f43-47df-840c-60c5297cdb2e",
    "system": true
  },
  "d6e3f697-1cdd-4834-bf2a-fc1fab44dff3": {
    "type": "\`U\`&\`G\`",
    "name": "input names",
    "units": {
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {}
        },
        "output": {
          "keys": {
            "metadata": {
              "position": {
                "x": 118,
                "y": 30
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 69,
            "y": 28
          }
        }
      },
      "pinnames": {
        "id": "6ba29720-ab8e-462a-941f-b36d24da8ab2",
        "input": {
          "type": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "input"
            },
            "metadata": {
              "position": {
                "x": 0,
                "y": -20
              },
              "data": {
                "position": {
                  "x": 22,
                  "y": -50
                }
              }
            }
          },
          "unit": {
            "metadata": {
              "position": {
                "x": -83,
                "y": 27
              }
            }
          },
          "any": {
            "metadata": {
              "position": {
                "x": -84,
                "y": -8
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -37,
            "y": 8
          }
        }
      }
    },
    "merges": {
      "0": {
        "pinnames": {
          "output": {
            "value": true
          }
        },
        "keys": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "pinnames",
            "pinId": "any"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -103,
                "y": -22
              }
            }
          }
        }
      },
      "unit": {
        "plug": {
          "0": {
            "unitId": "pinnames",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -100,
                "y": 43
              }
            }
          }
        }
      }
    },
    "outputs": {
      "names": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "keys",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 141,
                "y": 33
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "list unit input names",
      "position": {
        "merge": {
          "0": {
            "x": 16,
            "y": 22
          }
        },
        "data": {
          "x": -134,
          "y": -47
        }
      },
      "tags": [
        "platform",
        "core",
        "unit"
      ]
    },
    "id": "d6e3f697-1cdd-4834-bf2a-fc1fab44dff3",
    "system": true
  },
  "4ae69887-a087-4d37-8743-d83ca48184d1": {
    "type": "\`U\`&\`G\`",
    "name": "input",
    "units": {
      "pin": {
        "id": "fd4f28bb-9114-46b4-92d2-5dfcaaf7d65b",
        "input": {
          "unit": {},
          "name": {
            "constant": false
          },
          "type": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "input"
            }
          },
          "done": {
            "ignored": false
          }
        },
        "output": {
          "pin": {},
          "done": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true
      },
      "name": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "name",
            "kind": "input"
          }
        },
        "ref": false
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "pin": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "pin",
            "kind": "output"
          }
        },
        "ref": true
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "pin",
            "pinId": "done"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "reference \`unit\` input \`name\`",
      "tags": [
        "platform",
        "core",
        "unit"
      ]
    },
    "id": "4ae69887-a087-4d37-8743-d83ca48184d1",
    "system": true
  },
  "8e17c506-c949-4a94-9691-f0188231dafc": {
    "type": "\`U\`&\`G\`",
    "name": "lower case keys",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {},
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 129,
            "y": 3
          }
        }
      },
      "tolowercase": {
        "id": "adde2d16-e1e6-4599-9a64-dd0968797041",
        "input": {
          "A": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 119,
            "y": 79
          }
        }
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {
            "metadata": {
              "position": {
                "x": 35,
                "y": 32
              }
            }
          },
          "test": {
            "metadata": {
              "position": {
                "x": -46,
                "y": 18
              }
            }
          },
          "init": {
            "metadata": {
              "position": {
                "x": 65,
                "y": -98
              }
            },
            "constant": false
          }
        },
        "output": {
          "current": {
            "metadata": {
              "position": {
                "x": 35,
                "y": -31
              }
            }
          },
          "local": {
            "metadata": {
              "position": {
                "x": 72,
                "y": -68
              }
            },
            "ignored": true
          },
          "final": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -11,
                "y": -48
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 36,
            "y": -32
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 39,
            "y": 47
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "a": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -44,
                "y": 84
              }
            }
          },
          "i": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 24,
                "y": 123
              }
            }
          },
          "test": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 4,
            "y": 78
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -112,
                "y": 10
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -105,
                "y": 42
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -123,
                "y": 24
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -61,
            "y": 20
          }
        }
      },
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -136,
                "y": 141
              }
            }
          }
        },
        "output": {
          "keys": {}
        },
        "metadata": {
          "position": {
            "x": -88,
            "y": 133
          }
        }
      },
      "emptyobject": {
        "id": "dc6e6bc0-081b-11eb-baf7-b7383b70c236",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": -52,
                "y": -136
              }
            }
          }
        },
        "output": {
          "{}": {}
        },
        "metadata": {
          "position": {
            "x": -6,
            "y": -122
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "keys": {
          "output": {
            "keys": true
          }
        }
      },
      "1": {
        "loop": {
          "input": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "foreach": {
          "output": {
            "test": true
          }
        }
      },
      "2": {
        "tolowercase": {
          "input": {
            "A": true
          }
        },
        "get": {
          "input": {
            "key": true
          }
        },
        "foreach": {
          "output": {
            "a[i]": true
          }
        }
      },
      "3": {
        "set": {
          "input": {
            "key": true
          }
        },
        "tolowercase": {
          "output": {
            "a": true
          }
        }
      },
      "4": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "5": {
        "set": {
          "input": {
            "value": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      },
      "6": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        }
      },
      "7": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "set": {
          "output": {
            "obj": true
          }
        }
      },
      "8": {
        "emptyobject": {
          "output": {
            "{}": true
          }
        },
        "loop": {
          "input": {
            "init": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "obj",
            "kind": "input"
          },
          "1": {
            "unitId": "looprepeat",
            "pinId": "init",
            "kind": "input"
          },
          "2": {
            "unitId": "emptyobject",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -156,
                "y": 153
              }
            },
            "1": {
              "ext": {
                "x": -132,
                "y": -2
              }
            },
            "2": {
              "ext": {
                "x": -68,
                "y": -153
              }
            }
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -32,
                "y": -60
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": null,
      "description": "",
      "position": {
        "merge": {
          "0": {
            "x": -41,
            "y": 111
          },
          "1": {
            "x": -4,
            "y": 17
          },
          "2": {
            "x": 63,
            "y": 84
          },
          "3": {
            "x": 156,
            "y": 45
          },
          "4": {
            "x": -16,
            "y": 42
          },
          "5": {
            "x": 89,
            "y": 31
          },
          "6": {
            "x": 84,
            "y": -15
          },
          "7": {
            "x": 94,
            "y": -35
          },
          "8": {
            "x": 28,
            "y": -84
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "text"
      ]
    },
    "id": "8e17c506-c949-4a94-9691-f0188231dafc",
    "component": {},
    "system": true
  },
  "8b231876-26af-11eb-8e1d-6f057957054d": {
    "name": "tag password",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'password'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{password: \`password\`}",
      "tags": [
        "platform",
        "core",
        "tag"
      ]
    },
    "inputs": {
      "password": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{password}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "8b231876-26af-11eb-8e1d-6f057957054d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6e9e4202-26af-11eb-8d6e-eb6fbc70a0a9": {
    "name": "tag email",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'email'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{email: \`email\`}",
      "tags": [
        "platform",
        "core",
        "tag"
      ]
    },
    "inputs": {
      "email": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{email}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "6e9e4202-26af-11eb-8d6e-eb6fbc70a0a9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "72a186fe-a18b-44ca-b36b-c014ee44003a": {
    "type": "\`U\`&\`G\`",
    "name": "percent",
    "units": {
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "\\"%\\""
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": 22,
            "y": 102
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "a"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "pa": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "percent",
      "description": "% + a",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "72a186fe-a18b-44ca-b36b-c014ee44003a",
    "system": true
  },
  "13f661c0-2616-11eb-af30-2f9ba81c8b3b": {
    "name": "tag top",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'top'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{top: \`top\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "top": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{top}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "13f661c0-2616-11eb-af30-2f9ba81c8b3b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "91f0b6b7-4242-42c5-9ba1-e1833c13f17c": {
    "name": "tag to",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'to'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{to: \`to\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "to": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{to}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "91f0b6b7-4242-42c5-9ba1-e1833c13f17c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2afbbe21-d399-482a-b53d-50820ee510be": {
    "name": "tag opacity",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'opacity'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{opacity: \`opacity\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "opacity": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{opacity}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "2afbbe21-d399-482a-b53d-50820ee510be",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "3cbca5b0-2616-11eb-a3d8-7b83ecaf1822": {
    "name": "tag left",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'left'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{left: \`left\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "left": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{left}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "3cbca5b0-2616-11eb-a3d8-7b83ecaf1822",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2a6c9339-d20f-431b-8db1-f6f4f5a0af74": {
    "name": "tag from",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'from'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{from: \`from\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "from": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{from}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "2a6c9339-d20f-431b-8db1-f6f4f5a0af74",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "06d91634-9aee-11eb-8e48-8bdcd8add0ff": {
    "name": "tag font size px",
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "px",
            "pinId": "n"
          }
        }
      }
    },
    "outputs": {
      "{fontSize}": {
        "plug": {
          "0": {
            "unitId": "tagfontsize",
            "pinId": "{fontSize}"
          }
        }
      }
    },
    "units": {
      "px": {
        "id": "87c7b2b8-c17e-11ea-ba3a-072aa030b89f",
        "input": {
          "n": {
            "metadata": {
              "position": {
                "x": -88,
                "y": 4
              }
            }
          }
        },
        "output": {
          "px": {}
        },
        "metadata": {
          "position": {
            "x": -39,
            "y": 4
          }
        }
      },
      "tagfontsize": {
        "id": "119335e8-9a6f-11eb-bd5e-a7c983e2d4cd",
        "input": {
          "fontSize": {}
        },
        "output": {
          "{fontSize}": {
            "metadata": {
              "position": {
                "x": 112,
                "y": 4
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 63,
            "y": 4
          }
        }
      }
    },
    "merges": {
      "0": {
        "px": {
          "output": {
            "px": true
          }
        },
        "tagfontsize": {
          "input": {
            "fontSize": true
          }
        }
      }
    },
    "metadata": {
      "description": "create obj with property \\"fontSize\\" to \`n\` px",
      "icon": "brackets-curly",
      "position": {
        "merge": {
          "0": {
            "x": 12,
            "y": 4
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "06d91634-9aee-11eb-8e48-8bdcd8add0ff",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "119335e8-9a6f-11eb-bd5e-a7c983e2d4cd": {
    "name": "tag font size",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'fontSize'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{fontSize: \`fontSize\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "fontSize": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{fontSize}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "119335e8-9a6f-11eb-bd5e-a7c983e2d4cd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cb1f45ee-2137-11eb-9b9d-e7e8fc730ec7": {
    "name": "tag filter",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'filter'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{filter: \`filter\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "filter": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{filter}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "cb1f45ee-2137-11eb-9b9d-e7e8fc730ec7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "dfba14dd-bd14-4fd2-bbfa-c910eadd9f7d": {
    "name": "tag color",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'color'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{color: \`color\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "color": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{color}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "dfba14dd-bd14-4fd2-bbfa-c910eadd9f7d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "26dc94ea-347b-4dbb-a7d7-1dab60da8352": {
    "name": "tag background-color",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'background-color'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{\\"background-color\\": \`color\`}",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "inputs": {
      "color": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{bc}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "26dc94ea-347b-4dbb-a7d7-1dab60da8352",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "de473a6a-a0f3-11ea-bc93-ff2e35342869": {
    "name": "style center",
    "units": {
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {
            "constant": true,
            "data": "{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {},
    "outputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "repeat-1",
      "description": "style to centralize element on container",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "de473a6a-a0f3-11ea-bc93-ff2e35342869",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b63a7c25-918c-4783-80bd-828da0e5d08f": {
    "name": "set value",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'value'"
          },
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` property \\"value\\" to \`value\`",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "b63a7c25-918c-4783-80bd-828da0e5d08f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cc5e3d8d-1de5-4c12-9054-4c27b1a49d55": {
    "type": "\`U\`&\`G\`",
    "name": "set top left px",
    "units": {
      "set0": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": true,
            "data": "{}",
            "metadata": {
              "position": {
                "x": -123.98447658585758,
                "y": 236.81172319973763
              }
            }
          },
          "key": {
            "constant": true,
            "data": "\\"left\\"",
            "metadata": {
              "position": {
                "x": -48.257481422809064,
                "y": 232.59708643485345
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 53,
            "y": 194
          }
        }
      },
      "px": {
        "id": "87c7b2b8-c17e-11ea-ba3a-072aa030b89f",
        "input": {
          "n": {}
        },
        "output": {
          "px": {}
        },
        "metadata": {
          "position": {
            "x": 61,
            "y": 59
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": false
          },
          "key": {
            "constant": true,
            "data": "\\"top\\"",
            "metadata": {
              "position": {
                "x": 41.455115269298176,
                "y": 163.18213935695036
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 143,
            "y": 126
          }
        }
      },
      "px0": {
        "id": "87c7b2b8-c17e-11ea-ba3a-072aa030b89f",
        "input": {
          "n": {}
        },
        "output": {
          "px": {}
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": 183
          }
        }
      }
    },
    "merges": {
      "5": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "set0": {
          "output": {
            "obj": true
          }
        }
      },
      "7": {
        "set0": {
          "input": {
            "value": true
          }
        },
        "px0": {
          "output": {
            "px": true
          }
        }
      },
      "8": {
        "px": {
          "output": {
            "px": true
          }
        },
        "set": {
          "input": {
            "value": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set0",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false
      },
      "y": {
        "plug": {
          "0": {
            "unitId": "px",
            "pinId": "n",
            "kind": "input"
          }
        },
        "ref": false
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "px0",
            "pinId": "n",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` top left property to \`x\` \`y\` px",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "cc5e3d8d-1de5-4c12-9054-4c27b1a49d55",
    "system": true
  },
  "aab4ce68-49a6-4c84-a7f8-87359c453be9": {
    "name": "set to",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'to'"
          },
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` property \\"to\\" to \`value\`",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "aab4ce68-49a6-4c84-a7f8-87359c453be9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "53846253-2c16-4329-8e65-e6e8f37e6b086": {
    "name": "set from",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'from'"
          },
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` property \\"from\\" to \`value\`",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "53846253-2c16-4329-8e65-e6e8f37e6b086",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8affb853-d25e-48bc-87d6-8ce949aa8ecb": {
    "name": "set data",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'data'"
          },
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` property \\"data\\" to \`value\`",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "8affb853-d25e-48bc-87d6-8ce949aa8ecb",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b153e3d9-cf4a-449f-974d-e63cc604568a": {
    "name": "set color",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'color'"
          },
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` background-color property to \`value\`",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "b153e3d9-cf4a-449f-974d-e63cc604568a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "0ca54c4f-148e-49e5-bedf-d24276200f66": {
    "name": "set background-color",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'backgroundColor'"
          },
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` background-color property to \`value\`",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "0ca54c4f-148e-49e5-bedf-d24276200f66",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "87c7b2b8-c17e-11ea-ba3a-072aa030b89f": {
    "name": "px",
    "units": {
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "'px'"
          }
        },
        "output": {
          "ab": {}
        }
      },
      "numbertostring": {
        "id": "f712793d-8ee9-4805-9d4a-8c210cae667a",
        "input": {
          "n": {},
          "radix": {
            "constant": true,
            "data": "10"
          }
        },
        "output": {
          "str": {}
        }
      }
    },
    "merges": {
      "tavfhissj": {
        "numbertostring": {
          "output": {
            "str": true
          }
        },
        "concat": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "numbertostring",
            "pinId": "n"
          }
        }
      }
    },
    "outputs": {
      "px": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "metadata": {
      "icon": "dot-circle",
      "description": "\`n\` + \\"px\\"",
      "tags": [
        "platform",
        "core",
        "style"
      ]
    },
    "id": "87c7b2b8-c17e-11ea-ba3a-072aa030b89f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1a0773eb-559c-47e2-81d7-fc28bc80076d": {
    "type": "\`U\`&\`G\`",
    "name": "remove newlines",
    "units": {
      "replace": {
        "id": "af5469c4-a09e-4b22-8133-a21e721e7639",
        "input": {
          "str": {},
          "regex": {
            "constant": true,
            "data": "'\\\\n'"
          },
          "with": {
            "constant": true,
            "data": "''"
          },
          "flags": {
            "constant": true,
            "data": "'g'"
          }
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": -74,
            "y": -39
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "replace",
            "pinId": "str"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "replace",
            "pinId": "str"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "type",
      "description": "remove \\n",
      "tags": [
        "platform",
        "core",
        "string"
      ]
    },
    "id": "1a0773eb-559c-47e2-81d7-fc28bc80076d",
    "system": true
  },
  "b7028cdd-41c2-42ab-99d9-7122d372aee2": {
    "name": "speech to speech",
    "units": {
      "texttospeech": {
        "id": "6db29a62-2035-4cfc-a9d3-03444a8bc2b8",
        "input": {
          "voice": {
            "data": "0",
            "constant": true
          }
        }
      },
      "speechtotext": {
        "id": "416550cc-6e02-4ff2-aafa-2f0edbf121c6",
        "input": {
          "opt": {
            "constant": true,
            "data": "{lang:'en-US'}"
          }
        }
      }
    },
    "merges": {
      "0": {
        "speechtotext": {
          "output": {
            "text": true
          }
        },
        "texttospeech": {
          "input": {
            "message": true
          }
        }
      }
    },
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "message-circle",
      "description": "say what I say",
      "tags": [
        "platform",
        "core",
        "speech"
      ]
    },
    "id": "b7028cdd-41c2-42ab-99d9-7122d372aee2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1a89a9c0-0dfe-419b-96e7-8aae6bae1859": {
    "name": "post JSON body",
    "inputs": {
      "json": {
        "plug": {
          "0": {
            "unitId": "postJSON",
            "pinId": "json"
          }
        },
        "ref": false
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "postJSON",
            "pinId": "url"
          }
        },
        "ref": false
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "postJSON",
            "pinId": "opt"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "body": {
        "plug": {
          "0": {
            "unitId": "getbody",
            "pinId": "body"
          }
        },
        "ref": false
      }
    },
    "units": {
      "postJSON": {
        "id": "6fcb6d82-4d64-438e-8a30-82f8b89c524b",
        "input": {
          "json": {},
          "url": {},
          "opt": {}
        },
        "output": {
          "res": {}
        },
        "metadata": {
          "position": {
            "x": -53,
            "y": 9
          }
        }
      },
      "getbody": {
        "id": "6a529c4d-07af-4778-8086-8a578694ec3f",
        "input": {
          "{body}": {}
        },
        "output": {
          "body": {}
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": -10
          }
        }
      }
    },
    "merges": {
      "2": {
        "getbody": {
          "input": {
            "{body}": true
          }
        },
        "postJSON": {
          "output": {
            "res": true
          }
        }
      }
    },
    "render": false,
    "component": {},
    "metadata": {
      "icon": "send",
      "description": "POST JSON body",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "id": "1a89a9c0-0dfe-419b-96e7-8aae6bae1859",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c4ff2bad-0d60-4d17-9471-c906075d2751": {
    "name": "post",
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "url"
          }
        },
        "ref": false
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "deepmerge",
            "pinId": "b"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "res": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "res"
          }
        },
        "ref": false
      }
    },
    "units": {
      "deepmerge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f",
        "input": {
          "a": {
            "constant": true,
            "data": "{method:'POST'}"
          },
          "b": {
            "constant": false
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -53,
            "y": 2
          }
        }
      },
      "fetch": {
        "id": "c5856fdc-5154-46ab-a414-47f37af39da1",
        "input": {
          "url": {},
          "opt": {}
        },
        "output": {
          "res": {}
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": -3
          }
        }
      }
    },
    "merges": {
      "6": {
        "deepmerge": {
          "input": {},
          "output": {
            "ab": true
          }
        },
        "fetch": {
          "input": {
            "opt": true
          },
          "output": {}
        }
      }
    },
    "render": false,
    "component": {},
    "metadata": {
      "icon": "send",
      "description": "fetch a resource across the network through HTTP POST",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "id": "c4ff2bad-0d60-4d17-9471-c906075d2751",
    "system": true
  },
  "63ede222-07af-4b27-98bc-d8bc7cc5b14c": {
    "name": "parse JSON body",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'body'"
          }
        }
      },
      "parse": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d"
      }
    },
    "merges": {
      "dbjrwzdhw": {
        "get": {
          "output": {
            "value": true
          }
        },
        "parse": {
          "input": {
            "string": true
          }
        }
      }
    },
    "metadata": {
      "icon": "arrow-right",
      "description": "parse response \`res\` body into JSON",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "res": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "json": {
        "plug": {
          "0": {
            "unitId": "parse",
            "pinId": "json"
          }
        }
      }
    },
    "id": "63ede222-07af-4b27-98bc-d8bc7cc5b14c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "3698d7af-8d4c-40f6-bcfa-222d9efb0940": {
    "name": "put JSON",
    "units": {
      "stringify": {
        "id": "ee184ea6-3c80-4119-919e-290620aafab0",
        "input": {
          "json": {}
        }
      },
      "fetch": {
        "id": "c5856fdc-5154-46ab-a414-47f37af39da1",
        "input": {
          "url": {
            "constant": false
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'body'"
          }
        }
      },
      "deepmerge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f",
        "input": {
          "a": {
            "constant": true,
            "data": "{method:'PUT',headers:{\\"Content-Type\\":'application/json'}}"
          }
        }
      }
    },
    "merges": {
      "0": {
        "set": {
          "input": {
            "value": true
          }
        },
        "stringify": {
          "output": {
            "string": true
          }
        }
      },
      "1": {
        "fetch": {
          "input": {
            "opt": true
          }
        },
        "set": {
          "output": {
            "obj": true
          }
        }
      },
      "2": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "deepmerge": {
          "output": {
            "ab": true
          }
        }
      }
    },
    "inputs": {
      "json": {
        "plug": {
          "0": {
            "unitId": "stringify",
            "pinId": "json"
          }
        }
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "url"
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "deepmerge",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "res": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "res"
          }
        }
      }
    },
    "metadata": {
      "icon": "send",
      "description": "PUT JSON body",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "id": "3698d7af-8d4c-40f6-bcfa-222d9efb0940",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b9a7ef07-db1c-4a4a-814d-4e4113bbbbf7": {
    "name": "post url encoded",
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "url"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 22,
              "y": 112
            }
          }
        }
      },
      "body": {
        "plug": {
          "0": {
            "unitId": "stringify",
            "pinId": "obj"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 177,
              "y": -84
            }
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "deepmerge",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -170,
              "y": -39
            }
          }
        }
      }
    },
    "outputs": {
      "res": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "res"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 145,
              "y": 84
            }
          }
        }
      }
    },
    "units": {
      "fetch": {
        "id": "c5856fdc-5154-46ab-a414-47f37af39da1",
        "input": {
          "url": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 34,
                "y": 87
              }
            }
          },
          "opt": {}
        },
        "output": {
          "res": {
            "metadata": {
              "position": {
                "x": 120,
                "y": 73
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 73,
            "y": 61
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'body'",
            "metadata": {
              "position": {
                "x": -23,
                "y": -54
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 9,
            "y": -22
          }
        }
      },
      "stringify": {
        "id": "f97f2a74-d9a9-411d-afd3-fda46ba86c3b",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 152,
                "y": -78
              }
            }
          }
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": 104,
            "y": -68
          }
        }
      },
      "deepmerge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f",
        "input": {
          "a": {
            "constant": true,
            "data": "{method:'POST',headers:{\\"Content-Type\\":'application/x-www-form-urlencoded'}}",
            "metadata": {
              "position": {
                "x": -144,
                "y": 11
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -147,
                "y": -24
              }
            }
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -100,
            "y": -9
          }
        }
      }
    },
    "merges": {
      "0": {
        "fetch": {
          "input": {
            "opt": true
          }
        },
        "set": {
          "output": {
            "obj": true
          }
        }
      },
      "1": {
        "set": {
          "input": {
            "value": true
          }
        },
        "stringify": {
          "output": {
            "str": true
          }
        }
      },
      "2": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "deepmerge": {
          "output": {
            "ab": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "send",
      "description": "POST url-encoded body",
      "tags": [
        "platform",
        "core",
        "rest"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 40,
            "y": 21
          },
          "1": {
            "x": 56,
            "y": -50
          },
          "2": {
            "x": -47,
            "y": -14
          }
        }
      }
    },
    "id": "b9a7ef07-db1c-4a4a-814d-4e4113bbbbf7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6fcb6d82-4d64-438e-8a30-82f8b89c524b": {
    "name": "post JSON",
    "inputs": {
      "json": {
        "plug": {
          "0": {
            "unitId": "stringify",
            "pinId": "json"
          }
        },
        "functional": true
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "url"
          }
        },
        "functional": true
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "deepmerge",
            "pinId": "b"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "res": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "res"
          }
        }
      }
    },
    "units": {
      "stringify": {
        "id": "ee184ea6-3c80-4119-919e-290620aafab0",
        "input": {
          "json": {}
        },
        "output": {
          "string": {}
        },
        "metadata": {
          "position": {
            "x": -76,
            "y": 54
          }
        }
      },
      "fetch": {
        "id": "c5856fdc-5154-46ab-a414-47f37af39da1",
        "input": {
          "url": {
            "constant": false
          },
          "opt": {}
        },
        "output": {
          "res": {}
        },
        "metadata": {
          "position": {
            "x": 124,
            "y": 22
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": false
          },
          "key": {
            "constant": true,
            "data": "\\"body\\""
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 14,
            "y": -1
          }
        }
      },
      "deepmerge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f",
        "input": {
          "a": {
            "constant": true,
            "data": "{method:\\"POST\\",headers:{\\"Content-Type\\":\\"application/json\\"}}"
          },
          "b": {}
        },
        "output": {
          "ab": {}
        }
      }
    },
    "merges": {
      "0": {
        "set": {
          "input": {
            "value": true
          }
        },
        "stringify": {
          "output": {
            "string": true
          }
        }
      },
      "1": {
        "fetch": {
          "input": {
            "opt": true
          }
        },
        "set": {
          "output": {
            "obj": true
          }
        }
      },
      "2": {
        "deepmerge": {
          "output": {
            "ab": true
          }
        },
        "set": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "render": false,
    "component": {},
    "metadata": {
      "icon": "send",
      "description": "POST JSON body",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "id": "6fcb6d82-4d64-438e-8a30-82f8b89c524b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ba70dd41-d533-4f8f-b476-c76274141468": {
    "name": "HTTP token auth opt",
    "units": {
      "httptokenauth": {
        "id": "522a9858-02c2-487a-ac04-27d2f5ebe7c3"
      },
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'headers'"
          }
        }
      },
      "tag0": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'Authorization'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "httptokenauth": {
          "output": {
            "auth": true
          }
        },
        "tag0": {
          "input": {
            "v": true
          }
        }
      },
      "1": {
        "tag0": {
          "output": {
            "kv": true
          }
        },
        "tag": {
          "input": {
            "v": true
          }
        }
      }
    },
    "metadata": {
      "icon": "send",
      "description": "build HTTP token auth header options",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "token": {
        "plug": {
          "0": {
            "unitId": "httptokenauth",
            "pinId": "token"
          }
        }
      }
    },
    "outputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "ba70dd41-d533-4f8f-b476-c76274141468",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "522a9858-02c2-487a-ac04-27d2f5ebe7c3": {
    "name": "HTTP token auth",
    "units": {
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "a": {
            "constant": true,
            "data": "'Bearer '"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "send",
      "description": "build HTTP token auth value",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "token": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "auth": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "522a9858-02c2-487a-ac04-27d2f5ebe7c3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "081b1edf-f66c-4e0a-9aaf-c20b4088d1ec": {
    "name": "HTTP basic auth",
    "units": {
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "b": {
            "constant": true,
            "data": "':'"
          }
        }
      },
      "concat0": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6"
      },
      "encode": {
        "id": "ee7b692f-5fe5-43c3-b636-aacca92b0bc7"
      },
      "concat1": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "a": {
            "constant": true,
            "data": "'Basic '"
          }
        }
      }
    },
    "merges": {
      "0": {
        "concat": {
          "output": {
            "ab": true
          }
        },
        "concat0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "concat0": {
          "output": {
            "ab": true
          }
        },
        "encode": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "encode": {
          "output": {
            "b": true
          }
        },
        "concat1": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "send",
      "description": "build HTTP basic auth header value",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "username": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "a"
          }
        }
      },
      "password": {
        "plug": {
          "0": {
            "unitId": "concat0",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "auth": {
        "plug": {
          "0": {
            "unitId": "concat1",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "081b1edf-f66c-4e0a-9aaf-c20b4088d1ec",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6a529c4d-07af-4778-8086-8a578694ec3f": {
    "name": "get body",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'body'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "send",
      "description": "get body property",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "{body}": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "body": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "id": "6a529c4d-07af-4778-8086-8a578694ec3f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "00a8a078-91bf-4676-aa32-c9cfacdfd527": {
    "name": "fetch json body",
    "units": {
      "fetchbody": {
        "id": "7ba3db14-6f80-434b-b9dc-bd38462b20fc",
        "input": {
          "url": {
            "metadata": {
              "position": {
                "x": 125,
                "y": 66
              }
            }
          },
          "opt": {}
        },
        "output": {
          "body": {}
        },
        "metadata": {
          "position": {
            "x": 90,
            "y": 37
          }
        }
      },
      "parsejson": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
        "input": {
          "string": {}
        },
        "output": {
          "json": {
            "metadata": {
              "position": {
                "x": 241,
                "y": 15
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 192,
            "y": 17
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "headers": {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
                }
              }
            },
            "metadata": {
              "position": {
                "x": -60,
                "y": 17
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -60,
                "y": 53
              }
            }
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -15,
            "y": 35
          }
        }
      }
    },
    "merges": {
      "0": {
        "fetchbody": {
          "output": {
            "body": true
          }
        },
        "parsejson": {
          "input": {
            "string": true
          }
        }
      },
      "1": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "fetchbody": {
          "input": {
            "opt": true
          }
        }
      }
    },
    "render": false,
    "component": {},
    "metadata": {
      "icon": "send",
      "description": "fetch JSON",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "fetchbody",
            "pinId": "url",
            "kind": "input"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 130,
                "y": 89
              }
            }
          }
        }
      },
      "options": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b",
            "kind": "input"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -76,
                "y": 69
              }
            }
          }
        }
      }
    },
    "outputs": {
      "json": {
        "plug": {
          "0": {
            "unitId": "parsejson",
            "pinId": "json",
            "kind": "output"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 264,
                "y": 12
              }
            }
          }
        }
      }
    },
    "id": "00a8a078-91bf-4676-aa32-c9cfacdfd527",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7ba3db14-6f80-434b-b9dc-bd38462b20fc": {
    "name": "fetch body",
    "units": {
      "fetch": {
        "id": "c5856fdc-5154-46ab-a414-47f37af39da1"
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'body'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "fetch": {
          "output": {
            "res": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "metadata": {
      "icon": "send",
      "description": "fetch + get body",
      "tags": [
        "platform",
        "core",
        "rest"
      ]
    },
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "url"
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "opt"
          }
        }
      }
    },
    "outputs": {
      "body": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "id": "7ba3db14-6f80-434b-b9dc-bd38462b20fc",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c03c7ef3-0649-4a99-9e9a-858bcaba1307": {
    "name": "default video user media",
    "inputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "stream": {
        "plug": {
          "0": {
            "unitId": "getusermedia",
            "pinId": "stream"
          }
        },
        "ref": true,
        "icon": "circle-play"
      }
    },
    "units": {
      "getusermedia": {
        "id": "a6e30b43-9ab4-4206-bfba-3f2129faac30",
        "input": {
          "opt": {
            "constant": false
          }
        },
        "output": {
          "stream": {},
          "icon": "circle-play"
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": -1
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {
            "constant": true,
            "data": "{video:true,audio:{echoCancellation:true,noiseSuppression:true}}"
          },
          "b": {}
        },
        "output": {
          "ab": {}
        }
      }
    },
    "merges": {
      "0": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "getusermedia": {
          "input": {
            "opt": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "video",
      "description": "get device default video stream",
      "tags": [
        "platform",
        "core",
        "media"
      ]
    },
    "id": "c03c7ef3-0649-4a99-9e9a-858bcaba1307",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1b164d72-2c14-4ec2-a1c8-253679a2bf13": {
    "name": "default audio user media",
    "units": {
      "getusermedia": {
        "id": "a6e30b43-9ab4-4206-bfba-3f2129faac30",
        "input": {
          "opt": {
            "constant": true,
            "data": "{video:false,audio:{echoCancellation:true,noiseSuppression:true}}"
          }
        },
        "output": {}
      }
    },
    "merges": {},
    "inputs": {},
    "outputs": {
      "stream": {
        "plug": {
          "0": {
            "unitId": "getusermedia",
            "pinId": "stream"
          }
        },
        "ref": true
      }
    },
    "metadata": {
      "icon": "mic",
      "description": "get default device audio stream",
      "tags": [
        "platform",
        "core",
        "media"
      ]
    },
    "id": "1b164d72-2c14-4ec2-a1c8-253679a2bf13",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8e017373-3a2b-4985-b60c-f6f0a94db200": {
    "type": "\`U\`&\`G\`",
    "name": "pow 2",
    "units": {
      "pow": {
        "id": "ef4c1d0a-bda1-484e-8fcb-0fdbde195778",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "2"
          }
        },
        "output": {
          "a ** b": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "pow",
            "pinId": "a"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "a²": {
        "plug": {
          "0": {
            "unitId": "pow",
            "pinId": "a ** b"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "exponential",
      "description": "\`a\` to the power of 2",
      "tags": [
        "platform",
        "core",
        "math",
        "power"
      ]
    },
    "id": "8e017373-3a2b-4985-b60c-f6f0a94db200",
    "system": true
  },
  "b9d50cfc-482c-4106-b036-0e604dbada1b": {
    "type": "\`U\`&\`G\`",
    "name": "rad to deg",
    "units": {
      "divide": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233",
        "input": {
          "b": {
            "constant": false
          },
          "a": {}
        }
      },
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "b": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 180
            }
          }
        }
      },
      "PI": {
        "id": "3256e26d-8495-4c9d-8998-5b026691231d",
        "input": {
          "any": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            }
          }
        },
        "output": {
          "PI": {}
        }
      }
    },
    "merges": {
      "0": {
        "divide": {
          "output": {
            "a ÷ b": true
          }
        },
        "multiply": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "divide": {
          "input": {
            "b": true
          }
        },
        "PI": {
          "output": {
            "PI": true
          }
        }
      }
    },
    "inputs": {
      "rad": {
        "plug": {
          "0": {
            "unitId": "divide",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "angle": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a × b",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "convert angle in radians to degrees",
      "tags": [
        "platform",
        "core",
        "math",
        "geometry",
        "trigonometry"
      ]
    },
    "id": "b9d50cfc-482c-4106-b036-0e604dbada1b",
    "system": true
  },
  "af451707-9400-429f-bb3a-2670d4ce8821": {
    "name": "point in circle",
    "units": {
      "mergexy": {
        "id": "2737cd82-d80b-4d3f-b33d-f00f68361e24"
      },
      "sin": {
        "id": "b9f90a95-1bfc-4897-9068-2560743821a3"
      },
      "cos": {
        "id": "62af44dc-17d6-459a-b95f-3b8ce5b48856"
      },
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "b": {
            "constant": false
          }
        }
      },
      "multiply0": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "b": {
            "constant": false
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "b": {
            "constant": false
          }
        }
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {
            "constant": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "multiply0": {
          "input": {
            "a": true
          }
        },
        "sin": {
          "output": {
            "sin(a)": true
          }
        }
      },
      "1": {
        "cos": {
          "output": {
            "cos(a)": true
          }
        },
        "multiply": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "add": {
          "input": {
            "a": true
          }
        },
        "multiply": {
          "output": {
            "a × b": true
          }
        }
      },
      "3": {
        "mergexy": {
          "input": {
            "x": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      },
      "4": {
        "cos": {
          "input": {
            "a": true
          }
        },
        "sin": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "mergexy": {
          "input": {
            "y": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      },
      "6": {
        "multiply0": {
          "output": {
            "a × b": true
          }
        },
        "subtract": {
          "input": {
            "b": true
          }
        }
      },
      "7": {
        "multiply0": {
          "input": {
            "b": true
          }
        },
        "multiply": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "radius",
      "description": "get point in circle at angle \`rad\`",
      "tags": [
        "platform",
        "core",
        "math",
        "geometry",
        "trigonometry"
      ]
    },
    "inputs": {
      "rad": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "b"
          }
        },
        "functional": true
      },
      "y": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "r": {
        "plug": {
          "0": {
            "mergeId": "7"
          }
        }
      }
    },
    "outputs": {
      "{x,y}": {
        "plug": {
          "0": {
            "unitId": "mergexy",
            "pinId": "{x,y}"
          }
        }
      }
    },
    "id": "af451707-9400-429f-bb3a-2670d4ce8821",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "38321611-6cb6-4840-8dff-34fc69347aff": {
    "type": "\`U\`&\`G\`",
    "name": "hypotenuse",
    "units": {
      "untitled0": {
        "id": "8e017373-3a2b-4985-b60c-f6f0a94db200",
        "metadata": {
          "position": {
            "x": -68,
            "y": 59
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a + b": {}
        },
        "metadata": {
          "position": {
            "x": 15,
            "y": -1
          }
        }
      },
      "sqrt": {
        "id": "530e83d2-1d61-11eb-b472-53e545a06c92",
        "input": {
          "a": {}
        },
        "output": {
          "√a": {}
        },
        "metadata": {
          "position": {
            "x": 120,
            "y": -1
          }
        }
      },
      "pow2": {
        "id": "8e017373-3a2b-4985-b60c-f6f0a94db200",
        "metadata": {
          "position": {
            "x": -69,
            "y": -60
          }
        }
      }
    },
    "merges": {
      "0": {
        "untitled0": {
          "output": {
            "a²": true
          }
        },
        "add": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "add": {
          "input": {
            "b": true
          }
        },
        "pow2": {
          "output": {
            "a²": true
          }
        }
      },
      "2": {
        "add": {
          "output": {
            "a + b": true
          }
        },
        "sqrt": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "untitled0",
            "pinId": "a"
          }
        },
        "ref": false
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "pow2",
            "pinId": "a"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "h": {
        "plug": {
          "0": {
            "unitId": "sqrt",
            "pinId": "√a"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "hypotenuse \`h\` for legs \`a\` and \`b\`",
      "tags": [
        "platform",
        "core",
        "math",
        "geometry",
        "trigonometry"
      ]
    },
    "id": "38321611-6cb6-4840-8dff-34fc69347aff",
    "system": true
  },
  "3a138358-cc25-45e3-a0ce-bbe54445736f": {
    "name": "deg to rad",
    "units": {
      "PI": {
        "id": "3256e26d-8495-4c9d-8998-5b026691231d",
        "input": {
          "any": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7"
      },
      "divide": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233",
        "input": {
          "b": {
            "constant": true,
            "data": "180"
          }
        }
      },
      "remainder": {
        "id": "c5c05c85-f4c1-4b67-ab85-08b61fe67531",
        "input": {
          "b": {
            "constant": true,
            "data": "360"
          }
        }
      }
    },
    "merges": {
      "0": {
        "multiply": {
          "input": {
            "a": true
          }
        },
        "divide": {
          "output": {
            "a ÷ b": true
          }
        }
      },
      "1": {
        "multiply": {
          "input": {
            "b": true
          }
        },
        "PI": {
          "output": {
            "PI": true
          }
        }
      },
      "2": {
        "remainder": {
          "output": {
            "a % b": true
          }
        },
        "divide": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "convert angle in degrees to radians",
      "tags": [
        "platform",
        "core",
        "math",
        "geometry",
        "trigonometry"
      ]
    },
    "inputs": {
      "angle": {
        "plug": {
          "0": {
            "unitId": "remainder",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "rad": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a × b"
          }
        }
      }
    },
    "id": "3a138358-cc25-45e3-a0ce-bbe54445736f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "3bd18787-017f-4477-a182-8956aad82ffd": {
    "type": "\`U\`&\`G\`",
    "name": "distance",
    "units": {
      "norm": {
        "id": "54d339fb-76af-4a37-9f0a-08015fb51850",
        "input": {
          "y": {},
          "x": {}
        },
        "output": {
          "d": {}
        }
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a - b": {}
        }
      },
      "subtract0": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a - b": {}
        }
      }
    },
    "merges": {
      "0": {
        "norm": {
          "input": {
            "x": true
          }
        },
        "subtract0": {
          "output": {
            "a - b": true
          }
        }
      },
      "1": {
        "norm": {
          "input": {
            "y": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      }
    },
    "inputs": {
      "y1": {
        "plug": {
          "2": {
            "unitId": "subtract",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false
      },
      "y0": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false
      },
      "x1": {
        "plug": {
          "0": {
            "unitId": "subtract0",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false
      },
      "x0": {
        "plug": {
          "0": {
            "unitId": "subtract0",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "norm",
            "pinId": "d",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "euclidean distance between points (x0,y0) and (x1,y1)",
      "tags": [
        "platform",
        "core",
        "math",
        "geometry"
      ]
    },
    "id": "3bd18787-017f-4477-a182-8956aad82ffd",
    "system": true
  },
  "a3fcb4d9-240c-4984-8c4b-fe863ae1076b": {
    "type": "\`U\`&\`G\`",
    "name": "text http server",
    "units": {
      "listen0": {
        "id": "7e5710aa-faf0-41c4-8936-2583ac637c72",
        "input": {
          "port": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -66,
                "y": -2
              }
            }
          },
          "server": {},
          "close": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -77,
                "y": -20
              }
            }
          }
        },
        "output": {
          "url": {}
        },
        "metadata": {
          "position": {
            "x": -33,
            "y": -32
          }
        }
      },
      "createserver": {
        "id": "d52ecdec-776b-425c-b982-ce25ee8113bd",
        "input": {
          "opt": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -195,
                "y": -51
              }
            }
          },
          "close": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -184,
                "y": -78
              }
            }
          }
        },
        "output": {
          "server": {
            "metadata": {
              "position": {
                "x": -90,
                "y": -44
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -146,
            "y": -49
          }
        }
      },
      "buffer": {
        "id": "84b00637-b2bf-4b99-92eb-bf54f7f88ad0",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 1.125,
                "y": 16.9375
              }
            }
          },
          "init": {
            "constant": true,
            "metadata": {
              "position": {
                "x": 97,
                "y": -75
              },
              "data": {
                "position": {
                  "x": 107,
                  "y": -109
                }
              }
            },
            "data": {
              "ref": [],
              "data": []
            }
          }
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": -94.875,
                "y": 35.9375
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 73,
            "y": -37
          }
        }
      },
      "textdispatcher": {
        "id": "cf40cb93-65a7-42bf-aa7a-a00ec15faa08",
        "output": {
          "body": {
            "metadata": {
              "position": {
                "x": 137,
                "y": 24
              }
            }
          },
          "req": {
            "metadata": {
              "position": {
                "x": 227,
                "y": 23
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 181,
            "y": 2
          }
        },
        "input": {
          "status": {
            "metadata": {
              "position": {
                "x": 216,
                "y": -32
              }
            }
          },
          "headers": {
            "metadata": {
              "position": {
                "x": 191,
                "y": 47
              }
            }
          },
          "body": {
            "metadata": {
              "position": {
                "x": 235,
                "y": -6
              }
            }
          }
        }
      }
    },
    "merges": {
      "0": {
        "listen0": {
          "input": {
            "server": true
          }
        },
        "createserver": {
          "output": {
            "server": true
          }
        }
      },
      "1": {
        "listen0": {
          "output": {
            "url": true
          }
        },
        "buffer": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "buffer": {
          "output": {
            "a": true
          }
        },
        "textdispatcher": {
          "input": {
            "url": true
          }
        }
      }
    },
    "inputs": {
      "headers": {
        "plug": {
          "0": {
            "unitId": "textdispatcher",
            "pinId": "headers",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 193,
                "y": 72
              }
            }
          }
        },
        "type": "string{}"
      },
      "status": {
        "plug": {
          "0": {
            "unitId": "textdispatcher",
            "pinId": "status",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 229,
                "y": -54
              }
            }
          }
        },
        "type": "number"
      },
      "body": {
        "plug": {
          "0": {
            "unitId": "textdispatcher",
            "pinId": "body",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 259,
                "y": -12
              }
            }
          }
        },
        "type": "any"
      },
      "port": {
        "plug": {
          "0": {
            "unitId": "listen0",
            "pinId": "port",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -69,
                "y": 22
              }
            }
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "createserver",
            "pinId": "opt",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -218,
                "y": -52
              }
            }
          }
        }
      }
    },
    "outputs": {
      "body": {
        "plug": {
          "0": {
            "kind": "output",
            "unitId": "textdispatcher",
            "pinId": "body"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 124,
                "y": 45
              }
            }
          }
        },
        "type": "string"
      },
      "req": {
        "plug": {
          "0": {
            "unitId": "textdispatcher",
            "pinId": "req",
            "kind": "output"
          }
        },
        "ref": false,
        "type": "object",
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 247,
                "y": 38
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "server",
      "description": "http server for text only requests",
      "position": {
        "merge": {
          "1": {
            "x": 18,
            "y": -35
          },
          "2": {
            "x": 127,
            "y": -19
          },
          "4": {
            "x": 149,
            "y": 32
          },
          "5": {
            "x": 166,
            "y": -10
          }
        },
        "data": {
          "x": -253,
          "y": -53
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "a3fcb4d9-240c-4984-8c4b-fe863ae1076b",
    "system": true
  },
  "cf40cb93-65a7-42bf-aa7a-a00ec15faa08": {
    "type": "\`U\`&\`G\`",
    "name": "text dispatcher",
    "units": {
      "dispatcher": {
        "id": "39217208-f21a-4131-a089-13fa6f0631a4",
        "metadata": {
          "position": {
            "x": 0,
            "y": -22
          }
        },
        "input": {
          "status": {
            "metadata": {
              "position": {
                "x": 3,
                "y": 26
              }
            }
          },
          "headers": {
            "metadata": {
              "position": {
                "x": -38,
                "y": 10
              }
            }
          },
          "url": {
            "metadata": {
              "position": {
                "x": -3,
                "y": -68
              }
            }
          }
        },
        "output": {
          "body": {
            "metadata": {
              "position": {
                "x": 55,
                "y": -49
              }
            }
          },
          "req": {
            "metadata": {
              "position": {
                "x": 41,
                "y": 8
              }
            }
          }
        }
      },
      "totext": {
        "id": "b0d71197-fad7-4fc6-87e4-97636d365de6",
        "input": {
          "body": {},
          "any": {
            "constant": false,
            "ignored": false,
            "metadata": {
              "position": {
                "x": 241,
                "y": 111
              },
              "data": {
                "position": {
                  "x": 112,
                  "y": 150
                }
              }
            }
          }
        },
        "output": {
          "text": {
            "metadata": {
              "position": {
                "x": 158,
                "y": -39
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 108,
            "y": -37
          }
        }
      },
      "state": {
        "id": "c899b675-c3c4-428e-b548-b228305c0302",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -158,
                "y": -36
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 286,
                "y": -124
              }
            }
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": -55,
                "y": -47
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -108,
            "y": -34
          }
        }
      }
    },
    "merges": {
      "0": {
        "state": {
          "output": {
            "data": true
          }
        },
        "dispatcher": {
          "input": {
            "body": true
          }
        }
      },
      "3": {
        "totext": {
          "input": {
            "body": true
          }
        },
        "dispatcher": {
          "output": {
            "body": true
          }
        }
      },
      "7": {
        "totext": {
          "input": {
            "any": true
          }
        },
        "dispatcher": {
          "output": {
            "url": true
          }
        }
      },
      "8": {
        "state": {
          "input": {
            "done": true
          }
        },
        "dispatcher": {
          "output": {
            "done": true
          }
        }
      }
    },
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "dispatcher",
            "pinId": "url"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -4,
                "y": -93
              }
            }
          }
        }
      },
      "status": {
        "plug": {
          "0": {
            "unitId": "dispatcher",
            "pinId": "status"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 4,
                "y": 51
              }
            }
          }
        }
      },
      "headers": {
        "plug": {
          "0": {
            "unitId": "dispatcher",
            "pinId": "headers"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -49,
                "y": 33
              }
            }
          }
        }
      },
      "body": {
        "plug": {
          "0": {
            "unitId": "state",
            "pinId": "init"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -181,
                "y": -38
              }
            }
          }
        }
      }
    },
    "outputs": {
      "body": {
        "plug": {
          "0": {
            "unitId": "totext",
            "pinId": "text"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 181,
                "y": -42
              }
            }
          }
        }
      },
      "req": {
        "plug": {
          "0": {
            "unitId": "dispatcher",
            "pinId": "req",
            "kind": "output"
          }
        },
        "ref": false,
        "type": "object",
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 53,
                "y": 31
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "headset",
      "description": "text body http request handler",
      "position": {
        "merge": {
          "7": {
            "x": 59,
            "y": -22
          },
          "8": {
            "x": -59,
            "y": -19
          }
        },
        "data": {
          "x": -68,
          "y": 68
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "cf40cb93-65a7-42bf-aa7a-a00ec15faa08",
    "system": true
  },
  "fce38491-5fb7-4351-a775-ca4d474fdfe1": {
    "type": "\`U\`&\`G\`",
    "name": "is web socket request",
    "units": {
      "getordefault": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "connection"
            },
            "metadata": {
              "data": {
                "position": {
                  "x": -47,
                  "y": 122
                }
              },
              "position": {
                "x": 18,
                "y": 91
              }
            }
          },
          "obj": {},
          "default": {
            "constant": true,
            "metadata": {
              "position": {
                "x": -9,
                "y": 63
              },
              "data": {
                "position": {
                  "x": -112,
                  "y": 91
                }
              }
            },
            "data": {
              "ref": [],
              "data": ""
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 39,
            "y": 50
          }
        }
      },
      "tolowercase": {
        "id": "adde2d16-e1e6-4599-9a64-dd0968797041",
        "input": {
          "A": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": 43.05882352941177,
                "y": -35.588235294117645
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 142,
            "y": 77
          }
        }
      },
      "includes": {
        "id": "38bc7001-3543-48ba-99a5-96aeb908494b",
        "input": {
          "str": {},
          "search": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "upgrade"
            },
            "metadata": {
              "position": {
                "x": 285,
                "y": 96
              },
              "data": {
                "position": {
                  "x": 226,
                  "y": 125
                }
              }
            }
          }
        },
        "output": {
          "test": {}
        },
        "metadata": {
          "position": {
            "x": 245,
            "y": 72
          }
        }
      },
      "getordefault0": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "upgrade"
            },
            "metadata": {
              "data": {
                "position": {
                  "x": -7,
                  "y": -125
                }
              },
              "position": {
                "x": 18,
                "y": -91
              }
            }
          },
          "obj": {},
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": ""
            },
            "metadata": {
              "position": {
                "x": -9,
                "y": -63
              },
              "data": {
                "position": {
                  "x": -99,
                  "y": -109
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 39,
            "y": -50
          }
        }
      },
      "tolowercase0": {
        "id": "adde2d16-e1e6-4599-9a64-dd0968797041",
        "input": {
          "A": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": 92.24632352941177,
                "y": 25.28676470588235
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 142,
            "y": -77
          }
        }
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "websocket"
            },
            "metadata": {
              "position": {
                "x": 285,
                "y": -96
              },
              "data": {
                "position": {
                  "x": 239,
                  "y": -120
                }
              }
            }
          }
        },
        "output": {
          "a = b": {}
        },
        "metadata": {
          "position": {
            "x": 245,
            "y": -72
          }
        }
      },
      "and": {
        "id": "407640f7-f1c3-4297-a5ce-baff357a6d31",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a and b": {
            "metadata": {
              "position": {
                "x": 370,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 319,
            "y": 0
          }
        }
      },
      "getordefault1": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "headers"
            },
            "metadata": {
              "position": {
                "x": -195,
                "y": 32
              },
              "data": {
                "position": {
                  "x": -212,
                  "y": 45
                }
              }
            }
          },
          "obj": {
            "metadata": {
              "position": {
                "x": -212,
                "y": 0
              }
            }
          },
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": -195,
                "y": -32
              },
              "data": {
                "position": {
                  "x": -204,
                  "y": -69
                }
              }
            }
          }
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": -163.94117647058823,
                "y": 13.411764705882353
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -160,
            "y": 0
          }
        }
      },
      "lowercasekeys": {
        "id": "8e17c506-c949-4a94-9691-f0188231dafc",
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": 48.05882352941177,
                "y": 0.4117647058823529
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": 0
          }
        },
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -49.94117647058823,
                "y": 0.4117647058823529
              }
            }
          }
        }
      }
    },
    "merges": {
      "0": {
        "getordefault": {
          "input": {
            "obj": true
          }
        },
        "getordefault0": {
          "input": {
            "obj": true
          }
        },
        "lowercasekeys": {
          "output": {
            "obj": true
          }
        }
      },
      "1": {
        "tolowercase": {
          "input": {
            "A": true
          }
        },
        "getordefault": {
          "output": {
            "value": true
          }
        }
      },
      "2": {
        "includes": {
          "input": {
            "str": true
          }
        },
        "tolowercase": {
          "output": {
            "a": true
          }
        }
      },
      "3": {
        "getordefault0": {
          "output": {
            "value": true
          }
        },
        "tolowercase0": {
          "input": {
            "A": true
          }
        }
      },
      "4": {
        "equals": {
          "input": {
            "a": true
          }
        },
        "tolowercase0": {
          "output": {
            "a": true
          }
        }
      },
      "5": {
        "lowercasekeys": {
          "input": {
            "obj": true
          }
        },
        "getordefault1": {
          "output": {
            "value": true
          }
        }
      },
      "6": {
        "and": {
          "input": {
            "b": true
          }
        },
        "equals": {
          "output": {
            "a = b": true
          }
        }
      },
      "7": {
        "and": {
          "input": {
            "a": true
          }
        },
        "includes": {
          "output": {
            "test": true
          }
        }
      }
    },
    "inputs": {
      "req": {
        "plug": {
          "0": {
            "unitId": "getordefault1",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -236,
                "y": 0
              }
            }
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a and b",
            "kind": "output"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 393,
                "y": 0
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check weather a HTTP request object is a web socket upgrade request",
      "position": {
        "merge": {
          "0": {
            "x": 8,
            "y": 0
          },
          "1": {
            "x": 91,
            "y": 66
          },
          "2": {
            "x": 193,
            "y": 78
          },
          "3": {
            "x": 91,
            "y": -67
          },
          "4": {
            "x": 193,
            "y": -78
          },
          "5": {
            "x": -106,
            "y": 0
          },
          "6": {
            "x": 286,
            "y": -39
          },
          "7": {
            "x": 286,
            "y": 39
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "fce38491-5fb7-4351-a775-ca4d474fdfe1",
    "system": true
  },
  "5796118d-f441-405c-ac06-1455ff7e3e79": {
    "type": "\`U\`&\`G\`",
    "name": "is event stream request",
    "units": {
      "getordefault": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "accept"
            },
            "metadata": {
              "position": {
                "x": -7,
                "y": -8
              }
            }
          },
          "obj": {},
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": ""
            },
            "metadata": {
              "position": {
                "x": 66,
                "y": 50
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 28,
            "y": 22
          }
        }
      },
      "tolowercase": {
        "id": "adde2d16-e1e6-4599-9a64-dd0968797041",
        "input": {
          "A": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": 535.983152173913,
                "y": 438.86067774936055
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 134,
            "y": 3
          }
        }
      },
      "lowercasekeys": {
        "id": "8e17c506-c949-4a94-9691-f0188231dafc",
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": 605.9427109974424,
                "y": 337.01508951406646
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -81,
            "y": 36
          }
        },
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 507.9427109974425,
                "y": 337.01508951406646
              }
            }
          }
        }
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "text/event-stream"
            },
            "metadata": {
              "position": {
                "x": 205,
                "y": -49
              },
              "data": {
                "position": {
                  "x": 239,
                  "y": -120
                }
              }
            }
          }
        },
        "output": {
          "a = b": {
            "metadata": {
              "position": {
                "x": 285,
                "y": -17
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 236,
            "y": -18
          }
        }
      },
      "getordefault0": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": -235,
                "y": 41
              }
            }
          },
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "headers"
            },
            "metadata": {
              "position": {
                "x": -237,
                "y": 6
              }
            }
          },
          "obj": {
            "metadata": {
              "position": {
                "x": -156,
                "y": -10
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -190,
            "y": 22
          }
        }
      }
    },
    "merges": {
      "0": {
        "lowercasekeys": {
          "input": {
            "obj": true
          }
        },
        "getordefault0": {
          "output": {
            "value": true
          }
        }
      },
      "1": {
        "getordefault": {
          "input": {
            "obj": true
          }
        },
        "lowercasekeys": {
          "output": {
            "obj": true
          }
        }
      },
      "2": {
        "tolowercase": {
          "input": {
            "A": true
          }
        },
        "getordefault": {
          "output": {
            "value": true
          }
        }
      },
      "3": {
        "equals": {
          "input": {
            "a": true
          }
        },
        "tolowercase": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "req": {
        "plug": {
          "0": {
            "unitId": "getordefault0",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -155,
                "y": -34
              }
            }
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b",
            "kind": "output"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 308,
                "y": -15
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check weather an HTTP request object is a text event stream request",
      "position": {
        "merge": {
          "0": {
            "x": -135,
            "y": 32
          },
          "1": {
            "x": -26,
            "y": 33
          },
          "2": {
            "x": 82,
            "y": 9
          },
          "3": {
            "x": 186,
            "y": -4
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "5796118d-f441-405c-ac06-1455ff7e3e79",
    "system": true
  },
  "6f1388c8-9ad3-44b4-9669-d1386d8a9fc4": {
    "type": "\`U\`&\`G\`",
    "name": "fetch graph",
    "units": {
      "frombundle": {
        "id": "de2d42e2-4fca-4a3f-8783-3585c546e88b",
        "input": {
          "bundle": {}
        },
        "output": {
          "graph": {}
        },
        "metadata": {
          "position": {
            "x": 242,
            "y": 187
          }
        }
      },
      "fetchJSONbody": {
        "id": "00a8a078-91bf-4676-aa32-c9cfacdfd527",
        "input": {
          "url": {},
          "options": {
            "constant": false
          }
        },
        "output": {
          "json": {}
        },
        "metadata": {
          "position": {
            "x": 138,
            "y": 187
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "b": {
            "constant": false
          },
          "a": {
            "constant": true,
            "data": "{headers:{accept:\\"application/json\\"}}"
          }
        }
      }
    },
    "merges": {
      "0": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "fetchJSONbody": {
          "input": {
            "options": true
          }
        }
      },
      "4": {
        "frombundle": {
          "input": {
            "bundle": true
          }
        },
        "fetchJSONbody": {
          "output": {
            "json": true
          }
        }
      }
    },
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "fetchJSONbody",
            "pinId": "url"
          }
        },
        "ref": false
      },
      "options": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "frombundle",
            "pinId": "graph"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "send",
      "description": "fetch a JSON defined graph class",
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "6f1388c8-9ad3-44b4-9669-d1386d8a9fc4",
    "system": true
  },
  "c5856fdc-5154-46ab-a414-47f37af39da1": {
    "type": "\`U\`&\`G\`",
    "name": "fetch",
    "units": {
      "fetch": {
        "id": "b97c0133-6c87-4b69-af4e-354c0b590ece",
        "input": {
          "url": {
            "metadata": {
              "position": {
                "x": 17,
                "y": 103
              }
            }
          },
          "opt": {
            "metadata": {
              "position": {
                "x": -31,
                "y": 95
              }
            }
          },
          "body": {},
          "done": {
            "ignored": false
          }
        },
        "output": {
          "res": {
            "metadata": {
              "position": {
                "x": 55,
                "y": 31
              }
            }
          },
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -1,
            "y": 60
          }
        }
      },
      "state": {
        "id": "c899b675-c3c4-428e-b548-b228305c0302",
        "input": {
          "init": {},
          "done": {
            "ignored": false
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": -59,
                "y": 65
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -107,
            "y": 42
          }
        }
      },
      "getordefault": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "body"
            },
            "metadata": {
              "position": {
                "x": -261,
                "y": 40
              },
              "data": {
                "position": {
                  "x": -409,
                  "y": 205
                }
              }
            }
          },
          "obj": {
            "metadata": {
              "position": {
                "x": -262,
                "y": 5
              }
            }
          },
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": ""
            },
            "metadata": {
              "position": {
                "x": -182,
                "y": -10
              },
              "data": {
                "position": {
                  "x": -277,
                  "y": 101
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -215,
            "y": 21
          }
        }
      },
      "read": {
        "id": "c6da6b9f-a783-4e58-a252-e543aef109fb",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": 161.61904761904762,
                "y": 55.95238095238095
              }
            }
          },
          "any": {
            "metadata": {
              "position": {
                "x": 141,
                "y": 90
              },
              "data": {
                "position": {
                  "x": 77,
                  "y": 222
                }
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": "xxx"
            }
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": 194.61904761904762,
                "y": -20.047619047619047
              }
            }
          },
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 106,
            "y": 58
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "body"
            },
            "metadata": {
              "position": {
                "x": 248,
                "y": 21
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": 244,
                "y": -13
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 200,
            "y": 8
          }
        }
      },
      "totext": {
        "id": "b0d71197-fad7-4fc6-87e4-97636d365de6",
        "input": {
          "body": {},
          "any": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "xxx"
            },
            "metadata": {
              "position": {
                "x": 60,
                "y": -43
              }
            }
          }
        },
        "output": {
          "text": {}
        },
        "metadata": {
          "position": {
            "x": 96,
            "y": -12
          }
        }
      }
    },
    "merges": {
      "0": {
        "state": {
          "output": {
            "data": true
          }
        },
        "fetch": {
          "input": {
            "body": true
          }
        }
      },
      "1": {
        "state": {
          "input": {
            "init": true
          }
        },
        "getordefault": {
          "output": {
            "value": true
          }
        }
      },
      "2": {
        "fetch": {
          "output": {
            "res": true
          }
        },
        "read": {
          "input": {
            "value": true
          }
        },
        "totext": {
          "input": {
            "body": true
          }
        }
      },
      "3": {
        "read": {
          "output": {
            "done": true
          }
        },
        "fetch": {
          "input": {
            "done": true
          }
        }
      },
      "4": {
        "set": {
          "input": {
            "value": true
          }
        },
        "totext": {
          "output": {
            "text": true
          }
        }
      },
      "5": {
        "fetch": {
          "output": {
            "done": true
          }
        },
        "state": {
          "input": {
            "done": true
          }
        }
      },
      "6": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "read": {
          "output": {
            "data": true
          }
        }
      }
    },
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "url",
            "kind": "input"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 20,
                "y": 128
              }
            }
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "fetch",
            "pinId": "opt",
            "kind": "input"
          },
          "1": {
            "unitId": "getordefault",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -39,
                "y": 119
              }
            },
            "1": {
              "ext": {
                "x": -282,
                "y": -9
              }
            }
          }
        }
      }
    },
    "outputs": {
      "res": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj",
            "kind": "output"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 261,
                "y": -29
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "send",
      "description": "fetch a resource across the network through HTTP (with text body)",
      "position": {
        "merge": {
          "0": {
            "x": -48,
            "y": 16
          },
          "1": {
            "x": -161,
            "y": 34
          },
          "2": {
            "x": 66,
            "y": -18
          },
          "3": {
            "x": 53,
            "y": 68
          },
          "4": {
            "x": 150,
            "y": -11
          },
          "5": {
            "x": -52,
            "y": 38
          },
          "6": {
            "x": 157,
            "y": 38
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "c5856fdc-5154-46ab-a414-47f37af39da1",
    "system": true
  },
  "39217208-f21a-4131-a089-13fa6f0631a4": {
    "type": "\`U\`&\`G\`",
    "name": "dispatcher",
    "units": {
      "handle": {
        "id": "a9aaed9e-a0ca-423f-bb44-4ee0b3432471",
        "input": {
          "url": {
            "metadata": {
              "position": {
                "x": -124,
                "y": 11
              }
            }
          },
          "done": {
            "metadata": {
              "position": {
                "x": 148,
                "y": 30
              }
            }
          }
        },
        "output": {
          "url": {},
          "req": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -106,
                "y": -18
              }
            }
          },
          "body": {
            "metadata": {
              "position": {
                "x": -118,
                "y": 47
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -73,
            "y": 15
          }
        }
      },
      "respond": {
        "id": "7ef1c827-bbd4-4339-94c5-9fce05e50667",
        "input": {
          "url": {},
          "body": {
            "metadata": {
              "position": {
                "x": 64,
                "y": 47
              }
            }
          },
          "status": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 64,
                "y": -14
              }
            }
          },
          "headers": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 79,
                "y": 16
              }
            }
          }
        },
        "output": {
          "done": {
            "metadata": {
              "position": {
                "x": 172,
                "y": -61
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 27,
            "y": 16
          }
        }
      }
    },
    "merges": {
      "4": {
        "respond": {
          "input": {
            "url": true
          }
        },
        "handle": {
          "output": {
            "url": true
          }
        }
      },
      "5": {
        "handle": {
          "input": {
            "done": true
          }
        },
        "respond": {
          "output": {
            "done": true
          }
        }
      }
    },
    "inputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "handle",
            "pinId": "url"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -148,
                "y": 6
              }
            }
          }
        }
      },
      "body": {
        "plug": {
          "0": {
            "unitId": "respond",
            "pinId": "body"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 77,
                "y": 68
              }
            }
          }
        }
      },
      "status": {
        "plug": {
          "0": {
            "unitId": "respond",
            "pinId": "status"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 77,
                "y": -35
              }
            }
          }
        }
      },
      "headers": {
        "plug": {
          "0": {
            "unitId": "respond",
            "pinId": "headers"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 104,
                "y": 16
              }
            }
          }
        }
      }
    },
    "outputs": {
      "body": {
        "plug": {
          "0": {
            "unitId": "handle",
            "pinId": "body"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -136,
                "y": 71
              }
            }
          }
        }
      },
      "url": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -22,
                "y": -21
              }
            }
          }
        }
      },
      "done": {
        "plug": {
          "0": {
            "mergeId": "5"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -23,
                "y": 53
              }
            }
          }
        }
      },
      "req": {
        "plug": {
          "0": {
            "unitId": "handle",
            "pinId": "req",
            "kind": "output"
          }
        },
        "ref": false,
        "type": "object",
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -117,
                "y": -40
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "headset",
      "description": "http request handle + respond",
      "position": {
        "merge": {
          "4": {
            "x": -23,
            "y": 4
          },
          "5": {
            "x": -23,
            "y": 28
          }
        },
        "data": {
          "x": 142,
          "y": 17
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "39217208-f21a-4131-a089-13fa6f0631a4",
    "system": true
  },
  "84b00637-b2bf-4b99-92eb-bf54f7f88ad0": {
    "type": "\`U\`&\`G\`",
    "name": "buffer",
    "units": {
      "append": {
        "id": "cf4db91a-f8b2-454f-a763-12005d71cb9d",
        "input": {
          "a[]": {},
          "a": {
            "metadata": {
              "position": {
                "x": -231,
                "y": 98
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -188,
            "y": 77
          }
        }
      },
      "state": {
        "id": "c899b675-c3c4-428e-b548-b228305c0302",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -256,
                "y": 25
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -247,
                "y": -8
              }
            }
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": -146,
                "y": 38
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -206,
            "y": 18
          }
        }
      },
      "debounce": {
        "id": "e55c58b3-8653-4481-b5c9-2a75fce6365a",
        "input": {
          "ms": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            },
            "metadata": {
              "position": {
                "x": 53,
                "y": 128
              },
              "data": {
                "position": {
                  "x": -76,
                  "y": 134
                }
              }
            }
          },
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 13,
            "y": 100
          }
        }
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 257,
                "y": 18
              }
            }
          },
          "b": {}
        },
        "output": {
          "a if not b": {}
        },
        "metadata": {
          "position": {
            "x": 208,
            "y": 5
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": 116,
            "y": -22
          }
        }
      },
      "iterate0": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {
            "metadata": {
              "position": {
                "x": -51,
                "y": 47
              }
            }
          },
          "init": {
            "constant": true,
            "data": {
              "ref": [],
              "data": false
            },
            "metadata": {
              "position": {
                "x": 76,
                "y": -122
              },
              "data": {
                "position": {
                  "x": 218,
                  "y": -134
                }
              }
            }
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 135,
                "y": -135
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 114,
            "y": -94
          }
        }
      },
      "constant1": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": -248,
                "y": 67
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 215,
            "y": -79
          }
        }
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 108,
            "y": 47
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 21,
            "y": -44
          }
        }
      },
      "identity0": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 16,
            "y": 22
          }
        }
      },
      "ifgreaterthan0": {
        "id": "0facebfb-2449-430d-8f12-d8fdc5fc04e7",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -53,
            "y": 21
          }
        }
      },
      "length0": {
        "id": "ec482aaf-0029-4b85-b03a-de5bd361d706",
        "input": {
          "a": {},
          "any": {}
        },
        "output": {
          "length": {}
        },
        "metadata": {
          "position": {
            "x": -100,
            "y": 80
          }
        }
      },
      "shift": {
        "id": "4730fbc1-dd24-4b6a-adc2-d71e2b2df22d",
        "input": {
          "a": {},
          "any": {}
        },
        "output": {
          "first": {
            "metadata": {
              "position": {
                "x": -135,
                "y": -35
              }
            }
          },
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -96,
            "y": -6
          }
        }
      }
    },
    "merges": {
      "0": {
        "append": {
          "input": {
            "a[]": true
          }
        },
        "state": {
          "output": {
            "data": true
          }
        },
        "length0": {
          "input": {
            "a": true
          }
        },
        "shift": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "ifgreaterthan0": {
          "input": {
            "a": true
          }
        },
        "length0": {
          "output": {
            "length": true
          }
        }
      },
      "2": {
        "true": {
          "output": {
            "true": true
          }
        },
        "iterate0": {
          "input": {
            "next": true
          }
        },
        "false": {
          "output": {
            "false": true
          }
        }
      },
      "3": {
        "identity": {
          "output": {
            "a": true
          }
        },
        "debounce": {
          "input": {
            "a": true
          }
        },
        "identity0": {
          "output": {
            "a": true
          }
        }
      },
      "4": {
        "false": {
          "input": {
            "any": true
          }
        },
        "identity0": {
          "input": {
            "a": true
          }
        },
        "shift": {
          "output": {
            "done": true
          }
        }
      },
      "5": {
        "ifgreaterthan0": {
          "output": {
            "a": true
          }
        },
        "shift": {
          "input": {
            "any": true
          }
        }
      },
      "7": {
        "debounce": {
          "output": {
            "a": true
          }
        },
        "length0": {
          "input": {
            "any": true
          }
        }
      },
      "16": {
        "iterate0": {
          "output": {
            "current": true
          }
        },
        "constant1": {
          "input": {
            "a": true
          }
        }
      },
      "17": {
        "ifnot": {
          "input": {
            "b": true
          }
        },
        "constant1": {
          "output": {
            "a": true
          }
        }
      },
      "19": {
        "ifnot": {
          "output": {
            "a if not b": true
          }
        },
        "identity": {
          "input": {
            "a": true
          }
        },
        "true": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "ifnot",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -244,
                "y": 118
              }
            },
            "1": {
              "ext": {
                "x": 276,
                "y": 33
              }
            }
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "state",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -280,
                "y": 27
              }
            }
          }
        }
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "state",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false,
        "type": "any",
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -262,
                "y": -27
              }
            }
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "shift",
            "pinId": "first",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -142,
                "y": -59
              }
            }
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "array",
      "description": "general purpose buffer",
      "position": {
        "merge": {
          "1": {
            "x": -59,
            "y": 65
          },
          "2": {
            "x": 76,
            "y": -56
          },
          "3": {
            "x": 54,
            "y": 60
          },
          "4": {
            "x": -28,
            "y": -13
          },
          "5": {
            "x": -58,
            "y": -24
          },
          "7": {
            "x": -46,
            "y": 101
          },
          "11": {
            "x": -124,
            "y": -42
          },
          "12": {
            "x": -220,
            "y": -13
          },
          "13": {
            "x": -227,
            "y": -41
          },
          "14": {
            "x": -313,
            "y": -21
          },
          "15": {
            "x": -250,
            "y": 42
          },
          "16": {
            "x": 166,
            "y": -96
          },
          "17": {
            "x": 238,
            "y": -37
          },
          "19": {
            "x": 153,
            "y": 15
          },
          "22": {
            "x": 3,
            "y": -64
          }
        },
        "data": {
          "x": -297,
          "y": -40
        }
      },
      "tags": [
        "platform",
        "core",
        "http"
      ]
    },
    "id": "84b00637-b2bf-4b99-92eb-bf54f7f88ad0",
    "system": true
  },
  "6652cded-6a51-473e-9fce-5843186d971a": {
    "type": "\`U\`&\`G\`",
    "name": "set name",
    "units": {
      "setname": {
        "id": "ee6b5fbb-5e05-4750-83a8-d6ffe5a059db",
        "metadata": {
          "position": {
            "x": 57,
            "y": 0
          }
        },
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -48,
                "y": 0
              }
            }
          },
          "name": {
            "metadata": {
              "position": {
                "x": 105,
                "y": 0
              }
            }
          }
        }
      },
      "spec": {
        "id": "e547c624-d505-485d-8d78-e393c6beb1b4",
        "input": {
          "unit": {
            "metadata": {
              "position": {
                "x": -105,
                "y": 0
              }
            }
          }
        },
        "output": {
          "spec": {
            "metadata": {
              "position": {
                "x": 0,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "spec": {
          "output": {
            "spec": true
          }
        },
        "setname": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "spec",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -128,
                "y": 0
              }
            }
          }
        }
      },
      "name": {
        "plug": {
          "0": {
            "kind": "input",
            "unitId": "setname",
            "pinId": "name"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 128,
                "y": 0
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set graph spec name",
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "id": "6652cded-6a51-473e-9fce-5843186d971a",
    "component": {},
    "system": true
  },
  "33124e48-d0ef-4e69-b1d4-95959f3ba18a": {
    "type": "\`U\`&\`G\`",
    "name": "set icon",
    "units": {
      "spec": {
        "id": "e547c624-d505-485d-8d78-e393c6beb1b4",
        "input": {
          "unit": {}
        },
        "output": {
          "spec": {}
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": 0
          }
        }
      },
      "deepsetmetadataicon": {
        "id": "b97d77a2-bf51-4bf9-aa72-2956c26ce1ab",
        "input": {
          "value": {},
          "obj": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 56,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "spec": {
          "output": {
            "spec": true
          }
        },
        "deepsetmetadataicon": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "spec",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true
      },
      "icon": {
        "plug": {
          "0": {
            "unitId": "deepsetmetadataicon",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set \`graph\` spec icon",
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "id": "33124e48-d0ef-4e69-b1d4-95959f3ba18a",
    "system": true
  },
  "3866656a-8fe0-44b5-a278-59284c555606": {
    "type": "\`U\`&\`G\`",
    "name": "remove all units",
    "units": {
      "bundle": {
        "id": "13d738b9-401d-43c9-852f-e9611545f5bc",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": -40,
                "y": -25
              }
            }
          },
          "opt": {
            "constant": false
          }
        },
        "output": {
          "bundle": {}
        },
        "metadata": {
          "position": {
            "x": -3,
            "y": -50
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "a": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -12,
                "y": 166
              }
            }
          },
          "i": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 18,
                "y": 143
              }
            }
          },
          "test": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -64,
                "y": 151
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -27,
            "y": 122
          }
        }
      },
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {}
        },
        "output": {
          "keys": {}
        },
        "metadata": {
          "position": {
            "x": 73,
            "y": 105
          }
        }
      },
      "removeunit": {
        "id": "c47d84b2-4207-11eb-a064-a3633d64f05d",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": -175,
                "y": 125
              }
            }
          },
          "id": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -127,
            "y": 125
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "spec"
            },
            "metadata": {
              "position": {
                "x": 143,
                "y": -51
              },
              "data": {
                "position": {
                  "x": 174,
                  "y": -74
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 100,
            "y": -30
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "system": false,
                "state": false
              }
            },
            "metadata": {
              "data": {
                "position": {
                  "x": -222,
                  "y": -139
                }
              },
              "position": {
                "x": -151,
                "y": -92
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -154,
                "y": -57
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -108,
            "y": -72
          }
        }
      },
      "get0": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "units"
            },
            "metadata": {
              "position": {
                "x": 209,
                "y": 57
              },
              "data": {
                "position": {
                  "x": 255,
                  "y": 64
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 160,
            "y": 52
          }
        }
      }
    },
    "merges": {
      "0": {
        "bundle": {
          "input": {
            "opt": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "bundle": {
          "output": {
            "bundle": true
          }
        }
      },
      "2": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "keys": {
          "output": {
            "keys": true
          }
        }
      },
      "3": {
        "removeunit": {
          "input": {
            "id": true
          }
        },
        "foreach": {
          "output": {
            "a[i]": true
          }
        }
      },
      "4": {
        "get0": {
          "input": {
            "obj": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      },
      "5": {
        "keys": {
          "input": {
            "obj": true
          }
        },
        "get0": {
          "output": {
            "value": true
          }
        }
      }
    },
    "inputs": {
      "graph": {
        "ref": true,
        "plug": {
          "0": {
            "unitId": "removeunit",
            "kind": "input",
            "pinId": "graph"
          },
          "1": {
            "unitId": "bundle",
            "pinId": "graph",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -198,
                "y": 125
              }
            },
            "1": {
              "ext": {
                "x": -48,
                "y": -3
              }
            }
          }
        }
      },
      "any": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "wait",
            "kind": "input",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -174,
                "y": -44
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "x",
      "description": "remove all units from a graph",
      "position": {
        "merge": {
          "0": {
            "x": -55,
            "y": -65
          },
          "1": {
            "x": 49,
            "y": -43
          },
          "2": {
            "x": 24,
            "y": 116
          },
          "3": {
            "x": -78,
            "y": 125
          },
          "4": {
            "x": 134,
            "y": 9
          },
          "5": {
            "x": 120,
            "y": 85
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "id": "3866656a-8fe0-44b5-a278-59284c555606",
    "system": true
  },
  "912fddea-98d5-4e6c-9901-936e6f276767": {
    "type": "\`U\`&\`G\`",
    "name": "get icon",
    "units": {
      "deepget1": {
        "id": "2ff102a7-b469-461f-a3b1-a61b81c1b325",
        "input": {
          "path": {
            "constant": true,
            "data": {
              "ref": [],
              "data": [
                "metadata",
                "icon"
              ]
            },
            "metadata": {
              "position": {
                "x": 75,
                "y": 30
              },
              "data": {
                "position": {
                  "x": 111,
                  "y": 51
                }
              }
            }
          },
          "obj": {}
        },
        "output": {
          "result": {
            "metadata": {
              "position": {
                "x": 57,
                "y": -30
              }
            }
          },
          "value": {
            "metadata": {
              "position": {
                "x": 75,
                "y": -7
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 31,
            "y": 12
          }
        }
      },
      "spec": {
        "id": "ae1f7fc0-d6e7-489c-94ed-dee71c68dbb7",
        "input": {
          "unit": {
            "metadata": {
              "position": {
                "x": -117,
                "y": 30
              }
            }
          },
          "any": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -117,
                "y": -7
              }
            }
          }
        },
        "output": {
          "spec": {}
        },
        "metadata": {
          "position": {
            "x": -73,
            "y": 12
          }
        }
      }
    },
    "merges": {
      "1": {
        "deepget1": {
          "input": {
            "obj": true
          }
        },
        "spec": {
          "output": {
            "spec": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "spec",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -133,
                "y": -23
              }
            }
          }
        }
      },
      "unit": {
        "plug": {
          "0": {
            "unitId": "spec",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -133,
                "y": 47
              }
            }
          }
        }
      }
    },
    "outputs": {
      "icon": {
        "plug": {
          "0": {
            "unitId": "deepget1",
            "pinId": "value",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 92,
                "y": -23
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`unit\` spec icon",
      "position": {
        "merge": {
          "1": {
            "x": -21,
            "y": 12
          }
        },
        "data": {
          "x": -158,
          "y": -51
        }
      },
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "id": "912fddea-98d5-4e6c-9901-936e6f276767",
    "system": true
  },
  "fc9cd968-7e0d-4540-9f0e-d16afeb0d3b3": {
    "name": "editor | editor",
    "inputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 59,
              "y": -245
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "graph": {
        "id": "e80c912e-7508-11ea-966b-436805345ff0",
        "input": {
          "style": {
            "constant": true,
            "data": "{position:'relative'}",
            "metadata": {
              "position": {
                "x": 87,
                "y": 55
              }
            }
          },
          "graph": {},
          "disabled": {
            "metadata": {
              "position": {
                "x": 86,
                "y": 24
              }
            }
          },
          "fullwindow": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 92,
                "y": -28
              }
            }
          },
          "frame": {
            "metadata": {
              "position": {
                "x": 87,
                "y": -6
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 238,
            "y": 6
          },
          "component": {
            "width": 300,
            "height": 300
          }
        }
      },
      "new": {
        "id": "324b9c5e-5810-11eb-bf7c-634b3bb07f8c",
        "input": {
          "graph": {}
        },
        "output": {
          "graph": {
            "metadata": {
              "position": {
                "x": 68,
                "y": -53
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 70,
            "y": -111
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 72,
                "y": -221
              }
            }
          },
          "d": {
            "constant": true,
            "data": "\${unit:{id:'e33e7dcd-9715-461c-a474-15ed2bda899e'}}",
            "metadata": {
              "position": {
                "x": 162,
                "y": -209
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 115,
            "y": -200
          }
        }
      },
      "graph0": {
        "id": "e80c912e-7508-11ea-966b-436805345ff0",
        "input": {
          "style": {
            "constant": true,
            "data": "{position:'relative'}",
            "metadata": {
              "position": {
                "x": -249,
                "y": -13
              }
            }
          },
          "graph": {},
          "disabled": {
            "metadata": {
              "position": {
                "x": -251,
                "y": -46
              }
            }
          },
          "fullwindow": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -248,
                "y": -103
              }
            }
          },
          "frame": {
            "metadata": {
              "position": {
                "x": -249,
                "y": -79
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 236.420654296875,
            "height": 240.87225341796875
          },
          "position": {
            "x": -100,
            "y": -46
          }
        }
      },
      "verticalsplit": {
        "id": "01791e01-bfeb-47d0-952a-8dd32a72d1fb"
      }
    },
    "merges": {
      "0": {
        "default": {
          "output": {
            "a": true
          }
        },
        "new": {
          "input": {
            "graph": true
          }
        }
      },
      "1": {
        "new": {
          "output": {
            "graph": true
          }
        },
        "graph0": {
          "input": {
            "graph": true
          }
        },
        "graph": {
          "input": {
            "graph": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "graph",
          "default"
        ],
        [
          "graph0",
          "default"
        ]
      ],
      "subComponents": {
        "verticalsplit": {
          "children": [
            "graph",
            "graph0"
          ],
          "childSlot": {
            "graph": "default",
            "graph0": "1"
          },
          "width": 600,
          "height": 300
        },
        "graph": {
          "children": []
        },
        "graph0": {
          "children": []
        }
      },
      "children": [
        "verticalsplit"
      ],
      "defaultWidth": 600,
      "defaultHeight": 420
    },
    "metadata": {
      "icon": "atom-alt",
      "description": "two editor side by side, connected to the same graph",
      "tags": [
        "platform",
        "core",
        "graph"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 89,
            "y": -158
          }
        }
      }
    },
    "id": "fc9cd968-7e0d-4540-9f0e-d16afeb0d3b3",
    "render": true,
    "system": true
  },
  "470428a2-b4b4-4866-a1e9-2f130772cd3b": {
    "name": "editor | box",
    "inputs": {},
    "outputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "graph"
          }
        },
        "ref": true,
        "type": "\`U\`&\`G\`",
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "x": 235,
              "y": 21
            }
          }
        }
      }
    },
    "units": {
      "editor": {
        "id": "e80c912e-7508-11ea-966b-436805345ff0",
        "input": {
          "style": {
            "constant": true,
            "data": "{\\"borderRight\\":\\"1px solid currentColor\\"}",
            "metadata": {
              "position": {
                "x": -210,
                "y": -53
              }
            }
          },
          "graph": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 208,
                "y": -27
              }
            }
          },
          "disabled": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -210,
                "y": -139
              }
            }
          },
          "fullwindow": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -210,
                "y": -90
              }
            }
          },
          "frame": {
            "ignored": false
          },
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -209,
                "y": 28
              }
            }
          },
          "zoom": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -210,
                "y": -113
              }
            }
          },
          "controls": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -210,
                "y": -70
              }
            }
          }
        },
        "output": {
          "graph": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 221,
                "y": 11
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 171,
            "y": 189
          },
          "component": {
            "width": 360.1918640136719,
            "height": 441.29931640625
          }
        }
      },
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {
            "constant": true,
            "data": "{}",
            "metadata": {
              "position": {
                "x": -503,
                "y": -12
              }
            }
          },
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -503,
                "y": -41
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -228,
            "y": 149
          },
          "component": {
            "width": 246.2730712890625,
            "height": 329.615966796875
          }
        }
      },
      "row": {
        "id": "ad5a2fcc-fdee-11ea-a34f-77e9c48dbe57",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -385,
                "y": -406
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 21,
            "y": -298
          },
          "component": {
            "width": 376.8758239746094,
            "height": 223.14797973632812
          }
        }
      }
    },
    "merges": {
      "0": {
        "editor": {
          "input": {
            "frame": true
          }
        },
        "box": {
          "output": {
            "_self": true
          }
        }
      }
    },
    "metadata": {
      "icon": "atom-alt",
      "description": "editor with a box frame, side by side",
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "component": {
      "slots": [
        [
          "editor",
          "default"
        ],
        [
          "box",
          "default"
        ]
      ],
      "children": [
        "row"
      ],
      "subComponents": {
        "editor": {
          "children": []
        },
        "box": {
          "children": []
        },
        "row": {
          "children": [
            "editor",
            "box"
          ]
        }
      },
      "defaultWidth": 420,
      "defaultHeight": 300
    },
    "id": "470428a2-b4b4-4866-a1e9-2f130772cd3b",
    "type": "\`U\`&\`G\`",
    "render": true,
    "system": true
  },
  "58ecd331-f5e8-4089-a2d0-b6ad8410d994": {
    "type": "\`U\`&\`G\`",
    "name": "bundle to clipboard",
    "units": {
      "stringify": {
        "id": "ee184ea6-3c80-4119-919e-290620aafab0",
        "input": {
          "json": {
            "ignored": false
          }
        },
        "output": {
          "string": {}
        },
        "metadata": {
          "position": {
            "x": 1,
            "y": -1
          }
        }
      },
      "texttoclipboard": {
        "id": "0b5a71c6-5c43-4e55-a29c-27d9ff7ed43a",
        "input": {
          "text": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 99,
            "y": -1
          }
        }
      },
      "bundle": {
        "id": "13d738b9-401d-43c9-852f-e9611545f5bc",
        "input": {
          "graph": {},
          "opt": {}
        },
        "output": {
          "bundle": {}
        }
      }
    },
    "merges": {
      "0": {
        "stringify": {
          "input": {
            "json": true
          }
        },
        "bundle": {
          "output": {
            "bundle": true
          }
        }
      },
      "1": {
        "stringify": {
          "output": {
            "string": true
          }
        },
        "texttoclipboard": {
          "input": {
            "text": true
          }
        }
      }
    },
    "inputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "bundle",
            "pinId": "graph",
            "kind": "input"
          }
        },
        "ref": true
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "bundle",
            "pinId": "opt",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "brackets-curly",
      "description": "copy \`graph\` bundle to clipboard",
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "id": "58ecd331-f5e8-4089-a2d0-b6ad8410d994",
    "system": true
  },
  "ca6c1e54-b482-4fa1-aba9-04568fb59958": {
    "name": "add random unit",
    "inputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "addunit",
            "pinId": "graph"
          }
        },
        "ref": true
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "units": {
      "randomclass": {
        "id": "96c788b0-9bc1-11eb-931a-7312c12cb4c3",
        "input": {
          "any": {}
        },
        "output": {
          "class": {}
        },
        "metadata": {
          "position": {
            "x": 138,
            "y": 26
          }
        }
      },
      "addunit": {
        "id": "b80d4b5a-40e9-11eb-a2bb-1777d47bf9ae",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": 67,
                "y": 72
              }
            }
          },
          "id": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 57,
            "y": 56
          }
        }
      },
      "randomnatural": {
        "id": "9569f78e-18d3-40a3-9373-c56afa0214f6",
        "input": {
          "max": {}
        },
        "output": {
          "i": {}
        },
        "metadata": {
          "position": {
            "x": -65,
            "y": -34
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "1000000",
            "metadata": {
              "position": {
                "x": -158,
                "y": -21
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -158,
                "y": -57
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -168,
            "y": -36
          }
        }
      },
      "numbertodecimal": {
        "id": "a6ab9464-303a-48a4-8b5f-0cd515ab7b8f",
        "input": {
          "n": {}
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": 38,
            "y": -12
          }
        }
      }
    },
    "merges": {
      "0": {
        "randomclass": {
          "output": {
            "class": true
          }
        },
        "addunit": {
          "input": {
            "class": true
          }
        }
      },
      "1": {
        "randomclass": {
          "input": {
            "any": true
          }
        },
        "addunit": {
          "input": {
            "id": true
          }
        },
        "numbertodecimal": {
          "output": {
            "str": true
          }
        }
      },
      "2": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "randomnatural": {
          "input": {
            "max": true
          }
        }
      },
      "3": {
        "numbertodecimal": {
          "input": {
            "n": true
          }
        },
        "randomnatural": {
          "output": {
            "i": true
          }
        }
      }
    },
    "metadata": {
      "icon": "shapes",
      "description": "add random unit to \`graph\`",
      "tags": [
        "platform",
        "core",
        "graph"
      ]
    },
    "id": "ca6c1e54-b482-4fa1-aba9-04568fb59958",
    "type": "\`U\`&\`G\`",
    "component": {},
    "system": true
  },
  "dcd6a544-e386-4e1c-9282-043da9585957": {
    "type": "\`U\`&\`G\`",
    "name": "download graph",
    "units": {
      "stringify": {
        "id": "ee184ea6-3c80-4119-919e-290620aafab0"
      },
      "graphbundle": {
        "id": "13d738b9-401d-43c9-852f-e9611545f5bc",
        "input": {
          "graph": {},
          "opt": {}
        },
        "output": {
          "bundle": {}
        },
        "metadata": {
          "position": {
            "x": -8,
            "y": 10
          }
        }
      },
      "downloadtext": {
        "id": "b5ab65ce-4306-4a46-8d3c-36b6c29b1c60",
        "input": {
          "text": {},
          "name": {
            "constant": false
          },
          "mimetype": {
            "constant": true,
            "data": "\\"application/json\\""
          },
          "charset": {
            "constant": true,
            "data": "\\"utf-8\\""
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 198,
            "y": -15
          }
        }
      }
    },
    "merges": {
      "0": {
        "stringify": {
          "input": {
            "json": true
          }
        },
        "graphbundle": {
          "output": {
            "bundle": true
          }
        }
      },
      "1": {
        "stringify": {
          "output": {
            "string": true
          }
        },
        "downloadtext": {
          "input": {
            "text": true
          }
        }
      }
    },
    "inputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "graphbundle",
            "pinId": "graph"
          }
        },
        "ref": true
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "graphbundle",
            "pinId": "opt"
          }
        },
        "ref": false
      },
      "name": {
        "plug": {
          "0": {
            "unitId": "downloadtext",
            "pinId": "name"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "download",
      "description": "download \`graph\` bundle as a json file",
      "tags": [
        "platform",
        "core",
        "download"
      ]
    },
    "id": "dcd6a544-e386-4e1c-9282-043da9585957",
    "system": true
  },
  "ecb16ee2-d81f-4f3f-a241-b007087f5055": {
    "name": "swallow",
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "catch",
            "pinId": "unit"
          }
        },
        "ref": true
      }
    },
    "outputs": {},
    "units": {
      "catch": {
        "id": "2520668c-b279-11ea-ace3-5b84eb02bd7f",
        "input": {
          "unit": {}
        },
        "output": {
          "err": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "render": false,
    "component": {},
    "metadata": {
      "icon": "alert-circle",
      "description": "throw away any caught error",
      "tags": [
        "platform",
        "core",
        "control"
      ]
    },
    "type": "\`U\`&\`G\`",
    "id": "ecb16ee2-d81f-4f3f-a241-b007087f5055",
    "system": true
  },
  "e08596c5-fdb2-464f-802b-f52217295c04": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "svg + text",
    "units": {
      "svg": {
        "id": "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -65,
                "y": -181
              }
            }
          },
          "viewBox": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -64,
                "y": -210
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 69,
            "y": -181
          }
        }
      },
      "text": {
        "id": "49ef122e-b4d1-11ea-b45e-b73d8ee2aae8",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 108,
                "y": 27
              }
            }
          },
          "value": {
            "constant": true,
            "data": "\\"SVG\\"",
            "metadata": {
              "position": {
                "x": 106,
                "y": 61
              }
            }
          },
          "x": {
            "constant": true,
            "data": "\\"50%\\"",
            "metadata": {
              "position": {
                "x": -107,
                "y": 61
              }
            }
          },
          "y": {
            "constant": true,
            "data": "\\"50%\\"",
            "metadata": {
              "position": {
                "x": -109,
                "y": 27
              }
            }
          },
          "dx": {
            "metadata": {
              "position": {
                "x": -107,
                "y": -6
              }
            }
          },
          "dy": {
            "constant": true,
            "metadata": {
              "position": {
                "x": 106,
                "y": -6
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 0,
            "y": 27
          }
        }
      }
    },
    "merges": {},
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG text",
      "tags": [
        "platform",
        "core",
        "component",
        "svg"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "svg": {
          "children": [
            "text"
          ],
          "childSlot": {}
        },
        "text": {
          "children": [],
          "childSlot": {}
        }
      },
      "children": [
        "svg"
      ],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "id": "e08596c5-fdb2-464f-802b-f52217295c04",
    "system": true
  },
  "79c37c2e-4a2b-445f-af75-5599cc6bf31c": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "svg + path",
    "units": {
      "path": {
        "id": "60bc7930-8982-11ea-8b24-cf97a783bb32",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 111,
                "y": -80
              }
            },
            "ignored": false
          },
          "d": {},
          "fillRule": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 111,
                "y": -112
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 194,
            "y": -14
          }
        }
      },
      "svg": {
        "id": "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
        "input": {
          "style": {},
          "viewBox": {
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -111,
            "y": -190
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "path",
            "pinId": "d"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "path",
            "pinId": "style"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG path",
      "tags": [
        "platform",
        "core",
        "component",
        "svg"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "path": {
          "children": [],
          "childSlot": {}
        },
        "svg": {
          "children": [
            "path"
          ],
          "childSlot": {}
        }
      },
      "children": [
        "svg"
      ],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "id": "79c37c2e-4a2b-445f-af75-5599cc6bf31c",
    "system": true
  },
  "c30f0873-71d8-405f-9b92-d3eb5a387a3b": {
    "name": "canvas line",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "style"
          }
        }
      },
      "line": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "type": "{x0:number,y0:number,x1:number,y1:number}"
      }
    },
    "outputs": {},
    "units": {
      "addline": {
        "id": "90dc2942-52fa-4e09-bcef-43fa97cc0b72",
        "input": {
          "d": {
            "constant": true,
            "data": "[]",
            "metadata": {
              "position": {
                "x": 25,
                "y": 47
              }
            }
          },
          "line": {
            "constant": false
          }
        },
        "output": {
          "d": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 54,
            "y": 12
          }
        }
      },
      "canvas": {
        "id": "94243ec4-8967-4907-8cdd-7223fe256cf6",
        "input": {
          "d": {},
          "style": {
            "metadata": {
              "position": {
                "x": 119,
                "y": -47
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 248,
            "y": -18
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -105,
                "y": 18
              }
            }
          },
          "d": {
            "constant": true,
            "data": "{x0:20,y0:180,x1:180,y1:20}",
            "metadata": {
              "position": {
                "x": -104,
                "y": -16
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -58,
            "y": 2
          }
        }
      }
    },
    "merges": {
      "0": {
        "addline": {
          "output": {
            "d": true
          }
        },
        "canvas": {
          "input": {
            "d": true
          }
        }
      },
      "1": {
        "default": {
          "output": {
            "a": true
          }
        },
        "addline": {
          "input": {
            "line": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "canvas": {
          "children": []
        }
      },
      "children": [
        "canvas"
      ],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "metadata": {
      "icon": "edit-3",
      "description": "a line on canvas",
      "tags": [
        "platform",
        "core",
        "component",
        "canvas"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 109,
            "y": 4
          },
          "1": {
            "x": -3,
            "y": 5
          }
        }
      }
    },
    "id": "c30f0873-71d8-405f-9b92-d3eb5a387a3b",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "3e555954-4748-48bf-a767-8943ff5a7e95": {
    "name": "canvas fill circle",
    "units": {
      "addfillcircle": {
        "id": "0eb3579e-4645-4e45-a3b1-f3fb1a62ab4d",
        "input": {
          "circle": {
            "constant": false
          },
          "d": {
            "constant": true,
            "data": "[]"
          }
        },
        "output": {
          "d": {
            "ignored": false
          }
        }
      },
      "canvas": {
        "id": "94243ec4-8967-4907-8cdd-7223fe256cf6",
        "input": {
          "d": {},
          "style": {}
        },
        "output": {}
      }
    },
    "merges": {
      "0": {
        "addfillcircle": {
          "output": {
            "d": true
          }
        },
        "canvas": {
          "input": {
            "d": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "a circle on canvas",
      "tags": [
        "platform",
        "core",
        "component",
        "canvas"
      ]
    },
    "inputs": {
      "circle": {
        "plug": {
          "0": {
            "unitId": "addfillcircle",
            "pinId": "circle"
          }
        },
        "type": "{x:number,y:number,r:number}",
        "metadata": {
          "examples": [
            "{x:100,y:100,r:50}"
          ]
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "style"
          }
        }
      }
    },
    "outputs": {
      "canvas": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "_self"
          }
        },
        "ref": true,
        "type": "\`C\`&\`V\`&\`A\`"
      }
    },
    "id": "3e555954-4748-48bf-a767-8943ff5a7e95",
    "component": {
      "slots": [
        [
          "canvas",
          "default"
        ]
      ],
      "defaultWidth": 200,
      "defaultHeight": 200,
      "subComponents": {
        "canvas": {
          "children": []
        }
      },
      "children": [
        "canvas"
      ]
    },
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "01562c38-9973-43f4-982b-1dbdbea49c5b": {
    "name": "canvas arc",
    "inputs": {
      "arc": {
        "plug": {
          "0": {
            "unitId": "arc",
            "pinId": "arc"
          }
        },
        "type": "{x:number,y:number,r:number,start:number,end:number,anticlockwise?:boolean}",
        "metadata": {
          "examples": [
            "{x:100,y:100,r:60,start:0.78,end:2.35}",
            "{x:100,y:100,r:50,start:0,end:6.29}"
          ]
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "style"
          }
        }
      }
    },
    "outputs": {
      "canvas": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "_self"
          }
        },
        "ref": true,
        "type": "\`C\`&\`V\`&\`A\`"
      }
    },
    "units": {
      "arc": {
        "id": "790d5128-7fd6-48f9-b5cf-9edecedb1043",
        "input": {
          "arc": {
            "constant": false,
            "data": "{x:100,y:100,r:60,start:0.78,end:2.35}"
          },
          "d": {
            "constant": true,
            "data": "[]"
          }
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": -120,
            "y": 0
          }
        }
      },
      "canvas": {
        "id": "94243ec4-8967-4907-8cdd-7223fe256cf6",
        "input": {
          "d": {},
          "style": {}
        },
        "output": {}
      }
    },
    "merges": {
      "0": {
        "arc": {
          "output": {
            "d": true
          }
        },
        "canvas": {
          "input": {
            "d": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "canvas",
          "default"
        ]
      ],
      "subComponents": {
        "canvas": {
          "children": []
        }
      },
      "children": [
        "canvas"
      ],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "metadata": {
      "icon": "radius",
      "description": "canvas with an arc drawn",
      "tags": [
        "platform",
        "core",
        "component",
        "canvas"
      ]
    },
    "id": "01562c38-9973-43f4-982b-1dbdbea49c5b",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "09072f81-7c8e-4bce-80ad-6d9a821a2897": {
    "name": "white-space nowrap",
    "units": {
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {},
        "metadata": {
          "component": {
            "width": 120,
            "height": 210
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{'white-space':'nowrap',overflow:'auto'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "box": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "column flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "box",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "box": {
          "children": []
        }
      },
      "children": [
        "box"
      ]
    },
    "id": "09072f81-7c8e-4bce-80ad-6d9a821a2897",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "01791e01-bfeb-47d0-952a-8dd32a72d1fb": {
    "name": "vertical split",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "flexrow",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false,
        "type": "object",
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -490,
                "y": -343
              }
            }
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "ondragdelta",
            "pinId": "test",
            "kind": "output"
          },
          "1": {
            "unitId": "constant1",
            "pinId": "a",
            "kind": "input"
          },
          "2": {
            "unitId": "iffalse",
            "pinId": "a",
            "kind": "input"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -126,
                "y": -208
              }
            },
            "1": {
              "ext": {
                "x": 790,
                "y": -273
              }
            },
            "2": {
              "ext": {
                "x": 574,
                "y": -462
              }
            }
          }
        }
      },
      "left": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a + b",
            "kind": "output"
          },
          "1": {
            "unitId": "numbertodecimal",
            "pinId": "n",
            "kind": "input"
          },
          "2": {
            "unitId": "subtract",
            "pinId": "b",
            "kind": "input"
          },
          "3": {
            "unitId": "numbertodecimal0",
            "pinId": "n",
            "kind": "input"
          },
          "4": {
            "unitId": "if",
            "pinId": "a",
            "kind": "input"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 162,
                "y": -281
              }
            },
            "1": {
              "ext": {
                "x": -611,
                "y": -47
              }
            },
            "2": {
              "ext": {
                "x": -594,
                "y": 385
              }
            },
            "3": {
              "ext": {
                "x": -502,
                "y": 175
              }
            },
            "4": {
              "ext": {
                "x": 661,
                "y": -350
              }
            }
          }
        }
      }
    },
    "units": {
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -708,
                "y": 52
              }
            },
            "constant": false
          },
          "attr": {
            "metadata": {
              "position": {
                "x": -173,
                "y": -130
              }
            },
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 1,
            "y": -132
          },
          "component": {
            "width": 292,
            "height": 120
          }
        }
      },
      "box0": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {},
          "attr": {
            "metadata": {
              "position": {
                "x": -61,
                "y": 437
              }
            },
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 27,
            "y": 400
          }
        }
      },
      "box1": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {},
          "attr": {
            "metadata": {
              "position": {
                "x": -62,
                "y": 192
              }
            },
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 26,
            "y": 155
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "constant": false
          },
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "height": "100%",
                "background": "none",
                "position": "absolute",
                "background-size": "10px 10px"
              }
            },
            "metadata": {
              "position": {
                "x": -158,
                "y": 125
              },
              "data": {
                "position": {
                  "x": -197,
                  "y": 49
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -122,
            "y": 153
          }
        }
      },
      "tagwidth": {
        "id": "c13fec8e-a253-11eb-bbe5-6bbcbf28b3ef",
        "input": {
          "width": {}
        },
        "output": {
          "{width}": {}
        },
        "metadata": {
          "position": {
            "x": -226,
            "y": 173
          }
        }
      },
      "numbertodecimal": {
        "id": "a6ab9464-303a-48a4-8b5f-0cd515ab7b8f",
        "input": {
          "n": {
            "metadata": {
              "position": {
                "x": -588,
                "y": -47
              }
            }
          }
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": -540,
            "y": -47
          }
        }
      },
      "flexrow": {
        "id": "ad5a2fcc-fdee-11ea-a34f-77e9c48dbe57",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -498,
                "y": -321
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -661,
            "y": -290
          },
          "component": {
            "width": 265,
            "height": 191
          }
        }
      },
      "mergedefault0": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "height": "100%",
                "background": "",
                "right": "0",
                "position": "absolute"
              }
            },
            "metadata": {
              "position": {
                "x": -157,
                "y": 370
              },
              "data": {
                "position": {
                  "x": -193,
                  "y": 298
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -121,
            "y": 398
          }
        }
      },
      "divide": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a ÷ b": {}
        },
        "metadata": {
          "position": {
            "x": -274,
            "y": -257
          }
        }
      },
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "100",
            "metadata": {
              "position": {
                "x": -67,
                "y": -389
              },
              "data": {
                "position": {
                  "x": -54,
                  "y": -421
                }
              }
            }
          }
        },
        "output": {
          "a × b": {}
        },
        "metadata": {
          "position": {
            "x": -97,
            "y": -356
          }
        }
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {
            "constant": true,
            "data": "100",
            "metadata": {
              "position": {
                "x": -578,
                "y": 438
              },
              "data": {
                "position": {
                  "x": -608,
                  "y": 459
                }
              }
            }
          },
          "b": {
            "constant": false,
            "data": "100",
            "metadata": {
              "position": {
                "x": -578,
                "y": 402
              }
            }
          }
        },
        "output": {
          "a - b": {}
        },
        "metadata": {
          "position": {
            "x": -533,
            "y": 420
          }
        }
      },
      "tagwidth0": {
        "id": "c13fec8e-a253-11eb-bbe5-6bbcbf28b3ef",
        "input": {
          "width": {}
        },
        "output": {
          "{width}": {}
        },
        "metadata": {
          "position": {
            "x": -225,
            "y": 418
          }
        }
      },
      "percent": {
        "id": "72a186fe-a18b-44ca-b36b-c014ee44003a",
        "metadata": {
          "position": {
            "x": -438,
            "y": -47
          }
        }
      },
      "clamp": {
        "id": "9ef9ff5b-6a1c-444b-8fc0-bfebbec6f4fd",
        "input": {
          "max": {
            "constant": true,
            "data": "1",
            "metadata": {
              "position": {
                "x": -193,
                "y": -384
              },
              "data": {
                "position": {
                  "x": -188,
                  "y": -418
                }
              }
            }
          },
          "min": {
            "constant": true,
            "data": {
              "ref": [],
              "data": -1
            },
            "metadata": {
              "position": {
                "x": -254,
                "y": -359
              },
              "data": {
                "position": {
                  "x": -281,
                  "y": -376
                }
              }
            }
          },
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -207,
            "y": -342
          }
        }
      },
      "sizeobserver": {
        "id": "2f2d5ea4-6dd2-406e-a095-5552ebc235e7",
        "input": {
          "component": {},
          "opt": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": -503,
                "y": -218
              },
              "data": {
                "position": {
                  "x": -514,
                  "y": -234
                }
              }
            }
          },
          "done": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -447,
                "y": -287
              }
            }
          }
        },
        "output": {
          "width": {},
          "height": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -452,
                "y": -220
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -481,
            "y": -256
          }
        }
      },
      "numbertodecimal1": {
        "id": "a6ab9464-303a-48a4-8b5f-0cd515ab7b8f",
        "input": {
          "n": {}
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": -430,
            "y": 420
          }
        }
      },
      "percent0": {
        "id": "72a186fe-a18b-44ca-b36b-c014ee44003a",
        "metadata": {
          "position": {
            "x": -328,
            "y": 420
          }
        }
      },
      "constant": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -377,
            "y": -252
          }
        }
      },
      "mergedefault1": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "width": "1px",
                "background": "currentcolor",
                "cursor": "ew-resize",
                "position": "absolute",
                "zIndex": "1"
              }
            },
            "metadata": {
              "data": {
                "position": {
                  "x": -388,
                  "y": -146
                }
              },
              "position": {
                "x": -276,
                "y": -94
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -232,
            "y": -76
          }
        }
      },
      "tagleft": {
        "id": "3cbca5b0-2616-11eb-a3d8-7b83ecaf1822",
        "input": {
          "left": {}
        },
        "output": {
          "{left}": {}
        },
        "metadata": {
          "position": {
            "x": -335,
            "y": -49
          }
        }
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 50
            },
            "metadata": {
              "position": {
                "x": 290,
                "y": -400
              },
              "data": {
                "position": {
                  "x": 272,
                  "y": -429
                }
              }
            }
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 348,
                "y": -334
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 325,
            "y": -371
          }
        }
      },
      "constant0": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 222,
            "y": -351
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a + b": {
            "metadata": {
              "position": {
                "x": 155,
                "y": -304
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 118,
            "y": -332
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 430,
            "y": -370
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {},
          "d": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            },
            "metadata": {
              "position": {
                "x": 46,
                "y": -379
              },
              "data": {
                "position": {
                  "x": 62,
                  "y": -406
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 11,
            "y": -350
          }
        }
      },
      "memory": {
        "id": "49e11645-c25d-4bf7-923d-56817f67b686",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 515,
            "y": -313
          }
        }
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 653,
                "y": -327
              }
            }
          },
          "b": {}
        },
        "output": {
          "a if b": {}
        },
        "metadata": {
          "position": {
            "x": 617,
            "y": -299
          }
        }
      },
      "constant1": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 767,
                "y": -276
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 719,
            "y": -279
          }
        }
      },
      "ondragdelta": {
        "id": "ae5c6f18-9ff9-11eb-986e-6fd93ceb151c",
        "input": {
          "element": {}
        },
        "output": {
          "x": {},
          "y": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -241,
                "y": -181
              }
            }
          },
          "test": {
            "metadata": {
              "position": {
                "x": -148,
                "y": -201
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -192,
            "y": -189
          }
        }
      },
      "iffalse": {
        "id": "bbbe75ed-d436-47d7-a9a0-59bcfa41dfda",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 554,
                "y": -449
              }
            }
          }
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 507,
            "y": -435
          }
        }
      },
      "percent1": {
        "id": "72a186fe-a18b-44ca-b36b-c014ee44003a",
        "metadata": {
          "position": {
            "x": -329,
            "y": 175
          }
        }
      },
      "numbertodecimal0": {
        "id": "a6ab9464-303a-48a4-8b5f-0cd515ab7b8f",
        "input": {
          "n": {
            "metadata": {
              "position": {
                "x": -480,
                "y": 175
              }
            }
          }
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": -431,
            "y": 175
          }
        }
      }
    },
    "merges": {
      "0": {
        "ondragdelta": {
          "input": {
            "element": true
          }
        },
        "box": {
          "output": {
            "_self": true
          }
        }
      },
      "1": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "box1": {
          "input": {
            "style": true
          }
        }
      },
      "2": {
        "iterate": {
          "output": {
            "current": true
          }
        },
        "constant0": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "multiply": {
          "output": {
            "a × b": true
          }
        },
        "default": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "percent": {
          "input": {
            "a": true
          }
        },
        "numbertodecimal": {
          "output": {
            "str": true
          }
        }
      },
      "5": {
        "divide": {
          "input": {
            "a": true
          }
        },
        "ondragdelta": {
          "output": {
            "x": true
          }
        }
      },
      "6": {
        "percent": {
          "output": {
            "pa": true
          }
        },
        "tagleft": {
          "input": {
            "left": true
          }
        }
      },
      "7": {
        "mergedefault0": {
          "output": {
            "a": true
          }
        },
        "box0": {
          "input": {
            "style": true
          }
        }
      },
      "8": {
        "mergedefault0": {
          "input": {
            "a": true
          }
        },
        "tagwidth0": {
          "output": {
            "{width}": true
          }
        }
      },
      "9": {
        "divide": {
          "output": {
            "a ÷ b": true
          }
        },
        "clamp": {
          "input": {
            "a": true
          }
        }
      },
      "10": {
        "numbertodecimal1": {
          "input": {
            "n": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      },
      "12": {
        "multiply": {
          "input": {
            "a": true
          }
        },
        "clamp": {
          "output": {
            "a": true
          }
        }
      },
      "13": {
        "mergedefault": {
          "input": {
            "a": true
          }
        },
        "tagwidth": {
          "output": {
            "{width}": true
          }
        }
      },
      "14": {
        "iffalse": {
          "output": {
            "false": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "15": {
        "percent1": {
          "input": {
            "a": true
          }
        },
        "numbertodecimal0": {
          "output": {
            "str": true
          }
        }
      },
      "16": {
        "percent1": {
          "output": {
            "pa": true
          }
        },
        "tagwidth": {
          "input": {
            "width": true
          }
        }
      },
      "17": {
        "add": {
          "input": {
            "a": true
          }
        },
        "constant0": {
          "output": {
            "a": true
          }
        }
      },
      "18": {
        "default": {
          "output": {
            "a": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        }
      },
      "22": {
        "sizeobserver": {
          "input": {
            "component": true
          }
        },
        "flexrow": {
          "output": {
            "_self": true
          }
        }
      },
      "23": {
        "sizeobserver": {
          "output": {
            "width": true
          }
        },
        "constant": {
          "input": {
            "a": true
          }
        }
      },
      "24": {
        "percent0": {
          "input": {
            "a": true
          }
        },
        "numbertodecimal1": {
          "output": {
            "str": true
          }
        }
      },
      "25": {
        "percent0": {
          "output": {
            "pa": true
          }
        },
        "tagwidth0": {
          "input": {
            "width": true
          }
        }
      },
      "27": {
        "constant": {
          "output": {
            "a": true
          }
        },
        "divide": {
          "input": {
            "b": true
          }
        }
      },
      "28": {
        "mergedefault1": {
          "output": {
            "a": true
          }
        },
        "box": {
          "input": {
            "style": true
          }
        }
      },
      "29": {
        "tagleft": {
          "output": {
            "{left}": true
          }
        },
        "mergedefault1": {
          "input": {
            "a": true
          }
        }
      },
      "31": {
        "iterate": {
          "input": {
            "next": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      },
      "32": {
        "memory": {
          "output": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "a": true
          }
        }
      },
      "33": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "memory": {
          "input": {
            "a": true
          }
        }
      },
      "34": {
        "constant1": {
          "output": {
            "a": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "box1",
          "default"
        ],
        [
          "box0",
          "default"
        ]
      ],
      "subComponents": {
        "box": {
          "children": []
        },
        "box0": {
          "children": []
        },
        "box1": {
          "children": []
        },
        "flexrow": {
          "children": [
            "box1",
            "box",
            "box0"
          ]
        }
      },
      "children": [
        "flexrow"
      ],
      "defaultWidth": 240,
      "defaultHeight": 180
    },
    "metadata": {
      "icon": "square",
      "description": "adjustable vertically split container",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "1": {
            "x": -70,
            "y": 154
          },
          "2": {
            "x": 274,
            "y": -358
          },
          "3": {
            "x": -43,
            "y": -350
          },
          "4": {
            "x": -489,
            "y": -47
          },
          "5": {
            "x": -236,
            "y": -221
          },
          "6": {
            "x": -387,
            "y": -47
          },
          "7": {
            "x": -69,
            "y": 399
          },
          "8": {
            "x": -173,
            "y": 412
          },
          "9": {
            "x": -243,
            "y": -300
          },
          "10": {
            "x": -482,
            "y": 420
          },
          "12": {
            "x": -151,
            "y": -349
          },
          "13": {
            "x": -174,
            "y": 167
          },
          "14": {
            "x": 464,
            "y": -407
          },
          "15": {
            "x": -380,
            "y": 175
          },
          "16": {
            "x": -278,
            "y": 175
          },
          "17": {
            "x": 170,
            "y": -344
          },
          "18": {
            "x": 64,
            "y": -337
          },
          "20": {
            "x": -326,
            "y": -1
          },
          "23": {
            "x": -429,
            "y": -253
          },
          "24": {
            "x": -379,
            "y": 420
          },
          "25": {
            "x": -277,
            "y": 420
          },
          "26": {
            "x": 606,
            "y": 59
          },
          "27": {
            "x": -326,
            "y": -253
          },
          "28": {
            "x": -181,
            "y": -93
          },
          "29": {
            "x": -283,
            "y": -56
          },
          "31": {
            "x": 377,
            "y": -370
          },
          "32": {
            "x": 469,
            "y": -336
          },
          "33": {
            "x": 565,
            "y": -302
          },
          "34": {
            "x": 668,
            "y": -285
          }
        },
        "data": {
          "x": 674,
          "y": -382
        }
      }
    },
    "id": "01791e01-bfeb-47d0-952a-8dd32a72d1fb",
    "type": "\`U\`&\`G\`&\`C\`",
    "system": true
  },
  "dae754da-d773-41b9-bbc8-f72b83b6f03d": {
    "name": "toggle value",
    "units": {
      "getvalue": {
        "id": "d74f12c2-1868-11eb-8136-238c1b1a727f",
        "input": {
          "obj": {},
          "any": {}
        },
        "output": {
          "value": {}
        }
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d",
        "input": {
          "a": {}
        },
        "output": {
          "!a": {}
        }
      },
      "setvalue": {
        "id": "ad68ca8e-ff63-467d-a770-3e6a7490f7fb",
        "input": {
          "element": {},
          "value": {}
        },
        "output": {}
      }
    },
    "merges": {
      "0": {
        "not": {
          "input": {
            "a": true
          }
        },
        "getvalue": {
          "output": {
            "value": true
          }
        }
      },
      "1": {
        "setvalue": {
          "input": {
            "element": true
          }
        },
        "getvalue": {
          "input": {
            "obj": true
          }
        }
      },
      "2": {
        "setvalue": {
          "input": {
            "value": true
          }
        },
        "not": {
          "output": {
            "!a": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "ref": true
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "getvalue",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "toggle-left",
      "description": "toggle \`obj\` boolean property",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "dae754da-d773-41b9-bbc8-f72b83b6f03d",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": false,
    "system": true
  },
  "4ba86ad5-899b-4e8d-b5ce-3589dcfeaefd": {
    "name": "text span",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "span",
            "pinId": "style"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "span": {
        "id": "c711d540-9de3-437e-854a-b59491af3cf8",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 44,
            "y": -58
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -45,
            "y": 57
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "square",
      "description": "text inside a span",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "children": [
        "span"
      ],
      "subComponents": {
        "span": {
          "children": [
            "text"
          ]
        },
        "text": {
          "children": []
        }
      },
      "defaultWidth": 200,
      "defaultHeight": 90
    },
    "id": "4ba86ad5-899b-4e8d-b5ce-3589dcfeaefd",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "30995775-fa18-4474-813e-17186d3f20aa": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text select",
    "units": {
      "removeallchildren": {
        "id": "2c7507c4-02bc-11eb-88e5-8bc78086a76f",
        "input": {
          "any": {},
          "parent": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 8,
            "y": 80
          }
        }
      },
      "appendchild": {
        "id": "ee4715e6-f479-11ea-b231-bf95a7f38a99",
        "input": {
          "parent": {},
          "child": {}
        },
        "output": {
          "at": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -222,
                "y": 47
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -173,
            "y": 49
          }
        }
      },
      "setinput": {
        "id": "43b43afd-9e7d-44ba-aef7-6e9db4ed8744",
        "input": {
          "unit": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -277,
                "y": -218
              },
              "data": {
                "position": {
                  "x": -251,
                  "y": -253
                }
              }
            }
          },
          "name": {
            "constant": true,
            "data": "\\"text\\"",
            "metadata": {
              "position": {
                "x": -157,
                "y": -43
              },
              "data": {
                "position": {
                  "x": -200,
                  "y": -57
                }
              }
            }
          },
          "data": {}
        },
        "output": {
          "unit": {}
        },
        "metadata": {
          "position": {
            "x": -106,
            "y": -33
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "a": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -36,
                "y": 2
              }
            }
          },
          "i": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 58,
                "y": -32
              }
            }
          },
          "test": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 43,
                "y": -57
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 6,
            "y": -22
          }
        }
      },
      "select": {
        "id": "6c7cd7d1-c8a0-4317-9c8c-ba781f150729",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": -36,
                "y": 137
              }
            }
          },
          "style": {
            "metadata": {
              "position": {
                "x": -255,
                "y": 111
              }
            }
          }
        },
        "output": {
          "value": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -6,
                "y": 128
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -130,
            "y": 105
          }
        }
      },
      "setinput0": {
        "id": "43b43afd-9e7d-44ba-aef7-6e9db4ed8744",
        "input": {
          "unit": {
            "constant": true,
            "data": "\${unit:{id:\\"8543c796-caee-4e35-bffb-0065532afdf9\\"}}",
            "metadata": {
              "position": {
                "x": 15,
                "y": -106
              },
              "data": {
                "position": {
                  "x": 52,
                  "y": -129
                }
              }
            }
          },
          "name": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "value"
            },
            "metadata": {
              "position": {
                "x": -63,
                "y": -125
              },
              "data": {
                "position": {
                  "x": -82,
                  "y": -156
                }
              }
            }
          },
          "data": {}
        },
        "output": {
          "unit": {}
        },
        "metadata": {
          "position": {
            "x": -32,
            "y": -89
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 258,
                "y": -10
              }
            }
          },
          "d": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 209,
            "y": 5
          }
        }
      },
      "emptyarray0": {
        "id": "b226083c-2797-11eb-a546-c350370e09cb",
        "input": {
          "any": {}
        },
        "output": {
          "[]": {}
        },
        "metadata": {
          "position": {
            "x": 197,
            "y": 62
          }
        }
      },
      "plan3": {
        "id": "0c78466f-f682-4aca-9a15-d4d2eac5e26d",
        "input": {
          "a": {}
        },
        "output": {
          "0": {},
          "1": {},
          "2": {}
        },
        "metadata": {
          "position": {
            "x": 102,
            "y": 28
          }
        }
      }
    },
    "merges": {
      "0": {
        "setinput0": {
          "input": {
            "data": true
          }
        },
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "setinput": {
          "input": {
            "data": true
          }
        }
      },
      "1": {
        "appendchild": {
          "input": {
            "child": true
          }
        },
        "setinput": {
          "output": {
            "unit": true
          }
        }
      },
      "2": {
        "removeallchildren": {
          "input": {
            "parent": true
          }
        },
        "appendchild": {
          "input": {
            "parent": true
          }
        },
        "select": {
          "output": {
            "_self": true
          }
        }
      },
      "3": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "plan3": {
          "output": {
            "1": true
          }
        }
      },
      "4": {
        "removeallchildren": {
          "input": {
            "any": true
          }
        },
        "plan3": {
          "output": {
            "0": true
          }
        }
      },
      "5": {
        "default": {
          "output": {
            "a": true
          }
        },
        "plan3": {
          "input": {
            "a": true
          }
        }
      },
      "6": {
        "setinput": {
          "input": {
            "unit": true
          }
        },
        "setinput0": {
          "output": {
            "unit": true
          }
        }
      },
      "7": {
        "emptyarray0": {
          "input": {
            "any": true
          }
        },
        "plan3": {
          "output": {
            "2": true
          }
        }
      },
      "8": {
        "emptyarray0": {
          "output": {
            "[]": true
          }
        },
        "default": {
          "input": {
            "d": true
          }
        }
      }
    },
    "inputs": {
      "list": {
        "plug": {
          "1": {
            "unitId": "default",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "examples": [
            "['banana','apple','orange']"
          ],
          "position": {
            "0": {
              "ext": {
                "x": -187,
                "y": 181
              }
            },
            "1": {
              "ext": {
                "x": 277,
                "y": -24
              }
            },
            "2": {
              "ext": {
                "x": -25,
                "y": 144
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "select",
            "pinId": "value"
          }
        },
        "ref": false,
        "metadata": {
          "examples": [
            "'banana'",
            "'apple'",
            "'orange'"
          ],
          "position": {
            "0": {
              "ext": {
                "x": -45,
                "y": 159
              }
            },
            "1": {
              "ext": {
                "x": -463,
                "y": 174
              }
            }
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "select",
            "pinId": "style"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -277,
                "y": 116
              }
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "select",
            "pinId": "value",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 7,
                "y": 148
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "select with text options",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -48,
            "y": -42
          },
          "1": {
            "x": -141,
            "y": 9
          },
          "3": {
            "x": 56,
            "y": -1
          },
          "4": {
            "x": 58,
            "y": 58
          },
          "5": {
            "x": 154,
            "y": 10
          },
          "6": {
            "x": -79,
            "y": -71
          },
          "7": {
            "x": 146,
            "y": 54
          },
          "8": {
            "x": 241,
            "y": 41
          }
        },
        "data": {
          "x": 19,
          "y": 97
        }
      }
    },
    "render": true,
    "component": {
      "subComponents": {
        "select": {
          "children": [],
          "childSlot": {}
        }
      },
      "children": [
        "select"
      ],
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "id": "30995775-fa18-4474-813e-17186d3f20aa",
    "system": true
  },
  "2e596b5f-f4b6-44fe-8ad0-6e17d12fa104": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text paragraph",
    "units": {
      "text0": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 104,
            "y": 50
          }
        }
      },
      "paragraph": {
        "id": "2a5ad480-9d38-4918-8774-41fac7b54203",
        "input": {
          "style": {},
          "attr": {
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -105,
            "y": -51
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text0",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "paragraph",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "type",
      "description": "text paragraph",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "text0": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        },
        "paragraph": {
          "children": [
            "text0"
          ],
          "childSlot": {},
          "width": 120,
          "height": 120
        }
      },
      "children": [
        "paragraph"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "id": "2e596b5f-f4b6-44fe-8ad0-6e17d12fa104",
    "system": true
  },
  "8543c796-caee-4e35-bffb-0065532afdf9": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text option",
    "units": {
      "option": {
        "id": "c0d13c03-9b10-4a6f-a79f-66294d10aae6",
        "input": {
          "value": {},
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 26,
            "y": 56
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -27,
            "y": -57
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "option",
            "pinId": "value"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "option",
            "pinId": "style"
          }
        },
        "ref": false
      },
      "text": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "text option",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "option": {
          "children": [
            "text"
          ],
          "childSlot": {}
        },
        "text": {
          "children": [],
          "childSlot": {}
        }
      },
      "children": [
        "option"
      ],
      "defaultWidth": 180,
      "defaultHeight": 90
    },
    "id": "8543c796-caee-4e35-bffb-0065532afdf9",
    "system": true
  },
  "b27a5ddd-f78a-4356-bb24-c16b137107fa": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text label",
    "units": {
      "label": {
        "id": "23b7df22-79e0-4233-8388-7e6e8f1859c6",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -155,
                "y": -66
              }
            }
          },
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -154,
                "y": -95
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -47,
            "y": -66
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": -92,
                "y": 54
              }
            }
          }
        },
        "output": {
          "value": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 155,
                "y": 54
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 32,
            "y": 54
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "style": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "label",
            "kind": "input",
            "pinId": "style"
          }
        }
      },
      "value": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "text",
            "kind": "input",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": null,
      "description": "",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "slots": [],
      "defaultWidth": 152,
      "defaultHeight": 47,
      "subComponents": {
        "label": {
          "children": [
            "text"
          ],
          "childSlot": {
            "text": "default"
          }
        },
        "text": {}
      },
      "children": [
        "label"
      ]
    },
    "id": "b27a5ddd-f78a-4356-bb24-c16b137107fa",
    "system": true
  },
  "49b314c0-a1ad-4004-ab63-875359b8ff0e": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text header 3",
    "units": {
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092"
      },
      "header3": {
        "id": "b7f043ee-4f9d-4f69-90fe-63b1357ff4c2",
        "input": {
          "style": {},
          "attr": {
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -105,
            "y": -51
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "header3",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "type",
      "description": "text header3",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "text": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        },
        "header3": {
          "children": [
            "text"
          ],
          "childSlot": {},
          "width": 120,
          "height": 120
        }
      },
      "children": [
        "header3"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "id": "49b314c0-a1ad-4004-ab63-875359b8ff0e",
    "system": true
  },
  "783e349b-769e-4d88-ab39-b4750c1f5d21": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text header 2",
    "units": {
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092"
      },
      "header2": {
        "id": "321f971c-b898-4ca4-9e6e-3d75d68940f7"
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value",
            "kind": "input"
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "header2",
            "pinId": "style",
            "kind": "input"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "type",
      "description": "text header2",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "text": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        },
        "header2": {
          "children": [
            "text"
          ],
          "childSlot": {},
          "width": 120,
          "height": 120
        }
      },
      "children": [
        "header2"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "id": "783e349b-769e-4d88-ab39-b4750c1f5d21",
    "system": true
  },
  "e82b5eac-b3d0-4e6a-adb6-a8411c0c2db2": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text header 1",
    "units": {
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 104,
            "y": 50
          }
        }
      },
      "header1": {
        "id": "dd7616e2-2e64-4d9c-b13e-ca7efeacd982"
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "header1",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "type",
      "description": "text header1",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "text": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        },
        "header1": {
          "children": [
            "text"
          ],
          "childSlot": {},
          "width": 120,
          "height": 120
        }
      },
      "children": [
        "header1"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "id": "e82b5eac-b3d0-4e6a-adb6-a8411c0c2db2",
    "system": true
  },
  "b12c858a-26ea-42a7-a435-0ee50ac34fbf": {
    "name": "text fit",
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "fit-content",
            "pinId": "style"
          }
        }
      }
    },
    "outputs": {
      "fit-content": {
        "plug": {
          "0": {
            "unitId": "fit-content",
            "pinId": "_self"
          }
        },
        "defaultIgnored": true,
        "ref": true,
        "component": true
      }
    },
    "units": {
      "fit-content": {
        "id": "4d0092bf-0e68-49e5-8fe1-6b0c79da571c",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 232.120361328125,
            "height": 187.77685546875
          },
          "position": {
            "x": -21,
            "y": -94
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 20,
            "y": 93
          }
        }
      }
    },
    "merges": {},
    "component": {
      "subComponents": {
        "fit-content": {
          "children": [
            "text"
          ]
        },
        "text": {
          "children": []
        }
      },
      "children": [
        "fit-content"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "metadata": {
      "icon": "square",
      "description": "text box fit content",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "b12c858a-26ea-42a7-a435-0ee50ac34fbf",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "93080c02-3f34-4ebe-8671-624737907c0e": {
    "name": "text div",
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "div",
            "pinId": "attr"
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "div",
            "pinId": "style"
          }
        }
      }
    },
    "outputs": {
      "div": {
        "plug": {
          "0": {
            "unitId": "div",
            "pinId": "_self"
          }
        },
        "defaultIgnored": true,
        "ref": true,
        "component": true
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      }
    },
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 232.120361328125,
            "height": 187.77685546875
          },
          "position": {
            "x": -21,
            "y": -94
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {
          "value": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 20,
            "y": 93
          }
        }
      }
    },
    "merges": {},
    "component": {
      "subComponents": {
        "div": {
          "children": [
            "text"
          ]
        },
        "text": {
          "children": []
        }
      },
      "children": [
        "div"
      ],
      "defaultWidth": 240,
      "defaultHeight": 180
    },
    "metadata": {
      "description": "text inside a div",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "93080c02-3f34-4ebe-8671-624737907c0e",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "e5c811c0-aee9-4609-b31d-70bd4bacab14": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text details",
    "units": {
      "summary": {
        "id": "58bfcb06-b41d-4205-91f5-c00aff3e209c",
        "input": {
          "style": {
            "ignored": false,
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "fontWeight": "bold"
              }
            }
          },
          "attr": {
            "ignored": true
          }
        },
        "output": {}
      },
      "text0": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {}
      },
      "details": {
        "id": "0ea7279e-9ca2-48ab-8d70-f5333a717dc4",
        "input": {
          "style": {},
          "attr": {}
        },
        "output": {}
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {
            "constant": false
          }
        },
        "output": {}
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {},
          "d": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "Title"
            }
          }
        },
        "output": {
          "a": {}
        }
      },
      "default0": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {},
          "d": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "Text"
            }
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "default": {
          "output": {
            "a": true
          }
        },
        "text": {
          "input": {
            "value": true
          }
        }
      },
      "1": {
        "default0": {
          "output": {
            "a": true
          }
        },
        "text0": {
          "input": {
            "value": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "details",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "details",
            "pinId": "attr",
            "kind": "input"
          }
        },
        "ref": false
      },
      "title": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false
      },
      "text": {
        "plug": {
          "0": {
            "unitId": "default0",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "text \`details\` + text \`summary\`",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "subComponents": {
        "summary": {
          "children": [
            "text"
          ],
          "childSlot": {},
          "width": 120,
          "height": 120
        },
        "text0": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        },
        "details": {
          "children": [
            "summary",
            "text0"
          ],
          "childSlot": {},
          "width": 147,
          "height": 149.21875
        },
        "text": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        }
      },
      "children": [
        "details"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "id": "e5c811c0-aee9-4609-b31d-70bd4bacab14",
    "render": true,
    "system": true
  },
  "1dbbadab-bdbc-4dea-ba6d-442a3c7f33ed": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "text button",
    "units": {
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {}
      },
      "button": {
        "id": "b61f5cc6-37e9-45e1-965b-02940820f7ce",
        "input": {
          "style": {}
        },
        "output": {}
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "button",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "text button",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "text": {
          "children": [],
          "childSlot": {},
          "width": 180,
          "height": 90
        },
        "button": {
          "children": [
            "text"
          ],
          "childSlot": {},
          "width": 120,
          "height": 120
        }
      },
      "children": [
        "button"
      ],
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "id": "1dbbadab-bdbc-4dea-ba6d-442a3c7f33ed",
    "system": true
  },
  "9988a56e-6bee-46c8-864c-e351d84bc7e2": {
    "name": "text box",
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "attr"
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "style"
          }
        }
      }
    },
    "outputs": {
      "div": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "_self"
          }
        },
        "defaultIgnored": true,
        "ref": true,
        "component": true
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "text",
            "pinId": "value"
          }
        }
      }
    },
    "units": {
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 232.120361328125,
            "height": 187.77685546875
          },
          "position": {
            "x": -21,
            "y": -94
          }
        }
      },
      "text": {
        "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
        "input": {
          "value": {}
        },
        "output": {
          "value": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 20,
            "y": 93
          }
        }
      }
    },
    "merges": {},
    "component": {
      "subComponents": {
        "box": {
          "children": [
            "text"
          ]
        },
        "text": {
          "children": []
        }
      },
      "children": [
        "box"
      ],
      "defaultWidth": 240,
      "defaultHeight": 180
    },
    "metadata": {
      "description": "text inside a box",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "360c691a-ac2d-11eb-95ec-b3053bd928da": {
    "name": "text area to speech",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "textarea",
            "pinId": "style"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -331,
              "y": -10
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "textarea",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -331,
              "y": 74
            }
          }
        }
      },
      "voice": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 249,
              "y": -53
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "texttospeech": {
        "id": "6db29a62-2035-4cfc-a9d3-03444a8bc2b8",
        "input": {
          "message": {},
          "voice": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 200,
                "y": -33
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 76,
            "y": -10
          }
        }
      },
      "onenterkeydown": {
        "id": "de45f6d0-7504-4061-b4ab-5d1ee902a0cb",
        "input": {
          "element": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -44,
            "y": 62
          }
        }
      },
      "textarea": {
        "id": "83ec6688-b80b-4ef2-861f-14245ef392c0",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": -315,
                "y": 51
              }
            }
          },
          "style": {
            "metadata": {
              "position": {
                "x": -315,
                "y": 13
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -182,
            "y": 32
          }
        }
      },
      "getvalue": {
        "id": "d74f12c2-1868-11eb-8136-238c1b1a727f",
        "input": {
          "obj": {},
          "any": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -32,
            "y": 13
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 228,
                "y": -35
              }
            }
          },
          "d": {
            "constant": true,
            "data": "1",
            "metadata": {
              "position": {
                "x": 228,
                "y": 1
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 183,
            "y": -16
          }
        }
      }
    },
    "merges": {
      "0": {
        "onenterkeydown": {
          "input": {
            "element": true
          }
        },
        "textarea": {
          "output": {
            "_self": true
          }
        },
        "getvalue": {
          "input": {
            "obj": true
          }
        }
      },
      "1": {
        "onenterkeydown": {
          "output": {
            "a": true
          }
        },
        "getvalue": {
          "input": {
            "any": true
          }
        }
      },
      "2": {
        "texttospeech": {
          "input": {
            "message": true
          }
        },
        "getvalue": {
          "output": {
            "value": true
          }
        }
      },
      "3": {
        "default": {
          "output": {
            "a": true
          }
        },
        "texttospeech": {
          "input": {
            "voice": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "textarea": {
          "children": []
        }
      },
      "children": [
        "textarea"
      ],
      "defaultWidth": 200,
      "defaultHeight": 150
    },
    "metadata": {
      "icon": "align-left",
      "description": "speak text on enter",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "1": {
            "x": 0,
            "y": 47
          },
          "2": {
            "x": 22,
            "y": -2
          },
          "3": {
            "x": 130,
            "y": -14
          }
        }
      }
    },
    "id": "360c691a-ac2d-11eb-95ec-b3053bd928da",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "6253bf76-2e85-11eb-9f59-3703abfd39c7": {
    "name": "switch",
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "checkbox",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 133,
              "y": 44,
              "ext": {
                "x": 122,
                "y": 95
              }
            }
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault0",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 263,
              "y": -101,
              "ext": {
                "x": 232,
                "y": -55
              }
            }
          }
        }
      },
      "offColor": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -33,
              "y": -182,
              "ext": {
                "x": -46,
                "y": -129
              }
            }
          }
        }
      },
      "onColor": {
        "plug": {
          "0": {
            "unitId": "default0",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -187,
              "y": -86,
              "ext": {
                "x": -199,
                "y": -32
              }
            }
          }
        }
      },
      "sliderStyle": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "x": -196,
              "y": 183,
              "ext": {
                "x": -205,
                "y": 237
              }
            }
          }
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "div",
            "pinId": "attr",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 282,
                "y": -82
              }
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 17,
              "y": 25,
              "ext": {
                "x": 7,
                "y": 78
              }
            }
          }
        }
      }
    },
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {},
          "attr": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 278,
                "y": -59
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 348,
            "y": -19
          },
          "component": {
            "width": 100,
            "height": 50
          }
        }
      },
      "div0": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {},
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -394,
                "y": 178
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 100,
            "height": 50
          },
          "position": {
            "x": -311,
            "y": 178
          }
        }
      },
      "mergedefault0": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 237,
                "y": -32
              }
            }
          },
          "default": {
            "constant": false,
            "data": "{position:'relative',display:'flex',flexDirection:'row',padding:'4px',gap:'4px',backgroundColor:'#1f1f1f',cursor:'pointer',boxSizing:'border-box'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 202,
            "y": -5
          }
        }
      },
      "invert": {
        "id": "f55ab180-3fd5-44c4-915f-f40e6bbcc481",
        "input": {
          "a": {},
          "c": {},
          "b": {}
        },
        "output": {
          "b": {},
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -23,
            "y": 26
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -40,
                "y": -106
              }
            }
          },
          "d": {
            "constant": true,
            "data": "\\"#1f1f1f\\"",
            "metadata": {
              "position": {
                "x": 42,
                "y": -104
              },
              "data": {
                "position": {
                  "x": 70,
                  "y": -129
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": -79
          }
        }
      },
      "default0": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -175,
                "y": -29
              }
            }
          },
          "d": {
            "constant": true,
            "data": "\\"#d1d1d1\\"",
            "metadata": {
              "position": {
                "x": -163,
                "y": -61
              },
              "data": {
                "position": {
                  "x": -188,
                  "y": -90
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -124,
            "y": -31
          }
        }
      },
      "setbackgroundcolor0": {
        "id": "0ca54c4f-148e-49e5-bedf-d24276200f66",
        "input": {
          "obj": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "position": "relative",
                "display": "flex",
                "flexDirection": "row",
                "padding": "4px",
                "gap": "4px",
                "backgroundColor": "#00aa11",
                "cursor": "pointer",
                "boxSizing": "border-box",
                "height": "100%"
              }
            },
            "metadata": {
              "position": {
                "x": 126,
                "y": -35
              },
              "data": {
                "position": {
                  "x": 151,
                  "y": -162
                }
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 91,
            "y": -5
          }
        }
      },
      "setbackgroundcolor": {
        "id": "0ca54c4f-148e-49e5-bedf-d24276200f66",
        "input": {
          "obj": {
            "constant": true,
            "data": "{position:\\"absolute\\",top:\\"3px\\",left:\\"0\\",width:\\"calc(50% - 6px)\\",height:\\"calc(100% - 6px)\\",backgroundColor:\\"#ff6666\\",cursor:\\"pointer\\",boxSizing:\\"border-box\\"}",
            "metadata": {
              "position": {
                "x": -176,
                "y": 62
              },
              "data": {
                "position": {
                  "x": -302,
                  "y": 50
                }
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -125,
            "y": 65
          }
        }
      },
      "pickset": {
        "id": "9a85acf3-c40b-4e82-b04c-68c3dd1b0d4b",
        "input": {
          "b": {
            "constant": true,
            "data": "\\"3px\\"",
            "metadata": {
              "position": {
                "x": -9,
                "y": 152
              },
              "data": {
                "position": {
                  "x": 17,
                  "y": 179
                }
              }
            }
          },
          "a": {
            "constant": true,
            "data": "\\"calc(50% + 3px)\\"",
            "metadata": {
              "position": {
                "x": -32,
                "y": 180
              },
              "data": {
                "position": {
                  "x": -14,
                  "y": 214
                }
              }
            }
          },
          "key": {
            "constant": true,
            "data": "\\"left\\"",
            "metadata": {
              "position": {
                "x": -76,
                "y": 181
              },
              "data": {
                "position": {
                  "x": -81,
                  "y": 217
                }
              }
            }
          },
          "obj": {},
          "test": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": 139
          }
        }
      },
      "checkbox": {
        "id": "096fc4ca-edd2-11ea-8266-37b634a3ee0b",
        "input": {
          "value": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 98,
                "y": 98
              }
            }
          },
          "attr": {
            "ignored": false,
            "data": "{tabindex:-1}",
            "metadata": {
              "position": {
                "x": 103,
                "y": 125
              },
              "data": {
                "position": {
                  "x": 158,
                  "y": 143
                }
              }
            },
            "constant": true
          },
          "style": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "opacity": "0",
                "cursor": "pointer"
              }
            },
            "metadata": {
              "position": {
                "x": 90,
                "y": 153
              },
              "data": {
                "position": {
                  "x": 140,
                  "y": 206
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": 114
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -203,
                "y": 214
              }
            }
          },
          "default": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -169,
            "y": 181
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div0": {
          "input": {
            "style": true
          }
        }
      },
      "1": {
        "mergedefault": {
          "input": {
            "default": true
          }
        },
        "pickset": {
          "output": {
            "obj": true
          }
        }
      },
      "2": {
        "pickset": {
          "input": {
            "test": true
          }
        },
        "invert": {
          "input": {
            "c": true
          }
        },
        "checkbox": {
          "output": {
            "value": true
          }
        }
      },
      "3": {
        "mergedefault0": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      },
      "4": {
        "default": {
          "output": {
            "a": true
          }
        },
        "invert": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "default0": {
          "output": {
            "a": true
          }
        },
        "invert": {
          "input": {
            "b": true
          }
        }
      },
      "6": {
        "setbackgroundcolor": {
          "input": {
            "value": true
          }
        },
        "invert": {
          "output": {
            "b": true
          }
        }
      },
      "7": {
        "setbackgroundcolor0": {
          "input": {
            "value": true
          }
        },
        "invert": {
          "output": {
            "a": true
          }
        }
      },
      "8": {
        "mergedefault0": {
          "input": {
            "default": true
          }
        },
        "setbackgroundcolor0": {
          "output": {
            "obj": true
          }
        }
      },
      "9": {
        "setbackgroundcolor": {
          "output": {
            "obj": true
          }
        },
        "pickset": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "div": {
          "children": [
            "div0",
            "checkbox"
          ],
          "childSlot": {
            "div0": "default",
            "checkbox": "default"
          }
        },
        "div0": {
          "children": []
        },
        "checkbox": {
          "children": []
        }
      },
      "children": [
        "div"
      ],
      "defaultWidth": 100,
      "defaultHeight": 50
    },
    "metadata": {
      "icon": "toggle-right",
      "description": "select between \\"on\\" or \\"off\\"",
      "position": {
        "merge": {
          "0": {
            "x": -224,
            "y": 179
          },
          "1": {
            "x": -114,
            "y": 162
          },
          "2": {
            "x": -12,
            "y": 91
          },
          "3": {
            "x": 259,
            "y": -3
          },
          "4": {
            "x": -13,
            "y": -28
          },
          "5": {
            "x": -73,
            "y": -6
          },
          "6": {
            "x": -75,
            "y": 44
          },
          "7": {
            "x": 35,
            "y": 10
          },
          "8": {
            "x": 147,
            "y": -3
          },
          "9": {
            "x": -95,
            "y": 104
          }
        },
        "data": {
          "x": 39,
          "y": 57
        }
      },
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "6253bf76-2e85-11eb-9f59-3703abfd39c7",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "58f72eed-f3d6-4972-9d13-b1bebdd98e61": {
    "name": "stack box",
    "inputs": {},
    "outputs": {},
    "units": {
      "wrap": {
        "id": "454aaff2-cd74-4f6e-baf2-631bb32e7a6b",
        "input": {
          "component": {
            "constant": true,
            "data": "\${unit:{id:'dc546440-13ca-4ebf-8831-c28138c7efc6'}}"
          }
        },
        "output": {
          "parent": {}
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": -114
          }
        }
      },
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {
            "constant": true,
            "data": "{whiteSpace:\\"nowrap\\",width:\\"100%\\"}"
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -51,
            "y": 113
          }
        }
      }
    },
    "merges": {},
    "component": {
      "slots": [
        [
          "wrap",
          "default"
        ]
      ],
      "subComponents": {
        "wrap": {
          "children": []
        },
        "div": {
          "children": [
            "wrap"
          ]
        }
      },
      "children": [
        "div"
      ],
      "defaultWidth": 180,
      "defaultHeight": 300
    },
    "metadata": {
      "icon": "square",
      "description": "horizontal scroll container",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "58f72eed-f3d6-4972-9d13-b1bebdd98e61",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "063ee2df-eeb6-4cd9-8516-9201e6e282ca": {
    "name": "slider 360 rad",
    "inputs": {},
    "outputs": {
      "rad": {
        "plug": {
          "0": {
            "unitId": "degtorad",
            "pinId": "rad"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 73,
              "y": -1
            }
          }
        }
      }
    },
    "units": {
      "slider360": {
        "id": "6bdd7a40-e465-42ae-8219-b428d7d57aea",
        "input": {},
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -147,
            "y": 0
          }
        }
      },
      "degtorad": {
        "id": "3a138358-cc25-45e3-a0ce-bbe54445736f",
        "input": {
          "angle": {}
        },
        "output": {
          "rad": {
            "metadata": {
              "position": {
                "x": 47,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -2,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "hgtjcyd": {
        "degtorad": {
          "input": {
            "angle": true
          }
        },
        "slider360": {
          "output": {
            "value": true
          }
        }
      }
    },
    "metadata": {
      "icon": "sliders",
      "description": "360 rad slider current value",
      "position": {
        "merge": {
          "hgtjcyd": {
            "x": -52,
            "y": 0
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "063ee2df-eeb6-4cd9-8516-9201e6e282ca",
    "component": {
      "subComponents": {
        "slider360": {
          "children": []
        }
      },
      "children": [
        "slider360"
      ],
      "defaultWidth": 120,
      "defaultHeight": 30
    },
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "6bdd7a40-e465-42ae-8219-b428d7d57aea": {
    "name": "slider 360",
    "inputs": {},
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "slider",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 90,
              "y": -19
            }
          }
        }
      },
      "slider": {
        "plug": {
          "0": {
            "unitId": "slider",
            "pinId": "_self"
          }
        },
        "ref": true,
        "type": "\`C\`&\`V\`",
        "defaultIgnored": true
      }
    },
    "units": {
      "slider": {
        "id": "e06518cf-9edf-430b-8751-74c486e407aa",
        "input": {
          "min": {
            "ignored": false,
            "constant": true,
            "data": "0",
            "metadata": {
              "position": {
                "x": -127,
                "y": 7
              }
            }
          },
          "style": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 31,
                "y": -20
              }
            }
          },
          "value": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -114,
                "y": -18
              }
            }
          },
          "max": {
            "ignored": false,
            "constant": true,
            "data": "360",
            "metadata": {
              "position": {
                "x": 60,
                "y": 26
              }
            }
          }
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 60,
                "y": -12
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -33,
            "y": 7
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "sliders",
      "description": "360 slider current value",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "6bdd7a40-e465-42ae-8219-b428d7d57aea",
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 30,
      "subComponents": {
        "slider": {
          "children": []
        }
      },
      "children": [
        "slider"
      ]
    },
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "cef90fb7-bfcb-4f9d-8828-df6e68278601": {
    "name": "scroll snap y box",
    "units": {
      "white-spacenowrap": {
        "id": "09072f81-7c8e-4bce-80ad-6d9a821a2897",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 251,
            "y": -124
          }
        }
      },
      "inheritdisplayinline-block": {
        "id": "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 86,
            "y": 194
          }
        }
      },
      "inheritscroll-snapy": {
        "id": "5867c5b6-24f2-4bd7-90b3-4e44615bc42c",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -93,
            "y": -179
          }
        }
      },
      "inheritscroll-snap-alignstart": {
        "id": "b62c0058-9183-435f-baae-c51a3ee1855b",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -247,
            "y": 107
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "white-spacenowrap",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false
      }
    },
    "outputs": {},
    "component": {
      "slots": [
        [
          "inheritscroll-snap-alignstart",
          "default"
        ]
      ],
      "children": [
        "inheritscroll-snapy"
      ],
      "subComponents": {
        "white-spacenowrap": {
          "children": [
            "inheritdisplayinline-block"
          ]
        },
        "inheritdisplayinline-block": {
          "children": [
            "inheritscroll-snap-alignstart"
          ]
        },
        "inheritscroll-snapy": {
          "children": [
            "white-spacenowrap"
          ]
        },
        "inheritscroll-snap-alignstart": {
          "children": []
        }
      },
      "metadata": {
        "icon": "square",
        "description": "container with y scroll snap",
        "complexity": 109
      },
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "id": "cef90fb7-bfcb-4f9d-8828-df6e68278601",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "metadata": {
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "system": true
  },
  "44a75416-9cc9-4889-b4c5-ad9b661a8cdf": {
    "name": "scroll snap x box",
    "units": {
      "white-spacenowrap": {
        "id": "09072f81-7c8e-4bce-80ad-6d9a821a2897",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 251,
            "y": -124
          }
        }
      },
      "inheritdisplayinline-block": {
        "id": "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 86,
            "y": 194
          }
        }
      },
      "inheritscroll-snapx": {
        "id": "0b5d4999-21ce-48da-907d-2891514c451d",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -93,
            "y": -179
          }
        }
      },
      "inheritscroll-snap-alignstart": {
        "id": "b62c0058-9183-435f-baae-c51a3ee1855b",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -247,
            "y": 107
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "white-spacenowrap",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false
      }
    },
    "outputs": {},
    "component": {
      "slots": [
        [
          "inheritscroll-snap-alignstart",
          "default"
        ]
      ],
      "children": [
        "inheritscroll-snapx"
      ],
      "subComponents": {
        "white-spacenowrap": {
          "children": [
            "inheritdisplayinline-block"
          ]
        },
        "inheritdisplayinline-block": {
          "children": [
            "inheritscroll-snap-alignstart"
          ]
        },
        "inheritscroll-snapx": {
          "children": [
            "white-spacenowrap"
          ]
        },
        "inheritscroll-snap-alignstart": {
          "children": []
        }
      },
      "metadata": {
        "icon": "square",
        "description": "container with y scroll snap",
        "complexity": 109
      },
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "id": "44a75416-9cc9-4889-b4c5-ad9b661a8cdf",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "metadata": {
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "system": true
  },
  "b792e421-1c0b-40fc-ac33-87c5c2bbac2a": {
    "name": "scroll snap align start",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "metadata": {
          "position": {
            "x": 73,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"scroll-snap-align\\":'start'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -74,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ],
      "defaultWidth": 300,
      "defaultHeight": 420
    },
    "metadata": {
      "icon": "square",
      "description": "container with set scroll snap align start",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "b792e421-1c0b-40fc-ac33-87c5c2bbac2a",
    "system": true
  },
  "9aba266d-5200-4281-b477-749c9b3c5815": {
    "name": "root",
    "inputs": {
      "disabled": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "disabled"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -208,
              "y": 27,
              "ext": {
                "x": -393,
                "y": 75
              }
            }
          }
        },
        "defaultIgnored": true
      },
      "fullwindow": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "fullwindow"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -234,
              "y": -81,
              "ext": {
                "x": -384,
                "y": -14
              }
            }
          }
        },
        "defaultIgnored": true
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "style"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -250,
              "y": -35,
              "ext": {
                "x": -394,
                "y": 34
              }
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "graph",
            "pinId": "graph"
          }
        },
        "type": "\`G\`",
        "metadata": {
          "position": {
            "0": {
              "x": -310,
              "y": 67,
              "ext": {
                "x": -512,
                "y": 171
              }
            }
          }
        }
      },
      "config": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "config",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -372,
                "y": 199
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "value"
          }
        },
        "defaultIgnored": true
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "d"
          }
        },
        "defaultIgnored": true
      }
    },
    "outputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "graph"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 140,
                "y": 40
              }
            }
          }
        }
      },
      "state": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "state"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 140,
                "y": 139
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "io",
            "pinId": "value"
          }
        },
        "defaultIgnored": true
      }
    },
    "units": {
      "io": {
        "id": "6f267de2-b02c-11ea-b55c-db553f4c6c45",
        "input": {
          "disabled": {
            "data": "false",
            "metadata": {
              "position": {
                "x": -372,
                "y": 83
              }
            },
            "ignored": false
          },
          "style": {
            "metadata": {
              "position": {
                "x": -373,
                "y": 45
              }
            }
          },
          "graph": {},
          "fullwindow": {
            "metadata": {
              "position": {
                "x": -373,
                "y": 7
              }
            },
            "ignored": false
          },
          "frame": {
            "metadata": {
              "position": {
                "x": 109,
                "y": 89
              }
            },
            "ignored": true
          },
          "d": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -370,
                "y": 207
              }
            }
          },
          "config": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -370,
                "y": 176
              }
            }
          },
          "value": {
            "ignored": false
          }
        },
        "output": {
          "graph": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 117,
                "y": 58
              }
            }
          },
          "state": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 117,
                "y": 120
              }
            }
          },
          "value": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -132,
            "y": 89
          }
        }
      },
      "graph": {
        "id": "324b9c5e-5810-11eb-bf7c-634b3bb07f8c",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": -494,
                "y": 155
              }
            }
          },
          "done": {
            "metadata": {
              "position": {
                "x": -497,
                "y": 121
              }
            }
          }
        },
        "output": {
          "graph": {
            "metadata": {
              "position": {
                "x": -390,
                "y": 129
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -450,
            "y": 135
          }
        }
      },
      "guikeyboard": {
        "id": "96d5d60e-85eb-11eb-ba90-7fc42ab0a641",
        "input": {},
        "output": {},
        "metadata": {
          "position": {
            "x": 411,
            "y": -179
          }
        }
      }
    },
    "merges": {
      "0": {
        "io": {
          "input": {
            "graph": true
          }
        },
        "graph": {
          "output": {
            "graph": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "io",
          "default"
        ]
      ],
      "subComponents": {
        "io": {
          "children": [
            "guikeyboard"
          ],
          "childSlot": {
            "guikeyboard": "2"
          }
        },
        "guikeyboard": {
          "children": []
        }
      },
      "children": [
        "io"
      ],
      "defaultWidth": 420,
      "defaultHeight": 360
    },
    "metadata": {
      "icon": "chalkboard",
      "description": "io + cloud",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "9aba266d-5200-4281-b477-749c9b3c5815",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "f27cae4e-fea8-11ea-b91e-db41e114c426": {
    "name": "random color box",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -2,
              "y": 55
            }
          },
          "examples": [
            "{}",
            "{opacity:\\"0.5\\"}",
            "{width:'100px',height:'100px'}"
          ]
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "box",
            "pinId": "attr",
            "kind": "input"
          }
        },
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "units": {
      "randombgcolortag": {
        "id": "051d4600-42e5-403b-b12e-eb58ae78ef0b",
        "input": {
          "any": {
            "constant": true,
            "data": "null",
            "metadata": {
              "position": {
                "x": 42,
                "y": 8
              }
            }
          }
        },
        "output": {
          "{bc}": {}
        },
        "metadata": {
          "position": {
            "x": 16,
            "y": 16
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 156,
                "y": 58
              }
            }
          },
          "default": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 119,
            "y": 39
          }
        }
      },
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {},
          "attr": {
            "metadata": {
              "position": {
                "x": 259,
                "y": 89
              }
            },
            "ignored": false
          }
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 138,
            "height": 128
          },
          "position": {
            "x": 333,
            "y": 114
          }
        }
      }
    },
    "merges": {
      "0": {
        "randombgcolortag": {
          "output": {
            "{bc}": true
          }
        },
        "mergedefault": {
          "input": {
            "default": true
          }
        }
      },
      "1": {
        "box": {
          "input": {
            "style": true
          }
        },
        "mergedefault": {
          "output": {
            "a": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "box",
          "default"
        ]
      ],
      "subComponents": {
        "box": {}
      },
      "children": [
        "box"
      ],
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "metadata": {
      "icon": "square",
      "description": "box with a random background color",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -9,
            "y": -15
          },
          "1": {
            "x": 94,
            "y": 2
          }
        }
      }
    },
    "id": "f27cae4e-fea8-11ea-b91e-db41e114c426",
    "type": "\`U\`&\`C\`&\`G\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "5f162826-e925-408f-8eb2-7984ef14c420": {
    "name": "random color 100px",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "randomcolorbox": {
        "id": "f27cae4e-fea8-11ea-b91e-db41e114c426",
        "input": {
          "style": {},
          "attr": {
            "ignored": true
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 73,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{width:\\"100px\\",height:'100px'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -74,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "randomcolorbox": {
          "input": {
            "style": true
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "100px div with random background color",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "5f162826-e925-408f-8eb2-7984ef14c420",
    "component": {
      "slots": [
        [
          "randomcolorbox",
          "default"
        ]
      ],
      "subComponents": {
        "randomcolorbox": {
          "children": []
        }
      },
      "children": [
        "randomcolorbox"
      ],
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "3a56b714-36d3-4a0a-b641-001db6f774e8": {
    "name": "mirror",
    "units": {
      "defaultvideo": {
        "id": "68ee3bf2-7d57-4828-92ac-1070e988ffe7",
        "input": {
          "style": {},
          "controls": {
            "ignored": false,
            "constant": true,
            "data": "false"
          },
          "opt": {
            "constant": true,
            "data": "{audio:false}"
          }
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 260.117431640625,
            "height": 194.74407958984375
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{transform:'scaleX(-1)'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "defaultvideo": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "video": {
        "plug": {
          "0": {
            "unitId": "defaultvideo",
            "pinId": "video"
          }
        },
        "ref": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "video",
      "description": "default user media",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "defaultvideo",
          "default"
        ]
      ],
      "subComponents": {
        "defaultvideo": {
          "children": []
        }
      },
      "children": [
        "defaultvideo"
      ],
      "defaultWidth": 260,
      "defaultHeight": 195
    },
    "id": "3a56b714-36d3-4a0a-b641-001db6f774e8",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "0d9605e4-f4f2-4141-a7f0-1f090c88230f": {
    "name": "min max slider",
    "inputs": {
      "max": {
        "plug": {
          "0": {
            "unitId": "max",
            "pinId": "value"
          },
          "1": {
            "mergeId": "6"
          },
          "2": {
            "mergeId": "7"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -364,
              "y": -6
            },
            "1": {
              "x": -120,
              "y": 62
            },
            "2": {
              "x": -138,
              "y": -133
            }
          }
        }
      },
      "min": {
        "plug": {
          "0": {
            "mergeId": "8"
          },
          "lmxgapmoa": {
            "unitId": "min",
            "pinId": "value"
          },
          "ehxxshptb": {
            "mergeId": "9"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 176,
              "y": -115
            },
            "lmxgapmoa": {
              "x": 384,
              "y": -9
            },
            "ehxxshptb": {
              "x": 118,
              "y": 86
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "slider",
            "pinId": "value"
          },
          "iwqrfsvcw": {
            "unitId": "numberinput",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 35,
              "y": -176
            },
            "iwqrfsvcw": {
              "x": -37,
              "y": 122
            }
          }
        }
      }
    },
    "outputs": {
      "slider": {
        "plug": {
          "0": {
            "unitId": "slider",
            "pinId": "_self"
          }
        },
        "ref": true,
        "defaultIgnored": true
      }
    },
    "units": {
      "numberinput": {
        "id": "9bc56564-ef4e-11ea-939a-27ae3feb321e",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": -45,
                "y": 91
              }
            }
          },
          "style": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -80,
                "y": 84
              }
            }
          },
          "min": {
            "ignored": false
          },
          "max": {
            "ignored": false
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 7,
            "y": 47
          }
        }
      },
      "slider": {
        "id": "e06518cf-9edf-430b-8751-74c486e407aa",
        "input": {
          "style": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 79,
                "y": -135
              }
            }
          },
          "value": {
            "metadata": {
              "position": {
                "x": 44,
                "y": -146
              }
            }
          },
          "min": {
            "ignored": false
          },
          "max": {
            "ignored": false
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 14,
            "y": -105
          }
        }
      },
      "oninput": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 91,
            "y": 6
          }
        }
      },
      "setvalue": {
        "id": "ad68ca8e-ff63-467d-a770-3e6a7490f7fb",
        "input": {
          "element": {},
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 122,
            "y": -81
          }
        }
      },
      "oninput0": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -100,
            "y": -81
          }
        }
      },
      "setvalue0": {
        "id": "ad68ca8e-ff63-467d-a770-3e6a7490f7fb",
        "input": {
          "element": {},
          "value": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -59,
            "y": 1
          }
        }
      },
      "max": {
        "id": "9bc56564-ef4e-11ea-939a-27ae3feb321e",
        "input": {
          "value": {
            "data": "100",
            "metadata": {
              "position": {
                "x": -335,
                "y": -21
              }
            }
          },
          "style": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -294,
                "y": -65
              }
            }
          },
          "min": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -298,
                "y": 20
              }
            }
          },
          "max": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -340,
                "y": -46
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -240,
            "y": -22
          }
        }
      },
      "oninput1": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -182,
            "y": -77
          }
        }
      },
      "min": {
        "id": "9bc56564-ef4e-11ea-939a-27ae3feb321e",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": 353,
                "y": -1
              }
            }
          },
          "style": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 338,
                "y": -41
              }
            }
          },
          "min": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 297,
                "y": 44
              }
            }
          },
          "max": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 355,
                "y": 28
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 120,
            "height": 45
          },
          "position": {
            "x": 258,
            "y": -2
          }
        }
      },
      "oninput2": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 166,
            "y": 42
          }
        }
      },
      "row": {
        "id": "ad5a2fcc-fdee-11ea-a34f-77e9c48dbe57",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -117,
                "y": 192
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -256,
            "y": 192
          }
        }
      },
      "column": {
        "id": "67a6fb5a-feab-11ea-8bd1-a3c19e76592a",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 145,
                "y": 226
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 238,
            "y": 226
          }
        }
      },
      "oninput3": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -152,
            "y": 23
          }
        }
      },
      "oninput4": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 206,
            "y": -59
          }
        }
      }
    },
    "merges": {
      "0": {
        "oninput": {
          "input": {
            "element": true
          }
        },
        "numberinput": {
          "output": {
            "_self": true
          }
        },
        "setvalue0": {
          "input": {
            "element": true
          }
        }
      },
      "1": {
        "setvalue": {
          "input": {
            "element": true
          }
        },
        "slider": {
          "output": {
            "_self": true
          }
        },
        "oninput0": {
          "input": {
            "element": true
          }
        }
      },
      "2": {
        "setvalue0": {
          "input": {
            "value": true
          }
        },
        "oninput0": {
          "output": {
            "event": true
          }
        }
      },
      "3": {
        "max": {
          "output": {
            "_self": true
          }
        },
        "oninput1": {
          "input": {
            "element": true
          }
        },
        "oninput3": {
          "input": {
            "element": true
          }
        }
      },
      "4": {
        "oninput2": {
          "input": {
            "element": true
          }
        },
        "min": {
          "output": {
            "_self": true
          }
        },
        "oninput4": {
          "input": {
            "element": true
          }
        }
      },
      "5": {
        "setvalue": {
          "input": {
            "value": true
          }
        },
        "oninput": {
          "output": {
            "event": true
          }
        }
      },
      "6": {
        "numberinput": {
          "input": {
            "max": true
          }
        },
        "oninput3": {
          "output": {
            "event": true
          }
        }
      },
      "7": {
        "oninput1": {
          "output": {
            "event": true
          }
        },
        "slider": {
          "input": {
            "max": true
          }
        }
      },
      "8": {
        "oninput4": {
          "output": {
            "event": true
          }
        },
        "slider": {
          "input": {
            "min": true
          }
        }
      },
      "9": {
        "oninput2": {
          "output": {
            "event": true
          }
        },
        "numberinput": {
          "input": {
            "min": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "numberinput": {
          "children": []
        },
        "slider": {
          "children": []
        },
        "max": {
          "children": []
        },
        "min": {
          "children": [],
          "width": 120,
          "height": 45
        },
        "row": {
          "children": [
            "min",
            "numberinput",
            "max"
          ]
        },
        "column": {
          "children": [
            "slider",
            "row"
          ],
          "width": 278,
          "height": 85
        }
      },
      "children": [
        "column"
      ],
      "defaultWidth": 210,
      "defaultHeight": 120
    },
    "metadata": {
      "icon": "sliders",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "description": "slider + fields for adjusting min max",
      "position": {
        "merge": {
          "2": {
            "x": -73,
            "y": -44
          },
          "5": {
            "x": 114,
            "y": -36
          },
          "6": {
            "x": -98,
            "y": 42
          },
          "7": {
            "x": -132,
            "y": -101
          },
          "8": {
            "x": 160,
            "y": -89
          },
          "9": {
            "x": 111,
            "y": 56
          }
        }
      }
    },
    "id": "0d9605e4-f4f2-4141-a7f0-1f090c88230f",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "ff4144c4-052a-4bc4-93a8-08876b66f0c0": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "microphone",
    "units": {
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "constant": false,
            "ignored": false,
            "metadata": {
              "position": {
                "x": -224,
                "y": 37
              }
            }
          },
          "default": {
            "constant": false,
            "ignored": false,
            "data": "{\\"cursor\\":\\"pointer\\",\\"color\\":\\"currentcolor\\"}"
          }
        },
        "output": {
          "a": {
            "constant": false,
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -173,
            "y": 39
          }
        }
      },
      "mergedefault0": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "constant": false,
            "ignored": false,
            "data": "{\\"color\\":\\"currentcolor\\"}"
          },
          "default": {
            "constant": true,
            "ignored": false,
            "data": "{\\"cursor\\":\\"pointer\\"}",
            "metadata": {
              "position": {
                "x": -142,
                "y": 139
              }
            }
          }
        },
        "output": {
          "a": {
            "constant": false,
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -101,
            "y": 112
          }
        }
      },
      "icon": {
        "id": "63a417e5-d354-4b39-9ebd-05f55e70de7b",
        "input": {
          "style": {
            "ignored": false,
            "constant": false
          },
          "icon": {
            "ignored": false,
            "constant": true,
            "data": "\\"mic\\"",
            "metadata": {
              "position": {
                "x": -124,
                "y": -41
              }
            }
          },
          "attr": {
            "ignored": true,
            "constant": false,
            "metadata": {
              "position": {
                "x": -109,
                "y": -65
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -70,
            "y": -17
          }
        }
      },
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {
          "a": {
            "constant": true,
            "ignored": false,
            "data": "{\\"color\\":\\"#de5d54\\"}",
            "metadata": {
              "position": {
                "x": 55,
                "y": 96
              }
            }
          },
          "b": {
            "constant": true,
            "ignored": false,
            "data": "{\\"color\\":\\"currentcolor\\"}",
            "metadata": {
              "position": {
                "x": 35,
                "y": 127
              }
            }
          },
          "c": {
            "constant": false,
            "ignored": false,
            "data": "false"
          }
        },
        "output": {
          "a": {
            "constant": false,
            "ignored": false,
            "data": "{\\"color\\":\\"currentcolor\\"}"
          }
        },
        "metadata": {
          "position": {
            "x": 4,
            "y": 91
          }
        }
      },
      "speechtotext": {
        "id": "416550cc-6e02-4ff2-aafa-2f0edbf121c6",
        "input": {
          "opt": {
            "ignored": false,
            "constant": false
          },
          "stop": {
            "ignored": false,
            "constant": false
          },
          "done": {
            "ignored": true,
            "constant": false,
            "metadata": {
              "position": {
                "x": 82,
                "y": -107
              }
            }
          },
          "start": {}
        },
        "output": {
          "text": {
            "ignored": false,
            "constant": false,
            "metadata": {
              "position": {
                "x": 124,
                "y": -106
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 102,
            "y": -66
          }
        }
      },
      "pressed0": {
        "id": "f1cde29c-2da3-410e-b4c7-737650475933",
        "input": {
          "element": {},
          "next": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -28,
                "y": -43
              }
            }
          }
        },
        "output": {
          "current": {},
          "up": {
            "ignored": false
          },
          "down": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 12,
            "y": -20
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {
            "metadata": {
              "position": {
                "x": 163,
                "y": 26
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 118,
            "y": 6
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {
            "metadata": {
              "position": {
                "x": -28,
                "y": -133
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 15,
            "y": -109
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 265,
                "y": -67
              }
            }
          },
          "d": {
            "constant": true,
            "data": "{}",
            "metadata": {
              "position": {
                "x": 261,
                "y": -100
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 216,
            "y": -81
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "icon": {
          "input": {
            "style": true
          }
        }
      },
      "1": {
        "icon": {
          "output": {
            "_self": true
          }
        },
        "pressed0": {
          "input": {
            "element": true
          }
        }
      },
      "2": {
        "mergedefault0": {
          "output": {
            "a": true
          }
        },
        "mergedefault": {
          "input": {
            "default": true
          }
        }
      },
      "3": {
        "pressed0": {
          "output": {
            "current": true
          }
        },
        "pick": {
          "input": {
            "c": true
          }
        }
      },
      "4": {
        "pick": {
          "output": {
            "a": true
          }
        },
        "mergedefault0": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "pressed0": {
          "output": {
            "down": true
          }
        },
        "true": {
          "input": {
            "any": true
          }
        },
        "speechtotext": {
          "input": {
            "start": true
          }
        }
      },
      "6": {
        "default": {
          "output": {
            "a": true
          }
        },
        "speechtotext": {
          "input": {
            "opt": true
          }
        }
      },
      "7": {
        "speechtotext": {
          "input": {
            "stop": true
          }
        },
        "pressed0": {
          "output": {
            "up": true
          }
        },
        "false": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -248,
                "y": 35
              }
            }
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 285,
                "y": -55
              }
            }
          }
        }
      },
      "start": {
        "plug": {
          "0": {
            "mergeId": "5"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 73,
                "y": 0
              }
            }
          }
        }
      },
      "stop": {
        "plug": {
          "0": {
            "mergeId": "7"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 52,
                "y": -88
              }
            }
          }
        }
      }
    },
    "outputs": {
      "text": {
        "plug": {
          "0": {
            "unitId": "speechtotext",
            "pinId": "text",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 126,
                "y": -130
              }
            }
          }
        }
      },
      "recording": {
        "plug": {
          "0": {
            "unitId": "true",
            "pinId": "true",
            "kind": "output"
          },
          "1": {
            "unitId": "false",
            "pinId": "false",
            "kind": "output"
          },
          "2": {
            "unitId": "pressed0",
            "pinId": "next",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 177,
                "y": 46
              }
            },
            "1": {
              "ext": {
                "x": -36,
                "y": -155
              }
            },
            "2": {
              "ext": {
                "x": -39,
                "y": -64
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "mic",
      "description": "icon button for microphone recording",
      "position": {
        "merge": {
          "0": {
            "x": -130,
            "y": 8
          },
          "2": {
            "x": -142,
            "y": 80
          },
          "3": {
            "x": 9,
            "y": 36
          },
          "4": {
            "x": -47,
            "y": 107
          },
          "5": {
            "x": 71,
            "y": -23
          },
          "6": {
            "x": 160,
            "y": -74
          },
          "7": {
            "x": 45,
            "y": -66
          },
          "8": {
            "x": 111,
            "y": -85
          },
          "9": {
            "x": 95,
            "y": -76
          },
          "10": {
            "x": -1,
            "y": -42
          },
          "12": {
            "x": 209,
            "y": 50
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "render": true,
    "component": {
      "subComponents": {
        "icon": {
          "children": []
        }
      },
      "children": [
        "icon"
      ]
    },
    "id": "ff4144c4-052a-4bc4-93a8-08876b66f0c0",
    "system": true
  },
  "8aee8e9f-a132-46de-a0c7-17f8035b1898": {
    "name": "logo",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "svg",
            "pinId": "style"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -143,
              "y": 216
            }
          }
        }
      },
      "pathStyle": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 1,
              "y": -26
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "svgpath": {
        "id": "60bc7930-8982-11ea-8b24-cf97a783bb32",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 99,
                "y": -107
              }
            }
          },
          "d": {
            "constant": true,
            "data": "'M2,36.00000000000001 A6,6,1,1,0,2,35.99900000000001z M2,36.00000000000001 A6,6,1,1,0,2,35.99900000000001zM14,36.00000000000001 L24,36.00000000000001M24,36 A24,24,1,1,0,24,35.999z M24,36 A24,24,1,1,0,24,35.999zM82,36 A6,6,1,1,0,82,35.999zM82,36 L72,36'",
            "metadata": {
              "position": {
                "x": 124,
                "y": -127
              }
            }
          },
          "fillRule": {
            "ignored": false,
            "constant": true,
            "data": "'evenodd'",
            "metadata": {
              "position": {
                "x": 125,
                "y": -163
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 255,
            "y": -121
          }
        }
      },
      "svg": {
        "id": "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
        "input": {
          "style": {
            "data": "{userSelect:'none'}",
            "metadata": {
              "position": {
                "x": -123,
                "y": 198
              }
            }
          },
          "viewBox": {
            "ignored": false,
            "constant": true,
            "data": "'0 0 96 72'",
            "metadata": {
              "position": {
                "x": -123,
                "y": 160
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 10,
            "y": 179
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 20,
                "y": -47
              }
            }
          },
          "default": {
            "constant": true,
            "data": "{fill:'currentColor'}",
            "metadata": {
              "position": {
                "x": 14,
                "y": -81
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 63,
            "y": -70
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "svgpath": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "svgpath": {
          "children": []
        },
        "svg": {
          "children": [
            "svgpath"
          ],
          "width": 285,
          "height": 268
        }
      },
      "children": [
        "svg"
      ],
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "metadata": {
      "icon": "square",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "description": "Unit logo in SVG",
      "position": {
        "merge": {
          "0": {
            "x": 117,
            "y": -84
          }
        }
      }
    },
    "id": "8aee8e9f-a132-46de-a0c7-17f8035b1898",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "e1b6acd3-69cd-4edb-8e3e-6c78ffd28b49": {
    "name": "local root",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "root",
            "pinId": "style",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 23,
                "y": 210
              }
            }
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "root",
            "pinId": "d",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "units": {
      "root": {
        "id": "9aba266d-5200-4281-b477-749c9b3c5815",
        "input": {
          "disabled": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 22,
                "y": 216
              }
            }
          },
          "fullwindow": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 22,
                "y": 1
              }
            }
          },
          "style": {
            "metadata": {
              "position": {
                "x": 23,
                "y": 186
              }
            }
          },
          "graph": {}
        },
        "output": {
          "graph": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 6,
                "y": 52
              }
            }
          },
          "state": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 12,
                "y": -62
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 258,
            "y": 76
          }
        }
      },
      "localstorage": {
        "id": "c8f3faa8-09f4-11eb-a3b1-477aa3ec4193",
        "input": {},
        "output": {},
        "metadata": {
          "position": {
            "x": -241,
            "y": -227
          }
        }
      },
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {},
          "name": {
            "constant": true,
            "data": "\\"bundle\\"",
            "metadata": {
              "position": {
                "x": -146,
                "y": -251
              },
              "data": {
                "position": {
                  "x": -123,
                  "y": -279
                }
              }
            }
          },
          "data": {}
        },
        "output": {
          "data": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -135,
                "y": -230
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -183,
            "y": -225
          }
        }
      },
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {
            "constant": false
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -245,
            "y": 200
          }
        }
      },
      "localstorage0": {
        "id": "c8f3faa8-09f4-11eb-a3b1-477aa3ec4193",
        "input": {},
        "output": {},
        "metadata": {
          "position": {
            "x": -290,
            "y": 233
          }
        }
      },
      "spark": {
        "id": "3be8272d-310a-4aa2-84a1-71f590a8227a",
        "input": {
          "a": {
            "constant": true,
            "data": "\\"bundle\\"",
            "metadata": {
              "position": {
                "x": -397,
                "y": 174
              },
              "data": {
                "position": {
                  "x": -445,
                  "y": 170
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -348,
            "y": 177
          }
        }
      },
      "swallow": {
        "id": "ecb16ee2-d81f-4f3f-a241-b007087f5055",
        "input": {
          "unit": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -203,
            "y": 167
          }
        }
      },
      "stringify": {
        "id": "2b24877a-3221-4288-9f59-efbf29964368",
        "input": {
          "a": {}
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": -91,
            "y": -177
          }
        }
      },
      "parse": {
        "id": "69323dab-b425-4a2a-b1c7-d7efc723327a",
        "input": {
          "str": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -137,
            "y": 206
          }
        }
      },
      "frombundle": {
        "id": "de2d42e2-4fca-4a3f-8783-3585c546e88b",
        "input": {
          "bundle": {}
        },
        "output": {
          "graph": {}
        },
        "metadata": {
          "position": {
            "x": -36,
            "y": 177
          }
        }
      },
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "emitter": {},
          "event": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "edit"
            },
            "metadata": {
              "position": {
                "x": -89,
                "y": 73
              },
              "data": {
                "position": {
                  "x": -116,
                  "y": 96
                }
              }
            }
          },
          "remove": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -16,
                "y": 25
              }
            }
          }
        },
        "output": {
          "data": {}
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": 49
          }
        }
      },
      "debounce": {
        "id": "e55c58b3-8653-4481-b5c9-2a75fce6365a",
        "input": {
          "ms": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 1000
            },
            "metadata": {
              "position": {
                "x": -206,
                "y": 29
              },
              "data": {
                "position": {
                  "x": -244,
                  "y": 35
                }
              }
            }
          },
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -156,
            "y": 21
          }
        }
      },
      "get0": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -38,
            "y": -94
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "bundle"
            },
            "metadata": {
              "position": {
                "x": -192,
                "y": -72
              },
              "data": {
                "position": {
                  "x": -241,
                  "y": -81
                }
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -142,
            "y": -65
          }
        }
      }
    },
    "merges": {
      "0": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "localstorage": {
          "output": {
            "obj": true
          }
        }
      },
      "1": {
        "set": {
          "input": {
            "data": true
          }
        },
        "stringify": {
          "output": {
            "str": true
          }
        }
      },
      "2": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "localstorage0": {
          "output": {
            "obj": true
          }
        }
      },
      "3": {
        "parse": {
          "input": {
            "str": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      },
      "4": {
        "root": {
          "output": {
            "graph": true
          }
        },
        "listen": {
          "input": {
            "emitter": true
          }
        }
      },
      "5": {
        "spark": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      },
      "6": {
        "swallow": {
          "input": {
            "unit": true
          }
        },
        "get": {
          "output": {
            "_self": true
          }
        }
      },
      "7": {
        "get0": {
          "output": {
            "value": true
          }
        },
        "stringify": {
          "input": {
            "a": true
          }
        }
      },
      "8": {
        "debounce": {
          "input": {
            "a": true
          }
        },
        "listen": {
          "output": {
            "data": true
          }
        }
      },
      "9": {
        "frombundle": {
          "input": {
            "bundle": true
          }
        },
        "parse": {
          "output": {
            "a": true
          }
        }
      },
      "10": {
        "frombundle": {
          "output": {
            "graph": true
          }
        },
        "root": {
          "input": {
            "graph": true
          }
        }
      },
      "11": {
        "debounce": {
          "output": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "12": {
        "get0": {
          "input": {
            "obj": true
          }
        },
        "root": {
          "output": {
            "state": true
          }
        }
      },
      "13": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "get0": {
          "input": {
            "name": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "subComponents": {
        "root": {
          "children": []
        }
      },
      "children": [
        "root"
      ],
      "defaultWidth": 420,
      "defaultHeight": 420
    },
    "metadata": {
      "icon": "square",
      "description": "root app local auto-save",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "1": {
            "x": -136,
            "y": -202
          },
          "3": {
            "x": -190,
            "y": 209
          },
          "5": {
            "x": -297,
            "y": 185
          },
          "7": {
            "x": -55,
            "y": -141
          },
          "8": {
            "x": -104,
            "y": 36
          },
          "9": {
            "x": -85,
            "y": 195
          },
          "10": {
            "x": 11,
            "y": 151
          },
          "11": {
            "x": -170,
            "y": -25
          },
          "13": {
            "x": -90,
            "y": -80
          }
        }
      }
    },
    "id": "e1b6acd3-69cd-4edb-8e3e-6c78ffd28b49",
    "type": "\`U\`&\`C\`&\`G\`",
    "system": true
  },
  "b434223f-7f7a-4f03-83ab-744e16990206": {
    "name": "inline-block div",
    "type": "\`U\`&\`G\`&\`C\`",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {
            "constant": false
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 73,
            "y": -9
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:\\"inline-block\\",verticalAlign:\\"bottom\\"}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -74,
            "y": 8
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ],
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "metadata": {
      "icon": "square",
      "description": "div with inline-block display",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "b434223f-7f7a-4f03-83ab-744e16990206",
    "render": true,
    "system": true
  },
  "5867c5b6-24f2-4bd7-90b3-4e44615bc42c": {
    "name": "inherit scroll-snap y",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"scroll-snap-type\\":'y mandatory',\\"scroll-snap-stop\\":\\"always\\"}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with scroll-snap y",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "5867c5b6-24f2-4bd7-90b3-4e44615bc42c",
    "system": true
  },
  "0b5d4999-21ce-48da-907d-2891514c451d": {
    "name": "inherit scroll-snap x",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"scroll-snap-type\\":'x mandatory',\\"scroll-snap-stop\\":\\"always\\"}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with scroll-snap x",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "0b5d4999-21ce-48da-907d-2891514c451d",
    "system": true
  },
  "b62c0058-9183-435f-baae-c51a3ee1855b": {
    "name": "inherit scroll-snap-align start",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"scroll-snap-align\\":'start'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with scroll-snap-align start",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "b62c0058-9183-435f-baae-c51a3ee1855b",
    "system": true
  },
  "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b": {
    "name": "inherit display inline-block",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "inherit": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 103,
            "y": -1
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{\\"display\\":'inline-block',\\"vertical-align\\":\\"bottom\\"}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "inherit": {
          "input": {
            "style": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "slots": [
        [
          "inherit",
          "default"
        ]
      ],
      "subComponents": {
        "inherit": {
          "children": []
        }
      },
      "children": [
        "inherit"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "metadata": {
      "icon": "square",
      "description": "style children with display inline block",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "e16f9ac0-29c3-4ae7-a2e7-2aa6b98bcc1b",
    "system": true
  },
  "6f267de2-b02c-11ea-b55c-db553f4c6c45": {
    "name": "io",
    "units": {
      "app": {
        "id": "4181691b-4790-4191-9b03-86c6c968d1b8",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 22,
                "y": -192
              }
            }
          },
          "disabled": {
            "metadata": {
              "position": {
                "x": 23,
                "y": -227
              }
            }
          },
          "graph": {
            "metadata": {
              "position": {
                "x": 24,
                "y": -257
              }
            }
          },
          "fullwindow": {
            "metadata": {
              "position": {
                "x": 22,
                "y": -287
              }
            }
          },
          "frame": {
            "metadata": {
              "position": {
                "x": 21,
                "y": -351
              }
            }
          },
          "config": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -462,
                "y": -261
              }
            }
          },
          "value": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -462,
                "y": -315
              }
            }
          }
        },
        "output": {
          "graph": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 28,
                "y": -389
              }
            }
          },
          "state": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 34,
                "y": -318
              }
            }
          },
          "value": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 20,
                "y": -164
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -219,
            "y": -288
          }
        },
        "value": {
          "ignored": false
        }
      },
      "propifhaskey": {
        "id": "8c4f4d5e-2c98-4dfb-aeac-d1e6605a673e",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "color"
            },
            "metadata": {
              "position": {
                "x": 147,
                "y": 53
              },
              "data": {
                "position": {
                  "x": -12,
                  "y": 95
                }
              }
            }
          },
          "obj": {
            "metadata": {
              "position": {
                "x": 147,
                "y": 17
              }
            }
          }
        },
        "output": {
          "value": {},
          "has": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 212,
                "y": -4
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 192,
            "y": 35
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "opacity": "0.1",
                "position": "relative",
                "width": "240px",
                "top": "50%",
                "left": "50%",
                "transform": "translate(-50%,-50%)"
              }
            },
            "metadata": {
              "position": {
                "x": 364,
                "y": -15
              },
              "data": {
                "position": {
                  "x": 207,
                  "y": -88
                }
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 401,
            "y": 13
          }
        }
      },
      "tagcolor": {
        "id": "dfba14dd-bd14-4fd2-bbfa-c910eadd9f7d",
        "input": {
          "color": {}
        },
        "output": {
          "{color}": {}
        },
        "metadata": {
          "position": {
            "x": 296,
            "y": 33
          }
        }
      },
      "path": {
        "id": "60bc7930-8982-11ea-8b24-cf97a783bb32",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 270,
                "y": 252
              },
              "data": {
                "position": {
                  "x": 113,
                  "y": 250
                }
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": {
                "fill": "currentColor",
                "strokeWidth": "3px"
              }
            }
          },
          "d": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -14.890598290598291,
                "y": -99.99145299145297
              }
            }
          },
          "fillRule": {
            "ignored": false,
            "constant": true,
            "data": {
              "ref": [],
              "data": "evenodd"
            },
            "metadata": {
              "position": {
                "x": 269,
                "y": 289
              },
              "data": {
                "position": {
                  "x": 94,
                  "y": 293
                }
              }
            }
          },
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 270,
                "y": 311
              }
            }
          }
        },
        "output": {
          "d": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 279,
                "y": 374
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 401,
            "y": 297
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {
            "constant": false,
            "metadata": {
              "data": {
                "position": {
                  "x": 140,
                  "y": 454
                }
              },
              "position": {
                "x": 249,
                "y": 403
              }
            }
          },
          "d": {
            "metadata": {
              "position": {
                "x": 169,
                "y": 372
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": "M2,36.00000000000001 A6,6,1,1,0,2,35.99900000000001z M2,36.00000000000001 A6,6,1,1,0,2,35.99900000000001zM14,36.00000000000001 L24,36.00000000000001M24,36 A24,24,1,1,0,24,35.999z M24,36 A24,24,1,1,0,24,35.999zM82,36 A6,6,1,1,0,82,35.999zM82,36 L72,36"
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 218,
            "y": 370
          }
        }
      },
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "metadata": {
          "component": {
            "width": 197,
            "height": 202
          },
          "position": {
            "x": 587,
            "y": 15
          }
        },
        "input": {
          "attr": {
            "metadata": {
              "position": {
                "x": 460,
                "y": -27
              }
            },
            "ignored": true
          },
          "style": {}
        }
      }
    },
    "merges": {
      "1": {
        "default": {
          "output": {
            "a": true
          }
        },
        "path": {
          "input": {
            "d": true
          }
        }
      },
      "5": {
        "tagcolor": {
          "input": {
            "color": true
          }
        },
        "propifhaskey": {
          "output": {
            "value": true
          }
        }
      },
      "6": {
        "tagcolor": {
          "output": {
            "{color}": true
          }
        },
        "mergedefault": {
          "input": {
            "a": true
          }
        }
      },
      "7": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "box": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "disabled": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "disabled"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 45,
                "y": -216
              }
            }
          }
        }
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "style"
          },
          "2": {
            "unitId": "propifhaskey",
            "pinId": "obj"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 37,
                "y": -174
              }
            },
            "2": {
              "ext": {
                "x": 130,
                "y": 0
              }
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "graph"
          }
        },
        "ref": true,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 48,
                "y": -250
              }
            }
          }
        }
      },
      "fullwindow": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "fullwindow"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 47,
                "y": -284
              }
            }
          }
        }
      },
      "frame": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "frame"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 43,
                "y": -359
              }
            }
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a",
            "kind": "input"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 250,
                "y": 427
              }
            }
          }
        }
      },
      "config": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "config",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -481,
                "y": -248
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "value"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -481,
                "y": -329
              }
            }
          }
        }
      }
    },
    "outputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "graph"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 43,
                "y": -415
              }
            }
          }
        }
      },
      "state": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "state"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 64,
                "y": -325
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "app",
            "pinId": "value"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 25,
                "y": -142
              }
            }
          }
        }
      }
    },
    "render": true,
    "component": {
      "subComponents": {
        "app": {
          "children": [
            "box"
          ],
          "childSlot": {
            "box": "1"
          }
        },
        "path": {},
        "box": {
          "children": [
            "path"
          ],
          "childSlot": {
            "path": "default"
          }
        }
      },
      "children": [
        "app"
      ],
      "slots": [
        [
          "app",
          "default"
        ],
        [
          "app",
          "1"
        ],
        [
          "app",
          "2"
        ]
      ],
      "defaultWidth": 420,
      "defaultHeight": 360
    },
    "metadata": {
      "icon": "atom-alt",
      "description": "app + logo",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "1": {
            "x": 265,
            "y": 346
          },
          "5": {
            "x": 244,
            "y": 35
          },
          "6": {
            "x": 349,
            "y": 27
          },
          "7": {
            "x": 453,
            "y": 14
          }
        }
      }
    },
    "id": "6f267de2-b02c-11ea-b55c-db553f4c6c45",
    "type": "\`U\`&\`G\`&\`C\`",
    "system": true
  },
  "687384e5-8b9a-4ba8-b68a-e7972213d7bc": {
    "name": "hovered or not",
    "inputs": {},
    "outputs": {},
    "units": {
      "textdiv": {
        "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
        "input": {
          "value": {
            "constant": false,
            "data": "'NOT HOVERED'"
          },
          "style": {
            "constant": true,
            "data": "{display:'flex',justifyContent:'center',alignItems:'center',fontSize:'30px',textAlign:'center'}",
            "metadata": {
              "position": {
                "x": 251,
                "y": 0
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 128,
            "y": 0
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'HOVERED'",
            "metadata": {
              "position": {
                "x": -109,
                "y": 43
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -59,
            "y": 31
          }
        }
      },
      "onpointerenter": {
        "id": "c0bb493a-af78-11ea-b6fa-3b893b757a39",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 4,
            "y": 62
          }
        }
      },
      "onpointerleave": {
        "id": "c7dba94e-af78-11ea-b7d7-47e14ca215b5",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 4,
            "y": -63
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'NOT HOVERED'",
            "metadata": {
              "position": {
                "x": -109,
                "y": -44
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -59,
            "y": -32
          }
        }
      }
    },
    "merges": {
      "amznbrs": {
        "onpointerleave": {
          "input": {
            "element": true
          }
        },
        "textdiv": {
          "output": {
            "_self": true
          }
        },
        "onpointerenter": {
          "input": {
            "element": true
          }
        }
      },
      "qkzuxfdle": {
        "wait0": {
          "input": {
            "b": true
          }
        },
        "onpointerleave": {
          "output": {
            "event": true
          }
        }
      },
      "skqbcsu": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "onpointerenter": {
          "output": {
            "event": true
          }
        }
      },
      "qldolfj": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "textdiv": {
          "input": {
            "value": true
          }
        },
        "wait0": {
          "output": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "text box showing whether it is hovered or not",
      "position": {
        "merge": {
          "qkzuxfdle": {
            "x": -41,
            "y": -72
          },
          "skqbcsu": {
            "x": -41,
            "y": 71
          },
          "qldolfj": {
            "x": -12,
            "y": 0
          },
          "yqhxzi": {
            "x": 257,
            "y": 0
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "687384e5-8b9a-4ba8-b68a-e7972213d7bc",
    "component": {
      "subComponents": {
        "textdiv": {
          "children": []
        }
      },
      "children": [
        "textdiv"
      ],
      "defaultWidth": 180,
      "defaultHeight": 90
    },
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "ec8afd36-0718-42f7-9b0d-4b1adbf62766": {
    "name": "horizontal scroll box",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "defaultstyle": {
        "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
        "input": {
          "style": {
            "constant": true,
            "data": "{display:\\"inline-block\\",verticalAlign:\\"bottom\\"}"
          }
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": -114
          }
        }
      },
      "box": {
        "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
        "input": {
          "style": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -51,
            "y": 113
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "default": {
            "constant": true,
            "data": "{whiteSpace:\\"nowrap\\"}"
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "box": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "defaultstyle",
          "default"
        ]
      ],
      "subComponents": {
        "defaultstyle": {
          "children": []
        },
        "box": {
          "children": [
            "defaultstyle"
          ]
        }
      },
      "children": [
        "box"
      ],
      "defaultWidth": 300,
      "defaultHeight": 180
    },
    "metadata": {
      "icon": "square",
      "description": "horizontal scroll container",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "ec8afd36-0718-42f7-9b0d-4b1adbf62766",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "a9cbed12-9a53-11eb-8c2e-f3146b36128d": {
    "name": "hello world",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "textbox": {
        "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
        "input": {
          "value": {
            "constant": true,
            "data": "'hello world'"
          },
          "style": {
            "constant": false
          }
        },
        "output": {
          "div": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": 105,
            "y": 14
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{textAlign:'center',fontFamily:'Inconsolata',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'20vw'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -106,
            "y": -15
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "textbox": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "textbox": {
          "children": []
        }
      },
      "children": [
        "textbox"
      ],
      "defaultWidth": 300,
      "defaultHeight": 300
    },
    "metadata": {
      "description": "text box saying 'hello world'",
      "icon": "sign",
      "position": {},
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "a9cbed12-9a53-11eb-8c2e-f3146b36128d",
    "render": true,
    "type": "\`U\`&\`C\`&\`G\`",
    "system": true
  },
  "120ff298-ff92-4b7c-b748-9a3c3bdbad2e": {
    "name": "full chalkboard",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "chalkboard",
            "pinId": "style"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 336,
              "y": 0
            }
          }
        }
      }
    },
    "outputs": {
      "canvas": {
        "plug": {
          "0": {
            "unitId": "chalkboard",
            "pinId": "canvas"
          }
        },
        "ref": true,
        "defaultIgnored": true
      }
    },
    "units": {
      "chalkboard": {
        "id": "a24f049c-7bb0-11ea-bbdc-17b9984e1f06",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": 311,
                "y": -1
              }
            }
          },
          "width": {
            "constant": true,
            "data": "\\"100vw\\""
          },
          "height": {
            "constant": true,
            "data": "\\"100vh\\""
          }
        },
        "output": {
          "canvas": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          },
          "component": {
            "width": 346.2822265625,
            "height": 384.0284118652344
          }
        }
      }
    },
    "component": {
      "children": [
        "chalkboard"
      ],
      "subComponents": {
        "chalkboard": {
          "children": []
        }
      },
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "metadata": {
      "icon": "chalkboard",
      "description": "full frame chalkboard",
      "position": {
        "merge": {
          "dnnbflw": {
            "x": -92,
            "y": 50
          },
          "cgpompnrt": {
            "x": -92,
            "y": -51
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "120ff298-ff92-4b7c-b748-9a3c3bdbad2e",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "9b9f4c2e-7c28-44c6-b59a-ef26d63892d6": {
    "name": "flex row grid",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {},
        "metadata": {
          "component": {
            "width": 240,
            "height": 240
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',flexDirection:'row',flexWrap:'wrap',alignContent:'start',height:'100%'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "grid flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 240,
      "defaultHeight": 240,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "9b9f4c2e-7c28-44c6-b59a-ef26d63892d6",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "5a7018ba-079d-4749-982d-16326e708a71": {
    "name": "flex row center box",
    "units": {
      "flexrowcenter": {
        "id": "af731047-6d74-4dfd-93bd-0daa4d649d4d",
        "metadata": {
          "component": {
            "width": 240,
            "height": 240
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{width:\\"100%\\",height:\\"100%\\"}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "flexrowcenter": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "full-size flexbox with content centered",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "flexrowcenter",
          "default"
        ]
      ],
      "defaultWidth": 240,
      "defaultHeight": 240,
      "subComponents": {
        "flexrowcenter": {
          "children": []
        }
      },
      "children": [
        "flexrowcenter"
      ]
    },
    "id": "5a7018ba-079d-4749-982d-16326e708a71",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "af731047-6d74-4dfd-93bd-0daa4d649d4d": {
    "name": "flex row center",
    "units": {
      "flexrow": {
        "id": "7d6383c6-9791-4f2a-8f9a-e80415551f15",
        "metadata": {
          "component": {
            "width": 240,
            "height": 240
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{flexWrap:'wrap',alignContent:'center',justifyContent:'center'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "flexrow": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "centered flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "flexrow",
          "default"
        ]
      ],
      "defaultWidth": 240,
      "defaultHeight": 240,
      "subComponents": {
        "flexrow": {
          "children": []
        }
      },
      "children": [
        "flexrow"
      ]
    },
    "id": "af731047-6d74-4dfd-93bd-0daa4d649d4d",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "ad5a2fcc-fdee-11ea-a34f-77e9c48dbe57": {
    "name": "flex row box",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {},
        "metadata": {
          "component": {
            "width": 210,
            "height": 120
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',flexDirection:'row',height:'100%',width:'100%'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "full-size row flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 270,
      "defaultHeight": 180,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "ad5a2fcc-fdee-11ea-a34f-77e9c48dbe57",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "7d6383c6-9791-4f2a-8f9a-e80415551f15": {
    "name": "flex row",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {},
        "metadata": {
          "component": {
            "width": 180,
            "height": 270
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',flexDirection:'row',overflow:'auto'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "flex row div",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 270,
      "defaultHeight": 180,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "7d6383c6-9791-4f2a-8f9a-e80415551f15",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "cac87386-de49-480e-87ec-80c306aa5eec": {
    "name": "flex column grid",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "metadata": {
          "component": {
            "width": 240,
            "height": 240
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',flexDirection:'column',flexWrap:'wrap',alignContent:'start',height:'100%'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "grid flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 240,
      "defaultHeight": 240,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "cac87386-de49-480e-87ec-80c306aa5eec",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "48e9715d-cf6d-4c59-ac65-e7a3c6f8e601": {
    "name": "flex column center box",
    "units": {
      "flexcolumncenter": {
        "id": "59d00328-d61e-4ed2-b4e4-cfa53e0b7fa7",
        "input": {},
        "metadata": {
          "component": {
            "width": 240,
            "height": 240
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{height:'100%',width:'100%'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "flexcolumncenter": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "full-size flexbox with centered content",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "flexcolumncenter",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "flexcolumncenter": {
          "children": []
        }
      },
      "children": [
        "flexcolumncenter"
      ]
    },
    "id": "48e9715d-cf6d-4c59-ac65-e7a3c6f8e601",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "59d00328-d61e-4ed2-b4e4-cfa53e0b7fa7": {
    "name": "flex column center",
    "units": {
      "flexcolumn": {
        "id": "435e106b-9ee5-4457-818b-3f41a62992a6",
        "input": {},
        "metadata": {
          "component": {
            "width": 240,
            "height": 240
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{flexWrap:'wrap',alignContent:'center',justifyContent:'center'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "flexcolumn": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "column flexbox with centered content",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "flexcolumn",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "flexcolumn": {
          "children": []
        }
      },
      "children": [
        "flexcolumn"
      ]
    },
    "id": "59d00328-d61e-4ed2-b4e4-cfa53e0b7fa7",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "67a6fb5a-feab-11ea-8bd1-a3c19e76592a": {
    "name": "flex column box",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {},
        "metadata": {
          "component": {
            "width": 180,
            "height": 270
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',flexDirection:'column',height:'100%',width:'100%'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "full-size column flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "67a6fb5a-feab-11ea-8bd1-a3c19e76592a",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "435e106b-9ee5-4457-818b-3f41a62992a6": {
    "name": "flex column",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {},
        "metadata": {
          "component": {
            "width": 180,
            "height": 270
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',flexDirection:'column'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "flex column div",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "435e106b-9ee5-4457-818b-3f41a62992a6",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "4d0092bf-0e68-49e5-8fe1-6b0c79da571c": {
    "name": "fit-content",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {},
        "metadata": {
          "component": {
            "width": 120,
            "height": 210
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{width:'fit-content',height:'fit-content'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "column flexbox",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 180,
      "defaultHeight": 270,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "4d0092bf-0e68-49e5-8fe1-6b0c79da571c",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "68ee3bf2-7d57-4828-92ac-1070e988ffe7": {
    "name": "default video",
    "units": {
      "defaultvideomedia": {
        "id": "c03c7ef3-0649-4a99-9e9a-858bcaba1307",
        "input": {
          "opt": {}
        },
        "output": {
          "stream": {}
        },
        "metadata": {
          "position": {
            "x": 110,
            "y": 0
          }
        }
      },
      "video": {
        "id": "7a8921eb-c1ad-400b-94fc-6c6cead8163d",
        "input": {
          "src": {
            "ignored": true
          },
          "style": {},
          "stream": {
            "ignored": false,
            "icon": "circle-play"
          },
          "controls": {
            "ignored": false
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -111,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "video": {
          "input": {
            "stream": true
          }
        },
        "defaultvideomedia": {
          "output": {
            "stream": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "video",
            "pinId": "style"
          }
        }
      },
      "controls": {
        "plug": {
          "0": {
            "unitId": "video",
            "pinId": "controls"
          }
        },
        "defaultIgnored": true
      },
      "opt": {
        "plug": {
          "0": {
            "unitId": "defaultvideomedia",
            "pinId": "opt"
          }
        }
      }
    },
    "outputs": {
      "video": {
        "plug": {
          "0": {
            "unitId": "video",
            "pinId": "_self"
          }
        },
        "ref": true
      }
    },
    "metadata": {
      "icon": "video",
      "description": "default video media",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "video",
          "default"
        ]
      ],
      "subComponents": {
        "video": {
          "children": []
        }
      },
      "children": [
        "video"
      ],
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "id": "68ee3bf2-7d57-4828-92ac-1070e988ffe7",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "d0c59812-a8ec-4c53-81a9-c9725dda987e": {
    "name": "charcode",
    "inputs": {
      "code": {
        "plug": {
          "0": {
            "unitId": "fromcharcode",
            "pinId": "code"
          }
        },
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "units": {
      "textspan": {
        "id": "4ba86ad5-899b-4e8d-b5ce-3589dcfeaefd",
        "input": {
          "style": {},
          "value": {}
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 137.0802001953125,
            "height": 130.09799194335938
          }
        }
      },
      "fromcharcode": {
        "id": "25d0e003-f002-45ae-a50c-6fa3bffee4eb",
        "input": {
          "code": {}
        },
        "output": {
          "char": {}
        },
        "metadata": {
          "position": {
            "x": -76,
            "y": 0
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{display:'flex',justifyContent:'center',alignItems:'center',fontSize:'60px'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "fromcharcode": {
          "output": {
            "char": true
          }
        },
        "textspan": {
          "input": {
            "value": true
          }
        }
      },
      "1": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "textspan": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "textspan": {
          "children": []
        }
      },
      "children": [
        "textspan"
      ],
      "defaultWidth": 90,
      "defaultHeight": 90
    },
    "metadata": {
      "icon": "square",
      "description": "render a unicode char from its code",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "d0c59812-a8ec-4c53-81a9-c9725dda987e",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "6475795b-1953-4d08-975b-15ace80099d3": {
    "name": "chalkboard behavior",
    "units": {
      "getoffsetxy": {
        "id": "2307cacf-1363-40bc-bd6b-d58227927ae0",
        "input": {
          "obj": {}
        },
        "output": {
          "y": {},
          "x": {}
        },
        "metadata": {
          "position": {
            "x": 188,
            "y": -210
          }
        }
      },
      "ondrag": {
        "id": "d4de180e-f1e8-4575-ab64-eaef413bcfc4",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": 41,
                "y": -213
              }
            }
          }
        },
        "output": {
          "move": {},
          "down": {},
          "up": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 184,
                "y": -258
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 78,
            "y": -178
          }
        }
      },
      "plan": {
        "id": "36329d25-218d-48a5-a06c-1e0525da504f",
        "input": {
          "a": {}
        },
        "output": {
          "0": {},
          "1": {}
        },
        "metadata": {
          "position": {
            "x": -26,
            "y": -107
          }
        }
      },
      "mergexy": {
        "id": "2737cd82-d80b-4d3f-b33d-f00f68361e24",
        "input": {
          "y": {},
          "x": {}
        },
        "output": {
          "{x,y}": {}
        },
        "metadata": {
          "position": {
            "x": 289,
            "y": -204
          }
        }
      },
      "iterate0": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": {
              "ref": [],
              "data": -1
            },
            "metadata": {
              "position": {
                "x": 150,
                "y": -26
              },
              "data": {
                "position": {
                  "x": 178,
                  "y": -24
                }
              }
            }
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 55,
                "y": -11
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 102,
            "y": -23
          }
        }
      },
      "propoffsetXoffsetY": {
        "id": "2307cacf-1363-40bc-bd6b-d58227927ae0",
        "metadata": {
          "position": {
            "x": -100,
            "y": -13
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {},
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 314,
            "y": -105
          }
        }
      },
      "getpointerId0": {
        "id": "c51a275d-8610-452d-a136-7a2b58d8caf2",
        "input": {
          "obj": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -25,
            "y": 1
          }
        }
      },
      "constant1": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 165,
            "y": 44
          }
        }
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a = b": {}
        },
        "metadata": {
          "position": {
            "x": 63,
            "y": 48
          }
        }
      },
      "constant0": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 361,
            "y": 4
          }
        }
      },
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "if": {},
          "else": {}
        },
        "metadata": {
          "position": {
            "x": 42,
            "y": 93
          }
        }
      },
      "addlineto": {
        "id": "2b0ef9e9-028b-4acc-9daf-6999e86cc2af",
        "input": {
          "d": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -37,
                "y": -207
              }
            }
          },
          "x": {},
          "y": {}
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": -147,
            "y": 70
          }
        }
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": 386,
                "y": -20
              },
              "data": {
                "position": {
                  "x": 425,
                  "y": -23
                }
              }
            }
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 377,
                "y": -39
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 329,
            "y": -14
          }
        }
      },
      "constant": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 266,
            "y": 87
          }
        }
      },
      "get0": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 146,
            "y": 145
          }
        }
      },
      "emptyarray": {
        "id": "b226083c-2797-11eb-a546-c350370e09cb",
        "input": {
          "any": {}
        },
        "output": {
          "[]": {}
        },
        "metadata": {
          "position": {
            "x": -61,
            "y": 109
          }
        }
      },
      "stroke": {
        "id": "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99",
        "input": {
          "d": {}
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": -255,
            "y": 66
          }
        }
      },
      "getxy": {
        "id": "5bf348b6-9776-4b23-9516-d802b6b3c846",
        "input": {
          "obj": {}
        },
        "output": {
          "y": {},
          "x": {}
        },
        "metadata": {
          "position": {
            "x": 31,
            "y": 191
          }
        }
      },
      "moveto0": {
        "id": "3c47d4bc-315d-4600-a9cd-6e388b345980",
        "input": {
          "d": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -209,
                "y": -168
              },
              "data": {
                "position": {
                  "x": -243,
                  "y": -184
                }
              }
            }
          },
          "x": {},
          "y": {}
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": -76,
            "y": 174
          }
        }
      },
      "drawd0": {
        "id": "62bd0895-8889-40b2-8147-1c690809f4eb",
        "input": {
          "d": {},
          "canvas": {
            "metadata": {
              "position": {
                "x": -407,
                "y": 66
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -358,
            "y": 66
          }
        }
      },
      "beginpath": {
        "id": "81c0f469-ab88-4bc8-89d5-98d291b1d8b2",
        "input": {
          "d": {
            "constant": true,
            "data": {
              "ref": [],
              "data": []
            },
            "metadata": {
              "data": {
                "position": {
                  "x": -255,
                  "y": 233
                }
              },
              "position": {
                "x": -221,
                "y": 226
              }
            }
          }
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": -173,
            "y": 219
          }
        }
      },
      "ondoubleclick": {
        "id": "40f9a40a-b4f2-11eb-baf1-933bfa98253e",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": 131,
                "y": 220
              }
            }
          }
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 180,
            "y": 220
          }
        }
      },
      "clear": {
        "id": "1ef77768-7394-4b83-ad11-f5905fa9d0d3",
        "input": {
          "any": {},
          "canvas": {
            "metadata": {
              "position": {
                "x": 330,
                "y": 220
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 281,
            "y": 220
          }
        }
      },
      "constant2": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 268,
            "y": 29
          }
        }
      },
      "delete": {
        "id": "664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": 34,
                "y": -9
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 249,
            "y": -48
          }
        }
      },
      "getpointerId1": {
        "id": "c51a275d-8610-452d-a136-7a2b58d8caf2",
        "input": {
          "obj": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 165,
            "y": -106
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": {
              "ref": [],
              "data": -1
            },
            "metadata": {
              "position": {
                "x": 53,
                "y": -92
              },
              "data": {
                "position": {
                  "x": 30,
                  "y": -98
                }
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 99,
            "y": -90
          }
        }
      },
      "getpointerId2": {
        "id": "c51a275d-8610-452d-a136-7a2b58d8caf2",
        "input": {
          "obj": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 200,
            "y": -156
          }
        }
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 83,
            "y": -142
          }
        }
      },
      "getpointerId": {
        "id": "c51a275d-8610-452d-a136-7a2b58d8caf2",
        "input": {
          "obj": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 12,
            "y": -73
          }
        }
      }
    },
    "merges": {
      "0": {
        "getpointerId": {
          "input": {
            "obj": true
          }
        },
        "plan": {
          "output": {
            "1": true
          }
        },
        "identity": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "getoffsetxy": {
          "output": {
            "x": true
          }
        },
        "mergexy": {
          "input": {
            "x": true
          }
        }
      },
      "2": {
        "getoffsetxy": {
          "output": {
            "y": true
          }
        },
        "mergexy": {
          "input": {
            "y": true
          }
        }
      },
      "3": {
        "ondrag": {
          "output": {
            "move": true
          }
        },
        "plan": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "plan": {
          "output": {
            "0": true
          }
        },
        "propoffsetXoffsetY": {
          "input": {
            "obj": true
          }
        },
        "getpointerId0": {
          "input": {
            "obj": true
          }
        }
      },
      "5": {
        "delete": {
          "input": {
            "obj": true
          }
        },
        "constant2": {
          "output": {
            "a": true
          }
        }
      },
      "6": {
        "propoffsetXoffsetY": {
          "output": {
            "y": true
          }
        },
        "addlineto": {
          "input": {
            "y": true
          }
        }
      },
      "7": {
        "propoffsetXoffsetY": {
          "output": {
            "x": true
          }
        },
        "addlineto": {
          "input": {
            "x": true
          }
        }
      },
      "8": {
        "addlineto": {
          "output": {
            "d": true
          }
        },
        "stroke": {
          "input": {
            "d": true
          }
        }
      },
      "9": {
        "getpointerId0": {
          "output": {
            "value": true
          }
        },
        "equals": {
          "input": {
            "a": true
          }
        },
        "ifelse": {
          "input": {
            "a": true
          }
        }
      },
      "10": {
        "stroke": {
          "output": {
            "d": true
          }
        },
        "drawd0": {
          "input": {
            "d": true
          }
        }
      },
      "11": {
        "constant0": {
          "input": {
            "a": true
          }
        },
        "iterate": {
          "output": {
            "current": true
          }
        },
        "constant": {
          "input": {
            "a": true
          }
        },
        "constant2": {
          "input": {
            "a": true
          }
        }
      },
      "12": {
        "iterate0": {
          "output": {
            "current": true
          }
        },
        "constant1": {
          "input": {
            "a": true
          }
        }
      },
      "13": {
        "ondoubleclick": {
          "output": {
            "event": true
          }
        },
        "clear": {
          "input": {
            "any": true
          }
        }
      },
      "14": {
        "constant": {
          "output": {
            "a": true
          }
        },
        "get0": {
          "input": {
            "obj": true
          }
        }
      },
      "15": {
        "get0": {
          "output": {
            "value": true
          }
        },
        "getxy": {
          "input": {
            "obj": true
          }
        }
      },
      "16": {
        "iterate0": {
          "input": {
            "next": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        },
        "getpointerId": {
          "output": {
            "value": true
          }
        }
      },
      "17": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "constant0": {
          "output": {
            "a": true
          }
        }
      },
      "18": {
        "mergexy": {
          "output": {
            "{x,y}": true
          }
        },
        "set": {
          "input": {
            "value": true
          }
        }
      },
      "19": {
        "addlineto": {
          "input": {
            "d": true
          }
        },
        "emptyarray": {
          "output": {
            "[]": true
          }
        },
        "moveto0": {
          "output": {
            "d": true
          }
        }
      },
      "20": {
        "getxy": {
          "output": {
            "y": true
          }
        },
        "moveto0": {
          "input": {
            "y": true
          }
        }
      },
      "21": {
        "getxy": {
          "output": {
            "x": true
          }
        },
        "moveto0": {
          "input": {
            "x": true
          }
        }
      },
      "22": {
        "constant1": {
          "output": {
            "a": true
          }
        },
        "equals": {
          "input": {
            "b": true
          }
        }
      },
      "23": {
        "set": {
          "output": {
            "obj": true
          }
        },
        "iterate": {
          "input": {
            "next": true
          }
        },
        "delete": {
          "output": {
            "obj": true
          }
        }
      },
      "24": {
        "moveto0": {
          "input": {
            "d": true
          }
        },
        "beginpath": {
          "output": {
            "d": true
          }
        }
      },
      "25": {
        "equals": {
          "output": {
            "a = b": true
          }
        },
        "ifelse": {
          "input": {
            "b": true
          }
        }
      },
      "26": {
        "ifelse": {
          "output": {
            "if": true
          }
        },
        "emptyarray": {
          "input": {
            "any": true
          }
        }
      },
      "27": {
        "ondrag": {
          "output": {
            "down": true
          }
        },
        "getoffsetxy": {
          "input": {
            "obj": true
          }
        },
        "getpointerId2": {
          "input": {
            "obj": true
          }
        },
        "identity": {
          "output": {
            "a": true
          }
        }
      },
      "28": {
        "ondrag": {
          "output": {
            "up": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        },
        "getpointerId1": {
          "input": {
            "obj": true
          }
        }
      },
      "29": {
        "delete": {
          "input": {
            "key": true
          }
        },
        "getpointerId1": {
          "output": {
            "value": true
          }
        }
      },
      "30": {
        "getpointerId2": {
          "output": {
            "value": true
          }
        },
        "set": {
          "input": {
            "key": true
          }
        }
      },
      "31": {
        "ifelse": {
          "output": {
            "else": true
          }
        },
        "get0": {
          "input": {
            "key": true
          }
        }
      }
    },
    "inputs": {
      "canvas": {
        "plug": {
          "0": {
            "unitId": "drawd0",
            "pinId": "canvas",
            "kind": "input"
          },
          "1": {
            "unitId": "ondrag",
            "pinId": "element",
            "kind": "input"
          },
          "2": {
            "unitId": "clear",
            "pinId": "canvas",
            "kind": "input"
          },
          "3": {
            "unitId": "ondoubleclick",
            "pinId": "element",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -430,
                "y": 66
              }
            },
            "1": {
              "ext": {
                "x": 31,
                "y": -236
              }
            },
            "2": {
              "ext": {
                "x": 353,
                "y": 220
              }
            },
            "3": {
              "ext": {
                "x": 111,
                "y": 231
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "chalkboard",
      "description": "isolated multi-touch drawing behavior",
      "position": {
        "merge": {
          "0": {
            "x": 26,
            "y": -118
          },
          "1": {
            "x": 239,
            "y": -206
          },
          "2": {
            "x": 240,
            "y": -227
          },
          "3": {
            "x": 16,
            "y": -153
          },
          "4": {
            "x": -54,
            "y": -48
          },
          "5": {
            "x": 233,
            "y": -3
          },
          "6": {
            "x": -143,
            "y": 18
          },
          "7": {
            "x": -115,
            "y": 32
          },
          "8": {
            "x": -202,
            "y": 68
          },
          "9": {
            "x": 13,
            "y": 45
          },
          "10": {
            "x": -306,
            "y": 66
          },
          "11": {
            "x": 313,
            "y": 37
          },
          "12": {
            "x": 137,
            "y": 8
          },
          "13": {
            "x": 230,
            "y": 220
          },
          "14": {
            "x": 210,
            "y": 121
          },
          "15": {
            "x": 92,
            "y": 177
          },
          "16": {
            "x": 62,
            "y": -56
          },
          "17": {
            "x": 351,
            "y": -56
          },
          "18": {
            "x": 320,
            "y": -159
          },
          "19": {
            "x": -109,
            "y": 120
          },
          "20": {
            "x": -21,
            "y": 178
          },
          "21": {
            "x": -25,
            "y": 199
          },
          "22": {
            "x": 115,
            "y": 49
          },
          "23": {
            "x": 300,
            "y": -57
          },
          "24": {
            "x": -124,
            "y": 201
          },
          "25": {
            "x": 89,
            "y": 83
          },
          "26": {
            "x": -10,
            "y": 100
          },
          "27": {
            "x": 139,
            "y": -175
          },
          "28": {
            "x": 120,
            "y": -134
          },
          "29": {
            "x": 206,
            "y": -75
          },
          "30": {
            "x": 259,
            "y": -132
          },
          "31": {
            "x": 94,
            "y": 124
          }
        },
        "data": {
          "x": 674,
          "y": -110
        }
      },
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "6475795b-1953-4d08-975b-15ace80099d3",
    "type": "\`U\`&\`C\`&\`G\`",
    "system": true
  },
  "a24f049c-7bb0-11ea-bbdc-17b9984e1f06": {
    "name": "chalkboard",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "style"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -148,
              "y": 177,
              "ext": {
                "x": -204,
                "y": 75
              }
            }
          }
        }
      },
      "width": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "width"
          }
        },
        "metadata": {
          "examples": [
            "200"
          ],
          "position": {
            "0": {
              "x": -165,
              "y": 128,
              "ext": {
                "x": -217,
                "y": 29
              }
            }
          }
        }
      },
      "height": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "height"
          }
        },
        "metadata": {
          "examples": [
            "200"
          ],
          "position": {
            "0": {
              "x": -153,
              "y": -22,
              "ext": {
                "x": -204,
                "y": -56
              }
            }
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "d"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -217,
                "y": -10
              }
            }
          }
        }
      }
    },
    "outputs": {
      "canvas": {
        "plug": {
          "0": {
            "unitId": "canvas",
            "pinId": "_self"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -89,
                "y": -152
              }
            }
          }
        }
      }
    },
    "units": {
      "canvas": {
        "id": "94243ec4-8967-4907-8cdd-7223fe256cf6",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -192,
                "y": 54
              }
            }
          },
          "width": {
            "metadata": {
              "position": {
                "x": -193,
                "y": 24
              }
            }
          },
          "height": {
            "metadata": {
              "position": {
                "x": -192,
                "y": -35
              }
            }
          },
          "d": {
            "metadata": {
              "position": {
                "x": -193,
                "y": -4
              }
            }
          },
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -205,
                "y": -17
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 1,
            "y": 10
          },
          "component": {
            "width": 321,
            "height": 292
          }
        }
      },
      "chalkboardbehavior": {
        "id": "6475795b-1953-4d08-975b-15ace80099d3",
        "metadata": {
          "position": {
            "x": 206,
            "y": 10
          }
        }
      }
    },
    "merges": {
      "5": {
        "canvas": {
          "output": {
            "_self": true
          }
        },
        "chalkboardbehavior": {
          "input": {
            "canvas": true
          }
        }
      }
    },
    "component": {
      "subComponents": {
        "canvas": {
          "children": []
        }
      },
      "children": [
        "canvas"
      ],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "metadata": {
      "icon": "chalkboard",
      "description": "drawing board",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {},
        "data": {
          "x": -381,
          "y": 80
        }
      }
    },
    "id": "a24f049c-7bb0-11ea-bbdc-17b9984e1f06",
    "type": "\`U\`&\`G\`&\`C\`",
    "render": true,
    "system": true
  },
  "9eba84b6-d2ca-47e6-9195-8208dbb880bc": {
    "name": "box",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "attr": {
            "ignored": false
          }
        },
        "metadata": {
          "component": {
            "width": 120,
            "height": 120
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{width:'100%',height:'100%',overflow:'auto'}"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      },
      "attr": {
        "plug": {
          "0": {
            "unitId": "div",
            "pinId": "attr"
          }
        },
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "100% div",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "defaultWidth": 120,
      "defaultHeight": 120,
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ]
    },
    "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "4181691b-4790-4191-9b03-86c6c968d1b8": {
    "name": "app",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "gui",
            "pinId": "style"
          },
          "1": {
            "unitId": "propifhaskey",
            "pinId": "obj"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -372,
              "y": -232,
              "ext": {
                "x": -498,
                "y": -162
              }
            },
            "1": {
              "x": -59,
              "y": 45,
              "ext": {
                "x": -166,
                "y": 85
              }
            }
          }
        }
      },
      "disabled": {
        "plug": {
          "0": {
            "unitId": "gui",
            "pinId": "disabled"
          },
          "1": {
            "unitId": "editor",
            "pinId": "disabled"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -372,
              "y": -304,
              "ext": {
                "x": -498,
                "y": -240
              }
            },
            "1": {
              "x": 183,
              "y": 16,
              "ext": {
                "x": 64,
                "y": 29
              }
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "graph"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 183,
              "y": 145,
              "ext": {
                "x": 43,
                "y": 227
              }
            }
          }
        },
        "type": "\`G\`"
      },
      "fullwindow": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "fullwindow"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 63,
                "y": 63
              }
            }
          }
        }
      },
      "frame": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "frame"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 55,
                "y": 275
              }
            }
          }
        }
      },
      "config": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "config",
            "kind": "input"
          }
        },
        "defaultIgnored": true,
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 43,
                "y": 185
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "value"
          }
        },
        "defaultIgnored": true
      }
    },
    "outputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "graph"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 517,
                "y": 122
              }
            }
          }
        }
      },
      "state": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "state"
          }
        },
        "ref": true,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 517,
                "y": 221
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "editor",
            "pinId": "value"
          }
        },
        "defaultIgnored": true
      }
    },
    "units": {
      "gui": {
        "id": "0f043df2-46fc-11eb-ae20-6f1fedd527ba",
        "input": {
          "style": {
            "metadata": {
              "position": {
                "x": -480,
                "y": -176
              }
            }
          },
          "disabled": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -480,
                "y": -226
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -237,
            "y": -201
          }
        }
      },
      "editor": {
        "id": "e80c912e-7508-11ea-966b-436805345ff0",
        "input": {
          "style": {},
          "graph": {
            "metadata": {
              "position": {
                "x": 64,
                "y": 215
              }
            }
          },
          "disabled": {
            "metadata": {
              "position": {
                "x": 68,
                "y": 50
              }
            },
            "ignored": true
          },
          "fullwindow": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 67,
                "y": 86
              }
            }
          },
          "frame": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 65,
                "y": 253
              }
            }
          },
          "attr": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 67,
                "y": 286
              }
            }
          },
          "zoom": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 70,
                "y": 112
              }
            }
          },
          "controls": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 58,
                "y": 232
              }
            }
          },
          "config": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 64,
                "y": 177
              }
            }
          },
          "value": {
            "ignored": false
          }
        },
        "output": {
          "graph": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 495,
                "y": 140
              }
            }
          },
          "state": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 495,
                "y": 202
              }
            }
          },
          "value": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 276,
            "y": 171
          }
        }
      },
      "tagcolor": {
        "id": "dfba14dd-bd14-4fd2-bbfa-c910eadd9f7d",
        "input": {
          "color": {}
        },
        "output": {
          "{color}": {}
        },
        "metadata": {
          "position": {
            "x": 1,
            "y": 124
          }
        }
      },
      "propifhaskey": {
        "id": "8c4f4d5e-2c98-4dfb-aeac-d1e6605a673e",
        "input": {
          "key": {
            "constant": true,
            "data": "'color'",
            "metadata": {
              "position": {
                "x": -150,
                "y": 139
              }
            }
          },
          "obj": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -150,
                "y": 102
              }
            }
          }
        },
        "output": {
          "value": {},
          "has": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -83,
                "y": 159
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -105,
            "y": 121
          }
        }
      }
    },
    "merges": {
      "0": {
        "tagcolor": {
          "output": {
            "{color}": true
          }
        },
        "editor": {
          "input": {
            "style": true
          }
        }
      },
      "1": {
        "tagcolor": {
          "input": {
            "color": true
          }
        },
        "propifhaskey": {
          "output": {
            "value": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "gui",
          "default"
        ],
        [
          "gui",
          "1"
        ],
        [
          "gui",
          "2"
        ]
      ],
      "subComponents": {
        "gui": {
          "children": [
            "editor"
          ],
          "width": 420,
          "height": 420
        },
        "editor": {
          "children": []
        }
      },
      "children": [
        "gui"
      ],
      "defaultWidth": 420,
      "defaultHeight": 360
    },
    "metadata": {
      "icon": "atom-alt",
      "description": "editor + gui",
      "tags": [
        "platform",
        "core",
        "component"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 55,
            "y": 132
          },
          "1": {
            "x": -53,
            "y": 121
          }
        }
      }
    },
    "id": "4181691b-4790-4191-9b03-86c6c968d1b8",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "dc546440-13ca-4ebf-8831-c28138c7efc6": {
    "name": "absolute div",
    "type": "\`U\`&\`G\`&\`C\`",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "mergedefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {
            "constant": false
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 73,
            "y": -9
          }
        }
      },
      "mergedefault": {
        "id": "304e98ac-bda1-11ea-b416-9746f024148c",
        "input": {
          "a": {},
          "default": {
            "constant": true,
            "data": "{position:'absolute',top:'0',left:'0'}"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -74,
            "y": 8
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergedefault": {
          "output": {
            "a": true
          }
        },
        "div": {
          "input": {
            "style": true
          }
        }
      }
    },
    "component": {
      "slots": [
        [
          "div",
          "default"
        ]
      ],
      "subComponents": {
        "div": {
          "children": []
        }
      },
      "children": [
        "div"
      ],
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "metadata": {
      "icon": "square",
      "description": "absolute positioned div",
      "tags": [
        "platform",
        "core",
        "component"
      ]
    },
    "id": "dc546440-13ca-4ebf-8831-c28138c7efc6",
    "render": true,
    "system": true
  },
  "31c06a15-ca1a-4175-b60a-0cb5dfff3a6c": {
    "name": "XYZ to xy",
    "units": {
      "sumall": {
        "id": "bd1a9bbb-6129-4031-b7e9-aec351d847d9"
      },
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "at0": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "1"
          }
        }
      },
      "divide": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233"
      },
      "divide0": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233"
      },
      "pair": {
        "id": "a7d5c2f3-6134-4248-b9bc-33271c280267"
      }
    },
    "merges": {
      "0": {
        "sumall": {
          "input": {
            "a": true
          }
        },
        "at0": {
          "input": {
            "a": true
          }
        },
        "at": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "sumall": {
          "output": {
            "sum": true
          }
        },
        "divide": {
          "input": {
            "b": true
          }
        },
        "divide0": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "at": {
          "output": {
            "a[i]": true
          }
        },
        "divide0": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "at0": {
          "output": {
            "a[i]": true
          }
        },
        "divide": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "divide0": {
          "output": {
            "a ÷ b": true
          }
        },
        "pair": {
          "input": {
            "1": true
          }
        }
      },
      "5": {
        "divide": {
          "output": {
            "a ÷ b": true
          }
        },
        "pair": {
          "input": {
            "0": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "convert XYZ color to XY",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "XYZ": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "xy": {
        "plug": {
          "0": {
            "unitId": "pair",
            "pinId": "pair"
          }
        }
      }
    },
    "id": "31c06a15-ca1a-4175-b60a-0cb5dfff3a6c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2f48e431-9338-44dd-9f20-b8b14e710a1f": {
    "name": "random hex color",
    "units": {
      "randomnaturalbetween": {
        "id": "9d2b69b2-c468-4fca-a7d5-d158033c0201",
        "input": {
          "b": {
            "constant": true,
            "data": "16"
          },
          "a": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "nstringbuilderfrom": {
        "id": "9cab124a-b40d-4614-b032-20b0209e90e3",
        "input": {
          "n": {
            "constant": true,
            "data": "7"
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'#'"
          }
        }
      },
      "numbertohex": {
        "id": "1a7665a2-2af0-11eb-9fdb-4bdf5feec91c",
        "input": {
          "n": {}
        },
        "output": {
          "hex": {}
        }
      }
    },
    "merges": {
      "0": {
        "nstringbuilderfrom": {
          "input": {
            "from": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "numbertohex": {
          "input": {
            "n": true
          }
        },
        "randomnaturalbetween": {
          "output": {
            "n": true
          }
        }
      },
      "2": {
        "numbertohex": {
          "output": {
            "hex": true
          }
        },
        "nstringbuilderfrom": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "random HEX color string",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "hex": {
        "plug": {
          "0": {
            "unitId": "nstringbuilderfrom",
            "pinId": "str"
          }
        }
      }
    },
    "id": "2f48e431-9338-44dd-9f20-b8b14e710a1f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "09856cbd-2676-4930-8241-08c5bbde0474": {
    "name": "random CIE xy color",
    "units": {
      "hextoxy": {
        "id": "f2043fd6-04d4-4523-939b-f631af07f70e"
      },
      "randomhexcolor": {
        "id": "2f48e431-9338-44dd-9f20-b8b14e710a1f",
        "input": {
          "any": {
            "constant": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "hextoxy": {
          "input": {
            "hex": true
          }
        },
        "randomhexcolor": {
          "output": {
            "hex": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "generate a random CIE xy color string",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "randomhexcolor",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "xy": {
        "plug": {
          "0": {
            "unitId": "hextoxy",
            "pinId": "xy"
          }
        }
      }
    },
    "id": "09856cbd-2676-4930-8241-08c5bbde0474",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "73193df9-d5f4-4689-92ce-d804cf30ee20": {
    "name": "RGB to XYZ",
    "units": {
      "multiply": {
        "id": "2dbdf0a4-09c1-49af-b9f8-d51b5cbab5a2",
        "input": {
          "b": {
            "constant": true,
            "data": "[0.000088,0.07231,0.986039]"
          }
        }
      },
      "multiply0": {
        "id": "2dbdf0a4-09c1-49af-b9f8-d51b5cbab5a2",
        "input": {
          "b": {
            "constant": true,
            "data": "[0.664511,0.154324,0.162028]"
          }
        }
      },
      "multiply1": {
        "id": "2dbdf0a4-09c1-49af-b9f8-d51b5cbab5a2",
        "input": {
          "b": {
            "constant": true,
            "data": "[0.283881,0.668433,0.047685]"
          }
        }
      },
      "sumall": {
        "id": "bd1a9bbb-6129-4031-b7e9-aec351d847d9"
      },
      "sumall0": {
        "id": "bd1a9bbb-6129-4031-b7e9-aec351d847d9"
      },
      "sumall1": {
        "id": "bd1a9bbb-6129-4031-b7e9-aec351d847d9"
      },
      "triplet": {
        "id": "91536c82-8e5f-4542-8138-a1a4eb2e5f4d"
      }
    },
    "merges": {
      "0": {
        "multiply": {
          "input": {
            "a": true
          }
        },
        "multiply1": {
          "input": {
            "a": true
          }
        },
        "multiply0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "multiply0": {
          "output": {
            "ab": true
          }
        },
        "sumall": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "multiply1": {
          "output": {
            "ab": true
          }
        },
        "sumall0": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "multiply": {
          "output": {
            "ab": true
          }
        },
        "sumall1": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "sumall1": {
          "output": {
            "sum": true
          }
        },
        "triplet": {
          "input": {
            "2": true
          }
        }
      },
      "5": {
        "sumall0": {
          "output": {
            "sum": true
          }
        },
        "triplet": {
          "input": {
            "0": true
          }
        }
      },
      "6": {
        "sumall": {
          "output": {
            "sum": true
          }
        },
        "triplet": {
          "input": {
            "1": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "convert RGB color to XYZ",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "RGB": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "XYZ": {
        "plug": {
          "0": {
            "unitId": "triplet",
            "pinId": "a"
          }
        }
      }
    },
    "id": "73193df9-d5f4-4689-92ce-d804cf30ee20",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "23cae4c7-b88c-4004-865f-e618bfb0c63f": {
    "name": "RGB to xy",
    "units": {
      "rgbtoxyz": {
        "id": "73193df9-d5f4-4689-92ce-d804cf30ee20"
      },
      "xyztoxy": {
        "id": "31c06a15-ca1a-4175-b60a-0cb5dfff3a6c"
      }
    },
    "merges": {
      "0": {
        "rgbtoxyz": {
          "output": {
            "XYZ": true
          }
        },
        "xyztoxy": {
          "input": {
            "XYZ": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "RGB to XY",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "RGB": {
        "plug": {
          "0": {
            "unitId": "rgbtoxyz",
            "pinId": "RGB"
          }
        }
      }
    },
    "outputs": {
      "XY": {
        "plug": {
          "0": {
            "unitId": "xyztoxy",
            "pinId": "xy"
          }
        }
      }
    },
    "id": "23cae4c7-b88c-4004-865f-e618bfb0c63f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d7bf7bad-3b64-4190-9bae-878e88d119e7": {
    "name": "RGB to HEX",
    "units": {
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "256"
          }
        },
        "output": {
          "a × b": {}
        }
      },
      "multiply0": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "a": {
            "constant": false
          },
          "b": {
            "constant": true,
            "data": "65536"
          }
        },
        "output": {
          "a × b": {}
        }
      },
      "add3": {
        "id": "51de3251-1bb6-454d-b9d6-6b8bcb1f56aa",
        "input": {},
        "output": {}
      },
      "numbertostring": {
        "id": "f712793d-8ee9-4805-9d4a-8c210cae667a",
        "input": {
          "n": {},
          "radix": {
            "constant": true,
            "data": "16"
          }
        },
        "output": {
          "str": {}
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "16777216"
          }
        },
        "output": {
          "a + b": {}
        }
      },
      "slice": {
        "id": "c8a4cd44-a554-4901-8a33-a8adbff63d03",
        "input": {
          "a": {},
          "begin": {
            "constant": true,
            "data": "1"
          },
          "end": {
            "constant": true,
            "data": "7"
          }
        },
        "output": {
          "a": {}
        }
      },
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
        "input": {
          "a": {
            "constant": true,
            "data": "'#'"
          },
          "b": {}
        },
        "output": {
          "ab": {}
        }
      }
    },
    "merges": {
      "0": {
        "multiply": {
          "output": {
            "a × b": true
          }
        },
        "add3": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "multiply0": {
          "output": {
            "a × b": true
          }
        },
        "add3": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "add": {
          "input": {
            "a": true
          }
        },
        "add3": {
          "output": {
            "a + b + c": true
          }
        }
      },
      "4": {
        "numbertostring": {
          "input": {
            "n": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      },
      "5": {
        "slice": {
          "input": {
            "a": true
          }
        },
        "numbertostring": {
          "output": {
            "str": true
          }
        }
      },
      "6": {
        "concat": {
          "input": {
            "b": true
          }
        },
        "slice": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "add3",
            "pinId": "c"
          }
        }
      },
      "g": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a"
          }
        }
      },
      "r": {
        "plug": {
          "0": {
            "unitId": "multiply0",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "hex": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "RGB color to hexadecimal",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "id": "d7bf7bad-3b64-4190-9bae-878e88d119e7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5f1dfd62-e6ac-4c1d-80e4-c0e99440def9": {
    "name": "name to color",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {
            "constant": true,
            "data": "{aliceblue:'#f0f8ff',antiquewhite:'#faebd7',aqua:'#00ffff',aquamarine:'#7fffd4',azure:'#f0ffff',beige:'#f5f5dc',bisque:'#ffe4c4',black:'#000000',blanchedalmond:'#ffebcd',blue:'#0000ff',blueviolet:'#8a2be2',brown:'#a52a2a',burlywood:'#deb887',cadetblue:'#5f9ea0',chartreuse:'#7fff00',chocolate:'#d2691e',coral:'#ff7f50',cornflowerblue:'#6495ed',cornsilk:'#fff8dc',crimson:'#dc143c',cyan:'#00ffff',darkblue:'#00008b',darkcyan:'#008b8b',darkgoldenrod:'#b8860b',darkgray:'#a9a9a9',darkgreen:'#006400',darkkhaki:'#bdb76b',darkmagenta:'#8b008b',darkolivegreen:'#556b2f',darkorange:'#ff8c00',darkorchid:'#9932cc',darkred:'#8b0000',darksalmon:'#e9967a',darkseagreen:'#8fbc8f',darkslateblue:'#483d8b',darkslategray:'#2f4f4f',darkturquoise:'#00ced1',darkviolet:'#9400d3',deeppink:'#ff1493',deepskyblue:'#00bfff',dimgray:'#696969',dodgerblue:'#1e90ff',firebrick:'#b22222',floralwhite:'#fffaf0',forestgreen:'#228b22',fuchsia:'#ff00ff',gainsboro:'#dcdcdc',ghostwhite:'#f8f8ff',gold:'#ffd700',goldenrod:'#daa520',gray:'#808080',green:'#008000',greenyellow:'#adff2f',honeydew:'#f0fff0',hotpink:'#ff69b4',\\"indianred \\":'#cd5c5c',indigo:'#4b0082',ivory:'#fffff0',khaki:'#f0e68c',lavender:'#e6e6fa',lavenderblush:'#fff0f5',lawngreen:'#7cfc00',lemonchiffon:'#fffacd',lightblue:'#add8e6',lightcoral:'#f08080',lightcyan:'#e0ffff',lightgoldenrodyellow:'#fafad2',lightgrey:'#d3d3d3',lightgreen:'#90ee90',lightpink:'#ffb6c1',lightsalmon:'#ffa07a',lightseagreen:'#20b2aa',lightskyblue:'#87cefa',lightslategray:'#778899',lightsteelblue:'#b0c4de',lightyellow:'#ffffe0',lime:'#00ff00',limegreen:'#32cd32',linen:'#faf0e6',magenta:'#ff00ff',maroon:'#800000',mediumaquamarine:'#66cdaa',mediumblue:'#0000cd',mediumorchid:'#ba55d3',mediumpurple:'#9370d8',mediumseagreen:'#3cb371',mediumslateblue:'#7b68ee',mediumspringgreen:'#00fa9a',mediumturquoise:'#48d1cc',mediumvioletred:'#c71585',midnightblue:'#191970',mintcream:'#f5fffa',mistyrose:'#ffe4e1',moccasin:'#ffe4b5',navajowhite:'#ffdead',navy:'#000080',oldlace:'#fdf5e6',olive:'#808000',olivedrab:'#6b8e23',orange:'#ffa500',orangered:'#ff4500',orchid:'#da70d6',palegoldenrod:'#eee8aa',palegreen:'#98fb98',paleturquoise:'#afeeee',palevioletred:'#d87093',papayawhip:'#ffefd5',peachpuff:'#ffdab9',peru:'#cd853f',pink:'#ffc0cb',plum:'#dda0dd',powderblue:'#b0e0e6',purple:'#800080',rebeccapurple:'#663399',red:'#ff0000',rosybrown:'#bc8f8f',royalblue:'#4169e1',saddlebrown:'#8b4513',salmon:'#fa8072',sandybrown:'#f4a460',seagreen:'#2e8b57',seashell:'#fff5ee',sienna:'#a0522d',silver:'#c0c0c0',skyblue:'#87ceeb',slateblue:'#6a5acd',slategray:'#708090',snow:'#fffafa',springgreen:'#00ff7f',steelblue:'#4682b4',tan:'#d2b48c',teal:'#008080',thistle:'#d8bfd8',tomato:'#ff6347',turquoise:'#40e0d0',violet:'#ee82ee',wheat:'#f5deb3',white:'#ffffff',whitesmoke:'#f5f5f5',yellow:'#ffff00',yellowgreen:'#9acd32'}"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "palette",
      "description": "turn a color named \`name\` into its correspondent \`hex\` string",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "key"
          }
        }
      }
    },
    "outputs": {
      "color": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "id": "5f1dfd62-e6ac-4c1d-80e4-c0e99440def9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f2043fd6-04d4-4523-939b-f631af07f70e": {
    "name": "hex to xy",
    "units": {
      "hextorgb": {
        "id": "653279dc-893d-4627-854e-d110aece0b72"
      },
      "rgbtoxy": {
        "id": "23cae4c7-b88c-4004-865f-e618bfb0c63f"
      }
    },
    "merges": {
      "0": {
        "hextorgb": {
          "output": {
            "RGB": true
          }
        },
        "rgbtoxy": {
          "input": {
            "RGB": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "convert hex color to xyz",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "hex": {
        "plug": {
          "0": {
            "unitId": "hextorgb",
            "pinId": "hex"
          }
        }
      }
    },
    "outputs": {
      "xy": {
        "plug": {
          "0": {
            "unitId": "rgbtoxy",
            "pinId": "XY"
          }
        }
      }
    },
    "id": "f2043fd6-04d4-4523-939b-f631af07f70e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "653279dc-893d-4627-854e-d110aece0b72": {
    "name": "hex to rgb",
    "units": {
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b"
      },
      "parseint": {
        "id": "8cd29108-95cd-4217-9721-11f7c7c1131e",
        "input": {
          "radix": {
            "constant": true,
            "data": "16"
          }
        }
      },
      "tail": {
        "id": "5c9f4a0a-e675-48db-b6c0-5ac6914cdae0"
      },
      "ifnotempty": {
        "id": "5f5b12b5-c3b9-460e-a84b-3db4f5d9c483"
      },
      "split": {
        "id": "306fe446-a495-4ae3-a835-34f1468e92fe",
        "input": {
          "at": {
            "constant": true,
            "data": "2"
          }
        }
      },
      "for": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": true
          }
        }
      },
      "validate": {
        "id": "ea515441-7284-49ab-9bac-a0978f25e2c3",
        "input": {
          "message": {
            "constant": true,
            "data": "'invalid hex color string'"
          }
        }
      },
      "test": {
        "id": "c2fec1e6-b370-4069-bb43-6dab5a78b9ab",
        "input": {
          "regex": {
            "constant": true,
            "data": "'^#[0-9a-zA-Z]{6}\$'"
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "3"
          }
        }
      }
    },
    "merges": {
      "0": {
        "parseint": {
          "input": {
            "str": true
          }
        },
        "split": {
          "output": {
            "first": true
          }
        }
      },
      "1": {
        "narraybuilder": {
          "input": {
            "a": true
          }
        },
        "parseint": {
          "output": {
            "n": true
          }
        }
      },
      "2": {
        "ifnotempty": {
          "input": {
            "a": true
          }
        },
        "for": {
          "output": {
            "local": true
          }
        }
      },
      "3": {
        "ifnotempty": {
          "output": {
            "!empty": true
          }
        },
        "for": {
          "input": {
            "test": true
          }
        }
      },
      "4": {
        "split": {
          "output": {
            "second": true
          }
        },
        "for": {
          "input": {
            "next": true
          }
        }
      },
      "5": {
        "tail": {
          "output": {
            "tail": true
          }
        },
        "for": {
          "input": {
            "init": true
          }
        }
      },
      "6": {
        "split": {
          "input": {
            "a": true
          }
        },
        "for": {
          "output": {
            "current": true
          }
        }
      },
      "7": {
        "validate": {
          "input": {
            "test": true
          }
        },
        "test": {
          "output": {
            "match": true
          }
        }
      },
      "8": {
        "validate": {
          "output": {
            "a": true
          }
        },
        "tail": {
          "input": {
            "a": true
          }
        }
      },
      "9": {
        "validate": {
          "input": {
            "a": true
          }
        },
        "test": {
          "input": {
            "str": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "10": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "narraybuilder": {
          "input": {
            "n": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "hexadecimal color string to RGB array",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "hex": {
        "plug": {
          "0": {
            "mergeId": "9"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "RGB": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "id": "653279dc-893d-4627-854e-d110aece0b72",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "0a2aad57-975f-4806-a8c9-58e42161d8ec": {
    "name": "gamma correction",
    "units": {
      "greaterthan": {
        "id": "1651ce6b-4db0-4787-9edf-f770b72d253c",
        "input": {
          "b": {
            "constant": true,
            "data": "0.04045"
          }
        }
      },
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3"
      },
      "divide": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233",
        "input": {
          "b": {
            "constant": true,
            "data": "12.92"
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "b": {
            "constant": true,
            "data": "0.055"
          }
        }
      },
      "divide0": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233",
        "input": {
          "b": {
            "constant": true,
            "data": "1.055"
          }
        }
      },
      "pow": {
        "id": "ef4c1d0a-bda1-484e-8fcb-0fdbde195778",
        "input": {
          "b": {
            "constant": true,
            "data": "2.4"
          }
        }
      }
    },
    "merges": {
      "0": {
        "ifelse": {
          "input": {
            "b": true
          }
        },
        "greaterthan": {
          "output": {
            "a > b": true
          }
        }
      },
      "1": {
        "greaterthan": {
          "input": {
            "a": true
          }
        },
        "ifelse": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "ifelse": {
          "output": {
            "else": true
          }
        },
        "divide": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "ifelse": {
          "output": {
            "if": true
          }
        },
        "add": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "add": {
          "output": {
            "a + b": true
          }
        },
        "divide0": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "divide0": {
          "output": {
            "a ÷ b": true
          }
        },
        "pow": {
          "input": {
            "a": true
          }
        }
      },
      "6": {
        "divide": {
          "output": {
            "a ÷ b": true
          }
        },
        "pow": {
          "output": {
            "a ** b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "gamma correction algorithm",
      "link": "https://en.wikipedia.org/wiki/Gamma_correction",
      "tags": [
        "platform",
        "core",
        "color"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "6"
          }
        }
      }
    },
    "id": "0a2aad57-975f-4806-a8c9-58e42161d8ec",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e3cfa57c-27ca-11eb-9aab-afd483aa07b0": {
    "name": "tag y",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'y'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{y: \`y\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{y}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "e3cfa57c-27ca-11eb-9aab-afd483aa07b0",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c03c6348-27ca-11eb-a1a3-c7af00092506": {
    "name": "tag x",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'x'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{x: \`x\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "x": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{x}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "c03c6348-27ca-11eb-a1a3-c7af00092506",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c13fec8e-a253-11eb-bbe5-6bbcbf28b3ef": {
    "name": "tag width",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'width'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{width: \`width\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "width": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{width}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "c13fec8e-a253-11eb-bbe5-6bbcbf28b3ef",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d4aa836e-a9ed-11eb-b048-6f5e7792f8be": {
    "name": "tag value",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'value'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{r: \`r\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{value}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "d4aa836e-a9ed-11eb-b048-6f5e7792f8be",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f08860e0-f393-4159-80da-510ff95adb21": {
    "name": "tag transform translate px",
    "inputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "px",
            "pinId": "n"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "px0",
            "pinId": "n"
          }
        }
      }
    },
    "outputs": {
      "{transform}": {
        "plug": {
          "0": {
            "unitId": "tagtransform",
            "pinId": "{transform}"
          }
        }
      }
    },
    "units": {
      "tagtransform": {
        "id": "e9758d91-5270-4e11-b1c4-969092abbfe7",
        "input": {
          "transform": {}
        },
        "output": {
          "{transform}": {}
        },
        "metadata": {
          "position": {
            "x": 156,
            "y": 10
          }
        }
      },
      "px": {
        "id": "87c7b2b8-c17e-11ea-ba3a-072aa030b89f",
        "input": {
          "n": {}
        },
        "output": {
          "px": {}
        },
        "metadata": {
          "position": {
            "x": -137,
            "y": -77
          }
        }
      },
      "px0": {
        "id": "87c7b2b8-c17e-11ea-ba3a-072aa030b89f",
        "input": {
          "n": {}
        },
        "output": {
          "px": {}
        },
        "metadata": {
          "position": {
            "x": -38,
            "y": 87
          }
        }
      },
      "concat3": {
        "id": "bb28c9d9-0afd-4ef2-8c5b-41815ea65bf1",
        "input": {
          "a": {
            "constant": true,
            "data": "\\"translate(\\""
          },
          "b": {},
          "c": {}
        },
        "output": {
          "abc": {}
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": 26
          }
        }
      },
      "concat30": {
        "id": "bb28c9d9-0afd-4ef2-8c5b-41815ea65bf1",
        "input": {
          "a": {
            "constant": true,
            "data": "', '"
          },
          "b": {},
          "c": {
            "constant": true,
            "data": "')'"
          }
        },
        "output": {
          "abc": {}
        },
        "metadata": {
          "position": {
            "x": -33,
            "y": -49
          }
        }
      }
    },
    "merges": {
      "0": {
        "concat30": {
          "output": {
            "abc": true
          }
        },
        "concat3": {
          "input": {
            "c": true
          }
        }
      },
      "1": {
        "px": {
          "output": {
            "px": true
          }
        },
        "concat30": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "px0": {
          "output": {
            "px": true
          }
        },
        "concat3": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "tagtransform": {
          "input": {
            "transform": true
          }
        },
        "concat3": {
          "output": {
            "abc": true
          }
        }
      }
    },
    "type": "\`U\`&\`G\`",
    "metadata": {
      "icon": "tag",
      "description": "{transform: translate(x, y)}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "f08860e0-f393-4159-80da-510ff95adb21",
    "system": true
  },
  "e9758d91-5270-4e11-b1c4-969092abbfe7": {
    "name": "tag transform",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'transform'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{transform: \`transform\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "transform": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{transform}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "e9758d91-5270-4e11-b1c4-969092abbfe7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "99764e75-c4be-4f35-9051-0e3a750dca83": {
    "name": "tag start",
    "units": {
      "temzrvlyb": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'start'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{start: \`start\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "start": {
        "plug": {
          "0": {
            "unitId": "temzrvlyb",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{start}": {
        "plug": {
          "0": {
            "unitId": "temzrvlyb",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "99764e75-c4be-4f35-9051-0e3a750dca83",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5611a149-95bf-406e-b227-f583f71f5f3f": {
    "name": "tag r",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'r'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{r: \`r\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "r": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{r}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "5611a149-95bf-406e-b227-f583f71f5f3f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cd3cc728-a253-11eb-92b7-876e93d80737": {
    "name": "tag height",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'height'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{height: \`height\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "height": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{height}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "cd3cc728-a253-11eb-92b7-876e93d80737",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "fe80edec-454f-4e87-ace4-51cdb5b5456f": {
    "name": "tag end",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'end'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{end: \`end\`}",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "end": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "end": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "fe80edec-454f-4e87-ace4-51cdb5b5456f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f1456a8d-7f4f-41b4-9487-166a67a6cbd4": {
    "name": "stroke fill style",
    "units": {
      "strokestyle": {
        "id": "83d22558-2c6f-4dd4-a231-baba798d1d97",
        "input": {
          "d": {},
          "strokeStyle": {}
        },
        "output": {
          "d": {}
        }
      },
      "fillstyle": {
        "id": "f5b2faf1-3a8b-489f-9d99-62d3c749ced6",
        "input": {
          "d": {},
          "fillStyle": {}
        },
        "output": {
          "d": {}
        }
      }
    },
    "merges": {
      "0": {
        "fillstyle": {
          "output": {
            "d": true
          }
        },
        "strokestyle": {
          "input": {
            "d": true
          }
        }
      },
      "1": {
        "fillstyle": {
          "input": {
            "fillStyle": true
          }
        },
        "strokestyle": {
          "input": {
            "strokeStyle": true
          }
        }
      }
    },
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "fillstyle",
            "pinId": "d"
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "strokestyle",
            "pinId": "d"
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "set the color, gradient, or pattern to use for stroke and fill",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "f1456a8d-7f4f-41b4-9487-166a67a6cbd4",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "0eb3579e-4645-4e45-a3b1-f3fb1a62ab4d": {
    "name": "stroke fill circle",
    "units": {
      "addcircle": {
        "id": "50d23b21-1513-42c0-9722-4a01a32dc161"
      },
      "beginpath": {
        "id": "81c0f469-ab88-4bc8-89d5-98d291b1d8b2"
      },
      "stroke": {
        "id": "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99"
      },
      "fill": {
        "id": "87a11e2c-278c-11eb-9209-2f30aebffb25",
        "input": {
          "d": {}
        },
        "output": {
          "d": {}
        }
      }
    },
    "merges": {
      "0": {
        "addcircle": {
          "input": {
            "d": true
          }
        },
        "beginpath": {
          "output": {
            "d": true
          }
        }
      },
      "1": {
        "stroke": {
          "input": {
            "d": true
          }
        },
        "fill": {
          "output": {
            "d": true
          }
        }
      },
      "2": {
        "fill": {
          "input": {
            "d": true
          }
        },
        "addcircle": {
          "output": {
            "d": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "draw a circle to the canvas",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "beginpath",
            "pinId": "d"
          }
        },
        "functional": true
      },
      "circle": {
        "plug": {
          "0": {
            "unitId": "addcircle",
            "pinId": "circle"
          }
        },
        "type": "{x:number,y:number,r:number}"
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "stroke",
            "pinId": "d"
          }
        }
      }
    },
    "id": "0eb3579e-4645-4e45-a3b1-f3fb1a62ab4d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "89051065-ef45-48b2-ab7f-77ae173e1b4d": {
    "name": "stroke circle",
    "units": {
      "addcircle": {
        "id": "50d23b21-1513-42c0-9722-4a01a32dc161",
        "input": {
          "d": {},
          "circle": {}
        },
        "output": {
          "d": {}
        }
      },
      "beginpath": {
        "id": "81c0f469-ab88-4bc8-89d5-98d291b1d8b2",
        "input": {
          "d": {}
        },
        "output": {
          "d": {}
        }
      },
      "stroke": {
        "id": "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99",
        "input": {
          "d": {}
        },
        "output": {
          "d": {}
        }
      }
    },
    "merges": {
      "0": {
        "beginpath": {
          "output": {
            "d": true
          }
        },
        "addcircle": {
          "input": {
            "d": true
          }
        }
      },
      "1": {
        "stroke": {
          "input": {
            "d": true
          }
        },
        "addcircle": {
          "output": {
            "d": true
          }
        }
      }
    },
    "inputs": {
      "circle": {
        "plug": {
          "0": {
            "unitId": "addcircle",
            "pinId": "circle"
          }
        },
        "type": "{x:number,y:number,r:number}",
        "metadada": {
          "examples": [
            "{x:50,y:50,r:25}"
          ]
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "beginpath",
            "pinId": "d"
          }
        },
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "stroke",
            "pinId": "d"
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "stroke a circle path",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "89051065-ef45-48b2-ab7f-77ae173e1b4d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1b6923a6-b383-4909-af8f-85444aeb6aae": {
    "name": "rotation",
    "units": {
      "rotate": {
        "id": "8f7ce559-a046-45bc-8e98-c39934ed0ae6"
      },
      "loopadd": {
        "id": "93369291-7ce2-4b4c-a414-870b1f3c9b4c",
        "output": {
          "final": {
            "ignored": true
          },
          "local": {
            "ignored": true
          }
        },
        "input": {
          "test": {
            "constant": true,
            "data": "true"
          },
          "init": {
            "constant": true,
            "data": "0"
          },
          "plus": {
            "constant": true
          }
        }
      },
      "translate": {
        "id": "6f79ee03-4b3f-439c-b955-5529f3bebcc9",
        "input": {
          "x": {
            "constant": true,
            "data": "100"
          },
          "y": {
            "constant": true,
            "data": "100"
          }
        }
      },
      "translate0": {
        "id": "6f79ee03-4b3f-439c-b955-5529f3bebcc9",
        "input": {
          "x": {
            "constant": true,
            "data": "-100"
          },
          "y": {
            "constant": true,
            "data": "-100"
          }
        }
      }
    },
    "merges": {
      "0": {
        "rotate": {
          "input": {
            "rad": true
          }
        },
        "loopadd": {
          "output": {
            "current": true
          }
        }
      },
      "1": {
        "translate": {
          "output": {
            "d": true
          }
        },
        "rotate": {
          "input": {
            "d": true
          }
        }
      },
      "2": {
        "translate0": {
          "input": {
            "d": true
          }
        },
        "rotate": {
          "output": {
            "d": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "rotate \`+\` more every frame",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "rad": {
        "plug": {
          "0": {
            "unitId": "loopadd",
            "pinId": "plus"
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "translate",
            "pinId": "d"
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "translate0",
            "pinId": "d"
          }
        }
      }
    },
    "id": "1b6923a6-b383-4909-af8f-85444aeb6aae",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "389f41b1-0a1d-4b02-ab30-53446c2e13e2": {
    "name": "rotate around",
    "units": {
      "translate": {
        "id": "6f79ee03-4b3f-439c-b955-5529f3bebcc9",
        "input": {
          "y": {
            "constant": false
          },
          "x": {
            "constant": false
          }
        }
      },
      "rotate": {
        "id": "8f7ce559-a046-45bc-8e98-c39934ed0ae6",
        "input": {
          "rad": {
            "constant": true,
            "data": "0.1"
          }
        }
      },
      "translate0": {
        "id": "6f79ee03-4b3f-439c-b955-5529f3bebcc9",
        "input": {
          "y": {
            "constant": false
          },
          "x": {
            "constant": false
          }
        }
      },
      "negate": {
        "id": "13cbadb7-bbe5-4c6d-a81e-fc6fe5949e30"
      },
      "negate0": {
        "id": "13cbadb7-bbe5-4c6d-a81e-fc6fe5949e30"
      }
    },
    "merges": {
      "0": {
        "translate0": {
          "output": {
            "d": true
          }
        },
        "rotate": {
          "input": {
            "d": true
          }
        }
      },
      "1": {
        "translate": {
          "input": {
            "d": true
          }
        },
        "rotate": {
          "output": {
            "d": true
          }
        }
      },
      "2": {
        "translate0": {
          "input": {
            "x": true
          }
        },
        "negate0": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "translate0": {
          "input": {
            "y": true
          }
        },
        "negate": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "translate": {
          "input": {
            "y": true
          }
        },
        "negate": {
          "output": {
            "-a": true
          }
        }
      },
      "5": {
        "translate": {
          "input": {
            "x": true
          }
        },
        "negate0": {
          "output": {
            "-a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "adds a rotation to the transformation matrix",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "translate0",
            "pinId": "d"
          }
        },
        "functional": true
      },
      "y": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "translate",
            "pinId": "d"
          }
        }
      }
    },
    "id": "389f41b1-0a1d-4b02-ab30-53446c2e13e2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4617df3b-4ca5-42c1-bcda-4a3833c645da": {
    "name": "merge x y r",
    "units": {
      "mergexy": {
        "id": "2737cd82-d80b-4d3f-b33d-f00f68361e24",
        "input": {
          "y": {},
          "x": {}
        },
        "output": {
          "{x,y}": {}
        }
      },
      "tagr": {
        "id": "5611a149-95bf-406e-b227-f583f71f5f3f",
        "input": {
          "r": {}
        },
        "output": {
          "{r}": {}
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "ab": {}
        }
      }
    },
    "merges": {
      "merge0": {
        "merge": {
          "input": {
            "b": true
          }
        },
        "mergexy": {
          "output": {
            "{x,y}": true
          }
        }
      },
      "merge1": {
        "merge": {
          "input": {
            "a": true
          }
        },
        "tagr": {
          "output": {
            "{r}": true
          }
        }
      }
    },
    "inputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "mergexy",
            "pinId": "y"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "mergexy",
            "pinId": "x"
          }
        }
      },
      "r": {
        "plug": {
          "0": {
            "unitId": "tagr",
            "pinId": "r"
          }
        }
      }
    },
    "outputs": {
      "{x,y,r}": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "ab"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "create object with values \`x\`, \`y\` and \`r\`",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "4617df3b-4ca5-42c1-bcda-4a3833c645da",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2737cd82-d80b-4d3f-b33d-f00f68361e24": {
    "name": "merge x y",
    "units": {
      "merge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f"
      },
      "tagx": {
        "id": "c03c6348-27ca-11eb-a1a3-c7af00092506",
        "input": {
          "x": {}
        },
        "output": {
          "{x}": {}
        }
      },
      "tagy": {
        "id": "e3cfa57c-27ca-11eb-9aab-afd483aa07b0",
        "input": {
          "y": {}
        },
        "output": {
          "{y}": {}
        }
      }
    },
    "merges": {
      "merge0": {
        "tagx": {
          "output": {
            "{x}": true
          }
        },
        "merge": {
          "input": {
            "a": true
          }
        }
      },
      "merge1": {
        "tagy": {
          "output": {
            "{y}": true
          }
        },
        "merge": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "{ x, y }",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "tagy",
            "pinId": "y"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "tagx",
            "pinId": "x"
          }
        }
      }
    },
    "outputs": {
      "{x,y}": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "2737cd82-d80b-4d3f-b33d-f00f68361e24",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2bd0d83a-bd19-425b-aa75-84a47c73fc81": {
    "name": "merge x0 y0 x1 y1",
    "units": {
      "merge4": {
        "id": "1f1b065a-937b-4630-be80-54edf795eb19"
      },
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'x0'"
          }
        }
      },
      "tag0": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'x1'"
          }
        }
      },
      "tag1": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'y0'"
          }
        }
      },
      "tag2": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'y1'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "merge4": {
          "input": {
            "c": true
          }
        },
        "tag": {
          "output": {
            "kv": true
          }
        }
      },
      "1": {
        "merge4": {
          "input": {
            "d": true
          }
        },
        "tag0": {
          "output": {
            "kv": true
          }
        }
      },
      "2": {
        "merge4": {
          "input": {
            "b": true
          }
        },
        "tag1": {
          "output": {
            "kv": true
          }
        }
      },
      "3": {
        "merge4": {
          "input": {
            "a": true
          }
        },
        "tag2": {
          "output": {
            "kv": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "{ x0, y0, x1, y1 }",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "x0": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        },
        "functional": true
      },
      "x1": {
        "plug": {
          "0": {
            "unitId": "tag0",
            "pinId": "v"
          }
        },
        "functional": true
      },
      "y0": {
        "plug": {
          "0": {
            "unitId": "tag1",
            "pinId": "v"
          }
        },
        "functional": true
      },
      "y1": {
        "plug": {
          "0": {
            "unitId": "tag2",
            "pinId": "v"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "{x0,y0,x1,y1}": {
        "plug": {
          "0": {
            "unitId": "merge4",
            "pinId": "abcd"
          }
        }
      }
    },
    "id": "2bd0d83a-bd19-425b-aa75-84a47c73fc81",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "eb9740fb-1a02-4006-a618-7fc8ebc2af96": {
    "name": "merge rect",
    "inputs": {
      "width": {
        "plug": {
          "0": {
            "unitId": "mergewidthheight",
            "pinId": "width"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -191,
              "y": -36
            }
          }
        }
      },
      "height": {
        "plug": {
          "0": {
            "unitId": "mergewidthheight",
            "pinId": "height"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -190,
              "y": 34
            }
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "mergexy",
            "pinId": "x"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 177,
              "y": 53
            }
          }
        }
      },
      "y": {
        "plug": {
          "0": {
            "unitId": "mergexy",
            "pinId": "y"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 184,
              "y": -16
            }
          }
        }
      }
    },
    "outputs": {
      "rect": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "ab"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 32,
              "y": -59
            }
          }
        }
      }
    },
    "units": {
      "mergexy": {
        "id": "2737cd82-d80b-4d3f-b33d-f00f68361e24",
        "input": {
          "y": {
            "metadata": {
              "position": {
                "x": 158,
                "y": -1
              }
            }
          },
          "x": {
            "metadata": {
              "position": {
                "x": 155,
                "y": 33
              }
            }
          }
        },
        "output": {
          "{x,y}": {}
        },
        "metadata": {
          "position": {
            "x": 109,
            "y": 13
          }
        }
      },
      "mergewidthheight": {
        "id": "450dac92-395b-4c7b-b8c0-219315c28035",
        "input": {
          "height": {
            "metadata": {
              "position": {
                "x": -167,
                "y": 16
              }
            }
          },
          "width": {
            "metadata": {
              "position": {
                "x": -167,
                "y": -18
              }
            }
          }
        },
        "output": {
          "{width,height}": {}
        },
        "metadata": {
          "position": {
            "x": -119,
            "y": -1
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "ab": {
            "metadata": {
              "position": {
                "x": 29,
                "y": -31
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -6,
            "y": -2
          }
        }
      }
    },
    "merges": {
      "0": {
        "merge": {
          "input": {
            "a": true
          }
        },
        "mergewidthheight": {
          "output": {
            "{width,height}": true
          }
        }
      },
      "1": {
        "merge": {
          "input": {
            "b": true
          }
        },
        "mergexy": {
          "output": {
            "{x,y}": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "{ x, y, width, height }",
      "position": {
        "merge": {
          "0": {
            "x": -63,
            "y": -1
          },
          "1": {
            "x": 52,
            "y": 9
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "eb9740fb-1a02-4006-a618-7fc8ebc2af96",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "15b8fb24-bbee-49af-a1ae-36016b89f596": {
    "type": "\`U\`&\`G\`",
    "name": "image to blob",
    "units": {
      "drawimage": {
        "id": "82cf909e-a78f-4f3e-b87a-976458c8e15d",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": 264,
                "y": -92
              }
            }
          },
          "image": {},
          "canvas": {},
          "x": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            },
            "ignored": true,
            "metadata": {
              "position": {
                "x": 53,
                "y": 180
              },
              "data": {
                "position": {
                  "x": -526,
                  "y": -330
                }
              }
            }
          },
          "y": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            },
            "ignored": true,
            "metadata": {
              "position": {
                "x": 104,
                "y": 218
              },
              "data": {
                "position": {
                  "x": -526,
                  "y": -330
                }
              }
            }
          },
          "width": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 312,
                "y": -53
              },
              "data": {
                "position": {
                  "x": 349,
                  "y": -68
                }
              }
            }
          },
          "height": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 301,
                "y": -80
              },
              "data": {
                "position": {
                  "x": 325,
                  "y": -110
                }
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 101,
            "y": 174
          }
        }
      },
      "offscreencanvas": {
        "id": "8d7fc133-7cfa-4975-836f-31ae15b818be",
        "input": {
          "width": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 349,
                "y": 81
              },
              "data": {
                "position": {
                  "x": 378,
                  "y": 105
                }
              }
            }
          },
          "height": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 274,
                "y": 97
              },
              "data": {
                "position": {
                  "x": 257,
                  "y": 128
                }
              }
            }
          },
          "done": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -38,
                "y": 135
              }
            }
          },
          "opt": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": -44,
                "y": 158
              },
              "data": {
                "position": {
                  "x": -80,
                  "y": 157
                }
              }
            }
          }
        },
        "output": {
          "canvas": {
            "metadata": {
              "position": {
                "x": 49,
                "y": 205
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 9,
            "y": 161
          }
        }
      },
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "naturalWidth"
            },
            "metadata": {
              "position": {
                "x": 53,
                "y": 94
              },
              "data": {
                "position": {
                  "x": 26,
                  "y": 64
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 93,
            "y": 127
          }
        }
      },
      "toblob": {
        "id": "c9d64ef4-35f6-44e7-a16b-1e4173f951dc",
        "input": {
          "canvas": {},
          "quality": {
            "constant": true,
            "data": "1"
          },
          "type": {},
          "done": {}
        },
        "output": {
          "blob": {}
        },
        "metadata": {
          "position": {
            "x": -115,
            "y": -1
          }
        }
      },
      "get0": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "naturalHeight"
            },
            "metadata": {
              "position": {
                "x": 152,
                "y": 66
              },
              "data": {
                "position": {
                  "x": 171,
                  "y": 35
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 115,
            "y": 98
          }
        }
      }
    },
    "merges": {
      "0": {
        "drawimage": {
          "input": {
            "canvas": true
          }
        },
        "offscreencanvas": {
          "output": {
            "canvas": true
          }
        },
        "toblob": {
          "input": {
            "canvas": true
          }
        }
      },
      "1": {
        "drawimage": {
          "input": {
            "width": true
          }
        },
        "offscreencanvas": {
          "input": {
            "width": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      },
      "2": {
        "drawimage": {
          "input": {
            "image": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        },
        "get0": {
          "input": {
            "obj": true
          }
        }
      },
      "3": {
        "drawimage": {
          "input": {
            "height": true
          }
        },
        "offscreencanvas": {
          "input": {
            "height": true
          }
        },
        "get0": {
          "output": {
            "value": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "drawimage",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false
      },
      "image": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "blob": {
        "plug": {
          "0": {
            "unitId": "toblob",
            "pinId": "blob",
            "kind": "output"
          }
        },
        "ref": true
      }
    },
    "metadata": {
      "icon": "image",
      "description": "get \`image\` \`blob\`",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "15b8fb24-bbee-49af-a1ae-36016b89f596",
    "system": true
  },
  "348215e7-6fc4-4668-8f6a-f02e8b1f2c5d": {
    "type": "\`U\`&\`G\`",
    "name": "image data to url",
    "units": {
      "offscreencanvas0": {
        "id": "8d7fc133-7cfa-4975-836f-31ae15b818be",
        "input": {
          "width": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 37,
                "y": -96
              }
            }
          },
          "height": {
            "metadata": {
              "position": {
                "x": -18,
                "y": -108
              }
            }
          },
          "opt": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": -12,
                "y": -67
              },
              "data": {
                "position": {
                  "x": -21,
                  "y": -103
                }
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -148,
                "y": -23
              }
            }
          }
        },
        "output": {
          "canvas": {
            "metadata": {
              "position": {
                "x": -42,
                "y": 6
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 3,
            "y": -22
          }
        }
      },
      "todataurl": {
        "id": "002fbcc6-ec01-4282-b5a6-77ec4812744e",
        "input": {
          "canvas": {},
          "quality": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 217,
                "y": 168
              },
              "data": {
                "position": {
                  "x": 233,
                  "y": 198
                }
              }
            }
          },
          "type": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "image/png"
            },
            "metadata": {
              "position": {
                "x": -157,
                "y": -17
              },
              "data": {
                "position": {
                  "x": -218,
                  "y": -16
                }
              }
            }
          }
        },
        "output": {
          "url": {
            "metadata": {
              "position": {
                "x": -142,
                "y": -46
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -142,
                "y": -42
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -103,
            "y": -15
          }
        }
      },
      "putimagedata": {
        "id": "138d16a7-a200-4329-9b4a-17abd24943d4",
        "input": {
          "canvas": {},
          "image": {
            "metadata": {
              "position": {
                "x": 18,
                "y": 93
              }
            }
          },
          "any": {
            "metadata": {
              "position": {
                "x": 66,
                "y": 45
              }
            }
          },
          "dx": {
            "metadata": {
              "position": {
                "x": 45,
                "y": 86
              },
              "data": {
                "position": {
                  "x": 64,
                  "y": 122
                }
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            }
          },
          "dy": {
            "metadata": {
              "position": {
                "x": -29,
                "y": 70
              },
              "data": {
                "position": {
                  "x": -55,
                  "y": 97
                }
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            }
          },
          "x": {
            "metadata": {
              "position": {
                "x": 63,
                "y": 69
              },
              "data": {
                "position": {
                  "x": 88,
                  "y": 97
                }
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            }
          },
          "y": {
            "metadata": {
              "position": {
                "x": -11,
                "y": 89
              },
              "data": {
                "position": {
                  "x": -29,
                  "y": 124
                }
              }
            },
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            }
          },
          "width": {
            "metadata": {
              "position": {
                "x": 60,
                "y": 19
              }
            }
          },
          "height": {
            "metadata": {
              "position": {
                "x": 77,
                "y": 39
              }
            }
          }
        },
        "output": {
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 16,
                "y": 102
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 14,
            "y": 45
          }
        }
      },
      "one": {
        "id": "f488c69c-1167-11eb-875f-3354cd742d50",
        "input": {
          "any": {}
        },
        "output": {
          "1": {}
        },
        "metadata": {
          "position": {
            "x": -103,
            "y": 54
          }
        }
      },
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 98,
                "y": -103
              }
            }
          },
          "name": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "width"
            },
            "metadata": {
              "position": {
                "x": 128,
                "y": -73
              },
              "data": {
                "position": {
                  "x": 173,
                  "y": -92
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 80,
            "y": -61
          }
        }
      },
      "get0": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 172,
                "y": 36
              }
            }
          },
          "name": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "height"
            },
            "metadata": {
              "position": {
                "x": 175,
                "y": 6
              },
              "data": {
                "position": {
                  "x": 227,
                  "y": -8
                }
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 125,
            "y": 16
          }
        }
      }
    },
    "merges": {
      "0": {
        "one": {
          "input": {
            "any": true
          }
        },
        "putimagedata": {
          "output": {
            "done": true
          }
        }
      },
      "1": {
        "todataurl": {
          "output": {
            "done": true
          }
        },
        "offscreencanvas0": {
          "input": {
            "done": true
          }
        }
      },
      "2": {
        "todataurl": {
          "input": {
            "quality": true
          }
        },
        "one": {
          "output": {
            "1": true
          }
        }
      },
      "4": {
        "putimagedata": {
          "input": {
            "width": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        },
        "offscreencanvas0": {
          "input": {
            "width": true
          }
        }
      },
      "5": {
        "putimagedata": {
          "input": {
            "height": true
          }
        },
        "get0": {
          "output": {
            "value": true
          }
        },
        "offscreencanvas0": {
          "input": {
            "height": true
          }
        }
      },
      "16": {
        "offscreencanvas0": {
          "output": {
            "canvas": true
          }
        },
        "todataurl": {
          "input": {
            "canvas": true
          }
        },
        "putimagedata": {
          "input": {
            "canvas": true
          }
        }
      }
    },
    "inputs": {
      "image": {
        "plug": {
          "0": {
            "unitId": "putimagedata",
            "pinId": "image",
            "kind": "input"
          },
          "1": {
            "unitId": "get",
            "pinId": "obj",
            "kind": "input"
          },
          "2": {
            "unitId": "get0",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 20,
                "y": 121
              }
            },
            "1": {
              "ext": {
                "x": 102,
                "y": -127
              }
            },
            "2": {
              "ext": {
                "x": 192,
                "y": 50
              }
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "putimagedata",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 90,
                "y": 55
              }
            }
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "todataurl",
            "pinId": "url",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -155,
                "y": -67
              }
            }
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "get \`image\` to data \`url\`",
      "position": {
        "merge": {
          "0": {
            "x": -48,
            "y": 52
          },
          "1": {
            "x": -53,
            "y": -33
          },
          "2": {
            "x": -139,
            "y": 22
          },
          "4": {
            "x": 45,
            "y": -14
          },
          "5": {
            "x": 59,
            "y": 10
          }
        },
        "data": {
          "x": -154,
          "y": 109
        }
      },
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "348215e7-6fc4-4668-8f6a-f02e8b1f2c5d",
    "system": true
  },
  "5bf348b6-9776-4b23-9516-d802b6b3c846": {
    "name": "get x y",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'x'"
          }
        }
      },
      "prop0": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'y'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "prop0": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`x\` and \`y\` from \`obj\`",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "prop0",
            "pinId": "value"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "id": "5bf348b6-9776-4b23-9516-d802b6b3c846",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "004058a4-3562-4427-a782-66f90bf336a3": {
    "name": "get x0 y0 x1 y1",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'x0'"
          }
        }
      },
      "get0": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'x1'"
          }
        }
      },
      "get1": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'y0'"
          }
        }
      },
      "get2": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'y1'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "get1": {
          "input": {
            "obj": true
          }
        },
        "get2": {
          "input": {
            "obj": true
          }
        },
        "get0": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get x0, x1, y0 and y1 rect from object",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "{x0,y0,x1,y1}": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "x1": {
        "plug": {
          "0": {
            "unitId": "get0",
            "pinId": "value"
          }
        }
      },
      "y0": {
        "plug": {
          "0": {
            "unitId": "get1",
            "pinId": "value"
          }
        }
      },
      "x0": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      },
      "y1": {
        "plug": {
          "0": {
            "unitId": "get2",
            "pinId": "value"
          }
        }
      }
    },
    "id": "004058a4-3562-4427-a782-66f90bf336a3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "62bd0895-8889-40b2-8147-1c690809f4eb": {
    "name": "draw d",
    "units": {
      "draw": {
        "id": "53018958-b686-11ea-bf53-175a3698c92d",
        "input": {
          "canvas": {},
          "step": {}
        },
        "output": {}
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "a": {
            "ignored": true
          },
          "i": {
            "ignored": true
          },
          "test": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "merge": {
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "draw": {
          "input": {
            "step": true
          }
        }
      }
    },
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        }
      },
      "canvas": {
        "plug": {
          "0": {
            "unitId": "draw",
            "pinId": "canvas"
          }
        },
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "edit-3",
      "description": "draw step of \`d\` on \`canvas\`",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "id": "62bd0895-8889-40b2-8147-1c690809f4eb",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1a398694-284e-4d67-a13c-3a929c38b0fc": {
    "name": "download canvas",
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "downloadblob",
            "pinId": "name",
            "kind": "input"
          },
          "1": {
            "unitId": "downloadblob",
            "pinId": "init"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 128,
                "y": 15
              }
            },
            "1": {
              "ext": {
                "x": 125,
                "y": -49
              }
            }
          }
        }
      },
      "type": {
        "plug": {
          "0": {
            "unitId": "toblob",
            "pinId": "type"
          }
        },
        "functional": true,
        "metadata": {
          "examples": [
            "\\"image/png\\""
          ],
          "position": {
            "0": {
              "ext": {
                "x": -92,
                "y": -61
              }
            }
          }
        }
      },
      "canvas": {
        "plug": {
          "0": {
            "unitId": "toblob",
            "pinId": "canvas"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -105,
                "y": 37
              }
            }
          }
        }
      }
    },
    "outputs": {
      "done": {
        "plug": {
          "0": {
            "unitId": "toblob",
            "pinId": "done",
            "kind": "output"
          }
        },
        "ref": false,
        "type": "any",
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -29,
                "y": 61
              }
            }
          }
        }
      }
    },
    "units": {
      "toblob": {
        "id": "c9d64ef4-35f6-44e7-a16b-1e4173f951dc",
        "input": {
          "canvas": {
            "metadata": {
              "position": {
                "x": -88,
                "y": 19
              }
            }
          },
          "quality": {
            "constant": true,
            "data": "1",
            "metadata": {
              "position": {
                "x": -98,
                "y": -11
              },
              "data": {
                "position": {
                  "x": -130,
                  "y": -15
                }
              }
            }
          },
          "type": {
            "metadata": {
              "position": {
                "x": -80,
                "y": -39
              }
            }
          },
          "done": {}
        },
        "output": {
          "blob": {
            "metadata": {
              "position": {
                "x": 7,
                "y": -29
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -30,
                "y": 36
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -45,
            "y": -6
          }
        }
      },
      "downloadblob": {
        "id": "c3a080cc-f2f2-4c7c-998d-17809c555ef1",
        "metadata": {
          "position": {
            "x": 62,
            "y": -15
          }
        },
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": 108,
                "y": -34
              }
            }
          },
          "name": {
            "metadata": {
              "position": {
                "x": 110,
                "y": 1
              }
            }
          }
        }
      }
    },
    "merges": {
      "0": {
        "toblob": {
          "output": {
            "blob": true
          }
        },
        "downloadblob": {
          "input": {
            "blob": true
          }
        }
      },
      "1": {
        "downloadblob": {
          "output": {
            "done": true
          }
        },
        "toblob": {
          "input": {
            "done": true
          }
        }
      }
    },
    "render": false,
    "metadata": {
      "icon": "download",
      "description": "download full canvas as png",
      "tags": [
        "platform",
        "core",
        "canvas"
      ],
      "position": {
        "merge": {
          "1": {
            "x": 10,
            "y": -1
          }
        }
      }
    },
    "id": "1a398694-284e-4d67-a13c-3a929c38b0fc",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c3a080cc-f2f2-4c7c-998d-17809c555ef1": {
    "type": "\`U\`&\`G\`",
    "name": "download blob",
    "units": {
      "downloadurl": {
        "id": "c18c8f59-f3c8-49a8-9dbd-ed30fdf856e9",
        "input": {
          "url": {},
          "name": {
            "metadata": {
              "position": {
                "x": 97,
                "y": -30
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 49,
            "y": -27
          }
        }
      },
      "createbloburl": {
        "id": "1d5b6bb0-f18e-4428-a350-a29d8ca3ff4a",
        "input": {
          "blob": {
            "metadata": {
              "position": {
                "x": -101,
                "y": 8
              }
            }
          },
          "init": {
            "metadata": {
              "position": {
                "x": -100,
                "y": -27
              }
            }
          }
        },
        "output": {
          "url": {},
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -19,
                "y": 20
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -55,
            "y": -9
          }
        }
      }
    },
    "merges": {
      "1": {
        "downloadurl": {
          "input": {
            "url": true
          }
        },
        "createbloburl": {
          "output": {
            "url": true
          }
        }
      }
    },
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "downloadurl",
            "pinId": "name"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 120,
                "y": -33
              }
            }
          }
        }
      },
      "blob": {
        "plug": {
          "0": {
            "unitId": "createbloburl",
            "pinId": "blob"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -120,
                "y": 22
              }
            }
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "createbloburl",
            "pinId": "init"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -117,
                "y": -43
              }
            }
          }
        }
      }
    },
    "outputs": {
      "done": {
        "plug": {
          "0": {
            "unitId": "createbloburl",
            "pinId": "done",
            "kind": "output"
          }
        },
        "ref": false,
        "type": "any",
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -14,
                "y": 43
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "download",
      "description": "download blob file with \`name\`",
      "tags": [
        "platform",
        "core",
        "canvas"
      ],
      "position": {
        "merge": {
          "1": {
            "x": -3,
            "y": -22
          }
        }
      }
    },
    "id": "c3a080cc-f2f2-4c7c-998d-17809c555ef1",
    "system": true
  },
  "790d5128-7fd6-48f9-b5cf-9edecedb1043": {
    "name": "arc",
    "units": {
      "stroke": {
        "id": "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99",
        "output": {
          "d": {
            "ignored": false
          }
        }
      },
      "addarc": {
        "id": "6796cd2d-2bd2-4dd3-9396-49d6bc1d2652",
        "input": {
          "arc": {
            "constant": false
          }
        }
      },
      "beginpath": {
        "id": "81c0f469-ab88-4bc8-89d5-98d291b1d8b2"
      }
    },
    "merges": {
      "0": {
        "addarc": {
          "input": {
            "d": true
          }
        },
        "beginpath": {
          "output": {
            "d": true
          }
        }
      },
      "1": {
        "addarc": {
          "output": {
            "d": true
          }
        },
        "stroke": {
          "input": {
            "d": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "draw a circle to the canvas",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "arc": {
        "plug": {
          "0": {
            "unitId": "addarc",
            "pinId": "arc"
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "beginpath",
            "pinId": "d"
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "stroke",
            "pinId": "d"
          }
        }
      }
    },
    "id": "790d5128-7fd6-48f9-b5cf-9edecedb1043",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "22db6e29-8884-43ea-8561-5dc145c192d6": {
    "name": "add pie",
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "moveto",
            "pinId": "d"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "x": 260,
              "y": -197
            }
          }
        }
      },
      "rad": {
        "plug": {
          "0": {
            "unitId": "negate",
            "pinId": "a"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "x": -214,
              "y": 3
            }
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "moveto",
            "pinId": "x"
          },
          "lbxjkjit": {
            "unitId": "add",
            "pinId": "a"
          },
          "yngaryall": {
            "unitId": "mergexyr",
            "pinId": "x"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 254,
              "y": -139
            },
            "lbxjkjit": {
              "x": -107,
              "y": -178
            },
            "yngaryall": {
              "x": -227,
              "y": 280
            }
          }
        }
      },
      "y": {
        "plug": {
          "0": {
            "unitId": "moveto",
            "pinId": "y"
          },
          "1": {
            "unitId": "addlineto",
            "pinId": "y"
          },
          "fgkhrak": {
            "unitId": "mergexyr",
            "pinId": "y"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 205,
              "y": -241
            },
            "1": {
              "x": 2,
              "y": -108
            },
            "fgkhrak": {
              "x": -110,
              "y": 287
            }
          }
        }
      },
      "r": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "b"
          },
          "vzqrpth": {
            "unitId": "mergexyr",
            "pinId": "r"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -79,
              "y": -238
            },
            "vzqrpth": {
              "x": -243,
              "y": 216
            }
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "closepath",
            "pinId": "d"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 241,
              "y": 59
            }
          }
        }
      }
    },
    "units": {
      "moveto": {
        "id": "3c47d4bc-315d-4600-a9cd-6e388b345980",
        "input": {
          "d": {
            "metadata": {
              "position": {
                "x": 232,
                "y": -185
              }
            }
          },
          "x": {
            "metadata": {
              "position": {
                "x": 230,
                "y": -156
              }
            }
          },
          "y": {
            "metadata": {
              "position": {
                "x": 205,
                "y": -211
              }
            }
          }
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": 182,
            "y": -172
          }
        }
      },
      "addarc": {
        "id": "6796cd2d-2bd2-4dd3-9396-49d6bc1d2652",
        "input": {
          "d": {},
          "arc": {
            "constant": false
          }
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": 69,
            "y": -8
          }
        }
      },
      "addlineto": {
        "id": "2b0ef9e9-028b-4acc-9daf-6999e86cc2af",
        "input": {
          "d": {},
          "x": {},
          "y": {
            "metadata": {
              "position": {
                "x": 25,
                "y": -122
              }
            }
          }
        },
        "output": {
          "d": {}
        },
        "metadata": {
          "position": {
            "x": 72,
            "y": -127
          }
        }
      },
      "closepath": {
        "id": "288aede9-59ea-4cb4-baf9-fef9109cc2b9",
        "input": {
          "d": {}
        },
        "output": {
          "d": {
            "metadata": {
              "position": {
                "x": 219,
                "y": 44
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 170,
            "y": 33
          }
        }
      },
      "negate": {
        "id": "13cbadb7-bbe5-4c6d-a81e-fc6fe5949e30",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -190,
                "y": 17
              }
            }
          }
        },
        "output": {
          "-a": {}
        },
        "metadata": {
          "position": {
            "x": -141,
            "y": 27
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -65,
                "y": 68
              }
            }
          },
          "key": {
            "constant": true,
            "data": "'end'",
            "metadata": {
              "position": {
                "x": 12,
                "y": 77
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -33,
            "y": 62
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -78,
                "y": -179
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -68,
                "y": -210
              }
            }
          }
        },
        "output": {
          "a + b": {}
        },
        "metadata": {
          "position": {
            "x": -28,
            "y": -184
          }
        }
      },
      "mergexyr": {
        "id": "4617df3b-4ca5-42c1-bcda-4a3833c645da",
        "input": {
          "y": {
            "metadata": {
              "position": {
                "x": -126,
                "y": 263
              }
            }
          },
          "x": {
            "metadata": {
              "position": {
                "x": -208,
                "y": 257
              }
            }
          },
          "r": {
            "metadata": {
              "position": {
                "x": -215,
                "y": 225
              }
            }
          }
        },
        "output": {
          "{x,y,r}": {
            "metadata": {
              "position": {
                "x": -98,
                "y": 231
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -164,
            "y": 234
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {
            "constant": true,
            "data": "{start:0,anticlockwise:true}",
            "metadata": {
              "position": {
                "x": -24,
                "y": 185
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -28,
                "y": 157
              }
            }
          }
        },
        "output": {
          "ab": {
            "metadata": {
              "position": {
                "x": 63,
                "y": 176
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -71,
            "y": 168
          }
        }
      }
    },
    "merges": {
      "0": {
        "addarc": {
          "output": {
            "d": true
          }
        },
        "closepath": {
          "input": {
            "d": true
          }
        }
      },
      "1": {
        "addlineto": {
          "output": {
            "d": true
          }
        },
        "addarc": {
          "input": {
            "d": true
          }
        }
      },
      "2": {
        "addlineto": {
          "input": {
            "d": true
          }
        },
        "moveto": {
          "output": {
            "d": true
          }
        }
      },
      "3": {
        "set": {
          "input": {
            "value": true
          }
        },
        "negate": {
          "output": {
            "-a": true
          }
        }
      },
      "4": {
        "addarc": {
          "input": {
            "arc": true
          }
        },
        "set": {
          "output": {
            "obj": true
          }
        }
      },
      "pewuwgpn": {
        "add": {
          "output": {
            "a + b": true
          }
        },
        "addlineto": {
          "input": {
            "x": true
          }
        }
      },
      "uexuvd": {
        "merge": {
          "input": {
            "b": true
          }
        },
        "mergexyr": {
          "output": {
            "{x,y,r}": true
          }
        }
      },
      "aepibezsi": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "set": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "add a pie to current sub-path",
      "tags": [
        "platform",
        "core",
        "canvas"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 121,
            "y": 14
          },
          "1": {
            "x": 72,
            "y": -67
          },
          "2": {
            "x": 127,
            "y": -152
          },
          "3": {
            "x": -88,
            "y": 43
          },
          "4": {
            "x": 18,
            "y": 26
          },
          "pewuwgpn": {
            "x": 23,
            "y": -160
          },
          "uexuvd": {
            "x": -116,
            "y": 202
          },
          "aepibezsi": {
            "x": -51,
            "y": 116
          }
        }
      }
    },
    "id": "22db6e29-8884-43ea-8561-5dc145c192d6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "90dc2942-52fa-4e09-bcef-43fa97cc0b72": {
    "name": "stroke line",
    "units": {
      "addlineto": {
        "id": "2b0ef9e9-028b-4acc-9daf-6999e86cc2af"
      },
      "moveto": {
        "id": "3c47d4bc-315d-4600-a9cd-6e388b345980"
      },
      "beginpath": {
        "id": "81c0f469-ab88-4bc8-89d5-98d291b1d8b2"
      },
      "stroke": {
        "id": "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99"
      },
      "propx0y0x1y1": {
        "id": "004058a4-3562-4427-a782-66f90bf336a3"
      }
    },
    "merges": {
      "0": {
        "addlineto": {
          "output": {
            "d": true
          }
        },
        "stroke": {
          "input": {
            "d": true
          }
        }
      },
      "1": {
        "beginpath": {
          "output": {
            "d": true
          }
        },
        "moveto": {
          "input": {
            "d": true
          }
        }
      },
      "2": {
        "addlineto": {
          "input": {
            "d": true
          }
        },
        "moveto": {
          "output": {
            "d": true
          }
        }
      },
      "3": {
        "propx0y0x1y1": {
          "output": {
            "x0": true
          }
        },
        "moveto": {
          "input": {
            "x": true
          }
        }
      },
      "4": {
        "propx0y0x1y1": {
          "output": {
            "y0": true
          }
        },
        "moveto": {
          "input": {
            "y": true
          }
        }
      },
      "5": {
        "propx0y0x1y1": {
          "output": {
            "x1": true
          }
        },
        "addlineto": {
          "input": {
            "x": true
          }
        }
      },
      "6": {
        "propx0y0x1y1": {
          "output": {
            "y1": true
          }
        },
        "addlineto": {
          "input": {
            "y": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "draw a circle to the canvas",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "beginpath",
            "pinId": "d"
          }
        }
      },
      "line": {
        "plug": {
          "0": {
            "unitId": "propx0y0x1y1",
            "pinId": "{x0,y0,x1,y1}"
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "stroke",
            "pinId": "d"
          }
        }
      }
    },
    "id": "90dc2942-52fa-4e09-bcef-43fa97cc0b72",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "50d23b21-1513-42c0-9722-4a01a32dc161": {
    "name": "add circle",
    "units": {
      "addarc": {
        "id": "6796cd2d-2bd2-4dd3-9396-49d6bc1d2652"
      },
      "merge3": {
        "id": "23b844e3-1cef-4ff7-9e2a-bb3ffb613055",
        "input": {
          "c": {
            "constant": true,
            "data": "{start:0}"
          },
          "b": {
            "constant": true,
            "data": "{end:6.283185307179586}"
          }
        }
      }
    },
    "merges": {
      "0": {
        "addarc": {
          "input": {
            "arc": true
          }
        },
        "merge3": {
          "output": {
            "abc": true
          }
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "add a circular arc to the current sub-path",
      "tags": [
        "platform",
        "core",
        "canvas"
      ]
    },
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "addarc",
            "pinId": "d"
          }
        }
      },
      "circle": {
        "plug": {
          "0": {
            "unitId": "merge3",
            "pinId": "a"
          }
        },
        "type": "{x:number,y:number,r:number}"
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "addarc",
            "pinId": "d"
          }
        }
      }
    },
    "id": "50d23b21-1513-42c0-9722-4a01a32dc161",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "89cc231d-07a1-49a0-8dcb-6af7aba1ca18": {
    "type": "\`U\`&\`G\`",
    "name": "icon names",
    "units": {
      "icons": {
        "id": "72c84615-4d9c-4a82-a828-fa5d9447a4d5",
        "input": {
          "any": {}
        },
        "output": {
          "icons": {}
        }
      },
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {}
        },
        "output": {
          "keys": {}
        }
      }
    },
    "merges": {
      "0": {
        "icons": {
          "output": {
            "icons": true
          }
        },
        "keys": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "icons",
            "pinId": "any"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "keys": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "keys"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "question",
      "description": "all icon names",
      "tags": [
        "platform",
        "core",
        "asset"
      ]
    },
    "id": "89cc231d-07a1-49a0-8dcb-6af7aba1ca18",
    "system": true
  },
  "8d3a4d38-3015-46f2-81d7-694644cec386": {
    "type": "\`U\`&\`C\`&\`G\`",
    "name": "icon grid",
    "units": {
      "iconnames": {
        "id": "89cc231d-07a1-49a0-8dcb-6af7aba1ca18",
        "input": {
          "any": {
            "constant": false,
            "ignored": false
          }
        },
        "output": {
          "keys": {
            "constant": false,
            "ignored": false
          }
        }
      },
      "appendchild": {
        "id": "ee4715e6-f479-11ea-b231-bf95a7f38a99",
        "input": {
          "parent": {
            "ignored": false,
            "constant": false
          },
          "child": {
            "ignored": false,
            "constant": false
          }
        },
        "output": {
          "at": {
            "ignored": true,
            "constant": false
          }
        }
      },
      "setinput": {
        "id": "43b43afd-9e7d-44ba-aef7-6e9db4ed8744",
        "input": {
          "unit": {
            "ignored": false,
            "constant": false
          },
          "name": {
            "ignored": false,
            "constant": true,
            "data": "'icon'"
          },
          "data": {
            "ignored": false,
            "constant": false
          }
        },
        "output": {
          "unit": {
            "ignored": false,
            "constant": false
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {
            "constant": false,
            "ignored": false
          }
        },
        "output": {
          "a[i]": {
            "constant": false,
            "ignored": false
          },
          "a": {
            "constant": false,
            "ignored": true
          },
          "i": {
            "constant": false,
            "ignored": true
          },
          "test": {
            "constant": false,
            "ignored": true
          }
        }
      },
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {
            "ignored": false,
            "constant": true,
            "data": "{display:'grid',\\"grid-template-columns\\":'1fr 1fr 1fr 1fr',height:'fit-content',gap:'12px',padding:'12px'}"
          }
        },
        "output": {},
        "metadata": {
          "component": {
            "width": 192.5234375,
            "height": 188.8046875
          }
        }
      },
      "spark": {
        "id": "3be8272d-310a-4aa2-84a1-71f590a8227a",
        "input": {
          "a": {
            "ignored": false,
            "constant": true,
            "data": "null"
          }
        },
        "output": {
          "a": {
            "ignored": false,
            "constant": false
          }
        }
      },
      "setinput0": {
        "id": "43b43afd-9e7d-44ba-aef7-6e9db4ed8744",
        "input": {
          "unit": {
            "ignored": false,
            "constant": true,
            "data": "\${unit:{id:'63a417e5-d354-4b39-9ebd-05f55e70de7b',input:{icon:{data:\\"'zoom-out'\\"},style:{data:\\"{height:'24px',width:'24px'}\\"}}}}"
          },
          "name": {
            "ignored": false,
            "constant": true,
            "data": "'style'"
          },
          "data": {
            "ignored": false,
            "constant": true,
            "data": "{'aspect-ratio':1}"
          }
        },
        "output": {
          "unit": {
            "ignored": false,
            "constant": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "setinput": {
          "output": {
            "unit": true
          }
        },
        "appendchild": {
          "input": {
            "child": true
          }
        }
      },
      "1": {
        "iconnames": {
          "output": {
            "keys": true
          }
        },
        "foreach": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "setinput0": {
          "output": {
            "unit": true
          }
        },
        "setinput": {
          "input": {
            "unit": true
          }
        }
      },
      "3": {
        "appendchild": {
          "input": {
            "parent": true
          }
        },
        "div": {
          "output": {
            "_self": true
          }
        }
      },
      "4": {
        "spark": {
          "output": {
            "a": true
          }
        },
        "iconnames": {
          "input": {
            "any": true
          }
        }
      },
      "5": {
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "setinput": {
          "input": {
            "data": true
          }
        }
      }
    },
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "grid showin",
      "tags": [
        "platform",
        "core",
        "asset"
      ]
    },
    "id": "8d3a4d38-3015-46f2-81d7-694644cec386",
    "render": true,
    "component": {
      "subComponents": {
        "div": {}
      },
      "children": [
        "div"
      ],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "system": true
  },
  "7b067f38-e437-11ea-ad36-13112ed6b20b": {
    "name": "set color",
    "inputs": {
      "color": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 46,
              "y": 37
            }
          }
        }
      },
      "context": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -91,
              "y": -1
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -65,
                "y": -1
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'color'",
            "metadata": {
              "position": {
                "x": 27,
                "y": -19
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 27,
                "y": 18
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -17,
            "y": -1
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "object-set",
      "description": "set context color",
      "tags": [
        "platform",
        "core",
        "api",
        "set"
      ]
    },
    "id": "7b067f38-e437-11ea-ad36-13112ed6b20b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b97d77a2-bf51-4bf9-aa72-2956c26ce1ab": {
    "type": "\`U\`&\`G\`",
    "name": "deep set metadata icon",
    "units": {
      "deepsetmetadata": {
        "id": "dafd2596-f53f-44fa-b82c-2e8b1587ba9c",
        "input": {
          "obj": {},
          "value": {
            "constant": false
          },
          "path": {
            "constant": true,
            "data": "[\\"icon\\"]"
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "deepsetmetadata",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "deepsetmetadata",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "deep set \`obj\` metadata icon property",
      "tags": [
        "platform",
        "core",
        "api",
        "set"
      ]
    },
    "id": "b97d77a2-bf51-4bf9-aa72-2956c26ce1ab",
    "system": true
  },
  "dafd2596-f53f-44fa-b82c-2e8b1587ba9c": {
    "type": "\`U\`&\`G\`",
    "name": "deep set metadata",
    "units": {
      "concat": {
        "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728",
        "input": {
          "a": {
            "constant": true,
            "data": "[\\"metadata\\"]",
            "metadata": {
              "position": {
                "x": 72,
                "y": 14
              }
            }
          },
          "b": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 72,
                "y": -22
              }
            }
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": 27,
            "y": -4
          }
        }
      },
      "deepset": {
        "id": "64f8e8bc-124d-49f6-a143-625265eafe68",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -124,
                "y": 14
              }
            }
          },
          "path": {},
          "value": {
            "metadata": {
              "position": {
                "x": -124,
                "y": -22
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -79,
            "y": -4
          }
        }
      }
    },
    "merges": {
      "0": {
        "concat": {
          "output": {
            "ab": true
          }
        },
        "deepset": {
          "input": {
            "path": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "deepset",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -140,
                "y": 31
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "deepset",
            "pinId": "value",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -140,
                "y": -39
              }
            }
          }
        }
      },
      "path": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 88,
                "y": -39
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "deep set \`obj\` \\"metadata\\" property",
      "position": {
        "merge": {
          "0": {
            "x": -26,
            "y": -4
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "set"
      ]
    },
    "id": "dafd2596-f53f-44fa-b82c-2e8b1587ba9c",
    "system": true
  },
  "16fa715f-fc94-43f7-831e-335037c8daea": {
    "type": "\`U\`&\`G\`",
    "name": "peer share graph",
    "units": {
      "parsejson": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
        "input": {
          "string": {}
        },
        "output": {
          "json": {}
        },
        "metadata": {
          "position": {
            "x": 129,
            "y": -30
          }
        }
      },
      "onmessage": {
        "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
        "input": {
          "emitter": {
            "metadata": {
              "position": {
                "x": 253,
                "y": -28
              }
            }
          }
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 28,
            "y": -43
          }
        }
      },
      "send": {
        "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
        "input": {
          "channel": {
            "metadata": {
              "position": {
                "x": -253,
                "y": -76
              }
            }
          },
          "data": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 21,
            "y": -109
          }
        }
      },
      "peertransmitter": {
        "id": "7375aad5-50fd-403c-80ae-471b95088f04",
        "input": {
          "answer": {
            "metadata": {
              "position": {
                "x": -54,
                "y": -31
              }
            }
          },
          "stream": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -98,
                "y": -19
              }
            }
          },
          "opt": {
            "metadata": {
              "position": {
                "x": -125,
                "y": -36
              }
            }
          },
          "close": {
            "metadata": {
              "position": {
                "x": -137,
                "y": -66
              }
            }
          }
        },
        "output": {
          "offer": {
            "metadata": {
              "position": {
                "x": -122,
                "y": -95
              }
            }
          },
          "channel": {
            "metadata": {
              "position": {
                "x": -24,
                "y": -73
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -86,
            "y": -63
          }
        }
      },
      "stringify": {
        "id": "2b24877a-3221-4288-9f59-efbf29964368",
        "input": {
          "a": {}
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": 122,
            "y": -127
          }
        }
      },
      "remotesharegraph": {
        "id": "727133c9-3e87-4219-a91e-a257c9b2669b",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": 263,
                "y": -67
              }
            }
          },
          "opt": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": 262,
                "y": -101
              },
              "data": {
                "position": {
                  "x": 295,
                  "y": -122
                }
              }
            }
          },
          "message": {},
          "done": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 274,
                "y": -84
              }
            }
          }
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 216,
            "y": -83
          }
        }
      }
    },
    "merges": {
      "0": {
        "parsejson": {
          "input": {
            "string": true
          }
        },
        "onmessage": {
          "output": {
            "message": true
          }
        }
      },
      "1": {
        "remotesharegraph": {
          "output": {
            "message": true
          }
        },
        "stringify": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "send": {
          "input": {
            "data": true
          }
        },
        "stringify": {
          "output": {
            "str": true
          }
        }
      },
      "3": {
        "remotesharegraph": {
          "input": {
            "message": true
          }
        },
        "parsejson": {
          "output": {
            "json": true
          }
        }
      },
      "4": {
        "send": {
          "input": {
            "channel": true
          }
        },
        "peertransmitter": {
          "output": {
            "channel": true
          }
        },
        "onmessage": {
          "input": {
            "emitter": true
          }
        }
      }
    },
    "inputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "peertransmitter",
            "pinId": "opt",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -139,
                "y": -16
              }
            }
          }
        },
        "functional": true
      },
      "answer": {
        "plug": {
          "0": {
            "unitId": "peertransmitter",
            "pinId": "answer",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -53,
                "y": -7
              }
            }
          }
        }
      },
      "close": {
        "plug": {
          "0": {
            "unitId": "peertransmitter",
            "pinId": "close",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -161,
                "y": -68
              }
            }
          }
        },
        "defaultIgnored": true
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "remotesharegraph",
            "pinId": "graph",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 283,
                "y": -54
              }
            }
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "offer": {
        "plug": {
          "0": {
            "unitId": "peertransmitter",
            "pinId": "offer",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -134,
                "y": -117
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "link",
      "description": "allow remote peer to connect to this graph",
      "position": {
        "merge": {
          "0": {
            "x": 78,
            "y": -29
          },
          "1": {
            "x": 173,
            "y": -112
          },
          "2": {
            "x": 70,
            "y": -126
          },
          "3": {
            "x": 177,
            "y": -50
          }
        },
        "data": {
          "x": -151,
          "y": -151
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "peer"
      ]
    },
    "id": "16fa715f-fc94-43f7-831e-335037c8daea",
    "system": true
  },
  "d4ec46ab-d065-4d1c-9357-fa8b95be0c36": {
    "type": "\`U\`&\`G\`",
    "name": "peer graph",
    "units": {
      "parsejson": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
        "input": {
          "string": {}
        },
        "output": {
          "json": {}
        },
        "metadata": {
          "position": {
            "x": 166,
            "y": 27
          }
        }
      },
      "onmessage": {
        "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
        "input": {
          "emitter": {
            "metadata": {
              "position": {
                "x": 253,
                "y": -28
              }
            }
          }
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 64,
            "y": 8
          }
        }
      },
      "send": {
        "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
        "input": {
          "channel": {
            "metadata": {
              "position": {
                "x": -253,
                "y": -76
              }
            }
          },
          "data": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 61,
            "y": -63
          }
        }
      },
      "stringify": {
        "id": "2b24877a-3221-4288-9f59-efbf29964368",
        "input": {
          "a": {}
        },
        "output": {
          "str": {}
        },
        "metadata": {
          "position": {
            "x": 161,
            "y": -87
          }
        }
      },
      "peerreceiver": {
        "id": "f079a38e-fb4f-496e-8e5f-d5e03a590cda",
        "input": {
          "offer": {
            "metadata": {
              "position": {
                "x": -19,
                "y": 10
              }
            }
          },
          "close": {
            "metadata": {
              "position": {
                "x": -84,
                "y": 13
              }
            }
          },
          "opt": {
            "metadata": {
              "position": {
                "x": -101,
                "y": -14
              }
            }
          }
        },
        "output": {
          "stream": {
            "metadata": {
              "position": {
                "x": -102,
                "y": -48
              }
            }
          },
          "answer": {
            "metadata": {
              "position": {
                "x": -45,
                "y": -66
              }
            }
          },
          "channel": {
            "metadata": {
              "position": {
                "x": 15,
                "y": -27
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": -22
          }
        }
      },
      "remotegraph": {
        "id": "57bcdd88-a4f4-49ab-92d4-ed1969895520",
        "input": {
          "opt": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": 206,
                "y": -32
              },
              "data": {
                "position": {
                  "x": 175,
                  "y": -31
                }
              }
            }
          },
          "close": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 289,
                "y": -60
              }
            }
          },
          "message": {}
        },
        "output": {
          "graph": {
            "metadata": {
              "position": {
                "x": 306,
                "y": -32
              }
            }
          },
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 250,
            "y": -32
          }
        }
      }
    },
    "merges": {
      "0": {
        "parsejson": {
          "input": {
            "string": true
          }
        },
        "onmessage": {
          "output": {
            "message": true
          }
        }
      },
      "1": {
        "remotegraph": {
          "output": {
            "message": true
          }
        },
        "stringify": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "send": {
          "input": {
            "data": true
          }
        },
        "stringify": {
          "output": {
            "str": true
          }
        }
      },
      "3": {
        "remotegraph": {
          "input": {
            "message": true
          }
        },
        "parsejson": {
          "output": {
            "json": true
          }
        }
      },
      "4": {
        "send": {
          "input": {
            "channel": true
          }
        },
        "onmessage": {
          "input": {
            "emitter": true
          }
        }
      },
      "5": {
        "peerreceiver": {
          "output": {
            "channel": true
          }
        },
        "send": {
          "input": {
            "channel": true
          }
        },
        "onmessage": {
          "input": {
            "emitter": true
          }
        }
      }
    },
    "inputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "peerreceiver",
            "pinId": "opt",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -125,
                "y": -6
              }
            }
          }
        },
        "functional": true
      },
      "close": {
        "plug": {
          "0": {
            "unitId": "peerreceiver",
            "pinId": "close",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -96,
                "y": 35
              }
            }
          }
        },
        "defaultIgnored": true
      },
      "offer": {
        "plug": {
          "0": {
            "unitId": "peerreceiver",
            "pinId": "offer",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -16,
                "y": 35
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "link",
      "description": "remote peer graph",
      "position": {
        "merge": {
          "0": {
            "x": 113,
            "y": 27
          },
          "1": {
            "x": 212,
            "y": -69
          },
          "2": {
            "x": 108,
            "y": -84
          },
          "3": {
            "x": 215,
            "y": 7
          },
          "4": {
            "x": 128,
            "y": -29
          }
        },
        "data": {
          "x": -248,
          "y": 26
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "peer"
      ]
    },
    "id": "d4ec46ab-d065-4d1c-9357-fa8b95be0c36",
    "outputs": {
      "answer": {
        "plug": {
          "0": {
            "unitId": "peerreceiver",
            "pinId": "answer",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -46,
                "y": -90
              }
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "remotegraph",
            "pinId": "graph",
            "kind": "output"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 336,
                "y": -33
              }
            }
          }
        }
      }
    },
    "system": true
  },
  "e98f03fc-0987-4d21-9642-9078b23183ed": {
    "name": "get devices of kind",
    "units": {
      "enumeratedevices": {
        "id": "3511f756-2a02-4346-b417-8c34502f79d4"
      },
      "filterpropequals": {
        "id": "f0386b2f-de73-49a3-be8f-1a2ca10600c5",
        "input": {
          "key": {
            "constant": true,
            "data": "'kind'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "enumeratedevices": {
          "output": {
            "devices": true
          }
        },
        "filterpropequals": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "enumeratedevices": {
          "input": {
            "any": true
          }
        },
        "filterpropequals": {
          "input": {
            "value": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "get all available device descriptions of \`kind\`",
      "tags": [
        "platform",
        "core",
        "api",
        "media"
      ]
    },
    "inputs": {
      "kind": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "name": "kind"
      }
    },
    "outputs": {
      "devices": {
        "plug": {
          "0": {
            "unitId": "filterpropequals",
            "pinId": "b"
          }
        },
        "name": "devices"
      }
    },
    "id": "e98f03fc-0987-4d21-9642-9078b23183ed",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4ed1cdd6-1514-4871-9845-489366cf3dbd": {
    "type": "\`U\`&\`G\`",
    "name": "location search",
    "units": {
      "parseurl": {
        "id": "81ac8195-57ed-4b22-b8b8-fe3e68b11af0",
        "input": {
          "url": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -1,
            "y": -104
          }
        }
      },
      "location": {
        "id": "30f6738c-1938-4dcd-9e7f-6c10f9730021",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": 147,
                "y": -101
              }
            }
          }
        },
        "output": {
          "url": {}
        },
        "metadata": {
          "position": {
            "x": 99,
            "y": -101
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "\\"search\\"",
            "metadata": {
              "position": {
                "x": -152,
                "y": -121
              },
              "data": {
                "position": {
                  "x": -201,
                  "y": -118
                }
              }
            }
          }
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": -72,
                "y": -154
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -103,
            "y": -122
          }
        }
      }
    },
    "merges": {
      "0": {
        "parseurl": {
          "input": {
            "url": true
          }
        },
        "location": {
          "output": {
            "url": true
          }
        }
      },
      "1": {
        "parseurl": {
          "output": {
            "obj": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "location",
            "pinId": "any"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 170,
                "y": -101
              }
            }
          }
        }
      }
    },
    "outputs": {
      "search": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -72,
                "y": -177
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "map-pin",
      "description": "get current web context location url search",
      "position": {
        "merge": {
          "0": {
            "x": 50,
            "y": -102
          },
          "1": {
            "x": -53,
            "y": -109
          }
        },
        "data": {
          "x": -71,
          "y": -212
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "location"
      ]
    },
    "id": "4ed1cdd6-1514-4871-9845-489366cf3dbd",
    "system": true
  },
  "74aea9dc-5247-4689-816f-2a1f24abbfc8": {
    "type": "\`U\`&\`G\`",
    "name": "location query",
    "units": {
      "parsequery": {
        "id": "02f91720-c4d5-4d66-ae91-d46ddc635722",
        "input": {
          "str": {}
        },
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": 85,
                "y": -46
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 38,
            "y": -46
          }
        }
      },
      "locationsearch": {
        "id": "4ed1cdd6-1514-4871-9845-489366cf3dbd",
        "metadata": {
          "position": {
            "x": -63,
            "y": -46
          }
        },
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": -112,
                "y": -46
              }
            }
          }
        }
      }
    },
    "merges": {
      "2": {
        "parsequery": {
          "input": {
            "str": true
          }
        },
        "locationsearch": {
          "output": {
            "search": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "locationsearch",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -134,
                "y": -46
              }
            }
          }
        }
      }
    },
    "outputs": {
      "query": {
        "plug": {
          "0": {
            "unitId": "parsequery",
            "pinId": "obj"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 108,
                "y": -46
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "map-pin",
      "description": "get current web context location url query",
      "tags": [
        "platform",
        "core",
        "api",
        "location"
      ],
      "complexity": 10,
      "position": {
        "data": {
          "x": 144,
          "y": -46
        },
        "merge": {
          "2": {
            "x": -12,
            "y": -46
          }
        }
      }
    },
    "id": "74aea9dc-5247-4689-816f-2a1f24abbfc8",
    "system": true
  },
  "d7a85938-eb33-4b14-bb99-32a60c275dc6": {
    "type": "\`U\`&\`G\`",
    "name": "location origin",
    "units": {
      "parseurl": {
        "id": "81ac8195-57ed-4b22-b8b8-fe3e68b11af0",
        "input": {
          "url": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -1,
            "y": -104
          }
        }
      },
      "location": {
        "id": "30f6738c-1938-4dcd-9e7f-6c10f9730021",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": 147,
                "y": -101
              }
            }
          }
        },
        "output": {
          "url": {}
        },
        "metadata": {
          "position": {
            "x": 99,
            "y": -101
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "\\"origin\\"",
            "metadata": {
              "position": {
                "x": -152,
                "y": -121
              },
              "data": {
                "position": {
                  "x": -201,
                  "y": -118
                }
              }
            }
          }
        },
        "output": {
          "origin": {
            "metadata": {
              "position": {
                "x": -72,
                "y": -154
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -103,
            "y": -122
          }
        }
      }
    },
    "merges": {
      "0": {
        "parseurl": {
          "input": {
            "url": true
          }
        },
        "location": {
          "output": {
            "url": true
          }
        }
      },
      "1": {
        "parseurl": {
          "output": {
            "obj": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "location",
            "pinId": "any"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 170,
                "y": -101
              }
            }
          }
        }
      }
    },
    "outputs": {
      "origin": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -72,
                "y": -177
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "map-pin",
      "description": "get current web context location url origin",
      "position": {
        "merge": {
          "0": {
            "x": 50,
            "y": -102
          },
          "1": {
            "x": -53,
            "y": -109
          }
        },
        "data": {
          "x": -71,
          "y": -212
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "location"
      ]
    },
    "id": "d7a85938-eb33-4b14-bb99-32a60c275dc6",
    "system": true
  },
  "00682850-3e30-11eb-86ea-8f1c604946aa": {
    "name": "get width",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 123,
              "y": 33
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -120,
              "y": 33
            }
          }
        }
      }
    },
    "outputs": {
      "width": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 123,
              "y": -34
            }
          }
        }
      }
    },
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 100,
                "y": 17
              }
            }
          },
          "name": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 100,
                "y": -18
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 55,
            "y": 0
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'width'",
            "metadata": {
              "position": {
                "x": -97,
                "y": -18
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -97,
                "y": 17
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait0": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"width\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 2,
            "y": 0
          }
        }
      }
    },
    "id": "00682850-3e30-11eb-86ea-8f1c604946aa",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d74f12c2-1868-11eb-8136-238c1b1a727f": {
    "name": "get value",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -125,
              "y": -34
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 120,
              "y": 33
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -125,
              "y": 33
            }
          }
        }
      }
    },
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -102,
                "y": -18
              }
            }
          },
          "name": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": -102,
                "y": 17
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -56,
            "y": 0
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'value'",
            "metadata": {
              "position": {
                "x": 97,
                "y": -18
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": 97,
                "y": 17
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait0": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"value\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -2,
            "y": 0
          }
        }
      }
    },
    "id": "d74f12c2-1868-11eb-8136-238c1b1a727f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c0dfeea2-4c9c-45df-99ea-d458925ddc94": {
    "name": "get src",
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'src'"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "src": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"src\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ]
    },
    "id": "c0dfeea2-4c9c-45df-99ea-d458925ddc94",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6a2e05c5-9753-4511-9e10-a8fba6491c29": {
    "name": "get sender",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 123,
              "y": 33
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -120,
              "y": 33
            }
          }
        }
      }
    },
    "outputs": {
      "sender": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 123,
              "y": -34
            }
          }
        }
      }
    },
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 100,
                "y": 17
              }
            }
          },
          "name": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 100,
                "y": -18
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 55,
            "y": 0
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'sender'",
            "metadata": {
              "position": {
                "x": -97,
                "y": -18
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -97,
                "y": 17
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait0": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"sender\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 2,
            "y": 0
          }
        }
      }
    },
    "id": "6a2e05c5-9753-4511-9e10-a8fba6491c29",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "3bc6b974-594b-41b8-96d2-2189d58bfcd2": {
    "name": "get search",
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'search'"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "search": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"search\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ]
    },
    "id": "3bc6b974-594b-41b8-96d2-2189d58bfcd2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c51a275d-8610-452d-a136-7a2b58d8caf2": {
    "type": "\`U\`&\`G\`",
    "name": "get pointerId",
    "units": {
      "get1": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "pointerId"
            }
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get1",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get1",
            "pinId": "value",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"pointerId\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ]
    },
    "id": "c51a275d-8610-452d-a136-7a2b58d8caf2",
    "system": true
  },
  "3a8a68cc-2ec7-11eb-a2b8-df0a171f0ba5": {
    "name": "get origin",
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'origin'"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "origin": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"origin\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ]
    },
    "id": "3a8a68cc-2ec7-11eb-a2b8-df0a171f0ba5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d0349c4b-8d69-48f0-a5ac-9e6beffce765": {
    "name": "get items",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -125,
              "y": -34
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 120,
              "y": 33
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -125,
              "y": 33
            }
          }
        }
      }
    },
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -102,
                "y": -18
              }
            }
          },
          "name": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": -102,
                "y": 17
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -56,
            "y": 0
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'value'",
            "metadata": {
              "position": {
                "x": 97,
                "y": -18
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": 97,
                "y": 17
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait0": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"items\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -2,
            "y": 0
          }
        }
      }
    },
    "id": "d0349c4b-8d69-48f0-a5ac-9e6beffce765",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9a695a17-a448-457f-90c2-02aed4b392af": {
    "name": "get hostname",
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'hostname'"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "hostname": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"hostname\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ]
    },
    "id": "9a695a17-a448-457f-90c2-02aed4b392af",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "38b257d7-fa9d-483f-b858-4a0e6cbf7f66": {
    "name": "get host",
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'host'"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "host": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"host\\" property",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ]
    },
    "id": "38b257d7-fa9d-483f-b858-4a0e6cbf7f66",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f513667c-3e2f-11eb-8a96-4fbfb5c1b798": {
    "name": "get height",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 123,
              "y": 33
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -120,
              "y": 33
            }
          }
        }
      }
    },
    "outputs": {
      "height": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 123,
              "y": -34
            }
          }
        }
      }
    },
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 100,
                "y": 17
              }
            }
          },
          "name": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 100,
                "y": -18
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 55,
            "y": 0
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "'height'",
            "metadata": {
              "position": {
                "x": -97,
                "y": -18
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -97,
                "y": 17
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait0": {
          "output": {
            "a": true
          }
        },
        "get": {
          "input": {
            "name": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` \\"height\\"",
      "tags": [
        "platform",
        "core",
        "api",
        "get"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 2,
            "y": 0
          }
        }
      }
    },
    "id": "f513667c-3e2f-11eb-8a96-4fbfb5c1b798",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5fdbcbc3-079b-40dd-b133-5a3ec3972032": {
    "type": "\`U\`&\`G\`",
    "name": "read file as text",
    "units": {
      "emptyobject": {
        "id": "dc6e6bc0-081b-11eb-baf7-b7383b70c236",
        "input": {
          "any": {}
        },
        "output": {
          "{}": {}
        },
        "metadata": {
          "position": {
            "x": -22,
            "y": -84
          }
        }
      },
      "filereader": {
        "id": "f8485868-345a-416a-b323-547ddcb068ad",
        "input": {
          "opt": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 240,
                "y": -15
              },
              "data": {
                "position": {
                  "x": 275,
                  "y": -26
                }
              }
            }
          },
          "done": {
            "metadata": {
              "position": {
                "x": 233,
                "y": 19
              }
            },
            "ignored": true
          }
        },
        "output": {
          "reader": {
            "metadata": {
              "position": {
                "x": 134,
                "y": -17
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 191,
            "y": -3
          }
        }
      },
      "readastext": {
        "id": "e025d8e5-baa2-4411-864d-4db6fc42220f",
        "input": {
          "reader": {},
          "file": {},
          "opt": {
            "metadata": {
              "position": {
                "x": 223,
                "y": 10
              }
            }
          }
        },
        "output": {
          "text": {
            "metadata": {
              "position": {
                "x": 218,
                "y": 43
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 78,
            "y": -41
          }
        }
      }
    },
    "merges": {
      "1": {
        "filereader": {
          "output": {
            "reader": true
          }
        },
        "readastext": {
          "input": {
            "reader": true
          }
        }
      },
      "9": {
        "emptyobject": {
          "output": {
            "{}": true
          }
        },
        "filereader": {
          "input": {
            "opt": true
          }
        },
        "readastext": {
          "input": {
            "opt": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "emptyobject",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false
      },
      "file": {
        "plug": {
          "0": {
            "unitId": "readastext",
            "pinId": "file",
            "kind": "input"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "text": {
        "plug": {
          "0": {
            "unitId": "readastext",
            "pinId": "text",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "asynchronously read the contents of a file as text",
      "tags": [
        "platform",
        "core",
        "api",
        "file"
      ]
    },
    "id": "5fdbcbc3-079b-40dd-b133-5a3ec3972032",
    "system": true
  },
  "9256571c-db04-4559-a0a6-b8b0d107861f": {
    "name": "on set",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'set'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` \\"set\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "9256571c-db04-4559-a0a6-b8b0d107861f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f1e3b2aa-1215-49f0-a2cd-2ef7178a4374": {
    "name": "watch input",
    "units": {
      "getvalue": {
        "id": "d74f12c2-1868-11eb-8136-238c1b1a727f",
        "input": {
          "obj": {},
          "any": {
            "data": "1"
          }
        },
        "output": {
          "value": {}
        }
      },
      "oninput": {
        "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        }
      }
    },
    "merges": {
      "0": {
        "oninput": {
          "input": {
            "element": true
          }
        },
        "getvalue": {
          "input": {
            "obj": true
          }
        }
      },
      "1": {
        "oninput": {
          "output": {
            "event": true
          }
        },
        "getvalue": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "getvalue",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "output \`element\` value and listen \\"input\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "f1e3b2aa-1215-49f0-a2cd-2ef7178a4374",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9a652f1b-f65f-4f3b-888a-2d90ddb43713": {
    "name": "watch change",
    "units": {
      "getvalue": {
        "id": "d74f12c2-1868-11eb-8136-238c1b1a727f",
        "input": {
          "obj": {},
          "any": {
            "data": "1"
          }
        },
        "output": {
          "value": {}
        }
      },
      "onchange": {
        "id": "7f25303a-b1ee-11ea-bab2-5f81e27c8466",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        }
      }
    },
    "merges": {
      "0": {
        "onchange": {
          "input": {
            "element": true
          }
        },
        "getvalue": {
          "input": {
            "obj": true
          }
        }
      },
      "1": {
        "onchange": {
          "output": {
            "event": true
          }
        },
        "getvalue": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "getvalue",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "output \`element\` value and listen \\"input\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "9a652f1b-f65f-4f3b-888a-2d90ddb43713",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5fe94b90-2618-11eb-b06a-5fc0ce62fd27": {
    "name": "tag event",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'event'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{event: \`event\`}",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{event}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "5fe94b90-2618-11eb-b06a-5fc0ce62fd27",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7a602db8-2618-11eb-b9c6-4bb45b6d8833": {
    "name": "tag data",
    "units": {
      "tag": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'data'"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "{data: \`data\`}",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "inputs": {
      "data": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "{data}": {
        "plug": {
          "0": {
            "unitId": "tag",
            "pinId": "kv"
          }
        }
      }
    },
    "id": "7a602db8-2618-11eb-b9c6-4bb45b6d8833",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "52e6d3c8-0958-4829-bc25-1f6cdbf6e451": {
    "name": "on wheel",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'wheel'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` wheel event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "52e6d3c8-0958-4829-bc25-1f6cdbf6e451",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d0e6f14c-400c-42f3-bfd6-1bbe0146f490": {
    "name": "on value",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'value'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` input event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "d0e6f14c-400c-42f3-bfd6-1bbe0146f490",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9649cf39-fd6e-4437-a268-c0b4def6bcbd": {
    "name": "on toggle",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'toggle'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` click event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "9649cf39-fd6e-4437-a268-c0b4def6bcbd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cbb19840-081e-11eb-918d-3f728eda5672": {
    "name": "on show",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'show'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` \\"show\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "cbb19840-081e-11eb-918d-3f728eda5672",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9fd9d2ea-98a7-11eb-8aa3-fbeb43cb1944": {
    "name": "on resize",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "emitter": {
            "metadata": {
              "position": {
                "x": -15,
                "y": 26
              }
            }
          },
          "event": {
            "data": "'_resize'",
            "constant": true,
            "metadata": {
              "position": {
                "x": -34,
                "y": -7
              }
            }
          },
          "remove": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -15,
                "y": -39
              }
            }
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": 66,
                "y": -7
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 17,
            "y": -7
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` 'resize' event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "9fd9d2ea-98a7-11eb-8aa3-fbeb43cb1944",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "43a9d452-b1ee-11ea-923f-efb4af36e68e": {
    "name": "on pointer up",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'pointerup'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` pointerup event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "43a9d452-b1ee-11ea-923f-efb4af36e68e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6e45f29a-b1ee-11ea-908d-c7724f096465": {
    "name": "on pointer move",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'pointermove'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` pointerup event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "6e45f29a-b1ee-11ea-908d-c7724f096465",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c7dba94e-af78-11ea-b7d7-47e14ca215b5": {
    "name": "on pointer leave",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'pointerleave'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` pointerleave event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "c7dba94e-af78-11ea-b7d7-47e14ca215b5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c0bb493a-af78-11ea-b6fa-3b893b757a39": {
    "name": "on pointer enter",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'pointerenter'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` pointerenter event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "c0bb493a-af78-11ea-b6fa-3b893b757a39",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2beefe96-b1ee-11ea-960c-7f33e07a2ad6": {
    "name": "on pointer down",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'pointerdown'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` pointerdown event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "2beefe96-b1ee-11ea-960c-7f33e07a2ad6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6151735b-8120-4f42-bad0-8c83dccbcc8c": {
    "name": "on pointer cancel",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'pointercancel'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` pointercancel event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "6151735b-8120-4f42-bad0-8c83dccbcc8c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ec03bf8a-30f8-11eb-b4a7-a77c38c8f1b3": {
    "name": "on paste",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'paste'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` paste event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "ec03bf8a-30f8-11eb-b4a7-a77c38c8f1b3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "08467719-795a-4f08-838b-314ac6f4f814": {
    "name": "on open",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'open'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` \\"open\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "08467719-795a-4f08-838b-314ac6f4f814",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6ecc9c94-98bd-11eb-845c-dfd895d4184c": {
    "name": "on mount",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "emitter": {
            "metadata": {
              "position": {
                "x": -15,
                "y": 26
              }
            }
          },
          "event": {
            "data": "'mount'",
            "constant": true,
            "metadata": {
              "position": {
                "x": -34,
                "y": -7
              }
            }
          },
          "remove": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -15,
                "y": -39
              }
            }
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": 66,
                "y": -7
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 17,
            "y": -7
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` 'mount' event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "6ecc9c94-98bd-11eb-845c-dfd895d4184c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "23c3952a-ef19-11ea-b80e-3f693508091e": {
    "name": "on message",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'message'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "emitter": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "_type": "<T:\`EE\`>",
        "ref": true
      }
    },
    "outputs": {
      "message": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        },
        "_type": "<T:\`EE\`>['message']"
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` message event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6340cbb4-effc-4831-ac12-e9c00e685685": {
    "name": "on loaded data",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'loadeddata'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` load event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "6340cbb4-effc-4831-ac12-e9c00e685685",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "be8e421f-efc8-4b58-a091-28514f395fd8": {
    "name": "on load",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'load'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` load event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "be8e421f-efc8-4b58-a091-28514f395fd8",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "30271eaa-ec9d-4979-8722-6af0aa85feb6": {
    "name": "on keyup",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'keyup'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` keyup event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "30271eaa-ec9d-4979-8722-6af0aa85feb6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "02dec0ae-a3b0-11eb-ab4e-afd7066a6476": {
    "name": "on keydown",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'keydown'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` keydown event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "02dec0ae-a3b0-11eb-ab4e-afd7066a6476",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b345c410-b1ee-11ea-b725-0b9ed734d65f": {
    "name": "on input",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'input'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` input event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "b345c410-b1ee-11ea-b725-0b9ed734d65f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "15507368-081f-11eb-aee1-d3c00ce4dd9d": {
    "name": "on error",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'error'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` \\"error\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "15507368-081f-11eb-aee1-d3c00ce4dd9d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b1c25165-f0dd-4f83-8fb1-1364b349da25": {
    "name": "on ended",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'ended'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` ended event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "b1c25165-f0dd-4f83-8fb1-1364b349da25",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "3bd7d771-05a8-4677-89d3-6077e7595521": {
    "name": "on edit",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'edit'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`graph\` edit event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "3bd7d771-05a8-4677-89d3-6077e7595521",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4638661f-11d9-4727-83d1-8cdccc01508c": {
    "name": "on drop",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'drop'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` click event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "4638661f-11d9-4727-83d1-8cdccc01508c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "90b783fe-a6a6-4026-9af6-fd853a5705f4": {
    "name": "on drag start",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'dragstart'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` dragstart event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "90b783fe-a6a6-4026-9af6-fd853a5705f4",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9b48ab2c-69f2-4869-bcc1-12a4cbaa4fce": {
    "name": "on drag over",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'dragover'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` click event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "9b48ab2c-69f2-4869-bcc1-12a4cbaa4fce",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d0972c71-45a8-4a01-8bf1-9ed588c13493": {
    "name": "on drag end",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'dragend'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` dragend event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "d0972c71-45a8-4a01-8bf1-9ed588c13493",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ae5c6f18-9ff9-11eb-986e-6fd93ceb151c": {
    "name": "on drag delta",
    "type": "\`U\`&\`G\`",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "ondrag",
            "pinId": "element"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "x": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "a - b"
          }
        }
      },
      "y": {
        "plug": {
          "0": {
            "unitId": "subtract0",
            "pinId": "a - b"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "6"
          }
        }
      }
    },
    "units": {
      "ondrag": {
        "id": "d4de180e-f1e8-4575-ab64-eaef413bcfc4",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": -174,
                "y": -1
              }
            }
          }
        },
        "output": {
          "move": {},
          "down": {},
          "up": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -166,
                "y": 24
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -74,
            "y": 48
          }
        }
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a - b": {
            "metadata": {
              "position": {
                "x": 126,
                "y": -63
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 135,
            "y": -31
          }
        }
      },
      "getclientxclienty": {
        "id": "1cbbfd58-c4ee-4c83-a5c8-83f614eb7027",
        "input": {
          "obj": {}
        },
        "output": {
          "y": {},
          "x": {}
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": -51
          }
        }
      },
      "getclientxclienty0": {
        "id": "1cbbfd58-c4ee-4c83-a5c8-83f614eb7027",
        "input": {
          "obj": {}
        },
        "output": {
          "y": {},
          "x": {}
        },
        "metadata": {
          "position": {
            "x": 39,
            "y": 36
          }
        }
      },
      "subtract0": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a - b": {
            "metadata": {
              "position": {
                "x": 126,
                "y": 61
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 132,
            "y": 28
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true
          },
          "current": {},
          "final": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": -39
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": -71,
            "y": 7
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": -159,
            "y": -3
          }
        }
      }
    },
    "merges": {
      "0": {
        "ondrag": {
          "output": {
            "down": true
          }
        },
        "looprepeat": {
          "input": {
            "init": true
          }
        }
      },
      "1": {
        "getclientxclienty0": {
          "input": {
            "obj": true
          }
        },
        "ondrag": {
          "output": {
            "move": true
          }
        },
        "true": {
          "input": {
            "any": true
          }
        }
      },
      "2": {
        "subtract": {
          "input": {
            "a": true
          }
        },
        "getclientxclienty0": {
          "output": {
            "x": true
          }
        }
      },
      "3": {
        "subtract": {
          "input": {
            "b": true
          }
        },
        "getclientxclienty": {
          "output": {
            "x": true
          }
        }
      },
      "4": {
        "subtract0": {
          "input": {
            "a": true
          }
        },
        "getclientxclienty0": {
          "output": {
            "y": true
          }
        }
      },
      "5": {
        "subtract0": {
          "input": {
            "b": true
          }
        },
        "getclientxclienty": {
          "output": {
            "y": true
          }
        }
      },
      "6": {
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "true": {
          "output": {
            "true": true
          }
        },
        "false": {
          "output": {
            "false": true
          }
        }
      },
      "7": {
        "false": {
          "input": {
            "any": true
          }
        },
        "ondrag": {
          "output": {
            "up": true
          }
        }
      },
      "8": {
        "getclientxclienty": {
          "input": {
            "obj": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      }
    },
    "metadata": {
      "icon": "grab",
      "description": "keep track of current pointer x y distance from initial press",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -72,
            "y": -22
          },
          "1": {
            "x": -72,
            "y": 20
          },
          "2": {
            "x": 33,
            "y": -15
          },
          "3": {
            "x": 28,
            "y": -55
          },
          "4": {
            "x": 28,
            "y": 52
          },
          "5": {
            "x": 33,
            "y": 13
          }
        }
      }
    },
    "id": "ae5c6f18-9ff9-11eb-986e-6fd93ceb151c",
    "system": true
  },
  "d4de180e-f1e8-4575-ab64-eaef413bcfc4": {
    "name": "on drag",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          },
          "2": {
            "unitId": "onpointerdown",
            "pinId": "element"
          },
          "3": {
            "unitId": "setpointercapture",
            "pinId": "element"
          },
          "4": {
            "unitId": "onpointerup",
            "pinId": "element"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 68,
              "y": -106
            },
            "1": {
              "x": 186,
              "y": 43
            },
            "2": {
              "x": -252,
              "y": 6
            },
            "3": {
              "x": 59,
              "y": 92
            },
            "4": {
              "x": 188,
              "y": -57
            }
          }
        }
      }
    },
    "outputs": {
      "move": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -6,
              "y": -116
            }
          }
        }
      },
      "down": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -139,
              "y": -13
            }
          }
        }
      },
      "up": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 72,
              "y": 12
            }
          }
        }
      }
    },
    "units": {
      "onpointerdown": {
        "id": "2beefe96-b1ee-11ea-960c-7f33e07a2ad6",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": -229,
                "y": 5
              }
            }
          }
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -178,
            "y": 5
          }
        }
      },
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "emitter": {
            "metadata": {
              "position": {
                "x": 61,
                "y": -83
              }
            }
          },
          "event": {},
          "remove": {
            "ignored": false
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": -1,
                "y": -92
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 24,
            "y": -52
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "\\"pointermove\\"",
            "metadata": {
              "position": {
                "x": -131,
                "y": -64
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -89,
            "y": -39
          }
        }
      },
      "setpointercapture": {
        "id": "d3fc887c-9fc5-11eb-8f63-ab42b0414469",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": 56,
                "y": 68
              }
            }
          },
          "pointerId": {},
          "done": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 27,
            "y": 32
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "\\"pointerId\\"",
            "metadata": {
              "position": {
                "x": -119,
                "y": 71
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -82,
            "y": 40
          }
        }
      },
      "onpointerup": {
        "id": "43a9d452-b1ee-11ea-923f-efb4af36e68e",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": 168,
                "y": -45
              }
            }
          }
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 118,
            "y": -33
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "onpointerdown": {
          "output": {
            "event": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      },
      "1": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "listen": {
          "input": {
            "event": true
          }
        }
      },
      "2": {
        "listen": {
          "input": {
            "remove": true
          }
        },
        "setpointercapture": {
          "input": {
            "done": true
          }
        },
        "onpointerup": {
          "output": {
            "event": true
          }
        }
      },
      "3": {
        "setpointercapture": {
          "input": {
            "pointerId": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      }
    },
    "metadata": {
      "icon": "grab",
      "description": "listen to pointer down, move and up events",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -123,
            "y": 3
          },
          "1": {
            "x": -33,
            "y": -50
          },
          "2": {
            "x": 67,
            "y": -10
          },
          "3": {
            "x": -27,
            "y": 43
          }
        }
      }
    },
    "id": "d4de180e-f1e8-4575-ab64-eaef413bcfc4",
    "type": "\`U\`&\`G\`",
    "component": {
      "subComponents": {},
      "children": [],
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "system": true
  },
  "40f9a40a-b4f2-11eb-baf1-933bfa98253e": {
    "name": "on double click",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'dbclick'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` double click event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "40f9a40a-b4f2-11eb-baf1-933bfa98253e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f7c43966-be6b-11eb-ac82-2f0415b064df": {
    "name": "on data available",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'dataavailable'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "data": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` message event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "f7c43966-be6b-11eb-ac82-2f0415b064df",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8809ad1e-91bf-11eb-a3ad-dbb373958321": {
    "name": "on data",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'data'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "data": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` message event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "8809ad1e-91bf-11eb-a3ad-dbb373958321",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2ef3ebd3-6447-4871-ba2f-f539a3fa02ff": {
    "name": "on close",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'close'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` \\"close\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "2ef3ebd3-6447-4871-ba2f-f539a3fa02ff",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "97c94516-add1-11ea-ba72-8f55299b735c": {
    "name": "on click",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'click'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` click event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "97c94516-add1-11ea-ba72-8f55299b735c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7b1eebd2-e8eb-11ea-a986-af42b73b3719": {
    "name": "on charact value changed",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'characteristicvaluechanged'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "charact": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to Bluetooth GATT \`characteristic\` value changed event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "7b1eebd2-e8eb-11ea-a986-af42b73b3719",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7f25303a-b1ee-11ea-bab2-5f81e27c8466": {
    "name": "on change",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'change'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`element\` change event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "7f25303a-b1ee-11ea-bab2-5f81e27c8466",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "60f1199f-d3e8-4968-8b48-4f8169a89602": {
    "name": "on button up",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'buttonup'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "gamepad": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`gamepad\` \\"buttonup\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "60f1199f-d3e8-4968-8b48-4f8169a89602",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "98c01feb-afc7-4333-988f-9d516b5038bd": {
    "name": "on button down",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'buttondown'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "gamepad": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`gamepad\` \\"buttondown\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "98c01feb-afc7-4333-988f-9d516b5038bd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1448dd43-3e1e-4709-a9e1-3562d61cc6f1": {
    "name": "on axis change",
    "units": {
      "listen": {
        "id": "367241d8-ad12-11ea-beed-9777f31699a8",
        "input": {
          "event": {
            "data": "'axischange'",
            "constant": true
          },
          "remove": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "gamepad": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "emitter"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "listen",
            "pinId": "data"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen to \`gamepad\` \\"axischange\\" event",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "1448dd43-3e1e-4709-a9e1-3562d61cc6f1",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "bbc52982-4a71-45b8-8521-c0c30260c022": {
    "name": "merge event data",
    "units": {
      "tagevent": {
        "id": "5fe94b90-2618-11eb-b06a-5fc0ce62fd27",
        "input": {
          "event": {}
        },
        "output": {
          "{event}": {}
        }
      },
      "tagdata": {
        "id": "7a602db8-2618-11eb-b9c6-4bb45b6d8833",
        "input": {
          "data": {}
        },
        "output": {
          "{data}": {}
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "ab": {}
        }
      }
    },
    "merges": {
      "0": {
        "merge": {
          "input": {
            "a": true
          }
        },
        "tagdata": {
          "output": {
            "{data}": true
          }
        }
      },
      "1": {
        "merge": {
          "input": {
            "b": true
          }
        },
        "tagevent": {
          "output": {
            "{event}": true
          }
        }
      }
    },
    "inputs": {
      "data": {
        "plug": {
          "0": {
            "unitId": "tagdata",
            "pinId": "data"
          }
        }
      },
      "event": {
        "plug": {
          "0": {
            "unitId": "tagevent",
            "pinId": "event"
          }
        }
      }
    },
    "outputs": {
      "{event,data}": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "ab"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "create object with values \`event\` and \`data\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "bbc52982-4a71-45b8-8521-c0c30260c022",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "16249a80-98ac-11eb-95b7-1b64bf84f0d8": {
    "name": "get width",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'width'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "width": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract width from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "16249a80-98ac-11eb-95b7-1b64bf84f0d8",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f401cdfe-b231-40d0-88a1-fda9a55f282e": {
    "name": "get value",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'value'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract \`id\` from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "f401cdfe-b231-40d0-88a1-fda9a55f282e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "19f08be0-560a-11eb-a3a2-e7395ef5830a": {
    "name": "get url",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'url'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "url": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract \`url\` from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "19f08be0-560a-11eb-a3a2-e7395ef5830a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6e9c4adb-77e4-45ef-a71b-ced42a49aae9": {
    "name": "get offsetY",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'offsetY'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "offsetY": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract offsetY from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "6e9c4adb-77e4-45ef-a71b-ced42a49aae9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2307cacf-1363-40bc-bd6b-d58227927ae0": {
    "name": "get offsetX offsetY",
    "units": {
      "propoffsetx": {
        "id": "cd7cfbb3-c86b-401d-a6b7-9de912672d96",
        "input": {
          "event": {}
        },
        "output": {
          "offsetX": {}
        }
      },
      "propclientcy": {
        "id": "6e9c4adb-77e4-45ef-a71b-ced42a49aae9",
        "input": {
          "event": {}
        },
        "output": {
          "offsetY": {}
        }
      }
    },
    "merges": {
      "0": {
        "propclientcy": {
          "input": {
            "event": true
          }
        },
        "propoffsetx": {
          "input": {
            "event": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "propclientcy",
            "pinId": "offsetY"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "propoffsetx",
            "pinId": "offsetX"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract \`offsetX\` and \`offsetY\` from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "2307cacf-1363-40bc-bd6b-d58227927ae0",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cd7cfbb3-c86b-401d-a6b7-9de912672d96": {
    "name": "get offsetX",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'offsetX'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "offsetX": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract offsetX from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "cd7cfbb3-c86b-401d-a6b7-9de912672d96",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8e48bf34-a3b3-11eb-af21-9fff67fa4349": {
    "name": "get key",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'key'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "key": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract key from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "8e48bf34-a3b3-11eb-af21-9fff67fa4349",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f7805a56-668d-11eb-a8df-732d644930cc": {
    "name": "get id",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'id'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "id": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract \`id\` from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "f7805a56-668d-11eb-a8df-732d644930cc",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f7a26f8c-98ac-11eb-9b81-e79fad66a6ce": {
    "name": "get height",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'height'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "height": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract height from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "f7a26f8c-98ac-11eb-9b81-e79fad66a6ce",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "97c4f4ec-2613-11eb-8c54-4b82dde232ca": {
    "name": "get clientY",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'clientY'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "clientY": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract clientY from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "97c4f4ec-2613-11eb-8c54-4b82dde232ca",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1cbbfd58-c4ee-4c83-a5c8-83f614eb7027": {
    "name": "get clientX clientY",
    "units": {
      "getclientx": {
        "id": "4556afd4-2463-48c8-abb6-12e30fff6ed0",
        "input": {
          "event": {}
        },
        "output": {
          "clientX": {}
        }
      },
      "getclienty": {
        "id": "97c4f4ec-2613-11eb-8c54-4b82dde232ca",
        "input": {
          "event": {}
        },
        "output": {
          "clientY": {}
        }
      }
    },
    "merges": {
      "0": {
        "getclienty": {
          "input": {
            "event": true
          }
        },
        "getclientx": {
          "input": {
            "event": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "getclienty",
            "pinId": "clientY"
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "getclientx",
            "pinId": "clientX"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract \`clientX\` and \`clientY\` from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "1cbbfd58-c4ee-4c83-a5c8-83f614eb7027",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4556afd4-2463-48c8-abb6-12e30fff6ed0": {
    "name": "get clientX",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": "'clientX'"
          }
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "event": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "clientX": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "extract clientX from \`obj\`",
      "tags": [
        "platform",
        "core",
        "api",
        "event"
      ]
    },
    "id": "4556afd4-2463-48c8-abb6-12e30fff6ed0",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5fb0ca59-4245-49ec-b13a-7b5c4af4c4bb": {
    "type": "\`U\`&\`G\`",
    "name": "buffer",
    "units": {
      "append": {
        "id": "cf4db91a-f8b2-454f-a763-12005d71cb9d",
        "input": {
          "a[]": {},
          "a": {
            "metadata": {
              "position": {
                "x": -233,
                "y": 14
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -188,
            "y": -3
          }
        }
      },
      "state": {
        "id": "c899b675-c3c4-428e-b548-b228305c0302",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -241,
                "y": -62
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -228,
                "y": -94
              }
            }
          }
        },
        "output": {
          "data": {
            "metadata": {
              "position": {
                "x": -136,
                "y": -32
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -191,
            "y": -64
          }
        }
      },
      "debounce": {
        "id": "e55c58b3-8653-4481-b5c9-2a75fce6365a",
        "input": {
          "ms": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            },
            "metadata": {
              "position": {
                "x": -58,
                "y": 108
              },
              "data": {
                "position": {
                  "x": -76,
                  "y": 134
                }
              }
            }
          },
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -22,
            "y": 76
          }
        }
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 239,
                "y": 72
              }
            }
          },
          "b": {}
        },
        "output": {
          "a if not b": {}
        },
        "metadata": {
          "position": {
            "x": 195,
            "y": 48
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": 126,
            "y": -6
          }
        }
      },
      "iterate0": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {
            "metadata": {
              "position": {
                "x": -51,
                "y": 47
              }
            }
          },
          "init": {
            "constant": true,
            "data": {
              "ref": [],
              "data": false
            },
            "metadata": {
              "position": {
                "x": 198,
                "y": -105
              },
              "data": {
                "position": {
                  "x": 218,
                  "y": -134
                }
              }
            }
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 213,
                "y": -86
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 163,
            "y": -73
          }
        }
      },
      "constant1": {
        "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
        "input": {
          "a": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": -248,
                "y": 67
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 256,
            "y": -26
          }
        }
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 87,
            "y": 58
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 55,
            "y": -57
          }
        }
      },
      "pop": {
        "id": "dff853f8-7bb4-48dc-a792-5efdead94640",
        "input": {
          "a": {},
          "any": {}
        },
        "output": {
          "last": {
            "metadata": {
              "position": {
                "x": -96,
                "y": -97
              }
            }
          },
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -70,
            "y": -58
          }
        }
      },
      "identity0": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 22,
            "y": 5
          }
        }
      },
      "ifgreaterthan0": {
        "id": "0facebfb-2449-430d-8f12-d8fdc5fc04e7",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -41,
            "y": -26
          }
        }
      },
      "length0": {
        "id": "ec482aaf-0029-4b85-b03a-de5bd361d706",
        "input": {
          "a": {},
          "any": {}
        },
        "output": {
          "length": {}
        },
        "metadata": {
          "position": {
            "x": -117,
            "y": 22
          }
        }
      }
    },
    "merges": {
      "0": {
        "append": {
          "input": {
            "a[]": true
          }
        },
        "pop": {
          "input": {
            "a": true
          }
        },
        "state": {
          "output": {
            "data": true
          }
        },
        "length0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "ifgreaterthan0": {
          "input": {
            "a": true
          }
        },
        "length0": {
          "output": {
            "length": true
          }
        }
      },
      "2": {
        "true": {
          "output": {
            "true": true
          }
        },
        "iterate0": {
          "input": {
            "next": true
          }
        },
        "false": {
          "output": {
            "false": true
          }
        }
      },
      "3": {
        "identity": {
          "output": {
            "a": true
          }
        },
        "debounce": {
          "input": {
            "a": true
          }
        },
        "identity0": {
          "output": {
            "a": true
          }
        }
      },
      "4": {
        "false": {
          "input": {
            "any": true
          }
        },
        "identity0": {
          "input": {
            "a": true
          }
        },
        "pop": {
          "output": {
            "done": true
          }
        }
      },
      "5": {
        "pop": {
          "input": {
            "any": true
          }
        },
        "ifgreaterthan0": {
          "output": {
            "a": true
          }
        }
      },
      "7": {
        "debounce": {
          "output": {
            "a": true
          }
        },
        "length0": {
          "input": {
            "any": true
          }
        }
      },
      "16": {
        "iterate0": {
          "output": {
            "current": true
          }
        },
        "constant1": {
          "input": {
            "a": true
          }
        }
      },
      "17": {
        "ifnot": {
          "input": {
            "b": true
          }
        },
        "constant1": {
          "output": {
            "a": true
          }
        }
      },
      "19": {
        "ifnot": {
          "output": {
            "a if not b": true
          }
        },
        "identity": {
          "input": {
            "a": true
          }
        },
        "true": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "ifnot",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -249,
                "y": 32
              }
            },
            "1": {
              "ext": {
                "x": 252,
                "y": 92
              }
            }
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "state",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -265,
                "y": -64
              }
            }
          }
        }
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "state",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false,
        "type": "any",
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -239,
                "y": -116
              }
            }
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "pop",
            "pinId": "last",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -97,
                "y": -121
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "general purpose buffer",
      "position": {
        "merge": {
          "1": {
            "x": -79,
            "y": 1
          },
          "2": {
            "x": 111,
            "y": -54
          },
          "3": {
            "x": 32,
            "y": 55
          },
          "4": {
            "x": -3,
            "y": -43
          },
          "5": {
            "x": -26,
            "y": -69
          },
          "7": {
            "x": -76,
            "y": 57
          },
          "11": {
            "x": -124,
            "y": -42
          },
          "12": {
            "x": -220,
            "y": -13
          },
          "13": {
            "x": -227,
            "y": -41
          },
          "14": {
            "x": -313,
            "y": -21
          },
          "15": {
            "x": -250,
            "y": 42
          },
          "16": {
            "x": 214,
            "y": -55
          },
          "17": {
            "x": 239,
            "y": 19
          },
          "19": {
            "x": 139,
            "y": 42
          },
          "22": {
            "x": 3,
            "y": -64
          }
        },
        "data": {
          "x": -297,
          "y": -40
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "children"
      ]
    },
    "id": "5fb0ca59-4245-49ec-b13a-7b5c4af4c4bb",
    "system": true
  },
  "5bfd6983-ac96-4b74-a469-c0add966cdf2": {
    "type": "\`U\`&\`G\`&\`C\`",
    "name": "children length",
    "units": {
      "length0": {
        "id": "ec482aaf-0029-4b85-b03a-de5bd361d706",
        "input": {
          "a": {},
          "any": {
            "metadata": {
              "position": {
                "x": 20,
                "y": 31
              }
            }
          }
        },
        "output": {
          "length": {
            "metadata": {
              "position": {
                "x": 100,
                "y": -3
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 57,
            "y": 9
          }
        }
      },
      "children": {
        "id": "d4945010-686d-431b-a884-1a4db0bfafc4",
        "input": {
          "parent": {
            "metadata": {
              "position": {
                "x": -112,
                "y": -21
              }
            }
          }
        },
        "output": {
          "children": {
            "metadata": {
              "position": {
                "x": -6,
                "y": -14
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": -9
          }
        }
      }
    },
    "merges": {
      "0": {
        "length0": {
          "input": {
            "a": true
          }
        },
        "children": {
          "output": {
            "children": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "length0",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false
      },
      "parent": {
        "plug": {
          "0": {
            "unitId": "children",
            "pinId": "parent",
            "kind": "input"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "length": {
        "plug": {
          "0": {
            "unitId": "length0",
            "pinId": "length",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "get component children count",
      "tags": [
        "platform",
        "core",
        "api",
        "children"
      ]
    },
    "id": "5bfd6983-ac96-4b74-a469-c0add966cdf2",
    "system": true
  },
  "9f9dff70-30e6-467b-9204-55fdf5b4ac4f": {
    "name": "child set value",
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 69,
              "y": -43
            }
          }
        }
      },
      "at": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "at"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -66,
              "y": 28
            }
          }
        }
      },
      "parent": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "parent"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 69,
              "y": 28
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "childset": {
        "id": "2633ed12-309e-40fe-910d-44106d917e96",
        "input": {
          "parent": {
            "metadata": {
              "position": {
                "x": 47,
                "y": 11
              }
            }
          },
          "at": {
            "metadata": {
              "position": {
                "x": -44,
                "y": 11
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'value'",
            "metadata": {
              "position": {
                "x": -44,
                "y": -26
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 47,
                "y": -26
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 2,
            "y": -8
          }
        }
      }
    },
    "merges": {},
    "component": {},
    "metadata": {
      "icon": "triangle",
      "description": "set \`element\` child \`at\` value to \`value\`",
      "tags": [
        "platform",
        "core",
        "api",
        "children"
      ]
    },
    "id": "9f9dff70-30e6-467b-9204-55fdf5b4ac4f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d7d77ad6-91db-4da7-a3c6-c37157574b17": {
    "name": "child set style",
    "inputs": {
      "style": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 69,
              "y": -43
            }
          }
        }
      },
      "at": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "at"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -66,
              "y": 28
            }
          }
        }
      },
      "parent": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "parent"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 69,
              "y": 28
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "childset": {
        "id": "2633ed12-309e-40fe-910d-44106d917e96",
        "input": {
          "parent": {
            "metadata": {
              "position": {
                "x": 47,
                "y": 11
              }
            }
          },
          "at": {
            "metadata": {
              "position": {
                "x": -44,
                "y": 11
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'style'",
            "metadata": {
              "position": {
                "x": -44,
                "y": -26
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 47,
                "y": -26
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 2,
            "y": -8
          }
        }
      }
    },
    "merges": {},
    "component": {},
    "metadata": {
      "icon": "object-set",
      "description": "set \`element\` child \`at\` style to \`style\`",
      "tags": [
        "platform",
        "core",
        "api",
        "children"
      ]
    },
    "id": "d7d77ad6-91db-4da7-a3c6-c37157574b17",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2633ed12-309e-40fe-910d-44106d917e96": {
    "name": "child set",
    "type": "\`U\`&\`G\`",
    "inputs": {
      "parent": {
        "plug": {
          "0": {
            "unitId": "child",
            "pinId": "parent"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -97,
              "y": 39,
              "ext": {
                "x": -123,
                "y": 0
              }
            }
          }
        }
      },
      "at": {
        "plug": {
          "0": {
            "unitId": "child",
            "pinId": "at"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -102,
              "y": -31,
              "ext": {
                "x": -95,
                "y": -51
              }
            }
          }
        },
        "ref": false,
        "functional": true
      },
      "name": {
        "plug": {
          "0": {
            "unitId": "writeinput",
            "pinId": "name"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 96,
              "y": 39,
              "ext": {
                "x": 123,
                "y": 33
              }
            }
          }
        },
        "ref": false,
        "functional": true
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "writeinput",
            "pinId": "data",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 101,
              "y": -31,
              "ext": {
                "x": 122,
                "y": -33
              }
            }
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "done": {
        "plug": {
          "0": {
            "unitId": "child",
            "pinId": "done",
            "kind": "output"
          }
        },
        "ref": false,
        "type": "any",
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -98,
                "y": 51
              }
            }
          }
        }
      }
    },
    "units": {
      "child": {
        "id": "59afce80-30e7-4322-84e6-955767bb5106",
        "input": {
          "parent": {
            "metadata": {
              "position": {
                "x": -99,
                "y": 0
              }
            }
          },
          "at": {
            "metadata": {
              "position": {
                "x": -83,
                "y": -30
              }
            }
          },
          "done": {}
        },
        "output": {
          "child": {
            "metadata": {
              "position": {
                "x": 5,
                "y": 19
              }
            }
          },
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -84,
                "y": 31
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -47,
            "y": 1
          }
        }
      },
      "writeinput": {
        "id": "04953fed-157a-479d-91ac-005174b9b85e",
        "input": {
          "name": {
            "metadata": {
              "position": {
                "x": 104,
                "y": 18
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 104,
                "y": -17
              }
            }
          },
          "unit": {}
        },
        "output": {
          "done": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 58,
            "y": 1
          }
        }
      }
    },
    "merges": {
      "0": {
        "writeinput": {
          "output": {
            "done": true
          }
        },
        "child": {
          "input": {
            "done": true
          }
        }
      },
      "1": {
        "writeinput": {
          "input": {
            "unit": true
          }
        },
        "child": {
          "output": {
            "child": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "object-set",
      "description": "set \`parent\` child \`at\` input \`name\` to \`data\`",
      "position": {
        "merge": {
          "0": {
            "x": 5,
            "y": -11
          },
          "2": {
            "x": -38,
            "y": -3
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "children"
      ]
    },
    "id": "2633ed12-309e-40fe-910d-44106d917e96",
    "system": true
  },
  "9369ceea-b3ad-44d3-a856-59fe2ea76e32": {
    "type": "\`U\`&\`G\`",
    "name": "child merge",
    "units": {
      "foreachkeyvalue": {
        "id": "47771360-640a-11ea-8393-d32f60372182",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -69,
                "y": 57
              }
            }
          }
        },
        "output": {
          "key": {
            "metadata": {
              "position": {
                "x": -38,
                "y": 79
              }
            }
          },
          "value": {},
          "test": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -20,
            "y": 38
          }
        }
      },
      "childset": {
        "id": "2633ed12-309e-40fe-910d-44106d917e96",
        "input": {
          "parent": {
            "metadata": {
              "position": {
                "x": 125,
                "y": 11
              }
            }
          },
          "at": {},
          "name": {
            "metadata": {
              "position": {
                "x": 153,
                "y": 35
              }
            }
          },
          "data": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 74,
            "y": 11
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -66,
                "y": -57
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -44,
                "y": -78
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 16,
                "y": -69
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -20,
            "y": -35
          }
        }
      }
    },
    "merges": {
      "0": {
        "childset": {
          "input": {
            "at": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "1": {
        "foreachkeyvalue": {
          "output": {
            "key": true
          }
        },
        "childset": {
          "input": {
            "name": true
          }
        }
      },
      "2": {
        "foreachkeyvalue": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "foreachkeyvalue": {
          "output": {
            "value": true
          }
        },
        "childset": {
          "input": {
            "data": true
          }
        }
      }
    },
    "inputs": {
      "parent": {
        "plug": {
          "0": {
            "unitId": "childset",
            "pinId": "parent",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 148,
                "y": 11
              }
            }
          }
        }
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "foreachkeyvalue",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -86,
                "y": 74
              }
            }
          }
        }
      },
      "at": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -81,
                "y": -76
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "merge \`parent\` child \`at\` input \`name\` to \`data\`",
      "position": {
        "merge": {
          "0": {
            "x": 33,
            "y": -23
          },
          "1": {
            "x": 35,
            "y": 44
          },
          "2": {
            "x": -54,
            "y": 1
          },
          "3": {
            "x": 26,
            "y": 21
          }
        }
      },
      "tags": [
        "platform",
        "core",
        "api",
        "children"
      ]
    },
    "id": "9369ceea-b3ad-44d3-a856-59fe2ea76e32",
    "system": true
  },
  "a08ce854-e13b-11ea-b260-e76cc1643e97": {
    "name": "any device",
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "device": {
        "plug": {
          "0": {
            "unitId": "device",
            "pinId": "device"
          }
        },
        "ref": true
      }
    },
    "units": {
      "device": {
        "id": "4ad5bd0e-e11e-11ea-ad4c-83da30628333",
        "input": {
          "opt": {}
        },
        "output": {
          "device": {}
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": -1
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {
            "constant": true,
            "data": "{acceptAllDevices:true}"
          },
          "b": {}
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "device": {
          "input": {
            "opt": true
          }
        }
      }
    },
    "render": false,
    "component": {},
    "metadata": {
      "icon": "bluetooth",
      "description": "select one of all available bluetooth devices",
      "tags": [
        "platform",
        "core",
        "api",
        "bluetooth"
      ]
    },
    "type": "\`U\`&\`G\`",
    "id": "a08ce854-e13b-11ea-b260-e76cc1643e97",
    "system": true
  },
  "47a78f03-7dd4-4207-aefa-02574661de6e": {
    "name": "transform",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": true
      },
      "name": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "next": {
        "plug": {
          "0": {
            "unitId": "set0",
            "pinId": "data"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      }
    },
    "units": {
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 46,
            "y": 0
          }
        }
      },
      "set0": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {},
          "name": {},
          "data": {}
        },
        "output": {
          "data": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": -47,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "set0": {
          "input": {
            "obj": true
          }
        }
      },
      "1": {
        "get": {
          "input": {
            "name": true
          }
        },
        "set0": {
          "input": {
            "name": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "get element then set element after going through a function",
      "tags": [
        "platform",
        "core"
      ]
    },
    "type": "\`U\`&\`G\`",
    "id": "47a78f03-7dd4-4207-aefa-02574661de6e",
    "system": true
  },
  "7849c9db-bf2d-4d1f-a105-11f0f3eee333": {
    "name": "set width",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": 37
            }
          }
        }
      },
      "width": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": -38
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 34,
                "y": 18
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'width'",
            "metadata": {
              "position": {
                "x": -60,
                "y": 0
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 34,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -11,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` property \`name\` to \`data\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "7849c9db-bf2d-4d1f-a105-11f0f3eee333",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ad68ca8e-ff63-467d-a770-3e6a7490f7fb": {
    "name": "set value",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": 37
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": -38
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 34,
                "y": 18
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'value'",
            "metadata": {
              "position": {
                "x": -60,
                "y": 0
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 34,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -11,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "object-set",
      "description": "set property \`value\` of \`obj\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "ad68ca8e-ff63-467d-a770-3e6a7490f7fb",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1241b0ea-eaa8-4dc3-95d1-a3e1580e4267": {
    "name": "set scale y",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": 37
            }
          }
        }
      },
      "sy": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": -38
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 34,
                "y": 18
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'sy'",
            "metadata": {
              "position": {
                "x": -60,
                "y": 0
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 34,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -11,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "object-set",
      "description": "set property \`sy\` of \`object\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "1241b0ea-eaa8-4dc3-95d1-a3e1580e4267",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cea694c2-9c36-4655-85b6-9b33425a5c33": {
    "name": "set scale x",
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": 37
            }
          }
        }
      },
      "sx": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": -38
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 34,
                "y": 18
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'sx'",
            "metadata": {
              "position": {
                "x": -60,
                "y": 0
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 34,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -11,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "object-set",
      "description": "set property \`sx\` of \`object\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "cea694c2-9c36-4655-85b6-9b33425a5c33",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "33a97304-0832-40d9-b013-de0ddf0688af": {
    "type": "\`U\`&\`G\`",
    "name": "set scale",
    "units": {
      "setscalex": {
        "id": "cea694c2-9c36-4655-85b6-9b33425a5c33",
        "input": {
          "obj": {}
        },
        "output": {}
      },
      "setscaley": {
        "id": "1241b0ea-eaa8-4dc3-95d1-a3e1580e4267",
        "input": {
          "obj": {},
          "sy": {}
        },
        "output": {}
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "setscaley",
            "pinId": "obj"
          },
          "1": {
            "unitId": "setscalex",
            "pinId": "obj"
          }
        },
        "ref": true
      },
      "sx": {
        "plug": {
          "0": {
            "unitId": "setscalex",
            "pinId": "sx"
          }
        },
        "ref": false
      },
      "sy": {
        "plug": {
          "0": {
            "unitId": "setscaley",
            "pinId": "sy"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set scale \`sx\` and \`sy\` of \`obj\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "33a97304-0832-40d9-b013-de0ddf0688af",
    "system": true
  },
  "ee6b5fbb-5e05-4750-83a8-d6ffe5a059db": {
    "type": "\`U\`&\`G\`",
    "name": "set name",
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "ignored": false,
            "constant": false,
            "metadata": {
              "position": {
                "x": -34,
                "y": 23
              }
            }
          },
          "name": {
            "ignored": false,
            "constant": true,
            "data": "\\"name\\"",
            "metadata": {
              "position": {
                "x": -34,
                "y": -15
              }
            }
          },
          "data": {
            "ignored": false,
            "constant": false,
            "metadata": {
              "position": {
                "x": 59,
                "y": 4
              }
            }
          }
        },
        "output": {
          "data": {
            "ignored": true,
            "constant": false,
            "metadata": {
              "position": {
                "x": 49,
                "y": 32
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 10,
            "y": 4
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -51,
                "y": 39
              }
            }
          }
        }
      },
      "name": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 82,
                "y": 4
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` \\"name\\" property",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "ee6b5fbb-5e05-4750-83a8-d6ffe5a059db",
    "system": true
  },
  "946701f6-7dd4-11ea-a1aa-67938c0c6214": {
    "name": "set if",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614"
      },
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05"
      }
    },
    "merges": {
      "0": {
        "set": {
          "output": {
            "obj": true
          }
        },
        "pick": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "pick": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "c"
          }
        },
        "functional": true
      },
      "obj": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "key": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "key"
          }
        },
        "functional": true
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set value at \`key\` to \`value\` if \`test\` is true",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "946701f6-7dd4-11ea-a1aa-67938c0c6214",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f752e8ce-83ce-4bdd-9ae2-67b241c51cfc": {
    "name": "set height",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": 37
            }
          }
        }
      },
      "height": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 53,
              "y": -38
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 34,
                "y": 18
              }
            }
          },
          "name": {
            "constant": true,
            "data": "'height'",
            "metadata": {
              "position": {
                "x": -60,
                "y": 0
              }
            }
          },
          "data": {
            "metadata": {
              "position": {
                "x": 34,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -11,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "object-set",
      "description": "set height property of \`obj\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "f752e8ce-83ce-4bdd-9ae2-67b241c51cfc",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "887e66b8-a08e-11ea-bfea-b3687d92658a": {
    "name": "set fill default",
    "units": {
      "setifordefault": {
        "id": "c0b85780-7e99-11ea-9a99-879f3f411ebd",
        "input": {
          "key": {
            "constant": true,
            "data": "'fill'"
          },
          "testdefault": {
            "constant": true,
            "data": "false"
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "default": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "default"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "test"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "value"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` \\"fill\\" to \`value\` if \`test\` is true or to \`default\` otherwise",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "887e66b8-a08e-11ea-bfea-b3687d92658a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c0b85780-7e99-11ea-9a99-879f3f411ebd": {
    "name": "set default",
    "units": {
      "setif": {
        "id": "946701f6-7dd4-11ea-a1aa-67938c0c6214"
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89"
      },
      "default0": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89"
      }
    },
    "merges": {
      "0": {
        "setif": {
          "input": {
            "test": true
          }
        },
        "default": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "setif": {
          "input": {
            "value": true
          }
        },
        "default0": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "testdefault": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "d"
          }
        }
      },
      "default": {
        "plug": {
          "0": {
            "unitId": "default0",
            "pinId": "d"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "default0",
            "pinId": "a"
          }
        }
      },
      "key": {
        "plug": {
          "0": {
            "unitId": "setif",
            "pinId": "key"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "setif",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "setif",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set value at \`key\` to \`value\` if \`test\` is defined and true or to \`default\` otherwise",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "c0b85780-7e99-11ea-9a99-879f3f411ebd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "88553858-c62d-4970-98c9-084084528d2a": {
    "type": "\`U\`&\`G\`",
    "name": "set currentTime",
    "units": {
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {},
          "name": {
            "constant": true,
            "data": "'currentTime'"
          },
          "data": {}
        },
        "output": {
          "data": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": 6,
            "y": 19
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        },
        "ref": true
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set currentTime property of \`obj\`",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "88553858-c62d-4970-98c9-084084528d2a",
    "system": true
  },
  "7b344491-48a2-46e1-949e-56805bebe3da": {
    "name": "set color default",
    "units": {
      "setifordefault": {
        "id": "c0b85780-7e99-11ea-9a99-879f3f411ebd",
        "input": {
          "key": {
            "constant": true,
            "data": "'color'"
          },
          "testdefault": {
            "constant": true,
            "data": "false"
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "default": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "default"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "test"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "value"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "setifordefault",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`obj\` \\"color\\" to \`value\` if \`test\` is true or to \`default\` otherwise",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "7b344491-48a2-46e1-949e-56805bebe3da",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2c7507c4-02bc-11eb-88e5-8bc78086a76f": {
    "name": "remove all children",
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -168,
              "y": -31
            }
          }
        }
      },
      "parent": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 185,
              "y": 8
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "haschild": {
        "id": "c475117a-02b9-11eb-b7c8-579fe4f6c669",
        "input": {
          "parent": {},
          "at": {}
        },
        "output": {
          "test": {}
        },
        "metadata": {
          "position": {
            "x": 113,
            "y": -19
          }
        }
      },
      "removechild": {
        "id": "6dbff818-02b9-11eb-9ee7-93b57419f741",
        "input": {
          "parent": {},
          "at": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 115,
            "y": 34
          }
        }
      },
      "loop": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {},
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -21,
                "y": -29
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 17,
            "y": 0
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "0",
            "metadata": {
              "position": {
                "x": -143,
                "y": 17
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -143,
                "y": -17
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -97,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "haschild": {
          "input": {
            "parent": true
          }
        },
        "removechild": {
          "input": {
            "parent": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "local": true
          }
        },
        "haschild": {
          "input": {
            "at": true
          }
        }
      },
      "2": {
        "haschild": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "removechild": {
          "input": {
            "at": true
          }
        }
      },
      "4": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "loop": {
          "input": {
            "init": true
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "remove all \`parent\` children",
      "tags": [
        "platform",
        "core"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 156,
            "y": 7
          },
          "1": {
            "x": 66,
            "y": -5
          },
          "2": {
            "x": 61,
            "y": -28
          },
          "3": {
            "x": 62,
            "y": 29
          },
          "4": {
            "x": -42,
            "y": 0
          }
        }
      }
    },
    "id": "2c7507c4-02bc-11eb-88e5-8bc78086a76f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8a2d42bf-fc83-4696-9e0c-cf8c6c4641ae": {
    "name": "random color tag",
    "units": {
      "tagcolor": {
        "id": "dfba14dd-bd14-4fd2-bbfa-c910eadd9f7d"
      },
      "randomhexcolor": {
        "id": "2f48e431-9338-44dd-9f20-b8b14e710a1f"
      }
    },
    "merges": {
      "0": {
        "tagcolor": {
          "input": {
            "color": true
          }
        },
        "randomhexcolor": {
          "output": {
            "hex": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "random HEX color string tag",
      "tags": [
        "platform",
        "core"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "randomhexcolor",
            "pinId": "any"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "{color}": {
        "plug": {
          "0": {
            "unitId": "tagcolor",
            "pinId": "{color}"
          }
        }
      }
    },
    "id": "8a2d42bf-fc83-4696-9e0c-cf8c6c4641ae",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "051d4600-42e5-403b-b12e-eb58ae78ef0b": {
    "name": "random background-color tag",
    "units": {
      "randomhexcolor": {
        "id": "2f48e431-9338-44dd-9f20-b8b14e710a1f"
      },
      "tagbackgroundcolor": {
        "id": "26dc94ea-347b-4dbb-a7d7-1dab60da8352"
      }
    },
    "merges": {
      "0": {
        "randomhexcolor": {
          "output": {
            "hex": true
          }
        },
        "tagbackgroundcolor": {
          "input": {
            "color": true
          }
        }
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "random HEX background color string tag",
      "tags": [
        "platform",
        "core"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "randomhexcolor",
            "pinId": "any"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "{bc}": {
        "plug": {
          "0": {
            "unitId": "tagbackgroundcolor",
            "pinId": "{bc}"
          }
        }
      }
    },
    "id": "051d4600-42e5-403b-b12e-eb58ae78ef0b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "de45f6d0-7504-4061-b4ab-5d1ee902a0cb": {
    "name": "on enter keydown",
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "unitId": "onkeydown",
            "pinId": "element"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "units": {
      "onkeydown": {
        "id": "02dec0ae-a3b0-11eb-ab4e-afd7066a6476",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": -162,
                "y": -10
              }
            }
          }
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -111,
            "y": -9
          }
        }
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "'Enter'",
            "metadata": {
              "position": {
                "x": 138,
                "y": -21
              }
            }
          }
        },
        "output": {
          "a = b": {}
        },
        "metadata": {
          "position": {
            "x": 88,
            "y": -18
          }
        }
      },
      "propkey": {
        "id": "8e48bf34-a3b3-11eb-af21-9fff67fa4349",
        "input": {
          "event": {}
        },
        "output": {
          "key": {}
        },
        "metadata": {
          "position": {
            "x": -12,
            "y": -35
          }
        }
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a if b": {
            "metadata": {
              "position": {
                "x": 15,
                "y": 57
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -9,
            "y": 18
          }
        }
      }
    },
    "merges": {
      "lwzzgu": {
        "propkey": {
          "input": {
            "event": true
          }
        },
        "onkeydown": {
          "output": {
            "event": true
          }
        },
        "if": {
          "input": {
            "a": true
          }
        }
      },
      "webletbkt": {
        "equals": {
          "input": {
            "a": true
          }
        },
        "propkey": {
          "output": {
            "key": true
          }
        }
      },
      "tswomu": {
        "if": {
          "input": {
            "b": true
          }
        },
        "equals": {
          "output": {
            "a = b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "listen for \\"Enter\\" keydown",
      "position": {
        "merge": {
          "lwzzgu": {
            "x": -56,
            "y": -8
          },
          "webletbkt": {
            "x": 41,
            "y": -37
          },
          "tswomu": {
            "x": 43,
            "y": 6
          }
        }
      },
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "de45f6d0-7504-4061-b4ab-5d1ee902a0cb",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9b2bdc7c-eb5d-11ea-bdb1-1760294f446b": {
    "name": "on click toggle",
    "units": {
      "onclick": {
        "id": "97c94516-add1-11ea-ba72-8f55299b735c",
        "input": {
          "element": {
            "metadata": {
              "position": {
                "x": -105,
                "y": -18
              }
            }
          }
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": -9
          }
        }
      },
      "toggle": {
        "id": "58c50bb2-569f-4b7a-aba3-176d9ac91d5c",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": 15,
                "y": 34
              }
            }
          },
          "toggle": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 97,
                "y": 2
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 9
          }
        }
      }
    },
    "merges": {
      "0": {
        "toggle": {
          "input": {
            "toggle": true
          }
        },
        "onclick": {
          "output": {
            "event": true
          }
        }
      }
    },
    "inputs": {
      "init": {
        "plug": {
          "0": {
            "unitId": "toggle",
            "pinId": "init"
          }
        }
      },
      "element": {
        "plug": {
          "0": {
            "unitId": "onclick",
            "pinId": "element"
          }
        },
        "ref": true
      },
      "toggle": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": false,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "toggle",
            "pinId": "value"
          }
        }
      }
    },
    "metadata": {
      "icon": "square",
      "description": "toggle true/false on click",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "9b2bdc7c-eb5d-11ea-bdb1-1760294f446b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "450dac92-395b-4c7b-b8c0-219315c28035": {
    "name": "merge width height",
    "inputs": {
      "height": {
        "plug": {
          "0": {
            "unitId": "tagheight",
            "pinId": "height"
          }
        }
      },
      "width": {
        "plug": {
          "0": {
            "unitId": "tagwidth",
            "pinId": "width"
          }
        }
      }
    },
    "outputs": {
      "{width,height}": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "ab"
          }
        }
      }
    },
    "units": {
      "tagwidth": {
        "id": "c13fec8e-a253-11eb-bbe5-6bbcbf28b3ef",
        "input": {
          "width": {
            "metadata": {
              "position": {
                "x": -70,
                "y": 71
              }
            }
          }
        },
        "output": {
          "{width}": {}
        },
        "metadata": {
          "position": {
            "x": -22,
            "y": 59
          }
        }
      },
      "tagheight": {
        "id": "cd3cc728-a253-11eb-92b7-876e93d80737",
        "input": {
          "height": {
            "metadata": {
              "position": {
                "x": -70,
                "y": -72
              }
            }
          }
        },
        "output": {
          "{height}": {}
        },
        "metadata": {
          "position": {
            "x": -22,
            "y": -60
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "ab": {
            "metadata": {
              "position": {
                "x": 111,
                "y": -1
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 61,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "merge": {
          "input": {
            "a": true
          }
        },
        "tagheight": {
          "output": {
            "{height}": true
          }
        }
      },
      "1": {
        "merge": {
          "input": {
            "b": true
          }
        },
        "tagwidth": {
          "output": {
            "{width}": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "{width, height}",
      "position": {
        "merge": {
          "0": {
            "x": 24,
            "y": -36
          },
          "1": {
            "x": 24,
            "y": 35
          }
        }
      },
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "450dac92-395b-4c7b-b8c0-219315c28035",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "69ee5ea3-660c-479e-9cff-da9dc33a2b0a": {
    "name": "drag accumulate",
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "a"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "iterate0",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "a + Δ": {
        "plug": {
          "0": {
            "unitId": "add0",
            "pinId": "a + b"
          }
        }
      }
    },
    "units": {
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": "0"
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": 60
          }
        }
      },
      "iterate0": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {}
        },
        "metadata": {
          "position": {
            "x": -110,
            "y": -26
          }
        }
      },
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "if": {},
          "else": {}
        },
        "metadata": {
          "position": {
            "x": 94,
            "y": -37
          }
        }
      },
      "zero": {
        "id": "618898d6-1167-11eb-bef9-cb053e09c21b",
        "input": {
          "any": {}
        },
        "output": {
          "0": {}
        },
        "metadata": {
          "position": {
            "x": 37,
            "y": -8
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a + b": {}
        },
        "metadata": {
          "position": {
            "x": -18,
            "y": -57
          }
        }
      },
      "add0": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a + b": {}
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": 64
          }
        }
      }
    },
    "merges": {
      "0": {
        "ifelse": {
          "output": {
            "else": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        },
        "zero": {
          "input": {
            "any": true
          }
        }
      },
      "1": {
        "add": {
          "output": {
            "a + b": true
          }
        },
        "iterate0": {
          "input": {
            "next": true
          }
        }
      },
      "2": {
        "add": {
          "input": {
            "a": true
          }
        },
        "iterate0": {
          "output": {
            "local": true
          }
        }
      },
      "3": {
        "ifelse": {
          "output": {
            "if": true
          }
        },
        "iterate": {
          "input": {
            "next": true
          }
        },
        "zero": {
          "output": {
            "0": true
          }
        }
      },
      "4": {
        "add0": {
          "input": {
            "a": true
          }
        },
        "iterate": {
          "output": {
            "current": true
          }
        }
      },
      "5": {
        "add0": {
          "input": {
            "b": true
          }
        },
        "iterate0": {
          "output": {
            "current": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "mouse-pointer",
      "description": "utility for keeping track of current pointer down max x y distance",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "69ee5ea3-660c-479e-9cff-da9dc33a2b0a",
    "system": true
  },
  "839af244-d1d3-11ea-89c0-073ae59ae4f1": {
    "name": "delay push random tag color",
    "units": {
      "tagcolor": {
        "id": "8a2d42bf-fc83-4696-9e0c-cf8c6c4641ae",
        "input": {
          "any": {
            "data": "0",
            "constant": true
          }
        },
        "output": {
          "{color}": {}
        }
      },
      "delaypush": {
        "id": "8cd6c706-d1d4-11ea-92e1-47577abb9ccf",
        "input": {
          "ms": {},
          "a": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "fajbgvoyh": {
        "delaypush": {
          "input": {
            "a": true
          }
        },
        "tagcolor": {
          "output": {
            "{color}": true
          }
        }
      }
    },
    "inputs": {
      "ms": {
        "plug": {
          "0": {
            "unitId": "delaypush",
            "pinId": "ms"
          }
        }
      }
    },
    "outputs": {
      "tag": {
        "plug": {
          "0": {
            "unitId": "delaypush",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "tag",
      "description": "delay push random {color}",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "839af244-d1d3-11ea-89c0-073ae59ae4f1",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c6896674-a9f9-4754-838e-5e3b71694d79": {
    "type": "\`U\`&\`G\`",
    "name": "append n children",
    "units": {
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b",
        "input": {
          "n": {},
          "a": {}
        },
        "output": {
          "a[]": {},
          "test": {
            "ignored": false
          },
          "acc": {
            "ignored": true
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true
          },
          "current": {},
          "final": {
            "ignored": true
          }
        }
      },
      "appendchildren": {
        "id": "2ea56c24-642b-420b-ae7d-e434299c7003",
        "input": {
          "parent": {},
          "children": {}
        },
        "output": {
          "length": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "narraybuilder": {
          "input": {
            "a": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "1": {
        "narraybuilder": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "2": {
        "narraybuilder": {
          "output": {
            "a[]": true
          }
        },
        "appendchildren": {
          "input": {
            "children": true
          }
        }
      }
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "n",
            "kind": "input"
          }
        },
        "ref": false,
        "functional": true
      },
      "child": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init",
            "kind": "input"
          }
        },
        "metadata": {
          "examples": [
            "10"
          ]
        },
        "ref": false,
        "functional": true
      },
      "parent": {
        "plug": {
          "0": {
            "unitId": "appendchildren",
            "pinId": "parent",
            "kind": "input"
          }
        },
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "append the same \`child\` class \`n\` times",
      "tags": [
        "platform",
        "core"
      ]
    },
    "id": "c6896674-a9f9-4754-838e-5e3b71694d79",
    "system": true
  },
  "6a14988f-5f4b-4fab-af32-226b7844e41f": {
    "name": "text field",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "maxLength": {
        "type": "number",
        "optional": true,
        "defaultIgnored": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "single line text input",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "6a14988f-5f4b-4fab-af32-226b7844e41f",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "83ec6688-b80b-4ef2-861f-14245ef392c0": {
    "name": "text area",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true,
        "metadata": {
          "description": "input text here"
        }
      },
      "placeholder": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "\\"Type Text Here\\""
          ]
        }
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "examples": [
          "{spellcheck:true}"
        ]
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "align-left",
      "description": "input text through keyboard",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "83ec6688-b80b-4ef2-861f-14245ef392c0",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 150
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "87f99b85-1c24-4e5b-a903-dd27230f4092": {
    "name": "text",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "\\"Text\\"",
            "\\"Hello world!\\""
          ]
        }
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "type",
      "description": "text",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "87f99b85-1c24-4e5b-a903-dd27230f4092",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 90
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "e06518cf-9edf-430b-8751-74c486e407aa": {
    "name": "slider",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "value": {
        "type": "number",
        "optional": true
      },
      "min": {
        "type": "number",
        "optional": true,
        "defaultIgnored": true
      },
      "max": {
        "type": "number",
        "optional": true,
        "defaultIgnored": true
      },
      "attr": {
        "type": "object",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "value": {
        "type": "number",
        "optional": true
      }
    },
    "metadata": {
      "icon": "sliders",
      "description": "slide",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "e06518cf-9edf-430b-8751-74c486e407aa",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 30
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "6c7cd7d1-c8a0-4317-9c8c-ba781f150729": {
    "name": "select",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "select HTML element",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "6c7cd7d1-c8a0-4317-9c8c-ba781f150729",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "0f82f52f-0380-46d5-a959-0eebd5de503e": {
    "name": "radio field",
    "inputs": {
      "name": {
        "type": "string"
      },
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true
      },
      "checked": {
        "type": "boolean",
        "optional": true
      }
    },
    "outputs": {
      "value": {
        "type": "string"
      },
      "checked": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "form input of type radio",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "0f82f52f-0380-46d5-a959-0eebd5de503e",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "51c2c7b4-cb8a-42e8-95ab-14b8ac37700c": {
    "name": "password field",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "single line password text input",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "51c2c7b4-cb8a-42e8-95ab-14b8ac37700c",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "c0d13c03-9b10-4a6f-a79f-66294d10aae6": {
    "name": "option",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "form-input",
      "description": "single line text input",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "c0d13c03-9b10-4a6f-a79f-66294d10aae6",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "9bc56564-ef4e-11ea-939a-27ae3feb321e": {
    "name": "number field",
    "inputs": {
      "value": {
        "type": "number",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{fontSize:'30px'}",
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "min": {
        "type": "number",
        "optional": true,
        "defaultIgnored": true
      },
      "max": {
        "type": "number",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "value": {
        "type": "number",
        "optional": true
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "single line number input",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "9bc56564-ef4e-11ea-939a-27ae3feb321e",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "e2109627-9783-4664-a70c-858fd8c46ea5": {
    "name": "file field",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {
      "files": {
        "type": "\`A<\`F\`>\`",
        "optional": true,
        "ref": true,
        "icon": "files"
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "single line text input",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "e2109627-9783-4664-a70c-858fd8c46ea5",
    "base": true,
    "component": {
      "defaultWidth": 270,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "429496bf-98fa-45e8-81b8-960f4e2546ba": {
    "name": "fieldset",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "form-input",
      "description": "select HTML element",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "429496bf-98fa-45e8-81b8-960f4e2546ba",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "6309ac3f-4a37-4ab0-86c6-8be70b38e31d": {
    "name": "editable field",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "form-input",
      "description": "single line text input",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "6309ac3f-4a37-4ab0-86c6-8be70b38e31d",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "d8aa573f-129e-4587-9c64-674729d024e2": {
    "name": "color",
    "inputs": {
      "value": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {
      "value": {
        "type": "string",
        "optional": true
      }
    },
    "metadata": {
      "icon": "palette",
      "description": "pick a color",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "d8aa573f-129e-4587-9c64-674729d024e2",
    "base": true,
    "component": {
      "defaultWidth": 45,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "096fc4ca-edd2-11ea-8266-37b634a3ee0b": {
    "name": "checkbox",
    "inputs": {
      "value": {
        "type": "boolean",
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "value": {
        "type": "boolean",
        "optional": true
      }
    },
    "metadata": {
      "icon": "square",
      "description": "checkbox",
      "tags": [
        "platform",
        "component",
        "value"
      ]
    },
    "id": "096fc4ca-edd2-11ea-8266-37b634a3ee0b",
    "base": true,
    "component": {
      "defaultWidth": 30,
      "defaultHeight": 30
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "4e555154-695c-471a-8a91-47bda70f8110": {
    "name": "svg view",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "viewBox": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'0 0 100 100'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG view element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "4e555154-695c-471a-8a91-47bda70f8110",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "ad12678e-6642-11eb-9fc3-9fbc75c58110": {
    "name": "svg use",
    "inputs": {
      "href": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG G",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "ad12678e-6642-11eb-9fc3-9fbc75c58110",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "00c828fc-9243-11ea-b897-5b0fc55820c5": {
    "name": "svg text path",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG text path",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "00c828fc-9243-11ea-b897-5b0fc55820c5",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "49ef122e-b4d1-11ea-b45e-b73d8ee2aae8": {
    "name": "svg text",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "value": {
        "type": "string",
        "optional": true
      },
      "x": {
        "type": "string",
        "optional": true
      },
      "y": {
        "type": "string",
        "optional": true
      },
      "dx": {
        "type": "string",
        "optional": true
      },
      "dy": {
        "type": "string",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG text",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "49ef122e-b4d1-11ea-b45e-b73d8ee2aae8",
    "base": true,
    "component": {
      "defaultWidth": 150,
      "defaultHeight": 60
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "e535bcf4-395f-41c7-afa4-01a4861c8859": {
    "name": "svg tspan",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG tspan element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "e535bcf4-395f-41c7-afa4-01a4861c8859",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "3c629fa2-6cc6-4ebc-b265-80444b446d2b": {
    "name": "svg symbol",
    "inputs": {
      "id": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG symbol element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "3c629fa2-6cc6-4ebc-b265-80444b446d2b",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "c68b0424-ced2-43b3-ac82-965163579f7e": {
    "name": "svg switch",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG switch element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "c68b0424-ced2-43b3-ac82-965163579f7e",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "56744e26-6909-4432-9849-2c77b0f2f2bf": {
    "name": "svg stop",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "offset": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'0'"
          ]
        }
      },
      "stopColor": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'red'"
          ]
        }
      },
      "stopOpacity": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'1'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG view element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "56744e26-6909-4432-9849-2c77b0f2f2bf",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "224dcb68-db0e-494c-8b91-7e2ebe0051c6": {
    "name": "svg set",
    "inputs": {
      "attributeName": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "to": {
        "type": "string",
        "optional": true
      },
      "begin": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'0s', '1s"
          ]
        }
      },
      "dur": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'0.2s', '1s', '3s'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG set element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "224dcb68-db0e-494c-8b91-7e2ebe0051c6",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1": {
    "name": "svg",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "viewBox": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG container",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "c0bfe832-8967-11ea-8c4c-1f2995e41b68": {
    "name": "svg rect",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{fill:'transparent',stroke:'currentColor',strokeWidth:'3px'}"
          ]
        }
      },
      "x": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "y": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "width": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "100",
            "150"
          ]
        }
      },
      "height": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "100",
            "150"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG rectangle",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "c0bfe832-8967-11ea-8c4c-1f2995e41b68",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "d1c76124-8869-4145-ba30-e3604e928527": {
    "name": "svg radial gradient",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "id": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG radialGradient element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "d1c76124-8869-4145-ba30-e3604e928527",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "4a06405b-29d6-483e-9ab4-5f659e139e4c": {
    "name": "svg polyline",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{fill:'transparent',stroke:'currentColor',strokeWidth:'3px'}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "points": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG polyline element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "4a06405b-29d6-483e-9ab4-5f659e139e4c",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "e4f85559-b661-49a6-aa90-9191c00e59cd": {
    "name": "svg polygon",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{fill:'transparent',stroke:'currentColor',strokeWidth:'3px'}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "points": {
        "type": "object",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG polygon element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "e4f85559-b661-49a6-aa90-9191c00e59cd",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "de8e7f1a-3064-4e04-b47e-eb06386ac794": {
    "name": "svg pattern",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "id": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG filter element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "de8e7f1a-3064-4e04-b47e-eb06386ac794",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "60bc7930-8982-11ea-8b24-cf97a783bb32": {
    "name": "svg path",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "d": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "\\"M126.274,15.18l-0.091-0.091 c-13.42-13.42-35.517-13.08-49.354,0.756l-6.158,6.158l-6.159-6.159C50.677,2.006,28.579,1.669,15.158,15.088l-0.091,0.092 C1.646,28.6,1.985,50.698,15.822,64.536l29.793,29.793c0.006,0.006,0.013,0.012,0.019,0.019l0.639,0.639 c0.002,0.003,0.005,0.005,0.007,0.008l0.091,0.091c0.002,0.003,0.005,0.005,0.008,0.008l24.291,24.291l24.278-24.278 c0.008-0.008,0.016-0.015,0.023-0.022l0.073-0.074l0.667-0.667c0.005-0.005,0.01-0.01,0.015-0.015l29.791-29.791 C139.356,50.698,139.694,28.6,126.274,15.18z\\"",
            "\\"M 10 10 h 100 v 100 h -100 v -100 z\\"",
            "\\"M 5 55 A 50 50 0 1 0 5 54.9 z\\""
          ]
        }
      },
      "fillRule": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "d": {
        "type": "string",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "square",
      "description": "SVG path",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "60bc7930-8982-11ea-8b24-cf97a783bb32",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "a9d998f8-4e62-40b0-8c4d-440e39d28ca3": {
    "name": "svg mask",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "id": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG mask element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "a9d998f8-4e62-40b0-8c4d-440e39d28ca3",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "9932f3bc-9241-11ea-89fa-0b2fdace0f08": {
    "name": "svg marker",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG marker",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "9932f3bc-9241-11ea-89fa-0b2fdace0f08",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "a95746c4-013d-4dd4-8488-fdca75c4757b": {
    "name": "svg mpath",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true
      },
      "href": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG tspan element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "a95746c4-013d-4dd4-8488-fdca75c4757b",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "a693fa9e-1ab3-4145-968a-9c234a7df038": {
    "name": "svg linear gradient",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "id": {
        "type": "string",
        "optional": true
      },
      "x1": {
        "type": "string",
        "optional": true
      },
      "y1": {
        "type": "string",
        "optional": true
      },
      "x2": {
        "type": "string",
        "optional": true
      },
      "y2": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG linearGradient element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "a693fa9e-1ab3-4145-968a-9c234a7df038",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "38d26d76-2559-11eb-ae02-dfda9b9b137e": {
    "name": "svg line",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "x1": {
        "type": "number",
        "optional": true
      },
      "y1": {
        "type": "number",
        "optional": true
      },
      "x2": {
        "type": "number",
        "optional": true
      },
      "y2": {
        "type": "number",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG line",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "38d26d76-2559-11eb-ae02-dfda9b9b137e",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "3865cbaf-aac1-4640-b809-c08f979b67f0": {
    "name": "svg image",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "x": {
        "type": "string",
        "optional": true
      },
      "y": {
        "type": "string",
        "optional": true
      },
      "width": {
        "type": "string",
        "optional": true
      },
      "height": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG image element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "3865cbaf-aac1-4640-b809-c08f979b67f0",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "be11165e-489f-11eb-921f-87b924eb0725": {
    "name": "svg group",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG G",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "be11165e-489f-11eb-921f-87b924eb0725",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "e049f16e-2559-11eb-bdc4-db5b8a11164b": {
    "name": "svg foreign object",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG G",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "e049f16e-2559-11eb-bdc4-db5b8a11164b",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "be0975fc-a9c7-4d92-a3b9-4479e986c2af": {
    "name": "svg filter effect turbulence",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "type": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'turbulence'"
          ]
        }
      },
      "baseFrequency": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'0.05'"
          ]
        }
      },
      "numOctaves": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "2"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG faTurbulence element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "be0975fc-a9c7-4d92-a3b9-4479e986c2af",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "bdce9206-5331-47dd-a111-902ee41f16ce": {
    "name": "svg filter effect tile",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "in": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "circle.svg"
          ]
        }
      },
      "elevation": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG faSpotlLight element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "bdce9206-5331-47dd-a111-902ee41f16ce",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "01193871-ae03-4ab3-9d06-e9956b28e626": {
    "name": "svg filter effect spot light",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "x": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "y": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "z": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "pointsAtX": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "pointsAtY": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG faSpotlLight element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "01193871-ae03-4ab3-9d06-e9956b28e626",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf": {
    "name": "svg filter effect specular lighting",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "specularExponent": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "lightingColor": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'white'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG faSpecularLighting element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "1fca03b4-707c-4f16-aeb5-992e55f351c6": {
    "name": "svg filter effect point light",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "azimuth": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "elevation": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG faSpotlLight element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "1fca03b4-707c-4f16-aeb5-992e55f351c6",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "9023fbd3-8308-4436-a26a-cc19044183e4": {
    "name": "svg filter effect offset",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "dx": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "dy": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feOffset element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "9023fbd3-8308-4436-a26a-cc19044183e4",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "541f7ae5-3db1-4344-8e87-f42e4d1fdfe8": {
    "name": "svg filter effect morphology",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "operator": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'erode','dilate'"
          ]
        }
      },
      "radius": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "2"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feMorphology element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "541f7ae5-3db1-4344-8e87-f42e4d1fdfe8",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "1a362a13-9df1-4b22-a9b5-91cdeac1e00f": {
    "name": "svg filter effect merge node",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "in": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feMergeNode element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "1a362a13-9df1-4b22-a9b5-91cdeac1e00f",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "f87fd33f-c02a-4238-959f-3520611c7903": {
    "name": "svg filter effect merge",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feMergeNode element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "f87fd33f-c02a-4238-959f-3520611c7903",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "bc9e9f08-877a-4814-a33f-ee80c013fca3": {
    "name": "svg filter effect image",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feImage element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "bc9e9f08-877a-4814-a33f-ee80c013fca3",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "8fa07772-cd92-4b7b-b876-29883a27d7c7": {
    "name": "svg filter effect gaussian blur",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feGaussianBlur element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "8fa07772-cd92-4b7b-b876-29883a27d7c7",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "d94b1e9d-0445-4e54-a549-b79e47a3c7a0": {
    "name": "svg filter effect flood",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feMergeNode element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "d94b1e9d-0445-4e54-a549-b79e47a3c7a0",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "0c15cd43-6997-4f9f-b52f-acd4c0ed0670": {
    "name": "svg filter effect drop shadow",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feMergeNode element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "0c15cd43-6997-4f9f-b52f-acd4c0ed0670",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "fc78d9fd-45dc-4b01-83d9-8979b5697f56": {
    "name": "svg filter effect distant light",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "azimuth": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "elevation": {
        "type": "number",
        "optional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG faSpotlLight element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "fc78d9fd-45dc-4b01-83d9-8979b5697f56",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1": {
    "name": "svg filter effect displacement map",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feDisplacementMap element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "fdae0046-d36c-4b21-bb1d-77182d89cadf": {
    "name": "svg filter effect diffuse lighting",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "lightingColor": {
        "type": "string",
        "optional": true
      },
      "surfaceScale": {
        "type": "number",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feDiffuseLighting element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "fdae0046-d36c-4b21-bb1d-77182d89cadf",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "7db232f5-870c-418a-8efd-fa9bba6c8c4a": {
    "name": "svg filter effect convolve matrix",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "order": {
        "type": "number",
        "optional": true
      },
      "kernelMatrix": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feConvolveMatrix element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "7db232f5-870c-418a-8efd-fa9bba6c8c4a",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "90d0f768-3991-4cd3-9995-07d0dab6d41c": {
    "name": "svg filter effect component transfer",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feComponentTransfer element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "90d0f768-3991-4cd3-9995-07d0dab6d41c",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "6a9360da-a323-4e67-b522-4dbd704483a3": {
    "name": "svg filter effect color matrix",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "type": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'matrix'"
          ]
        }
      },
      "values": {
        "type": "string",
        "metadata": {
          "examples": [
            "'1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feColorMatrix element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "6a9360da-a323-4e67-b522-4dbd704483a3",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "066655a1-b9ac-4877-a258-53c8a008db0e": {
    "name": "svg filter effect blend",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "in": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "'SourceGraphic'"
          ]
        }
      },
      "in2": {
        "type": "string",
        "metadata": {
          "examples": [
            "'BackgroundImage'"
          ]
        }
      },
      "mode": {
        "type": "string",
        "metadata": {
          "examples": [
            "'multiply'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG feBlend element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "066655a1-b9ac-4877-a258-53c8a008db0e",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "7bc94934-0b91-46ca-bf45-7b5d2918dd6a": {
    "name": "svg filter",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "id": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG filter element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "7bc94934-0b91-46ca-bf45-7b5d2918dd6a",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "b173c896-4818-46a1-9a5b-ef3a90fea45a": {
    "name": "svg ellipse",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "x": {
        "type": "number",
        "optional": true
      },
      "y": {
        "type": "number",
        "optional": true
      },
      "rx": {
        "type": "number",
        "optional": true
      },
      "ry": {
        "type": "number",
        "optional": true
      },
      "attr": {
        "type": "object",
        "ignored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG circle",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "b173c896-4818-46a1-9a5b-ef3a90fea45a",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "3fcb8e64-923d-11ea-bab1-43fa3b273af8": {
    "name": "svg defs",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG defs",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "3fcb8e64-923d-11ea-bab1-43fa3b273af8",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "8a204a3a-12af-4970-8851-464ebb91342e": {
    "name": "svg clip path",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      },
      "id": {
        "type": "string",
        "optional": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG filter element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "8a204a3a-12af-4970-8851-464ebb91342e",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "7666978e-252c-11eb-97a4-0f3e81286cae": {
    "name": "svg circle",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "x": {
        "type": "number",
        "optional": true
      },
      "y": {
        "type": "number",
        "optional": true
      },
      "r": {
        "type": "number",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG circle",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "7666978e-252c-11eb-97a4-0f3e81286cae",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "25f45f9e-1a62-4b96-9347-7ea5bc0af651": {
    "name": "svg animate transform",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true
      },
      "attributeName": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "from": {
        "type": "string",
        "optional": true
      },
      "to": {
        "type": "string",
        "optional": true
      },
      "dur": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'0.2s', '1s', '3s'"
          ]
        }
      },
      "repeatCount": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'indefinite'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG animate transform element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "25f45f9e-1a62-4b96-9347-7ea5bc0af651",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "9140df42-1c5e-4e18-a106-6ad9be30bb55": {
    "name": "svg animate motion",
    "inputs": {
      "dur": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'0.2s', '1s', '3s'"
          ]
        }
      },
      "repeatCount": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'indefinite'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG animate motion element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "9140df42-1c5e-4e18-a106-6ad9be30bb55",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "4e97caab-d48d-488e-b56b-4141e68fed85": {
    "name": "svg animate",
    "inputs": {
      "attr": {
        "type": "object",
        "optional": true
      },
      "attributeName": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true
      },
      "from": {
        "type": "string",
        "optional": true
      },
      "to": {
        "type": "string",
        "optional": true
      },
      "dur": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'0.2s', '1s', '3s'"
          ]
        }
      },
      "repeatCount": {
        "type": "string",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "'indefinite'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "SVG animate element",
      "tags": [
        "platform",
        "component",
        "svg"
      ]
    },
    "id": "4e97caab-d48d-488e-b56b-4141e68fed85",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "7a8921eb-c1ad-400b-94fc-6c6cead8163d": {
    "name": "video",
    "inputs": {
      "src": {
        "type": "string",
        "metadata": {
          "description": "url pointing to a video data"
        },
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "metadata": {
          "description": "stream object"
        },
        "defaultIgnored": false,
        "optional": true
      },
      "controls": {
        "type": "boolean",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "video",
      "description": "video element",
      "tags": [
        "platform",
        "component",
        "media"
      ]
    },
    "id": "7a8921eb-c1ad-400b-94fc-6c6cead8163d",
    "base": true,
    "component": {
      "defaultWidth": 240,
      "defaultHeight": 180
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`&\`PS\`&\`CS\`&\`IM\`&\`ME\`",
    "render": true,
    "system": true
  },
  "059579bb-184f-435b-ace0-64ec95c9f125": {
    "name": "image",
    "inputs": {
      "src": {
        "type": "string",
        "metadata": {
          "description": "url pointing to a image data"
        },
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "image",
      "description": "HTML image element",
      "tags": [
        "platform",
        "component",
        "media"
      ]
    },
    "id": "059579bb-184f-435b-ace0-64ec95c9f125",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 240
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`&\`IM\`",
    "render": true,
    "system": true
  },
  "06823924-b659-4a22-8ed4-b3243121b55d": {
    "name": "audio",
    "inputs": {
      "src": {
        "type": "string",
        "metadata": {
          "description": "url pointing to a audio data"
        },
        "optional": true
      },
      "style": {
        "type": "object",
        "optional": true
      },
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "metadata": {
          "description": "stream object"
        },
        "defaultIgnored": false,
        "optional": true
      },
      "controls": {
        "type": "boolean",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "volume-2",
      "description": "platform audio component",
      "tags": [
        "platform",
        "component",
        "media"
      ]
    },
    "id": "06823924-b659-4a22-8ed4-b3243121b55d",
    "base": true,
    "component": {
      "defaultWidth": 240,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`&\`ME\`&\`CS\`",
    "render": true,
    "system": true
  },
  "94243ec4-8967-4907-8cdd-7223fe256cf6": {
    "name": "canvas",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "width": {
        "type": "number|string",
        "optional": true
      },
      "height": {
        "type": "number|string",
        "optional": true
      },
      "d": {
        "type": "any[][]",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "chalkboard",
      "description": "for painting",
      "tags": [
        "platform",
        "component",
        "canvas"
      ]
    },
    "id": "94243ec4-8967-4907-8cdd-7223fe256cf6",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`&\`PS\`&\`CS\`&\`CA\`",
    "render": true,
    "system": true
  },
  "e39a2a34-c71a-11ea-9835-07964acf6760": {
    "name": "transcend",
    "inputs": {
      "style": {
        "type": "object"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "atom-alt",
      "description": "\\"get out\\"",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "e39a2a34-c71a-11ea-9835-07964acf6760",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "4caaa14d-282f-49a0-832e-c5254735efbf": {
    "name": "search",
    "inputs": {
      "style": {
        "type": "object"
      },
      "attr": {
        "type": "object",
        "defaultIgnored": true
      },
      "selected": {
        "type": "string"
      },
      "selectedColor": {
        "type": "string"
      },
      "specs": {
        "type": "object{}",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "atom-alt",
      "description": "unit fuzzy list search implementing editor search protocol",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "4caaa14d-282f-49a0-832e-c5254735efbf",
    "base": true,
    "component": {
      "defaultWidth": 360,
      "defaultHeight": 360
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "6b18c608-7b5a-11ea-bb6e-2ff12a5cc3f3": {
    "name": "resize",
    "inputs": {
      "size": {
        "type": "{width:number,height:number}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "expand",
      "description": "all corner resize handlers",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "6b18c608-7b5a-11ea-bb6e-2ff12a5cc3f3",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "bc34c618-1c77-11eb-9785-e39a2bf52e49": {
    "name": "phone keyboard key",
    "inputs": {
      "style": {
        "type": "object"
      },
      "key": {
        "type": "string"
      },
      "altKey": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "keyboard",
      "description": "virtual keyboard single key",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "bc34c618-1c77-11eb-9785-e39a2bf52e49",
    "component": {
      "defaultWidth": 48,
      "defaultHeight": 60
    },
    "base": true,
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "fcccb9a4-1a30-11eb-93b0-e7d511d031f2": {
    "name": "phone keyboard",
    "inputs": {
      "style": {
        "type": "object"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "keyboard",
      "description": "virtual keyboard",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "fcccb9a4-1a30-11eb-93b0-e7d511d031f2",
    "base": true,
    "component": {
      "defaultWidth": 302,
      "defaultHeight": 212
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "b4d025e2-811e-11ea-97ee-1bd8d1736e67": {
    "name": "mode selector",
    "units": {
      "div": {
        "id": "66698a97-15c5-4602-9925-11a1aeb03710",
        "input": {
          "style": {
            "data": "{width:'fit-content',height:'fit-content',opacity:'0.85',top:'50%',left:'6px',textAlign:'center',transform:'translateY(-50%)',display:'flex',flexDirection:'column',position:'relative',gap:'12px',border:'1px solid','min-width':'30px','min-height':'30px'}"
          }
        }
      },
      "iconbutton": {
        "id": "65759894-7d11-11ea-a838-93e14e650d65",
        "input": {
          "icon": {
            "data": "'description'"
          },
          "style": {
            "data": "{height:'24px',width:'24px',marginTop:'6px',marginBottom:'6px'}"
          },
          "activeColor": {
            "ignored": false,
            "data": "'hsla(216, 75%, 50%, 1)'"
          },
          "hoverColor": {
            "ignored": false,
            "data": "'hsla(216, 75%, 50%, 1)'"
          },
          "active": {
            "ignored": false
          }
        }
      },
      "iconbutton0": {
        "id": "65759894-7d11-11ea-a838-93e14e650d65",
        "input": {
          "icon": {
            "data": "'exchange'"
          },
          "style": {
            "data": "{height:'24px',width:'24px',marginTop:'6px',marginBottom:'6px'}"
          },
          "activeColor": {
            "ignored": false,
            "data": "'hsla(0, 100%, 70%, 1)'"
          },
          "hoverColor": {
            "ignored": false,
            "data": "'hsla(0, 100%, 70%, 1)'"
          },
          "active": {
            "ignored": false
          }
        }
      },
      "iconbutton1": {
        "id": "65759894-7d11-11ea-a838-93e14e650d65",
        "input": {
          "icon": {
            "data": "'x'"
          },
          "style": {
            "data": "{height:'24px',width:'24px',marginTop:'6px',marginBottom:'6px'}"
          },
          "activeColor": {
            "ignored": false,
            "data": "'#10a51b'"
          },
          "hoverColor": {
            "ignored": false,
            "data": "'#10a51b'"
          },
          "active": {
            "ignored": false
          }
        }
      },
      "iconbutton2": {
        "id": "65759894-7d11-11ea-a838-93e14e650d65",
        "input": {
          "icon": {
            "data": "'plus-2'"
          },
          "style": {
            "data": "{height:'24px',width:'24px',marginTop:'6px',marginBottom:'6px'}"
          },
          "activeColor": {
            "ignored": false,
            "data": "'#E5E5E5'"
          },
          "hoverColor": {
            "ignored": false,
            "data": "'#C2C2C2'"
          },
          "active": {
            "ignored": false
          }
        }
      },
      "iconbutton3": {
        "id": "65759894-7d11-11ea-a838-93e14e650d65",
        "input": {
          "icon": {
            "data": "'data'"
          },
          "style": {
            "data": "{height:'24px',width:'24px',marginTop:'6px',marginBottom:'6px'}"
          },
          "activeColor": {
            "ignored": false,
            "data": "'#E5E5E5'"
          },
          "hoverColor": {
            "ignored": false,
            "data": "'#C2C2C2'"
          },
          "active": {
            "ignored": false
          }
        }
      },
      "iconbutton4": {
        "id": "65759894-7d11-11ea-a838-93e14e650d65",
        "input": {
          "icon": {
            "data": "'brackets'"
          },
          "style": {
            "data": "{height:'24px',width:'24px',marginTop:'6px',marginBottom:'6px'}"
          },
          "activeColor": {
            "ignored": false,
            "data": "'#E5E5E5'"
          },
          "hoverColor": {
            "ignored": false,
            "data": "'#C2C2C2'"
          },
          "active": {
            "ignored": false
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "data": "'change'",
            "constant": true
          }
        }
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "data": "'remove'",
            "constant": true
          }
        }
      },
      "wait1": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "data": "'add'",
            "constant": true
          }
        }
      },
      "wait2": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "data": "'info'",
            "constant": true
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "d": {
            "data": "'none'",
            "constant": true
          }
        }
      }
    },
    "merges": {
      "4": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "wait0": {
          "output": {
            "a": true
          }
        },
        "wait1": {
          "output": {
            "a": true
          }
        },
        "wait2": {
          "output": {
            "a": true
          }
        },
        "default": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {},
    "outputs": {},
    "component": {
      "defaultWidth": 60,
      "defaultHeight": 300,
      "subComponents": {
        "div": {
          "width": 30,
          "height": 120,
          "children": [
            "iconbutton",
            "iconbutton0",
            "iconbutton1",
            "iconbutton2",
            "iconbutton3",
            "iconbutton4"
          ]
        },
        "iconbutton": {
          "width": 30,
          "height": 30
        },
        "iconbutton0": {
          "width": 30,
          "height": 30
        },
        "iconbutton1": {
          "width": 30,
          "height": 30
        },
        "iconbutton2": {
          "width": 30,
          "height": 30
        },
        "iconbutton3": {
          "width": 30,
          "height": 30
        },
        "iconbutton4": {
          "width": 30,
          "height": 30
        }
      },
      "children": [
        "div"
      ]
    },
    "metadata": {
      "icon": "navigation",
      "description": "select a mode (\\"none\\"|\\"info\\"|\\"add\\"|\\"remove\\"|\\"change\\")",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "b4d025e2-811e-11ea-97ee-1bd8d1736e67",
    "type": "\`U\`&\`C\`&\`G\`",
    "render": true,
    "system": true
  },
  "65759894-7d11-11ea-a838-93e14e650d65": {
    "name": "icon button",
    "inputs": {
      "icon": {
        "plug": {
          "0": {
            "unitId": "default0",
            "pinId": "a"
          }
        },
        "type": "string",
        "ref": false
      },
      "style": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "type": "object",
        "ref": false
      },
      "active": {
        "plug": {
          "0": {
            "unitId": "setifdefault0",
            "pinId": "test"
          }
        },
        "type": "boolean",
        "ref": false
      },
      "activeColor": {
        "plug": {
          "0": {
            "unitId": "setifdefault0",
            "pinId": "value"
          }
        },
        "type": "string",
        "ref": false
      },
      "hoverColor": {
        "plug": {
          "0": {
            "unitId": "setifdefault",
            "pinId": "value"
          }
        },
        "type": "string",
        "ref": false
      },
      "disabled": {
        "plug": {
          "0": {
            "unitId": "setifdefault1",
            "pinId": "test"
          }
        },
        "defaultIgnored": true,
        "type": "boolean",
        "ref": false
      },
      "disabledColor": {
        "plug": {
          "0": {
            "unitId": "setifdefault1",
            "pinId": "value"
          }
        },
        "defaultIgnored": true,
        "type": "string",
        "ref": false
      }
    },
    "outputs": {},
    "units": {
      "icon": {
        "id": "63a417e5-d354-4b39-9ebd-05f55e70de7b",
        "output": {},
        "input": {
          "style": {},
          "icon": {}
        },
        "metadata": {
          "position": {
            "x": -72,
            "y": -51
          }
        }
      },
      "setifdefault": {
        "id": "7b344491-48a2-46e1-949e-56805bebe3da",
        "input": {
          "default": {
            "data": "'#C2C2C2'"
          },
          "obj": {
            "data": "{color:'currentColor',cursor:'pointer'}"
          },
          "test": {},
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 191,
            "y": -3
          }
        }
      },
      "setifdefault0": {
        "id": "7b344491-48a2-46e1-949e-56805bebe3da",
        "input": {
          "default": {
            "data": "'#787878'"
          },
          "test": {},
          "value": {},
          "obj": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 138,
            "y": 103
          }
        }
      },
      "setifdefault1": {
        "id": "7b344491-48a2-46e1-949e-56805bebe3da",
        "input": {
          "default": {
            "data": "'#363636'"
          },
          "test": {},
          "value": {},
          "obj": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 14,
            "y": 119
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": 92,
            "y": -33
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 104,
            "y": -80
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -88,
            "y": 60
          }
        }
      },
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "d": {
            "data": "{}"
          },
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -194,
            "y": 85
          }
        }
      },
      "onpointerenter": {
        "id": "c0bb493a-af78-11ea-b6fa-3b893b757a39",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -7,
            "y": -33
          }
        }
      },
      "onpointerleave": {
        "id": "c7dba94e-af78-11ea-b7d7-47e14ca215b5",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -5,
            "y": -86
          }
        }
      },
      "default0": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {},
          "d": {
            "constant": true,
            "data": "\\"unit\\""
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -181,
            "y": -87
          }
        }
      }
    },
    "merges": {
      "0": {
        "default0": {
          "output": {
            "a": true
          }
        },
        "icon": {
          "input": {
            "icon": true
          }
        }
      },
      "2": {
        "false": {
          "output": {
            "false": true
          }
        },
        "true": {
          "output": {
            "true": true
          }
        },
        "setifdefault": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "setifdefault1": {
          "output": {
            "obj": true
          }
        },
        "merge": {
          "input": {
            "b": true
          }
        }
      },
      "4": {
        "setifdefault0": {
          "output": {
            "obj": true
          }
        },
        "setifdefault1": {
          "input": {
            "obj": true
          }
        }
      },
      "5": {
        "setifdefault": {
          "output": {
            "obj": true
          }
        },
        "setifdefault0": {
          "input": {
            "obj": true
          }
        }
      },
      "6": {
        "default": {
          "output": {
            "a": true
          }
        },
        "merge": {
          "input": {
            "a": true
          }
        }
      },
      "7": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "icon": {
          "input": {
            "style": true
          }
        }
      },
      "8": {
        "onpointerenter": {
          "input": {
            "element": true
          }
        },
        "icon": {
          "output": {
            "_self": true
          }
        },
        "onpointerleave": {
          "input": {
            "element": true
          }
        }
      },
      "9": {
        "onpointerleave": {
          "output": {
            "event": true
          }
        },
        "false": {
          "input": {
            "any": true
          }
        }
      },
      "cuurfvll": {
        "onpointerenter": {
          "output": {
            "event": true
          }
        },
        "true": {
          "input": {
            "any": true
          }
        }
      }
    },
    "render": true,
    "component": {
      "subComponents": {
        "icon": {
          "children": []
        }
      },
      "children": [
        "icon"
      ],
      "defaultWidth": 60,
      "defaultHeight": 60
    },
    "metadata": {
      "icon": "square",
      "description": "button with icon",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "65759894-7d11-11ea-a838-93e14e650d65",
    "type": "\`U\`&\`G\`&\`C\`",
    "system": true
  },
  "96d5d60e-85eb-11eb-ba90-7fc42ab0a641": {
    "name": "GUI control keyboard",
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "chalkboard",
      "description": "unit class component",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "96d5d60e-85eb-11eb-ba90-7fc42ab0a641",
    "base": true,
    "component": {
      "defaultWidth": 210,
      "defaultHeight": 180
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "c9b62bcc-8196-11eb-8372-9f2ac2c356d4": {
    "name": "GUI control",
    "private": true,
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "chalkboard",
      "description": "unit class component",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "c9b62bcc-8196-11eb-8372-9f2ac2c356d4",
    "base": true,
    "component": {
      "defaultWidth": 210,
      "defaultHeight": 180
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "0f043df2-46fc-11eb-ae20-6f1fedd527ba": {
    "name": "GUI",
    "inputs": {
      "style": {
        "type": "object"
      },
      "disabled": {
        "type": "boolean"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "atom-alt",
      "description": "minimalist UI to control a unit graph",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "0f043df2-46fc-11eb-ae20-6f1fedd527ba",
    "component": {
      "defaultWidth": 420,
      "defaultHeight": 300
    },
    "base": true,
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "deps": [
      "6253bf76-2e85-11eb-9f59-3703abfd39c7",
      "ff4144c4-052a-4bc4-93a8-08876b66f0c0"
    ],
    "system": true
  },
  "e80c912e-7508-11ea-966b-436805345ff0": {
    "name": "editor",
    "inputs": {
      "style": {
        "type": "object"
      },
      "attr": {
        "type": "object",
        "defaultIgnored": true
      },
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "disabled": {
        "type": "boolean",
        "defaultIgnored": true
      },
      "fullwindow": {
        "type": "boolean",
        "defaultIgnored": true
      },
      "frame": {
        "type": "\`C\`",
        "ref": true,
        "defaultIgnored": true
      },
      "zoom": {
        "type": "{x:number,y:number,z:number}",
        "defaultIgnored": true
      },
      "controls": {
        "type": "boolean",
        "defaultIgnored": true
      },
      "config": {
        "type": "{geometryOverride?:boolean,plugIcons?:boolean,unlinkTake?:boolean,dataCreate?:boolean,dataEdit?:boolean,dataUnlink?:boolean,dataSelect?:boolean,dataCompatible?:boolean,drawing?:boolean,enterGraph?:boolean,highlightCompatible?:boolean,plugReverse?:boolean,plugUnit?:boolean,multiInputMerge?:boolean,edgeDrag?:boolean,plugNames?:boolean,unitNames?:boolean,pinNames?:boolean,zoom?:boolean|{x?:number,y?:number,z?:number,maxZoom?:number,minZoom?:number},metaSelection?:boolean,center?:'node'|'unit'}",
        "optional": true,
        "defaultIgnored": true
      },
      "value": {
        "type": "{zoom:{x:number,y:number,z:number},fullwindow:boolean}",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true,
        "defaultIgnored": true,
        "icon": "graph"
      },
      "state": {
        "type": "\`V\`&\`J\`",
        "defaultIgnored": true,
        "ref": true
      },
      "value": {
        "type": "{zoom?:{x?:number,y?:number,z?:number},fullwindow?:boolean}",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "atom-alt",
      "description": "Recursive Graph Editor",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "e80c912e-7508-11ea-966b-436805345ff0",
    "base": true,
    "component": {
      "defaultWidth": 360,
      "defaultHeight": 360
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "deps": [
      "4df9733c-9e3a-4ec2-9473-54ae2172cbe6",
      "87f99b85-1c24-4e5b-a903-dd27230f4092",
      "ccf6d0e2-6b08-11eb-9fc3-3785374109d0",
      "cbf8f925-05df-4562-81ed-8cc1ddac6aac",
      "b61f5cc6-37e9-45e1-965b-02940820f7ce",
      "94243ec4-8967-4907-8cdd-7223fe256cf6",
      "0ea7279e-9ca2-48ab-8d70-f5333a717dc4",
      "66698a97-15c5-4602-9925-11a1aeb03710",
      "f59a94c6-4d05-496a-bb36-da5263703ea1",
      "dd7616e2-2e64-4d9c-b13e-ca7efeacd982",
      "321f971c-b898-4ca4-9e6e-3d75d68940f7",
      "b7f043ee-4f9d-4f69-90fe-63b1357ff4c2",
      "23b7df22-79e0-4233-8388-7e6e8f1859c6",
      "06823924-b659-4a22-8ed4-b3243121b55d",
      "059579bb-184f-435b-ace0-64ec95c9f125",
      "7a8921eb-c1ad-400b-94fc-6c6cead8163d",
      "2a5ad480-9d38-4918-8774-41fac7b54203",
      "c711d540-9de3-437e-854a-b59491af3cf8",
      "58bfcb06-b41d-4205-91f5-c00aff3e209c",
      "2168add9-f2f9-4a9d-9af3-5da57705c4f9",
      "eff80fbe-2f83-4a59-8576-9ec0c79ce439",
      "9487c48c-ab31-45ae-897f-348ec222b35e",
      "e7d8b387-3ea7-490e-80da-40af51c9ac4a",
      "e80c912e-7508-11ea-966b-436805345ff0",
      "fecc2df2-ce36-4401-8eed-63d65fb67e6d",
      "cef90fb7-bfcb-4f9d-8828-df6e68278601",
      "4e97caab-d48d-488e-b56b-4141e68fed85",
      "9140df42-1c5e-4e18-a106-6ad9be30bb55",
      "25f45f9e-1a62-4b96-9347-7ea5bc0af651",
      "7666978e-252c-11eb-97a4-0f3e81286cae",
      "8a204a3a-12af-4970-8851-464ebb91342e",
      "3fcb8e64-923d-11ea-bab1-43fa3b273af8",
      "b173c896-4818-46a1-9a5b-ef3a90fea45a",
      "7bc94934-0b91-46ca-bf45-7b5d2918dd6a",
      "066655a1-b9ac-4877-a258-53c8a008db0e",
      "6a9360da-a323-4e67-b522-4dbd704483a3",
      "90d0f768-3991-4cd3-9995-07d0dab6d41c",
      "7db232f5-870c-418a-8efd-fa9bba6c8c4a",
      "fdae0046-d36c-4b21-bb1d-77182d89cadf",
      "1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1",
      "fc78d9fd-45dc-4b01-83d9-8979b5697f56",
      "0c15cd43-6997-4f9f-b52f-acd4c0ed0670",
      "d94b1e9d-0445-4e54-a549-b79e47a3c7a0",
      "8fa07772-cd92-4b7b-b876-29883a27d7c7",
      "f87fd33f-c02a-4238-959f-3520611c7903",
      "1a362a13-9df1-4b22-a9b5-91cdeac1e00f",
      "541f7ae5-3db1-4344-8e87-f42e4d1fdfe8",
      "9023fbd3-8308-4436-a26a-cc19044183e4",
      "1fca03b4-707c-4f16-aeb5-992e55f351c6",
      "e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf",
      "01193871-ae03-4ab3-9d06-e9956b28e626",
      "bdce9206-5331-47dd-a111-902ee41f16ce",
      "be0975fc-a9c7-4d92-a3b9-4479e986c2af",
      "e049f16e-2559-11eb-bdc4-db5b8a11164b",
      "be11165e-489f-11eb-921f-87b924eb0725",
      "38d26d76-2559-11eb-ae02-dfda9b9b137e",
      "a693fa9e-1ab3-4145-968a-9c234a7df038",
      "9932f3bc-9241-11ea-89fa-0b2fdace0f08",
      "a9d998f8-4e62-40b0-8c4d-440e39d28ca3",
      "a95746c4-013d-4dd4-8488-fdca75c4757b",
      "60bc7930-8982-11ea-8b24-cf97a783bb32",
      "de8e7f1a-3064-4e04-b47e-eb06386ac794",
      "e4f85559-b661-49a6-aa90-9191c00e59cd",
      "4a06405b-29d6-483e-9ab4-5f659e139e4c",
      "d1c76124-8869-4145-ba30-e3604e928527",
      "3865cbaf-aac1-4640-b809-c08f979b67f0",
      "c0bfe832-8967-11ea-8c4c-1f2995e41b68",
      "224dcb68-db0e-494c-8b91-7e2ebe0051c6",
      "56744e26-6909-4432-9849-2c77b0f2f2bf",
      "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
      "c68b0424-ced2-43b3-ac82-965163579f7e",
      "3c629fa2-6cc6-4ebc-b265-80444b446d2b",
      "49ef122e-b4d1-11ea-b45e-b73d8ee2aae8",
      "00c828fc-9243-11ea-b897-5b0fc55820c5",
      "e535bcf4-395f-41c7-afa4-01a4861c8859",
      "ad12678e-6642-11eb-9fc3-9fbc75c58110",
      "4e555154-695c-471a-8a91-47bda70f8110"
    ],
    "system": true
  },
  "4df9733c-9e3a-4ec2-9473-54ae2172cbe6": {
    "name": "body",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}",
            "{background:'white'}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML body element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "4df9733c-9e3a-4ec2-9473-54ae2172cbe6",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "ccf6d0e2-6b08-11eb-9fc3-3785374109d0": {
    "name": "anchor",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "href": {
        "type": "string",
        "optional": true
      },
      "target": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "\\"_blank\\""
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "link",
      "description": "HTML anchor element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "ccf6d0e2-6b08-11eb-9fc3-3785374109d0",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "cbf8f925-05df-4562-81ed-8cc1ddac6aac": {
    "name": "bold",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "bold",
      "description": "HTML bold element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "cbf8f925-05df-4562-81ed-8cc1ddac6aac",
    "base": true,
    "component": {
      "defaultWidth": 200,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "b61f5cc6-37e9-45e1-965b-02940820f7ce": {
    "name": "button",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML div element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "b61f5cc6-37e9-45e1-965b-02940820f7ce",
    "base": true,
    "component": {
      "defaultWidth": 90,
      "defaultHeight": 60
    },
    "render": true,
    "system": true
  },
  "0ea7279e-9ca2-48ab-8d70-f5333a717dc4": {
    "name": "details",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML details element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "0ea7279e-9ca2-48ab-8d70-f5333a717dc4",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "66698a97-15c5-4602-9925-11a1aeb03710": {
    "name": "div",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}",
            "{background:'red'}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML div element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "66698a97-15c5-4602-9925-11a1aeb03710",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "f59a94c6-4d05-496a-bb36-da5263703ea1": {
    "name": "form",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML form element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "f59a94c6-4d05-496a-bb36-da5263703ea1",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "dd7616e2-2e64-4d9c-b13e-ca7efeacd982": {
    "name": "header 1",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML h3 heading element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "dd7616e2-2e64-4d9c-b13e-ca7efeacd982",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "321f971c-b898-4ca4-9e6e-3d75d68940f7": {
    "name": "header 2",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML h3 heading element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "321f971c-b898-4ca4-9e6e-3d75d68940f7",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "b7f043ee-4f9d-4f69-90fe-63b1357ff4c2": {
    "name": "header 3",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML h3 heading element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "b7f043ee-4f9d-4f69-90fe-63b1357ff4c2",
    "base": true,
    "component": {
      "defaultWidth": 180,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "23b7df22-79e0-4233-8388-7e6e8f1859c6": {
    "name": "label",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML label element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "23b7df22-79e0-4233-8388-7e6e8f1859c6",
    "base": true,
    "component": {
      "defaultWidth": 150,
      "defaultHeight": 45
    },
    "render": true,
    "system": true
  },
  "2a5ad480-9d38-4918-8774-41fac7b54203": {
    "name": "paragraph",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML h3 heading element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "2a5ad480-9d38-4918-8774-41fac7b54203",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "c711d540-9de3-437e-854a-b59491af3cf8": {
    "name": "span",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML div element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "c711d540-9de3-437e-854a-b59491af3cf8",
    "base": true,
    "component": {
      "defaultWidth": 60,
      "defaultHeight": 60
    },
    "render": true,
    "system": true
  },
  "58bfcb06-b41d-4205-91f5-c00aff3e209c": {
    "name": "summary",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML summary element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "58bfcb06-b41d-4205-91f5-c00aff3e209c",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "2168add9-f2f9-4a9d-9af3-5da57705c4f9": {
    "name": "table",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML table element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "2168add9-f2f9-4a9d-9af3-5da57705c4f9",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "eff80fbe-2f83-4a59-8576-9ec0c79ce439": {
    "name": "table data",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML tr element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "eff80fbe-2f83-4a59-8576-9ec0c79ce439",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "9487c48c-ab31-45ae-897f-348ec222b35e": {
    "name": "table header",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML th element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "9487c48c-ab31-45ae-897f-348ec222b35e",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "e7d8b387-3ea7-490e-80da-40af51c9ac4a": {
    "name": "table row",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML tr element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "e7d8b387-3ea7-490e-80da-40af51c9ac4a",
    "base": true,
    "component": {
      "defaultWidth": 120,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "fecc2df2-ce36-4401-8eed-63d65fb67e6d": {
    "name": "image",
    "inputs": {
      "src": {
        "type": "string"
      }
    },
    "outputs": {
      "image": {
        "type": "\`IM\`&\`J\`",
        "ref": true
      }
    },
    "id": "fecc2df2-ce36-4401-8eed-63d65fb67e6d",
    "base": true,
    "metadata": {
      "icon": "image",
      "description": "load image",
      "tags": [
        "platform",
        "api",
        "media",
        "image"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "e8bce1fc-ae56-4f9f-9685-3cc844758855": {
    "name": "datum",
    "inputs": {
      "style": {
        "type": "object"
      },
      "value": {
        "type": "any"
      }
    },
    "outputs": {
      "value": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "atom-alt",
      "description": "app component used to render data",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "e8bce1fc-ae56-4f9f-9685-3cc844758855",
    "base": true,
    "component": {
      "defaultWidth": 360,
      "defaultHeight": 360
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "c18d7dcc-939b-11ea-90cb-77846d7504a9": {
    "name": "unit class",
    "inputs": {
      "id": {
        "type": "string"
      },
      "style": {
        "type": "object"
      },
      "attr": {
        "type": "object",
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "chalkboard",
      "description": "unit class component",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "c18d7dcc-939b-11ea-90cb-77846d7504a9",
    "base": true,
    "component": {
      "defaultWidth": 100,
      "defaultHeight": 100
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "0e9e6cd4-67eb-11ea-995b-4b0721193361": {
    "name": "bot",
    "inputs": {
      "style": {
        "type": "object"
      },
      "disabled": {
        "type": "boolean"
      },
      "r": {
        "type": "number"
      },
      "x": {
        "type": "string",
        "defaultIgnored": true
      },
      "y": {
        "type": "string",
        "defaultIgnored": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "bot",
      "description": "your fellow robot",
      "tags": [
        "platform",
        "component",
        "app"
      ]
    },
    "id": "0e9e6cd4-67eb-11ea-995b-4b0721193361",
    "base": true,
    "component": {
      "defaultHeight": 200,
      "defaultWidth": 200
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "3ffeaaf8-30dd-11eb-9dcc-836b075fc64d": {
    "name": "zoom",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true
      },
      "zoom": {
        "type": "{x:number,y:number,z:number}",
        "optional": true,
        "metadata": {
          "examples": [
            "{x:0,y:0,z:1}"
          ]
        }
      },
      "width": {
        "type": "number",
        "metadata": {
          "examples": [
            "240"
          ]
        }
      },
      "height": {
        "type": "number",
        "metadata": {
          "examples": [
            "240"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "parent container",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "3ffeaaf8-30dd-11eb-9dcc-836b075fc64d",
    "component": {
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "base": true,
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "454aaff2-cd74-4f6e-baf2-631bb32e7a6b": {
    "name": "wrap",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "optional": true,
        "metadata": {
          "examples": [
            "\${unit:{id:\\"f27cae4e-fea8-11ea-b91e-db41e114c426\\"}}"
          ]
        }
      }
    },
    "outputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true,
        "component": true
      }
    },
    "metadata": {
      "icon": "square",
      "description": "wrap all children with \`component\`",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "454aaff2-cd74-4f6e-baf2-631bb32e7a6b",
    "base": true,
    "component": {
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`&\`WP\`",
    "render": true,
    "system": true
  },
  "3ea02a11-9b11-46d9-948e-ff0e21e4ba14": {
    "name": "section",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML section element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "3ea02a11-9b11-46d9-948e-ff0e21e4ba14",
    "base": true,
    "component": {
      "defaultWidth": 300,
      "defaultHeight": 200
    },
    "render": true,
    "system": true
  },
  "7772a2f5-40c8-482e-83f4-bed9bfb364e3": {
    "name": "render",
    "type": "\`U\`&\`C\`&\`V\`",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "render a unit",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "7772a2f5-40c8-482e-83f4-bed9bfb364e3",
    "base": true,
    "component": {
      "defaultWidth": 300,
      "defaultHeight": 300
    },
    "render": true,
    "system": true
  },
  "78b0939d-43e1-4f6c-867d-e4217a55d217": {
    "name": "parent",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML div element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "78b0939d-43e1-4f6c-867d-e4217a55d217",
    "base": true,
    "component": {
      "defaultWidth": 210,
      "defaultHeight": 210
    },
    "render": true,
    "system": true
  },
  "ded3f778-b5f2-4f1f-80cd-7cf8ba18165c": {
    "name": "nav",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML nav element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "ded3f778-b5f2-4f1f-80cd-7cf8ba18165c",
    "base": true,
    "component": {
      "defaultWidth": 210,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "b5286262-9f92-40d3-8545-88fb3079a0f9": {
    "name": "inherit",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "apply default style to all children",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "b5286262-9f92-40d3-8545-88fb3079a0f9",
    "base": true,
    "component": {
      "defaultWidth": 240,
      "defaultHeight": 240
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "63a417e5-d354-4b39-9ebd-05f55e70de7b": {
    "name": "icon",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "icon": {
        "type": "string",
        "optional": true,
        "metadata": {
          "examples": [
            "\\"unit\\"",
            "\\"circle\\"",
            "\\"square\\""
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "icon from the system",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "63a417e5-d354-4b39-9ebd-05f55e70de7b",
    "base": true,
    "component": {
      "defaultWidth": 45,
      "defaultHeight": 45
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "d7c86a2a-489f-11eb-b83e-d3767f6d49b7": {
    "name": "frame",
    "inputs": {
      "style": {
        "type": "object",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": [
            "{tabIndex:1}",
            "{title:'hello'}",
            "{draggable:true}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "context of the connected \`element\`",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "d7c86a2a-489f-11eb-b83e-d3767f6d49b7",
    "base": true,
    "component": {
      "defaultWidth": 300,
      "defaultHeight": 300
    },
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "render": true,
    "system": true
  },
  "5628f1fb-8c36-4844-b459-89611c07c359": {
    "name": "footer",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML footer element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "5628f1fb-8c36-4844-b459-89611c07c359",
    "base": true,
    "component": {
      "defaultWidth": 210,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "b7bbde81-0ad8-4719-b1a2-cbaf48bb94a4": {
    "name": "article",
    "type": "\`U\`&\`C\`&\`V\`&\`J\`",
    "inputs": {
      "style": {
        "type": "object",
        "optional": true,
        "metadata": {
          "examples": []
        }
      },
      "attr": {
        "type": "object",
        "optional": true,
        "defaultIgnored": true,
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "HTML article element",
      "tags": [
        "platform",
        "component"
      ]
    },
    "id": "b7bbde81-0ad8-4719-b1a2-cbaf48bb94a4",
    "base": true,
    "component": {
      "defaultWidth": 210,
      "defaultHeight": 120
    },
    "render": true,
    "system": true
  },
  "72c84615-4d9c-4a82-a828-fa5d9447a4d5": {
    "name": "icons",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "icons": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "value-absolute",
      "description": "output system \`icons\` dictionary",
      "tags": [
        "platform",
        "asset"
      ]
    },
    "id": "72c84615-4d9c-4a82-a828-fa5d9447a4d5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "625e9caa-fefc-4675-a490-b9a199f25bee": {
    "type": "\`U\`&\`G\`",
    "name": "web socket json duplex",
    "units": {
      "parsejson": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
        "input": {
          "string": {
            "metadata": {
              "position": {
                "x": 86.15384615384616,
                "y": -70.6923076923077
              }
            }
          }
        },
        "output": {
          "json": {
            "metadata": {
              "position": {
                "x": 90,
                "y": 71
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 43,
            "y": 58
          }
        }
      },
      "stringify": {
        "id": "2b24877a-3221-4288-9f59-efbf29964368",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 90,
                "y": -71
              }
            }
          }
        },
        "output": {
          "str": {
            "metadata": {
              "position": {
                "x": 88.15384615384616,
                "y": 70.3076923076923
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 43,
            "y": -58
          }
        }
      },
      "websocketduplex": {
        "id": "acfb72f1-d215-4c8c-ac8b-a2efcc64677d",
        "input": {
          "close": {
            "metadata": {
              "position": {
                "x": -90,
                "y": 17
              }
            }
          },
          "url": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -90,
                "y": -17
              }
            }
          },
          "message": {}
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": -42,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "stringify": {
          "output": {
            "str": true
          }
        },
        "websocketduplex": {
          "input": {
            "message": true
          }
        }
      },
      "1": {
        "parsejson": {
          "input": {
            "string": true
          }
        },
        "websocketduplex": {
          "output": {
            "message": true
          }
        }
      }
    },
    "inputs": {
      "close": {
        "plug": {
          "0": {
            "unitId": "websocketduplex",
            "pinId": "close",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -110,
                "y": 30
              }
            }
          }
        }
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "websocketduplex",
            "pinId": "url",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -110,
                "y": -30
              }
            }
          }
        }
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "stringify",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 110,
                "y": -82
              }
            }
          }
        }
      }
    },
    "outputs": {
      "data": {
        "plug": {
          "0": {
            "unitId": "parsejson",
            "pinId": "json",
            "kind": "output"
          }
        },
        "ref": false,
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 110,
                "y": 82
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "network",
      "description": "web socket send and receive json",
      "position": {
        "merge": {
          "0": {
            "x": -2,
            "y": -34
          },
          "1": {
            "x": -2,
            "y": 34
          }
        }
      },
      "tags": [
        "platform",
        "api",
        "websocket"
      ]
    },
    "id": "625e9caa-fefc-4675-a490-b9a199f25bee",
    "system": true
  },
  "acfb72f1-d215-4c8c-ac8b-a2efcc64677d": {
    "type": "\`U\`&\`G\`",
    "name": "web socket duplex",
    "units": {
      "onmessage": {
        "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
        "input": {
          "emitter": {}
        },
        "output": {
          "message": {
            "metadata": {
              "position": {
                "x": 100,
                "y": -44
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 53,
            "y": -30
          }
        }
      },
      "websocket": {
        "id": "b8fc168e-ee2f-11ea-a42a-730934861ff1",
        "input": {
          "url": {
            "metadata": {
              "position": {
                "x": -101,
                "y": 18
              }
            }
          },
          "close": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -101,
                "y": -18
              }
            }
          }
        },
        "output": {
          "channel": {
            "metadata": {
              "position": {
                "x": 4,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -56,
            "y": 0
          }
        }
      },
      "send": {
        "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
        "input": {
          "channel": {},
          "data": {
            "metadata": {
              "position": {
                "x": 98,
                "y": 43
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 52,
            "y": 30
          }
        }
      }
    },
    "merges": {
      "0": {
        "onmessage": {
          "input": {
            "emitter": true
          }
        },
        "send": {
          "input": {
            "channel": true
          }
        },
        "websocket": {
          "output": {
            "channel": true
          }
        }
      }
    },
    "inputs": {
      "close": {
        "plug": {
          "0": {
            "unitId": "websocket",
            "pinId": "close",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -118,
                "y": -34
              }
            }
          }
        }
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "websocket",
            "pinId": "url",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -117,
                "y": 35
              }
            }
          }
        }
      },
      "message": {
        "plug": {
          "0": {
            "unitId": "send",
            "pinId": "data",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 115,
                "y": 60
              }
            }
          }
        }
      }
    },
    "outputs": {
      "message": {
        "plug": {
          "0": {
            "unitId": "onmessage",
            "pinId": "message",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 118,
                "y": -60
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "network",
      "description": "web socket send and receive",
      "tags": [
        "platform",
        "api",
        "websocket"
      ]
    },
    "id": "acfb72f1-d215-4c8c-ac8b-a2efcc64677d",
    "system": true
  },
  "81a54674-4e9c-11eb-a0e4-2b75980dbd9b": {
    "name": "wake lock",
    "inputs": {
      "type": {
        "type": "'screen'"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "lock",
      "description": "prevent device from dimming or locking the screen",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/Screen_Wake_Lock_API",
      "tags": [
        "platform",
        "api",
        "wakelock"
      ]
    },
    "id": "81a54674-4e9c-11eb-a0e4-2b75980dbd9b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "68992d62-d5ca-11ea-888d-97179b32b7ab": {
    "name": "vibrate",
    "inputs": {
      "pattern": {
        "type": "number[]"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "wave-square",
      "description": "vibrate following period \`pattern\`",
      "tags": [
        "platform",
        "api",
        "vibration"
      ]
    },
    "id": "68992d62-d5ca-11ea-888d-97179b32b7ab",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "56125930-6819-4c03-87c6-3fa042824715": {
    "name": "encode",
    "inputs": {
      "encoder": {
        "type": "\`TE\`",
        "ref": true
      },
      "opt": {
        "type": "object"
      },
      "text": {
        "type": "\`AB\`",
        "ref": true
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "hash"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "encode \`text\` into binary \`data\`",
      "tags": [
        "platform",
        "api",
        "text",
        "method"
      ]
    },
    "id": "56125930-6819-4c03-87c6-3fa042824715",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "12de8298-28f6-4b2b-8962-51cb41e5f99b": {
    "name": "encode",
    "inputs": {
      "encoder": {
        "type": "\`TE\`",
        "ref": true
      },
      "opt": {
        "type": "object"
      },
      "text": {
        "type": "string"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "type": "\`TA\`",
        "ref": true,
        "icon": "hash"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "encode \`text\` into binary \`data\`",
      "tags": [
        "platform",
        "api",
        "text",
        "method"
      ]
    },
    "id": "12de8298-28f6-4b2b-8962-51cb41e5f99b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "24b50c35-e558-4911-a3e3-8ee37777b1f5": {
    "name": "decode",
    "inputs": {
      "decoder": {
        "type": "\`TD\`",
        "ref": true
      },
      "opt": {
        "type": "object"
      },
      "data": {
        "type": "\`AB\`",
        "ref": true
      }
    },
    "outputs": {
      "text": {
        "type": "string",
        "icon": "text"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "decode binary \`data\` into \`text\`",
      "tags": [
        "platform",
        "api",
        "text",
        "method"
      ]
    },
    "id": "24b50c35-e558-4911-a3e3-8ee37777b1f5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ffc86129-e199-4ffb-bea0-f7307e62eafc": {
    "name": "text encoder",
    "inputs": {
      "opt": {
        "type": "{encoding:string}",
        "metadata": {
          "examples": [
            "{encoding:'utf8'}"
          ]
        }
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "encoder": {
        "type": "\`TE\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "square",
      "description": "\`encoder\` takes a stream of code points as input and emits a stream of UTF-8 bytes",
      "tags": [
        "platform",
        "api",
        "text"
      ]
    },
    "id": "ffc86129-e199-4ffb-bea0-f7307e62eafc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a64f3008-ad0d-401b-8294-cf222a5a4ca7": {
    "name": "text decoder",
    "inputs": {
      "label": {
        "type": "'utf-8'"
      },
      "opt": {
        "type": "{fatal?:boolean,ignoreBOM?:boolean}"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "decoder": {
        "type": "\`TD\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "square",
      "description": "\`decoder\` takes a stream of bytes as input and emits a stream of code points",
      "tags": [
        "platform",
        "api",
        "text"
      ]
    },
    "id": "a64f3008-ad0d-401b-8294-cf222a5a4ca7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "dc513ed0-09f4-11eb-a54a-7f4d4e253ef5": {
    "name": "session storage",
    "inputs": {},
    "outputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "table",
      "description": "persist data on current session storage",
      "tags": [
        "platform",
        "api",
        "storage"
      ],
      "globals": [
        "SessionStorage"
      ]
    },
    "id": "dc513ed0-09f4-11eb-a54a-7f4d4e253ef5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c8f3faa8-09f4-11eb-a3b1-477aa3ec4193": {
    "name": "local storage",
    "inputs": {},
    "outputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "table",
      "description": "persist data on local storage",
      "tags": [
        "platform",
        "api",
        "storage"
      ],
      "globals": [
        "LocalStorage"
      ]
    },
    "id": "c8f3faa8-09f4-11eb-a3b1-477aa3ec4193",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "32c6b01a-06af-4145-b02e-1b0276e05379": {
    "name": "local object",
    "inputs": {},
    "outputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "table",
      "description": "persist JSON data on local storage",
      "tags": [
        "platform",
        "api",
        "storage"
      ],
      "globals": [
        "LocalStorage"
      ]
    },
    "id": "32c6b01a-06af-4145-b02e-1b0276e05379",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6db29a62-2035-4cfc-a9d3-03444a8bc2b8": {
    "name": "text to speech",
    "inputs": {
      "message": {
        "type": "string",
        "metadata": {
          "examples": [
            "'hello world'",
            "'welcome to unit!'"
          ]
        }
      },
      "voice": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "message-circle",
      "description": "speak the message",
      "tags": [
        "platform",
        "api",
        "speech"
      ]
    },
    "id": "6db29a62-2035-4cfc-a9d3-03444a8bc2b8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "416550cc-6e02-4ff2-aafa-2f0edbf121c6": {
    "name": "speech to text",
    "inputs": {
      "opt": {
        "type": "{grammars?:string[],lang?:string,interimResults?:boolean,maxAlternatives?:number,continuous?:boolean}",
        "metadata": {
          "examples": [
            "{grammars:[],lang:'en-us',maxAlternatives:1,interimResults:false,continuous:false}"
          ]
        }
      },
      "stop": {
        "type": "any",
        "metadata": {}
      },
      "start": {
        "type": "any",
        "metadata": {}
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "text": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "mic",
      "description": "transcribe user's microphone speech recording",
      "tags": [
        "platform",
        "api",
        "speech"
      ]
    },
    "id": "416550cc-6e02-4ff2-aafa-2f0edbf121c6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "04eda925-4423-40c8-83c8-2117a0d81185": {
    "name": "share",
    "inputs": {
      "data": {
        "type": "{text:string,url:string,title:string}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "share",
      "description": "invokes the native sharing mechanism to share data such as text, URLs, or files",
      "tags": [
        "platform",
        "api",
        "share"
      ]
    },
    "id": "04eda925-4423-40c8-83c8-2117a0d81185",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "de9665db-a188-4252-99f0-ea50fc343058": {
    "name": "scroll into view",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "send",
      "description": "scroll parent until \`component\` is visible",
      "tags": [
        "platform",
        "api",
        "scroll"
      ]
    },
    "base": true,
    "id": "de9665db-a188-4252-99f0-ea50fc343058",
    "type": "\`U\`",
    "system": true
  },
  "9d51399e-06a0-44c6-9e98-04041159b9f3": {
    "name": "scroll",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{behavior?:'smooth'|'auto'|'instant',block?:'nearest'|'start'|'end',top?:number,left?:number}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "send",
      "description": "scroll \`component\`",
      "tags": [
        "platform",
        "api",
        "scroll"
      ]
    },
    "base": true,
    "id": "9d51399e-06a0-44c6-9e98-04041159b9f3",
    "type": "\`U\`",
    "system": true
  },
  "adcd6571-0884-45e8-ac58-8c73f307d98e": {
    "name": "broadcast channel",
    "inputs": {
      "name": {
        "type": "string",
        "metadata": {
          "description": "name of the channel"
        }
      },
      "close": {
        "type": "any",
        "metadata": {
          "description": "signal to close channel"
        }
      }
    },
    "outputs": {
      "channel": {
        "type": "\`CH\`",
        "ref": true,
        "icon": "arrow-up-down"
      }
    },
    "metadata": {
      "icon": "broadcast-tower",
      "description": "channel for same origin communication",
      "tags": [
        "platform",
        "api",
        "process"
      ]
    },
    "id": "adcd6571-0884-45e8-ac58-8c73f307d98e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c7183c96-74cb-4ded-a816-e74d986e7ea8": {
    "name": "toggle popover",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "mouse-pointer",
      "description": "toggle \`component\` popover",
      "tags": [
        "platform",
        "api",
        "popover"
      ]
    },
    "id": "c7183c96-74cb-4ded-a816-e74d986e7ea8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "eed20c86-41fe-46d4-87ba-ad2e6fb1bd4a": {
    "name": "show popover",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "mouse-pointer",
      "description": "show \`component\` popover",
      "tags": [
        "platform",
        "api",
        "popover"
      ]
    },
    "id": "eed20c86-41fe-46d4-87ba-ad2e6fb1bd4a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c6f309c8-9ca7-459c-9dd5-c9c9f92fbe8f": {
    "name": "hide popover",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "mouse-pointer",
      "description": "hide popover element if hidden",
      "tags": [
        "platform",
        "api",
        "popover"
      ]
    },
    "id": "c6f309c8-9ca7-459c-9dd5-c9c9f92fbe8f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d3fc887c-9fc5-11eb-8f63-ab42b0414469": {
    "name": "set pointer capture",
    "inputs": {
      "element": {
        "type": "\`U\`",
        "ref": true
      },
      "pointerId": {
        "type": "number"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "mouse-pointer",
      "description": "set specific \`element\` as the capture target of future pointer events from this \`pointerId\`",
      "tags": [
        "platform",
        "api",
        "pointer"
      ]
    },
    "id": "d3fc887c-9fc5-11eb-8f63-ab42b0414469",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7375aad5-50fd-403c-80ae-471b95088f04": {
    "name": "peer transmitter",
    "inputs": {
      "answer": {
        "type": "string"
      },
      "stream": {
        "type": "\`MS\`",
        "ref": true
      },
      "opt": {
        "type": "{iceServers:{urls:string[]}[]}",
        "metadata": {
          "examples": [
            "{iceServers:[{urls:['stun:stun.l.google.com:19302']}]}"
          ]
        }
      },
      "close": {
        "type": "any"
      }
    },
    "outputs": {
      "offer": {
        "type": "string"
      },
      "channel": {
        "type": "\`CH\`",
        "ref": true,
        "icon": "arrow-up-down"
      }
    },
    "metadata": {
      "icon": "link",
      "description": "output \`offer\` and input \`answer\` to stablish a Peer to Peer (P2P) connection with a remote peer",
      "tags": [
        "platform",
        "api",
        "peer"
      ]
    },
    "id": "7375aad5-50fd-403c-80ae-471b95088f04",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f079a38e-fb4f-496e-8e5f-d5e03a590cda": {
    "name": "peer receiver",
    "inputs": {
      "offer": {
        "type": "string"
      },
      "close": {
        "type": "any"
      },
      "opt": {
        "type": "{iceServers:{urls:string[]}[]}",
        "metadata": {
          "examples": [
            "{iceServers:[{urls:['stun:stun.l.google.com:19302']}]}"
          ]
        }
      }
    },
    "outputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "circle-play"
      },
      "answer": {
        "type": "string"
      },
      "channel": {
        "type": "\`CH\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "link",
      "description": "Peer to Peer (P2P) Receiver",
      "tags": [
        "platform",
        "api",
        "peer"
      ]
    },
    "id": "f079a38e-fb4f-496e-8e5f-d5e03a590cda",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "755b0a17-1b09-45b4-bb7d-e63d21009efd": {
    "name": "peer duplex",
    "inputs": {
      "offer": {
        "plug": {
          "0": {
            "unitId": "receiver",
            "pinId": "offer"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 84,
              "y": -91
            }
          }
        }
      },
      "answer": {
        "plug": {
          "0": {
            "unitId": "transmitter",
            "pinId": "answer"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -81,
              "y": 87
            }
          }
        }
      },
      "stream": {
        "plug": {
          "0": {
            "unitId": "transmitter",
            "pinId": "stream"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -126,
              "y": 50
            }
          }
        }
      },
      "close": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -17,
              "y": -27
            }
          }
        }
      },
      "message": {
        "plug": {
          "0": {
            "unitId": "send",
            "pinId": "data"
          }
        },
        "type": "any",
        "metadata": {
          "position": {
            "0": {
              "x": -188,
              "y": -25
            }
          }
        }
      },
      "opt": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "stream": {
        "plug": {
          "0": {
            "unitId": "receiver",
            "pinId": "stream"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 112,
              "y": 45
            }
          }
        },
        "icon": "circle-play"
      },
      "answer": {
        "plug": {
          "0": {
            "unitId": "receiver",
            "pinId": "answer"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 6,
              "y": -83
            }
          }
        }
      },
      "offer": {
        "plug": {
          "0": {
            "unitId": "transmitter",
            "pinId": "offer"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -8,
              "y": 73
            }
          }
        }
      },
      "message": {
        "plug": {
          "0": {
            "unitId": "onmessage",
            "pinId": "message"
          }
        },
        "type": "any",
        "metadata": {
          "position": {
            "0": {
              "x": 196,
              "y": -39
            }
          }
        }
      }
    },
    "units": {
      "send": {
        "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
        "input": {
          "data": {
            "metadata": {
              "position": {
                "x": -163,
                "y": -14
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -121,
            "y": 27
          }
        }
      },
      "transmitter": {
        "id": "7375aad5-50fd-403c-80ae-471b95088f04",
        "input": {
          "answer": {
            "metadata": {
              "position": {
                "x": -78,
                "y": 59
              }
            }
          },
          "stream": {
            "metadata": {
              "position": {
                "x": -103,
                "y": 32
              }
            }
          },
          "close": {},
          "opt": {}
        },
        "output": {
          "offer": {
            "metadata": {
              "position": {
                "x": -20,
                "y": 47
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": 54
          }
        }
      },
      "receiver": {
        "id": "f079a38e-fb4f-496e-8e5f-d5e03a590cda",
        "input": {
          "offer": {
            "metadata": {
              "position": {
                "x": 81,
                "y": -62
              }
            }
          },
          "close": {},
          "opt": {}
        },
        "output": {
          "stream": {
            "metadata": {
              "position": {
                "x": 97,
                "y": 11
              }
            },
            "icon": "circle-play"
          },
          "answer": {
            "metadata": {
              "position": {
                "x": 16,
                "y": -56
              }
            }
          },
          "channel": {}
        },
        "metadata": {
          "position": {
            "x": 26,
            "y": -36
          }
        }
      },
      "onmessage": {
        "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
        "input": {
          "emitter": {}
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 150,
            "y": -47
          }
        }
      }
    },
    "merges": {
      "0": {
        "onmessage": {
          "input": {
            "emitter": true
          }
        },
        "receiver": {
          "output": {
            "channel": true
          }
        }
      },
      "1": {
        "send": {
          "input": {
            "channel": true
          }
        },
        "transmitter": {
          "output": {
            "channel": true
          }
        }
      },
      "2": {
        "transmitter": {
          "input": {
            "opt": true
          }
        },
        "receiver": {
          "input": {
            "opt": true
          }
        }
      },
      "3": {
        "transmitter": {
          "input": {
            "close": true
          }
        },
        "receiver": {
          "input": {
            "close": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "link",
      "description": "peer transmitter + peer receiver",
      "tags": [
        "platform",
        "api",
        "peer"
      ],
      "position": {
        "merge": {
          "3": {
            "x": -3,
            "y": -4
          }
        }
      }
    },
    "id": "755b0a17-1b09-45b4-bb7d-e63d21009efd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "efd75c06-67c3-4053-8dda-9aadc1d0161c": {
    "name": "tags",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "tags": {
        "type": "string{}"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "object mapping HTML tag name to spec id",
      "tags": [
        "platform",
        "api",
        "parser"
      ]
    },
    "id": "efd75c06-67c3-4053-8dda-9aadc1d0161c",
    "base": true,
    "type": "\`U\`",
    "deps": [
      "4df9733c-9e3a-4ec2-9473-54ae2172cbe6",
      "87f99b85-1c24-4e5b-a903-dd27230f4092",
      "ccf6d0e2-6b08-11eb-9fc3-3785374109d0",
      "cbf8f925-05df-4562-81ed-8cc1ddac6aac",
      "b61f5cc6-37e9-45e1-965b-02940820f7ce",
      "94243ec4-8967-4907-8cdd-7223fe256cf6",
      "0ea7279e-9ca2-48ab-8d70-f5333a717dc4",
      "66698a97-15c5-4602-9925-11a1aeb03710",
      "f59a94c6-4d05-496a-bb36-da5263703ea1",
      "dd7616e2-2e64-4d9c-b13e-ca7efeacd982",
      "321f971c-b898-4ca4-9e6e-3d75d68940f7",
      "b7f043ee-4f9d-4f69-90fe-63b1357ff4c2",
      "23b7df22-79e0-4233-8388-7e6e8f1859c6",
      "06823924-b659-4a22-8ed4-b3243121b55d",
      "059579bb-184f-435b-ace0-64ec95c9f125",
      "7a8921eb-c1ad-400b-94fc-6c6cead8163d",
      "2a5ad480-9d38-4918-8774-41fac7b54203",
      "c711d540-9de3-437e-854a-b59491af3cf8",
      "58bfcb06-b41d-4205-91f5-c00aff3e209c",
      "2168add9-f2f9-4a9d-9af3-5da57705c4f9",
      "eff80fbe-2f83-4a59-8576-9ec0c79ce439",
      "9487c48c-ab31-45ae-897f-348ec222b35e",
      "e7d8b387-3ea7-490e-80da-40af51c9ac4a",
      "4e97caab-d48d-488e-b56b-4141e68fed85",
      "9140df42-1c5e-4e18-a106-6ad9be30bb55",
      "25f45f9e-1a62-4b96-9347-7ea5bc0af651",
      "7666978e-252c-11eb-97a4-0f3e81286cae",
      "8a204a3a-12af-4970-8851-464ebb91342e",
      "3fcb8e64-923d-11ea-bab1-43fa3b273af8",
      "b173c896-4818-46a1-9a5b-ef3a90fea45a",
      "7bc94934-0b91-46ca-bf45-7b5d2918dd6a",
      "066655a1-b9ac-4877-a258-53c8a008db0e",
      "6a9360da-a323-4e67-b522-4dbd704483a3",
      "90d0f768-3991-4cd3-9995-07d0dab6d41c",
      "7db232f5-870c-418a-8efd-fa9bba6c8c4a",
      "fdae0046-d36c-4b21-bb1d-77182d89cadf",
      "1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1",
      "fc78d9fd-45dc-4b01-83d9-8979b5697f56",
      "0c15cd43-6997-4f9f-b52f-acd4c0ed0670",
      "d94b1e9d-0445-4e54-a549-b79e47a3c7a0",
      "8fa07772-cd92-4b7b-b876-29883a27d7c7",
      "f87fd33f-c02a-4238-959f-3520611c7903",
      "1a362a13-9df1-4b22-a9b5-91cdeac1e00f",
      "541f7ae5-3db1-4344-8e87-f42e4d1fdfe8",
      "9023fbd3-8308-4436-a26a-cc19044183e4",
      "1fca03b4-707c-4f16-aeb5-992e55f351c6",
      "e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf",
      "01193871-ae03-4ab3-9d06-e9956b28e626",
      "bdce9206-5331-47dd-a111-902ee41f16ce",
      "be0975fc-a9c7-4d92-a3b9-4479e986c2af",
      "e049f16e-2559-11eb-bdc4-db5b8a11164b",
      "be11165e-489f-11eb-921f-87b924eb0725",
      "38d26d76-2559-11eb-ae02-dfda9b9b137e",
      "a693fa9e-1ab3-4145-968a-9c234a7df038",
      "9932f3bc-9241-11ea-89fa-0b2fdace0f08",
      "a9d998f8-4e62-40b0-8c4d-440e39d28ca3",
      "a95746c4-013d-4dd4-8488-fdca75c4757b",
      "60bc7930-8982-11ea-8b24-cf97a783bb32",
      "de8e7f1a-3064-4e04-b47e-eb06386ac794",
      "e4f85559-b661-49a6-aa90-9191c00e59cd",
      "4a06405b-29d6-483e-9ab4-5f659e139e4c",
      "d1c76124-8869-4145-ba30-e3604e928527",
      "3865cbaf-aac1-4640-b809-c08f979b67f0",
      "c0bfe832-8967-11ea-8c4c-1f2995e41b68",
      "224dcb68-db0e-494c-8b91-7e2ebe0051c6",
      "56744e26-6909-4432-9849-2c77b0f2f2bf",
      "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
      "c68b0424-ced2-43b3-ac82-965163579f7e",
      "3c629fa2-6cc6-4ebc-b265-80444b446d2b",
      "49ef122e-b4d1-11ea-b45e-b73d8ee2aae8",
      "00c828fc-9243-11ea-b897-5b0fc55820c5",
      "e535bcf4-395f-41c7-afa4-01a4861c8859",
      "ad12678e-6642-11eb-9fc3-9fbc75c58110",
      "4e555154-695c-471a-8a91-47bda70f8110"
    ],
    "system": true
  },
  "cdbac889-fb2d-4975-8938-00641a61f35b": {
    "name": "dom to unit",
    "inputs": {
      "type": {
        "type": "'application/xhtml+xml'|'application/xml'|'image/svg+xml'|'text/html'|'text/xml'"
      },
      "text": {
        "type": "string"
      }
    },
    "outputs": {
      "unit": {
        "type": "\`C\`"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a XML or HTML string into an equivalent unit component class",
      "tags": [
        "platform",
        "api",
        "parser"
      ]
    },
    "id": "cdbac889-fb2d-4975-8938-00641a61f35b",
    "base": true,
    "type": "\`U\`",
    "deps": [
      "4df9733c-9e3a-4ec2-9473-54ae2172cbe6",
      "87f99b85-1c24-4e5b-a903-dd27230f4092",
      "ccf6d0e2-6b08-11eb-9fc3-3785374109d0",
      "cbf8f925-05df-4562-81ed-8cc1ddac6aac",
      "b61f5cc6-37e9-45e1-965b-02940820f7ce",
      "94243ec4-8967-4907-8cdd-7223fe256cf6",
      "0ea7279e-9ca2-48ab-8d70-f5333a717dc4",
      "66698a97-15c5-4602-9925-11a1aeb03710",
      "f59a94c6-4d05-496a-bb36-da5263703ea1",
      "dd7616e2-2e64-4d9c-b13e-ca7efeacd982",
      "321f971c-b898-4ca4-9e6e-3d75d68940f7",
      "b7f043ee-4f9d-4f69-90fe-63b1357ff4c2",
      "23b7df22-79e0-4233-8388-7e6e8f1859c6",
      "06823924-b659-4a22-8ed4-b3243121b55d",
      "059579bb-184f-435b-ace0-64ec95c9f125",
      "7a8921eb-c1ad-400b-94fc-6c6cead8163d",
      "2a5ad480-9d38-4918-8774-41fac7b54203",
      "c711d540-9de3-437e-854a-b59491af3cf8",
      "58bfcb06-b41d-4205-91f5-c00aff3e209c",
      "2168add9-f2f9-4a9d-9af3-5da57705c4f9",
      "eff80fbe-2f83-4a59-8576-9ec0c79ce439",
      "9487c48c-ab31-45ae-897f-348ec222b35e",
      "e7d8b387-3ea7-490e-80da-40af51c9ac4a",
      "4e97caab-d48d-488e-b56b-4141e68fed85",
      "9140df42-1c5e-4e18-a106-6ad9be30bb55",
      "25f45f9e-1a62-4b96-9347-7ea5bc0af651",
      "7666978e-252c-11eb-97a4-0f3e81286cae",
      "8a204a3a-12af-4970-8851-464ebb91342e",
      "3fcb8e64-923d-11ea-bab1-43fa3b273af8",
      "b173c896-4818-46a1-9a5b-ef3a90fea45a",
      "7bc94934-0b91-46ca-bf45-7b5d2918dd6a",
      "066655a1-b9ac-4877-a258-53c8a008db0e",
      "6a9360da-a323-4e67-b522-4dbd704483a3",
      "90d0f768-3991-4cd3-9995-07d0dab6d41c",
      "7db232f5-870c-418a-8efd-fa9bba6c8c4a",
      "fdae0046-d36c-4b21-bb1d-77182d89cadf",
      "1e9b1142-bbcf-4627-8cc2-86d5a3bb3dd1",
      "fc78d9fd-45dc-4b01-83d9-8979b5697f56",
      "0c15cd43-6997-4f9f-b52f-acd4c0ed0670",
      "d94b1e9d-0445-4e54-a549-b79e47a3c7a0",
      "8fa07772-cd92-4b7b-b876-29883a27d7c7",
      "f87fd33f-c02a-4238-959f-3520611c7903",
      "1a362a13-9df1-4b22-a9b5-91cdeac1e00f",
      "541f7ae5-3db1-4344-8e87-f42e4d1fdfe8",
      "9023fbd3-8308-4436-a26a-cc19044183e4",
      "1fca03b4-707c-4f16-aeb5-992e55f351c6",
      "e98c55d5-9dce-4ca3-b7e5-08aa6b18eacf",
      "01193871-ae03-4ab3-9d06-e9956b28e626",
      "bdce9206-5331-47dd-a111-902ee41f16ce",
      "be0975fc-a9c7-4d92-a3b9-4479e986c2af",
      "e049f16e-2559-11eb-bdc4-db5b8a11164b",
      "be11165e-489f-11eb-921f-87b924eb0725",
      "38d26d76-2559-11eb-ae02-dfda9b9b137e",
      "a693fa9e-1ab3-4145-968a-9c234a7df038",
      "9932f3bc-9241-11ea-89fa-0b2fdace0f08",
      "a9d998f8-4e62-40b0-8c4d-440e39d28ca3",
      "a95746c4-013d-4dd4-8488-fdca75c4757b",
      "60bc7930-8982-11ea-8b24-cf97a783bb32",
      "de8e7f1a-3064-4e04-b47e-eb06386ac794",
      "e4f85559-b661-49a6-aa90-9191c00e59cd",
      "4a06405b-29d6-483e-9ab4-5f659e139e4c",
      "d1c76124-8869-4145-ba30-e3604e928527",
      "3865cbaf-aac1-4640-b809-c08f979b67f0",
      "c0bfe832-8967-11ea-8c4c-1f2995e41b68",
      "224dcb68-db0e-494c-8b91-7e2ebe0051c6",
      "56744e26-6909-4432-9849-2c77b0f2f2bf",
      "98c279fc-7f5e-11ea-b9e4-f772f9f0bed1",
      "c68b0424-ced2-43b3-ac82-965163579f7e",
      "3c629fa2-6cc6-4ebc-b265-80444b446d2b",
      "49ef122e-b4d1-11ea-b45e-b73d8ee2aae8",
      "00c828fc-9243-11ea-b897-5b0fc55820c5",
      "e535bcf4-395f-41c7-afa4-01a4861c8859",
      "ad12678e-6642-11eb-9fc3-9fbc75c58110",
      "4e555154-695c-471a-8a91-47bda70f8110"
    ],
    "system": true
  },
  "2f2d5ea4-6dd2-406e-a095-5552ebc235e7": {
    "name": "size observer",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "object"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "width": {
        "type": "number"
      },
      "height": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "watch the size of a component",
      "tags": [
        "platform",
        "api",
        "observer"
      ]
    },
    "id": "2f2d5ea4-6dd2-406e-a095-5552ebc235e7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b27ee28f-54fb-4737-91f5-04b52b7cf92d": {
    "name": "position observer",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "entry": {
        "type": "{x:number,y:number}"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "watch the position of a component",
      "tags": [
        "platform",
        "api",
        "observer"
      ]
    },
    "id": "b27ee28f-54fb-4737-91f5-04b52b7cf92d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e8aded15-a1af-42a0-9a9d-f88fcfd03dc3": {
    "name": "observe",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "done": {
        "type": "any"
      },
      "observer": {
        "type": "\`OB\`",
        "ref": true
      }
    },
    "outputs": {
      "entry": {
        "type": "<T>"
      }
    },
    "metadata": {
      "icon": "eye",
      "description": "monitors \`component\` to detect when it intersects with a defined ancestor",
      "tags": [
        "platform",
        "api",
        "observer"
      ]
    },
    "id": "e8aded15-a1af-42a0-9a9d-f88fcfd03dc3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "34a36b3a-cb04-4429-bdbc-15e0c278ad7a": {
    "name": "intersection observer",
    "inputs": {
      "root": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "observer": {
        "type": "\`OB\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "asynchronously observe changes in the intersection of a target element with a \`root\` element",
      "tags": [
        "platform",
        "api",
        "observer"
      ]
    },
    "id": "34a36b3a-cb04-4429-bdbc-15e0c278ad7a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "5aea0bf0-0815-11eb-9304-5f90b5542620": {
    "name": "show",
    "inputs": {
      "this": {
        "type": "\`U\`",
        "ref": true
      },
      "title": {
        "type": "string"
      },
      "opt": {
        "type": "{icon?:string,body?:string}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "bell",
      "description": "push \`notification\` to system tray",
      "tags": [
        "platform",
        "api",
        "notification"
      ]
    },
    "id": "5aea0bf0-0815-11eb-9304-5f90b5542620",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "bb029770-080e-11eb-9d38-f314d076f14b": {
    "name": "notification",
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "bell",
      "description": "notification object",
      "tags": [
        "platform",
        "api",
        "notification"
      ]
    },
    "id": "bb029770-080e-11eb-9d38-f314d076f14b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "29e974cc-081b-11eb-a607-1fd4ec67a52f": {
    "name": "close",
    "inputs": {
      "this": {
        "short": "ntf",
        "type": "\`U\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "bell",
      "description": "remove \`notification\` from system tray",
      "tags": [
        "platform",
        "api",
        "notification"
      ]
    },
    "id": "29e974cc-081b-11eb-a607-1fd4ec67a52f",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "81e15593-293c-4890-ae8e-d1e845673d28": {
    "name": "readable stream",
    "inputs": {
      "opt": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "data": {
        "type": "string"
      },
      "end": {
        "type": "any"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "stream": {
        "type": "\`RS\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "send",
      "description": "create a readable stream of byte data",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream",
      "tags": [
        "platform",
        "api",
        "network",
        "stream"
      ]
    },
    "id": "81e15593-293c-4890-ae8e-d1e845673d28",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b8fc168e-ee2f-11ea-a42a-730934861ff1": {
    "name": "web socket",
    "inputs": {
      "url": {
        "type": "string"
      },
      "close": {
        "type": "any",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "channel": {
        "type": "\`CH\`",
        "ref": true,
        "icon": "arrow-up-down"
      }
    },
    "metadata": {
      "icon": "network",
      "description": "create, manage and message a web socket connection to a server",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/WebSocket",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "b8fc168e-ee2f-11ea-a42a-730934861ff1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b0d71197-fad7-4fc6-87e4-97636d365de6": {
    "name": "to text",
    "inputs": {
      "body": {
        "type": "\`BO\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "text": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "send",
      "description": "reads response to completion and parse the body as text",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "b0d71197-fad7-4fc6-87e4-97636d365de6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4e14b9e8-a694-4c58-b509-fc53a279c22c": {
    "name": "to json",
    "inputs": {
      "body": {
        "type": "\`BO\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "json": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "send",
      "description": "reads response to completion and parse the body text as JSON",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "4e14b9e8-a694-4c58-b509-fc53a279c22c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e22782a9-31e9-4b12-83ca-1000607fd39b": {
    "name": "to blob",
    "inputs": {
      "body": {
        "type": "\`BO\`",
        "ref": true
      },
      "any": {
        "type": "any"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "blob": {
        "type": "\`B\`",
        "ref": true,
        "icon": "file"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "send",
      "description": "reads response to completion and parse the body as a Blob",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "e22782a9-31e9-4b12-83ca-1000607fd39b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e0cc1342-810e-4d19-a450-08498819fae7": {
    "name": "to array buffer",
    "inputs": {
      "body": {
        "type": "\`BO\`",
        "ref": true
      },
      "any": {
        "type": "any"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "buffer": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "array"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "send",
      "description": "reads response to completion and parse the body as an ArrayBuffer",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "e0cc1342-810e-4d19-a450-08498819fae7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b97c0133-6c87-4b69-af4e-354c0b590ece": {
    "name": "fetch",
    "inputs": {
      "url": {
        "type": "string",
        "metadata": {
          "examples": [
            "'/'"
          ]
        }
      },
      "opt": {
        "type": "{body?:string|null,headers?:object,method?:string}",
        "metadata": {
          "examples": [
            "{method:'GET'}"
          ]
        }
      },
      "body": {
        "type": "\`BO\`",
        "metadata": {},
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "res": {
        "type": "\`RES\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "send",
      "description": "fetch a resource across the network through HTTP",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "b97c0133-6c87-4b69-af4e-354c0b590ece",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "41de8d5e-2c41-441c-ad29-cc3f5d4e6c7a": {
    "name": "event source",
    "inputs": {
      "url": {
        "type": "string",
        "metadata": {
          "examples": [
            "'/'"
          ]
        }
      },
      "opt": {
        "type": "{withCredentials?:boolean}",
        "metadata": {
          "examples": [
            "{}",
            "{widthCredentials:true}",
            "{widthCredentials:false}"
          ]
        }
      },
      "close": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "emitter": {
        "type": "\`EE\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "network",
      "description": "opens a persistent connection to an HTTP server, which sends events in text/event-stream format",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/EventSource",
      "tags": [
        "platform",
        "api",
        "network"
      ]
    },
    "id": "41de8d5e-2c41-441c-ad29-cc3f5d4e6c7a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "262beb5f-21bd-4848-a62d-185f6f8a78e1": {
    "name": "image to bitmap",
    "inputs": {
      "opt": {
        "type": "{imageOrientation?:'none'|'flipY',premultiplyAlpha?:'none'|'premultiply'|'default',colorSpaceConversion?:'none'|'default',resizeWidth?:number,resizeHeight?:number,resizeQuality?:'pixelated'|'low'|'medium'}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "image": {
        "type": "\`IM\`",
        "ref": true
      },
      "rect": {
        "type": "{x?:number,y?:number,width?:number,height?:number}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {
      "bitmap": {
        "type": "\`IB\`",
        "ref": true
      }
    },
    "id": "262beb5f-21bd-4848-a62d-185f6f8a78e1",
    "base": true,
    "metadata": {
      "icon": "image",
      "description": "transform image to bitmap",
      "tags": [
        "platform",
        "api",
        "media",
        "image"
      ],
      "globals": [
        "MediaRecorder"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "11822d85-9e53-4658-92ed-f0c0428a5565": {
    "name": "image",
    "inputs": {
      "image": {
        "type": "\`IM\`",
        "ref": true
      }
    },
    "outputs": {
      "image": {
        "type": "\`IM\`&\`J\`",
        "ref": true
      }
    },
    "id": "11822d85-9e53-4658-92ed-f0c0428a5565",
    "base": true,
    "metadata": {
      "icon": "image",
      "description": "load image",
      "tags": [
        "platform",
        "api",
        "media",
        "image"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "c18c8f59-f3c8-49a8-9dbd-ed30fdf856e9": {
    "name": "download url",
    "inputs": {
      "url": {
        "type": "string",
        "metadata": {
          "examples": []
        }
      },
      "name": {
        "type": "string"
      }
    },
    "outputs": {},
    "id": "c18c8f59-f3c8-49a8-9dbd-ed30fdf856e9",
    "metadata": {
      "icon": "download",
      "description": "download whatever is at the given \`url\`",
      "tags": [
        "platform",
        "api",
        "media",
        "download"
      ]
    },
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "b5ab65ce-4306-4a46-8d3c-36b6c29b1c60": {
    "name": "download text",
    "inputs": {
      "text": {
        "type": "string",
        "metadata": {
          "examples": [
            "\\"unit\\""
          ]
        }
      },
      "name": {
        "type": "string",
        "metadata": {
          "examples": [
            "\\"text\\""
          ]
        }
      },
      "mimetype": {
        "type": "string",
        "metadata": {
          "examples": [
            "\\"text/plain\\"",
            "\\"application/json\\""
          ]
        }
      },
      "charset": {
        "type": "string",
        "metadata": {
          "examples": [
            "\\"utf-8\\""
          ]
        }
      }
    },
    "outputs": {},
    "id": "b5ab65ce-4306-4a46-8d3c-36b6c29b1c60",
    "metadata": {
      "icon": "download",
      "description": "download a \`text\` string",
      "tags": [
        "platform",
        "api",
        "media",
        "download"
      ]
    },
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "766e8fb5-b78e-4266-8571-54238eb1636b": {
    "name": "start",
    "inputs": {
      "node": {
        "type": "\`BSN\`",
        "ref": true
      },
      "opt": {
        "type": "{start?:number,offset?:number,duration?:number}",
        "metadata": {
          "examples": [
            "{}",
            "{start:0}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "activity",
      "description": "schedule audio buffer node playback",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "766e8fb5-b78e-4266-8571-54238eb1636b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c2738ec3-72fa-4432-96b9-74abb1a6f26a": {
    "name": "oscillator node",
    "inputs": {
      "node": {
        "type": "\`AC\`|\`AN\`",
        "ref": true
      },
      "opt": {
        "type": "{frequency?:number,type?:string,detune?:number}",
        "metadata": {
          "examples": [
            "{type:'sine',frequency:440}"
          ]
        }
      }
    },
    "outputs": {
      "node": {
        "type": "\`ON\`&\`AN\`",
        "ref": true
      },
      "frequency": {
        "type": "\`V\`",
        "ref": true,
        "defaultIgnored": true
      },
      "detune": {
        "type": "\`V\`",
        "ref": true,
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "periodic waveform, such as a sine wave",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "c2738ec3-72fa-4432-96b9-74abb1a6f26a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "33c623e5-bce2-4f30-9a98-50218bb6c431": {
    "name": "mixer node",
    "inputs": {
      "a": {
        "type": "\`AN\`",
        "ref": true
      },
      "b": {
        "type": "\`AN\`",
        "ref": true
      }
    },
    "outputs": {
      "node": {
        "type": "\`AN\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "add two audio signals together",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "33c623e5-bce2-4f30-9a98-50218bb6c431",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "009976af-80f1-4144-9be4-4b8126586354": {
    "name": "media stream destination node",
    "inputs": {
      "node": {
        "type": "\`AN\`",
        "ref": true
      }
    },
    "outputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "circle-play"
      }
    },
    "metadata": {
      "icon": "speaker",
      "description": "create media stream from audio node",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioDestinationNode"
      ]
    },
    "id": "009976af-80f1-4144-9be4-4b8126586354",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "31408be3-cc2a-490a-b0d1-96e0028ca68e": {
    "name": "media stream audio source node",
    "inputs": {
      "node": {
        "type": "\`AC\`|\`AN\`",
        "ref": true
      },
      "opt": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "circle-play"
      }
    },
    "outputs": {
      "node": {
        "type": "\`AN\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "periodic waveform, such as a sine wave",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "31408be3-cc2a-490a-b0d1-96e0028ca68e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e4ea5dce-10ea-434b-a93d-c874a92f2f39": {
    "name": "get byte time domain data",
    "inputs": {
      "node": {
        "type": "\`AAN\`",
        "ref": true
      },
      "opt": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{fftSize:2048}"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "type": "\`A\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "copies the current time data into an unsigned byte array",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioAnalyser"
      ]
    },
    "id": "e4ea5dce-10ea-434b-a93d-c874a92f2f39",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2ec96f8b-4ea5-4ba8-ab8d-a00105c6cb71": {
    "name": "get byte frequency data",
    "inputs": {
      "node": {
        "type": "\`AAN\`",
        "ref": true
      },
      "opt": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{fftSize:2048}"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "data": {
        "type": "\`A\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "copies the current frequency data into a unsigned byte array",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioAnalyser"
      ]
    },
    "id": "2ec96f8b-4ea5-4ba8-ab8d-a00105c6cb71",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a8d7c089-0385-4922-bb3a-6c550a8a1b3b": {
    "name": "gain node",
    "inputs": {
      "node": {
        "type": "\`AC\`|\`AN\`",
        "ref": true
      },
      "gain": {
        "type": "number",
        "metadata": {
          "examples": [
            "1",
            "0",
            "0.5"
          ]
        }
      }
    },
    "outputs": {
      "node": {
        "type": "\`ON\`&\`AN\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "apply gain to audio signal",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "a8d7c089-0385-4922-bb3a-6c550a8a1b3b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9543c94b-e19e-430b-8a48-9cda8dae44c5": {
    "name": "delay node",
    "inputs": {
      "node": {
        "type": "\`AC\`|\`AN\`",
        "ref": true
      },
      "gain": {
        "type": "number",
        "metadata": {
          "examples": [
            "1",
            "0",
            "0.5"
          ]
        }
      }
    },
    "outputs": {
      "node": {
        "type": "\`ON\`&\`AN\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "apply delay to audio signal",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "9543c94b-e19e-430b-8a48-9cda8dae44c5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "59332eaf-ab47-44e5-9417-7179574fb2af": {
    "name": "decode audio data",
    "inputs": {
      "buffer": {
        "type": "\`AB\`",
        "ref": true
      },
      "context": {
        "type": "\`AC\`",
        "ref": true
      }
    },
    "outputs": {
      "buffer": {
        "type": "\`ADB\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "decode audio file data contained in an array buffer",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "Audio"
      ]
    },
    "id": "59332eaf-ab47-44e5-9417-7179574fb2af",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9007bcd5-6697-480c-9566-a5edf4d7c90f": {
    "name": "buffer source node",
    "inputs": {
      "buffer": {
        "type": "\`ADB\`",
        "ref": true
      },
      "context": {
        "type": "\`AC\`",
        "ref": true
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "node": {
        "type": "\`BSN\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "audio source node consisting of in-memory buffer to be played once",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "Audio"
      ]
    },
    "id": "9007bcd5-6697-480c-9566-a5edf4d7c90f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a7dee8c6-15a3-4b7e-8f63-03f13a7d34a9": {
    "name": "audio target",
    "inputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true
      },
      "id": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "headphones",
      "description": "play audio stream on a selected device",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "Audio"
      ]
    },
    "id": "a7dee8c6-15a3-4b7e-8f63-03f13a7d34a9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "5c13db99-0923-4b27-85e3-7a18dbfdd309": {
    "name": "audio source",
    "inputs": {
      "src": {
        "type": "string",
        "metadata": {
          "description": "URL of the a media resource"
        }
      }
    },
    "outputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "audio-waveform"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "streams audio from a source url silently",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "Audio"
      ]
    },
    "id": "5c13db99-0923-4b27-85e3-7a18dbfdd309",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "71ff4fda-5878-4d4c-b55b-c2c79d8dc546": {
    "name": "audio destination node",
    "inputs": {
      "node": {
        "type": "\`AN\`",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "speaker",
      "description": "end destination of an audio graph in a given context",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioDestinationNode"
      ]
    },
    "id": "71ff4fda-5878-4d4c-b55b-c2c79d8dc546",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f5df301d-da63-492a-9e59-950289fe6ba9": {
    "name": "audio context",
    "inputs": {
      "opt": {
        "type": "object"
      }
    },
    "outputs": {
      "ctx": {
        "type": "\`AC\`",
        "ref": true,
        "icon": "square-play"
      }
    },
    "metadata": {
      "icon": "sliders",
      "description": "control an audio-processing graph built from audio modules linked together",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioContext"
      ]
    },
    "id": "f5df301d-da63-492a-9e59-950289fe6ba9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "210632fc-f85b-4f13-a2a9-f689ff85da78": {
    "name": "analyser node",
    "inputs": {
      "node": {
        "type": "\`AC\`|\`AN\`",
        "ref": true
      },
      "opt": {
        "type": "{fftSize?:number,frequencyBinCount?:number,minDecibels?:number,maxDecibels?:number,smoothingTimeConstant?:number}",
        "metadata": {
          "examples": [
            "{fftSize:2048}"
          ]
        }
      }
    },
    "outputs": {
      "node": {
        "type": "\`AAN\`&\`AN\`",
        "ref": true,
        "icon": "square-activity"
      }
    },
    "metadata": {
      "icon": "activity",
      "description": "provide real-time frequency and time-domain analysis information from input \`node\`",
      "tags": [
        "platform",
        "api",
        "media",
        "audio"
      ],
      "globals": [
        "AudioAnalyser"
      ]
    },
    "id": "210632fc-f85b-4f13-a2a9-f689ff85da78",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3889d2f1-a0ed-4e8c-8e75-7a6683224275": {
    "name": "request picture in picture",
    "inputs": {
      "media": {
        "type": "\`PS\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "arrow-up-right",
      "description": "request picture in picture window for \`media\`",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "Video"
      ]
    },
    "base": true,
    "id": "3889d2f1-a0ed-4e8c-8e75-7a6683224275",
    "type": "\`U\`",
    "system": true
  },
  "ab507863-2307-40c6-982b-c45680458997": {
    "name": "play",
    "inputs": {
      "media": {
        "type": "\`ME\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "play",
      "description": "play media element",
      "tags": [
        "platform",
        "api",
        "media"
      ]
    },
    "id": "ab507863-2307-40c6-982b-c45680458997",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "44968bd5-f1a5-4f81-a32f-8ee5a6e4a842": {
    "name": "pause",
    "inputs": {
      "media": {
        "type": "\`ME\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "play",
      "description": "play media element",
      "tags": [
        "platform",
        "api",
        "media"
      ]
    },
    "id": "44968bd5-f1a5-4f81-a32f-8ee5a6e4a842",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7e1b3a4c-be6b-11eb-b098-1b6b9db93f1e": {
    "name": "media recorder",
    "inputs": {
      "opt": {
        "type": "{mimeType?:string,bitsPerSecond?:number,audioBitsPerSecond?:number,videoBitsPerSecond?:number}",
        "metadata": {
          "examples": [
            "{mimeType:\\"video/webm;codecs=h264\\",audioBitsPerSecond:128000,videoBitsPerSecond:3145728}"
          ]
        }
      },
      "start": {
        "type": "any"
      },
      "stop": {
        "type": "any"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      },
      "stream": {
        "type": "\`MS\`",
        "ref": true
      }
    },
    "outputs": {
      "blob": {
        "type": "\`B\`",
        "ref": true,
        "icon": "file"
      },
      "err": {
        "type": "string",
        "defaultIgnored": true
      }
    },
    "id": "7e1b3a4c-be6b-11eb-b098-1b6b9db93f1e",
    "base": true,
    "metadata": {
      "icon": "film",
      "description": "provides functionality to record media",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "MediaRecorder"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "a57383a9-5b24-4dbb-a5d1-0e278d036f89": {
    "name": "image capture",
    "inputs": {
      "track": {
        "type": "\`MST\`",
        "ref": true
      },
      "init": {
        "type": "any"
      },
      "done": {
        "type": "number"
      }
    },
    "outputs": {
      "camera": {
        "type": "\`IC\`",
        "ref": true
      }
    },
    "id": "a57383a9-5b24-4dbb-a5d1-0e278d036f89",
    "base": true,
    "metadata": {
      "icon": "film",
      "description": "enable the capture of images or photos from a camera device",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "ImageCapture"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "f238caff-3f71-40d9-b1a9-d992060fea04": {
    "name": "grab frame",
    "inputs": {
      "camera": {
        "type": "\`IC\`",
        "ref": true
      },
      "init": {
        "type": "any"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "image": {
        "type": "\`IB\`",
        "ref": true
      }
    },
    "id": "f238caff-3f71-40d9-b1a9-d992060fea04",
    "base": true,
    "metadata": {
      "icon": "film",
      "description": "takes a snapshot of the live video in a media stream track",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "MediaRecorder"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "0bc0c4ad-d2e0-4e3e-92e8-5b9dfee1cf5e": {
    "name": "get video tracks",
    "inputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true
      },
      "init": {
        "type": "any"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "tracks": {
        "type": "\`MST\`[]",
        "ref": true
      }
    },
    "id": "0bc0c4ad-d2e0-4e3e-92e8-5b9dfee1cf5e",
    "base": true,
    "metadata": {
      "icon": "film",
      "description": "get \`stream\` video tracks",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "MediaStreamTrack"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "a6e30b43-9ab4-4206-bfba-3f2129faac30": {
    "name": "get user media",
    "inputs": {
      "opt": {
        "type": "{audio?:boolean,video?:boolean}"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "circle-play"
      }
    },
    "id": "a6e30b43-9ab4-4206-bfba-3f2129faac30",
    "base": true,
    "metadata": {
      "icon": "film",
      "description": "get user's default audio/video media stream",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "MediaDevices"
      ]
    },
    "type": "\`U\`",
    "system": true
  },
  "6705462c-5b47-11eb-9dfc-2f14c58b2789": {
    "name": "get display media",
    "inputs": {
      "opt": {
        "type": "{audio?:boolean,video?:boolean}"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "circle-play"
      }
    },
    "id": "6705462c-5b47-11eb-9dfc-2f14c58b2789",
    "base": true,
    "metadata": {
      "icon": "film",
      "description": "prompts the user to capture the contents of a display or portion thereof",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "MediaDevices"
      ],
      "href": ""
    },
    "type": "\`U\`",
    "system": true
  },
  "3511f756-2a02-4346-b417-8c34502f79d4": {
    "name": "enumerate devices",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "devices": {
        "type": "{deviceId:string,groupId:string,kind:string,label:string}[]"
      }
    },
    "metadata": {
      "icon": "list",
      "description": "output a list of the available media input and output devices, such as microphones, cameras, headsets, and so forth",
      "tags": [
        "platform",
        "api",
        "media"
      ]
    },
    "id": "3511f756-2a02-4346-b417-8c34502f79d4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ba8b9b28-79f5-42d6-9c98-3555ce4982cb": {
    "name": "document picture in picture",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{preferInitialWindowPlacement?:boolean}",
        "metadata": {
          "examples": [
            "{},{preferInitialWindowPlacement:true}"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "complexity": 13,
      "icon": "arrow-up-right",
      "description": "request picture in picture window for \`media\`",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "Video"
      ]
    },
    "base": true,
    "id": "ba8b9b28-79f5-42d6-9c98-3555ce4982cb",
    "type": "\`U\`",
    "system": true
  },
  "30e125ba-af81-11ea-ba6b-e70218ca7afe": {
    "name": "capture stream",
    "inputs": {
      "source": {
        "type": "\`CS\`",
        "ref": true
      },
      "opt": {
        "type": "{frameRate?:number}",
        "metadata": {
          "examples": [
            "{}",
            "{frameRate:60}"
          ]
        }
      },
      "stop": {
        "type": "any"
      }
    },
    "outputs": {
      "stream": {
        "type": "\`MS\`",
        "ref": true,
        "icon": "circle-play"
      }
    },
    "metadata": {
      "icon": "square",
      "description": "request a stream containing a real-time video capture of the \`media\` element",
      "tags": [
        "platform",
        "api",
        "media"
      ],
      "globals": [
        "MediaSource"
      ]
    },
    "base": true,
    "id": "30e125ba-af81-11ea-ba6b-e70218ca7afe",
    "type": "\`U\`&\`MS\`",
    "system": true
  },
  "30f6738c-1938-4dcd-9e7f-6c10f9730021": {
    "name": "location",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "map-pin",
      "description": "current web context location url",
      "tags": [
        "platform",
        "api",
        "location"
      ]
    },
    "id": "30f6738c-1938-4dcd-9e7f-6c10f9730021",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8a7e3307-7e3b-4360-a59e-6e95c507ebf5": {
    "name": "upgrade",
    "inputs": {
      "url": {
        "type": "string"
      },
      "close": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "socket": {
        "type": "\`CH\`",
        "ref": true,
        "icon": "arrow-up-down"
      }
    },
    "metadata": {
      "icon": "circle-fading-arrow-up",
      "description": "upgrade http request at \`url\`\` into a web socket connection",
      "tags": [
        "platform",
        "api",
        "http"
      ]
    },
    "id": "8a7e3307-7e3b-4360-a59e-6e95c507ebf5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7ef1c827-bbd4-4339-94c5-9fce05e50667": {
    "name": "respond",
    "inputs": {
      "url": {
        "type": "string"
      },
      "body": {
        "type": "\`BO\`",
        "ref": true
      },
      "status": {
        "type": "number"
      },
      "headers": {
        "type": "string{}"
      }
    },
    "outputs": {
      "done": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "mail-check",
      "description": "respond to the http request at \`url\`",
      "tags": [
        "platform",
        "api",
        "http"
      ]
    },
    "id": "7ef1c827-bbd4-4339-94c5-9fce05e50667",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7e5710aa-faf0-41c4-8936-2583ac637c72": {
    "name": "listen",
    "inputs": {
      "port": {
        "type": "number",
        "metadata": {
          "examples": [
            "80"
          ]
        }
      },
      "server": {
        "type": "\`SE\`",
        "ref": true
      },
      "close": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "door-open",
      "description": "have http \`server\` listen for requests on \`port\`",
      "tags": [
        "platform",
        "api",
        "http"
      ]
    },
    "id": "7e5710aa-faf0-41c4-8936-2583ac637c72",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6dbf7f62-cd6c-46a8-a559-ca50aebab9c4": {
    "name": "intercept",
    "inputs": {
      "system": {
        "type": "\`S\`",
        "ref": true
      },
      "opt": {
        "type": "{urls?:string|string[]}",
        "metadata": {
          "examples": [
            "{urls:'*'}"
          ]
        }
      },
      "stop": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "forward",
      "description": "intercept all \`system\` http requests that match given \\"opt\\"",
      "tags": [
        "platform",
        "api",
        "http"
      ]
    },
    "id": "6dbf7f62-cd6c-46a8-a559-ca50aebab9c4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a9aaed9e-a0ca-423f-bb44-4ee0b3432471": {
    "name": "handle",
    "inputs": {
      "url": {
        "type": "string"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      },
      "req": {
        "type": "object"
      },
      "body": {
        "type": "\`RS\`",
        "ref": true,
        "icon": "binary"
      }
    },
    "metadata": {
      "icon": "mail-open",
      "description": "handle http request available on internal \`url\`",
      "tags": [
        "platform",
        "api",
        "http"
      ]
    },
    "id": "a9aaed9e-a0ca-423f-bb44-4ee0b3432471",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d52ecdec-776b-425c-b982-ce25ee8113bd": {
    "name": "create server",
    "inputs": {
      "opt": {
        "type": "{}"
      },
      "close": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "server": {
        "type": "\`SE\`",
        "ref": true,
        "icon": "server"
      }
    },
    "metadata": {
      "icon": "network",
      "description": "create http server",
      "tags": [
        "platform",
        "api",
        "http"
      ]
    },
    "id": "d52ecdec-776b-425c-b982-ce25ee8113bd",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a9cba5ec-940d-42a3-b861-86197402cbe4": {
    "name": "geolocation",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "position": {
        "type": "{\\"latitude\\":number,\\"longitude\\":number}"
      }
    },
    "metadata": {
      "icon": "map-pin",
      "description": "current gps latitude and latitude",
      "tags": [
        "platform",
        "api",
        "geolocation"
      ]
    },
    "id": "a9cba5ec-940d-42a3-b861-86197402cbe4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "77238fd9-a968-454d-b7ce-0277bc37475d": {
    "name": "gamepad",
    "type": "\`U\`",
    "inputs": {
      "i": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "state": {
        "type": "\`V\`&\`EE\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "gamepad",
      "description": "connect to gamepad controller",
      "tags": [
        "platform",
        "api",
        "gamepad"
      ]
    },
    "id": "77238fd9-a968-454d-b7ce-0277bc37475d",
    "base": true,
    "system": true
  },
  "e025d8e5-baa2-4411-864d-4db6fc42220f": {
    "name": "read as text",
    "inputs": {
      "reader": {
        "type": "\`FR\`",
        "ref": true
      },
      "file": {
        "type": "\`F\`|\`B\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {
      "text": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "read the contents of the specified blob or file",
      "tags": [
        "platform",
        "api",
        "file"
      ]
    },
    "id": "e025d8e5-baa2-4411-864d-4db6fc42220f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "27ed8152-aaa0-4ac7-bebc-8b582727b129": {
    "name": "read as data url",
    "inputs": {
      "reader": {
        "type": "\`FR\`",
        "ref": true
      },
      "file": {
        "type": "\`F\`|\`B\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "read the contents of the specified blob or file",
      "tags": [
        "platform",
        "api",
        "file"
      ]
    },
    "id": "27ed8152-aaa0-4ac7-bebc-8b582727b129",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "bf92df60-f487-430f-a3e8-c988d57eadbb": {
    "name": "read as array buffer",
    "inputs": {
      "reader": {
        "type": "\`FR\`",
        "ref": true
      },
      "file": {
        "type": "\`F\`|\`B\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {
      "array": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "read the contents of the specified blob or file",
      "tags": [
        "platform",
        "api",
        "file"
      ]
    },
    "id": "bf92df60-f487-430f-a3e8-c988d57eadbb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f8485868-345a-416a-b323-547ddcb068ad": {
    "name": "file reader",
    "inputs": {
      "opt": {
        "type": "{}"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "reader": {
        "type": "\`FR\`",
        "ref": true,
        "icon": "file"
      }
    },
    "metadata": {
      "icon": "file-output",
      "description": "read the contents of files stored on the user's system",
      "tags": [
        "platform",
        "api",
        "file"
      ]
    },
    "id": "f8485868-345a-416a-b323-547ddcb068ad",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "48db8d23-dc55-4b03-b2ff-ca56c61927c8": {
    "name": "stop propagation",
    "inputs": {
      "event": {
        "type": "\`EV\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "TODO",
      "tags": [
        "platform",
        "api",
        "event"
      ]
    },
    "id": "48db8d23-dc55-4b03-b2ff-ca56c61927c8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8127337f-955d-4365-b180-21de8426feaa": {
    "name": "prevent default",
    "inputs": {
      "event": {
        "type": "\`EV\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "prevent all default platform reactions to this event, if any",
      "tags": [
        "platform",
        "api",
        "event"
      ]
    },
    "id": "8127337f-955d-4365-b180-21de8426feaa",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "aa810e5e-bf17-4abc-b726-bc06a7f210d9": {
    "name": "listener",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "event": {
        "type": "string"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "event": {
        "type": "\`EV\`&\`V\`",
        "ref": true
      },
      "data": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "listen to \`emitter\` \`event\`",
      "tags": [
        "platform",
        "api",
        "event"
      ]
    },
    "id": "aa810e5e-bf17-4abc-b726-bc06a7f210d9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "367241d8-ad12-11ea-beed-9777f31699a8": {
    "name": "listen",
    "inputs": {
      "emitter": {
        "type": "\`EE\`",
        "ref": true
      },
      "event": {
        "type": "string"
      },
      "remove": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "data": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "listen to \`emitter\` \`event\`",
      "tags": [
        "platform",
        "api",
        "event"
      ]
    },
    "id": "367241d8-ad12-11ea-beed-9777f31699a8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a1cd3c3c-b1fa-40a2-80d1-32f416264a3d": {
    "name": "dispatch",
    "inputs": {
      "element": {
        "type": "\`C\`",
        "ref": true
      },
      "event": {
        "type": "string"
      },
      "data": {
        "type": "any"
      },
      "opt": {
        "type": "{bubbles?:boolean}",
        "metadata": {
          "examples": [
            "{},{bubbles:true},{bubbles:false}"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "dispatch a custom \`event\` with \`data\` on \`element\`",
      "tags": [
        "platform",
        "api",
        "event"
      ]
    },
    "id": "a1cd3c3c-b1fa-40a2-80d1-32f416264a3d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "65180989-78be-414a-88c7-bf58af08e0f5": {
    "name": "verify",
    "inputs": {
      "opt": {
        "type": "{}"
      },
      "key": {
        "type": "\`CK\`",
        "ref": true
      },
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "signature": {
        "type": "\`AB\`",
        "ref": true
      },
      "data": {
        "type": "\`AB\`",
        "ref": true
      }
    },
    "outputs": {
      "valid": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "cryptographically verify signature",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/verify",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "65180989-78be-414a-88c7-bf58af08e0f5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d3719453-ca94-4827-a6b6-5aa8f87b1dc5": {
    "name": "sign",
    "inputs": {
      "opt": {
        "type": "{}"
      },
      "key": {
        "type": "\`CK\`",
        "ref": true
      },
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "data": {
        "type": "\`AB\`|\`TA\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "signature": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "file-lock"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "cryptographically generate \`signature\` of \`data\` with \`key\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/sign",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "d3719453-ca94-4827-a6b6-5aa8f87b1dc5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "378b4049-860a-44a3-82f2-12a15499859c": {
    "name": "rsa algorithm",
    "inputs": {
      "name": {
        "type": "'RSASSA-PKCS1-v1_5'|'RSA-PSS'|'RSA-OAEP'"
      },
      "modulusLength": {
        "type": "number",
        "metadata": {
          "examples": [
            "2048",
            "4096"
          ]
        }
      },
      "publicExponent": {
        "type": "\`TA\`",
        "ref": true
      },
      "hash": {
        "type": "'SHA-256'|'SHA-384'|'SHA-512'"
      }
    },
    "outputs": {
      "algorithm": {
        "type": "\`J\`",
        "ref": true,
        "icon": "brackets-curly"
      }
    },
    "metadata": {
      "icon": "square-function",
      "description": "instantiate an RSA algorithm parameter object",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "378b4049-860a-44a3-82f2-12a15499859c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6fdcf0d8-39ce-4d63-ad68-97d25be769ab": {
    "name": "import key",
    "inputs": {
      "data": {
        "type": "string",
        "ref": true,
        "icon": "key"
      },
      "format": {
        "type": "'raw'|'pkcs8'|'spki'|'jwk'"
      },
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "extractable": {
        "type": "boolean"
      },
      "keyUsages": {
        "type": "string[]",
        "metadata": {
          "examples": [
            "['encrypt','decrypt']",
            "['encrypt','decrypt','sign','verify','deriveKey','deriveBits','wrapKey','unwrapKey']"
          ]
        }
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "key": {
        "type": "\`CK\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "parse crypto \`key\` given knowledge of \`format\`, \`algorithm\`, \`extractable\` and \`keyUsages\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "6fdcf0d8-39ce-4d63-ad68-97d25be769ab",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4830eec3-2a72-4e36-b68a-902aa73c6ead": {
    "name": "import jwt key",
    "inputs": {
      "data": {
        "type": "object"
      },
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "extractable": {
        "type": "boolean"
      },
      "keyUsages": {
        "type": "string[]",
        "metadata": {
          "examples": [
            "['encrypt','decrypt']",
            "['encrypt','decrypt','sign','verify','deriveKey','deriveBits','wrapKey','unwrapKey']"
          ]
        }
      }
    },
    "outputs": {
      "key": {
        "type": "\`CK\`",
        "ref": true,
        "icon": "key"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "parse crypto jwk \`key\` given knowledge of \`format\`, \`algorithm\`, \`extractable\` and \`keyUsages\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "4830eec3-2a72-4e36-b68a-902aa73c6ead",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "089d3cef-2597-4777-8558-9942b4029472": {
    "name": "generate key pair",
    "inputs": {
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "extractable": {
        "type": "boolean"
      },
      "keyUsages": {
        "type": "string[]",
        "metadata": {
          "examples": [
            "['encrypt','decrypt']",
            "['encrypt','decrypt','sign','verify','deriveKey','deriveBits','wrapKey','unwrapKey']"
          ]
        }
      }
    },
    "outputs": {
      "public": {
        "type": "\`CK\`",
        "ref": true,
        "icon": "key"
      },
      "private": {
        "type": "\`CK\`",
        "ref": true,
        "icon": "key"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "generate cryptographic public and private key pairs based on \`algorithm\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/generateKey",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "089d3cef-2597-4777-8558-9942b4029472",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "00e14b7e-7339-4c9f-a3ff-a16562558a28": {
    "name": "generate key",
    "inputs": {
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "extractable": {
        "type": "boolean"
      },
      "keyUsages": {
        "type": "string[]",
        "metadata": {
          "examples": [
            "['encrypt','decrypt']",
            "['encrypt','decrypt','sign','verify','deriveKey','deriveBits','wrapKey','unwrapKey']"
          ]
        }
      }
    },
    "outputs": {
      "key": {
        "type": "\`CK\`",
        "ref": true,
        "icon": "key"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "generate single cryptographic key based on \`algorithm\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/generateKey",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "00e14b7e-7339-4c9f-a3ff-a16562558a28",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d54cd5d2-91eb-4f95-be2d-62fdaf86f474": {
    "name": "export key",
    "inputs": {
      "key": {
        "type": "\`CK\`",
        "ref": true
      },
      "format": {
        "type": "'raw'|'pkcs8'|'spki'"
      }
    },
    "outputs": {
      "key": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "key"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "export raw key as a \`data\` array buffer",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/exportKey",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "d54cd5d2-91eb-4f95-be2d-62fdaf86f474",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6183465e-381f-4546-8c42-6b7eaaa25926": {
    "name": "export jwk key",
    "inputs": {
      "key": {
        "type": "\`CK\`",
        "ref": true
      },
      "format": {
        "type": "'jwk'"
      }
    },
    "outputs": {
      "key": {
        "type": "object",
        "icon": "key"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "export jwt key as a \`data\` array buffer",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/exportKey",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "6183465e-381f-4546-8c42-6b7eaaa25926",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8edf4dd9-4d11-444c-bfe5-b54dc141cded": {
    "name": "encrypt",
    "inputs": {
      "opt": {
        "type": "{}"
      },
      "key": {
        "type": "\`CK\`",
        "ref": true
      },
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "data": {
        "type": "\`AB\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "data": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "file-lock"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "encrypts \`data\` with given \`key\` and \`algorithm\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/encrypt",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "8edf4dd9-4d11-444c-bfe5-b54dc141cded",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f6400b55-10af-4983-96bc-6b915433f3b6": {
    "name": "decrypt",
    "inputs": {
      "opt": {
        "type": "{}"
      },
      "key": {
        "type": "\`CK\`",
        "ref": true
      },
      "algorithm": {
        "type": "\`J\`",
        "ref": true
      },
      "data": {
        "type": "\`AB\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "data": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "file"
      }
    },
    "metadata": {
      "icon": "lock",
      "description": "dencrypts \`data\` with given \`key\` and \`algorithm\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/decrypt",
      "tags": [
        "platform",
        "api",
        "crypto"
      ]
    },
    "id": "f6400b55-10af-4983-96bc-6b915433f3b6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e7232263-a2cf-4f2b-a862-4fc85933d09f": {
    "name": "log",
    "inputs": {
      "message": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "terminal",
      "description": "print to the console",
      "tags": [
        "platform",
        "api",
        "console"
      ]
    },
    "id": "e7232263-a2cf-4f2b-a862-4fc85933d09f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "45654a47-f04e-484e-886e-99803aa48ab6": {
    "name": "set selection range",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{start:number,end:number,direction?:'forward'|'backward'|'none'}"
      }
    },
    "outputs": {
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "text-select",
      "description": "set the selection inside \`component\`",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "45654a47-f04e-484e-886e-99803aa48ab6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6dbff818-02b9-11eb-9ee7-93b57419f741": {
    "name": "remove child",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true
      },
      "at": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {},
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "remove \`parent\` child element \`at\` index",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "6dbff818-02b9-11eb-9ee7-93b57419f741",
    "type": "\`U\`",
    "system": true
  },
  "fb3fc7b4-3175-41ce-9546-cf3a07053cdc": {
    "name": "register",
    "inputs": {
      "ref": {
        "type": "any",
        "ref": true
      },
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "register \`ref\` on \`unit\` scope",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "fb3fc7b4-3175-41ce-9546-cf3a07053cdc",
    "type": "\`U\`",
    "system": true
  },
  "b6a5a63f-07b2-4cbe-8718-377c245c502e": {
    "name": "outer html",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "html": {
        "type": "string"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "code-2",
      "description": "get \`component\`'s inner html",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "b6a5a63f-07b2-4cbe-8718-377c245c502e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1ba931d8-0226-4600-9a48-dbb1b17d8d82": {
    "name": "lookup",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "name": {
        "type": "string"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "ref": {
        "type": "any",
        "ref": true
      }
    },
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "lookup a registered component by \`name\`",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "1ba931d8-0226-4600-9a48-dbb1b17d8d82",
    "type": "\`U\`",
    "system": true
  },
  "41a8c91e-87f8-4d96-9714-33716f329f7b": {
    "name": "insert child",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -116,
              "y": 30
            }
          }
        }
      },
      "child": {
        "type": "\`C\`",
        "metadata": {
          "examples": [
            "\${unit:{id:'f27cae4e-fea8-11ea-b91e-db41e114c426'}}"
          ],
          "position": {
            "0": {
              "x": 128,
              "y": 30
            }
          }
        }
      },
      "at": {
        "type": "number",
        "metadata": {
          "position": {
            "0": {
              "x": -116,
              "y": 0
            }
          }
        }
      }
    },
    "outputs": {},
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "insert \`child\` instance to \`parent\` \`at\` position",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "41a8c91e-87f8-4d96-9714-33716f329f7b",
    "type": "\`U\`",
    "system": true
  },
  "c475117a-02b9-11eb-b7c8-579fe4f6c669": {
    "name": "has child",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -116,
              "y": 30
            }
          }
        }
      },
      "at": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ],
          "position": {
            "0": {
              "x": 128,
              "y": 30
            }
          }
        }
      }
    },
    "outputs": {
      "test": {
        "type": "boolean"
      }
    },
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "check whether \`parent\` has a child \`at\`",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "c475117a-02b9-11eb-b7c8-579fe4f6c669",
    "type": "\`U\`",
    "system": true
  },
  "0d1d2204-f096-4aac-99d3-7c8dcdde8767": {
    "name": "get selection",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "selection": {
        "type": "{path:string[],start:number,end:number,direction:'forward'|'backward'|'none'}[]"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "space",
      "description": "get the selection object inside \`component\`",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "0d1d2204-f096-4aac-99d3-7c8dcdde8767",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d33eba3a-4a78-40b7-8501-77d74a8451ee": {
    "name": "get client bounding rect",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "rect": {
        "type": "{x:number,y:number,width:number,height:number}"
      },
      "done": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "get the bounding box rect of \`component\`",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "d33eba3a-4a78-40b7-8501-77d74a8451ee",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1ba97b81-5084-49b8-8fbf-227ccd31cabc": {
    "name": "detach",
    "inputs": {
      "component": {
        "type": "\`C\`",
        "ref": true
      },
      "host": {
        "type": "\`C\`",
        "ref": true
      },
      "opt": {
        "type": "{animate?:boolean}"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {},
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "visually append \`component\` to \`host\` without affecting tree structure",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "1ba97b81-5084-49b8-8fbf-227ccd31cabc",
    "type": "\`U\`",
    "system": true
  },
  "2ea56c24-642b-420b-ae7d-e434299c7003": {
    "name": "append children",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -116,
              "y": 30
            }
          }
        }
      },
      "children": {
        "type": "\`C\`[]",
        "metadata": {
          "examples": [
            "[\${unit:{id:'f27cae4e-fea8-11ea-b91e-db41e114c426'}},\${unit:{id:'f27cae4e-fea8-11ea-b91e-db41e114c426'}}]"
          ],
          "position": {
            "0": {
              "x": 128,
              "y": 30
            }
          }
        }
      }
    },
    "outputs": {
      "length": {
        "type": "number",
        "defaultIgnored": true
      }
    },
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "append \`children\` instances to \`parent\` at once",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "2ea56c24-642b-420b-ae7d-e434299c7003",
    "type": "\`U\`",
    "system": true
  },
  "ee4715e6-f479-11ea-b231-bf95a7f38a99": {
    "name": "append child",
    "inputs": {
      "parent": {
        "type": "\`C\`",
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -116,
              "y": 30
            }
          }
        }
      },
      "child": {
        "type": "\`C\`",
        "metadata": {
          "examples": [
            "\${unit:{id:'f27cae4e-fea8-11ea-b91e-db41e114c426'}}"
          ],
          "position": {
            "0": {
              "x": 128,
              "y": 30
            }
          }
        }
      }
    },
    "outputs": {
      "at": {
        "type": "number",
        "defaultIgnored": true
      }
    },
    "base": true,
    "metadata": {
      "icon": "square",
      "description": "append \`child\` instance to \`parent\`",
      "tags": [
        "platform",
        "api",
        "component"
      ]
    },
    "id": "ee4715e6-f479-11ea-b231-bf95a7f38a99",
    "type": "\`U\`",
    "system": true
  },
  "874f508f-d027-4e0b-852e-b4027e714406": {
    "name": "add arc",
    "inputs": {
      "d": {
        "type": "any[][]"
      },
      "arc": {
        "type": "{x:number,y:number,r:number,start:number,end:number,anticlockwise?:boolean}"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "adds a circular arc to the current sub-path",
      "tags": [
        "platform",
        "api",
        "codec"
      ]
    },
    "id": "874f508f-d027-4e0b-852e-b4027e714406",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0b5a71c6-5c43-4e55-a29c-27d9ff7ed43a": {
    "name": "copy to clipboard",
    "inputs": {
      "text": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "clipboard",
      "description": "copy \`text\` to clipboard",
      "tags": [
        "platform",
        "api",
        "clipboard"
      ]
    },
    "id": "0b5a71c6-5c43-4e55-a29c-27d9ff7ed43a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "002fbcc6-ec01-4282-b5a6-77ec4812744e": {
    "name": "to data url",
    "inputs": {
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      },
      "quality": {
        "type": "number",
        "metadata": {
          "examples": [
            "1"
          ]
        }
      },
      "type": {
        "type": "string",
        "metadata": {
          "examples": [
            "'image/png'"
          ]
        }
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "get base 64 url from \`canvas\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataUrl",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "002fbcc6-ec01-4282-b5a6-77ec4812744e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6f79ee03-4b3f-439c-b955-5529f3bebcc9": {
    "name": "translate",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      },
      "x": {
        "type": "number"
      },
      "y": {
        "type": "number"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "add a translation to the current transformation matrix",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/translate",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "6f79ee03-4b3f-439c-b955-5529f3bebcc9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b2eb49a8-7a7a-446a-ad36-e7c1efdaf61f": {
    "name": "transfer from image bitmap",
    "inputs": {
      "bitmap": {
        "type": "\`IB\`",
        "ref": true
      },
      "canvas": {
        "type": "\`IBRC\`",
        "ref": true
      },
      "init": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "draw an image \`bitmap\` on \`canvas\`",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "b2eb49a8-7a7a-446a-ad36-e7c1efdaf61f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c9d64ef4-35f6-44e7-a16b-1e4173f951dc": {
    "name": "to blob",
    "inputs": {
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      },
      "quality": {
        "type": "number",
        "metadata": {
          "examples": [
            "1"
          ]
        }
      },
      "type": {
        "type": "string",
        "metadata": {
          "examples": [
            "'image/png'"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "blob": {
        "type": "\`B\`",
        "ref": true,
        "icon": "file"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "get \`blob\` from \`canvas\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "c9d64ef4-35f6-44e7-a16b-1e4173f951dc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "83d22558-2c6f-4dd4-a231-baba798d1d97": {
    "name": "stroke style",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]",
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      },
      "strokeStyle": {
        "type": "string"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "set the color, gradient, or pattern to use for stroke",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "83d22558-2c6f-4dd4-a231-baba798d1d97",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c0e124ca-381a-414b-93a2-41526df02e28": {
    "name": "stroke path",
    "inputs": {
      "d": {
        "type": "string"
      },
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "edit-3",
      "description": "stroke a SVG path \`d\` on \`canvas\`",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "c0e124ca-381a-414b-93a2-41526df02e28",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99": {
    "name": "stroke",
    "inputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "strokes (outlines) the current",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "9a7c22e3-3de2-4c99-ac1f-b2f8ceffae99",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "af361c4c-0c46-4947-8692-1ddb308e5218": {
    "name": "scale",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      },
      "sx": {
        "type": "number"
      },
      "sy": {
        "type": "number"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "add a scale to the current transformation matrix",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/translate",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "af361c4c-0c46-4947-8692-1ddb308e5218",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2e2bede5-41a9-4c35-8b02-482b610837ff": {
    "name": "scale",
    "inputs": {
      "sx": {
        "type": "number",
        "metadata": {
          "examples": [
            "1",
            "0.5",
            "2"
          ]
        }
      },
      "sy": {
        "type": "number",
        "metadata": {
          "examples": [
            "1",
            "0.5",
            "2"
          ]
        }
      },
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "edit-3",
      "description": "scale a \`canvas\`",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "2e2bede5-41a9-4c35-8b02-482b610837ff",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8f7ce559-a046-45bc-8e98-c39934ed0ae6": {
    "name": "rotate",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      },
      "rad": {
        "type": "number"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "add a rotation to the transformation matrix",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/rotate",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "8f7ce559-a046-45bc-8e98-c39934ed0ae6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "138d16a7-a200-4329-9b4a-17abd24943d4": {
    "name": "put image data",
    "inputs": {
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      },
      "image": {
        "type": "\`ID\`",
        "ref": true,
        "metadata": {
          "examples": [
            "1"
          ]
        }
      },
      "any": {
        "type": "any"
      },
      "dx": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "dy": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "x": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "y": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "width": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      },
      "height": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      }
    },
    "outputs": {
      "done": {
        "type": "true",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "put \`image\` data on \`canvas\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/putImageData",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "138d16a7-a200-4329-9b4a-17abd24943d4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3c47d4bc-315d-4600-a9cd-6e388b345980": {
    "name": "move to",
    "inputs": {
      "d": {
        "type": "any[][]"
      },
      "x": {
        "type": "number"
      },
      "y": {
        "type": "number"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "start new sub-path at the point specified by the given x, y coordinates",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "3c47d4bc-315d-4600-a9cd-6e388b345980",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "21e49492-49ba-4efd-879e-4cd7bb1bd587": {
    "name": "line width",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]",
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      },
      "lineWidth": {
        "type": "number",
        "metadata": {
          "examples": [
            "1",
            "3",
            "9"
          ]
        }
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "set the color, gradient, or pattern to use for stroke",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "21e49492-49ba-4efd-879e-4cd7bb1bd587",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8e978642-b686-41fd-b2af-9a4c5db6bfa4": {
    "name": "image data",
    "inputs": {
      "data": {
        "type": "\`TA\`",
        "ref": true
      },
      "width": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      },
      "height": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      },
      "opt": {
        "type": "{colorSpace?:'srgb'|'display-p3'}",
        "metadata": {
          "examples": [
            "{}",
            "{colorSpace:'srgb'}"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "image": {
        "type": "\`ID\`&\`J\`",
        "ref": true,
        "metadata": {
          "examples": [
            "1"
          ]
        }
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "create new image data from \`data\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/getImageData",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "8e978642-b686-41fd-b2af-9a4c5db6bfa4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3ab81e83-5954-4bae-ad3e-ebf409dd23c4": {
    "name": "get image data",
    "inputs": {
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      },
      "x": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "y": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "width": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      },
      "height": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      },
      "opt": {
        "type": "{colorSpace?:'srgb'|'display-p3'}",
        "metadata": {
          "examples": [
            "{}",
            "{colorSpace:'srgb'}"
          ]
        }
      },
      "any": {
        "type": "any"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "image": {
        "type": "\`ID\`&\`J\`",
        "ref": true,
        "metadata": {
          "examples": [
            "1"
          ]
        }
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "get \`image\` data from \`canvas\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/getImageData",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "3ab81e83-5954-4bae-ad3e-ebf409dd23c4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f5b2faf1-3a8b-489f-9d99-62d3c749ced6": {
    "name": "fill style",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]",
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      },
      "fillStyle": {
        "type": "string"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "set current fillStyle",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "f5b2faf1-3a8b-489f-9d99-62d3c749ced6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "be59cf84-fcf2-46ef-aa34-6f0f8e055680": {
    "name": "fill path",
    "inputs": {
      "d": {
        "type": "string"
      },
      "rule": {
        "type": "\\"evenodd\\"|\\"nonzero\\""
      },
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "edit-3",
      "description": "fill a SVG path \`d\` on \`canvas\`",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "be59cf84-fcf2-46ef-aa34-6f0f8e055680",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "87a11e2c-278c-11eb-9209-2f30aebffb25": {
    "name": "fill",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "fill the current path",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "87a11e2c-278c-11eb-9209-2f30aebffb25",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "82cf909e-a78f-4f3e-b87a-976458c8e15d": {
    "name": "draw image",
    "inputs": {
      "any": {
        "type": "any"
      },
      "image": {
        "type": "\`IM\`",
        "ref": true
      },
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      },
      "x": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "y": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "width": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      },
      "height": {
        "type": "number",
        "metadata": {
          "examples": [
            "100"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "draw an image \`bitmap\` on \`canvas\`",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "82cf909e-a78f-4f3e-b87a-976458c8e15d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "53018958-b686-11ea-bf53-175a3698c92d": {
    "name": "draw",
    "inputs": {
      "canvas": {
        "type": "\`CA\`",
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": -117,
              "y": 28
            }
          }
        }
      },
      "step": {
        "_type": "(number|string)[]",
        "type": "any[]",
        "metadata": {
          "position": {
            "0": {
              "x": 128,
              "y": 32
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "draw on \`canvas\`",
      "tags": [
        "platform",
        "api",
        "canvas"
      ],
      "position": {
        "merge": {
          "rgarjyrwq": {
            "x": 5,
            "y": -4
          }
        }
      }
    },
    "id": "53018958-b686-11ea-bf53-175a3698c92d",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "288aede9-59ea-4cb4-baf9-fef9109cc2b9": {
    "name": "close path",
    "inputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "outputs": {
      "d": {
        "type": "(number|string|boolean)[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "add a straight line from the current point to the start of the current sub-path",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/closePath",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "288aede9-59ea-4cb4-baf9-fef9109cc2b9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1ef77768-7394-4b83-ad11-f5905fa9d0d3": {
    "name": "clear",
    "inputs": {
      "any": {
        "type": "any"
      },
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "eraser",
      "description": "clear canvas",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "1ef77768-7394-4b83-ad11-f5905fa9d0d3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "81c0f469-ab88-4bc8-89d5-98d291b1d8b2": {
    "name": "begin path",
    "inputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "starts a new path by emptying the list of sub-paths",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/beginPath",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "81c0f469-ab88-4bc8-89d5-98d291b1d8b2",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "58385055-7f06-472a-be9e-26bb5bce276a": {
    "name": "add rect",
    "inputs": {
      "d": {
        "type": "any[][]"
      },
      "rect": {
        "type": "{x:number,y:number,width:number,height:number}"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "adds a rectangle to the current sub-path",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "58385055-7f06-472a-be9e-26bb5bce276a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2b0ef9e9-028b-4acc-9daf-6999e86cc2af": {
    "name": "add line to",
    "inputs": {
      "d": {
        "type": "any[][]"
      },
      "x": {
        "type": "number"
      },
      "y": {
        "type": "number"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "adds a straight line to the current sub-path by connecting the sub-path's last point to the specified x, y coordinates",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "2b0ef9e9-028b-4acc-9daf-6999e86cc2af",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6796cd2d-2bd2-4dd3-9396-49d6bc1d2652": {
    "name": "add arc",
    "inputs": {
      "d": {
        "type": "any[][]"
      },
      "arc": {
        "type": "{x:number,y:number,r:number,start:number,end:number,anticlockwise?:boolean}"
      }
    },
    "outputs": {
      "d": {
        "type": "any[][]"
      }
    },
    "metadata": {
      "icon": "edit-3",
      "description": "adds a circular arc to the current sub-path",
      "tags": [
        "platform",
        "api",
        "canvas"
      ]
    },
    "id": "6796cd2d-2bd2-4dd3-9396-49d6bc1d2652",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "56eb0818-308a-4459-98c0-b05ffb219c05": {
    "name": "write value",
    "type": "\`U\`",
    "inputs": {
      "charac": {
        "type": "\`BC\`",
        "ref": true
      },
      "value": {
        "type": "string"
      }
    },
    "outputs": {
      "done": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "bluetooth",
      "description": "write \`value\` to a remote GATT \`charac\`teristic",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/BluetoothRemoteGATTDescriptor/writeValue",
      "tags": [
        "platform",
        "api",
        "bluetooth",
        "method"
      ]
    },
    "id": "56eb0818-308a-4459-98c0-b05ffb219c05",
    "base": true,
    "system": true
  },
  "cdea4530-d391-4661-bf92-21450d2e825a": {
    "name": "read value",
    "type": "\`U\`",
    "inputs": {
      "charac": {
        "type": "\`BC\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "charac": {
        "type": "\`V\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "bluetooth",
      "description": "read \`value\` from a remote GATT \`charac\`teristic",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/BluetoothRemoteGATTDescriptor/readValue",
      "tags": [
        "platform",
        "api",
        "bluetooth",
        "method"
      ]
    },
    "id": "cdea4530-d391-4661-bf92-21450d2e825a",
    "base": true,
    "system": true
  },
  "a44b2198-e18d-11ea-be3b-77e13b78b7e3": {
    "name": "bluetooth service",
    "inputs": {
      "server": {
        "type": "\`BS\`",
        "ref": true
      },
      "uuid": {
        "type": "string"
      }
    },
    "outputs": {
      "service": {
        "type": "\`BSE\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "bluetooth",
      "description": "remote GATT service",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/BluetoothRemoteGATTService",
      "tags": [
        "platform",
        "api",
        "bluetooth"
      ]
    },
    "id": "a44b2198-e18d-11ea-be3b-77e13b78b7e3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "dd520754-e138-11ea-879e-3bd947893124": {
    "name": "bluetooth server",
    "inputs": {
      "device": {
        "type": "\`BD\`",
        "ref": true
      }
    },
    "outputs": {
      "server": {
        "type": "\`BS\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "bluetooth",
      "description": "remote GATT server",
      "tags": [
        "platform",
        "api",
        "bluetooth"
      ]
    },
    "id": "dd520754-e138-11ea-879e-3bd947893124",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4ad5bd0e-e11e-11ea-ad4c-83da30628333": {
    "name": "bluetooth device",
    "inputs": {
      "opt": {
        "type": "{filters?:({name?:string}|{namePrefix?:string}|{services:(string|number)[]})[],optionalServices?:string[],acceptAllDevices?:boolean}"
      }
    },
    "outputs": {
      "device": {
        "type": "\`BD\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "bluetooth",
      "description": "remote GATT device",
      "tags": [
        "platform",
        "api",
        "bluetooth"
      ]
    },
    "id": "4ad5bd0e-e11e-11ea-ad4c-83da30628333",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c7f6f43e-e8ed-11ea-92b2-0bd612272247": {
    "name": "bluetooth characteristic",
    "type": "\`U\`",
    "subtype": {
      "V": "string"
    },
    "inputs": {
      "service": {
        "type": "\`BSE\`",
        "ref": true
      },
      "uuid": {
        "type": "string"
      }
    },
    "outputs": {
      "charac": {
        "type": "\`BC\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "bluetooth",
      "description": "remote GATT characteristic",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/BluetoothRemoteGATTCharacteristic",
      "tags": [
        "platform",
        "api",
        "bluetooth"
      ]
    },
    "id": "c7f6f43e-e8ed-11ea-92b2-0bd612272247",
    "base": true,
    "system": true
  },
  "89d07aa2-579f-4a4b-938c-0d85a24df56f": {
    "name": "blob",
    "inputs": {
      "parts": {
        "type": "\`A\`",
        "ref": true
      },
      "opt": {
        "type": "{ending?:'native'|'transparent',type?:string}",
        "metadata": {
          "examples": [
            "{type:'image/png'}",
            "{type:'text/plain'}"
          ]
        }
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "blob": {
        "type": "\`B\`",
        "ref": true,
        "icon": "file"
      }
    },
    "metadata": {
      "icon": "binary",
      "description": "get \`blob\` from \`canvas\`",
      "link": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob",
      "tags": [
        "platform",
        "api"
      ]
    },
    "id": "89d07aa2-579f-4a4b-938c-0d85a24df56f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ee7b692f-5fe5-43c3-b636-aacca92b0bc7": {
    "name": "encode",
    "inputs": {
      "a": {
        "type": "string"
      }
    },
    "outputs": {
      "b": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "base64-encode ASCII string",
      "tags": [
        "platform",
        "api",
        "base64"
      ]
    },
    "id": "ee7b692f-5fe5-43c3-b636-aacca92b0bc7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d6f727ee-5158-4e2b-a2d4-a84ee712144e": {
    "name": "decode",
    "inputs": {
      "b": {
        "type": "string"
      }
    },
    "outputs": {
      "a": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "Base64-decode ASCII string",
      "tags": [
        "platform",
        "api",
        "base64"
      ]
    },
    "id": "d6f727ee-5158-4e2b-a2d4-a84ee712144e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0fdae01c-cf4c-49ee-8fee-23890625ae29": {
    "name": "set",
    "inputs": {
      "array": {
        "type": "\`TA\`",
        "ref": true
      },
      "data": {
        "type": "\`TA\`",
        "ref": true
      },
      "offset": {
        "type": "number"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "square",
      "description": "...",
      "tags": [
        "platform",
        "api",
        "array",
        "typed",
        "method"
      ]
    },
    "id": "0fdae01c-cf4c-49ee-8fee-23890625ae29",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "98881480-aeba-4fee-b7d3-8c17a6aeb217": {
    "name": "8-bit unsigned clamped array",
    "inputs": {
      "init": {
        "type": "\`AB\`",
        "ref": true
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "array": {
        "type": "\`V\`&\`A<number>\`&\`TA\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "array of 8-bit unsigned integers clamped to 0-255",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "98881480-aeba-4fee-b7d3-8c17a6aeb217",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4d68d552-46d6-4ee4-9823-63f9b9479fae": {
    "name": "8-bit unsigned clamped array",
    "inputs": {
      "init": {
        "type": "number[]",
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "array": {
        "type": "\`V\`&\`A<number>\`&\`TA\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "array of 8-bit unsigned integers clamped to 0-255",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "4d68d552-46d6-4ee4-9823-63f9b9479fae",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "cd8c1d94-1471-49e2-8b43-d98ae93b70f3": {
    "name": "8-bit unsigned clamped array",
    "inputs": {
      "length": {
        "type": "number",
        "metadata": {
          "description": "length of the array"
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "array": {
        "type": "\`V\`&\`A<number>\`&\`TA\`",
        "ref": true,
        "icon": "array"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "array of 8-bit unsigned integers clamped to 0-255",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "cd8c1d94-1471-49e2-8b43-d98ae93b70f3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "364fad98-9190-47a8-bd5c-33d7b882ddd6": {
    "name": "8-bit unsigned array",
    "inputs": {
      "init": {
        "type": "\`AB\`",
        "ref": true
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "array": {
        "type": "\`V\`&\`A<number>\`&\`TA\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "array of 8-bit unsigned integers clamped to 0-255",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "364fad98-9190-47a8-bd5c-33d7b882ddd6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "5500c4ae-e464-40fa-9cfb-6af11c8f2c7e": {
    "name": "8-bit unsigned array",
    "inputs": {
      "init": {
        "type": "number[]",
        "metadata": {
          "examples": [
            "[]"
          ]
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "array": {
        "type": "\`V\`&\`A<number>\`&\`TA\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "array of 8-bit unsigned integers clamped to 0-255",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "5500c4ae-e464-40fa-9cfb-6af11c8f2c7e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c91ce066-ea5f-496d-8783-8f46c29673de": {
    "name": "8-bit unsigned array",
    "inputs": {
      "length": {
        "type": "number",
        "metadata": {
          "description": "length of the array"
        }
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "array": {
        "type": "\`V\`&\`A<number>\`&\`TA\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "array of 8-bit unsigned integers",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "c91ce066-ea5f-496d-8783-8f46c29673de",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "04d118fd-433e-4dd0-b828-0117eece566a": {
    "name": "buffer",
    "inputs": {
      "from": {
        "type": "\`TA\`",
        "ref": true
      },
      "any": {
        "type": "any"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "array": {
        "type": "\`AB\`",
        "ref": true,
        "icon": "array"
      }
    },
    "metadata": {
      "icon": "square",
      "description": "get internal \`array\` buffer from typed array",
      "tags": [
        "platform",
        "api",
        "array",
        "typed"
      ]
    },
    "id": "04d118fd-433e-4dd0-b828-0117eece566a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b949221c-8227-4178-bde4-5e8754a7ed39": {
    "name": "request animation frame",
    "inputs": {
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "timer",
      "description": "output \`a\` in the next animation frame",
      "tags": [
        "platform",
        "api",
        "animation"
      ]
    },
    "id": "b949221c-8227-4178-bde4-5e8754a7ed39",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1df77a6e-7632-44f0-9878-2aa5e0903928": {
    "name": "animate",
    "inputs": {
      "keyframes": {
        "type": "object[]"
      },
      "opt": {
        "type": "object",
        "metadata": {
          "examples": [
            "{duration:1000,iterations:Infinity}",
            "{duration:1000,iterations}"
          ]
        }
      },
      "element": {
        "type": "\`C\`",
        "ref": true
      },
      "done": {
        "type": "any",
        "defaultIgnore": true
      }
    },
    "outputs": {
      "animation": {
        "type": "\`AN\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "timer",
      "description": "animate \`element\` root style property",
      "tags": [
        "platform",
        "api",
        "animation"
      ]
    },
    "id": "1df77a6e-7632-44f0-9878-2aa5e0903928",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "fa3d97bb-060d-4671-9c18-dff81f64c1cc": {
    "name": "prompt",
    "inputs": {
      "message": {
        "type": "string",
        "metadata": {
          "examples": [
            "'Write something:'"
          ]
        }
      },
      "default": {
        "type": "string",
        "metadata": {
          "examples": [
            "''"
          ]
        }
      }
    },
    "outputs": {
      "answer": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "identify data type",
      "tags": [
        "platform",
        "api",
        "alert"
      ]
    },
    "id": "fa3d97bb-060d-4671-9c18-dff81f64c1cc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0b4aa055-010d-4d43-b991-f38a95cdb380": {
    "name": "alert",
    "inputs": {
      "message": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "tilde",
      "description": "display a dialog with an optional message and wait until user dismisses it",
      "tags": [
        "platform",
        "api",
        "alert"
      ]
    },
    "id": "0b4aa055-010d-4d43-b991-f38a95cdb380",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "81ac8195-57ed-4b22-b8b8-fe3e68b11af0": {
    "name": "parse url",
    "inputs": {
      "url": {
        "type": "string",
        "metadata": {
          "examples": [
            "\\"https://unit.land\\"",
            "\\"https://unit.moe\\"",
            "\\"https://unit.tools\\""
          ]
        }
      }
    },
    "outputs": {
      "obj": {
        "type": "{protocol:string,hostname:string,pathname:string,search:string,hash:string}"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "decode \`url\` into its segments \`obj\`",
      "tags": [
        "platform",
        "api",
        "URL"
      ]
    },
    "id": "81ac8195-57ed-4b22-b8b8-fe3e68b11af0",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "27e2f302-c23a-4447-abde-8309a94b331d": {
    "name": "encode URI component",
    "inputs": {
      "text": {
        "type": "string",
        "metadata": {
          "examples": []
        }
      }
    },
    "outputs": {
      "uri": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "encodes a text string as a valid component of a Uniform Resource Identifier (URI).",
      "tags": [
        "platform",
        "api",
        "URI"
      ]
    },
    "id": "27e2f302-c23a-4447-abde-8309a94b331d",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "5bd48844-67c6-4fdc-b23b-f03cd561877f": {
    "name": "encode uri",
    "inputs": {
      "uri": {
        "type": "string",
        "metadata": {
          "examples": [
            "https://unit.land"
          ]
        }
      }
    },
    "outputs": {
      "UTF-8": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "encode URI to UTF-8",
      "tags": [
        "platform",
        "api",
        "URI"
      ]
    },
    "id": "5bd48844-67c6-4fdc-b23b-f03cd561877f",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "1d5b6bb0-f18e-4428-a350-a29d8ca3ff4a": {
    "name": "create object url",
    "inputs": {
      "blob": {
        "type": "\`B\`",
        "ref": true
      },
      "init": {
        "type": "any"
      }
    },
    "outputs": {
      "url": {
        "type": "string"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "encode URI to UTF-8",
      "tags": [
        "platform",
        "api",
        "URI"
      ]
    },
    "id": "1d5b6bb0-f18e-4428-a350-a29d8ca3ff4a",
    "type": "\`U\`",
    "base": true,
    "system": true
  },
  "b296242e-8b82-11eb-ac6c-0f8d3f9948d0": {
    "name": "send",
    "inputs": {
      "channel": {
        "type": "\`CH\`",
        "ref": true
      },
      "data": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "send",
      "description": "send \`data\` through \`channel\`",
      "tags": [
        "platform",
        "api"
      ]
    },
    "base": true,
    "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
    "type": "\`U\`",
    "system": true
  },
  "a3246170-d638-4d96-8900-6cc3f2ffe799": {
    "name": "replace state",
    "inputs": {
      "data": {
        "type": "any"
      },
      "title": {
        "type": "string"
      },
      "url": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "map-pin",
      "description": "adds an entry to the session history stack",
      "tags": [
        "platform",
        "api",
        "History"
      ]
    },
    "id": "a3246170-d638-4d96-8900-6cc3f2ffe799",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "53dd6448-f1e8-46ed-b3e8-b03b846133bb": {
    "name": "push state",
    "inputs": {
      "data": {
        "type": "any"
      },
      "title": {
        "type": "string"
      },
      "url": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "map-pin",
      "description": "adds an entry to the session history stack",
      "tags": [
        "platform",
        "api",
        "History"
      ]
    },
    "id": "53dd6448-f1e8-46ed-b3e8-b03b846133bb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c899b675-c3c4-428e-b548-b228305c0302": {
    "name": "state",
    "inputs": {
      "init": {
        "type": "<T>"
      },
      "done": {
        "type": "any",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "data": {
        "type": "\`V<T>\`",
        "ref": true,
        "icon": "triangle"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "control a value in memory",
      "tags": [
        "platform"
      ]
    },
    "id": "c899b675-c3c4-428e-b548-b228305c0302",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8d7fc133-7cfa-4975-836f-31ae15b818be": {
    "name": "offscreen canvas",
    "inputs": {
      "width": {
        "type": "number"
      },
      "height": {
        "type": "number"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      },
      "opt": {
        "type": "{willReadFrequently?:boolean}"
      }
    },
    "outputs": {
      "canvas": {
        "type": "\`CA\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "chalkboard",
      "description": "for painting",
      "tags": [
        "platform"
      ]
    },
    "id": "8d7fc133-7cfa-4975-836f-31ae15b818be",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0966c9b3-2fd5-4b5b-8146-82fb08bd14c4": {
    "name": "form data",
    "inputs": {
      "data": {
        "type": "object"
      },
      "done": {
        "type": "any",
        "optional": true,
        "defaultIgnored": true
      }
    },
    "outputs": {
      "form": {
        "type": "\`J\`&\`FD\`",
        "ref": true,
        "icon": "brackets"
      }
    },
    "metadata": {
      "icon": "square",
      "description": "set of key/value pairs representing \`form\` fields and values",
      "tags": [
        "platform"
      ]
    },
    "id": "0966c9b3-2fd5-4b5b-8146-82fb08bd14c4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "33434271-3533-4a4e-adb9-306e35ab6afe": {
    "name": "unset pin",
    "inputs": {
      "unit": {
        "type": "\`U\`"
      },
      "type": {
        "type": "'input'|'output"
      },
      "name": {
        "type": "string"
      }
    },
    "outputs": {
      "unit": {
        "type": "\`U\`"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "remove data on input \`name\` of \`unit\`",
      "tags": [
        "f",
        "unit",
        "class"
      ]
    },
    "id": "33434271-3533-4a4e-adb9-306e35ab6afe",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8bd5bfb5-979c-4e51-917b-75e150d9170f": {
    "name": "set pin constant",
    "inputs": {
      "unit": {
        "_type": "<T:\`U\`>",
        "type": "\`U\`"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "name": {
        "type": "string"
      },
      "constant": {
        "type": "boolean"
      }
    },
    "outputs": {
      "unit": {
        "_type": "<T>",
        "type": "any"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set \`type\` pin \`name\` of \`unit\` to \`constant\`",
      "tags": [
        "f",
        "unit",
        "class"
      ]
    },
    "id": "8bd5bfb5-979c-4e51-917b-75e150d9170f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "43b43afd-9e7d-44ba-aef7-6e9db4ed8744": {
    "name": "set input",
    "inputs": {
      "unit": {
        "_type": "<T:\`U\`>",
        "type": "\`U\`"
      },
      "name": {
        "type": "string"
      },
      "data": {
        "type": "any"
      }
    },
    "outputs": {
      "unit": {
        "_type": "<T>",
        "type": "any"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set input \`name\` of \`unit\` to \`data\`",
      "tags": [
        "f",
        "unit",
        "class"
      ]
    },
    "id": "43b43afd-9e7d-44ba-aef7-6e9db4ed8744",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ac5863fc-5156-4a27-a6ce-148dc93f34dd": {
    "name": "has input",
    "inputs": {
      "unit": {
        "_type": "<T:\`U\`>",
        "type": "\`U\`"
      },
      "name": {
        "type": "string"
      }
    },
    "outputs": {
      "test": {
        "_type": "<T>",
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "check whether \`unit\` has input with \`name\`",
      "tags": [
        "f",
        "unit",
        "class"
      ]
    },
    "id": "ac5863fc-5156-4a27-a6ce-148dc93f34dd",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d745a41b-70ae-4162-a1d8-aac17d73b73d": {
    "name": "reset",
    "inputs": {
      "unit": {
        "_type": "<T:\`U\`>",
        "type": "\`U\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle-stop",
      "description": "reset \`unit\` to default state",
      "tags": [
        "f",
        "unit"
      ]
    },
    "id": "d745a41b-70ae-4162-a1d8-aac17d73b73d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ff84b8cd-216f-4bcf-8e29-e7c9998cae3d": {
    "name": "play",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "play",
      "description": "start unit execution",
      "tags": [
        "f",
        "unit"
      ]
    },
    "id": "ff84b8cd-216f-4bcf-8e29-e7c9998cae3d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "49517cda-b9da-4d80-b849-61fc2260317d": {
    "name": "paused",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "paused": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether unit is paused",
      "tags": [
        "f",
        "unit"
      ]
    },
    "id": "49517cda-b9da-4d80-b849-61fc2260317d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "a85fd9ad-5aec-4ebc-9008-e22db851dfa8": {
    "name": "pause",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "opt": {
        "type": "{}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "pause",
      "description": "pause unit execution",
      "tags": [
        "f",
        "unit"
      ]
    },
    "id": "a85fd9ad-5aec-4ebc-9008-e22db851dfa8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e599801e-d8c1-46a7-a2e9-4cae372b3606": {
    "name": "has pin",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string",
        "metadata": {
          "examples": [
            "'a'",
            "'b'",
            "'c'",
            "'d'"
          ]
        }
      }
    },
    "outputs": {
      "has": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "check whether \`graph\` \`has\` pin of \`type\` and \`pinId\`",
      "tags": [
        "f",
        "unit"
      ]
    },
    "id": "e599801e-d8c1-46a7-a2e9-4cae372b3606",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c2184162-4fda-49fb-afc3-6bc882a2736d": {
    "name": "debug",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "opt": {
        "type": "{events?:string[]}"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "moment": {
        "type": "{event:string,data:object}"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "watch \`unit\` for specified debug data events",
      "tags": [
        "f",
        "unit"
      ]
    },
    "id": "c2184162-4fda-49fb-afc3-6bc882a2736d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "95076599-0f2f-46b6-a9e0-b4cbfdb8dcc9": {
    "name": "timer",
    "inputs": {
      "ms": {
        "type": "number",
        "metadata": {
          "description": "number of milliseconds to wait before output"
        }
      }
    },
    "outputs": {
      "ms": {
        "type": "number",
        "metadata": {
          "description": "same as the inputted \`ms\`"
        }
      }
    },
    "metadata": {
      "icon": "timer",
      "description": "output \`ms\` after \`ms\` milliseconds",
      "tags": [
        "f",
        "time"
      ]
    },
    "id": "95076599-0f2f-46b6-a9e0-b4cbfdb8dcc9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "42a8023a-0581-4e92-968a-b31584d0ed75": {
    "name": "interval",
    "inputs": {
      "ms": {
        "type": "number",
        "metadata": {
          "description": "number of milliseconds to wait before output"
        }
      },
      "done": {
        "type": "number",
        "metadata": {
          "description": "signal the interval should stop"
        }
      }
    },
    "outputs": {
      "ms": {
        "type": "number",
        "metadata": {
          "description": "same as the inputted \`ms\`"
        }
      }
    },
    "metadata": {
      "icon": "timer",
      "description": "output \`ms\` after \`ms\` milliseconds, until \`done\`",
      "tags": [
        "f",
        "time"
      ]
    },
    "id": "42a8023a-0581-4e92-968a-b31584d0ed75",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "25cb84d7-ca96-4d79-926d-c01517a8d851": {
    "name": "trim",
    "inputs": {
      "a": {
        "type": "string"
      }
    },
    "outputs": {
      "a": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "remove whitespace from both ends of string \`a\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "25cb84d7-ca96-4d79-926d-c01517a8d851",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d4e4d4b2-80e0-4066-8d6f-5051e9a11a10": {
    "name": "to upper case",
    "inputs": {
      "a": {
        "type": "string",
        "metadata": {
          "examples": [
            "abc",
            "unit"
          ]
        }
      }
    },
    "outputs": {
      "A": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "convert string to upper case",
      "link": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "d4e4d4b2-80e0-4066-8d6f-5051e9a11a10",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "adde2d16-e1e6-4599-9a64-dd0968797041": {
    "name": "to lower case",
    "inputs": {
      "A": {
        "type": "string",
        "metadata": {
          "examples": [
            "ABC",
            "UNIT"
          ]
        }
      }
    },
    "outputs": {
      "a": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "convert string to lower case",
      "link": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "adde2d16-e1e6-4599-9a64-dd0968797041",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c2fec1e6-b370-4069-bb43-6dab5a78b9ab": {
    "name": "test",
    "inputs": {
      "str": {
        "type": "string"
      },
      "regex": {
        "type": "string"
      }
    },
    "outputs": {
      "match": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "regex",
      "description": "check if \`regex\` match \`str\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "c2fec1e6-b370-4069-bb43-6dab5a78b9ab",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "141eaa06-bb12-42f1-a46f-32ceefb64ddc": {
    "name": "substring",
    "inputs": {
      "a": {
        "type": "string"
      },
      "from": {
        "type": "number"
      },
      "length": {
        "type": "number"
      }
    },
    "outputs": {
      "a": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "substring",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "141eaa06-bb12-42f1-a46f-32ceefb64ddc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "387fef8e-3e75-4deb-86a0-7b1120992589": {
    "name": "starts with",
    "inputs": {
      "str": {
        "type": "string"
      },
      "search": {
        "type": "string"
      },
      "position": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {
      "test": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "match a string against a regular expression",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "387fef8e-3e75-4deb-86a0-7b1120992589",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e1e106ad-e15d-4044-82f6-27ddd476d7c8": {
    "name": "split",
    "inputs": {
      "a": {
        "type": "string"
      },
      "sep": {
        "type": "string",
        "metadata": {
          "examples": [
            "''"
          ]
        }
      }
    },
    "outputs": {
      "parts": {
        "type": "string[]"
      }
    },
    "metadata": {
      "icon": "split-text",
      "description": "output an array of strings by separating the string into substrings, using the specified separator \`sep\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "e1e106ad-e15d-4044-82f6-27ddd476d7c8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c8a4cd44-a554-4901-8a33-a8adbff63d03": {
    "name": "slice",
    "inputs": {
      "a": {
        "type": "string"
      },
      "begin": {
        "type": "number"
      },
      "end": {
        "type": "number"
      }
    },
    "outputs": {
      "a": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "extracts a section of a string",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "c8a4cd44-a554-4901-8a33-a8adbff63d03",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "af5469c4-a09e-4b22-8133-a21e721e7639": {
    "name": "replace",
    "inputs": {
      "str": {
        "type": "string"
      },
      "regex": {
        "type": "string"
      },
      "flags": {
        "type": "string"
      },
      "with": {
        "type": "string"
      }
    },
    "outputs": {
      "str": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "search",
      "description": "replace every \`regex\` match in \`str\` \`with\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "af5469c4-a09e-4b22-8133-a21e721e7639",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9da2b1ce-005e-4ec1-a73a-eee9850c97e2": {
    "name": "match all",
    "inputs": {
      "str": {
        "type": "string"
      },
      "regex": {
        "type": "string"
      }
    },
    "outputs": {
      "matches": {
        "type": "string[][]"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "match a string against a regular expression",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "9da2b1ce-005e-4ec1-a73a-eee9850c97e2",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b16cccf7-fe33-43a6-b208-48db494376e8": {
    "name": "match",
    "inputs": {
      "str": {
        "type": "string"
      },
      "regex": {
        "type": "string"
      }
    },
    "outputs": {
      "results": {
        "type": "string[]"
      },
      "meta": {
        "type": "{index:number,input:string,groups:string{}}",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "match a string against a regular expression",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "b16cccf7-fe33-43a6-b208-48db494376e8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "065d2fc3-af3b-4704-b26e-228d71f61771": {
    "name": "locale compare",
    "inputs": {
      "a": {
        "type": "string"
      },
      "b": {
        "type": "string"
      }
    },
    "outputs": {
      "a < b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "compare two strings in alphabetical order",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "065d2fc3-af3b-4704-b26e-228d71f61771",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1b8ce255-0bc7-4656-bafa-3dc86af44126": {
    "name": "length",
    "inputs": {
      "a": {
        "type": "string"
      }
    },
    "outputs": {
      "length": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "size of string",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "1b8ce255-0bc7-4656-bafa-3dc86af44126",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "38bc7001-3543-48ba-99a5-96aeb908494b": {
    "name": "includes",
    "inputs": {
      "str": {
        "type": "string"
      },
      "search": {
        "type": "string"
      }
    },
    "outputs": {
      "test": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "regex",
      "description": "check whether string \`str\` contains \`search\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "38bc7001-3543-48ba-99a5-96aeb908494b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "25d0e003-f002-45ae-a50c-6fa3bffee4eb": {
    "name": "from char code",
    "inputs": {
      "code": {
        "type": "number[]"
      }
    },
    "outputs": {
      "char": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "info",
      "description": "output string created from the specified sequence of UTF-16 code",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "25d0e003-f002-45ae-a50c-6fa3bffee4eb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f2ac8a60-70bc-4743-934b-c5cae16b42c1": {
    "name": "ends with",
    "inputs": {
      "str": {
        "type": "string"
      },
      "search": {
        "type": "string"
      },
      "position": {
        "type": "number",
        "metadata": {
          "examples": [
            "0"
          ]
        }
      }
    },
    "outputs": {
      "test": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "match end of a string against a regular expression",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "f2ac8a60-70bc-4743-934b-c5cae16b42c1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "779e538c-b0b9-477e-a986-30ee3abe6fe6": {
    "name": "concat",
    "inputs": {
      "a": {
        "type": "string"
      },
      "b": {
        "type": "string"
      }
    },
    "outputs": {
      "ab": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "concatenate two strings",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "998ae4f0-00ca-4c5f-9517-d47ed1d34457": {
    "name": "code point at",
    "inputs": {
      "str": {
        "type": "string"
      },
      "at": {
        "type": "number"
      }
    },
    "outputs": {
      "code": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "search",
      "description": "output the Unicode \`code\` point value of the character starting \`at\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "998ae4f0-00ca-4c5f-9517-d47ed1d34457",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "eb345e08-08fd-4032-bd69-a4e9f55e7aa6": {
    "name": "char at",
    "inputs": {
      "a": {
        "type": "string"
      },
      "i": {
        "type": "number",
        "metadata": {
          "description": "index"
        }
      }
    },
    "outputs": {
      "a[i]": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "get \`a\` character at position \`i\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "eb345e08-08fd-4032-bd69-a4e9f55e7aa6",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3e20a18c-60a3-40cd-bbee-f2f9e289b14d": {
    "name": "behead",
    "inputs": {
      "a": {
        "type": "string"
      }
    },
    "outputs": {
      "tail": {
        "type": "string"
      },
      "head": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "axe",
      "description": "remove the first character \`head\` of string \`a\`",
      "tags": [
        "f",
        "string"
      ]
    },
    "id": "3e20a18c-60a3-40cd-bbee-f2f9e289b14d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f97f2a74-d9a9-411d-afd3-fda46ba86c3b": {
    "name": "stringify",
    "inputs": {
      "obj": {
        "type": "object"
      }
    },
    "outputs": {
      "str": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "string",
      "description": "produces a URL query string from a given obj",
      "tags": [
        "f",
        "querystring"
      ]
    },
    "id": "f97f2a74-d9a9-411d-afd3-fda46ba86c3b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "02f91720-c4d5-4d66-ae91-d46ddc635722": {
    "name": "parse query",
    "inputs": {
      "str": {
        "type": "string"
      }
    },
    "outputs": {
      "obj": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "parses a URL query string into an object",
      "tags": [
        "f",
        "querystring"
      ]
    },
    "id": "02f91720-c4d5-4d66-ae91-d46ddc635722",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "964d3314-75fe-4a09-8ba8-c49145f29d49": {
    "name": "values",
    "inputs": {
      "obj": {
        "type": "object"
      }
    },
    "outputs": {
      "values": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "list values for this object",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "964d3314-75fe-4a09-8ba8-c49145f29d49",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c4784b05-1f50-44ad-b812-545b3ed77614": {
    "name": "set",
    "inputs": {
      "obj": {
        "type": "object",
        "_type": "O"
      },
      "key": {
        "type": "string",
        "_type": "K"
      },
      "value": {
        "type": "any",
        "_type": "V"
      }
    },
    "outputs": {
      "obj": {
        "type": "object",
        "_type": "{...O,[K]:V}"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set value at given key",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "60bdba6d-c670-430f-be72-6f39cf4e8453": {
    "name": "merge",
    "inputs": {
      "a": {
        "type": "object"
      },
      "b": {
        "type": "object"
      }
    },
    "outputs": {
      "ab": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge two objects \`a\` and \`b\` into \`ab\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "45b9c329-64e9-4c4a-800b-790947c75754": {
    "name": "keys",
    "inputs": {
      "obj": {
        "type": "object"
      }
    },
    "outputs": {
      "keys": {
        "type": "string[]"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "list keys for this object",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "45b9c329-64e9-4c4a-800b-790947c75754",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ad2ae8b9-9674-4b22-bed4-4458e0030b1a": {
    "name": "has key",
    "inputs": {
      "obj": {
        "type": "object"
      },
      "key": {
        "type": "string"
      }
    },
    "outputs": {
      "has": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "check if \`key\` is in \`obj\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "ad2ae8b9-9674-4b22-bed4-4458e0030b1a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9414421d-3376-4438-aa03-7afcd860972c": {
    "name": "get",
    "inputs": {
      "obj": {
        "_type": "T object",
        "type": "object"
      },
      "key": {
        "_type": "K keyof T",
        "type": "string"
      }
    },
    "outputs": {
      "value": {
        "_type": "T[K]",
        "type": "any"
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`obj\` property \`key\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "9414421d-3376-4438-aa03-7afcd860972c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ded32513-925d-4b37-924d-c85387c08ce9": {
    "name": "from entries",
    "inputs": {
      "entries": {
        "type": "[string,any][]"
      }
    },
    "outputs": {
      "obj": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "turn a list of key-value pairs into an object",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "ded32513-925d-4b37-924d-c85387c08ce9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "75ef6bb6-f7f1-4d48-a16d-2c04e05b14cf": {
    "name": "entries",
    "inputs": {
      "obj": {
        "type": "object"
      }
    },
    "outputs": {
      "entries": {
        "type": "[string,any][]"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "get \`obj\` list of key-value pairs \`entries\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "75ef6bb6-f7f1-4d48-a16d-2c04e05b14cf",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1": {
    "name": "delete",
    "inputs": {
      "obj": {
        "type": "object",
        "_type": "{...O,[K]:V}"
      },
      "key": {
        "type": "string",
        "_type": "K:string"
      }
    },
    "outputs": {
      "obj": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "remove \`obj\` key-value pair for given \`key\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "419e468e-e4d4-11ea-8efb-2b9d815b1798": {
    "name": "deep set",
    "inputs": {
      "path": {
        "type": "string[]"
      },
      "value": {
        "type": "any"
      },
      "obj": {
        "type": "object"
      }
    },
    "outputs": {
      "obj": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "get value of \`obj\` at \`path\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "419e468e-e4d4-11ea-8efb-2b9d815b1798",
    "type": "\`U\`&\`G\`",
    "base": true,
    "system": true
  },
  "2af12780-698c-40ca-baa9-5f3260377e0f": {
    "name": "deep merge",
    "inputs": {
      "a": {
        "type": "object"
      },
      "b": {
        "type": "object"
      }
    },
    "outputs": {
      "ab": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge two objects \`a\` and \`b\` into \`ab\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "2af12780-698c-40ca-baa9-5f3260377e0f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "740fde5d-8de1-448f-87d9-2ddd397e9c4b": {
    "name": "deep has key",
    "inputs": {
      "obj": {
        "type": "object"
      },
      "path": {
        "type": "string[]"
      },
      "key": {
        "type": "string"
      }
    },
    "outputs": {
      "has": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "check if \`key\` is in \`obj\` at \`path\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "740fde5d-8de1-448f-87d9-2ddd397e9c4b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2ff102a7-b469-461f-a3b1-a61b81c1b325": {
    "name": "deep get",
    "inputs": {
      "path": {
        "type": "string[]"
      },
      "obj": {
        "type": "object"
      }
    },
    "outputs": {
      "value": {
        "type": "any"
      }
    },
    "id": "2ff102a7-b469-461f-a3b1-a61b81c1b325",
    "type": "\`U\`",
    "metadata": {
      "icon": "object-get",
      "description": "get value of \`obj\` at \`path\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "base": true,
    "system": true
  },
  "9c903a42-4bc2-4f6b-8937-5dc464f34574": {
    "name": "deep delete",
    "inputs": {
      "obj": {
        "type": "object"
      },
      "path": {
        "type": "string[]"
      }
    },
    "outputs": {
      "obj": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "remove \`obj\` key-value pair for given \`path\`",
      "tags": [
        "f",
        "object"
      ]
    },
    "id": "9c903a42-4bc2-4f6b-8937-5dc464f34574",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4a2fc8f5-17a8-4665-8895-eee4b242121e": {
    "name": "to fixed",
    "inputs": {
      "n": {
        "type": "number"
      },
      "digits": {
        "type": "number"
      }
    },
    "outputs": {
      "str": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "round the number \`n\` to the specified number of \`digits\`",
      "tags": [
        "f",
        "number"
      ]
    },
    "id": "4a2fc8f5-17a8-4665-8895-eee4b242121e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8cd29108-95cd-4217-9721-11f7c7c1131e": {
    "name": "string to int",
    "inputs": {
      "str": {
        "type": "string"
      },
      "radix": {
        "type": "number",
        "metadata": {
          "description": "integer in the range 2 through 36 specifying the base to represent the number"
        },
        "optional": true
      }
    },
    "outputs": {
      "n": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a number into an integer",
      "tags": [
        "f",
        "number"
      ]
    },
    "id": "8cd29108-95cd-4217-9721-11f7c7c1131e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f60adade-f14e-11ea-b51e-537032a90354": {
    "name": "string to float",
    "inputs": {
      "str": {
        "type": "string"
      }
    },
    "outputs": {
      "n": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a string into a float",
      "tags": [
        "f",
        "number"
      ]
    },
    "id": "f60adade-f14e-11ea-b51e-537032a90354",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f712793d-8ee9-4805-9d4a-8c210cae667a": {
    "name": "number to string",
    "inputs": {
      "n": {
        "type": "number"
      },
      "radix": {
        "type": "number",
        "metadata": {
          "description": "integer in the range 2 through 36 specifying the base to represent the number"
        },
        "optional": true
      }
    },
    "outputs": {
      "str": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a number into a string",
      "tags": [
        "f",
        "number"
      ]
    },
    "id": "f712793d-8ee9-4805-9d4a-8c210cae667a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "94e93f42-d05e-45d9-9211-ba903e779f2d": {
    "name": "unit",
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "unit",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "94e93f42-d05e-45d9-9211-ba903e779f2d",
    "base": true,
    "type": "\`U\`",
    "private": true,
    "system": true
  },
  "70972046-ad11-11ea-aaea-0b9067ad19e7": {
    "name": "this",
    "inputs": {},
    "outputs": {
      "graph": {
        "type": "\`U\`&\`C\`&\`G\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "parent graph",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "70972046-ad11-11ea-aaea-0b9067ad19e7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "feaff5a2-1cbe-4fe8-89e7-421a2b7fc28f": {
    "name": "system",
    "inputs": {},
    "outputs": {
      "system": {
        "type": "\`S\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "system",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "feaff5a2-1cbe-4fe8-89e7-421a2b7fc28f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b5ea15f4-9bbd-11eb-b623-37aff4a9ce60": {
    "name": "specs",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "specs": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "object mapping id to spec",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "b5ea15f4-9bbd-11eb-b623-37aff4a9ce60",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e547c624-d505-485d-8d78-e393c6beb1b4": {
    "name": "spec",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      }
    },
    "outputs": {
      "spec": {
        "type": "\`J\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`unit\` \`spec\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "e547c624-d505-485d-8d78-e393c6beb1b4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ae1f7fc0-d6e7-489c-94ed-dee71c68dbb7": {
    "name": "spec",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "spec": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get system \`unit\` \`spec\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "ae1f7fc0-d6e7-489c-94ed-dee71c68dbb7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3be8272d-310a-4aa2-84a1-71f590a8227a": {
    "name": "spark",
    "inputs": {
      "a": {
        "type": "<T>"
      }
    },
    "outputs": {
      "a": {
        "type": "<T>"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "output \`a\` only once",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "3be8272d-310a-4aa2-84a1-71f590a8227a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f9f93972-0764-4095-9ca2-d18b7d9344d4": {
    "name": "scope",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      }
    },
    "outputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "access object local scope",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "f9f93972-0764-4095-9ca2-d18b7d9344d4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "727133c9-3e87-4219-a91e-a257c9b2669b": {
    "name": "remote share graph",
    "inputs": {
      "graph": {
        "type": "\`U\`&\`G\`",
        "ref": true
      },
      "opt": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "message": {
        "type": "object"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "outputs": {
      "message": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "link",
      "description": "protocol for one-to-one remote graph sync",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "727133c9-3e87-4219-a91e-a257c9b2669b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "57bcdd88-a4f4-49ab-92d4-ed1969895520": {
    "name": "remote graph",
    "inputs": {
      "opt": {
        "type": "{}",
        "metadata": {
          "examples": [
            "{}"
          ]
        }
      },
      "close": {
        "type": "any",
        "defaultIgnored": true
      },
      "message": {
        "type": "any"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`",
        "ref": true,
        "icon": "graph"
      },
      "message": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "link",
      "description": "remote graph",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "57bcdd88-a4f4-49ab-92d4-ed1969895520",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1b592040-968f-456b-bdb5-b424e08b80f1": {
    "name": "new",
    "inputs": {
      "class": {
        "type": "\`U\`"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "instantiate \`class\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "1b592040-968f-456b-bdb5-b424e08b80f1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b099cf61-6745-4c19-a4be-0e1f19ea4b15": {
    "name": "inspect",
    "inputs": {
      "ref": {
        "type": "any",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "interface": {
        "type": "{types:string[]}"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`object\` interface spec",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "b099cf61-6745-4c19-a4be-0e1f19ea4b15",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b0c25199-c284-4f90-817c-60dc89b15b1c": {
    "name": "id to class",
    "inputs": {
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "\\"260d774e-bc89-4027-aa92-cb1985fb312b\\""
          ]
        }
      }
    },
    "outputs": {
      "class": {
        "type": "\`U\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "unit \`class\` with the given system \`id\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "b0c25199-c284-4f90-817c-60dc89b15b1c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ef26bb99-42a2-40f9-a537-ae49416e1487": {
    "name": "graph",
    "inputs": {
      "unit": {
        "type": "any"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`G\`",
        "icon": "graph"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`unit\` \`graph\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "ef26bb99-42a2-40f9-a537-ae49416e1487",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "60169f42-7d1d-43db-9e24-53990dde80e0": {
    "name": "graph",
    "inputs": {
      "unit": {
        "type": "any",
        "ref": true
      }
    },
    "outputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true,
        "icon": "graph"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`unit\` \`graph\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "60169f42-7d1d-43db-9e24-53990dde80e0",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8383c41e-3f9b-4d04-8380-feb583a1404f": {
    "name": "global",
    "inputs": {},
    "outputs": {
      "obj": {
        "type": "\`J\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "table",
      "description": "globally accessible object scope",
      "tags": [
        "f",
        "meta"
      ],
      "globals": []
    },
    "id": "8383c41e-3f9b-4d04-8380-feb583a1404f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "56fb9a32-ad10-11ea-b0f4-3b0ea5e3ac2c": {
    "name": "exec",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "method": {
        "type": "string"
      },
      "args": {
        "type": "any[]"
      }
    },
    "outputs": {
      "return": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "execute \`unit\` \`method\` with \`data\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "56fb9a32-ad10-11ea-b0f4-3b0ea5e3ac2c",
    "private": true,
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "808f93cd-168d-4f06-9795-6477739a5e51": {
    "name": "env",
    "inputs": {},
    "outputs": {
      "obj": {
        "type": "\`J<string>\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "table",
      "description": "globally accessible environment variables",
      "tags": [
        "f",
        "meta"
      ],
      "globals": []
    },
    "id": "808f93cd-168d-4f06-9795-6477739a5e51",
    "base": true,
    "type": "\`U\`&\`J\`",
    "system": true
  },
  "e2c36c21-e293-40df-9238-5c9ae7a20299": {
    "name": "destroy",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "any": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle-x",
      "description": "destroy a \`unit\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "e2c36c21-e293-40df-9238-5c9ae7a20299",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "546fea11-bbb6-4d20-839b-df0011f528ac": {
    "name": "class to unit bundle",
    "inputs": {
      "class": {
        "type": "\`U\`"
      }
    },
    "outputs": {
      "unit": {
        "type": "{unit:object,specs:object}"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "extract \`unit\` bundle of the given unit \`class\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "546fea11-bbb6-4d20-839b-df0011f528ac",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2520668c-b279-11ea-ace3-5b84eb02bd7f": {
    "name": "catch",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      }
    },
    "outputs": {
      "err": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "circle-alert",
      "description": "catch all \`unit\` error",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "2520668c-b279-11ea-ace3-5b84eb02bd7f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3c284564-985a-403f-bf00-8d43aa805ea9": {
    "name": "bundle",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "opt": {
        "type": "{deep?:boolean,system?:boolean,state?:boolean}",
        "medatata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {
      "bundle": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`unit\` \`bundle\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "3c284564-985a-403f-bf00-8d43aa805ea9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "53825c2f-1aca-40f5-b739-3c60ef5886a8": {
    "name": "bundle",
    "inputs": {
      "unit": {
        "type": "\`U\`",
        "ref": true
      },
      "opt": {
        "type": "{deep?:boolean,system?:boolean,state?:boolean}",
        "medatata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {
      "bundle": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`unit\` \`bundle\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "53825c2f-1aca-40f5-b739-3c60ef5886a8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "13d738b9-401d-43c9-852f-e9611545f5bc": {
    "name": "bundle",
    "inputs": {
      "graph": {
        "type": "\`U\`&\`G\`",
        "ref": true
      },
      "opt": {
        "type": "{deep?:boolean,system?:boolean,state?:boolean}",
        "medatata": {
          "examples": [
            "{}"
          ]
        }
      }
    },
    "outputs": {
      "bundle": {
        "type": "object"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get \`graph\` \`bundle\`",
      "tags": [
        "f",
        "meta"
      ]
    },
    "id": "13d738b9-401d-43c9-852f-e9611545f5bc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "682c1419-d2cc-489d-b95f-a8b7dacada6c": {
    "name": "tan",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "tan(a)": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "tangent of angle \`a\` in rad",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "682c1419-d2cc-489d-b95f-a8b7dacada6c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b9f90a95-1bfc-4897-9068-2560743821a3": {
    "name": "sin",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "sin(a)": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "sine of angle \`a\` in rad",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "b9f90a95-1bfc-4897-9068-2560743821a3",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1a59348c-a25a-11eb-8afe-8bedb0732a89": {
    "name": "sign",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "sign(a)": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "plus-minus",
      "description": "sign of a",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "1a59348c-a25a-11eb-8afe-8bedb0732a89",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "530e83d2-1d61-11eb-b472-53e545a06c92": {
    "name": "sqrt",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "√a": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "square root of \`a\`",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "530e83d2-1d61-11eb-b472-53e545a06c92",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2b59f375-ef06-4ec7-80c2-71a53171ec67": {
    "name": "random",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "random": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "random",
      "description": "random number between 0 and 1, non inclusive",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "2b59f375-ef06-4ec7-80c2-71a53171ec67",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ef4c1d0a-bda1-484e-8fcb-0fdbde195778": {
    "name": "pow",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a ** b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "exponential",
      "description": "\`a\` to the power of \`b\`",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "ef4c1d0a-bda1-484e-8fcb-0fdbde195778",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3256e26d-8495-4c9d-8998-5b026691231d": {
    "name": "PI",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "PI": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "pi",
      "description": "the ratio of the circumference of a circle to its diameter",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "3256e26d-8495-4c9d-8998-5b026691231d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4e63c320-f5a5-4f65-982e-632b5adafa29": {
    "name": "min",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "min": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "arrow-down",
      "description": "the smallest between \`a\` and \`b\`",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "4e63c320-f5a5-4f65-982e-632b5adafa29",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e857c770-5a98-4f8d-a0e1-b6cb126071ed": {
    "name": "max",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "max": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "arrow-up",
      "description": "the biggest between \`a\` and \`b\`",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "e857c770-5a98-4f8d-a0e1-b6cb126071ed",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f68b0b2a-7967-445e-86a8-99ebc1e2144c": {
    "name": "log",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "ln(a)": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "exponential",
      "description": "log of \`a\` in natural base",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "f68b0b2a-7967-445e-86a8-99ebc1e2144c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3217edcf-2fa1-4dc4-af7c-d6fb607c888d": {
    "name": "floor",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "⌊a⌋": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "floor of a number",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "3217edcf-2fa1-4dc4-af7c-d6fb607c888d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "62af44dc-17d6-459a-b95f-3b8ce5b48856": {
    "name": "cos",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "cos(a)": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "cosine of angle \`a\` in rad",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "62af44dc-17d6-459a-b95f-3b8ce5b48856",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e90dbb0a-880b-42f8-9488-7728910ba7e5": {
    "name": "ceil",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "⌈a⌉": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "ceil of a number",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "e90dbb0a-880b-42f8-9488-7728910ba7e5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e3169d84-6b13-49f9-bae0-bf1652d0d5c9": {
    "name": "atan2",
    "inputs": {
      "x": {
        "type": "number"
      },
      "y": {
        "type": "number"
      }
    },
    "outputs": {
      "rad": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "angle (in radians) from the x axis to a point",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "e3169d84-6b13-49f9-bae0-bf1652d0d5c9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "5a5efeaf-79b7-4e7d-9507-09331b339962": {
    "name": "asinh",
    "inputs": {
      "x": {
        "type": "number"
      }
    },
    "outputs": {
      "rad": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "inverse hyperbolic sine of a number",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "5a5efeaf-79b7-4e7d-9507-09331b339962",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "50195696-e8d3-4b45-9a0a-26f2edf2a6bc": {
    "name": "asin",
    "inputs": {
      "x": {
        "type": "number"
      }
    },
    "outputs": {
      "rad": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "arc sine (inverse sine) of a number",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "50195696-e8d3-4b45-9a0a-26f2edf2a6bc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "5a711396-7cdc-4f5c-8b2c-76053a477868": {
    "name": "acosh",
    "inputs": {
      "x": {
        "type": "number"
      }
    },
    "outputs": {
      "rad": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "inverse hyperbolic cosine of a number",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "5a711396-7cdc-4f5c-8b2c-76053a477868",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c5f518c9-650f-4718-8c19-161496fdc676": {
    "name": "acos",
    "inputs": {
      "x": {
        "type": "number"
      }
    },
    "outputs": {
      "rad": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "arc cosine (inverse cosine) of a number",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "c5f518c9-650f-4718-8c19-161496fdc676",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "fafc23ce-a259-11eb-b14e-af9d1f579af4": {
    "name": "abs",
    "inputs": {
      "a": {
        "type": "number"
      }
    },
    "outputs": {
      "|a|": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "value-absolute",
      "description": "absolute value of \`a\`",
      "tags": [
        "f",
        "math"
      ]
    },
    "id": "fafc23ce-a259-11eb-b14e-af9d1f579af4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "62a19cd6-04bd-4e46-a72e-4fa3516ad3fa": {
    "name": "or",
    "inputs": {
      "a": {
        "type": "boolean"
      },
      "b": {
        "type": "boolean"
      }
    },
    "outputs": {
      "a or b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "grip-lines-vertical",
      "description": "OR logical operator",
      "tags": [
        "f",
        "logic"
      ]
    },
    "id": "62a19cd6-04bd-4e46-a72e-4fa3516ad3fa",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7d02d638-a311-4ea8-a0c0-d45baf739e0d": {
    "name": "not",
    "inputs": {
      "a": {
        "type": "boolean"
      }
    },
    "outputs": {
      "!a": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "exclamation",
      "description": "NOT logic operator",
      "tags": [
        "f",
        "logic"
      ]
    },
    "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "407640f7-f1c3-4297-a5ce-baff357a6d31": {
    "name": "and",
    "inputs": {
      "a": {
        "type": "boolean"
      },
      "b": {
        "type": "boolean"
      }
    },
    "outputs": {
      "a and b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "ampersand",
      "description": "AND logical operator",
      "tags": [
        "f",
        "logic"
      ]
    },
    "id": "407640f7-f1c3-4297-a5ce-baff357a6d31",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3e5c5856-c721-11ea-b7af-07a978a65cdc": {
    "name": "uuid",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "uuid": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "info",
      "description": "output a random uuid",
      "tags": [
        "f",
        "id"
      ]
    },
    "id": "3e5c5856-c721-11ea-b7af-07a978a65cdc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "af3e9b4f-779e-4245-903e-5d69192b1afb": {
    "name": "set unit pin data",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "id": {
        "type": "string"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      },
      "data": {
        "type": "any"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` unit \`id\` \`type\` pin \`pinId\` \`data\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "af3e9b4f-779e-4245-903e-5d69192b1afb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "cda93f82-5ffe-498c-b756-c7ff405aafa1": {
    "name": "set unit pin constant",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "id": {
        "type": "string"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      },
      "constant": {
        "type": "boolean"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` unit \`id\` \`type\` pin \`pinId\` \`constant\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "cda93f82-5ffe-498c-b756-c7ff405aafa1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f3b9b75b-a84b-4070-b4f1-25e5e48664e4": {
    "name": "set name",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "name": {
        "type": "string"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` class \`name\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "f3b9b75b-a84b-4070-b4f1-25e5e48664e4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7750a781-1aa2-4e78-aa91-67fdbf44c09d": {
    "name": "set metadata",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "path": {
        "type": "string[]"
      },
      "value": {
        "type": "any"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "deep set \`graph\` class metadata \`path\` \`value\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "7750a781-1aa2-4e78-aa91-67fdbf44c09d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d36729c6-432f-46e9-8fa1-3fc88de022ff": {
    "name": "add unit spec",
    "inputs": {
      "unit": {
        "type": "object"
      },
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "'0'",
            "'1'",
            "'2'",
            "'3'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "add unit of \`unit\` spec to \`graph\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "d36729c6-432f-46e9-8fa1-3fc88de022ff",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "73967b68-9b4b-44c1-8a19-f505551f6c53": {
    "name": "add unit",
    "inputs": {
      "class": {
        "type": "\`U\`"
      },
      "graph": {
        "type": "\`G\`"
      },
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "'0'",
            "'1'",
            "'2'",
            "'3'"
          ]
        }
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "add unit of \`class\` to \`graph\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "73967b68-9b4b-44c1-8a19-f505551f6c53",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "054adf25-93b2-492c-ada2-f55e70d23c3d": {
    "name": "add pin",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "'a'",
            "'b'",
            "'c'",
            "'d'"
          ]
        }
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pin": {
        "type": "object"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "add pin set of \`type\` and \`pin\` spec to \`graph\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "054adf25-93b2-492c-ada2-f55e70d23c3d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6da131ca-d22e-49ae-92ea-0607e7f1ea06": {
    "name": "add merge",
    "inputs": {
      "graph": {
        "type": "\`G\`"
      },
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "'0'",
            "'1'",
            "'2'",
            "'3'"
          ]
        }
      },
      "merge": {
        "type": "object"
      }
    },
    "outputs": {
      "graph": {
        "type": "\`U\`&\`G\`"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "add unit of \`class\` to \`graph\`",
      "tags": [
        "f",
        "graph",
        "class"
      ]
    },
    "id": "6da131ca-d22e-49ae-92ea-0607e7f1ea06",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d1e7f8a2-3ef2-4264-a429-79d62e54f0b8": {
    "name": "unplug",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      },
      "subPinId": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "disconnect plug in \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "d1e7f8a2-3ef2-4264-a429-79d62e54f0b8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "76e99304-aa0c-11eb-9bfa-07725a1b4287": {
    "name": "set unit pin data",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "id": {
        "type": "string"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "name": {
        "type": "string"
      },
      "data": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` \`id\` unit \`type\` \`name\` pin \`data\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "76e99304-aa0c-11eb-9bfa-07725a1b4287",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d1d9e6e8-c448-4c31-be19-95fab6b42084": {
    "name": "set unit pin constant",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "id": {
        "type": "string"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "name": {
        "type": "string"
      },
      "constant": {
        "type": "boolean"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` \`id\` unit \`type\` \`name\` pin \`data\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "d1d9e6e8-c448-4c31-be19-95fab6b42084",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c47d84b2-4207-11eb-a064-a3633d64f05d": {
    "name": "remove unit",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "id": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "remove unit \`id\` from \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "c47d84b2-4207-11eb-a064-a3633d64f05d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9a7d8615-9216-47d8-b60b-2bc457dc50e9": {
    "name": "remove plug",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      },
      "subPinId": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "remove plug \`type\` \`pinId\` \`subPinId\` from \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "9a7d8615-9216-47d8-b60b-2bc457dc50e9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0d93e505-d013-4c95-85d1-ffc424d1be5d": {
    "name": "remove pin",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "remove pin of \`type\` and \`pinId\` from \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "0d93e505-d013-4c95-85d1-ffc424d1be5d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2846ce5f-7f05-4c47-a969-8706b5064bbe": {
    "name": "plug",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      },
      "subPinId": {
        "type": "string"
      },
      "subPin": {
        "type": "object"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "connect plug in \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "2846ce5f-7f05-4c47-a969-8706b5064bbe",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6364c619-778c-43b6-b574-d475f758aeea": {
    "name": "edit",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "action": {
        "type": "{type:string,data:object}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "execute one action on \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "6364c619-778c-43b6-b574-d475f758aeea",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2fcdd937-62b4-4601-b972-196144d3ab33": {
    "name": "bulk edit",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "actions": {
        "type": "object[]"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "execute a sequence of actions on \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "2fcdd937-62b4-4601-b972-196144d3ab33",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "b80d4b5a-40e9-11eb-a2bb-1777d47bf9ae": {
    "name": "add unit",
    "inputs": {
      "class": {
        "type": "\`U\`"
      },
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "'0'",
            "'1'",
            "'2'",
            "'3'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "add unit of \`class\` to \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "b80d4b5a-40e9-11eb-a2bb-1777d47bf9ae",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c460bfe1-253e-4d9f-8572-1ca06557aba9": {
    "name": "add plug",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string",
        "metadata": {
          "examples": [
            "'a'",
            "'b'",
            "'c'",
            "'d'"
          ]
        }
      },
      "subPinId": {
        "type": "string"
      },
      "subPin": {
        "type": "object"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` \`id\` unit \`type\` \`name\` pin \`data\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "c460bfe1-253e-4d9f-8572-1ca06557aba9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d1f8bea7-3ef6-42c3-a4fc-b50e7484a823": {
    "name": "add pin to merge",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "mergeId": {
        "type": "string"
      },
      "unitId": {
        "type": "string"
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` \`id\` unit \`type\` \`name\` pin \`data\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "d1f8bea7-3ef6-42c3-a4fc-b50e7484a823",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "db3e8175-eef8-45fc-9676-f7f2672eadf1": {
    "name": "add pin",
    "inputs": {
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "type": {
        "type": "'input'|'output'"
      },
      "pinId": {
        "type": "string",
        "metadata": {
          "examples": [
            "'a'",
            "'b'",
            "'c'",
            "'d'"
          ]
        }
      },
      "pinSpec": {
        "type": "{plug?:({unitId?:string,pinId?:string,mergeId?:string}){}}"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "add pin of \`type\` \`pinId\` to \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "db3e8175-eef8-45fc-9676-f7f2672eadf1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8fb78908-6b6c-4781-acf1-77632361e48f": {
    "name": "add merge",
    "inputs": {
      "merge": {
        "type": "object{}"
      },
      "graph": {
        "type": "\`G\`",
        "ref": true
      },
      "id": {
        "type": "string",
        "metadata": {
          "examples": [
            "'0'",
            "'1'",
            "'2'",
            "'3'"
          ]
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "circle",
      "description": "add merge to \`graph\`",
      "tags": [
        "f",
        "graph"
      ]
    },
    "id": "8fb78908-6b6c-4781-acf1-77632361e48f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "17f6b87d-0b29-4c21-90ff-fc3ba7bee516": {
    "name": "set hours",
    "inputs": {
      "date": {
        "type": "\`D\`",
        "ref": true
      },
      "hours": {
        "type": "number"
      },
      "min": {
        "type": "number"
      },
      "sec": {
        "type": "number"
      },
      "ms": {
        "type": "number"
      }
    },
    "outputs": {
      "done": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "calendar",
      "description": "set \`date\` hours, minutes, seconds and milliseconds",
      "tags": [
        "f",
        "date",
        "method"
      ]
    },
    "id": "17f6b87d-0b29-4c21-90ff-fc3ba7bee516",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "fb194f3b-b7e6-49c8-a77b-e2c16d6f33d7": {
    "name": "set date",
    "inputs": {
      "date": {
        "type": "\`D\`",
        "ref": true
      },
      "day": {
        "type": "number"
      }
    },
    "outputs": {
      "done": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "calendar",
      "description": "set \`date\` hours, minutes, seconds and milliseconds",
      "tags": [
        "f",
        "date",
        "method"
      ]
    },
    "id": "fb194f3b-b7e6-49c8-a77b-e2c16d6f33d7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d58015a1-99c0-4f60-9b6f-5195a17be3fe": {
    "name": "get time",
    "inputs": {
      "any": {
        "type": "any"
      },
      "date": {
        "type": "\`D\`",
        "ref": true
      }
    },
    "outputs": {
      "time": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "calendar",
      "description": "get current date time",
      "tags": [
        "f",
        "date",
        "method"
      ]
    },
    "id": "d58015a1-99c0-4f60-9b6f-5195a17be3fe",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7b5d35ac-b11e-40cd-a3df-77979409da07": {
    "name": "get date",
    "inputs": {
      "any": {
        "type": "any"
      },
      "date": {
        "type": "\`D\`",
        "ref": true
      }
    },
    "outputs": {
      "day": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "calendar",
      "description": "get current date time",
      "tags": [
        "f",
        "date",
        "method"
      ]
    },
    "id": "7b5d35ac-b11e-40cd-a3df-77979409da07",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "939ed573-82b8-4385-ac62-88934e5b76c9": {
    "name": "now",
    "inputs": {
      "any": {
        "type": "any"
      }
    },
    "outputs": {
      "now": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "calendar",
      "description": "get current date time",
      "tags": [
        "f",
        "date"
      ]
    },
    "id": "939ed573-82b8-4385-ac62-88934e5b76c9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "4f390740-7257-4eca-911a-cea985628b59": {
    "name": "date",
    "inputs": {
      "init": {
        "type": "string|number"
      },
      "done": {
        "type": "any"
      }
    },
    "outputs": {
      "date": {
        "type": "\`D\`",
        "ref": true
      }
    },
    "metadata": {
      "icon": "calendar",
      "description": "instantiate a date object",
      "tags": [
        "f",
        "date"
      ]
    },
    "id": "4f390740-7257-4eca-911a-cea985628b59",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "63605ea1-40e7-47db-9f8f-313dffa6e3c9": {
    "name": "type of",
    "inputs": {
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "type": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "get \`a\` data type",
      "tags": [
        "f",
        "data"
      ]
    },
    "id": "63605ea1-40e7-47db-9f8f-313dffa6e3c9",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "2b24877a-3221-4288-9f59-efbf29964368": {
    "name": "stringify",
    "inputs": {
      "a": {
        "type": "any"
      }
    },
    "outputs": {
      "str": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "string",
      "description": "value to string",
      "tags": [
        "f",
        "data"
      ]
    },
    "id": "2b24877a-3221-4288-9f59-efbf29964368",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "69323dab-b425-4a2a-b1c7-d7efc723327a": {
    "name": "evaluate",
    "inputs": {
      "str": {
        "type": "string"
      }
    },
    "outputs": {
      "a": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "wave-triangle",
      "description": "string to value",
      "tags": [
        "f",
        "data"
      ]
    },
    "id": "69323dab-b425-4a2a-b1c7-d7efc723327a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ba38b0af-80c0-49e4-9e39-864396964ccc": {
    "name": "wait",
    "inputs": {
      "a": {
        "type": "<A>"
      },
      "b": {
        "type": "any"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "git-merge",
      "description": "wait for \`b\` before output \`a\`",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9d853ef5-3fff-474d-a951-6af4237cf4c4": {
    "name": "void",
    "inputs": {
      "a": {
        "type": "any"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "slash",
      "description": "consume \`a\`",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "9d853ef5-3fff-474d-a951-6af4237cf4c4",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "99657eb7-fb94-474e-b03d-4b08c537c0a2": {
    "name": "throw",
    "inputs": {
      "message": {
        "type": "string"
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "alert-circle",
      "description": "throw error message",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "99657eb7-fb94-474e-b03d-4b08c537c0a2",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0f1c7d8c-87a7-44ad-bee5-de37d4800e8f": {
    "name": "push",
    "inputs": {
      "a": {
        "type": "<T>"
      },
      "b": {
        "type": "any"
      }
    },
    "outputs": {
      "a": {
        "type": "<T>"
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "consume \`b\`, let pass \`a\` if present",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "0f1c7d8c-87a7-44ad-bee5-de37d4800e8f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "36329d25-218d-48a5-a06c-1e0525da504f": {
    "name": "plan",
    "inputs": {
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "0": {
        "type": "<A>"
      },
      "1": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "output \`a\` on \`0\`, then \`1\` after \`0\` is consumed",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "36329d25-218d-48a5-a06c-1e0525da504f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "835edaa6-d07c-44e4-916d-eb4b9fd8f7b1": {
    "name": "next",
    "inputs": {
      "next": {
        "type": "<A>"
      },
      "init": {
        "type": "<A>"
      }
    },
    "outputs": {
      "current": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "iteratively update a single value on next tick",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "835edaa6-d07c-44e4-916d-eb4b9fd8f7b1",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "49e11645-c25d-4bf7-923d-56817f67b686": {
    "name": "memory",
    "inputs": {
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "triangle",
      "description": "output \`a\` then consume \`a\`",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "49e11645-c25d-4bf7-923d-56817f67b686",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3432494e-fab6-4e9d-a846-0c48a7c429cd": {
    "name": "loop",
    "inputs": {
      "next": {
        "type": "<A>"
      },
      "test": {
        "type": "boolean"
      },
      "init": {
        "type": "<A>",
        "metadata": {
          "examples": [
            "0",
            "3"
          ]
        }
      }
    },
    "outputs": {
      "current": {
        "type": "<A>"
      },
      "local": {
        "type": "<A>"
      },
      "final": {
        "type": "<A>",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "for loop",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "8a2b756a-25e4-11eb-860d-1f34c850b992": {
    "name": "iterate",
    "inputs": {
      "next": {
        "type": "<A>"
      },
      "init": {
        "type": "<A>"
      }
    },
    "outputs": {
      "current": {
        "type": "<A>"
      },
      "local": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "iteratively update a single value",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "06bc3983-44b0-43d6-b041-2e9218ea89c8": {
    "name": "if",
    "inputs": {
      "a": {
        "type": "<A>"
      },
      "b": {
        "type": "boolean"
      }
    },
    "outputs": {
      "a if b": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "consume \`a\` and \`b\` if \`b\` is false, output pass \`a\` otherwise",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "260d774e-bc89-4027-aa92-cb1985fb312b": {
    "name": "identity",
    "inputs": {
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "output \`a\`",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "329920ae-7e91-11ea-988e-1b12488c8b89": {
    "name": "default",
    "inputs": {
      "a": {
        "type": "<A>"
      },
      "d": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "grip-lines-vertical",
      "description": "output \`a\` if present, \`default\` if not, otherwise",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ff976ac8-c54f-4d37-8c7d-089c271cb433": {
    "name": "constant",
    "inputs": {
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>"
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "output \`a\` forever",
      "tags": [
        "f",
        "control"
      ]
    },
    "id": "ff976ac8-c54f-4d37-8c7d-089c271cb433",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "bda175a9-a9d2-4282-9b50-1b008ae8a807": {
    "name": "not equal",
    "inputs": {
      "a": {
        "type": "<A>"
      },
      "b": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a ≠ b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "equal-not",
      "description": "inequality",
      "tags": [
        "f",
        "comparison"
      ]
    },
    "id": "bda175a9-a9d2-4282-9b50-1b008ae8a807",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "e13f3090-62a6-4a3b-8401-c571cbf03526": {
    "name": "less than equal",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a ≤ b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "less-than-equal",
      "description": "less than or equal to operator",
      "tags": [
        "f",
        "comparison"
      ]
    },
    "id": "e13f3090-62a6-4a3b-8401-c571cbf03526",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35": {
    "name": "less than",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a < b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "less-than",
      "description": "less than operator",
      "tags": [
        "f",
        "comparison"
      ]
    },
    "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c9e06816-0d2b-43ec-b7c8-d07563e19b6b": {
    "name": "greater than equal",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a ≥ b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "greater-than-equal",
      "description": "greater than equal operator",
      "tags": [
        "f",
        "comparison"
      ]
    },
    "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "1651ce6b-4db0-4787-9edf-f770b72d253c": {
    "name": "greater than",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a > b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "greater-than",
      "description": "greater than operator",
      "tags": [
        "f",
        "comparison"
      ]
    },
    "id": "1651ce6b-4db0-4787-9edf-f770b72d253c",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "85204bf6-6692-4686-a785-23127c0594b5": {
    "name": "equals",
    "inputs": {
      "a": {
        "type": "any"
      },
      "b": {
        "type": "any"
      }
    },
    "outputs": {
      "a = b": {
        "type": "boolean"
      }
    },
    "metadata": {
      "icon": "equal",
      "description": "equality",
      "tags": [
        "f",
        "comparison"
      ]
    },
    "id": "85204bf6-6692-4686-a785-23127c0594b5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "3d59edf2-5fca-4475-9df0-d876e14f990d": {
    "name": "xor",
    "inputs": {
      "a": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      },
      "b": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      }
    },
    "outputs": {
      "a ^ b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "bitwise-xor",
      "description": "bitwise XOR operator",
      "tags": [
        "f",
        "bitwise"
      ]
    },
    "id": "3d59edf2-5fca-4475-9df0-d876e14f990d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "0d656c2e-eb10-45f0-b236-f8916492ca86": {
    "name": "or",
    "inputs": {
      "a": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      },
      "b": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      }
    },
    "outputs": {
      "a | b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "bitwise-or",
      "description": "bitwise OR operator",
      "tags": [
        "f",
        "bitwise"
      ]
    },
    "id": "0d656c2e-eb10-45f0-b236-f8916492ca86",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "62d0c3e2-cf8b-4415-acfb-cf31739adce5": {
    "name": "not",
    "inputs": {
      "a": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      }
    },
    "outputs": {
      "~a": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "bitwise-not",
      "description": "bitwise NOT operator",
      "tags": [
        "f",
        "bitwise"
      ]
    },
    "id": "62d0c3e2-cf8b-4415-acfb-cf31739adce5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "be6801c0-02e2-4f76-bcad-b68c80991fad": {
    "name": "and",
    "inputs": {
      "a": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      },
      "b": {
        "type": "number",
        "metadata": {
          "examples": [
            "0",
            "1"
          ]
        }
      }
    },
    "outputs": {
      "a & b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "bitwise-and",
      "description": "bitwise AND operator",
      "tags": [
        "f",
        "bitwise"
      ]
    },
    "id": "be6801c0-02e2-4f76-bcad-b68c80991fad",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d4572f1c-83d3-4a3d-be76-fa16578286d2": {
    "name": "sort",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "a[i] < a[j]": {
        "type": "boolean"
      }
    },
    "outputs": {
      "a[i]": {
        "type": "<A>"
      },
      "a[j]": {
        "type": "<A>"
      },
      "b": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "sort array \`a\` by comparing its elements",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "d4572f1c-83d3-4a3d-be76-fa16578286d2",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c6bf897a-4970-4284-bea2-b4a86186f828": {
    "name": "slice",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "begin": {
        "type": "number"
      },
      "end": {
        "type": "number"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "extracts a section from string \`a\` from \`begin\` to \`end\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "c6bf897a-4970-4284-bea2-b4a86186f828",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f69e88e3-b2c2-481b-b036-a5c0ed7ccccb": {
    "name": "remove",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "start": {
        "type": "number"
      },
      "count": {
        "type": "number"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      },
      "removed": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "remove \`count\` elements from array \`a\` starting at \`start\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "f69e88e3-b2c2-481b-b036-a5c0ed7ccccb",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "22622778-d64f-47e7-8ceb-d175edcc6562": {
    "name": "put",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "v": {
        "type": "<A>"
      },
      "i": {
        "type": "number"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "set element of \`a\` at position \`i\` to \`v\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "22622778-d64f-47e7-8ceb-d175edcc6562",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "d9cf4224-39df-434a-85a6-2b143330cbab": {
    "name": "prepend",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "b": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "prepend element \`b\` to \`a\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "d9cf4224-39df-434a-85a6-2b143330cbab",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "81006022-e4d0-11ea-902a-fbf9fc5c9246": {
    "name": "pop",
    "inputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      },
      "last": {
        "type": "<A>"
      },
      "done": {
        "type": "any",
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "axe",
      "description": "remove the \`last\` element from \`a\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "81006022-e4d0-11ea-902a-fbf9fc5c9246",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "46d98b47-0fa4-409e-bbc6-bb3165d863d8": {
    "name": "length",
    "inputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "outputs": {
      "length": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "size of array \`a\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "104777ec-afb9-4513-9974-53b5528f0d15": {
    "name": "join",
    "inputs": {
      "a": {
        "type": "string[]"
      },
      "sep": {
        "type": "string",
        "metadata": {
          "examples": [
            "''",
            "','",
            "'/'"
          ]
        }
      }
    },
    "outputs": {
      "str": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "join array \`a\` elements into \`str\` with separator \`sep\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "104777ec-afb9-4513-9974-53b5528f0d15",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "7014b684-ce58-4b6a-989d-bd6c047daab5": {
    "name": "insert",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "i": {
        "type": "number"
      },
      "b": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "insert \`b\` element into \`a\` at index \`i\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "7014b684-ce58-4b6a-989d-bd6c047daab5",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "32b27ad8-51d9-4767-8b9a-09da5a34f39d": {
    "name": "init",
    "inputs": {
      "n": {
        "type": "number"
      },
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a[]": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "create an array of size \`n\` filled with value \`v\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "32b27ad8-51d9-4767-8b9a-09da5a34f39d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "9741cb34-bc83-4ebb-a854-edbe9eb3468f": {
    "name": "index of",
    "inputs": {
      "a[]": {
        "type": "<A>[]"
      },
      "a": {
        "type": "<A>"
      }
    },
    "outputs": {
      "i": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "find index \`i\` of the element \`a\` on array \`a[]\` or -1 if not found",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "9741cb34-bc83-4ebb-a854-edbe9eb3468f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "609ec474-cd6b-4646-b9b9-5ef4bbb378a7": {
    "name": "fill",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "value": {
        "type": "<A>"
      },
      "start": {
        "type": "number"
      },
      "end": {
        "type": "number"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "fill array \`a\` from \`start\` to \`end\` with \`value\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "609ec474-cd6b-4646-b9b9-5ef4bbb378a7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "f57f5318-f26f-4b9f-b9e2-dcc022ad7728": {
    "name": "concat",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "b": {
        "type": "<B>[]"
      }
    },
    "outputs": {
      "ab": {
        "type": "(<A>|<B>)[]"
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "concatenate arrays \`a\` and \`b\` into a single one",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "79f01345-4ed7-47e2-8882-fa3bd282c98a": {
    "name": "at",
    "inputs": {
      "a": {
        "type": "<A>[]",
        "metadata": {
          "description": "array"
        }
      },
      "i": {
        "type": "number",
        "metadata": {
          "description": "index"
        }
      }
    },
    "outputs": {
      "a[i]": {
        "type": "<A>",
        "metadata": {
          "description": "\$a[i] = \$a[\$i]"
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "\`a\` element at position \`i\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc": {
    "name": "append",
    "inputs": {
      "a": {
        "type": "<A>[]"
      },
      "b": {
        "type": "<A>"
      }
    },
    "outputs": {
      "a": {
        "type": "<A>[]"
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "append element \`b\` to an array \`a\`",
      "tags": [
        "f",
        "array"
      ]
    },
    "id": "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "fa94b179-00e3-4ed1-814e-7938324a833f": {
    "name": "subtract",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a - b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "minus",
      "description": "subtract \`b\` from \`a\`",
      "tags": [
        "f",
        "arithmetic"
      ]
    },
    "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "c5c05c85-f4c1-4b67-ab85-08b61fe67531": {
    "name": "remainder",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a % b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "percent",
      "description": "remainder of \`a\` divided by \`b\`",
      "tags": [
        "f",
        "arithmetic"
      ]
    },
    "id": "c5c05c85-f4c1-4b67-ab85-08b61fe67531",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "872be100-f4dc-4246-8eea-6e3da31137b7": {
    "name": "multiply",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a × b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "x",
      "description": "multiply \`a\` and \`b\`",
      "tags": [
        "f",
        "arithmetic"
      ]
    },
    "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "158d85eb-28b8-4355-b637-28a7ec751233": {
    "name": "divide",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a ÷ b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "divide",
      "description": "divide \`a\` by \`b\`",
      "tags": [
        "f",
        "arithmetic"
      ]
    },
    "id": "158d85eb-28b8-4355-b637-28a7ec751233",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "6fe452f2-2ec1-4ee2-887d-751c3697e6bf": {
    "name": "add",
    "inputs": {
      "a": {
        "type": "number"
      },
      "b": {
        "type": "number"
      }
    },
    "outputs": {
      "a + b": {
        "type": "number"
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "add \`a\` and \`b\`",
      "tags": [
        "f",
        "arithmetic"
      ]
    },
    "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ba0b8e9e-9d8a-4e83-8be3-04e95129e769": {
    "name": "stringify",
    "inputs": {
      "json": {
        "type": "any"
      },
      "space": {
        "type": "string|number"
      }
    },
    "outputs": {
      "string": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "string",
      "description": "converts a JSON value to a string",
      "tags": [
        "f",
        "JSON"
      ]
    },
    "id": "ba0b8e9e-9d8a-4e83-8be3-04e95129e769",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "ee184ea6-3c80-4119-919e-290620aafab0": {
    "name": "stringify",
    "inputs": {
      "json": {
        "type": "any"
      }
    },
    "outputs": {
      "string": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "string",
      "description": "converts a JSON value to a string",
      "tags": [
        "f",
        "JSON"
      ]
    },
    "id": "ee184ea6-3c80-4119-919e-290620aafab0",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "563e92be-ad5e-4a61-a718-9249c3eac51d": {
    "name": "parse json",
    "inputs": {
      "string": {
        "type": "string"
      }
    },
    "outputs": {
      "json": {
        "type": "any"
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "converts a JSON string into a data",
      "tags": [
        "f",
        "JSON"
      ]
    },
    "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "58900411-ccc3-4c5a-86df-86efe6b7e30e": {
    "name": "format",
    "inputs": {
      "json": {
        "type": "any"
      },
      "space": {
        "type": "string|number",
        "optional": false,
        "metadata": {
          "examples": [
            "0",
            "2"
          ]
        }
      }
    },
    "outputs": {
      "string": {
        "type": "string"
      }
    },
    "metadata": {
      "icon": "string",
      "description": "converts a JSON value to a string",
      "tags": [
        "f",
        "JSON"
      ]
    },
    "id": "58900411-ccc3-4c5a-86df-86efe6b7e30e",
    "base": true,
    "type": "\`U\`",
    "system": true
  },
  "984c4a44-86c7-464c-ad48-4759598c3be3": {
    "name": "true",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "true"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "check-circle",
      "description": "output true",
      "tags": [
        "core",
        "value"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "true": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b4d20f6f-32dc-4d04-97d6-69518976bdea": {
    "name": "false",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "false"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "x-circle",
      "description": "output false",
      "tags": [
        "core",
        "value"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "false": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4e54703e-08bc-4537-ba5d-5e697a02be1f": {
    "name": "merge ab",
    "units": {
      "deepmerge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f"
      },
      "tag0": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'b'"
          }
        }
      },
      "tag1": {
        "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
        "input": {
          "k": {
            "constant": true,
            "data": "'a'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "deepmerge": {
          "input": {
            "b": true
          }
        },
        "tag0": {
          "output": {
            "kv": true
          }
        }
      },
      "1": {
        "deepmerge": {
          "input": {
            "a": true
          }
        },
        "tag1": {
          "output": {
            "kv": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "create object \`ab\` with values \`a\` and \`b\`",
      "tags": [
        "core",
        "util"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "tag1",
            "pinId": "v"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "tag0",
            "pinId": "v"
          }
        }
      }
    },
    "outputs": {
      "ab": {
        "plug": {
          "0": {
            "unitId": "deepmerge",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "4e54703e-08bc-4537-ba5d-5e697a02be1f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "40555189-33ef-48b6-af8a-5ab4805b9a1f": {
    "name": "get a b",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'a'"
          }
        }
      },
      "get0": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": true,
            "data": "'b'"
          }
        }
      }
    },
    "merges": {
      "0": {
        "get0": {
          "input": {
            "obj": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get \`a\` and \`b\` from object \`ab\`",
      "tags": [
        "core",
        "util"
      ]
    },
    "inputs": {
      "ab": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "get0",
            "pinId": "value"
          }
        }
      }
    },
    "id": "40555189-33ef-48b6-af8a-5ab4805b9a1f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "568638fd-0338-4ad3-a76f-8581c7b3aa44": {
    "type": "\`U\`&\`G\`",
    "name": "merge input",
    "units": {
      "foreachkeyvalue": {
        "id": "47771360-640a-11ea-8393-d32f60372182",
        "input": {
          "obj": {}
        },
        "output": {
          "key": {},
          "value": {},
          "test": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -50,
            "y": -1
          }
        }
      },
      "setinput": {
        "id": "43b43afd-9e7d-44ba-aef7-6e9db4ed8744",
        "input": {
          "unit": {},
          "name": {},
          "data": {}
        },
        "output": {
          "unit": {}
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": 0
          }
        }
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreachkeyvalue": {
          "output": {
            "value": true
          }
        },
        "setinput": {
          "input": {
            "data": true
          }
        }
      },
      "1": {
        "foreachkeyvalue": {
          "output": {
            "key": true
          }
        },
        "setinput": {
          "input": {
            "name": true
          }
        }
      },
      "2": {
        "foreachkeyvalue": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "setinput": {
          "input": {
            "unit": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        }
      },
      "4": {
        "setinput": {
          "output": {
            "unit": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "foreachkeyvalue",
            "pinId": "obj"
          }
        },
        "ref": false
      },
      "unit": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "object-set",
      "description": "set each \`unit\` key value input",
      "tags": [
        "core",
        "unit"
      ]
    },
    "id": "568638fd-0338-4ad3-a76f-8581c7b3aa44",
    "system": true
  },
  "2c3c4a2c-7300-4050-a017-ba25e42497b5": {
    "name": "throttle",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "memory": {
        "id": "49e11645-c25d-4bf7-923d-56817f67b686"
      },
      "memory0": {
        "id": "49e11645-c25d-4bf7-923d-56817f67b686"
      },
      "interval": {
        "id": "42a8023a-0581-4e92-968a-b31584d0ed75",
        "input": {
          "done": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "interval": {
          "output": {
            "ms": true
          }
        }
      },
      "1": {
        "memory": {
          "output": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "memory0": {
          "input": {
            "a": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "alarm-clock",
      "description": "output element from stream every \`ms\` milliseconds",
      "tags": [
        "core",
        "time"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "memory",
            "pinId": "a"
          }
        }
      },
      "ms": {
        "plug": {
          "0": {
            "unitId": "interval",
            "pinId": "ms"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "memory0",
            "pinId": "a"
          }
        }
      }
    },
    "id": "2c3c4a2c-7300-4050-a017-ba25e42497b5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "66037c2f-d194-478b-866b-b2efb3027de1": {
    "name": "push delay",
    "units": {
      "delay": {
        "id": "586fb5b8-4129-4ca1-b0c4-1009485bed95",
        "input": {
          "ms": {},
          "a": {}
        },
        "output": {
          "a": {}
        }
      },
      "memory": {
        "id": "49e11645-c25d-4bf7-923d-56817f67b686",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "memory": {
          "output": {
            "a": true
          }
        },
        "delay": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "ms": {
        "plug": {
          "0": {
            "unitId": "delay",
            "pinId": "ms"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "memory",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "delay",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "alarm-clock",
      "description": "memory + delay",
      "tags": [
        "core",
        "time"
      ]
    },
    "id": "66037c2f-d194-478b-866b-b2efb3027de1",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8cd6c706-d1d4-11ea-92e1-47577abb9ccf": {
    "name": "delay push",
    "units": {
      "delay": {
        "id": "586fb5b8-4129-4ca1-b0c4-1009485bed95",
        "input": {
          "ms": {
            "constant": false
          },
          "a": {
            "constant": false
          }
        },
        "output": {
          "a": {}
        }
      },
      "push": {
        "id": "49e11645-c25d-4bf7-923d-56817f67b686",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "push": {
          "input": {
            "a": true
          }
        },
        "delay": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "ms": {
        "plug": {
          "0": {
            "unitId": "delay",
            "pinId": "ms"
          }
        },
        "metadata": {
          "examples": [
            "1000",
            "100"
          ]
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "delay",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "push",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "alarm-clock",
      "description": "delay + memory",
      "tags": [
        "core",
        "time"
      ]
    },
    "id": "8cd6c706-d1d4-11ea-92e1-47577abb9ccf",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "586fb5b8-4129-4ca1-b0c4-1009485bed95": {
    "name": "delay",
    "units": {
      "timer": {
        "id": "95076599-0f2f-46b6-a9e0-b4cbfdb8dcc9"
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      }
    },
    "merges": {
      "0": {
        "timer": {
          "output": {
            "ms": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "ms": {
        "plug": {
          "0": {
            "unitId": "timer",
            "pinId": "ms"
          }
        },
        "metadata": {
          "examples": [
            "500",
            "1000"
          ]
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "alarm-clock",
      "description": "output after \`ms\` milliseconds",
      "tags": [
        "core",
        "time"
      ]
    },
    "id": "586fb5b8-4129-4ca1-b0c4-1009485bed95",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e55c58b3-8653-4481-b5c9-2a75fce6365a": {
    "name": "debounce",
    "units": {
      "delay": {
        "id": "586fb5b8-4129-4ca1-b0c4-1009485bed95"
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "memory": {
        "id": "49e11645-c25d-4bf7-923d-56817f67b686"
      }
    },
    "merges": {
      "0": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "memory": {
          "output": {
            "a": true
          }
        },
        "delay": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "delay": {
          "input": {
            "ms": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "alarm-clock",
      "description": "output only after stream has stopped for \`ms\` milliseconds",
      "tags": [
        "core",
        "time"
      ]
    },
    "inputs": {
      "ms": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "memory",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "delay",
            "pinId": "a"
          }
        }
      }
    },
    "id": "e55c58b3-8653-4481-b5c9-2a75fce6365a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5c9f4a0a-e675-48db-b6c0-5ac6914cdae0": {
    "name": "tail",
    "units": {
      "behead": {
        "id": "3e20a18c-60a3-40cd-bbee-f2f9e289b14d",
        "output": {
          "head": {
            "ignored": true
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "axe",
      "description": "output \`tail\` of string \`a\`",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "behead",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "tail": {
        "plug": {
          "0": {
            "unitId": "behead",
            "pinId": "tail"
          }
        }
      }
    },
    "id": "5c9f4a0a-e675-48db-b6c0-5ac6914cdae0",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2006f85c-a05c-4c42-9270-591880969578": {
    "name": "remove whitespace",
    "units": {
      "replace": {
        "id": "af5469c4-a09e-4b22-8133-a21e721e7639",
        "input": {
          "regex": {
            "constant": true,
            "data": "' '"
          },
          "with": {
            "constant": true,
            "data": "''"
          },
          "flags": {
            "constant": true,
            "data": "''"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "x",
      "description": "remove all string \`str\` whitespace",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "replace",
            "pinId": "str"
          }
        }
      }
    },
    "outputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "replace",
            "pinId": "str"
          }
        }
      }
    },
    "id": "2006f85c-a05c-4c42-9270-591880969578",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1a7665a2-2af0-11eb-9fdb-4bdf5feec91c": {
    "name": "number to hex",
    "units": {
      "numbertostring": {
        "id": "f712793d-8ee9-4805-9d4a-8c210cae667a",
        "input": {
          "n": {},
          "radix": {
            "constant": true,
            "data": "16"
          }
        },
        "output": {
          "str": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "numbertostring",
            "pinId": "n"
          }
        }
      }
    },
    "outputs": {
      "hex": {
        "plug": {
          "0": {
            "unitId": "numbertostring",
            "pinId": "str"
          }
        }
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a number to its hexadecimal string",
      "tags": [
        "core",
        "string"
      ]
    },
    "id": "1a7665a2-2af0-11eb-9fdb-4bdf5feec91c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "a6ab9464-303a-48a4-8b5f-0cd515ab7b8f": {
    "name": "number to decimal",
    "units": {
      "numbertostring": {
        "id": "f712793d-8ee9-4805-9d4a-8c210cae667a",
        "input": {
          "n": {},
          "radix": {
            "constant": true,
            "data": "10"
          }
        },
        "output": {
          "str": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "numbertostring",
            "pinId": "n"
          }
        }
      }
    },
    "outputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "numbertostring",
            "pinId": "str"
          }
        }
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a number to its decimal string",
      "tags": [
        "core",
        "string"
      ]
    },
    "id": "a6ab9464-303a-48a4-8b5f-0cd515ab7b8f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9cab124a-b40d-4614-b032-20b0209e90e3": {
    "name": "n string builder from",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {},
        "output": {
          "final": {
            "ignored": false
          }
        }
      },
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6"
      },
      "length": {
        "id": "1b8ce255-0bc7-4656-bafa-3dc86af44126"
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "local": {
            "ignored": false
          },
          "current": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "concat": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "local": true
          }
        },
        "length": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "loop": {
          "input": {
            "test": true
          }
        },
        "lessthan": {
          "output": {
            "a < b": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "concat": {
          "output": {
            "ab": true
          }
        }
      },
      "4": {
        "lessthan": {
          "input": {
            "a": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        }
      },
      "5": {
        "lessthan": {
          "input": {
            "b": true
          }
        },
        "looprepeat": {
          "output": {
            "local": true
          }
        }
      }
    },
    "metadata": {
      "icon": "string",
      "description": "build a list of size n",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "from": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "b"
          }
        }
      },
      "n": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      }
    },
    "id": "9cab124a-b40d-4614-b032-20b0209e90e3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c0418d25-9739-4957-91f5-a835e5d818ec": {
    "type": "\`U\`&\`G\`",
    "name": "join path",
    "units": {
      "concat3": {
        "id": "bb28c9d9-0afd-4ef2-8c5b-41815ea65bf1",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "\\"/\\""
          },
          "c": {}
        },
        "output": {
          "abc": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "concat3",
            "pinId": "c"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "concat3",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "ab": {
        "plug": {
          "0": {
            "unitId": "concat3",
            "pinId": "abc"
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "a + / + b",
      "tags": [
        "core",
        "string"
      ]
    },
    "id": "c0418d25-9739-4957-91f5-a835e5d818ec",
    "system": true
  },
  "5f5b12b5-c3b9-460e-a84b-3db4f5d9c483": {
    "name": "is not empty",
    "units": {
      "isempty": {
        "id": "5b497ef5-eff7-45e4-854b-d02da5b89e90"
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "isempty": {
          "output": {
            "empty": true
          }
        },
        "not": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether array \`a\` is not empty",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "isempty",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "!empty": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "!a"
          }
        }
      }
    },
    "id": "5f5b12b5-c3b9-460e-a84b-3db4f5d9c483",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5b497ef5-eff7-45e4-854b-d02da5b89e90": {
    "name": "is empty",
    "units": {
      "length": {
        "id": "1b8ce255-0bc7-4656-bafa-3dc86af44126"
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "equals": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether array \`a\` is empty",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "empty": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b"
          }
        }
      }
    },
    "id": "5b497ef5-eff7-45e4-854b-d02da5b89e90",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7c8e8a47-2225-4716-986e-1cb2af3ed3b3": {
    "name": "empty string",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "\\"\\""
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "string",
      "description": "output an empty string",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "\\"\\"": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "id": "7c8e8a47-2225-4716-986e-1cb2af3ed3b3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "306fe446-a495-4ae3-a835-34f1468e92fe": {
    "name": "cut",
    "units": {
      "slice": {
        "id": "c8a4cd44-a554-4901-8a33-a8adbff63d03"
      },
      "slice0": {
        "id": "c8a4cd44-a554-4901-8a33-a8adbff63d03",
        "input": {
          "begin": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "length": {
        "id": "1b8ce255-0bc7-4656-bafa-3dc86af44126"
      }
    },
    "merges": {
      "0": {
        "slice": {
          "input": {
            "a": true
          }
        },
        "slice0": {
          "input": {
            "a": true
          }
        },
        "length": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "slice": {
          "input": {
            "begin": true
          }
        },
        "slice0": {
          "input": {
            "end": true
          }
        }
      },
      "2": {
        "slice": {
          "input": {
            "end": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        }
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "split string \`a\` \`at\` index",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "at": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "second": {
        "plug": {
          "0": {
            "unitId": "slice",
            "pinId": "a"
          }
        }
      },
      "first": {
        "plug": {
          "0": {
            "unitId": "slice0",
            "pinId": "a"
          }
        }
      }
    },
    "id": "306fe446-a495-4ae3-a835-34f1468e92fe",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "bb28c9d9-0afd-4ef2-8c5b-41815ea65bf1": {
    "name": "concat 3",
    "units": {
      "concat": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6"
      },
      "concat0": {
        "id": "779e538c-b0b9-477e-a986-30ee3abe6fe6"
      }
    },
    "merges": {
      "0": {
        "concat": {
          "input": {
            "b": true
          }
        },
        "concat0": {
          "output": {
            "ab": true
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "concat \`a\`, \`b\` and \`c\`",
      "tags": [
        "core",
        "string"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "concat0",
            "pinId": "a"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "concat0",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "abc": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "bb28c9d9-0afd-4ef2-8c5b-41815ea65bf1",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1de47760-fc93-4ee0-8cdb-f5338a01d4cd": {
    "name": "value equals or default",
    "units": {
      "propequal": {
        "id": "9df84140-dd90-48b3-a6a7-0651c8b5bfd7"
      },
      "if3": {
        "id": "13a16a8a-5dc6-11ea-a3d4-9bda49772976"
      },
      "haskey": {
        "id": "ad2ae8b9-9674-4b22-bed4-4458e0030b1a"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      }
    },
    "merges": {
      "0": {
        "propequal": {
          "output": {
            "equal": true
          }
        },
        "ifnot": {
          "output": {
            "a if not b": true
          }
        }
      },
      "1": {
        "if3": {
          "input": {
            "test": true
          }
        },
        "haskey": {
          "output": {
            "has": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "propequal": {
          "input": {
            "value": true
          }
        },
        "if3": {
          "output": {
            "c": true
          }
        }
      },
      "4": {
        "if3": {
          "output": {
            "b": true
          }
        },
        "propequal": {
          "input": {
            "key": true
          }
        }
      },
      "5": {
        "propequal": {
          "input": {
            "obj": true
          }
        },
        "if3": {
          "output": {
            "a": true
          }
        }
      },
      "6": {
        "if3": {
          "input": {
            "a": true
          }
        },
        "haskey": {
          "input": {
            "obj": true
          }
        }
      },
      "7": {
        "if3": {
          "input": {
            "b": true
          }
        },
        "haskey": {
          "input": {
            "key": true
          }
        }
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "check whether an object \`o\` has key-value \`k\` \`v\` or \`default\` if key is not present",
      "tags": [
        "core",
        "relation"
      ]
    },
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "if3",
            "pinId": "c"
          }
        },
        "functional": true
      },
      "key": {
        "plug": {
          "0": {
            "mergeId": "7"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "mergeId": "6"
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "equal": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "id": "1de47760-fc93-4ee0-8cdb-f5338a01d4cd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9df84140-dd90-48b3-a6a7-0651c8b5bfd7": {
    "name": "value equals",
    "units": {
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "b": {
            "constant": false
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "key": {
            "constant": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "output": {
            "value": true
          }
        },
        "equals": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "check whether an object \`o\` has key-value \`k\` \`v\`",
      "tags": [
        "core",
        "relation"
      ]
    },
    "inputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "b"
          }
        }
      },
      "key": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "key"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "equal": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b"
          }
        }
      }
    },
    "id": "9df84140-dd90-48b3-a6a7-0651c8b5bfd7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4d067752-843a-4c98-b1c4-9ffa29d693b4": {
    "type": "\`U\`&\`G\`",
    "name": "if greater than equal 0",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a if b": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      },
      "greaterthanequal0": {
        "id": "a8d162a8-1c5f-4b7f-abfb-877390ae4354",
        "input": {
          "a": {}
        },
        "output": {
          "a ≥ 0": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "greaterthanequal0": {
          "output": {
            "a ≥ 0": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "greaterthanequal0",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "if",
            "pinId": "a",
            "kind": "input"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b",
            "kind": "output"
          }
        }
      }
    },
    "metadata": {
      "icon": "greater-than-equal",
      "description": "let \`a\` pass if greater than or equal to 0",
      "tags": [
        "core",
        "relation"
      ]
    },
    "id": "4d067752-843a-4c98-b1c4-9ffa29d693b4",
    "system": true
  },
  "0facebfb-2449-430d-8f12-d8fdc5fc04e7": {
    "type": "\`U\`&\`G\`",
    "name": "if greater than 0",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a if b": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      },
      "greaterthan0": {
        "id": "6f4ac2fa-e9bd-4c0e-8bda-75976f3e4e58",
        "input": {
          "a": {}
        },
        "output": {
          "a > 0": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "greaterthan0": {
          "output": {
            "a > 0": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "greaterthan0",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "if",
            "pinId": "a",
            "kind": "input"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b",
            "kind": "output"
          }
        }
      }
    },
    "metadata": {
      "icon": "greater-than",
      "description": "let \`a\` pass if greater than 0",
      "tags": [
        "core",
        "relation"
      ]
    },
    "id": "0facebfb-2449-430d-8f12-d8fdc5fc04e7",
    "system": true
  },
  "9ef9ff5b-6a1c-444b-8fc0-bfebbec6f4fd": {
    "name": "clamp",
    "units": {
      "max": {
        "id": "e857c770-5a98-4f8d-a0e1-b6cb126071ed"
      },
      "min": {
        "id": "4e63c320-f5a5-4f65-982e-632b5adafa29"
      }
    },
    "merges": {
      "0": {
        "min": {
          "output": {
            "min": true
          }
        },
        "max": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "restricts a number to be within a range",
      "tags": [
        "core",
        "relation"
      ]
    },
    "inputs": {
      "max": {
        "plug": {
          "0": {
            "unitId": "min",
            "pinId": "b"
          }
        }
      },
      "min": {
        "plug": {
          "0": {
            "unitId": "max",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "min",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "max",
            "pinId": "max"
          }
        }
      }
    },
    "id": "9ef9ff5b-6a1c-444b-8fc0-bfebbec6f4fd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "26dc57a1-e372-47b0-8d06-1b6cf2056783": {
    "type": "\`U\`&\`G\`",
    "name": "set local",
    "units": {
      "localstorage": {
        "id": "c8f3faa8-09f4-11eb-a3b1-477aa3ec4193",
        "input": {},
        "output": {},
        "metadata": {
          "position": {
            "x": 206,
            "y": -26
          }
        }
      },
      "set": {
        "id": "074ef6f4-a0a1-40f9-95c0-cf0ecc3d420c",
        "input": {
          "obj": {},
          "name": {
            "constant": false
          },
          "data": {}
        },
        "output": {
          "data": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": 152,
            "y": -47
          }
        }
      }
    },
    "merges": {
      "0": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "localstorage": {
          "output": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "name",
            "kind": "input"
          }
        },
        "ref": false
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "data",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "object-set",
      "description": "set local storage property \`name\` to \`data\`",
      "tags": [
        "core",
        "object",
        "local"
      ]
    },
    "id": "26dc57a1-e372-47b0-8d06-1b6cf2056783",
    "system": true
  },
  "ffe53373-f413-45c6-8c14-ac93f7b2f4bf": {
    "type": "\`U\`&\`G\`",
    "name": "get local",
    "units": {
      "localstorage0": {
        "id": "c8f3faa8-09f4-11eb-a3b1-477aa3ec4193",
        "input": {},
        "output": {},
        "metadata": {
          "position": {
            "x": -156,
            "y": 51
          }
        }
      },
      "get": {
        "id": "bc0320e2-2eb8-11eb-a38f-a779bfe81645",
        "input": {
          "obj": {},
          "name": {
            "constant": false
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -203,
            "y": 20
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "localstorage0": {
          "output": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "name",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "get local storage property \`name\`",
      "tags": [
        "core",
        "object",
        "local"
      ]
    },
    "id": "ffe53373-f413-45c6-8c14-ac93f7b2f4bf",
    "system": true
  },
  "5480c89e-31ef-4fdb-b232-60f25b3e36f3": {
    "name": "tag",
    "units": {
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": true,
            "data": "{}"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "tag",
      "description": "create a single entry object with key \`k\` and value \`v\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "k": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "key"
          }
        }
      },
      "v": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value"
          }
        }
      }
    },
    "outputs": {
      "kv": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "id": "5480c89e-31ef-4fdb-b232-60f25b3e36f3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9daf6128-fd26-11ea-8f82-7374faa69acf": {
    "name": "partition",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "test": {
            "ignored": false
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true
          },
          "current": {}
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "value": {}
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {},
          "value": {}
        },
        "output": {
          "obj": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "{}"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "2": {
        "get": {
          "input": {
            "key": true
          }
        },
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "set": {
          "input": {
            "key": true
          }
        }
      },
      "3": {
        "set": {
          "output": {
            "obj": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      },
      "4": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        }
      },
      "5": {
        "get": {
          "output": {
            "value": true
          }
        },
        "set": {
          "input": {
            "value": true
          }
        }
      },
      "6": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "looprepeat": {
          "input": {
            "init": true
          }
        }
      },
      "7": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "loop": {
          "input": {
            "init": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "6"
          }
        },
        "functional": true
      },
      "keys": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "build \`obj\` by getting all \`keys\` from input \`obj\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "9daf6128-fd26-11ea-8f82-7374faa69acf",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "304e98ac-bda1-11ea-b416-9746f024148c": {
    "name": "merge default",
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -125,
              "y": -7
            }
          }
        }
      },
      "default": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 0,
              "y": 37
            }
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "default",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 124,
              "y": -7
            }
          }
        }
      }
    },
    "units": {
      "default": {
        "id": "329920ae-7e91-11ea-988e-1b12488c8b89",
        "input": {
          "a": {},
          "d": {}
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": 96,
                "y": -5
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 47,
            "y": -5
          }
        }
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453",
        "input": {
          "a": {},
          "b": {
            "metadata": {
              "position": {
                "x": -97,
                "y": -5
              }
            }
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -48,
            "y": -5
          }
        }
      }
    },
    "merges": {
      "0": {
        "default": {
          "input": {
            "d": true
          }
        },
        "merge": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "merge": {
          "output": {
            "ab": true
          }
        },
        "default": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge \`a\` and \`default\` if \`a\` is present, \`default\` otherwise",
      "tags": [
        "core",
        "object"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 0,
            "y": 8
          },
          "1": {
            "x": -1,
            "y": -18
          }
        }
      }
    },
    "id": "304e98ac-bda1-11ea-b416-9746f024148c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1f1b065a-937b-4630-be80-54edf795eb19": {
    "name": "merge 4",
    "units": {
      "merge3": {
        "id": "23b844e3-1cef-4ff7-9e2a-bb3ffb613055"
      },
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453"
      }
    },
    "merges": {
      "0": {
        "merge3": {
          "input": {
            "c": true
          }
        },
        "merge": {
          "output": {
            "ab": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge objects \`a\`, \`b\`, \`c\` and \`d\` into \`abcd\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "b"
          }
        },
        "functional": true
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "merge3",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "merge3",
            "pinId": "b"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "abcd": {
        "plug": {
          "0": {
            "unitId": "merge3",
            "pinId": "abc"
          }
        }
      }
    },
    "id": "1f1b065a-937b-4630-be80-54edf795eb19",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "23b844e3-1cef-4ff7-9e2a-bb3ffb613055": {
    "name": "merge 3",
    "units": {
      "merge": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453"
      },
      "merge0": {
        "id": "60bdba6d-c670-430f-be72-6f39cf4e8453"
      }
    },
    "merges": {
      "0": {
        "merge0": {
          "output": {
            "ab": true
          }
        },
        "merge": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "merge objects \`a\`, \`b\` and \`c\` into \`abc\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "merge0",
            "pinId": "a"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "merge0",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "abc": {
        "plug": {
          "0": {
            "unitId": "merge",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "23b844e3-1cef-4ff7-9e2a-bb3ffb613055",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8ea084fc-cffb-4b4a-9314-122e3c72554e": {
    "name": "key count",
    "units": {
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {}
        },
        "output": {
          "keys": {}
        }
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8",
        "input": {
          "a": {}
        },
        "output": {
          "length": {}
        }
      }
    },
    "merges": {
      "0": {
        "length": {
          "input": {
            "a": true
          }
        },
        "keys": {
          "output": {
            "keys": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "count": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "length"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "\`obj\` total key count",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "8ea084fc-cffb-4b4a-9314-122e3c72554e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5db358ae-5975-4a4f-8fa4-ec991624508a": {
    "name": "has keys",
    "units": {
      "reduce": {
        "id": "5cd76a8a-603b-49e1-bda3-09ad217eb108",
        "output": {},
        "input": {
          "init": {
            "constant": true,
            "data": "true"
          }
        }
      },
      "haskey": {
        "id": "ad2ae8b9-9674-4b22-bed4-4458e0030b1a"
      },
      "and": {
        "id": "407640f7-f1c3-4297-a5ce-baff357a6d31"
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "local": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "and": {
          "input": {
            "b": true
          }
        },
        "haskey": {
          "output": {
            "has": true
          }
        }
      },
      "1": {
        "reduce": {
          "output": {
            "local": true
          }
        },
        "and": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "reduce": {
          "output": {
            "a[i]": true
          }
        },
        "haskey": {
          "input": {
            "key": true
          }
        }
      },
      "3": {
        "reduce": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "4": {
        "haskey": {
          "input": {
            "obj": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "5": {
        "reduce": {
          "input": {
            "next": true
          }
        },
        "and": {
          "output": {
            "a and b": true
          }
        }
      }
    },
    "inputs": {
      "keys": {
        "plug": {
          "0": {
            "unitId": "reduce",
            "pinId": "a"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "has": {
        "plug": {
          "0": {
            "unitId": "reduce",
            "pinId": "result"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "check whether \`obj\` has all \`keys\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "5db358ae-5975-4a4f-8fa4-ec991624508a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "aeac1075-e01f-4d22-b01b-9a77cbba504b": {
    "name": "get or default",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c"
      },
      "haskey": {
        "id": "ad2ae8b9-9674-4b22-bed4-4458e0030b1a"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "haskey": {
          "output": {
            "has": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      },
      "2": {
        "get": {
          "input": {
            "key": true
          }
        },
        "if0": {
          "output": {
            "a if b": true
          }
        }
      },
      "3": {
        "get": {
          "output": {
            "value": true
          }
        },
        "ifnot": {
          "output": {
            "a if not b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "if \`key\` in \`obj\`, get its \`value\`, \`default\` otherwise",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "key": {
        "plug": {
          "0": {
            "unitId": "haskey",
            "pinId": "key"
          },
          "1": {
            "unitId": "if0",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          },
          "1": {
            "unitId": "haskey",
            "pinId": "obj"
          }
        },
        "functional": true
      },
      "default": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        }
      }
    },
    "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "034734a1-719b-41af-845f-ea50a4964d52": {
    "type": "\`U\`&\`G\`",
    "name": "get many",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {
            "constant": false
          }
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -40,
                "y": -28
              }
            }
          },
          "final": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": -56,
                "y": -10
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -61,
            "y": 7
          }
        }
      },
      "emptyobject": {
        "id": "dc6e6bc0-081b-11eb-baf7-b7383b70c236",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": -169,
                "y": 32
              }
            }
          }
        },
        "output": {
          "{}": {}
        },
        "metadata": {
          "position": {
            "x": -170,
            "y": 25
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": 61,
                "y": -98
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 39,
                "y": -84
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 124,
                "y": -90
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 35,
            "y": -62
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {},
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 41,
            "y": 38
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 61,
                "y": 53
              }
            }
          }
        },
        "output": {
          "a[i]": {},
          "a": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 28,
                "y": 0
              }
            }
          },
          "i": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 122,
                "y": 40
              }
            }
          },
          "test": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 30,
            "y": -1
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": 126,
            "y": -8
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "emptyobject": {
          "output": {
            "{}": true
          }
        },
        "loop": {
          "input": {
            "init": true
          }
        }
      },
      "2": {
        "set": {
          "output": {
            "obj": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      },
      "3": {
        "set": {
          "input": {
            "obj": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        }
      },
      "4": {
        "set": {
          "input": {
            "key": true
          }
        },
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "get": {
          "input": {
            "key": true
          }
        }
      },
      "5": {
        "looprepeat": {
          "output": {
            "current": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      },
      "6": {
        "set": {
          "input": {
            "value": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "emptyobject",
            "pinId": "any"
          },
          "1": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "keys": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "create new \`obj\` by picking \`keys\` from input \`obj\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "034734a1-719b-41af-845f-ea50a4964d52",
    "system": true
  },
  "8c4f4d5e-2c98-4dfb-aeac-d1e6605a673e": {
    "name": "get if has key",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "haskey": {
        "id": "ad2ae8b9-9674-4b22-bed4-4458e0030b1a"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      },
      "1": {
        "if": {
          "input": {
            "b": true
          }
        },
        "haskey": {
          "output": {
            "has": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "if": {
          "input": {
            "a": true
          }
        },
        "haskey": {
          "input": {
            "obj": true
          }
        }
      },
      "3": {
        "if0": {
          "input": {
            "a": true
          }
        },
        "haskey": {
          "input": {
            "key": true
          }
        }
      },
      "4": {
        "if0": {
          "output": {
            "a if b": true
          }
        },
        "get": {
          "input": {
            "key": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "output get if key is present",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "key": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "functional": true
      },
      "obj": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      },
      "has": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "id": "8c4f4d5e-2c98-4dfb-aeac-d1e6605a673e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "47771360-640a-11ea-8393-d32f60372182": {
    "name": "for each key value",
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": false
          }
        }
      },
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754"
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c"
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "local": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "keys": {
          "output": {
            "keys": true
          }
        }
      },
      "1": {
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "foreach": {
          "output": {
            "test": true
          }
        }
      },
      "2": {
        "keys": {
          "input": {
            "obj": true
          }
        },
        "looprepeat": {
          "input": {
            "init": true
          }
        }
      },
      "3": {
        "looprepeat": {
          "output": {
            "current": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      },
      "4": {
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "get": {
          "input": {
            "key": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "key": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "output every key value pair of \`obj\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "47771360-640a-11ea-8393-d32f60372182",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c20eae57-35d5-40ce-a42c-42f6bae42ae6": {
    "name": "flip object",
    "units": {
      "map": {
        "id": "1c68d1e5-9170-417d-bfc8-fb7f7f12e714",
        "input": {
          "b[i]": {},
          "a": {}
        },
        "output": {
          "a[i]": {},
          "b": {},
          "test": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -57,
                "y": -1
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -8,
            "y": -1
          }
        }
      },
      "fromentries": {
        "id": "ded32513-925d-4b37-924d-c85387c08ce9",
        "input": {
          "entries": {}
        },
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": -142,
                "y": 70
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -96,
            "y": 58
          }
        }
      },
      "swap": {
        "id": "706a0082-1dce-43d5-b629-9b6f8189e45d",
        "input": {
          "a": {},
          "i": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 0
            },
            "metadata": {
              "position": {
                "x": 139,
                "y": -19
              }
            }
          },
          "j": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 1
            },
            "metadata": {
              "position": {
                "x": 139,
                "y": 16
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 93,
            "y": -2
          }
        }
      },
      "entries": {
        "id": "75ef6bb6-f7f1-4d48-a16d-2c04e05b14cf",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -144,
                "y": -70
              }
            }
          }
        },
        "output": {
          "entries": {}
        },
        "metadata": {
          "position": {
            "x": -97,
            "y": -58
          }
        }
      }
    },
    "merges": {
      "0": {
        "fromentries": {
          "input": {
            "entries": true
          }
        },
        "map": {
          "output": {
            "b": true
          }
        }
      },
      "1": {
        "map": {
          "input": {
            "a": true
          }
        },
        "entries": {
          "output": {
            "entries": true
          }
        }
      },
      "2": {
        "map": {
          "input": {
            "b[i]": true
          }
        },
        "swap": {
          "output": {
            "a": true
          }
        }
      },
      "3": {
        "swap": {
          "input": {
            "a": true
          }
        },
        "map": {
          "output": {
            "a[i]": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "entries",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "fromentries",
            "pinId": "obj",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "flip object \`obj\` key-values",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "c20eae57-35d5-40ce-a42c-42f6bae42ae6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "dc6e6bc0-081b-11eb-baf7-b7383b70c236": {
    "name": "empty object",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "{}"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "brackets-curly",
      "description": "output an empty object",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "{}": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "id": "dc6e6bc0-081b-11eb-baf7-b7383b70c236",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7f348adc-e4f0-11ea-b8d1-0ba0ed3f34fe": {
    "name": "delete path",
    "units": {
      "propordefault": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "default": {
            "constant": true,
            "data": "{}"
          }
        }
      },
      "head": {
        "id": "e9831075-2e62-43a4-84af-0653f7e707a9"
      },
      "dissocpath": {
        "id": "7f348adc-e4f0-11ea-b8d1-0ba0ed3f34fe"
      },
      "lengthgt": {
        "id": "603ebe2e-5329-446d-b422-78f3201ddd7a",
        "input": {
          "b": {
            "constant": true,
            "data": "1"
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "obj": {}
        }
      },
      "delete": {
        "id": "664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "obj": {}
        }
      },
      "lengthequals": {
        "id": "175c0cc6-1801-4b5d-9980-e780c10ea745",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "1"
          }
        },
        "output": {
          "equals": {}
        }
      },
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "a": {},
          "i": {
            "constant": true,
            "data": "0"
          }
        },
        "output": {
          "a[i]": {}
        }
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if2": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if3": {
        "id": "175c0cc6-1801-4b5d-9980-e780c10ea745",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "0"
          }
        },
        "output": {
          "equals": {}
        }
      },
      "if4": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "lengthgt": {
          "output": {
            "test": true
          }
        },
        "if1": {
          "input": {
            "b": true
          }
        },
        "if2": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "head": {
          "input": {
            "a": true
          }
        },
        "if1": {
          "output": {
            "a if b": true
          }
        }
      },
      "2": {
        "propordefault": {
          "input": {
            "key": true
          }
        },
        "head": {
          "output": {
            "head": true
          }
        },
        "set": {
          "input": {
            "key": true
          }
        }
      },
      "3": {
        "dissocpath": {
          "input": {
            "obj": true
          }
        },
        "propordefault": {
          "output": {
            "value": true
          }
        }
      },
      "mchoroggl": {
        "propordefault": {
          "input": {
            "obj": true
          }
        },
        "set": {
          "input": {
            "obj": true
          }
        },
        "if2": {
          "output": {
            "a if b": true
          }
        }
      },
      "ikungyvz": {
        "lengthequals": {
          "output": {
            "equals": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        }
      },
      "axtvhx": {
        "at": {
          "input": {
            "a": true
          }
        },
        "if": {
          "output": {
            "a if b": true
          }
        }
      },
      "zigdwon": {
        "delete": {
          "input": {
            "key": true
          }
        },
        "at": {
          "output": {
            "a[i]": true
          }
        }
      },
      "qwlgwfuqb": {
        "delete": {
          "input": {
            "obj": true
          }
        },
        "if0": {
          "output": {
            "a if b": true
          }
        }
      },
      "wyrvlnzoh": {
        "dissocpath": {
          "output": {
            "result": true
          }
        },
        "set": {
          "input": {
            "value": true
          }
        }
      },
      "ejbegdofk": {
        "dissocpath": {
          "input": {
            "path": true
          }
        },
        "head": {
          "output": {
            "a": true
          }
        }
      },
      "rocsslaa": {
        "if4": {
          "input": {
            "b": true
          }
        },
        "if3": {
          "output": {
            "equals": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "get value of \`obj\` at \`path\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "inputs": {
      "path": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a"
          },
          "1": {
            "unitId": "lengthgt",
            "pinId": "a"
          },
          "2": {
            "unitId": "lengthequals",
            "pinId": "a"
          },
          "3": {
            "unitId": "if",
            "pinId": "a"
          },
          "4": {
            "unitId": "if3",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "if2",
            "pinId": "a"
          },
          "1": {
            "unitId": "if0",
            "pinId": "a"
          },
          "2": {
            "unitId": "if4",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "result": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          },
          "1": {
            "unitId": "delete",
            "pinId": "obj"
          },
          "2": {
            "unitId": "if4",
            "pinId": "a if b"
          }
        }
      }
    },
    "id": "7f348adc-e4f0-11ea-b8d1-0ba0ed3f34fe",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "474d900a-fd28-11ea-b59c-670afe58a912": {
    "name": "delete all",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "test": {
            "ignored": false
          }
        }
      },
      "delete": {
        "id": "664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "delete": {
          "input": {
            "key": true
          }
        },
        "foreach": {
          "output": {
            "a[i]": true
          }
        }
      },
      "2": {
        "delete": {
          "output": {
            "obj": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      },
      "3": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "delete": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "keys": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "delete all \`keys\` from \`obj\`",
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "474d900a-fd28-11ea-b59c-670afe58a912",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "852a1b1e-2ee3-4802-8cfb-e2093e35aa09": {
    "type": "\`U\`&\`G\`",
    "name": "deep get or default",
    "units": {
      "deepgetkey": {
        "id": "544571e6-f01b-40a3-8191-d077319958b4",
        "input": {
          "key": {},
          "obj": {},
          "path": {}
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": -160,
                "y": -50
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -109,
            "y": -48
          }
        }
      },
      "if3": {
        "id": "13a16a8a-5dc6-11ea-a3d4-9bda49772976",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 9,
                "y": -77
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": 35,
                "y": -53
              }
            }
          },
          "c": {
            "metadata": {
              "position": {
                "x": -38,
                "y": 5
              }
            }
          },
          "test": {}
        },
        "output": {
          "a": {},
          "b": {},
          "c": {}
        },
        "metadata": {
          "position": {
            "x": -11,
            "y": -34
          }
        }
      },
      "deephaskey": {
        "id": "740fde5d-8de1-448f-87d9-2ddd397e9c4b",
        "metadata": {
          "position": {
            "x": 108,
            "y": -16
          }
        },
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": 142,
                "y": -50
              }
            }
          },
          "path": {
            "metadata": {
              "position": {
                "x": 159,
                "y": -23
              }
            }
          },
          "key": {
            "metadata": {
              "position": {
                "x": 152,
                "y": 6
              }
            }
          }
        }
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 17,
                "y": 80
              }
            }
          },
          "b": {}
        },
        "output": {
          "a if not b": {
            "metadata": {
              "position": {
                "x": 97,
                "y": 79
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 56,
            "y": 52
          }
        }
      }
    },
    "merges": {
      "0": {
        "if3": {
          "input": {
            "test": true
          }
        },
        "deephaskey": {
          "output": {
            "has": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "deepgetkey": {
          "input": {
            "path": true
          }
        },
        "if3": {
          "output": {
            "b": true
          }
        }
      },
      "2": {
        "deepgetkey": {
          "input": {
            "obj": true
          }
        },
        "if3": {
          "output": {
            "a": true
          }
        }
      },
      "3": {
        "deepgetkey": {
          "input": {
            "key": true
          }
        },
        "if3": {
          "output": {
            "c": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "if3",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "deephaskey",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 13,
                "y": -102
              }
            },
            "1": {
              "ext": {
                "x": 154,
                "y": -72
              }
            }
          }
        }
      },
      "key": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "deephaskey",
            "pinId": "key",
            "kind": "input"
          },
          "1": {
            "unitId": "if3",
            "pinId": "c",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 171,
                "y": 20
              }
            },
            "1": {
              "ext": {
                "x": -49,
                "y": 28
              }
            }
          }
        }
      },
      "path": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "deephaskey",
            "pinId": "path",
            "kind": "input"
          },
          "1": {
            "unitId": "if3",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 184,
                "y": -29
              }
            },
            "1": {
              "ext": {
                "x": 49,
                "y": -73
              }
            }
          }
        }
      },
      "default": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 7,
                "y": 102
              }
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "deepgetkey",
            "pinId": "value",
            "kind": "output"
          },
          "1": {
            "unitId": "ifnot",
            "pinId": "a if not b",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -184,
                "y": -52
              }
            },
            "1": {
              "ext": {
                "x": 106,
                "y": 101
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "if \`key\` in \`obj\` at \`path\`, get its \`value\`, \`default\` otherwise",
      "position": {
        "merge": {
          "0": {
            "x": 48,
            "y": -3
          },
          "1": {
            "x": -66,
            "y": -23
          },
          "2": {
            "x": -58,
            "y": -63
          },
          "3": {
            "x": -61,
            "y": -44
          }
        }
      },
      "tags": [
        "core",
        "object"
      ]
    },
    "id": "852a1b1e-2ee3-4802-8cfb-e2093e35aa09",
    "system": true
  },
  "544571e6-f01b-40a3-8191-d077319958b4": {
    "type": "\`U\`&\`G\`",
    "name": "deep get key",
    "units": {
      "deepget": {
        "id": "2ff102a7-b469-461f-a3b1-a61b81c1b325",
        "input": {
          "path": {},
          "obj": {
            "metadata": {
              "position": {
                "x": 96,
                "y": -18
              }
            }
          }
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 96,
                "y": 18
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 0
          }
        }
      },
      "append": {
        "id": "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -96,
                "y": -18
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -96,
                "y": 18
              }
            }
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      }
    },
    "inputs": {
      "functional": true,
      "key": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -112,
                "y": 35
              }
            }
          }
        }
      },
      "obj": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "deepget",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 112,
                "y": -35
              }
            }
          }
        }
      },
      "path": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -112,
                "y": -35
              }
            }
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "deepget",
            "pinId": "value",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 112,
                "y": 35
              }
            }
          }
        }
      }
    },
    "merges": {
      "0": {
        "append": {
          "output": {
            "a": true
          }
        },
        "deepget": {
          "input": {
            "path": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "get \`obj\` property \`key\` at \`path\`",
      "tags": [
        "core",
        "object"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "id": "544571e6-f01b-40a3-8191-d077319958b4",
    "system": true
  },
  "fb8d58cc-f1a0-11ea-b163-9321d9d8dd29": {
    "name": "string to decimal",
    "units": {
      "stringtoint": {
        "id": "8cd29108-95cd-4217-9721-11f7c7c1131e",
        "input": {
          "str": {},
          "radix": {
            "constant": true,
            "data": "10"
          }
        },
        "output": {
          "n": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "str": {
        "plug": {
          "0": {
            "unitId": "stringtoint",
            "pinId": "str"
          }
        }
      }
    },
    "outputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "stringtoint",
            "pinId": "n"
          }
        }
      }
    },
    "metadata": {
      "icon": "tilde",
      "description": "convert a number into a decimal",
      "tags": [
        "core",
        "number"
      ]
    },
    "id": "fb8d58cc-f1a0-11ea-b163-9321d9d8dd29",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4d280c6a-3c33-42df-b0e3-ee643fad4c85": {
    "name": "includes",
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "indexof",
            "pinId": "a"
          }
        }
      },
      "a[]": {
        "plug": {
          "0": {
            "unitId": "indexof",
            "pinId": "a[]"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "greaterthan",
            "pinId": "a > b"
          }
        }
      }
    },
    "units": {
      "indexof": {
        "id": "26b06e21-798c-4bc4-96e1-12a4351c083d",
        "input": {
          "a[]": {},
          "a": {}
        },
        "output": {
          "i": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": -57
          }
        }
      },
      "greaterthan": {
        "id": "1651ce6b-4db0-4787-9edf-f770b72d253c",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "-1"
          }
        },
        "output": {
          "a > b": {}
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": -57
          }
        }
      },
      "includes": {
        "id": "8783e7de-6cde-11eb-bd74-574fd9c8b6aa",
        "input": {
          "a[]": {},
          "a": {}
        },
        "output": {
          "found": {}
        },
        "metadata": {
          "position": {
            "x": -2,
            "y": 113
          }
        }
      }
    },
    "merges": {
      "0": {
        "greaterthan": {
          "input": {
            "a": true
          }
        },
        "indexof": {
          "output": {
            "i": true
          }
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "checks whether an element \`a\` is present in array \`a[]\`",
      "tags": [
        "core",
        "method",
        "array"
      ]
    },
    "component": {
      "children": []
    },
    "id": "4d280c6a-3c33-42df-b0e3-ee643fad4c85",
    "system": true
  },
  "17f39380-0732-41b1-bb5e-e90cc703de82": {
    "type": "\`U\`&\`G\`",
    "name": "web socket remote share graph",
    "units": {
      "remotesharegraph": {
        "id": "727133c9-3e87-4219-a91e-a257c9b2669b",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": 81,
                "y": 30
              }
            }
          },
          "opt": {
            "metadata": {
              "position": {
                "x": 81,
                "y": -30
              }
            }
          },
          "message": {},
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 96,
                "y": 0
              }
            }
          }
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 44,
            "y": 0
          }
        }
      },
      "websocketjsonduplex": {
        "id": "625e9caa-fefc-4675-a490-b9a199f25bee",
        "input": {
          "close": {
            "metadata": {
              "position": {
                "x": -102,
                "y": 18
              }
            }
          },
          "url": {
            "metadata": {
              "position": {
                "x": -102,
                "y": -18
              }
            }
          },
          "data": {}
        },
        "output": {
          "data": {}
        },
        "metadata": {
          "position": {
            "x": -55,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "remotesharegraph": {
          "input": {
            "message": true
          }
        },
        "websocketjsonduplex": {
          "output": {
            "data": true
          }
        }
      },
      "1": {
        "websocketjsonduplex": {
          "input": {
            "data": true
          }
        },
        "remotesharegraph": {
          "output": {
            "message": true
          }
        }
      }
    },
    "inputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "remotesharegraph",
            "pinId": "opt",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 94,
                "y": -51
              }
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "remotesharegraph",
            "pinId": "graph",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 94,
                "y": 51
              }
            }
          }
        }
      },
      "close": {
        "plug": {
          "0": {
            "unitId": "websocketjsonduplex",
            "pinId": "close",
            "kind": "input"
          },
          "1": {
            "unitId": "remotesharegraph",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -120,
                "y": 33
              }
            },
            "1": {
              "ext": {
                "x": 120,
                "y": 0
              }
            }
          }
        }
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "websocketjsonduplex",
            "pinId": "url",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -120,
                "y": -33
              }
            }
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "link",
      "description": "share a graph through web socket",
      "position": {
        "merge": {
          "0": {
            "x": -6,
            "y": -12
          },
          "1": {
            "x": -6,
            "y": 12
          }
        }
      },
      "tags": [
        "core",
        "meta",
        "remote"
      ]
    },
    "id": "17f39380-0732-41b1-bb5e-e90cc703de82",
    "system": true
  },
  "f91983d2-be26-4487-afa7-dc5eb6f22b6c": {
    "type": "\`U\`&\`G\`",
    "name": "web socket remote graph",
    "units": {
      "remotegraph": {
        "id": "57bcdd88-a4f4-49ab-92d4-ed1969895520",
        "input": {
          "opt": {
            "metadata": {
              "position": {
                "x": 77,
                "y": -33
              }
            }
          },
          "close": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 96,
                "y": -4
              }
            }
          },
          "message": {}
        },
        "output": {
          "graph": {
            "metadata": {
              "position": {
                "x": 92,
                "y": 32
              }
            }
          },
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 45,
            "y": 1
          }
        }
      },
      "websocketjsonduplex": {
        "id": "625e9caa-fefc-4675-a490-b9a199f25bee",
        "input": {
          "data": {},
          "close": {
            "metadata": {
              "position": {
                "x": -101,
                "y": 22
              }
            }
          },
          "url": {
            "metadata": {
              "position": {
                "x": -101,
                "y": -13
              }
            }
          }
        },
        "output": {
          "data": {}
        },
        "metadata": {
          "position": {
            "x": -54,
            "y": 4
          }
        }
      }
    },
    "merges": {
      "0": {
        "remotegraph": {
          "input": {
            "message": true
          }
        },
        "websocketjsonduplex": {
          "output": {
            "data": true
          }
        }
      },
      "1": {
        "websocketjsonduplex": {
          "input": {
            "data": true
          }
        },
        "remotegraph": {
          "output": {
            "message": true
          }
        }
      }
    },
    "inputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "remotegraph",
            "pinId": "opt",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 87,
                "y": -55
              }
            }
          }
        }
      },
      "close": {
        "plug": {
          "0": {
            "unitId": "websocketjsonduplex",
            "pinId": "close",
            "kind": "input"
          },
          "1": {
            "unitId": "remotegraph",
            "pinId": "close",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -118,
                "y": 38
              }
            },
            "1": {
              "ext": {
                "x": 120,
                "y": -10
              }
            }
          }
        },
        "defaultIgnored": true
      },
      "url": {
        "plug": {
          "0": {
            "unitId": "websocketjsonduplex",
            "pinId": "url",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -120,
                "y": -28
              }
            }
          }
        }
      }
    },
    "outputs": {
      "graph": {
        "plug": {
          "0": {
            "unitId": "remotegraph",
            "pinId": "graph",
            "kind": "output"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 111,
                "y": 55
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "link",
      "description": "connect to a web socket shared graph",
      "position": {
        "merge": {
          "0": {
            "x": -5,
            "y": -10
          },
          "1": {
            "x": -4,
            "y": 15
          }
        }
      },
      "tags": [
        "core",
        "meta",
        "remote"
      ]
    },
    "id": "f91983d2-be26-4487-afa7-dc5eb6f22b6c",
    "system": true
  },
  "259ba71c-6315-4324-a32c-fc2277200a40": {
    "type": "\`U\`&\`G\`",
    "name": "local share graph",
    "units": {
      "remotesharegraph": {
        "id": "727133c9-3e87-4219-a91e-a257c9b2669b",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": 195,
                "y": 0
              }
            }
          },
          "opt": {
            "metadata": {
              "position": {
                "x": 181,
                "y": 29
              }
            }
          },
          "message": {},
          "done": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 181,
                "y": -30
              }
            }
          }
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 143,
            "y": 0
          }
        }
      },
      "broadcastchannel": {
        "id": "adcd6571-0884-45e8-ac58-8c73f307d98e",
        "input": {
          "name": {
            "metadata": {
              "position": {
                "x": -203,
                "y": 18
              }
            }
          },
          "close": {
            "metadata": {
              "position": {
                "x": -203,
                "y": -18
              }
            }
          }
        },
        "output": {
          "channel": {
            "metadata": {
              "position": {
                "x": -99,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -158,
            "y": 0
          }
        }
      },
      "onmessage": {
        "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
        "input": {
          "emitter": {}
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 34
          }
        }
      },
      "send": {
        "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
        "input": {
          "channel": {},
          "data": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -52,
            "y": -33
          }
        }
      },
      "parsejson": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
        "input": {
          "string": {}
        },
        "output": {
          "json": {
            "metadata": {
              "position": {
                "x": 143,
                "y": -79
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": 48
          }
        }
      },
      "stringify": {
        "id": "ee184ea6-3c80-4119-919e-290620aafab0",
        "input": {
          "json": {
            "metadata": {
              "position": {
                "x": 140,
                "y": 80
              }
            }
          }
        },
        "output": {
          "string": {}
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": -48
          }
        }
      }
    },
    "inputs": {
      "graph": {
        "ref": true,
        "plug": {
          "0": {
            "unitId": "remotesharegraph",
            "kind": "input",
            "pinId": "graph"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 220,
                "y": 0
              }
            }
          }
        }
      },
      "opt": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "remotesharegraph",
            "kind": "input",
            "pinId": "opt"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 195,
                "y": 49
              }
            }
          }
        }
      },
      "close": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "broadcastchannel",
            "pinId": "close"
          },
          "1": {
            "unitId": "remotesharegraph",
            "pinId": "done",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -220,
                "y": -34
              }
            },
            "1": {
              "ext": {
                "x": 195,
                "y": -50
              }
            }
          }
        }
      },
      "id": {
        "ref": false,
        "plug": {
          "1": {
            "unitId": "broadcastchannel",
            "pinId": "name",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "1": {
              "ext": {
                "x": -220,
                "y": 35
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "broadcast-tower",
      "description": "share a graph locally",
      "position": {
        "merge": {
          "0": {
            "x": 99,
            "y": -30
          },
          "1": {
            "x": 98,
            "y": 30
          },
          "3": {
            "x": -3,
            "y": 49
          },
          "4": {
            "x": -3,
            "y": -49
          }
        }
      },
      "tags": [
        "core",
        "meta",
        "remote"
      ]
    },
    "id": "259ba71c-6315-4324-a32c-fc2277200a40",
    "component": {},
    "merges": {
      "0": {
        "remotesharegraph": {
          "output": {
            "message": true
          }
        },
        "stringify": {
          "input": {
            "json": true
          }
        }
      },
      "1": {
        "parsejson": {
          "output": {
            "json": true
          }
        },
        "remotesharegraph": {
          "input": {
            "message": true
          }
        }
      },
      "2": {
        "onmessage": {
          "input": {
            "emitter": true
          }
        },
        "send": {
          "input": {
            "channel": true
          }
        },
        "broadcastchannel": {
          "output": {
            "channel": true
          }
        }
      },
      "3": {
        "parsejson": {
          "input": {
            "string": true
          }
        },
        "onmessage": {
          "output": {
            "message": true
          }
        }
      },
      "4": {
        "send": {
          "input": {
            "data": true
          }
        },
        "stringify": {
          "output": {
            "string": true
          }
        }
      }
    },
    "system": true
  },
  "5ec9d37d-f9f4-49d0-a139-55af26fab05c": {
    "type": "\`U\`&\`G\`",
    "name": "local graph",
    "units": {
      "remotegraph": {
        "id": "57bcdd88-a4f4-49ab-92d4-ed1969895520",
        "input": {
          "opt": {
            "metadata": {
              "position": {
                "x": 195,
                "y": -5
              }
            }
          },
          "close": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 179,
                "y": -33
              }
            }
          },
          "message": {}
        },
        "output": {
          "graph": {
            "metadata": {
              "position": {
                "x": 190,
                "y": 30
              }
            }
          },
          "message": {}
        },
        "metadata": {
          "position": {
            "x": 143,
            "y": -1
          }
        }
      },
      "broadcastchannel": {
        "id": "adcd6571-0884-45e8-ac58-8c73f307d98e",
        "input": {
          "name": {
            "metadata": {
              "position": {
                "x": -203,
                "y": 18
              }
            }
          },
          "close": {
            "metadata": {
              "position": {
                "x": -203,
                "y": -17
              }
            }
          }
        },
        "output": {
          "channel": {
            "metadata": {
              "position": {
                "x": -99,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -158,
            "y": 1
          }
        }
      },
      "parsejson": {
        "id": "563e92be-ad5e-4a61-a718-9249c3eac51d",
        "input": {
          "string": {}
        },
        "output": {
          "json": {
            "metadata": {
              "position": {
                "x": 143,
                "y": -79
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": 48
          }
        }
      },
      "onmessage": {
        "id": "23c3952a-ef19-11ea-b80e-3f693508091e",
        "input": {
          "emitter": {}
        },
        "output": {
          "message": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 34
          }
        }
      },
      "send": {
        "id": "b296242e-8b82-11eb-ac6c-0f8d3f9948d0",
        "input": {
          "channel": {},
          "data": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -51,
            "y": -33
          }
        }
      },
      "stringify": {
        "id": "ee184ea6-3c80-4119-919e-290620aafab0",
        "input": {
          "json": {
            "metadata": {
              "position": {
                "x": 140,
                "y": 80
              }
            }
          }
        },
        "output": {
          "string": {}
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": -48
          }
        }
      }
    },
    "inputs": {
      "opt": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "remotegraph",
            "kind": "input",
            "pinId": "opt"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 219,
                "y": -9
              }
            }
          }
        }
      },
      "close": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "broadcastchannel",
            "pinId": "close"
          },
          "1": {
            "unitId": "remotegraph",
            "pinId": "close",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -219,
                "y": -34
              }
            },
            "1": {
              "ext": {
                "x": 191,
                "y": -54
              }
            }
          }
        }
      },
      "id": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "broadcastchannel",
            "pinId": "name"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -219,
                "y": 35
              }
            }
          }
        }
      }
    },
    "outputs": {
      "graph": {
        "ref": true,
        "plug": {
          "0": {
            "unitId": "remotegraph",
            "kind": "output",
            "pinId": "graph"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 210,
                "y": 53
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "broadcast-tower",
      "description": "connect to a locally shared graph",
      "position": {
        "merge": {
          "0": {
            "x": 99,
            "y": -30
          },
          "1": {
            "x": 99,
            "y": 30
          },
          "3": {
            "x": -2,
            "y": 49
          },
          "4": {
            "x": -2,
            "y": -49
          }
        }
      },
      "tags": [
        "core",
        "meta",
        "remote"
      ]
    },
    "id": "5ec9d37d-f9f4-49d0-a139-55af26fab05c",
    "component": {},
    "merges": {
      "0": {
        "stringify": {
          "input": {
            "json": true
          }
        },
        "remotegraph": {
          "output": {
            "message": true
          }
        }
      },
      "1": {
        "parsejson": {
          "output": {
            "json": true
          }
        },
        "remotegraph": {
          "input": {
            "message": true
          }
        }
      },
      "2": {
        "onmessage": {
          "input": {
            "emitter": true
          }
        },
        "send": {
          "input": {
            "channel": true
          }
        },
        "broadcastchannel": {
          "output": {
            "channel": true
          }
        }
      },
      "3": {
        "parsejson": {
          "input": {
            "string": true
          }
        },
        "onmessage": {
          "output": {
            "message": true
          }
        }
      },
      "4": {
        "send": {
          "input": {
            "data": true
          }
        },
        "stringify": {
          "output": {
            "string": true
          }
        }
      }
    },
    "system": true
  },
  "4025f69f-6c2b-45c1-bbb3-d8d7c1f700bf": {
    "type": "\`U\`&\`G\`",
    "name": "unit bundle to bundle",
    "units": {
      "delete": {
        "id": "664b5d3c-e4cf-11ea-ab74-eb6d2f3bd6f1",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": -21
          }
        }
      },
      "set0": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": false
          },
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "spec"
            },
            "metadata": {
              "position": {
                "x": 182,
                "y": -49
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {
            "metadata": {
              "position": {
                "x": 186,
                "y": -79
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 136,
            "y": -68
          }
        }
      },
      "deepget": {
        "id": "2ff102a7-b469-461f-a3b1-a61b81c1b325",
        "input": {
          "path": {
            "constant": true,
            "data": {
              "ref": [],
              "data": [
                "unit",
                "id"
              ]
            },
            "metadata": {
              "position": {
                "x": -179,
                "y": -112
              }
            }
          },
          "obj": {
            "metadata": {
              "position": {
                "x": -188,
                "y": -81
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -138,
            "y": -86
          }
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -174,
                "y": 73
              }
            }
          },
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "specs"
            },
            "metadata": {
              "position": {
                "x": -188,
                "y": 41
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -138,
            "y": 44
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": 25,
                "y": 38
              }
            }
          },
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "specs"
            },
            "metadata": {
              "position": {
                "x": 93,
                "y": 26
              }
            }
          },
          "value": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 2
          }
        }
      },
      "idtospec": {
        "id": "b2626d61-b17d-4737-bea3-627c0322f9d6",
        "input": {
          "id": {}
        },
        "output": {
          "spec": {}
        },
        "metadata": {
          "position": {
            "x": -40,
            "y": -107
          }
        }
      },
      "getordefault": {
        "id": "aeac1075-e01f-4d22-b01b-9a77cbba504b",
        "input": {
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "base"
            },
            "metadata": {
              "position": {
                "x": -79,
                "y": -190
              }
            }
          },
          "obj": {},
          "default": {
            "constant": true,
            "data": {
              "ref": [],
              "data": false
            },
            "metadata": {
              "position": {
                "x": -58,
                "y": -221
              }
            }
          }
        },
        "output": {
          "value": {}
        },
        "metadata": {
          "position": {
            "x": -29,
            "y": -184
          }
        }
      },
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "if": {},
          "else": {}
        },
        "metadata": {
          "position": {
            "x": 63,
            "y": -151
          }
        }
      },
      "throw": {
        "id": "99657eb7-fb94-474e-b03d-4b08c537c0a2",
        "input": {
          "message": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 91,
            "y": -286
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "class is not a graph"
            },
            "metadata": {
              "position": {
                "x": 199,
                "y": -221
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 150,
            "y": -218
          }
        }
      }
    },
    "merges": {
      "0": {
        "idtospec": {
          "output": {
            "spec": true
          }
        },
        "getordefault": {
          "input": {
            "obj": true
          }
        },
        "ifelse": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "get": {
          "output": {
            "value": true
          }
        },
        "delete": {
          "input": {
            "obj": true
          }
        }
      },
      "2": {
        "delete": {
          "output": {
            "obj": true
          }
        },
        "set": {
          "input": {
            "value": true
          }
        }
      },
      "3": {
        "getordefault": {
          "output": {
            "value": true
          }
        },
        "ifelse": {
          "input": {
            "b": true
          }
        }
      },
      "4": {
        "set0": {
          "input": {
            "obj": true
          }
        },
        "set": {
          "output": {
            "obj": true
          }
        }
      },
      "5": {
        "idtospec": {
          "input": {
            "id": true
          }
        },
        "deepget": {
          "output": {
            "value": true
          }
        },
        "delete": {
          "input": {
            "key": true
          }
        }
      },
      "6": {
        "ifelse": {
          "output": {
            "else": true
          }
        },
        "set0": {
          "input": {
            "value": true
          }
        }
      },
      "7": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "ifelse": {
          "output": {
            "if": true
          }
        }
      },
      "8": {
        "throw": {
          "input": {
            "message": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "get",
            "kind": "input",
            "pinId": "obj"
          },
          "1": {
            "unitId": "deepget",
            "pinId": "obj",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -184,
                "y": 94
              }
            },
            "1": {
              "ext": {
                "x": -211,
                "y": -81
              }
            }
          }
        }
      }
    },
    "outputs": {
      "graph": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "set0",
            "kind": "output",
            "pinId": "obj"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 210,
                "y": -81
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "attempt to turn a unit class into a graph bundle",
      "position": {
        "merge": {
          "0": {
            "x": 4,
            "y": -144
          },
          "1": {
            "x": -95,
            "y": 16
          },
          "2": {
            "x": -3,
            "y": -7
          },
          "3": {
            "x": 20,
            "y": -176
          },
          "4": {
            "x": 97,
            "y": -31
          },
          "5": {
            "x": -82,
            "y": -71
          },
          "6": {
            "x": 102,
            "y": -110
          },
          "7": {
            "x": 107,
            "y": -185
          },
          "8": {
            "x": 131,
            "y": -261
          }
        }
      },
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "4025f69f-6c2b-45c1-bbb3-d8d7c1f700bf",
    "system": true
  },
  "4f8c249e-9bbf-11eb-b3ff-e3ecdde1acd1": {
    "name": "spec ids",
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "specs",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "keys"
          }
        }
      }
    },
    "units": {
      "specs": {
        "id": "b5ea15f4-9bbd-11eb-b623-37aff4a9ce60",
        "input": {
          "any": {}
        },
        "output": {
          "specs": {}
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": -1
          }
        }
      },
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754",
        "input": {
          "obj": {}
        },
        "output": {
          "keys": {}
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "keys": {
          "input": {
            "obj": true
          }
        },
        "specs": {
          "output": {
            "specs": true
          }
        }
      }
    },
    "id": "4f8c249e-9bbf-11eb-b3ff-e3ecdde1acd1",
    "metadata": {
      "icon": null,
      "description": "all system spec ids",
      "tags": [
        "core",
        "meta"
      ]
    },
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "95735a9e-9bc0-11eb-90ec-3bb9082e8fe9": {
    "name": "random spec id",
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "specids",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "id": {
        "plug": {
          "0": {
            "unitId": "randominarray",
            "pinId": "a[i]"
          }
        }
      }
    },
    "units": {
      "specids": {
        "id": "4f8c249e-9bbf-11eb-b3ff-e3ecdde1acd1",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": 0
          }
        }
      },
      "randominarray": {
        "id": "5b99b930-92c9-4fbe-be37-8c72a8e1c70b",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {}
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "randominarray": {
          "input": {
            "a": true
          }
        },
        "specids": {
          "output": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "random spec id",
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "95735a9e-9bc0-11eb-90ec-3bb9082e8fe9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "96c788b0-9bc1-11eb-931a-7312c12cb4c3": {
    "name": "random class",
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "randomspecid",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "class": {
        "plug": {
          "0": {
            "unitId": "idtoclass",
            "pinId": "class"
          }
        }
      }
    },
    "units": {
      "randomspecid": {
        "id": "95735a9e-9bc0-11eb-90ec-3bb9082e8fe9",
        "input": {
          "any": {}
        },
        "output": {
          "id": {}
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": 0
          }
        }
      },
      "idtoclass": {
        "id": "b0c25199-c284-4f90-817c-60dc89b15b1c",
        "input": {
          "id": {}
        },
        "output": {
          "class": {}
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "idtoclass": {
          "input": {
            "id": true
          }
        },
        "randomspecid": {
          "output": {
            "id": true
          }
        }
      }
    },
    "metadata": {
      "icon": "shapes",
      "description": "random unit class",
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "96c788b0-9bc1-11eb-931a-7312c12cb4c3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b2626d61-b17d-4737-bea3-627c0322f9d6": {
    "type": "\`U\`&\`G\`",
    "name": "id to spec",
    "units": {
      "specs": {
        "id": "b5ea15f4-9bbd-11eb-b623-37aff4a9ce60",
        "input": {
          "any": {}
        },
        "output": {
          "specs": {}
        }
      },
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "value": {}
        }
      }
    },
    "merges": {
      "0": {
        "specs": {
          "output": {
            "specs": true
          }
        },
        "get": {
          "input": {
            "obj": true
          }
        }
      }
    },
    "inputs": {
      "id": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "key",
            "kind": "input"
          },
          "1": {
            "unitId": "specs",
            "pinId": "any",
            "kind": "input"
          }
        }
      }
    },
    "outputs": {
      "spec": {
        "plug": {
          "0": {
            "unitId": "get",
            "pinId": "value",
            "kind": "output"
          }
        }
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get system \`spec\` with \`id\`",
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "b2626d61-b17d-4737-bea3-627c0322f9d6",
    "system": true
  },
  "45313e8a-bc8e-4883-b377-91c063b880a8": {
    "type": "\`U\`&\`G\`",
    "name": "class to spec",
    "units": {
      "classtoid": {
        "id": "1520b630-93aa-11ea-ac56-7718cb2ad75d",
        "input": {
          "class": {
            "metadata": {
              "position": {
                "x": -97,
                "y": 0
              }
            }
          }
        },
        "output": {
          "id": {}
        },
        "metadata": {
          "position": {
            "x": -50,
            "y": 0
          }
        }
      },
      "idtospec": {
        "id": "b2626d61-b17d-4737-bea3-627c0322f9d6",
        "input": {
          "id": {}
        },
        "output": {
          "spec": {
            "metadata": {
              "position": {
                "x": 97,
                "y": 0
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "classtoid": {
          "output": {
            "id": true
          }
        },
        "idtospec": {
          "input": {
            "id": true
          }
        }
      }
    },
    "inputs": {
      "class": {
        "plug": {
          "0": {
            "unitId": "classtoid",
            "pinId": "class",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -120,
                "y": 0
              }
            }
          }
        }
      }
    },
    "outputs": {
      "spec": {
        "plug": {
          "0": {
            "unitId": "idtospec",
            "pinId": "spec",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 120,
                "y": 0
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "get spec out of unit \`class\`",
      "position": {
        "merge": {
          "0": {
            "x": 0,
            "y": 0
          }
        }
      },
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "45313e8a-bc8e-4883-b377-91c063b880a8",
    "system": true
  },
  "ff952613-d9b5-4c96-82e7-16d7289ccbc5": {
    "type": "\`U\`&\`G\`",
    "name": "class to unit",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "unit"
            },
            "metadata": {
              "position": {
                "x": 85,
                "y": -14
              }
            }
          }
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 85,
                "y": 22
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 40,
            "y": 4
          }
        }
      },
      "classtobundle": {
        "id": "546fea11-bbb6-4d20-839b-df0011f528ac",
        "input": {
          "class": {
            "metadata": {
              "position": {
                "x": -109,
                "y": 4
              }
            }
          }
        },
        "output": {
          "unit": {}
        },
        "metadata": {
          "position": {
            "x": -61,
            "y": 4
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "classtobundle": {
          "output": {
            "unit": true
          }
        }
      }
    },
    "inputs": {
      "class": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "classtobundle",
            "kind": "input",
            "pinId": "class"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -132,
                "y": 4
              }
            }
          }
        }
      }
    },
    "outputs": {
      "unit": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "get",
            "kind": "output",
            "pinId": "value"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 101,
                "y": 39
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "\`unit\` spec of the given unit \`class\` bundle",
      "position": {
        "merge": {
          "0": {
            "x": -11,
            "y": 4
          }
        }
      },
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "ff952613-d9b5-4c96-82e7-16d7289ccbc5",
    "system": true
  },
  "1520b630-93aa-11ea-ac56-7718cb2ad75d": {
    "type": "\`U\`&\`G\`",
    "name": "class to id",
    "units": {
      "classtounit": {
        "id": "ff952613-d9b5-4c96-82e7-16d7289ccbc5",
        "metadata": {
          "position": {
            "x": 21,
            "y": -48
          }
        },
        "input": {
          "class": {
            "metadata": {
              "position": {
                "x": -27,
                "y": -48
              }
            }
          }
        }
      },
      "getid": {
        "id": "f7805a56-668d-11eb-a8df-732d644930cc",
        "input": {
          "obj": {}
        },
        "output": {
          "id": {
            "metadata": {
              "position": {
                "x": 171,
                "y": -48
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 123,
            "y": -48
          }
        }
      }
    },
    "merges": {
      "0": {
        "getid": {
          "input": {
            "obj": true
          }
        },
        "classtounit": {
          "output": {
            "unit": true
          }
        }
      }
    },
    "inputs": {
      "class": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "classtounit",
            "kind": "input",
            "pinId": "class"
          }
        }
      }
    },
    "outputs": {
      "id": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "getid",
            "kind": "output",
            "pinId": "id"
          }
        }
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "system \`id\` of the given unit \`class\`",
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "1520b630-93aa-11ea-ac56-7718cb2ad75d",
    "system": true
  },
  "326994cb-8a47-41b5-b902-3146cf5a8bac": {
    "type": "\`U\`&\`G\`",
    "name": "class to bundle",
    "units": {
      "classtounitbundle": {
        "id": "546fea11-bbb6-4d20-839b-df0011f528ac",
        "input": {
          "class": {
            "constant": false,
            "metadata": {
              "position": {
                "x": 445,
                "y": 222
              }
            }
          }
        },
        "output": {
          "bundle": {
            "metadata": {
              "position": {
                "x": 453.66426426426426,
                "y": 208.67454954954957
              }
            }
          },
          "unit": {
            "metadata": {
              "position": {
                "x": 503.4864864864865,
                "y": 287.2162162162162
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 493,
            "y": 222
          }
        }
      },
      "unitbundletobundle": {
        "id": "4025f69f-6c2b-45c1-bbb3-d8d7c1f700bf",
        "input": {
          "unit": {}
        },
        "output": {
          "graph": {
            "metadata": {
              "position": {
                "x": 644,
                "y": 222
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 594,
            "y": 222
          }
        }
      }
    },
    "merges": {
      "0": {
        "unitbundletobundle": {
          "input": {
            "unit": true
          }
        },
        "classtounitbundle": {
          "output": {
            "unit": true
          }
        }
      }
    },
    "inputs": {
      "class": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "classtounitbundle",
            "kind": "input",
            "pinId": "class"
          }
        }
      }
    },
    "outputs": {
      "graph": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "unitbundletobundle",
            "kind": "output",
            "pinId": "graph"
          }
        }
      }
    },
    "metadata": {
      "icon": "circle",
      "description": "extract graph \`class\` \`bundle\`",
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "326994cb-8a47-41b5-b902-3146cf5a8bac",
    "system": true
  },
  "123f2837-76c0-4cb2-8d73-29e66879b181": {
    "type": "\`U\`&\`G\`",
    "name": "class",
    "units": {
      "fromunitbundle": {
        "id": "23acb820-8820-4c4f-8e28-ee4daa4cc056",
        "input": {
          "bundle": {}
        },
        "output": {
          "unit": {
            "metadata": {
              "position": {
                "x": 165,
                "y": 19
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 117,
            "y": 19
          }
        }
      },
      "bundle": {
        "id": "53825c2f-1aca-40f5-b739-3c60ef5886a8",
        "input": {
          "unit": {
            "metadata": {
              "position": {
                "x": -11,
                "y": 56
              }
            }
          },
          "opt": {}
        },
        "output": {
          "bundle": {}
        },
        "metadata": {
          "position": {
            "x": 15,
            "y": 19
          }
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {
            "constant": true,
            "data": {
              "ref": [],
              "data": {}
            },
            "metadata": {
              "position": {
                "x": -54,
                "y": -47
              },
              "data": {
                "position": {
                  "x": -33,
                  "y": -77
                }
              }
            }
          },
          "key": {
            "constant": true,
            "data": {
              "ref": [],
              "data": "deep"
            },
            "metadata": {
              "position": {
                "x": -136,
                "y": -1
              },
              "data": {
                "position": {
                  "x": -175,
                  "y": 19
                }
              }
            }
          },
          "value": {
            "metadata": {
              "position": {
                "x": -135,
                "y": -36
              }
            }
          }
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": -89,
            "y": -17
          }
        }
      }
    },
    "merges": {
      "0": {
        "fromunitbundle": {
          "input": {
            "bundle": true
          }
        },
        "bundle": {
          "output": {
            "bundle": true
          }
        }
      },
      "1": {
        "set": {
          "output": {
            "obj": true
          }
        },
        "bundle": {
          "input": {
            "opt": true
          }
        }
      }
    },
    "inputs": {
      "unit": {
        "plug": {
          "0": {
            "unitId": "bundle",
            "pinId": "unit",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -14,
                "y": 80
              }
            }
          }
        }
      },
      "deep": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "value",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -153,
                "y": -51
              }
            }
          }
        }
      }
    },
    "outputs": {
      "class": {
        "plug": {
          "0": {
            "unitId": "fromunitbundle",
            "pinId": "unit",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 188,
                "y": 19
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "triangle",
      "description": "extract \`unit\` class of given \`unit\`",
      "position": {
        "merge": {
          "0": {
            "x": 67,
            "y": 19
          },
          "1": {
            "x": -37,
            "y": 2
          }
        }
      },
      "tags": [
        "core",
        "meta"
      ]
    },
    "id": "123f2837-76c0-4cb2-8d73-29e66879b181",
    "system": true
  },
  "13cbadb7-bbe5-4c6d-a81e-fc6fe5949e30": {
    "name": "negate",
    "units": {
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "b": {
            "constant": true,
            "data": "-1"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "minus",
      "description": "turn \`a\` into \`-a\`",
      "tags": [
        "core",
        "math"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "-a": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a × b"
          }
        }
      }
    },
    "id": "13cbadb7-bbe5-4c6d-a81e-fc6fe5949e30",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "06203a50-ace2-4c4e-9088-0951342c6b52": {
    "name": "range towards",
    "inputs": {
      "end": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "start": {
        "plug": {
          "0": {
            "unitId": "loopadd",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "final": {
        "plug": {
          "0": {
            "unitId": "loopadd",
            "pinId": "final"
          }
        }
      },
      "current": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "units": {
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -130,
                "y": -35
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {},
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -115,
                "y": -57
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -78,
            "y": -21
          }
        }
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a - b": {}
        },
        "metadata": {
          "position": {
            "x": 23,
            "y": -59
          }
        }
      },
      "greaterthan0": {
        "id": "1a59348c-a25a-11eb-8afe-8bedb0732a89",
        "input": {
          "a": {}
        },
        "output": {
          "sign(a)": {}
        },
        "metadata": {
          "position": {
            "x": 121,
            "y": -35
          }
        }
      },
      "loopadd": {
        "id": "93369291-7ce2-4b4c-a414-870b1f3c9b4c",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": 54,
                "y": 70
              }
            }
          },
          "test": {},
          "plus": {}
        },
        "output": {
          "local": {},
          "final": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 81,
                "y": 45
              }
            }
          },
          "current": {}
        },
        "metadata": {
          "position": {
            "x": 30,
            "y": 26
          }
        }
      },
      "greaterthan": {
        "id": "bda175a9-a9d2-4282-9b50-1b008ae8a807",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a ≠ b": {}
        },
        "metadata": {
          "position": {
            "x": -73,
            "y": 34
          }
        }
      }
    },
    "merges": {
      "0": {
        "subtract": {
          "input": {
            "a": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "1": {
        "greaterthan0": {
          "input": {
            "a": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      },
      "2": {
        "loopadd": {
          "output": {
            "current": true
          }
        },
        "subtract": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "greaterthan0": {
          "output": {
            "sign(a)": true
          }
        },
        "loopadd": {
          "input": {
            "plus": true
          }
        }
      },
      "4": {
        "greaterthan": {
          "input": {
            "b": true
          }
        },
        "loopadd": {
          "output": {
            "local": true
          }
        }
      },
      "5": {
        "greaterthan": {
          "input": {
            "a": true
          }
        },
        "looprepeat": {
          "output": {
            "local": true
          }
        }
      },
      "6": {
        "greaterthan": {
          "output": {
            "a ≠ b": true
          }
        },
        "loopadd": {
          "input": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "go from \`a\` to \`b\` step by step, not inclusive",
      "position": {
        "merge": {
          "0": {
            "x": -32,
            "y": -51
          },
          "1": {
            "x": 78,
            "y": -62
          },
          "2": {
            "x": 46,
            "y": -19
          },
          "3": {
            "x": 85,
            "y": 1
          },
          "4": {
            "x": -22,
            "y": 44
          },
          "5": {
            "x": -117,
            "y": 12
          },
          "6": {
            "x": -30,
            "y": 11
          }
        }
      },
      "tags": [
        "core",
        "loop"
      ]
    },
    "id": "06203a50-ace2-4c4e-9088-0951342c6b52",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7a09c38d-3866-46e3-a03e-112c4cf6d889": {
    "name": "range reverse",
    "units": {
      "range": {
        "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c",
        "input": {}
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "b": {
            "constant": false
          },
          "a": {
            "constant": false
          }
        }
      },
      "decrement": {
        "id": "4d67d2e4-8b06-4e15-8243-99be8e4be5d3"
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      },
      "repeatn": {
        "id": "251ba609-a9c5-451b-8162-411c966bf919"
      },
      "subtract0": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f"
      }
    },
    "merges": {
      "0": {
        "range": {
          "output": {
            "i": true
          }
        },
        "subtract": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "range": {
          "input": {
            "b": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        },
        "subtract0": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "range": {
          "input": {
            "a": true
          }
        },
        "add": {
          "input": {
            "a": true
          }
        },
        "subtract0": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "add": {
          "output": {
            "a + b": true
          }
        },
        "decrement": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "repeatn": {
          "input": {
            "n": true
          }
        },
        "subtract0": {
          "output": {
            "a - b": true
          }
        }
      },
      "5": {
        "repeatn": {
          "input": {
            "a": true
          }
        },
        "decrement": {
          "output": {
            "a - 1": true
          }
        }
      },
      "6": {
        "repeatn": {
          "output": {
            "a": true
          }
        },
        "subtract": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "sort-asc",
      "description": "regressive count from \`b - 1\` to \`a\`",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "a - b"
          }
        }
      }
    },
    "id": "7a09c38d-3866-46e3-a03e-112c4cf6d889",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cc816c77-3ee5-4a84-8f75-c319b53985c3": {
    "name": "range rec",
    "units": {
      "increment": {
        "id": "fafeadd7-06a8-4bb0-9fa5-2149d1b5208e"
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      },
      "range": {
        "id": "cc816c77-3ee5-4a84-8f75-c319b53985c3"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "plan": {
        "id": "36329d25-218d-48a5-a06c-1e0525da504f"
      }
    },
    "merges": {
      "0": {
        "lessthan": {
          "input": {
            "a": true
          }
        },
        "if0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "lessthan": {
          "input": {
            "b": true
          }
        },
        "if1": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "increment": {
          "output": {
            "a + 1": true
          }
        },
        "range": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "lessthan": {
          "output": {
            "a < b": true
          }
        },
        "if1": {
          "input": {
            "b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        }
      },
      "4": {
        "range": {
          "output": {
            "i": true
          }
        },
        "plan": {
          "output": {
            "0": true
          }
        }
      },
      "5": {
        "if1": {
          "output": {
            "a if b": true
          }
        },
        "range": {
          "input": {
            "b": true
          }
        }
      },
      "6": {
        "increment": {
          "input": {
            "a": true
          }
        },
        "plan": {
          "output": {
            "1": true
          }
        }
      },
      "7": {
        "plan": {
          "input": {
            "a": true
          }
        },
        "if0": {
          "output": {
            "a if b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "count from \`a\` to \`b\`, not inclusive",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        }
      }
    },
    "id": "cc816c77-3ee5-4a84-8f75-c319b53985c3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "23af575c-176a-451a-b710-a031a5ecb7a2": {
    "name": "range grid",
    "units": {
      "range": {
        "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -148,
                "y": 56
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -156,
                "y": 24
              }
            }
          }
        },
        "output": {
          "i": {},
          "test": {
            "ignored": false
          },
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -149,
                "y": 4
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": 31
          }
        }
      },
      "range1": {
        "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "i": {
            "metadata": {
              "position": {
                "x": 118,
                "y": -43
              }
            }
          },
          "test": {
            "ignored": false
          },
          "final": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 74,
            "y": -17
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -77,
                "y": -44
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -65,
                "y": -59
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 4,
                "y": 9
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -29,
            "y": -21
          }
        }
      },
      "looprepeat0": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -34,
                "y": 103
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 5,
                "y": 114
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 2,
            "y": 67
          }
        }
      },
      "looprepeat1": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -65,
                "y": -95
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -25,
                "y": -110
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 10,
                "y": -94
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -30,
            "y": -61
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": 100,
            "y": 98
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 170,
            "y": 35
          }
        }
      }
    },
    "merges": {
      "0": {
        "looprepeat": {
          "output": {
            "current": true
          }
        },
        "range1": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "range": {
          "output": {
            "test": true
          }
        },
        "looprepeat1": {
          "input": {
            "test": true
          }
        }
      },
      "2": {
        "looprepeat0": {
          "input": {
            "init": true
          }
        },
        "range": {
          "output": {
            "i": true
          }
        }
      },
      "3": {
        "range1": {
          "output": {
            "test": true
          }
        },
        "looprepeat0": {
          "input": {
            "test": true
          }
        }
      },
      "4": {
        "looprepeat1": {
          "output": {
            "current": true
          }
        },
        "range1": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "true": {
          "input": {
            "any": true
          }
        },
        "looprepeat0": {
          "output": {
            "current": true
          }
        }
      },
      "6": {
        "false": {
          "input": {
            "any": true
          }
        },
        "range1": {
          "output": {
            "final": true
          }
        }
      },
      "7": {
        "false": {
          "output": {
            "false": true
          }
        },
        "true": {
          "output": {
            "true": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "range",
            "pinId": "a"
          },
          "1": {
            "unitId": "looprepeat1",
            "pinId": "init"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -163,
                "y": 75
              }
            },
            "1": {
              "ext": {
                "x": -74,
                "y": -118
              }
            }
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          },
          "fyinwkvp": {
            "unitId": "range",
            "pinId": "b"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -98,
                "y": -59
              }
            },
            "fyinwkvp": {
              "ext": {
                "x": -180,
                "y": 19
              }
            }
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "mergeId": "5"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 42,
                "y": 118
              }
            }
          }
        }
      },
      "j": {
        "plug": {
          "0": {
            "unitId": "range1",
            "pinId": "i"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 132,
                "y": -63
              }
            }
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "7"
          }
        },
        "ref": false,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 164,
                "y": 96
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "grid",
      "description": "for every \`i\` < \`a\` and \`j\` < \`b\`",
      "tags": [
        "core",
        "loop"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 23,
            "y": -19
          },
          "1": {
            "x": -73,
            "y": -16
          },
          "2": {
            "x": -55,
            "y": 58
          },
          "3": {
            "x": 42,
            "y": 29
          },
          "4": {
            "x": 29,
            "y": -52
          },
          "5": {
            "x": 47,
            "y": 94
          },
          "6": {
            "x": 127,
            "y": 5
          },
          "7": {
            "x": 147,
            "y": 78
          }
        }
      }
    },
    "id": "23af575c-176a-451a-b710-a031a5ecb7a2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d34a9900-e46d-4f23-98bf-485dde71d9a3": {
    "name": "range bounce towards",
    "inputs": {
      "end": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "functional": true
      },
      "start": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "rangetowards",
            "pinId": "current"
          }
        }
      }
    },
    "units": {
      "switchab": {
        "id": "9c10309b-6ce8-4b92-a0d4-a4b6b2a17a64",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -34,
            "y": -25
          }
        }
      },
      "rangetowards": {
        "id": "06203a50-ace2-4c4e-9088-0951342c6b52",
        "input": {
          "end": {},
          "start": {}
        },
        "output": {
          "final": {
            "ignored": true
          },
          "current": {}
        },
        "metadata": {
          "position": {
            "x": 66,
            "y": 0
          }
        }
      },
      "switchab0": {
        "id": "9c10309b-6ce8-4b92-a0d4-a4b6b2a17a64",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -34,
            "y": 24
          }
        }
      }
    },
    "merges": {
      "0": {
        "switchab": {
          "output": {
            "a": true
          }
        },
        "rangetowards": {
          "input": {
            "start": true
          }
        }
      },
      "1": {
        "switchab0": {
          "output": {
            "a": true
          }
        },
        "rangetowards": {
          "input": {
            "end": true
          }
        }
      },
      "2": {
        "switchab0": {
          "input": {
            "b": true
          }
        },
        "switchab": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "switchab": {
          "input": {
            "b": true
          }
        },
        "switchab0": {
          "input": {
            "a": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "list-ordered",
      "description": "range bounce between \`start\` and \`and\`, interchangeably",
      "tags": [
        "core",
        "loop"
      ]
    },
    "type": "\`U\`&\`G\`",
    "id": "d34a9900-e46d-4f23-98bf-485dde71d9a3",
    "system": true
  },
  "343f1382-4d2d-4022-b4b3-139e40ab6627": {
    "name": "range bounce",
    "units": {
      "rangereverse": {
        "id": "7a09c38d-3866-46e3-a03e-112c4cf6d889"
      },
      "range": {
        "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c"
      },
      "plan": {
        "id": "36329d25-218d-48a5-a06c-1e0525da504f"
      }
    },
    "merges": {
      "0": {
        "range": {
          "input": {
            "a": true
          }
        },
        "plan": {
          "output": {
            "0": true
          }
        }
      },
      "1": {
        "plan": {
          "output": {
            "1": true
          }
        },
        "rangereverse": {
          "input": {
            "a": true
          }
        }
      },
      "bjpzdvv": {
        "range": {
          "input": {
            "b": true
          }
        },
        "rangereverse": {
          "input": {
            "b": true
          }
        }
      },
      "ymwlenzvu": {
        "range": {
          "output": {
            "i": true
          }
        },
        "rangereverse": {
          "output": {
            "i": true
          }
        }
      }
    },
    "metadata": {
      "icon": "exchange",
      "description": "count from \`a\` to \`b - 1\`, then regressive count from \`b - 1\` to \`a\`",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "plan",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "bjpzdvv"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "mergeId": "ymwlenzvu"
          }
        }
      }
    },
    "id": "343f1382-4d2d-4022-b4b3-139e40ab6627",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "29e43ad7-be5e-437f-8f0f-2df996c8b89c": {
    "name": "range",
    "units": {
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "current": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      },
      "loopincrement": {
        "id": "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7",
        "output": {
          "final": {
            "ignored": true
          }
        }
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35",
        "input": {
          "b": {
            "constant": false
          },
          "a": {}
        },
        "output": {
          "a < b": {}
        }
      }
    },
    "merges": {
      "0": {
        "looprepeat": {
          "output": {
            "local": true
          }
        },
        "lessthan": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "loopincrement": {
          "output": {
            "local": true
          }
        },
        "lessthan": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "lessthan": {
          "output": {
            "a < b": true
          }
        },
        "loopincrement": {
          "input": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "count from \`a\` to \`b\`, not inclusive",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "loopincrement",
            "pinId": "init"
          }
        },
        "functional": true,
        "metadata": {
          "examples": [
            "0"
          ]
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true,
        "metadata": {
          "examples": [
            "3"
          ]
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "loopincrement",
            "pinId": "current"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "defaultIgnored": true
      },
      "final": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "final"
          }
        },
        "defaultIgnored": true
      }
    },
    "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "eee90e0f-522d-4ac4-a0f1-abf5d69a4e26": {
    "name": "loop 2",
    "units": {
      "splitab0": {
        "id": "40555189-33ef-48b6-af8a-5ab4805b9a1f"
      },
      "mergeab0": {
        "id": "4e54703e-08bc-4537-ba5d-5e697a02be1f"
      },
      "splitab1": {
        "id": "40555189-33ef-48b6-af8a-5ab4805b9a1f"
      },
      "mergeab1": {
        "id": "4e54703e-08bc-4537-ba5d-5e697a02be1f"
      },
      "splitab2": {
        "id": "40555189-33ef-48b6-af8a-5ab4805b9a1f"
      },
      "for": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "mergeab0": {
          "output": {
            "ab": true
          }
        },
        "for": {
          "input": {
            "init": true
          }
        }
      },
      "1": {
        "splitab1": {
          "input": {
            "ab": true
          }
        },
        "for": {
          "output": {
            "final": true
          }
        }
      },
      "2": {
        "splitab0": {
          "input": {
            "ab": true
          }
        },
        "for": {
          "output": {
            "local": true
          }
        }
      },
      "3": {
        "mergeab1": {
          "output": {
            "ab": true
          }
        },
        "for": {
          "input": {
            "next": true
          }
        }
      },
      "4": {
        "splitab2": {
          "input": {
            "ab": true
          }
        },
        "for": {
          "output": {
            "current": true
          }
        }
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "iterate over \`a\` and \`b\`",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "next a": {
        "plug": {
          "0": {
            "unitId": "mergeab1",
            "pinId": "a"
          }
        }
      },
      "next b": {
        "plug": {
          "0": {
            "unitId": "mergeab1",
            "pinId": "b"
          }
        }
      },
      "inita": {
        "plug": {
          "0": {
            "unitId": "mergeab0",
            "pinId": "a"
          }
        }
      },
      "initb": {
        "plug": {
          "0": {
            "unitId": "mergeab0",
            "pinId": "b"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "for",
            "pinId": "test"
          }
        }
      }
    },
    "outputs": {
      "localb": {
        "plug": {
          "0": {
            "unitId": "splitab0",
            "pinId": "b"
          }
        }
      },
      "locala": {
        "plug": {
          "0": {
            "unitId": "splitab0",
            "pinId": "a"
          }
        }
      },
      "finalb": {
        "plug": {
          "0": {
            "unitId": "splitab1",
            "pinId": "b"
          }
        },
        "defaultIgnored": true
      },
      "finala": {
        "plug": {
          "0": {
            "unitId": "splitab1",
            "pinId": "a"
          }
        },
        "defaultIgnored": true
      },
      "currenta": {
        "plug": {
          "0": {
            "unitId": "splitab2",
            "pinId": "a"
          }
        }
      },
      "currentb": {
        "plug": {
          "0": {
            "unitId": "splitab2",
            "pinId": "b"
          }
        }
      }
    },
    "id": "eee90e0f-522d-4ac4-a0f1-abf5d69a4e26",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "fb311fff-521b-4066-b830-81d3a50f0f01": {
    "name": "is first",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {}
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea"
      },
      "loopforever": {
        "id": "4b6e5535-e600-4f91-a5df-105f6a5ad3d7",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": "true"
          }
        },
        "output": {
          "current": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "false": {
          "input": {
            "any": true
          }
        }
      },
      "1": {
        "loopforever": {
          "output": {
            "current": true
          }
        },
        "wait": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "false": {
          "output": {
            "false": true
          }
        },
        "loopforever": {
          "input": {
            "next": true
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether this is the first element of stream \`a\`",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "id": "fb311fff-521b-4066-b830-81d3a50f0f01",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e087017d-a69a-4a02-ad00-c5263bf47365": {
    "name": "count from",
    "units": {
      "loopincrement": {
        "id": "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7",
        "input": {
          "test": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": true
          }
        }
      },
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        }
      }
    },
    "merges": {
      "0": {
        "true": {
          "output": {
            "true": true
          }
        },
        "loopincrement": {
          "input": {
            "test": true
          }
        }
      }
    },
    "metadata": {
      "icon": "sort-desc",
      "description": "iteratively count \`a\`, starting from \`init\`",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "true",
            "pinId": "any"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "loopincrement",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "loopincrement",
            "pinId": "current"
          }
        }
      }
    },
    "id": "e087017d-a69a-4a02-ad00-c5263bf47365",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5ebc6dca-25d6-11eb-b3e1-5fd1eeef49f9": {
    "name": "count",
    "units": {
      "countfrom": {
        "id": "e087017d-a69a-4a02-ad00-c5263bf47365",
        "input": {
          "init": {
            "constant": true,
            "data": "1"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "sort-desc",
      "description": "iteratively count \`a\`, starting from 1",
      "tags": [
        "core",
        "loop"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "countfrom",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "countfrom",
            "pinId": "current"
          }
        }
      }
    },
    "id": "5ebc6dca-25d6-11eb-b3e1-5fd1eeef49f9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f022d16a-7a47-47c8-8d9b-3278df13bcc5": {
    "name": "is between",
    "inputs": {
      "c": {
        "plug": {
          "0": {
            "unitId": "lessthan",
            "pinId": "b"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "greaterthanequal",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a and b"
          }
        }
      }
    },
    "units": {
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a < b": {}
        },
        "metadata": {
          "position": {
            "x": 31,
            "y": -36
          }
        }
      },
      "greaterthanequal": {
        "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a ≥ b": {}
        },
        "metadata": {
          "position": {
            "x": 31,
            "y": 35
          }
        }
      },
      "and": {
        "id": "407640f7-f1c3-4297-a5ce-baff357a6d31",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a and b": {}
        },
        "metadata": {
          "position": {
            "x": -64,
            "y": -1
          }
        }
      }
    },
    "merges": {
      "0": {
        "greaterthanequal": {
          "input": {
            "a": true
          }
        },
        "lessthan": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "greaterthanequal": {
          "output": {
            "a ≥ b": true
          }
        },
        "and": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "lessthan": {
          "output": {
            "a < b": true
          }
        },
        "and": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether \`a\` is between \`b\` and \`c\`",
      "tags": [
        "core",
        "logic"
      ]
    },
    "id": "f022d16a-7a47-47c8-8d9b-3278df13bcc5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c059a789-b57c-4c2e-976b-fdbbe8f9993a": {
    "name": "and not",
    "units": {
      "and": {
        "id": "407640f7-f1c3-4297-a5ce-baff357a6d31"
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "and": {
          "input": {
            "b": true
          }
        },
        "not": {
          "output": {
            "!a": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a && !b": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a and b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ampersand",
      "description": "AND NOT logical operator",
      "tags": [
        "core",
        "logic"
      ]
    },
    "id": "c059a789-b57c-4c2e-976b-fdbbe8f9993a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6c3c8c8f-e383-46bc-ac0c-a294e65040bb": {
    "name": "50% chance",
    "units": {
      "random": {
        "id": "2b59f375-ef06-4ec7-80c2-71a53171ec67",
        "input": {},
        "output": {
          "random": {}
        }
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35",
        "input": {
          "b": {
            "constant": true,
            "data": "0.5"
          }
        },
        "output": {
          "a < b": {}
        }
      }
    },
    "merges": {
      "0": {
        "random": {
          "output": {
            "random": true
          }
        },
        "lessthan": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "random",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "lessthan",
            "pinId": "a < b"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "50%/50% true/false",
      "tags": [
        "core",
        "logic"
      ]
    },
    "id": "6c3c8c8f-e383-46bc-ac0c-a294e65040bb",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4433f550-6b85-4827-9aac-18b2c816818c": {
    "name": "2 bit condition",
    "units": {
      "nor": {
        "id": "561db4ce-1631-4d66-a047-140fb6e814a6"
      },
      "andnot": {
        "id": "c059a789-b57c-4c2e-976b-fdbbe8f9993a"
      },
      "and": {
        "id": "407640f7-f1c3-4297-a5ce-baff357a6d31"
      },
      "notand": {
        "id": "a4515f52-889c-4409-b710-59e2ebea265c"
      }
    },
    "merges": {
      "0": {
        "andnot": {
          "input": {
            "a": true
          }
        },
        "nor": {
          "input": {
            "a": true
          }
        },
        "and": {
          "input": {
            "a": true
          }
        },
        "notand": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "andnot": {
          "input": {
            "b": true
          }
        },
        "nor": {
          "input": {
            "b": true
          }
        },
        "and": {
          "input": {
            "b": true
          }
        },
        "notand": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a && b": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a and b"
          }
        }
      },
      "!a && !b": {
        "plug": {
          "0": {
            "unitId": "nor",
            "pinId": "!a && !b"
          }
        }
      },
      "a && !b": {
        "plug": {
          "0": {
            "unitId": "andnot",
            "pinId": "a && !b"
          }
        }
      },
      "!a && b": {
        "plug": {
          "0": {
            "unitId": "notand",
            "pinId": "!a && b"
          }
        }
      }
    },
    "metadata": {
      "icon": "binary",
      "description": "2 x 2 = 4",
      "tags": [
        "core",
        "logic"
      ]
    },
    "id": "4433f550-6b85-4827-9aac-18b2c816818c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ed5e826a-163c-42cd-8522-e47187decae7": {
    "name": "iterate wait",
    "units": {
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "iterate": {
          "input": {
            "next": true
          }
        }
      }
    },
    "inputs": {
      "init": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "init"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "current"
          }
        }
      },
      "local": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "local"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "iterate + wait",
      "tags": [
        "core",
        "iterate"
      ]
    },
    "id": "ed5e826a-163c-42cd-8522-e47187decae7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "58c50bb2-569f-4b7a-aba3-176d9ac91d5c": {
    "name": "iterate toggle",
    "units": {
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {}
        }
      }
    },
    "merges": {
      "0": {
        "not": {
          "output": {
            "!a": true
          }
        },
        "wait": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "iterate": {
          "input": {
            "next": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      },
      "2": {
        "not": {
          "input": {
            "a": true
          }
        },
        "iterate": {
          "output": {
            "local": true
          }
        }
      }
    },
    "metadata": {
      "icon": "toggle-right",
      "description": "iteratively toggle \`current\` value",
      "tags": [
        "core",
        "iterate"
      ]
    },
    "inputs": {
      "init": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "init"
          }
        }
      },
      "toggle": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "current"
          }
        }
      }
    },
    "id": "58c50bb2-569f-4b7a-aba3-176d9ac91d5c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "72513267-174e-4ea4-9561-b11dea518af5": {
    "name": "iterate sum from",
    "units": {
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {}
        }
      }
    },
    "merges": {
      "1": {
        "iterate": {
          "input": {
            "next": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      },
      "2": {
        "iterate": {
          "output": {
            "local": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "iterate \`sum\` by adding stream \`a\` starting \`from\`",
      "tags": [
        "core",
        "iterate"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a"
          }
        }
      },
      "from": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "sum": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "current"
          }
        }
      }
    },
    "id": "72513267-174e-4ea4-9561-b11dea518af5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9fa0c25b-0675-48dc-80e7-eab1829656bd": {
    "name": "iterate count from",
    "units": {
      "increment": {
        "id": "fafeadd7-06a8-4bb0-9fa5-2149d1b5208e",
        "input": {
          "a": {}
        },
        "output": {
          "a + 1": {}
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a": {}
        }
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {}
        }
      }
    },
    "merges": {
      "0": {
        "increment": {
          "output": {
            "a + 1": true
          }
        },
        "wait": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "iterate": {
          "output": {
            "local": true
          }
        },
        "increment": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "iterate": {
          "input": {
            "next": true
          }
        }
      }
    },
    "metadata": {
      "icon": "sort-desc",
      "description": "iteratively increment \`count\` starting from \`init\`",
      "tags": [
        "core",
        "iterate"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "current"
          }
        }
      }
    },
    "id": "9fa0c25b-0675-48dc-80e7-eab1829656bd",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "fb5bb9ea-bf24-4150-b12d-bc4873a153a2": {
    "name": "iterate count",
    "units": {
      "iteratecountfrom": {
        "id": "9fa0c25b-0675-48dc-80e7-eab1829656bd",
        "input": {
          "any": {},
          "init": {
            "constant": true,
            "data": "0"
          }
        },
        "output": {
          "current": {}
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "sort-desc",
      "description": "iteratively increment \`count\` starting from 0",
      "tags": [
        "core",
        "iterate"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "iteratecountfrom",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "count": {
        "plug": {
          "0": {
            "unitId": "iteratecountfrom",
            "pinId": "current"
          }
        }
      }
    },
    "id": "fb5bb9ea-bf24-4150-b12d-bc4873a153a2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "18e8759a-aa11-11eb-984d-339712a7789d": {
    "name": "set unit output data",
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "name"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -69,
              "y": -40
            }
          }
        }
      },
      "id": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "id"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -67,
              "y": 39
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "graph"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 66,
              "y": -34
            }
          }
        }
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -67,
              "y": 39
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "setunitpindata": {
        "id": "76e99304-aa0c-11eb-9bfa-07725a1b4287",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": 41,
                "y": -19
              }
            }
          },
          "id": {
            "metadata": {
              "position": {
                "x": -49,
                "y": 17
              }
            }
          },
          "type": {
            "constant": true,
            "data": "'output'",
            "metadata": {
              "position": {
                "x": 41,
                "y": 17
              }
            }
          },
          "name": {
            "metadata": {
              "position": {
                "x": -49,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -4,
            "y": -1
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` \`id\` unit \`name\` output pin \`data\`",
      "tags": [
        "core",
        "graph"
      ]
    },
    "id": "18e8759a-aa11-11eb-984d-339712a7789d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8a1ca6c0-af60-48cc-86bb-01e4e59598db": {
    "name": "set unit input data",
    "inputs": {
      "name": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "name"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -69,
              "y": -40
            }
          }
        }
      },
      "id": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "id"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -67,
              "y": 39
            }
          }
        }
      },
      "data": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "data"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -67,
              "y": 39
            }
          }
        }
      },
      "graph": {
        "plug": {
          "0": {
            "unitId": "setunitpindata",
            "pinId": "graph"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "x": 66,
              "y": -34
            }
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "setunitpindata": {
        "id": "76e99304-aa0c-11eb-9bfa-07725a1b4287",
        "input": {
          "graph": {
            "metadata": {
              "position": {
                "x": 41,
                "y": -19
              }
            }
          },
          "id": {
            "metadata": {
              "position": {
                "x": -49,
                "y": 17
              }
            }
          },
          "type": {
            "constant": true,
            "data": "'input'",
            "metadata": {
              "position": {
                "x": 41,
                "y": 17
              }
            }
          },
          "name": {
            "metadata": {
              "position": {
                "x": -49,
                "y": -19
              }
            }
          }
        },
        "output": {},
        "metadata": {
          "position": {
            "x": -4,
            "y": -1
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "circle",
      "description": "set \`graph\` \`id\` unit \`name\` input pin \`data\`",
      "tags": [
        "core",
        "graph"
      ]
    },
    "id": "8a1ca6c0-af60-48cc-86bb-01e4e59598db",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "349eb1a9-85ae-4fec-93f2-19ba3370b6c3": {
    "name": "wait all 2",
    "units": {
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "wait1": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      }
    },
    "merges": {
      "0": {
        "wait0": {
          "input": {
            "a": true
          }
        },
        "wait1": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "wait1": {
          "input": {
            "a": true
          }
        },
        "wait0": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "git-merge",
      "description": "wait for \`b\` and \`c\` before output \`a\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "wait1",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "a"
          }
        }
      }
    },
    "id": "349eb1a9-85ae-4fec-93f2-19ba3370b6c3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "67cca9ec-1976-47bc-b0d7-5b32e059f6f1": {
    "name": "wait 2",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "wait0": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "git-merge",
      "description": "wait for \`b\` and \`c\` before output \`a\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "inputs": {
      "c": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "b"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "a"
          }
        }
      }
    },
    "id": "67cca9ec-1976-47bc-b0d7-5b32e059f6f1",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9c10309b-6ce8-4b92-a0d4-a4b6b2a17a64": {
    "name": "switch a b",
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "switch",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "switch",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "switch",
            "pinId": "a"
          }
        }
      }
    },
    "units": {
      "constanttruefalse": {
        "id": "8df44351-9177-4c4c-abde-7576bc1c8d41",
        "input": {},
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -51,
            "y": 10
          }
        }
      },
      "switch": {
        "id": "c37c7c14-293e-414c-8a9c-01a40186c1e5",
        "input": {
          "c": {},
          "b": {},
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 50,
            "y": -11
          }
        }
      }
    },
    "merges": {
      "0": {
        "switch": {
          "input": {
            "c": true
          }
        },
        "constanttruefalse": {
          "output": {
            "a": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "map-signs",
      "description": "output \`a\` and \`b\`, interchangeably, forever",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "9c10309b-6ce8-4b92-a0d4-a4b6b2a17a64",
    "system": true
  },
  "0c78466f-f682-4aca-9a15-d4d2eac5e26d": {
    "name": "plan 3",
    "units": {
      "plan": {
        "id": "36329d25-218d-48a5-a06c-1e0525da504f"
      },
      "plan0": {
        "id": "36329d25-218d-48a5-a06c-1e0525da504f"
      }
    },
    "merges": {
      "0": {
        "plan0": {
          "output": {
            "1": true
          }
        },
        "plan": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "output \`a\` on \`0\`, then \`1\`, then \`2\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "plan0",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "0": {
        "plug": {
          "0": {
            "unitId": "plan0",
            "pinId": "0"
          }
        }
      },
      "1": {
        "plug": {
          "0": {
            "unitId": "plan",
            "pinId": "0"
          }
        }
      },
      "2": {
        "plug": {
          "0": {
            "unitId": "plan",
            "pinId": "1"
          }
        }
      }
    },
    "id": "0c78466f-f682-4aca-9a15-d4d2eac5e26d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f805b3c6-6c0e-4215-b3d6-91b93dc8a938": {
    "name": "pick lesser",
    "units": {
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05"
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      }
    },
    "merges": {
      "0": {
        "pick": {
          "input": {
            "a": true
          }
        },
        "lessthan": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "pick": {
          "input": {
            "b": true
          }
        },
        "lessthan": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "pick": {
          "input": {
            "c": true
          }
        },
        "lessthan": {
          "output": {
            "a < b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "pointer",
      "description": "pick the smalest from \`a\` and \`b\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "lesser": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      },
      "a < b": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "id": "f805b3c6-6c0e-4215-b3d6-91b93dc8a938",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "396497e4-f8e7-4573-95c9-a4f186a5cd05": {
    "name": "pick",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      }
    },
    "merges": {
      "0": {
        "ifnot": {
          "input": {
            "b": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "ifnot": {
          "output": {
            "a if not b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "c": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "metadata": {
      "icon": "pointer",
      "description": "conditional picker",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b6694fbe-4fc9-4779-92c6-4ba91c12718f": {
    "name": "is true",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {
            "constant": true,
            "data": "true"
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "true if \`a\` is true, false otherwise",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "b6694fbe-4fc9-4779-92c6-4ba91c12718f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b5f8a6bc-4fab-4905-a479-cf94e6e92448": {
    "name": "is false",
    "units": {
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda",
        "input": {
          "a": {
            "constant": true,
            "data": "true"
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a if not b"
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "true if \`a\` is false, false otherwise",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "b5f8a6bc-4fab-4905-a479-cf94e6e92448",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f55ab180-3fd5-44c4-915f-f40e6bbcc481": {
    "name": "invert",
    "units": {
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {
          "a": {},
          "b": {},
          "c": {}
        },
        "output": {
          "a": {}
        }
      },
      "pick0": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {
          "a": {},
          "b": {},
          "c": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "pick0",
            "pinId": "b"
          },
          "1": {
            "unitId": "pick",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "pick0",
            "pinId": "c"
          },
          "1": {
            "unitId": "pick",
            "pinId": "c"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "pick0",
            "pinId": "a"
          },
          "mertv": {
            "unitId": "pick",
            "pinId": "b"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "pick0",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "pointer",
      "description": "if \`c\` output \`a\` as \`b\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "f55ab180-3fd5-44c4-915f-f40e6bbcc481",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "439c6b56-a0b6-4b76-9131-c6dc23375fda": {
    "name": "if not",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "not": {
          "output": {
            "!a": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a if not b": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "reverse conditional operator",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "92760dd2-ecd9-46db-851f-70950a5b6bc3": {
    "name": "if else",
    "type": "\`U\`&\`G\`",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "a": true
          }
        },
        "ifnot": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "if": {
          "input": {
            "b": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "if": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      },
      "else": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a if not b"
          }
        }
      }
    },
    "metadata": {
      "icon": "map-signs",
      "description": "send \`a\` to \`if\` if \`b\` is false or \`else\` otherwise",
      "tags": [
        "core",
        "control"
      ]
    },
    "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3",
    "system": true
  },
  "1c59d8d8-5dc6-11ea-9bfb-9b22dd8d8cae": {
    "name": "if 4",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if2": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "if2": {
          "input": {
            "b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        },
        "if1": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "conditionally filter \`a\`, \`b\`, \`c\` and \`d\` based on \`test\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if0",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        }
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "if2",
            "pinId": "a"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "if2",
            "pinId": "a if b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "if0",
            "pinId": "a if b"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a if b"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "id": "1c59d8d8-5dc6-11ea-9bfb-9b22dd8d8cae",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "13a16a8a-5dc6-11ea-a3d4-9bda49772976": {
    "name": "if 3",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        },
        "if1": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "conditionally filter \`a\`, \`b\` and \`c\` based on \`test\`",
      "tags": [
        "core",
        "control"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if0",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if0",
            "pinId": "a if b"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a if b"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "id": "13a16a8a-5dc6-11ea-a3d4-9bda49772976",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "618898d6-1167-11eb-bef9-cb053e09c21b": {
    "name": "zero",
    "units": {
      "identity": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "0"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "0": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "zero",
      "description": "output 0",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "618898d6-1167-11eb-bef9-cb053e09c21b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "0c0954fb-07de-4722-87d8-b0989043335a": {
    "name": "two",
    "units": {
      "identity": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "2"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "2": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "dot-circle",
      "description": "output 2",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "0c0954fb-07de-4722-87d8-b0989043335a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d6d14fd8-4d8f-4d1c-94ac-f42b92f075e2": {
    "name": "true or false",
    "units": {
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "not0": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "if0": {
          "input": {
            "a": true,
            "b": true
          }
        },
        "not0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "not0": {
          "output": {
            "!a": true
          }
        },
        "if1": {
          "input": {
            "a": true,
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "a = true": {
        "plug": {
          "0": {
            "unitId": "if0",
            "pinId": "a if b"
          }
        }
      },
      "a = false": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "map-signs",
      "description": "direct \`a\` boolean value",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "d6d14fd8-4d8f-4d1c-94ac-f42b92f075e2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e24d1987-e3e7-4f1a-bf4a-191c79b2eae6": {
    "name": "true false",
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a[i]"
          }
        }
      }
    },
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "input": {
          "a": {}
        },
        "output": {
          "a[i]": {},
          "a": {
            "ignored": true
          },
          "i": {
            "ignored": true
          },
          "test": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": -1
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "[true,false]"
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "foreach": {
          "input": {
            "a": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "map-signs",
      "description": "outputs true and then false",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "e24d1987-e3e7-4f1a-bf4a-191c79b2eae6",
    "system": true
  },
  "a9405f74-fd5f-4e89-a66e-efe2ef9d6b70": {
    "name": "three",
    "units": {
      "identity": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "3"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "3": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "dot-circle",
      "description": "output 3",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "a9405f74-fd5f-4e89-a66e-efe2ef9d6b70",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "57e0cf37-1bf7-449e-91fd-f1ddf62c607d": {
    "name": "sum n from",
    "units": {
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      },
      "decrement": {
        "id": "4d67d2e4-8b06-4e15-8243-99be8e4be5d3"
      },
      "greaterthan0": {
        "id": "6f4ac2fa-e9bd-4c0e-8bda-75976f3e4e58"
      },
      "loop2": {
        "id": "eee90e0f-522d-4ac4-a0f1-abf5d69a4e26",
        "output": {
          "finalb": {
            "ignored": true
          },
          "locala": {
            "ignored": true
          },
          "finala": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop2": {
          "output": {
            "localb": true
          }
        },
        "greaterthan0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "loop2": {
          "input": {
            "test": true
          }
        },
        "greaterthan0": {
          "output": {
            "a > 0": true
          }
        }
      },
      "2": {
        "loop2": {
          "output": {
            "currentb": true
          }
        },
        "decrement": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "loop2": {
          "input": {
            "next b": true
          }
        },
        "decrement": {
          "output": {
            "a - 1": true
          }
        }
      },
      "4": {
        "loop2": {
          "input": {
            "next a": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      },
      "5": {
        "loop2": {
          "output": {
            "currenta": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "add \`n\` next numbers to \`from\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a"
          }
        }
      },
      "n": {
        "plug": {
          "0": {
            "unitId": "loop2",
            "pinId": "initb"
          }
        },
        "functional": true
      },
      "from": {
        "plug": {
          "0": {
            "unitId": "loop2",
            "pinId": "inita"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "sum": {
        "plug": {
          "0": {
            "unitId": "loop2",
            "pinId": "finala"
          }
        }
      }
    },
    "id": "57e0cf37-1bf7-449e-91fd-f1ddf62c607d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "74edae3f-87de-455c-a65a-e458334d2c47": {
    "name": "sum n",
    "units": {
      "sumnfrom": {
        "id": "57e0cf37-1bf7-449e-91fd-f1ddf62c607d",
        "input": {
          "from": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "plus",
      "description": "sum the next \`n\` \`a\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "sumnfrom",
            "pinId": "n"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "sumnfrom",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "sum": {
        "plug": {
          "0": {
            "unitId": "sumnfrom",
            "pinId": "sum"
          }
        }
      }
    },
    "id": "74edae3f-87de-455c-a65a-e458334d2c47",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "251ba609-a9c5-451b-8162-411c966bf919": {
    "name": "repeat n",
    "units": {
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "local": {
            "ignored": true
          }
        }
      },
      "loopdecrement": {
        "id": "95862764-be74-4372-b734-c767ddd3e323",
        "output": {
          "final": {
            "ignored": true
          },
          "current": {
            "ignored": true
          }
        }
      },
      "greaterthan0": {
        "id": "6f4ac2fa-e9bd-4c0e-8bda-75976f3e4e58"
      }
    },
    "merges": {
      "0": {
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "loopdecrement": {
          "input": {
            "test": true
          }
        },
        "greaterthan0": {
          "output": {
            "a > 0": true
          }
        }
      },
      "1": {
        "loopdecrement": {
          "output": {
            "local": true
          }
        },
        "greaterthan0": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "repeat-1",
      "description": "output \`a\` \`n\` times",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "loopdecrement",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "current"
          }
        }
      }
    },
    "id": "251ba609-a9c5-451b-8162-411c966bf919",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1f0e1e35-c920-4a3f-b71b-0e58f5c88bd3": {
    "name": "range array 6",
    "units": {
      "rangearray": {
        "id": "a0b5c3d9-7ee8-4c41-a299-1d32e707c673",
        "input": {
          "n": {
            "constant": true,
            "data": "6"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {},
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "rangearray",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "list-ordered",
      "description": "[0, 1, 2, 3, 4, 5]",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "1f0e1e35-c920-4a3f-b71b-0e58f5c88bd3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "587f9a76-de5f-4dc0-b395-6e5b0091d12e": {
    "name": "random natural lte",
    "units": {
      "randomnaturallt": {
        "id": "9569f78e-18d3-40a3-9373-c56afa0214f6"
      },
      "increment": {
        "id": "fafeadd7-06a8-4bb0-9fa5-2149d1b5208e"
      }
    },
    "merges": {
      "0": {
        "randomnaturallt": {
          "input": {
            "max": true
          }
        },
        "increment": {
          "output": {
            "a + 1": true
          }
        }
      }
    },
    "inputs": {
      "max": {
        "plug": {
          "0": {
            "unitId": "increment",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "randomnaturallt",
            "pinId": "i"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "output random natural \`i\` less than or equal to \`max\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "587f9a76-de5f-4dc0-b395-6e5b0091d12e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9d2b69b2-c468-4fca-a7d5-d158033c0201": {
    "name": "random natural between",
    "units": {
      "randomnaturallt": {
        "id": "9569f78e-18d3-40a3-9373-c56afa0214f6"
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f"
      }
    },
    "merges": {
      "0": {
        "add": {
          "input": {
            "a": true
          }
        },
        "subtract": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "add": {
          "input": {
            "b": true
          }
        },
        "randomnaturallt": {
          "output": {
            "i": true
          }
        }
      },
      "2": {
        "randomnaturallt": {
          "input": {
            "max": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a + b"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "output random natural \`n\` between \`a\` and \`b\`, not inclusive",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "9d2b69b2-c468-4fca-a7d5-d158033c0201",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9569f78e-18d3-40a3-9373-c56afa0214f6": {
    "name": "random natural",
    "units": {
      "random": {
        "id": "2b59f375-ef06-4ec7-80c2-71a53171ec67"
      },
      "floor": {
        "id": "3217edcf-2fa1-4dc4-af7c-d6fb607c888d"
      },
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7"
      }
    },
    "merges": {
      "0": {
        "random": {
          "output": {
            "random": true
          }
        },
        "multiply": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "multiply": {
          "output": {
            "a × b": true
          }
        },
        "floor": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "multiply": {
          "input": {
            "b": true
          }
        },
        "random": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "max": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "floor",
            "pinId": "⌊a⌋"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "random natural \`i\` less than \`max\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "9569f78e-18d3-40a3-9373-c56afa0214f6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e2325503-40a7-4c7e-b06c-d3833c8856e5": {
    "name": "random index in array",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "randomnaturallte": {
        "id": "9569f78e-18d3-40a3-9373-c56afa0214f6"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "randomnaturallte": {
          "input": {
            "max": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        },
        "metadata": {
          "examples": [
            "[0,1,2,3]"
          ]
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "randomnaturallte",
            "pinId": "i"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "random element of the array",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "e2325503-40a7-4c7e-b06c-d3833c8856e5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5b99b930-92c9-4fbe-be37-8c72a8e1c70b": {
    "name": "random in array",
    "units": {
      "randomindexinarray": {
        "id": "e2325503-40a7-4c7e-b06c-d3833c8856e5"
      },
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a"
      }
    },
    "merges": {
      "0": {
        "randomindexinarray": {
          "input": {
            "a": true
          }
        },
        "at": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "randomindexinarray": {
          "output": {
            "i": true
          }
        },
        "at": {
          "input": {
            "i": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "metadata": {
          "examples": [
            "[0,1,2,3,4]"
          ]
        }
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "random element of the array",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "5b99b930-92c9-4fbe-be37-8c72a8e1c70b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "be4600af-eb6b-417f-9bb6-88760afbbcba": {
    "name": "random bit matrix",
    "units": {
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b"
      },
      "randombitarray": {
        "id": "33ec13e7-5a30-4029-af21-07ee422a8a2d"
      },
      "repeatn": {
        "id": "251ba609-a9c5-451b-8162-411c966bf919"
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      }
    },
    "merges": {
      "0": {
        "narraybuilder": {
          "input": {
            "a": true
          }
        },
        "randombitarray": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "narraybuilder": {
          "input": {
            "n": true
          }
        },
        "repeatn": {
          "input": {
            "n": true
          }
        },
        "identity": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "randombitarray": {
          "input": {
            "n": true
          }
        },
        "repeatn": {
          "output": {
            "a": true
          }
        }
      },
      "3": {
        "repeatn": {
          "input": {
            "a": true
          }
        },
        "identity": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "metadata": {
      "icon": "binary",
      "description": "output a random bit matrix",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "be4600af-eb6b-417f-9bb6-88760afbbcba",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "33ec13e7-5a30-4029-af21-07ee422a8a2d": {
    "name": "random bit array",
    "units": {
      "randombit": {
        "id": "8a5043d9-e6ac-4628-9fde-a11cbd240e10",
        "input": {
          "any": {}
        },
        "output": {
          "bit": {}
        }
      },
      "range": {
        "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c",
        "input": {
          "a": {
            "constant": true,
            "data": "0"
          },
          "b": {}
        },
        "output": {
          "i": {}
        }
      },
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b",
        "input": {
          "a": {},
          "n": {}
        },
        "output": {
          "a[]": {}
        }
      }
    },
    "merges": {
      "0": {
        "randombit": {
          "input": {
            "any": true
          }
        },
        "range": {
          "output": {
            "i": true
          }
        }
      },
      "1": {
        "narraybuilder": {
          "input": {
            "a": true
          }
        },
        "randombit": {
          "output": {
            "bit": true
          }
        }
      },
      "2": {
        "range": {
          "input": {
            "b": true
          }
        },
        "narraybuilder": {
          "input": {
            "n": true
          }
        }
      }
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "random array of bits of size \`n\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "33ec13e7-5a30-4029-af21-07ee422a8a2d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8a5043d9-e6ac-4628-9fde-a11cbd240e10": {
    "name": "random bit",
    "units": {
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {
          "a": {
            "constant": true,
            "data": "0"
          },
          "b": {
            "constant": true,
            "data": "1"
          }
        }
      },
      "50chance": {
        "id": "6c3c8c8f-e383-46bc-ac0c-a294e65040bb",
        "input": {
          "any": {}
        }
      }
    },
    "merges": {
      "0": {
        "pick": {
          "input": {
            "c": true
          }
        },
        "50chance": {
          "output": {
            "test": true
          }
        }
      }
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "50chance",
            "pinId": "any"
          }
        }
      }
    },
    "outputs": {
      "bit": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "random",
      "description": "50% chance 0, 50% chance 1",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "8a5043d9-e6ac-4628-9fde-a11cbd240e10",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9a85acf3-c40b-4e82-b04c-68c3dd1b0d4b": {
    "name": "pick set",
    "units": {
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {
          "a": {},
          "b": {},
          "c": {}
        },
        "output": {
          "a": {}
        }
      },
      "set": {
        "id": "c4784b05-1f50-44ad-b812-545b3ed77614",
        "input": {
          "obj": {},
          "key": {},
          "value": {}
        },
        "output": {
          "obj": {}
        }
      }
    },
    "merges": {
      "0": {
        "pick": {
          "output": {
            "a": true
          }
        },
        "set": {
          "input": {
            "value": true
          }
        }
      }
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "c"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      },
      "key": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "key"
          }
        }
      },
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "set",
            "pinId": "obj"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets-curly",
      "description": "conditionally set \`obj\` property \`key\` to \`a\` or \`b\` based on \`test\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "9a85acf3-c40b-4e82-b04c-68c3dd1b0d4b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ea1389f2-3a83-44e5-ad8c-b29e03ab77d1": {
    "name": "pick branch",
    "units": {
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {}
      },
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3"
      }
    },
    "merges": {
      "0": {
        "pick": {
          "input": {
            "c": true
          }
        },
        "ifelse": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "pick": {
          "output": {
            "a": true
          }
        },
        "ifelse": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "pointer",
      "description": "filter \`a\` or \`b\` based on \`test\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "if"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "else"
          }
        }
      }
    },
    "id": "ea1389f2-3a83-44e5-ad8c-b29e03ab77d1",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "04bd8d41-7352-4609-b5af-603e4208775b": {
    "name": "pick 50% chance",
    "units": {
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05"
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "50chance": {
        "id": "6c3c8c8f-e383-46bc-ac0c-a294e65040bb"
      }
    },
    "merges": {
      "0": {
        "pick": {
          "input": {
            "b": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "pick": {
          "input": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "pick": {
          "input": {
            "c": true
          }
        },
        "50chance": {
          "output": {
            "test": true
          }
        }
      },
      "3": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "50chance": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "emrwe": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "scale",
      "description": "pick a or b, 50% chance",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "04bd8d41-7352-4609-b5af-603e4208775b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f488c69c-1167-11eb-875f-3354cd742d50": {
    "name": "one",
    "units": {
      "identity": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "1"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "1": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "dot-circle",
      "description": "output 1",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "f488c69c-1167-11eb-875f-3354cd742d50",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "a4515f52-889c-4409-b710-59e2ebea265c": {
    "name": "not and",
    "units": {
      "and": {
        "id": "407640f7-f1c3-4297-a5ce-baff357a6d31"
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "and": {
          "input": {
            "b": true
          }
        },
        "not": {
          "output": {
            "!a": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "!a && b": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a and b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ampersand",
      "description": "NOT AND logic operator",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "a4515f52-889c-4409-b710-59e2ebea265c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "561db4ce-1631-4d66-a047-140fb6e814a6": {
    "name": "nor",
    "units": {
      "or": {
        "id": "62a19cd6-04bd-4e46-a72e-4fa3516ad3fa"
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "or": {
          "output": {
            "a or b": true
          }
        },
        "not": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "or",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "or",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "!a && !b": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "!a"
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "NOT logic operator",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "561db4ce-1631-4d66-a047-140fb6e814a6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "85b8586a-0295-44fd-b3d2-24a048552700": {
    "name": "steps",
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        },
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "x": 43,
              "y": -60
            }
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": -36,
              "y": 4
            }
          }
        }
      }
    },
    "units": {
      "loopincrement": {
        "id": "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7",
        "output": {
          "current": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 30,
                "y": 56
              }
            }
          },
          "local": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -38,
                "y": 69
              }
            }
          }
        },
        "input": {
          "test": {},
          "init": {
            "metadata": {
              "position": {
                "x": -97,
                "y": 28
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -13,
            "y": 24
          }
        }
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35",
        "input": {
          "a": {},
          "b": {
            "constant": false
          }
        },
        "output": {
          "a < b": {}
        },
        "metadata": {
          "position": {
            "x": -105,
            "y": 3
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": 110,
                "y": -15
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {},
          "current": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -62,
                "y": -68
              }
            }
          },
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 9,
                "y": -74
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -21,
            "y": -32
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "0",
            "metadata": {
              "position": {
                "x": 133,
                "y": -18
              }
            }
          },
          "b": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 82,
            "y": -14
          }
        }
      }
    },
    "merges": {
      "0": {
        "loopincrement": {
          "output": {
            "local": true
          }
        },
        "lessthan": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "loopincrement": {
          "input": {
            "test": true
          }
        },
        "lessthan": {
          "output": {
            "a < b": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "2": {
        "looprepeat": {
          "output": {
            "local": true
          }
        },
        "lessthan": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "loopincrement": {
          "input": {
            "init": true
          }
        }
      },
      "4": {
        "wait": {
          "input": {
            "b": true
          }
        },
        "looprepeat": {
          "input": {
            "init": true
          }
        }
      }
    },
    "metadata": {
      "icon": "skip-forward",
      "description": "output true \`n\` times then false",
      "tags": [
        "core",
        "common"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -66,
            "y": 31
          },
          "1": {
            "x": -56,
            "y": 0
          },
          "2": {
            "x": -74,
            "y": -31
          },
          "3": {
            "x": 40,
            "y": 14
          },
          "4": {
            "x": 34,
            "y": -32
          }
        }
      }
    },
    "id": "85b8586a-0295-44fd-b3d2-24a048552700",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6c5543a6-d558-490d-8a94-20709375b10f": {
    "name": "n array builder from",
    "units": {
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "current": {
            "ignored": true
          }
        }
      },
      "arraybuilderfrom": {
        "id": "6db1905f-2343-4c63-97d3-07f4d946ef58",
        "output": {
          "acc": {
            "ignored": false
          }
        }
      },
      "lengthlessthan": {
        "id": "0e211b43-0d8d-44cb-b63f-79a1a02de614"
      }
    },
    "merges": {
      "0": {
        "lengthlessthan": {
          "input": {
            "a": true
          }
        },
        "arraybuilderfrom": {
          "output": {
            "local": true
          }
        }
      },
      "1": {
        "looprepeat": {
          "output": {
            "local": true
          }
        },
        "lengthlessthan": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "lengthlessthan": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "arraybuilderfrom": {
          "input": {
            "test": true
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "build a list of size n",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a"
          }
        }
      },
      "from": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "n": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a[]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "defaultIgnored": true
      },
      "acc": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "acc"
          }
        },
        "defaultIgnored": true
      }
    },
    "id": "6c5543a6-d558-490d-8a94-20709375b10f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "38033fcc-aa28-4df3-abc8-d4ece231028b": {
    "name": "n array builder",
    "units": {
      "buildarrayfrom": {
        "id": "6c5543a6-d558-490d-8a94-20709375b10f",
        "input": {
          "from": {
            "constant": true,
            "data": "[]"
          }
        },
        "output": {
          "acc": {
            "ignored": false
          },
          "test": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "unitId": "buildarrayfrom",
            "pinId": "n"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "buildarrayfrom",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "buildarrayfrom",
            "pinId": "a[]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "buildarrayfrom",
            "pinId": "test"
          }
        },
        "defaultIgnored": true
      },
      "acc": {
        "plug": {
          "0": {
            "unitId": "buildarrayfrom",
            "pinId": "acc"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "array",
      "description": "build a list of size n",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "38033fcc-aa28-4df3-abc8-d4ece231028b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "85343b1d-93db-4fc0-8fcf-655739dbd494": {
    "name": "max length",
    "units": {
      "max": {
        "id": "e857c770-5a98-4f8d-a0e1-b6cb126071ed"
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "length0": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      }
    },
    "merges": {
      "0": {
        "max": {
          "input": {
            "a": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        }
      },
      "1": {
        "max": {
          "input": {
            "b": true
          }
        },
        "length0": {
          "output": {
            "length": true
          }
        }
      }
    },
    "metadata": {
      "icon": "arrow-up",
      "description": "the biggest between size of \`a\` and size of \`b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length0",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "max": {
        "plug": {
          "0": {
            "unitId": "max",
            "pinId": "max"
          }
        }
      }
    },
    "id": "85343b1d-93db-4fc0-8fcf-655739dbd494",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6a006c91-181c-48c4-826d-a6eaec21fea3": {
    "name": "loop subtract",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          },
          "local": {
            "ignored": false
          }
        },
        "input": {}
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "b": {
            "constant": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "subtract": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "loop subtract the value of \`-\` from the current value",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "test"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "-": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "final": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      },
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "local"
          }
        }
      },
      "current": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "id": "6a006c91-181c-48c4-826d-a6eaec21fea3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ba8d655b-6014-4eae-bce1-fb8fef9ee535": {
    "name": "loop repeat",
    "units": {
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        }
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "identity": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "identity": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "test"
          }
        }
      }
    },
    "outputs": {
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "local"
          }
        }
      },
      "current": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "final": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "repeat",
      "description": "repeats \`a\` while \`next\` is true",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "70f3cdf1-2a78-49b3-9665-39da459cf0dc": {
    "name": "loop index desc",
    "units": {
      "loopdecrement": {
        "id": "95862764-be74-4372-b734-c767ddd3e323",
        "output": {
          "final": {
            "ignored": true
          }
        }
      },
      "greaterthanequal": {
        "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "lastindex": {
        "id": "f9588979-74e1-477a-8085-594043362fdf"
      }
    },
    "merges": {
      "0": {
        "loopdecrement": {
          "input": {
            "test": true
          }
        },
        "greaterthanequal": {
          "output": {
            "a ≥ b": true
          }
        }
      },
      "1": {
        "loopdecrement": {
          "output": {
            "local": true
          }
        },
        "greaterthanequal": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "loopdecrement": {
          "input": {
            "init": true
          }
        },
        "lastindex": {
          "output": {
            "last": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "lastindex",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "i": {
        "plug": {
          "0": {
            "unitId": "loopdecrement",
            "pinId": "current"
          }
        }
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "loop through array \`a\` elements in descending order",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "70f3cdf1-2a78-49b3-9665-39da459cf0dc",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7": {
    "name": "loop increment",
    "units": {
      "increment": {
        "id": "fafeadd7-06a8-4bb0-9fa5-2149d1b5208e"
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "increment": {
          "output": {
            "a + 1": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "increment": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "test"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "local"
          }
        }
      },
      "final": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "increment value until \`test\` is false",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4b6e5535-e600-4f91-a5df-105f6a5ad3d7": {
    "name": "loop forever",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": true
          },
          "local": {
            "ignored": true
          }
        },
        "input": {
          "test": {
            "constant": true,
            "data": "true"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "undo",
      "description": "loop forever",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "next": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "next"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "current"
          }
        }
      }
    },
    "id": "4b6e5535-e600-4f91-a5df-105f6a5ad3d7",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "95862764-be74-4372-b734-c767ddd3e323": {
    "name": "loop decrement",
    "units": {
      "decrement": {
        "id": "4d67d2e4-8b06-4e15-8243-99be8e4be5d3"
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "decrement": {
          "output": {
            "a - 1": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "decrement": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "test"
          }
        }
      }
    },
    "outputs": {
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "local"
          }
        }
      },
      "final": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      },
      "current": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "metadata": {
      "icon": "minus",
      "description": "decrement value until \`test\` is false",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "95862764-be74-4372-b734-c767ddd3e323",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "93369291-7ce2-4b4c-a414-870b1f3c9b4c": {
    "name": "loop add",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          },
          "local": {
            "ignored": false
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "b": {
            "constant": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "add": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "undo",
      "description": "loop adding the value of \`+\` to the current value",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "test"
          }
        }
      },
      "plus": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "local"
          }
        }
      },
      "final": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        },
        "defaultIgnored": true
      },
      "current": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "id": "93369291-7ce2-4b4c-a414-870b1f3c9b4c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "c37c7c14-293e-414c-8a9c-01a40186c1e5": {
    "name": "lever",
    "units": {
      "trueorfalse": {
        "id": "d6d14fd8-4d8f-4d1c-94ac-f42b92f075e2"
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      },
      "wait0": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc"
      }
    },
    "merges": {
      "0": {
        "trueorfalse": {
          "output": {
            "a = true": true
          }
        },
        "wait0": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "trueorfalse": {
          "output": {
            "a = false": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "merge2": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "wait0": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "c": {
        "plug": {
          "0": {
            "unitId": "trueorfalse",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "wait0",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "merge2"
          }
        }
      }
    },
    "metadata": {
      "icon": "map-signs",
      "description": "pick \`a\` or \`b\` based on \`test\`, but do not consume the other",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "c37c7c14-293e-414c-8a9c-01a40186c1e5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "568f2736-8734-464b-9bff-8e706e8d30ca": {
    "name": "less than or",
    "units": {
      "lt": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      },
      "gte": {
        "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b"
      }
    },
    "merges": {
      "0": {
        "gte": {
          "input": {
            "a": true
          }
        },
        "lt": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "gte": {
          "input": {
            "b": true
          }
        },
        "lt": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a < b": {
        "plug": {
          "0": {
            "unitId": "lt",
            "pinId": "a < b"
          }
        }
      },
      "a ≥ b": {
        "plug": {
          "0": {
            "unitId": "gte",
            "pinId": "a ≥ b"
          }
        }
      }
    },
    "metadata": {
      "icon": "less-than",
      "description": "less than operator",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "568f2736-8734-464b-9bff-8e706e8d30ca",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cc422ac4-f29c-419d-8628-f58315bd7660": {
    "name": "less than length",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      }
    },
    "merges": {
      "0": {
        "lessthan": {
          "input": {
            "b": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "lessthan",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "lessthan",
            "pinId": "a < b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "is \`a\` lesser than the size of \`b\`?",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "cc422ac4-f29c-419d-8628-f58315bd7660",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b82e2039-4b1d-4290-aa16-11939c1563c5": {
    "name": "length less than or",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "lessthanor": {
        "id": "568f2736-8734-464b-9bff-8e706e8d30ca"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "lessthanor": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "lessthanor",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "true": {
        "plug": {
          "0": {
            "unitId": "lessthanor",
            "pinId": "a < b"
          }
        }
      },
      "false": {
        "plug": {
          "0": {
            "unitId": "lessthanor",
            "pinId": "a ≥ b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "is the size of this \`list\` greater than or equal to \`n\`?",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "b82e2039-4b1d-4290-aa16-11939c1563c5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "0e211b43-0d8d-44cb-b63f-79a1a02de614": {
    "name": "length less than",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "lessthan": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "lessthan": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "lessthan",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "lessthan",
            "pinId": "a < b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "check whether the length of \`a\` lesser than \`b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "0e211b43-0d8d-44cb-b63f-79a1a02de614",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "603ebe2e-5329-446d-b422-78f3201ddd7a": {
    "name": "length greater than",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "greaterthan": {
        "id": "1651ce6b-4db0-4787-9edf-f770b72d253c"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "greaterthan": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "greaterthan",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "greaterthan",
            "pinId": "a > b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "check whether the length of \`a\` greater than \`b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "603ebe2e-5329-446d-b422-78f3201ddd7a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "175c0cc6-1801-4b5d-9980-e780c10ea745": {
    "name": "length equals",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5"
      }
    },
    "merges": {
      "merge0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "equals": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "equals": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "check whether the length of \`a\` is equal to \`n\`?",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "175c0cc6-1801-4b5d-9980-e780c10ea745",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f9588979-74e1-477a-8085-594043362fdf": {
    "name": "last index",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "decrement": {
        "id": "4d67d2e4-8b06-4e15-8243-99be8e4be5d3"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "decrement": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "last": {
        "plug": {
          "0": {
            "unitId": "decrement",
            "pinId": "a - 1"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "last position of \`a\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "f9588979-74e1-477a-8085-594043362fdf",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4465e3a5-40c6-4344-bcc1-94df5edb1899": {
    "type": "\`U\`&\`G\`",
    "name": "last",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 19,
                "y": 18
              }
            }
          },
          "i": {}
        },
        "output": {
          "a[i]": {
            "metadata": {
              "position": {
                "x": 101,
                "y": -14
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": -13
          }
        }
      },
      "lastindex": {
        "id": "f9588979-74e1-477a-8085-594043362fdf",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -101,
                "y": -34
              }
            }
          }
        },
        "output": {
          "last": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": -32
          }
        }
      }
    },
    "merges": {
      "0": {
        "at": {
          "input": {
            "i": true
          }
        },
        "lastindex": {
          "output": {
            "last": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "lastindex",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 18,
                "y": 42
              }
            },
            "1": {
              "ext": {
                "x": -124,
                "y": -37
              }
            }
          }
        }
      }
    },
    "outputs": {
      "a[-1]": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 124,
                "y": -16
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "last element of \`a\`",
      "position": {
        "merge": {
          "0": {
            "x": 0,
            "y": -26
          }
        }
      },
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "4465e3a5-40c6-4344-bcc1-94df5edb1899",
    "system": true
  },
  "7a7468e3-c6e4-4c0b-b561-967914250d9b": {
    "name": "keys equals",
    "units": {
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5"
      },
      "keys": {
        "id": "45b9c329-64e9-4c4a-800b-790947c75754"
      }
    },
    "merges": {
      "0": {
        "keys": {
          "output": {
            "keys": true
          }
        },
        "equals": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "keys",
            "pinId": "obj"
          }
        }
      },
      "keys": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "equals": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b"
          }
        }
      }
    },
    "metadata": {
      "icon": "equal",
      "description": "check whether \`obj\` has all \`keys\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "7a7468e3-c6e4-4c0b-b561-967914250d9b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "db072d27-eb40-4364-9104-8cd68b91e39a": {
    "type": "\`U\`&\`G\`",
    "name": "key equals",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -119,
                "y": 33
              }
            }
          },
          "key": {
            "metadata": {
              "position": {
                "x": -119,
                "y": -1
              }
            }
          }
        },
        "output": {
          "value": {
            "metadata": {
              "position": {
                "x": 87,
                "y": -41
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 94,
            "y": -41
          }
        }
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 58,
                "y": -48
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -71,
                "y": 22
              }
            }
          }
        },
        "output": {
          "a = b": {
            "metadata": {
              "position": {
                "x": 159,
                "y": 57
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 111,
            "y": 44
          }
        }
      },
      "haskey": {
        "id": "ad2ae8b9-9674-4b22-bed4-4458e0030b1a",
        "input": {
          "obj": {
            "metadata": {
              "position": {
                "x": -155,
                "y": -12
              }
            }
          },
          "key": {
            "metadata": {
              "position": {
                "x": -146,
                "y": -44
              }
            }
          }
        },
        "output": {
          "has": {}
        },
        "metadata": {
          "position": {
            "x": -104,
            "y": -18
          }
        }
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "metadata": {
          "position": {
            "x": -16,
            "y": -50
          }
        },
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -50,
                "y": -84
              }
            }
          }
        }
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "metadata": {
          "position": {
            "x": 6,
            "y": -6
          }
        },
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 52,
                "y": 7
              }
            }
          }
        }
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "metadata": {
          "position": {
            "x": -4,
            "y": 47
          }
        },
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -34,
                "y": 83
              }
            }
          }
        }
      },
      "iffalse": {
        "id": "bbbe75ed-d436-47d7-a9a0-59bcfa41dfda",
        "input": {
          "a": {}
        },
        "output": {
          "false": {
            "metadata": {
              "position": {
                "x": -139,
                "y": 54
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -92,
            "y": 35
          }
        }
      }
    },
    "merges": {
      "0": {
        "equals": {
          "input": {
            "b": true
          }
        },
        "get": {
          "output": {
            "value": true
          }
        }
      },
      "1": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "if0": {
          "output": {
            "a if b": true
          }
        }
      },
      "2": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "get": {
          "input": {
            "key": true
          }
        }
      },
      "3": {
        "equals": {
          "input": {
            "a": true
          }
        },
        "if1": {
          "output": {
            "a if b": true
          }
        }
      },
      "4": {
        "if0": {
          "input": {
            "b": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        },
        "haskey": {
          "output": {
            "has": true
          }
        },
        "if1": {
          "input": {
            "b": true
          }
        },
        "iffalse": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "haskey",
            "pinId": "obj",
            "kind": "input"
          },
          "1": {
            "unitId": "if0",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -180,
                "y": -11
              }
            },
            "1": {
              "ext": {
                "x": 71,
                "y": 19
              }
            }
          }
        }
      },
      "key": {
        "plug": {
          "0": {
            "unitId": "haskey",
            "pinId": "key",
            "kind": "input"
          },
          "2": {
            "unitId": "if",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -163,
                "y": -62
              }
            },
            "2": {
              "ext": {
                "x": -55,
                "y": -108
              }
            }
          }
        }
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -38,
                "y": 108
              }
            }
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b",
            "kind": "output"
          },
          "1": {
            "unitId": "iffalse",
            "pinId": "false",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 180,
                "y": 69
              }
            },
            "1": {
              "ext": {
                "x": -156,
                "y": 71
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether \`obj\` has \`key\` \`value\`",
      "position": {
        "merge": {
          "0": {
            "x": 128,
            "y": -3
          },
          "1": {
            "x": 50,
            "y": -29
          },
          "2": {
            "x": 41,
            "y": -60
          },
          "3": {
            "x": 55,
            "y": 56
          },
          "4": {
            "x": -46,
            "y": 2
          }
        }
      },
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "db072d27-eb40-4364-9104-8cd68b91e39a",
    "system": true
  },
  "f409eb04-77b5-49ad-b3aa-aeedde9b547f": {
    "name": "is multiple of",
    "units": {
      "remainder": {
        "id": "c5c05c85-f4c1-4b67-ab85-08b61fe67531"
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {
      "0": {
        "remainder": {
          "output": {
            "a % b": true
          }
        },
        "equals": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "remainder",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "remainder",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "a = b"
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether \`a\` is a multiple of \`b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "f409eb04-77b5-49ad-b3aa-aeedde9b547f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "194683f4-5b90-4501-a8c9-b34f131d4f79": {
    "name": "is empty",
    "units": {
      "lengthequals": {
        "id": "175c0cc6-1801-4b5d-9980-e780c10ea745",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "question",
      "description": "check whether \`obj\` is empty",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "obj": {
        "plug": {
          "0": {
            "unitId": "lengthequals",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "lengthequals",
            "pinId": "equals"
          }
        }
      }
    },
    "id": "194683f4-5b90-4501-a8c9-b34f131d4f79",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "86e310b3-4b84-4be2-a87a-e4ebcc5d3a0c": {
    "name": "integer half",
    "units": {
      "half": {
        "id": "49d04556-34fd-4231-a478-0e106b564e1c"
      },
      "floor": {
        "id": "3217edcf-2fa1-4dc4-af7c-d6fb607c888d"
      }
    },
    "merges": {
      "merge0": {
        "half": {
          "output": {
            "a ÷ 2": true
          }
        },
        "floor": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "half",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a ÷ 2": {
        "plug": {
          "0": {
            "unitId": "floor",
            "pinId": "⌊a⌋"
          }
        }
      }
    },
    "metadata": {
      "icon": "half",
      "description": "build a list of size n",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "86e310b3-4b84-4be2-a87a-e4ebcc5d3a0c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6ee7bbe1-3c5c-4e36-820e-4a9a923ad736": {
    "name": "infinity",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "Infinity"
          },
          "b": {}
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "inf": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "infinity",
      "description": "output Infinity",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "6ee7bbe1-3c5c-4e36-820e-4a9a923ad736",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "fafeadd7-06a8-4bb0-9fa5-2149d1b5208e": {
    "name": "increment",
    "units": {
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "b": {
            "constant": true,
            "data": "1"
          },
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a + 1": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a + b"
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "increment \`a\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "fafeadd7-06a8-4bb0-9fa5-2149d1b5208e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "9ee34534-a1e8-478d-87ca-81a5325f5d5c": {
    "name": "if true",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      },
      "identity0": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "a": true
          }
        },
        "identity": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "if": {
          "input": {
            "b": true
          }
        },
        "identity0": {
          "output": {
            "a": true
          }
        }
      },
      "2": {
        "identity": {
          "input": {
            "a": true
          }
        },
        "identity0": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "true": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "true if \`a\` is true",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "9ee34534-a1e8-478d-87ca-81a5325f5d5c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "bbbe75ed-d436-47d7-a9a0-59bcfa41dfda": {
    "name": "if false",
    "units": {
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      },
      "identity0": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      }
    },
    "merges": {
      "0": {
        "ifnot": {
          "input": {
            "a": true
          }
        },
        "identity": {
          "output": {
            "a": true
          }
        }
      },
      "1": {
        "ifnot": {
          "input": {
            "b": true
          }
        },
        "identity0": {
          "output": {
            "a": true
          }
        }
      },
      "2": {
        "identity": {
          "input": {
            "a": true
          }
        },
        "identity0": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "false": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a if not b"
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "false if \`a\` is false",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "bbbe75ed-d436-47d7-a9a0-59bcfa41dfda",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "62de5773-43bc-416c-b604-8fb529d7b299": {
    "name": "if else a ≤ b",
    "units": {
      "lessthanequal": {
        "id": "e13f3090-62a6-4a3b-8401-c571cbf03526"
      },
      "greaterthan": {
        "id": "1651ce6b-4db0-4787-9edf-f770b72d253c"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if1": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "greaterthan": {
          "input": {
            "b": true
          }
        },
        "lessthanequal": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "greaterthan": {
          "input": {
            "a": true
          }
        },
        "lessthanequal": {
          "input": {
            "a": true
          }
        },
        "if1": {
          "input": {
            "a": true
          }
        },
        "if0": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "greaterthan": {
          "output": {
            "a > b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "lessthanequal": {
          "output": {
            "a ≤ b": true
          }
        },
        "if1": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a ≤ b ? a": {
        "plug": {
          "0": {
            "unitId": "if1",
            "pinId": "a if b"
          }
        }
      },
      "a > b ? a": {
        "plug": {
          "0": {
            "unitId": "if0",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "forward \`a\` depending on \`a ≤ b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "62de5773-43bc-416c-b604-8fb529d7b299",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5fdf4aca-9bc3-11eb-9ae0-137ed72149df": {
    "name": "if else first",
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "first": {
        "plug": {
          "0": {
            "unitId": "bpdlaymdf",
            "pinId": "if"
          }
        }
      },
      "!first": {
        "plug": {
          "0": {
            "unitId": "bpdlaymdf",
            "pinId": "else"
          }
        }
      }
    },
    "units": {
      "isfirst": {
        "id": "fb311fff-521b-4066-b830-81d3a50f0f01",
        "input": {
          "a": {}
        },
        "output": {
          "test": {}
        },
        "metadata": {
          "position": {
            "x": -48,
            "y": -1
          }
        }
      },
      "bpdlaymdf": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "if": {},
          "else": {}
        },
        "metadata": {
          "position": {
            "x": 47,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "bpdlaymdf": {
          "input": {
            "b": true
          }
        },
        "isfirst": {
          "output": {
            "test": true
          }
        }
      },
      "1": {
        "bpdlaymdf": {
          "input": {
            "a": true
          }
        },
        "isfirst": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "map-signs",
      "description": "if else + is first",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "5fdf4aca-9bc3-11eb-9ae0-137ed72149df",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "bacfa026-d96f-4ea1-8430-86bb02d69a53": {
    "name": "if 50% chance",
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "50chance": {
        "id": "6c3c8c8f-e383-46bc-ac0c-a294e65040bb"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "50chance": {
          "output": {
            "test": true
          }
        }
      },
      "1": {
        "50chance": {
          "input": {
            "any": true
          }
        },
        "if": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "filter",
      "description": "50% chance of passing",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "bacfa026-d96f-4ea1-8430-86bb02d69a53",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5abe471c-c615-46ce-8a8c-158fcc8c1e5e": {
    "name": "hasn't length",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "equals": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "equals": {
          "output": {
            "a = b": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "length": {
          "input": {
            "a": true
          }
        },
        "ifnot": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "equals",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a if not b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "output list if size is equal to \`n\`?",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "5abe471c-c615-46ce-8a8c-158fcc8c1e5e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8211f5ea-2884-4ae8-aaf4-e98dbbedc10d": {
    "name": "has length less than",
    "units": {
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3"
      },
      "lengthlessthan": {
        "id": "0e211b43-0d8d-44cb-b63f-79a1a02de614"
      }
    },
    "merges": {
      "0": {
        "ifelse": {
          "input": {
            "b": true
          }
        },
        "lengthlessthan": {
          "output": {
            "test": true
          }
        }
      },
      "1": {
        "ifelse": {
          "input": {
            "a": true
          }
        },
        "lengthlessthan": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "lengthlessthan",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "true": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "if"
          }
        }
      },
      "false": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "else"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "output based on whether \`a\` size is less than \`b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "8211f5ea-2884-4ae8-aaf4-e98dbbedc10d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f317e5cd-63d0-4036-b958-09dfd04ab480": {
    "name": "has length",
    "units": {
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3"
      },
      "lengthequals": {
        "id": "175c0cc6-1801-4b5d-9980-e780c10ea745"
      }
    },
    "merges": {
      "0": {
        "ifelse": {
          "input": {
            "b": true
          }
        },
        "lengthequals": {
          "output": {
            "equals": true
          }
        }
      },
      "1": {
        "ifelse": {
          "input": {
            "a": true
          }
        },
        "lengthequals": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "lengthequals",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "false": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "else"
          }
        }
      },
      "true": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "if"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "output based on whether \`a\` size is equal to \`b\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "f317e5cd-63d0-4036-b958-09dfd04ab480",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "49d04556-34fd-4231-a478-0e106b564e1c": {
    "name": "half",
    "units": {
      "divide": {
        "id": "158d85eb-28b8-4355-b637-28a7ec751233",
        "input": {
          "b": {
            "constant": true,
            "data": "2"
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "divide",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a ÷ 2": {
        "plug": {
          "0": {
            "unitId": "divide",
            "pinId": "a ÷ b"
          }
        }
      }
    },
    "metadata": {
      "icon": "half",
      "description": "divide number by 2",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "49d04556-34fd-4231-a478-0e106b564e1c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "a8d162a8-1c5f-4b7f-abfb-877390ae4354": {
    "name": "greater than equal 0",
    "units": {
      "greaterthanequal": {
        "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "greater-than-equal",
      "description": "output whether \`a\` is greater than 0",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "greaterthanequal",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a ≥ 0": {
        "plug": {
          "0": {
            "unitId": "greaterthanequal",
            "pinId": "a ≥ b"
          }
        }
      }
    },
    "id": "a8d162a8-1c5f-4b7f-abfb-877390ae4354",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6f4ac2fa-e9bd-4c0e-8bda-75976f3e4e58": {
    "name": "greater than 0",
    "units": {
      "greaterthan": {
        "id": "1651ce6b-4db0-4787-9edf-f770b72d253c",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "greater-than",
      "description": "output whether \`a\` is greater than 0",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "greaterthan",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a > 0": {
        "plug": {
          "0": {
            "unitId": "greaterthan",
            "pinId": "a > b"
          }
        }
      }
    },
    "id": "6f4ac2fa-e9bd-4c0e-8bda-75976f3e4e58",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "dd7ae700-3016-4aba-a45f-5fa2c21cb00f": {
    "name": "for each reverse",
    "units": {
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "output": {
          "local": {
            "ignored": true
          }
        }
      },
      "loopdecrement": {
        "id": "95862764-be74-4372-b734-c767ddd3e323",
        "output": {
          "final": {
            "ignored": true
          }
        }
      },
      "lastindex": {
        "id": "f9588979-74e1-477a-8085-594043362fdf"
      },
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a"
      },
      "greaterthanequal": {
        "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b",
        "input": {
          "b": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {
      "0": {
        "loopdecrement": {
          "output": {
            "local": true
          }
        },
        "greaterthanequal": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "loopdecrement": {
          "input": {
            "test": true
          }
        },
        "greaterthanequal": {
          "output": {
            "a ≥ b": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "2": {
        "looprepeat": {
          "input": {
            "init": true
          }
        },
        "lastindex": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "loopdecrement": {
          "input": {
            "init": true
          }
        },
        "lastindex": {
          "output": {
            "last": true
          }
        }
      },
      "4": {
        "looprepeat": {
          "output": {
            "current": true
          }
        },
        "at": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "loopdecrement": {
          "output": {
            "current": true
          }
        },
        "at": {
          "input": {
            "i": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "output every element \`a[i]\` of \`a\` in decreasing order",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "dd7ae700-3016-4aba-a45f-5fa2c21cb00f",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "37dacb15-a5fe-468c-9495-6ec2c4ab6641": {
    "type": "\`U\`&\`G\`",
    "name": "filter key equals",
    "units": {
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -105,
                "y": 46
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -79,
                "y": 76
              }
            }
          },
          "current": {
            "metadata": {
              "position": {
                "x": -16,
                "y": 75
              }
            }
          },
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -110,
                "y": 23
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -56,
            "y": 32
          }
        }
      },
      "keyequals": {
        "id": "db072d27-eb40-4364-9104-8cd68b91e39a",
        "input": {
          "value": {
            "metadata": {
              "position": {
                "x": 166,
                "y": 35
              }
            }
          },
          "obj": {
            "metadata": {
              "position": {
                "x": 7,
                "y": 19
              }
            }
          },
          "key": {
            "metadata": {
              "position": {
                "x": 153,
                "y": 64
              }
            }
          }
        },
        "output": {
          "test": {
            "metadata": {
              "position": {
                "x": 155,
                "y": 14
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 32,
            "y": 33
          }
        }
      },
      "filter": {
        "id": "ea426391-2104-41fd-8963-626d21415d09",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 84,
                "y": -53
              }
            }
          },
          "test": {
            "metadata": {
              "position": {
                "x": -155,
                "y": 21
              }
            }
          }
        },
        "output": {
          "a[i]": {
            "metadata": {
              "position": {
                "x": 113,
                "y": -44
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": 105,
                "y": -24
              }
            }
          },
          "test": {
            "ignored": false
          },
          "a": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 39,
                "y": -62
              }
            }
          },
          "i": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 104,
                "y": -43
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 51,
            "y": -15
          }
        }
      },
      "looprepeat1": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -110,
                "y": -33
              }
            }
          },
          "test": {
            "metadata": {
              "position": {
                "x": 82,
                "y": -129
              }
            }
          }
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -98,
                "y": -56
              }
            }
          },
          "current": {
            "metadata": {
              "position": {
                "x": -11,
                "y": -91
              }
            }
          },
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -54,
                "y": -65
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -61,
            "y": -18
          }
        }
      }
    },
    "merges": {
      "0": {
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "filter": {
          "output": {
            "test": true
          }
        },
        "looprepeat1": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "keyequals": {
          "input": {
            "obj": true
          }
        },
        "filter": {
          "output": {
            "a[i]": true
          }
        }
      },
      "2": {
        "keyequals": {
          "input": {
            "value": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "3": {
        "keyequals": {
          "input": {
            "key": true
          }
        },
        "looprepeat1": {
          "output": {
            "current": true
          }
        }
      },
      "4": {
        "filter": {
          "input": {
            "test": true
          }
        },
        "keyequals": {
          "output": {
            "test": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "filter list \`a\` all elements with \`key\` \`value\`",
      "position": {
        "merge": {
          "0": {
            "x": -11,
            "y": -8
          },
          "1": {
            "x": 86,
            "y": 14
          },
          "2": {
            "x": -12,
            "y": 54
          },
          "3": {
            "x": -18,
            "y": 14
          },
          "4": {
            "x": 77,
            "y": 31
          }
        }
      },
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "filter",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 92,
                "y": -76
              }
            }
          }
        }
      },
      "key": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "looprepeat1",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -129,
                "y": -47
              }
            }
          }
        }
      },
      "value": {
        "functional": true,
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -126,
                "y": 58
              }
            }
          }
        }
      }
    },
    "outputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "filter",
            "pinId": "b",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 129,
                "y": -31
              }
            }
          }
        }
      }
    },
    "id": "37dacb15-a5fe-468c-9495-6ec2c4ab6641",
    "system": true
  },
  "51630f7a-fffb-42d7-8cf6-5a5924ec4774": {
    "name": "double",
    "units": {
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7",
        "input": {
          "b": {
            "constant": true,
            "data": "2"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "x",
      "description": "duplicate \`a\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "2a": {
        "plug": {
          "0": {
            "unitId": "multiply",
            "pinId": "a × b"
          }
        }
      }
    },
    "id": "51630f7a-fffb-42d7-8cf6-5a5924ec4774",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4d67d2e4-8b06-4e15-8243-99be8e4be5d3": {
    "name": "decrement",
    "units": {
      "decrement": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "b": {
            "constant": true,
            "data": "1"
          }
        },
        "output": {}
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "decrement",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a - 1": {
        "plug": {
          "0": {
            "unitId": "decrement",
            "pinId": "a - b"
          }
        }
      }
    },
    "metadata": {
      "icon": "minus",
      "description": "decrement \`a\`",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "4d67d2e4-8b06-4e15-8243-99be8e4be5d3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8df44351-9177-4c4c-abde-7576bc1c8d41": {
    "name": "constant true false",
    "inputs": {},
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "truefalse",
            "pinId": "a"
          }
        }
      }
    },
    "units": {
      "truefalse": {
        "id": "e24d1987-e3e7-4f1a-bf4a-191c79b2eae6",
        "input": {
          "any": {
            "constant": true,
            "data": "null"
          }
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "component": {},
    "metadata": {
      "description": "output true and false, forever",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "8df44351-9177-4c4c-abde-7576bc1c8d41",
    "system": true
  },
  "c6d4d8b4-b9cc-401a-98fe-37eaf71426b0": {
    "name": "constant one",
    "units": {
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {
            "constant": true,
            "data": "1"
          }
        },
        "output": {
          "a": {}
        }
      }
    },
    "merges": {},
    "inputs": {},
    "outputs": {
      "1": {
        "plug": {
          "0": {
            "unitId": "identity",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "dot-circle",
      "description": "one forever",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "c6d4d8b4-b9cc-401a-98fe-37eaf71426b0",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "baa94d4a-90a4-4b3d-8f4f-d10780c64754": {
    "name": "compare lte",
    "units": {
      "lessthanequal": {
        "id": "e13f3090-62a6-4a3b-8401-c571cbf03526"
      },
      "greaterthan": {
        "id": "1651ce6b-4db0-4787-9edf-f770b72d253c"
      }
    },
    "merges": {
      "0": {
        "lessthanequal": {
          "input": {
            "a": true
          }
        },
        "greaterthan": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "lessthanequal": {
          "input": {
            "b": true
          }
        },
        "greaterthan": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a ≤ b": {
        "plug": {
          "0": {
            "unitId": "lessthanequal",
            "pinId": "a ≤ b"
          }
        }
      },
      "a > b": {
        "plug": {
          "0": {
            "unitId": "greaterthan",
            "pinId": "a > b"
          }
        }
      }
    },
    "metadata": {
      "icon": "less-than-equal",
      "description": "less than euqal + greater than",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "baa94d4a-90a4-4b3d-8f4f-d10780c64754",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e2d48ad6-4212-45f4-940b-c614c44eb59b": {
    "name": "compare lt",
    "units": {
      "lt": {
        "id": "82c3cf2a-0855-4c6d-a4c4-807b0ce1fd35"
      },
      "gte": {
        "id": "c9e06816-0d2b-43ec-b7c8-d07563e19b6b"
      }
    },
    "merges": {
      "0": {
        "lt": {
          "input": {
            "a": true
          }
        },
        "gte": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "lt": {
          "input": {
            "b": true
          }
        },
        "gte": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a < b": {
        "plug": {
          "0": {
            "unitId": "lt",
            "pinId": "a < b"
          }
        },
        "functional": true
      },
      "a ≥ b": {
        "plug": {
          "0": {
            "unitId": "gte",
            "pinId": "a ≥ b"
          }
        },
        "functional": true
      }
    },
    "metadata": {
      "icon": "less-than",
      "description": "less than + greater than equal",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "e2d48ad6-4212-45f4-940b-c614c44eb59b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "625b208c-80e8-49bc-981c-dc69cfbc429d": {
    "name": "intersection",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "[]"
          }
        }
      },
      "id0": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      },
      "id1": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b"
      },
      "append": {
        "id": "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc"
      },
      "lengthequals": {
        "id": "175c0cc6-1801-4b5d-9980-e780c10ea745"
      },
      "ifnot0": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      },
      "ifnot1": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "id0": {
          "input": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "wait": {
          "output": {
            "a": true
          }
        },
        "append": {
          "output": {
            "a": true
          }
        },
        "lengthequals": {
          "input": {
            "a": true
          }
        },
        "if": {
          "input": {
            "a": true
          }
        },
        "ifnot1": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "id0": {
          "output": {
            "a": true
          }
        },
        "id1": {
          "output": {
            "a": true
          }
        },
        "ifnot0": {
          "input": {
            "a": true
          }
        },
        "lengthequals": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "lengthequals": {
          "output": {
            "equals": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        },
        "ifnot0": {
          "input": {
            "b": true
          }
        },
        "ifnot1": {
          "input": {
            "b": true
          }
        }
      },
      "4": {
        "ifnot1": {
          "output": {
            "a if not b": true
          }
        },
        "append": {
          "input": {
            "a": true
          }
        }
      },
      "merge5": {
        "ifnot0": {
          "output": {
            "a if not b": true
          }
        },
        "id1": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "build a list of size n",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "625b208c-80e8-49bc-981c-dc69cfbc429d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "36cca4eb-1d14-43bc-88da-5dbbd033e1aa": {
    "name": "array bitwise and",
    "units": {
      "level": {
        "id": "358fa592-55e4-49f5-be28-b66e5114b266",
        "input": {
          "with": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": true
          }
        }
      },
      "foreach0": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": true
          }
        }
      },
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b"
      },
      "and": {
        "id": "be6801c0-02e2-4f76-bcad-b68c80991fad"
      }
    },
    "merges": {
      "0": {
        "level": {
          "output": {
            "a[]": true
          }
        },
        "foreach0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "level": {
          "output": {
            "b[]": true
          }
        },
        "foreach": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "level": {
          "output": {
            "length": true
          }
        },
        "narraybuilder": {
          "input": {
            "n": true
          }
        }
      },
      "3": {
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "and": {
          "input": {
            "b": true
          }
        }
      },
      "4": {
        "foreach0": {
          "output": {
            "a[i]": true
          }
        },
        "and": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "and": {
          "output": {
            "a & b": true
          }
        },
        "narraybuilder": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "b[]": {
        "plug": {
          "0": {
            "unitId": "level",
            "pinId": "b[]"
          }
        },
        "functional": true
      },
      "a[]": {
        "plug": {
          "0": {
            "unitId": "level",
            "pinId": "a[]"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a & b": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "build new array \`a & b\` by bitwise and arrays \`a\` and \`b\` element by element",
      "tags": [
        "core",
        "common"
      ]
    },
    "id": "36cca4eb-1d14-43bc-88da-5dbbd033e1aa",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1c33668d-5aa9-4c45-bb8a-dfce14a2aded": {
    "type": "\`U\`&\`G\`",
    "name": "not",
    "units": {
      "xor": {
        "id": "3d59edf2-5fca-4475-9df0-d876e14f990d",
        "input": {
          "a": {},
          "b": {
            "constant": true,
            "data": "1"
          }
        },
        "output": {
          "a ^ b": {}
        },
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "xor",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "~a": {
        "plug": {
          "0": {
            "unitId": "xor",
            "pinId": "a ^ b"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "bitwise-not",
      "description": "bitwise NOT operator",
      "tags": [
        "core",
        "bitwise"
      ]
    },
    "id": "1c33668d-5aa9-4c45-bb8a-dfce14a2aded",
    "system": true
  },
  "bf7a541c-3085-477d-9640-ecd9ca22d7b2": {
    "name": "nor",
    "units": {
      "or": {
        "id": "0d656c2e-eb10-45f0-b236-f8916492ca86",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -107,
                "y": -28
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -107,
                "y": 8
              }
            }
          }
        },
        "output": {
          "a | b": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      },
      "not": {
        "id": "62d0c3e2-cf8b-4415-acfb-cf31739adce5",
        "input": {
          "a": {}
        },
        "output": {
          "~a": {
            "metadata": {
              "position": {
                "x": 90,
                "y": -10
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "not": {
          "input": {
            "a": true
          }
        },
        "or": {
          "output": {
            "a | b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "or",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "examples": [
            "0",
            "1"
          ],
          "position": {
            "0": {
              "x": -123,
              "y": -45
            }
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "or",
            "pinId": "b",
            "kind": "input"
          }
        },
        "metadata": {
          "examples": [
            "0",
            "1"
          ],
          "position": {
            "0": {
              "x": -123,
              "y": 25
            }
          }
        }
      }
    },
    "outputs": {
      "~(a | b)": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "~a",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 113,
              "y": -10
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "bitwise-nand",
      "description": "bitwise NAND operator",
      "tags": [
        "core",
        "bitwise"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -10,
            "y": -10
          }
        }
      }
    },
    "id": "bf7a541c-3085-477d-9640-ecd9ca22d7b2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "de60a07c-e166-41fa-9eef-da8cb22dc683": {
    "name": "nand",
    "units": {
      "and": {
        "id": "be6801c0-02e2-4f76-bcad-b68c80991fad",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -107,
                "y": -28
              }
            }
          },
          "b": {
            "metadata": {
              "position": {
                "x": -107,
                "y": 8
              }
            }
          }
        },
        "output": {
          "a & b": {}
        },
        "metadata": {
          "position": {
            "x": -52,
            "y": 0
          }
        }
      },
      "not": {
        "id": "62d0c3e2-cf8b-4415-acfb-cf31739adce5",
        "input": {
          "a": {}
        },
        "output": {
          "~a": {
            "metadata": {
              "position": {
                "x": 90,
                "y": -10
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 52,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "not": {
          "input": {
            "a": true
          }
        },
        "and": {
          "output": {
            "a & b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "a",
            "kind": "input"
          }
        },
        "metadata": {
          "examples": [
            "0",
            "1"
          ],
          "position": {
            "0": {
              "x": -123,
              "y": -45
            }
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "and",
            "pinId": "b",
            "kind": "input"
          }
        },
        "metadata": {
          "examples": [
            "0",
            "1"
          ],
          "position": {
            "0": {
              "x": -123,
              "y": 25
            }
          }
        }
      }
    },
    "outputs": {
      "~(a & b)": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "~a",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "x": 113,
              "y": -10
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "bitwise-nand",
      "description": "bitwise NAND operator",
      "tags": [
        "core",
        "bitwise"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -10,
            "y": -10
          }
        }
      }
    },
    "id": "de60a07c-e166-41fa-9eef-da8cb22dc683",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ea515441-7284-49ab-9bac-a0978f25e2c3": {
    "name": "validate",
    "units": {
      "throw": {
        "id": "99657eb7-fb94-474e-b03d-4b08c537c0a2"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "ifnot": {
          "output": {
            "a if not b": true
          }
        },
        "throw": {
          "input": {
            "message": true
          }
        }
      }
    },
    "metadata": {
      "icon": "alert-circle",
      "description": "pass if \`test\`, error \`message\` otherwise",
      "tags": [
        "core",
        "assert"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "message": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      }
    },
    "id": "ea515441-7284-49ab-9bac-a0978f25e2c3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "0047d386-e392-4230-adde-0d71a0bc2de4": {
    "name": "assert equal",
    "units": {
      "throw": {
        "id": "99657eb7-fb94-474e-b03d-4b08c537c0a2"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "notequal": {
        "id": "bda175a9-a9d2-4282-9b50-1b008ae8a807"
      }
    },
    "inputs": {
      "message": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "notequal",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "notequal",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "metadata": {
      "icon": "alert-circle",
      "description": "throw \`message\` if \`a\` is not equal \`b\`",
      "tags": [
        "core",
        "assert"
      ]
    },
    "merges": {
      "0": {
        "throw": {
          "input": {
            "message": true
          }
        },
        "if": {
          "output": {
            "a if b": true
          }
        }
      },
      "1": {
        "if": {
          "input": {
            "b": true
          }
        },
        "notequal": {
          "output": {
            "a ≠ b": true
          }
        }
      }
    },
    "id": "0047d386-e392-4230-adde-0d71a0bc2de4",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cbb46967-8627-4546-add8-6426e3730560": {
    "name": "assert",
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "b"
          }
        }
      },
      "message": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {},
    "units": {
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a if b": {}
        },
        "metadata": {
          "position": {
            "x": -50,
            "y": -1
          }
        }
      },
      "throw": {
        "id": "99657eb7-fb94-474e-b03d-4b08c537c0a2",
        "input": {
          "message": {}
        },
        "output": {},
        "metadata": {
          "position": {
            "x": 49,
            "y": 0
          }
        }
      }
    },
    "merges": {
      "0": {
        "throw": {
          "input": {
            "message": true
          }
        },
        "if": {
          "output": {
            "a if b": true
          }
        }
      }
    },
    "component": {},
    "metadata": {
      "icon": "alert-circle",
      "description": "throw \`message\` if \`test\` is false",
      "tags": [
        "core",
        "assert"
      ]
    },
    "id": "cbb46967-8627-4546-add8-6426e3730560",
    "system": true
  },
  "91536c82-8e5f-4542-8138-a1a4eb2e5f4d": {
    "name": "triplet",
    "units": {
      "single": {
        "id": "d2f8bb43-af44-4371-a32e-20b760695e13"
      },
      "pair": {
        "id": "a7d5c2f3-6134-4248-b9bc-33271c280267"
      },
      "concat": {
        "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728"
      }
    },
    "merges": {
      "0": {
        "concat": {
          "input": {
            "b": true
          }
        },
        "single": {
          "output": {
            "[a]": true
          }
        }
      },
      "1": {
        "concat": {
          "input": {
            "a": true
          }
        },
        "pair": {
          "output": {
            "pair": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "build array with elements \`0\` and \`1\` and \`2\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "0": {
        "plug": {
          "0": {
            "unitId": "pair",
            "pinId": "0"
          }
        }
      },
      "1": {
        "plug": {
          "0": {
            "unitId": "pair",
            "pinId": "1"
          }
        }
      },
      "2": {
        "plug": {
          "0": {
            "unitId": "single",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "91536c82-8e5f-4542-8138-a1a4eb2e5f4d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "706a0082-1dce-43d5-b629-9b6f8189e45d": {
    "name": "swap",
    "units": {
      "set0": {
        "id": "22622778-d64f-47e7-8ceb-d175edcc6562",
        "input": {
          "a": {},
          "i": {},
          "v": {}
        },
        "output": {
          "a": {}
        }
      },
      "set1": {
        "id": "22622778-d64f-47e7-8ceb-d175edcc6562",
        "input": {
          "a": {},
          "i": {},
          "v": {}
        },
        "output": {
          "a": {}
        }
      },
      "at0": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "a": {},
          "i": {}
        },
        "output": {
          "a[i]": {}
        }
      },
      "at1": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "a": {},
          "i": {}
        },
        "output": {
          "a[i]": {}
        }
      }
    },
    "merges": {
      "0": {
        "set0": {
          "input": {
            "a": true
          }
        },
        "at0": {
          "input": {
            "a": true
          }
        },
        "at1": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "set1": {
          "input": {
            "v": true
          }
        },
        "at1": {
          "output": {
            "a[i]": true
          }
        }
      },
      "2": {
        "set0": {
          "input": {
            "v": true
          }
        },
        "at0": {
          "output": {
            "a[i]": true
          }
        }
      },
      "3": {
        "set0": {
          "input": {
            "i": true
          }
        },
        "at1": {
          "input": {
            "i": true
          }
        }
      },
      "4": {
        "set0": {
          "output": {
            "a": true
          }
        },
        "set1": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "at0": {
          "input": {
            "i": true
          }
        },
        "set1": {
          "input": {
            "i": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "i": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        }
      },
      "j": {
        "plug": {
          "0": {
            "mergeId": "5"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "set1",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "swap elements at position \`i\` and \`j\` ",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "706a0082-1dce-43d5-b629-9b6f8189e45d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "bd1a9bbb-6129-4031-b7e9-aec351d847d9": {
    "name": "sum all",
    "units": {
      "reduce": {
        "id": "5cd76a8a-603b-49e1-bda3-09ad217eb108",
        "output": {
          "test": {
            "ignored": true
          }
        },
        "input": {
          "init": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      }
    },
    "merges": {
      "0": {
        "reduce": {
          "output": {
            "a[i]": true
          }
        },
        "add": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "reduce": {
          "output": {
            "local": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        }
      },
      "wvhfr": {
        "reduce": {
          "input": {
            "next": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "reduce",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "sum": {
        "plug": {
          "0": {
            "unitId": "reduce",
            "pinId": "result"
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "sum all elements of array \`a\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "bd1a9bbb-6129-4031-b7e9-aec351d847d9",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8babf4fa-e95e-449e-80b9-62e03ba0aae4": {
    "name": "split in half",
    "units": {
      "splitat": {
        "id": "de2d5ba8-ac0f-461e-849b-f4aa84d2736a",
        "metadata": {
          "position": {
            "x": 84,
            "y": -13
          }
        }
      },
      "inthalf": {
        "id": "86e310b3-4b84-4be2-a87a-e4ebcc5d3a0c",
        "metadata": {
          "position": {
            "x": -25,
            "y": -39
          }
        }
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8",
        "metadata": {
          "position": {
            "x": -25,
            "y": 12
          }
        }
      }
    },
    "merges": {
      "0": {
        "splitat": {
          "input": {
            "i": true
          }
        },
        "inthalf": {
          "output": {
            "a ÷ 2": true
          }
        }
      },
      "1": {
        "length": {
          "output": {
            "length": true
          }
        },
        "inthalf": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "splitat": {
          "input": {
            "a": true
          }
        },
        "length": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "first": {
        "plug": {
          "0": {
            "unitId": "splitat",
            "pinId": "first"
          }
        }
      },
      "second": {
        "plug": {
          "0": {
            "unitId": "splitat",
            "pinId": "second"
          }
        }
      }
    },
    "metadata": {
      "icon": "split-half",
      "description": "split array \`a\` in half",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "8babf4fa-e95e-449e-80b9-62e03ba0aae4",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "de2d5ba8-ac0f-461e-849b-f4aa84d2736a": {
    "name": "split at",
    "units": {
      "remove": {
        "id": "f69e88e3-b2c2-481b-b036-a5c0ed7ccccb"
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f"
      }
    },
    "merges": {
      "0": {
        "remove": {
          "input": {
            "a": true
          }
        },
        "length": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "length": {
          "output": {
            "length": true
          }
        },
        "subtract": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "remove": {
          "input": {
            "start": true
          }
        },
        "subtract": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "remove": {
          "input": {
            "count": true
          }
        },
        "subtract": {
          "output": {
            "a - b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "i": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      }
    },
    "outputs": {
      "second": {
        "plug": {
          "0": {
            "unitId": "remove",
            "pinId": "removed"
          }
        }
      },
      "first": {
        "plug": {
          "0": {
            "unitId": "remove",
            "pinId": "a"
          }
        }
      }
    },
    "metadata": {
      "icon": "split",
      "description": "split array \`a\` at index \`at\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "de2d5ba8-ac0f-461e-849b-f4aa84d2736a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "d2f8bb43-af44-4371-a32e-20b760695e13": {
    "name": "single",
    "units": {
      "append": {
        "id": "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc",
        "input": {
          "a": {
            "constant": true,
            "data": "[]"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "brackets",
      "description": "output a list with a single element \`a\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "[a]": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "a"
          }
        }
      }
    },
    "id": "d2f8bb43-af44-4371-a32e-20b760695e13",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5e6d3a86-f73e-46ce-9443-0f53e5a41d1c": {
    "name": "reverse",
    "units": {
      "foreachreverse": {
        "id": "dd7ae700-3016-4aba-a45f-5fa2c21cb00f"
      },
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b"
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      }
    },
    "merges": {
      "0": {
        "foreachreverse": {
          "input": {
            "a": true
          }
        },
        "length": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "narraybuilder": {
          "input": {
            "n": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        }
      },
      "2": {
        "narraybuilder": {
          "input": {
            "a": true
          }
        },
        "foreachreverse": {
          "output": {
            "a[i]": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "revert \`a\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "5e6d3a86-f73e-46ce-9443-0f53e5a41d1c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "55d4bc9e-a4a2-44ed-8b35-c9ae64b5d0e3": {
    "name": "remove index",
    "units": {
      "remove": {
        "id": "f69e88e3-b2c2-481b-b036-a5c0ed7ccccb",
        "input": {
          "a": {},
          "start": {},
          "count": {
            "constant": true,
            "data": "1"
          }
        },
        "output": {
          "a": {},
          "removed": {}
        }
      },
      "first": {
        "id": "0f77eb13-5c48-4611-a9bf-fe10c903dc63",
        "input": {
          "a": {}
        },
        "output": {
          "a[0]": {}
        }
      }
    },
    "merges": {
      "0": {
        "first": {
          "input": {
            "a": true
          }
        },
        "remove": {
          "output": {
            "removed": true
          }
        }
      }
    },
    "inputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "remove",
            "pinId": "start"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "remove",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "remove",
            "pinId": "a"
          }
        }
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "first",
            "pinId": "a[0]"
          }
        }
      }
    },
    "metadata": {
      "icon": "scissors",
      "description": "remove \`a\` element at position \`i\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "55d4bc9e-a4a2-44ed-8b35-c9ae64b5d0e3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "060945e7-055c-4891-849f-963f5adc9b63": {
    "type": "\`U\`&\`G\`",
    "name": "remove equals",
    "units": {
      "removeindex": {
        "id": "55d4bc9e-a4a2-44ed-8b35-c9ae64b5d0e3",
        "input": {
          "i": {},
          "a": {}
        },
        "output": {
          "a": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 84,
                "y": 25
              }
            }
          },
          "a[i]": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 75,
                "y": 52
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 34,
            "y": 25
          }
        }
      },
      "findequalindex": {
        "id": "8e312298-64a5-4e0a-abe1-47e75bcbd9d4",
        "input": {
          "b": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -113,
                "y": 25
              }
            }
          },
          "a": {
            "constant": false
          }
        },
        "output": {
          "i": {}
        },
        "metadata": {
          "position": {
            "x": -62,
            "y": 25
          }
        }
      }
    },
    "merges": {
      "0": {
        "removeindex": {
          "input": {
            "a": true
          }
        },
        "findequalindex": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "removeindex": {
          "input": {
            "i": true
          }
        },
        "findequalindex": {
          "output": {
            "i": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": false,
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -13,
                "y": -13
              }
            }
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "findequalindex",
            "pinId": "b",
            "kind": "input"
          }
        },
        "ref": false,
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -136,
                "y": 25
              }
            }
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "removeindex",
            "pinId": "a",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 107,
                "y": 25
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "remove the first element of \`a\` equals to \`b\`",
      "position": {
        "merge": {
          "0": {
            "x": -14,
            "y": 11
          },
          "1": {
            "x": -14,
            "y": 38
          }
        },
        "data": {
          "x": 150,
          "y": 25
        }
      },
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "060945e7-055c-4891-849f-963f5adc9b63",
    "system": true
  },
  "5cd76a8a-603b-49e1-bda3-09ad217eb108": {
    "name": "reduce",
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": false
          }
        }
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "next": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "next"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a[i]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "result": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      },
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "current"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "accumulatively iterate over array \`a\` to produce \`result\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "5cd76a8a-603b-49e1-bda3-09ad217eb108",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "a0b5c3d9-7ee8-4c41-a299-1d32e707c673": {
    "name": "range array",
    "units": {
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b",
        "input": {
          "n": {},
          "a": {}
        },
        "output": {
          "a[]": {}
        }
      },
      "range": {
        "id": "29e43ad7-be5e-437f-8f0f-2df996c8b89c",
        "input": {
          "a": {
            "constant": true,
            "data": "0"
          }
        }
      }
    },
    "merges": {
      "0": {
        "narraybuilder": {
          "input": {
            "a": true
          }
        },
        "range": {
          "output": {
            "i": true
          }
        }
      },
      "1": {
        "narraybuilder": {
          "input": {
            "n": true
          }
        },
        "range": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "metadata": {
          "description": "number of elements"
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "build an array from 0 to \`n\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "a0b5c3d9-7ee8-4c41-a299-1d32e707c673",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "7d7901df-7c97-4c66-b6e5-4a14c7c0fa75": {
    "type": "\`U\`&\`G\`",
    "name": "project",
    "units": {
      "map": {
        "id": "1c68d1e5-9170-417d-bfc8-fb7f7f12e714",
        "input": {
          "b[i]": {},
          "a": {}
        },
        "output": {
          "a[i]": {},
          "b": {},
          "test": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": -107,
            "y": 32
          }
        }
      },
      "getmany": {
        "id": "034734a1-719b-41af-845f-ea50a4964d52",
        "input": {
          "obj": {},
          "keys": {}
        },
        "output": {
          "obj": {}
        },
        "metadata": {
          "position": {
            "x": 107,
            "y": -24
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true
          },
          "current": {},
          "final": {
            "ignored": true
          }
        },
        "metadata": {
          "position": {
            "x": -1,
            "y": -10
          }
        }
      }
    },
    "merges": {
      "0": {
        "map": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "getmany": {
          "input": {
            "keys": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "2": {
        "getmany": {
          "input": {
            "obj": true
          }
        },
        "map": {
          "output": {
            "a[i]": true
          }
        }
      },
      "3": {
        "getmany": {
          "output": {
            "obj": true
          }
        },
        "map": {
          "input": {
            "b[i]": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "map",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "keys": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "map",
            "pinId": "b"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "create array \`b\` by getting \`keys\` from object array \`a\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "7d7901df-7c97-4c66-b6e5-4a14c7c0fa75",
    "system": true
  },
  "e75537f8-d35a-45c4-8193-e0c6e015b4c6": {
    "name": "prepend if not",
    "units": {
      "prependif": {
        "id": "5a8e4250-ad00-40a8-ae32-9f4aeeb8ab2e"
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "prependif": {
          "input": {
            "test": true
          }
        },
        "not": {
          "output": {
            "!a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "prepend element \`b\` to \`a\` if not \`test\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "prependif",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "prependif",
            "pinId": "b"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "prependif",
            "pinId": "a"
          }
        }
      }
    },
    "id": "e75537f8-d35a-45c4-8193-e0c6e015b4c6",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5a8e4250-ad00-40a8-ae32-9f4aeeb8ab2e": {
    "name": "prepend if",
    "units": {
      "prepend": {
        "id": "d9cf4224-39df-434a-85a6-2b143330cbab"
      },
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05"
      }
    },
    "merges": {
      "0": {
        "prepend": {
          "input": {
            "a": true
          }
        },
        "pick": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "prepend": {
          "output": {
            "a": true
          }
        },
        "pick": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "prepend element \`b\` to \`a\` if \`test\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "c"
          }
        },
        "functional": true
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "prepend",
            "pinId": "b"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "a"
          }
        }
      }
    },
    "id": "5a8e4250-ad00-40a8-ae32-9f4aeeb8ab2e",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "bad2ec99-81c0-4a7d-9b3a-562b870c13eb": {
    "type": "\`U\`&\`G\`",
    "name": "pluck",
    "units": {
      "get": {
        "id": "9414421d-3376-4438-aa03-7afcd860972c",
        "input": {
          "obj": {},
          "key": {}
        },
        "output": {
          "value": {}
        }
      },
      "map": {
        "id": "1c68d1e5-9170-417d-bfc8-fb7f7f12e714",
        "input": {
          "b[i]": {},
          "a": {}
        },
        "output": {
          "a[i]": {},
          "b": {},
          "test": {
            "ignored": false
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {},
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true
          },
          "current": {},
          "final": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "get": {
          "input": {
            "key": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "1": {
        "get": {
          "input": {
            "obj": true
          }
        },
        "map": {
          "output": {
            "a[i]": true
          }
        }
      },
      "2": {
        "map": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "get": {
          "output": {
            "value": true
          }
        },
        "map": {
          "input": {
            "b[i]": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "map",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "key": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "b": {
        "ref": false,
        "plug": {
          "0": {
            "unitId": "map",
            "pinId": "b"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "map array objects \`a\` to their \`key\` values",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "bad2ec99-81c0-4a7d-9b3a-562b870c13eb",
    "system": true
  },
  "a7d5c2f3-6134-4248-b9bc-33271c280267": {
    "name": "pair",
    "units": {
      "concat": {
        "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728"
      },
      "single": {
        "id": "d2f8bb43-af44-4371-a32e-20b760695e13"
      },
      "single0": {
        "id": "d2f8bb43-af44-4371-a32e-20b760695e13"
      }
    },
    "merges": {
      "0": {
        "concat": {
          "input": {
            "b": true
          }
        },
        "single": {
          "output": {
            "[a]": true
          }
        }
      },
      "1": {
        "concat": {
          "input": {
            "a": true
          }
        },
        "single0": {
          "output": {
            "[a]": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "build array with elements \`0\` and \`1\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "0": {
        "plug": {
          "0": {
            "unitId": "single0",
            "pinId": "a"
          }
        }
      },
      "1": {
        "plug": {
          "0": {
            "unitId": "single",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "pair": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "a7d5c2f3-6134-4248-b9bc-33271c280267",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "2dbdf0a4-09c1-49af-b9f8-d51b5cbab5a2": {
    "name": "array multiply",
    "units": {
      "map2": {
        "id": "57880ebc-bf8a-42da-b2b1-01ae188aa1fa"
      },
      "multiply": {
        "id": "872be100-f4dc-4246-8eea-6e3da31137b7"
      }
    },
    "merges": {
      "0": {
        "map2": {
          "output": {
            "a[i]": true
          }
        },
        "multiply": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "map2": {
          "output": {
            "b[i]": true
          }
        },
        "multiply": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "multiply": {
          "output": {
            "a × b": true
          }
        },
        "map2": {
          "input": {
            "c[i]": true
          }
        }
      }
    },
    "metadata": {
      "icon": "x",
      "description": "build new array by multiply arrays \`a\` and \`b\` element by element",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "map2",
            "pinId": "b"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "map2",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "ab": {
        "plug": {
          "0": {
            "unitId": "map2",
            "pinId": "c"
          }
        }
      }
    },
    "id": "2dbdf0a4-09c1-49af-b9f8-d51b5cbab5a2",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "28ee1447-9e5d-4e18-8a9d-90fedfceb4ff": {
    "name": "map 2 from",
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": false
          }
        }
      },
      "foreach1": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": true
          }
        }
      },
      "arraybuilderfrom": {
        "id": "6db1905f-2343-4c63-97d3-07f4d946ef58",
        "output": {
          "local": {
            "ignored": true
          },
          "acc": {
            "ignored": true
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "arraybuilderfrom": {
          "input": {
            "test": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "foreach1",
            "pinId": "a"
          }
        }
      },
      "c[i]": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "b[i]": {
        "plug": {
          "0": {
            "unitId": "foreach1",
            "pinId": "a[i]"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a[]"
          }
        }
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a[i]"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "map elements of arrays \`a\` and \`b\` to a new array \`c\` starting from index \`from\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "28ee1447-9e5d-4e18-8a9d-90fedfceb4ff",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "57880ebc-bf8a-42da-b2b1-01ae188aa1fa": {
    "name": "map 2",
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": false
          }
        }
      },
      "foreach1": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": true
          }
        }
      },
      "arraybuilderfrom": {
        "id": "6db1905f-2343-4c63-97d3-07f4d946ef58",
        "output": {
          "local": {
            "ignored": true
          },
          "acc": {
            "ignored": true
          }
        }
      },
      "wait2": {
        "id": "67cca9ec-1976-47bc-b0d7-5b32e059f6f1",
        "input": {
          "a": {
            "constant": true,
            "data": "[]"
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "arraybuilderfrom": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "wait2": {
          "input": {
            "c": true
          }
        },
        "foreach1": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "arraybuilderfrom": {
          "input": {
            "init": true
          }
        },
        "wait2": {
          "output": {
            "a": true
          }
        }
      },
      "3": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "wait2": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "c[i]": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "b[i]": {
        "plug": {
          "0": {
            "unitId": "foreach1",
            "pinId": "a[i]"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a[]"
          }
        }
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a[i]"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "map elements of arrays \`a\` and \`b\` to a new array \`c\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "57880ebc-bf8a-42da-b2b1-01ae188aa1fa",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "1c68d1e5-9170-417d-bfc8-fb7f7f12e714": {
    "name": "map",
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "test": {
            "ignored": false
          }
        }
      },
      "arraybuilderfrom": {
        "id": "6db1905f-2343-4c63-97d3-07f4d946ef58",
        "output": {
          "acc": {
            "ignored": true
          },
          "local": {
            "ignored": true
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "b": {
            "constant": false
          },
          "a": {
            "constant": true,
            "data": "[]"
          }
        }
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "arraybuilderfrom": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "arraybuilderfrom": {
          "input": {
            "init": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "b[i]": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a[i]"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a[]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "array",
      "description": "map elements of an array \`a\` to a new array \`b\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "1c68d1e5-9170-417d-bfc8-fb7f7f12e714",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "358fa592-55e4-49f5-be28-b66e5114b266": {
    "name": "level",
    "units": {
      "maxlength": {
        "id": "85343b1d-93db-4fc0-8fcf-655739dbd494"
      },
      "fillbothend": {
        "id": "b94fd858-9fa6-4487-bc2e-87801d3dfcc3"
      }
    },
    "merges": {
      "0": {
        "maxlength": {
          "output": {
            "max": true
          }
        },
        "fillbothend": {
          "input": {
            "n": true
          }
        }
      },
      "1": {
        "maxlength": {
          "input": {
            "a": true
          }
        },
        "fillbothend": {
          "input": {
            "a[]": true
          }
        }
      },
      "2": {
        "maxlength": {
          "input": {
            "b": true
          }
        },
        "fillbothend": {
          "input": {
            "b[]": true
          }
        }
      }
    },
    "inputs": {
      "with": {
        "plug": {
          "0": {
            "unitId": "fillbothend",
            "pinId": "with"
          }
        },
        "functional": true
      },
      "a[]": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "b[]": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "length": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "b[]": {
        "plug": {
          "0": {
            "unitId": "fillbothend",
            "pinId": "b[]"
          }
        }
      },
      "a[]": {
        "plug": {
          "0": {
            "unitId": "fillbothend",
            "pinId": "a[]"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "match arrays' length",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "358fa592-55e4-49f5-be28-b66e5114b266",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b74c6c04-8fe8-4009-9f61-b22f7a404342": {
    "name": "is not empty",
    "units": {
      "isempty": {
        "id": "194683f4-5b90-4501-a8c9-b34f131d4f79",
        "input": {
          "obj": {}
        }
      },
      "not": {
        "id": "7d02d638-a311-4ea8-a0c0-d45baf739e0d"
      }
    },
    "merges": {
      "0": {
        "isempty": {
          "output": {
            "test": true
          }
        },
        "not": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "check whether array \`a\` is empty",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "isempty",
            "pinId": "obj"
          }
        }
      }
    },
    "outputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "not",
            "pinId": "!a"
          }
        }
      }
    },
    "id": "b74c6c04-8fe8-4009-9f61-b22f7a404342",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5a7912c7-9c67-45b6-ae2b-e352405e6c16": {
    "name": "init",
    "units": {
      "repeatn": {
        "id": "251ba609-a9c5-451b-8162-411c966bf919"
      },
      "narraybuilder": {
        "id": "38033fcc-aa28-4df3-abc8-d4ece231028b"
      }
    },
    "merges": {
      "0": {
        "repeatn": {
          "input": {
            "n": true
          }
        },
        "narraybuilder": {
          "input": {
            "n": true
          }
        }
      },
      "1": {
        "repeatn": {
          "output": {
            "a": true
          }
        },
        "narraybuilder": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "init an array with length \`n\` filled with \`a\`'s",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "n": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "repeatn",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "narraybuilder",
            "pinId": "a[]"
          }
        }
      }
    },
    "id": "5a7912c7-9c67-45b6-ae2b-e352405e6c16",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8783e7de-6cde-11eb-bd74-574fd9c8b6aa": {
    "name": "includes",
    "inputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          },
          "1": {
            "unitId": "false",
            "pinId": "any"
          },
          "2": {
            "unitId": "zero",
            "pinId": "any"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "looprepeat0",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "found": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      }
    },
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {
            "constant": false
          }
        },
        "output": {
          "current": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 137,
                "y": 6
              }
            }
          },
          "local": {},
          "final": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 134,
                "y": -12
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 82,
            "y": -18
          }
        }
      },
      "loopincrement": {
        "id": "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7",
        "input": {
          "test": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -138,
                "y": -2
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -85,
            "y": 4
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -50,
                "y": -61
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {},
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -71,
                "y": -65
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -45,
            "y": -16
          }
        }
      },
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "a": {},
          "i": {}
        },
        "output": {
          "a[i]": {}
        },
        "metadata": {
          "position": {
            "x": -47,
            "y": 85
          }
        }
      },
      "lessthanlength": {
        "id": "cc422ac4-f29c-419d-8628-f58315bd7660",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "test": {}
        },
        "metadata": {
          "position": {
            "x": -103,
            "y": -87
          }
        }
      },
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a = b": {}
        },
        "metadata": {
          "position": {
            "x": 61,
            "y": 87
          }
        }
      },
      "looprepeat0": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": 19,
                "y": 71
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 2,
                "y": 51
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 90,
                "y": 84
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 48,
            "y": 36
          }
        }
      },
      "andnot": {
        "id": "c059a789-b57c-4c2e-976b-fdbbe8f9993a",
        "input": {
          "b": {},
          "a": {}
        },
        "output": {
          "a && !b": {}
        },
        "metadata": {
          "position": {
            "x": 5,
            "y": -67
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": 249,
                "y": -60
              }
            }
          }
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 198,
            "y": -55
          }
        }
      },
      "zero": {
        "id": "618898d6-1167-11eb-bef9-cb053e09c21b",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": -263,
                "y": 20
              }
            }
          }
        },
        "output": {
          "0": {}
        },
        "metadata": {
          "position": {
            "x": -211,
            "y": 19
          }
        }
      }
    },
    "merges": {
      "0": {
        "at": {
          "input": {
            "i": true
          }
        },
        "loopincrement": {
          "output": {
            "current": true
          }
        }
      },
      "1": {
        "lessthanlength": {
          "input": {
            "b": true
          }
        },
        "loopincrement": {
          "output": {
            "local": true
          }
        }
      },
      "2": {
        "looprepeat": {
          "output": {
            "local": true
          }
        },
        "lessthanlength": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "loopincrement": {
          "input": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "looprepeat0": {
          "input": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        },
        "andnot": {
          "output": {
            "a && !b": true
          }
        }
      },
      "4": {
        "looprepeat": {
          "output": {
            "current": true
          }
        },
        "at": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "equals": {
          "input": {
            "a": true
          }
        },
        "at": {
          "output": {
            "a[i]": true
          }
        }
      },
      "6": {
        "looprepeat0": {
          "output": {
            "current": true
          }
        },
        "equals": {
          "input": {
            "b": true
          }
        }
      },
      "7": {
        "andnot": {
          "input": {
            "b": true
          }
        },
        "loop": {
          "output": {
            "local": true
          }
        }
      },
      "8": {
        "andnot": {
          "input": {
            "a": true
          }
        },
        "lessthanlength": {
          "output": {
            "test": true
          }
        }
      },
      "9": {
        "equals": {
          "output": {
            "a = b": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      },
      "10": {
        "false": {
          "output": {
            "false": true
          }
        },
        "loop": {
          "input": {
            "init": true
          }
        }
      },
      "11": {
        "zero": {
          "output": {
            "0": true
          }
        },
        "loopincrement": {
          "input": {
            "init": true
          }
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "find whether array \`a[]\` contains an element of value \`a\`",
      "tags": [
        "core",
        "array"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -92,
            "y": 58
          },
          "1": {
            "x": -123,
            "y": -40
          },
          "2": {
            "x": -84,
            "y": -49
          },
          "3": {
            "x": 4,
            "y": -10
          },
          "4": {
            "x": -51,
            "y": 37
          },
          "5": {
            "x": 6,
            "y": 105
          },
          "6": {
            "x": 99,
            "y": 67
          },
          "7": {
            "x": 57,
            "y": -61
          },
          "8": {
            "x": -47,
            "y": -97
          },
          "9": {
            "x": 92,
            "y": 37
          },
          "10": {
            "x": 142,
            "y": -43
          },
          "11": {
            "x": -153,
            "y": 13
          }
        }
      }
    },
    "id": "8783e7de-6cde-11eb-bd74-574fd9c8b6aa",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "919d0a60-87cf-451b-a429-435aa70cde45": {
    "name": "head or default",
    "units": {
      "behead": {
        "id": "e9831075-2e62-43a4-84af-0653f7e707a9"
      },
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3"
      },
      "isempty": {
        "id": "194683f4-5b90-4501-a8c9-b34f131d4f79"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      }
    },
    "merges": {
      "0": {
        "ifelse": {
          "input": {
            "b": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        },
        "isempty": {
          "output": {
            "test": true
          }
        }
      },
      "1": {
        "ifelse": {
          "output": {
            "else": true
          }
        },
        "behead": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "object-get",
      "description": "head of array or default",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "a"
          },
          "1": {
            "unitId": "isempty",
            "pinId": "obj"
          }
        },
        "functional": true
      },
      "default": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "head": {
        "plug": {
          "0": {
            "unitId": "behead",
            "pinId": "head"
          },
          "1": {
            "unitId": "if",
            "pinId": "a if b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "behead",
            "pinId": "a"
          },
          "1": {
            "unitId": "ifelse",
            "pinId": "if"
          }
        }
      },
      "empty": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "id": "919d0a60-87cf-451b-a429-435aa70cde45",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f538e9b0-f172-4c9f-be23-86c715750b76": {
    "name": "for each from",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a"
      },
      "lessthanlength": {
        "id": "cc422ac4-f29c-419d-8628-f58315bd7660"
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535"
      },
      "loopincrement": {
        "id": "4e2c89b2-e9cb-42f6-bb8d-e9d665c21fa7",
        "output": {}
      }
    },
    "merges": {
      "0": {
        "lessthanlength": {
          "output": {
            "test": true
          }
        },
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "loopincrement": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "lessthanlength": {
          "input": {
            "a": true
          }
        },
        "looprepeat": {
          "output": {
            "local": true
          }
        }
      },
      "2": {
        "lessthanlength": {
          "input": {
            "b": true
          }
        },
        "loopincrement": {
          "output": {
            "local": true
          }
        }
      },
      "3": {
        "at": {
          "input": {
            "a": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "4": {
        "at": {
          "input": {
            "i": true
          }
        },
        "loopincrement": {
          "output": {
            "current": true
          }
        }
      }
    },
    "inputs": {
      "from": {
        "plug": {
          "0": {
            "unitId": "loopincrement",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        },
        "defaultIgnored": true
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "defaultIgnored": true
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "output every element of array \`a\` starting \`from\` index",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "f538e9b0-f172-4c9f-be23-86c715750b76",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857": {
    "name": "for each",
    "units": {
      "foreachfrom": {
        "id": "f538e9b0-f172-4c9f-be23-86c715750b76",
        "input": {
          "from": {
            "constant": true,
            "data": "0"
          }
        },
        "output": {
          "a": {
            "ignored": false
          },
          "i": {
            "ignored": false
          },
          "test": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "a[i]"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "a"
          }
        },
        "defaultIgnored": true
      },
      "i": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "i"
          }
        },
        "defaultIgnored": true
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "test"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "array",
      "description": "output every element of array \`a\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "df8ed55c-5f3d-460a-a7d7-2fa5aebaac53": {
    "name": "first 3",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "at0": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "1"
          }
        }
      },
      "at1": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "2"
          }
        }
      }
    },
    "merges": {
      "0": {
        "at1": {
          "input": {
            "a": true
          }
        },
        "at0": {
          "input": {
            "a": true
          }
        },
        "at": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "array \`a\`'s first 3 elements",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      }
    },
    "outputs": {
      "0": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]"
          }
        }
      },
      "1": {
        "plug": {
          "0": {
            "unitId": "at0",
            "pinId": "a[i]"
          }
        }
      },
      "2": {
        "plug": {
          "0": {
            "unitId": "at1",
            "pinId": "a[i]"
          }
        }
      }
    },
    "id": "df8ed55c-5f3d-460a-a7d7-2fa5aebaac53",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "a97f3eb4-854a-43e8-8881-a7081c3c1a53": {
    "type": "\`U\`&\`G\`",
    "name": "first",
    "units": {
      "at": {
        "id": "1625eaa0-a56c-4d35-919b-bc68ed626815",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 12,
                "y": 23
              }
            }
          },
          "i": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -9,
                "y": -292
              },
              "data": {
                "position": {
                  "x": -23,
                  "y": -321
                }
              }
            }
          },
          "done": {
            "metadata": {
              "position": {
                "x": 93,
                "y": -28
              }
            },
            "ignored": false
          }
        },
        "output": {
          "a[i]": {
            "metadata": {
              "position": {
                "x": 103,
                "y": 11
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 49,
            "y": -6
          }
        }
      },
      "zero": {
        "id": "618898d6-1167-11eb-bef9-cb053e09c21b",
        "input": {
          "any": {
            "metadata": {
              "position": {
                "x": -106,
                "y": -27
              }
            }
          }
        },
        "output": {
          "0": {}
        },
        "metadata": {
          "position": {
            "x": -57,
            "y": -25
          }
        }
      }
    },
    "merges": {
      "1": {
        "at": {
          "input": {
            "i": true
          }
        },
        "zero": {
          "output": {
            "0": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 7,
                "y": 46
              }
            }
          }
        }
      },
      "any": {
        "plug": {
          "0": {
            "unitId": "zero",
            "pinId": "any",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -129,
                "y": -30
              }
            }
          }
        }
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 108,
                "y": -46
              }
            }
          }
        }
      }
    },
    "outputs": {
      "a[0]": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]",
            "kind": "output"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 129,
                "y": 25
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "\`a\` element at position 0",
      "position": {
        "merge": {
          "1": {
            "x": -4,
            "y": -19
          }
        }
      },
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "a97f3eb4-854a-43e8-8881-a7081c3c1a53",
    "system": true
  },
  "0f77eb13-5c48-4611-a9bf-fe10c903dc63": {
    "name": "first",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "a": {},
          "i": {
            "constant": true,
            "data": "0"
          }
        },
        "output": {
          "a[i]": {}
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a[0]": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]"
          }
        }
      }
    },
    "metadata": {
      "icon": "info-square",
      "description": "\`a\` element at position 0",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "0f77eb13-5c48-4611-a9bf-fe10c903dc63",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "08d39098-c38f-4a88-9d8c-cc323730b36c": {
    "name": "find last index from or default",
    "units": {
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {
            "constant": false
          }
        },
        "output": {
          "current": {
            "ignored": false
          },
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      },
      "pick": {
        "id": "396497e4-f8e7-4573-95c9-a4f186a5cd05",
        "input": {
          "a": {},
          "b": {},
          "c": {}
        },
        "output": {
          "a": {}
        }
      },
      "foreachfrom": {
        "id": "f538e9b0-f172-4c9f-be23-86c715750b76",
        "input": {
          "from": {},
          "a": {}
        },
        "output": {
          "i": {
            "ignored": false
          },
          "a": {
            "ignored": false
          },
          "a[i]": {},
          "test": {}
        }
      }
    },
    "merges": {
      "0": {
        "pick": {
          "output": {
            "a": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      },
      "1": {
        "loop": {
          "output": {
            "current": true
          }
        },
        "pick": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "foreachfrom": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        }
      },
      "3": {
        "foreachfrom": {
          "output": {
            "i": true
          }
        },
        "pick": {
          "input": {
            "a": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "pick",
            "pinId": "c"
          }
        }
      },
      "from": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "from"
          }
        },
        "functional": true
      },
      "default": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "a"
          }
        },
        "defaultIgnored": true
      },
      "i": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "defaultIgnored": true
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "foreachfrom",
            "pinId": "a[i]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "defaultIgnored": true
      },
      "result": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "find index \`i\` of last element in array \`a\` for which \`test\` is true after index \`from\` or \`default\` if not found",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "08d39098-c38f-4a88-9d8c-cc323730b36c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "58e5ab50-dcc9-435a-8d17-87bc96b9b31c": {
    "name": "find last index from",
    "units": {
      "findlastindexfromordefault": {
        "id": "08d39098-c38f-4a88-9d8c-cc323730b36c",
        "input": {
          "a": {},
          "test": {},
          "from": {},
          "default": {
            "constant": true,
            "data": "-1"
          }
        },
        "output": {
          "a": {
            "ignored": false
          },
          "i": {
            "ignored": false
          },
          "a[i]": {},
          "result": {},
          "test": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "test"
          }
        }
      },
      "from": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "from"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "a[i]"
          }
        }
      },
      "result": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "result"
          }
        }
      },
      "i": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "i"
          }
        },
        "defaultIgnored": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "a"
          }
        },
        "defaultIgnored": true
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "findlastindexfromordefault",
            "pinId": "test"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "find index \`i\` of last element in array \`a\` for which \`test\` is true after index \`from\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "58e5ab50-dcc9-435a-8d17-87bc96b9b31c",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "411fbf6c-d5e2-42ba-8827-251233fb5bef": {
    "name": "find last index",
    "units": {
      "findlastindexfrom": {
        "id": "58e5ab50-dcc9-435a-8d17-87bc96b9b31c",
        "input": {
          "test": {},
          "from": {
            "constant": true,
            "data": "0"
          },
          "a": {}
        },
        "output": {
          "a[i]": {},
          "result": {},
          "i": {
            "ignored": false
          },
          "a": {
            "ignored": false
          },
          "test": {
            "ignored": false
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "a"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "test"
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "i"
          }
        },
        "defaultIgnored": true
      },
      "result": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "result"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "a"
          }
        },
        "defaultIgnored": true
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "a[i]"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "findlastindexfrom",
            "pinId": "test"
          }
        },
        "defaultIgnored": true
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "find index \`i\` of last element in array \`a\` for which \`test\` is true",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "411fbf6c-d5e2-42ba-8827-251233fb5bef",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "8e312298-64a5-4e0a-abe1-47e75bcbd9d4": {
    "type": "\`U\`&\`G\`",
    "name": "find index equals",
    "units": {
      "equals": {
        "id": "85204bf6-6692-4686-a785-23127c0594b5",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a = b": {}
        },
        "metadata": {
          "position": {
            "x": -67,
            "y": 32
          }
        }
      },
      "looprepeat": {
        "id": "ba8d655b-6014-4eae-bce1-fb8fef9ee535",
        "input": {
          "init": {
            "metadata": {
              "position": {
                "x": -132,
                "y": -43
              }
            }
          },
          "test": {}
        },
        "output": {
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -131,
                "y": -11
              }
            }
          },
          "current": {},
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -145,
                "y": -30
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -83,
            "y": -28
          }
        }
      },
      "findindex": {
        "id": "7ca98fbb-6e84-4133-b658-46329a8e45cf",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 74,
                "y": 21
              }
            }
          },
          "test": {}
        },
        "output": {
          "i": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 56,
                "y": 44
              }
            }
          },
          "test": {
            "ignored": false
          },
          "a[i]": {},
          "a": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 51,
                "y": -37
              }
            }
          },
          "result": {
            "metadata": {
              "position": {
                "x": 73,
                "y": -14
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 24,
            "y": 5
          }
        }
      }
    },
    "merges": {
      "0": {
        "equals": {
          "input": {
            "a": true
          }
        },
        "findindex": {
          "output": {
            "a[i]": true
          }
        }
      },
      "1": {
        "looprepeat": {
          "input": {
            "test": true
          }
        },
        "findindex": {
          "output": {
            "test": true
          }
        }
      },
      "2": {
        "equals": {
          "input": {
            "b": true
          }
        },
        "looprepeat": {
          "output": {
            "current": true
          }
        }
      },
      "3": {
        "equals": {
          "output": {
            "a = b": true
          }
        },
        "findindex": {
          "input": {
            "test": true
          }
        }
      }
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "looprepeat",
            "pinId": "init",
            "kind": "input"
          }
        },
        "ref": false,
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -151,
                "y": -57
              }
            }
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "findindex",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "functional": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 95,
                "y": 32
              }
            }
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "findindex",
            "pinId": "result",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 92,
                "y": -28
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "find the first element index of \`a\` which equals to \`b\`",
      "position": {
        "merge": {
          "0": {
            "x": -15,
            "y": 38
          },
          "1": {
            "x": -27,
            "y": -22
          },
          "2": {
            "x": -113,
            "y": 10
          },
          "3": {
            "x": -24,
            "y": 15
          }
        },
        "data": {
          "x": 115,
          "y": -49
        }
      },
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "8e312298-64a5-4e0a-abe1-47e75bcbd9d4",
    "system": true
  },
  "7ca98fbb-6e84-4133-b658-46329a8e45cf": {
    "name": "find index",
    "units": {
      "findlastindex": {
        "id": "411fbf6c-d5e2-42ba-8827-251233fb5bef",
        "input": {
          "a": {},
          "test": {}
        },
        "output": {
          "i": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 155,
                "y": -18
              }
            }
          },
          "result": {
            "metadata": {
              "position": {
                "x": 157,
                "y": 9
              }
            }
          },
          "a": {
            "ignored": false,
            "metadata": {
              "position": {
                "x": 134,
                "y": -40
              }
            }
          },
          "a[i]": {
            "metadata": {
              "position": {
                "x": 140,
                "y": 32
              }
            }
          },
          "test": {
            "ignored": false
          }
        },
        "metadata": {
          "position": {
            "x": 101,
            "y": -2
          }
        }
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "input": {
          "next": {},
          "test": {},
          "init": {}
        },
        "output": {
          "current": {},
          "local": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": -56,
                "y": 45
              }
            }
          },
          "final": {
            "ignored": true,
            "metadata": {
              "position": {
                "x": 15,
                "y": 31
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -23,
            "y": 3
          }
        }
      },
      "andnot": {
        "id": "c059a789-b57c-4c2e-976b-fdbbe8f9993a",
        "input": {
          "b": {},
          "a": {
            "metadata": {
              "position": {
                "x": -189,
                "y": -85
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": -137,
            "y": -77
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 41,
            "y": 73
          }
        }
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a if not b": {}
        },
        "metadata": {
          "position": {
            "x": -64,
            "y": -97
          }
        }
      },
      "iftrue0": {
        "id": "9ee34534-a1e8-478d-87ca-81a5325f5d5c",
        "input": {
          "a": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": -122,
            "y": -26
          }
        }
      },
      "identity0": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -42,
            "y": -49
          }
        }
      },
      "identity1": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": 39,
            "y": -87
          }
        }
      },
      "false0": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": -2,
            "y": -32
          }
        }
      },
      "identity": {
        "id": "260d774e-bc89-4027-aa92-cb1985fb312b",
        "input": {
          "a": {}
        },
        "output": {
          "a": {}
        },
        "metadata": {
          "position": {
            "x": -108,
            "y": 17
          }
        }
      }
    },
    "merges": {
      "0": {
        "loop": {
          "input": {
            "test": true
          }
        },
        "findlastindex": {
          "output": {
            "test": true
          }
        }
      },
      "1": {
        "andnot": {
          "input": {
            "b": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        },
        "ifnot": {
          "input": {
            "b": true
          }
        },
        "iftrue0": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "findlastindex": {
          "input": {
            "test": true
          }
        },
        "identity1": {
          "output": {
            "a": true
          }
        },
        "false0": {
          "output": {
            "false": true
          }
        }
      },
      "3": {
        "false": {
          "input": {
            "any": true
          }
        },
        "findlastindex": {
          "input": {
            "a": true
          }
        }
      },
      "4": {
        "false": {
          "output": {
            "false": true
          }
        },
        "loop": {
          "input": {
            "init": true
          }
        }
      },
      "5": {
        "ifnot": {
          "input": {
            "a": true
          }
        },
        "andnot": {
          "output": {
            "a && !b": true
          }
        }
      },
      "6": {
        "identity0": {
          "output": {
            "a": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        },
        "identity": {
          "output": {
            "a": true
          }
        }
      },
      "7": {
        "ifnot": {
          "output": {
            "a if not b": true
          }
        },
        "identity1": {
          "input": {
            "a": true
          }
        },
        "identity0": {
          "input": {
            "a": true
          }
        }
      },
      "8": {
        "iftrue0": {
          "output": {
            "true": true
          }
        },
        "identity": {
          "input": {
            "a": true
          }
        },
        "false0": {
          "input": {
            "any": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 92,
                "y": 71
              }
            }
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "andnot",
            "pinId": "a"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -213,
                "y": -91
              }
            }
          }
        }
      }
    },
    "outputs": {
      "i": {
        "plug": {
          "0": {
            "unitId": "findlastindex",
            "pinId": "i"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 178,
                "y": -28
              }
            }
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 45,
                "y": 27
              }
            }
          }
        }
      },
      "a[i]": {
        "plug": {
          "0": {
            "unitId": "findlastindex",
            "pinId": "a[i]"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 155,
                "y": 53
              }
            }
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "findlastindex",
            "pinId": "a"
          }
        },
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 146,
                "y": -62
              }
            }
          }
        }
      },
      "result": {
        "plug": {
          "0": {
            "unitId": "findlastindex",
            "pinId": "result"
          }
        },
        "defaultIgnored": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 182,
                "y": 15
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "find index \`i\` of first element in array \`a\` for which \`test\` is true",
      "tags": [
        "core",
        "array"
      ],
      "position": {
        "merge": {
          "0": {
            "x": 39,
            "y": 5
          },
          "1": {
            "x": -80,
            "y": -47
          },
          "2": {
            "x": 56,
            "y": -40
          },
          "3": {
            "x": 84,
            "y": 48
          },
          "4": {
            "x": -4,
            "y": 52
          },
          "5": {
            "x": -110,
            "y": -113
          },
          "6": {
            "x": -65,
            "y": 2
          },
          "7": {
            "x": -12,
            "y": -90
          },
          "8": {
            "x": -68,
            "y": -17
          }
        }
      }
    },
    "id": "7ca98fbb-6e84-4133-b658-46329a8e45cf",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f0386b2f-de73-49a3-be8f-1a2ca10600c5": {
    "name": "filter value equals",
    "units": {
      "filter": {
        "id": "ea426391-2104-41fd-8963-626d21415d09"
      },
      "propequal": {
        "id": "9df84140-dd90-48b3-a6a7-0651c8b5bfd7",
        "input": {
          "key": {
            "constant": false
          },
          "value": {
            "constant": false
          }
        }
      },
      "repeatn": {
        "id": "251ba609-a9c5-451b-8162-411c966bf919"
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "repeatn0": {
        "id": "251ba609-a9c5-451b-8162-411c966bf919"
      }
    },
    "merges": {
      "0": {
        "filter": {
          "input": {
            "test": true
          }
        },
        "propequal": {
          "output": {
            "equal": true
          }
        }
      },
      "1": {
        "filter": {
          "output": {
            "a[i]": true
          }
        },
        "propequal": {
          "input": {
            "obj": true
          }
        }
      },
      "2": {
        "propequal": {
          "input": {
            "value": true
          }
        },
        "repeatn0": {
          "output": {
            "a": true
          }
        }
      },
      "3": {
        "propequal": {
          "input": {
            "key": true
          }
        },
        "repeatn": {
          "output": {
            "a": true
          }
        }
      },
      "4": {
        "filter": {
          "input": {
            "a": true
          }
        },
        "length": {
          "input": {
            "a": true
          }
        }
      },
      "5": {
        "repeatn": {
          "input": {
            "n": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        },
        "repeatn0": {
          "input": {
            "n": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "filter \`a\` elements with prop \`k\` equal to \`v\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "key": {
        "plug": {
          "0": {
            "unitId": "repeatn",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "4"
          }
        },
        "functional": true
      },
      "value": {
        "plug": {
          "0": {
            "unitId": "repeatn0",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "filter",
            "pinId": "b"
          }
        }
      }
    },
    "id": "f0386b2f-de73-49a3-be8f-1a2ca10600c5",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "ea426391-2104-41fd-8963-626d21415d09": {
    "name": "filter",
    "units": {
      "foreach": {
        "id": "e2da2ac1-26bd-4c91-b8ad-a0395d9c8857",
        "output": {
          "a": {
            "ignored": false
          },
          "i": {
            "ignored": false
          },
          "test": {
            "ignored": false
          }
        }
      },
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "[]"
          }
        }
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "local": {
            "ignored": true
          },
          "current": {
            "ignored": false
          },
          "final": {
            "ignored": false
          }
        }
      },
      "appendif": {
        "id": "765114be-2c5e-4ac8-b04e-27dbcb60ac12"
      }
    },
    "merges": {
      "0": {
        "foreach": {
          "output": {
            "test": true
          }
        },
        "loop": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "foreach": {
          "output": {
            "a[i]": true
          }
        },
        "appendif": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "foreach": {
          "input": {
            "a": true
          }
        },
        "wait": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "loop": {
          "input": {
            "init": true
          }
        },
        "wait": {
          "output": {
            "a": true
          }
        }
      },
      "4": {
        "loop": {
          "input": {
            "next": true
          }
        },
        "appendif": {
          "output": {
            "a": true
          }
        }
      },
      "5": {
        "appendif": {
          "input": {
            "a": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "filter a list \`a\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "appendif",
            "pinId": "test"
          }
        }
      }
    },
    "outputs": {
      "a[i]": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "defaultIgnored": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "a"
          }
        },
        "defaultIgnored": true
      },
      "i": {
        "plug": {
          "0": {
            "unitId": "foreach",
            "pinId": "i"
          }
        },
        "defaultIgnored": true
      }
    },
    "id": "ea426391-2104-41fd-8963-626d21415d09",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b0995ebb-08d5-4740-9bf3-272d44f09595": {
    "name": "fill end",
    "units": {
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f"
      },
      "init": {
        "id": "5a7912c7-9c67-45b6-ae2b-e352405e6c16"
      },
      "concat": {
        "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728"
      }
    },
    "merges": {
      "0": {
        "length": {
          "output": {
            "length": true
          }
        },
        "subtract": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "length": {
          "input": {
            "a": true
          }
        },
        "concat": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "subtract": {
          "output": {
            "a - b": true
          }
        },
        "init": {
          "input": {
            "n": true
          }
        }
      },
      "3": {
        "concat": {
          "input": {
            "b": true
          }
        },
        "init": {
          "output": {
            "a[]": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "fill \`from\` array with \`a\` until size \`n\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a[]": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "n": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "a"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "init",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "b0995ebb-08d5-4740-9bf3-272d44f09595",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b94fd858-9fa6-4487-bc2e-87801d3dfcc3": {
    "name": "fill both end",
    "units": {
      "fillend": {
        "id": "b0995ebb-08d5-4740-9bf3-272d44f09595"
      },
      "fillend0": {
        "id": "b0995ebb-08d5-4740-9bf3-272d44f09595"
      }
    },
    "merges": {
      "0": {
        "fillend": {
          "input": {
            "a": true
          }
        },
        "fillend0": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "fillend": {
          "input": {
            "n": true
          }
        },
        "fillend0": {
          "input": {
            "n": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "fill \`a\` and \`b\` with \`a\` until both have size \`n\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "fillend",
            "pinId": "a[]"
          }
        },
        "functional": true
      },
      "b[]": {
        "plug": {
          "0": {
            "unitId": "fillend0",
            "pinId": "a[]"
          }
        },
        "functional": true
      },
      "with": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "n": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      }
    },
    "outputs": {
      "a[]": {
        "plug": {
          "0": {
            "unitId": "fillend",
            "pinId": "a[]"
          }
        }
      },
      "b[]": {
        "plug": {
          "0": {
            "unitId": "fillend0",
            "pinId": "a[]"
          }
        }
      }
    },
    "id": "b94fd858-9fa6-4487-bc2e-87801d3dfcc3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "b226083c-2797-11eb-a546-c350370e09cb": {
    "name": "empty array",
    "units": {
      "wait": {
        "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
        "input": {
          "a": {
            "constant": true,
            "data": "[]"
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "brackets",
      "description": "output an empty array",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "any": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "[]": {
        "plug": {
          "0": {
            "unitId": "wait",
            "pinId": "a"
          }
        }
      }
    },
    "id": "b226083c-2797-11eb-a546-c350370e09cb",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6c2a2d48-fd23-11ea-b8c5-27de11375b8a": {
    "name": "drop last",
    "units": {
      "split": {
        "id": "de2d5ba8-ac0f-461e-849b-f4aa84d2736a",
        "input": {
          "a": {},
          "i": {}
        },
        "output": {
          "second": {
            "ignored": true
          },
          "first": {}
        }
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8",
        "input": {
          "a": {}
        },
        "output": {
          "length": {}
        }
      },
      "subtract": {
        "id": "fa94b179-00e3-4ed1-814e-7938324a833f",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a - b": {}
        }
      }
    },
    "merges": {
      "0": {
        "length": {
          "input": {
            "a": true
          }
        },
        "split": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "length": {
          "output": {
            "length": true
          }
        },
        "subtract": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "subtract": {
          "output": {
            "a - b": true
          }
        },
        "split": {
          "input": {
            "i": true
          }
        }
      }
    },
    "inputs": {
      "ab": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        }
      },
      "n": {
        "plug": {
          "0": {
            "unitId": "subtract",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "split",
            "pinId": "first"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "output list \`a\` containing all but the last \`n\` elements of the given list \`ab\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "6c2a2d48-fd23-11ea-b8c5-27de11375b8a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "cdffb1ec-0790-11eb-96fc-97a33d06261b": {
    "name": "drop first",
    "units": {
      "split": {
        "id": "de2d5ba8-ac0f-461e-849b-f4aa84d2736a",
        "input": {
          "a": {},
          "i": {}
        },
        "output": {
          "second": {
            "ignored": false
          },
          "first": {
            "ignored": true
          }
        }
      }
    },
    "merges": {},
    "inputs": {
      "ab": {
        "plug": {
          "0": {
            "unitId": "split",
            "pinId": "a"
          }
        }
      },
      "n": {
        "plug": {
          "0": {
            "unitId": "split",
            "pinId": "i"
          }
        }
      }
    },
    "outputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "split",
            "pinId": "second"
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "output list \`a\` containing all but the first \`n\` elements of the given list \`ab\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "cdffb1ec-0790-11eb-96fc-97a33d06261b",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "abbbe3fa-8ee4-4446-8feb-e21a66fd8580": {
    "name": "concat 3",
    "units": {
      "concat": {
        "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728"
      },
      "concat0": {
        "id": "f57f5318-f26f-4b9f-b9e2-dcc022ad7728"
      }
    },
    "merges": {
      "0": {
        "concat": {
          "input": {
            "b": true
          }
        },
        "concat0": {
          "output": {
            "ab": true
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "concat arrays \`a\`, \`b\` and \`c\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "concat0",
            "pinId": "a"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "concat0",
            "pinId": "b"
          }
        }
      }
    },
    "outputs": {
      "abc": {
        "plug": {
          "0": {
            "unitId": "concat",
            "pinId": "ab"
          }
        }
      }
    },
    "id": "abbbe3fa-8ee4-4446-8feb-e21a66fd8580",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "697871f5-6515-4426-a011-88d0d6aedcc3": {
    "name": "chop 3",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "2"
          }
        }
      },
      "at0": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "0"
          }
        }
      },
      "at1": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a",
        "input": {
          "i": {
            "constant": true,
            "data": "1"
          }
        }
      }
    },
    "merges": {
      "0": {
        "at": {
          "input": {
            "a": true
          }
        },
        "at0": {
          "input": {
            "a": true
          }
        },
        "at1": {
          "input": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "split-three",
      "description": "get array \`a\` first 3 values",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "metadata": {
          "examples": [
            "[1,2,3]"
          ]
        }
      }
    },
    "outputs": {
      "0": {
        "plug": {
          "0": {
            "unitId": "at0",
            "pinId": "a[i]"
          }
        }
      },
      "1": {
        "plug": {
          "0": {
            "unitId": "at1",
            "pinId": "a[i]"
          }
        }
      },
      "2": {
        "plug": {
          "0": {
            "unitId": "at",
            "pinId": "a[i]"
          }
        }
      }
    },
    "id": "697871f5-6515-4426-a011-88d0d6aedcc3",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "e9831075-2e62-43a4-84af-0653f7e707a9": {
    "type": "\`U\`&\`G\`",
    "name": "behead",
    "units": {
      "slice": {
        "id": "c6bf897a-4970-4284-bea2-b4a86186f828",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": 109,
                "y": 54
              }
            }
          },
          "begin": {
            "constant": true,
            "data": {
              "ref": [],
              "data": 1
            },
            "metadata": {
              "position": {
                "x": 26,
                "y": 62
              },
              "data": {
                "position": {
                  "x": -112,
                  "y": 22
                }
              }
            }
          },
          "end": {
            "constant": false,
            "metadata": {
              "position": {
                "x": -29,
                "y": 11
              },
              "data": {
                "position": {
                  "x": -85,
                  "y": -39
                }
              }
            }
          }
        },
        "output": {
          "a": {
            "metadata": {
              "position": {
                "x": 110,
                "y": 19
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 64,
            "y": 36
          }
        }
      },
      "first": {
        "id": "0f77eb13-5c48-4611-a9bf-fe10c903dc63",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -5,
                "y": -93
              }
            }
          }
        },
        "output": {
          "a[0]": {
            "metadata": {
              "position": {
                "x": 91,
                "y": -93
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 43,
            "y": -93
          }
        }
      },
      "length": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8",
        "metadata": {
          "position": {
            "x": -37,
            "y": 9
          }
        },
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -86,
                "y": 5
              }
            }
          }
        }
      }
    },
    "merges": {
      "0": {
        "slice": {
          "input": {
            "end": true
          }
        },
        "length": {
          "output": {
            "length": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "slice",
            "pinId": "a",
            "kind": "input"
          },
          "1": {
            "unitId": "first",
            "pinId": "a",
            "kind": "input"
          },
          "2": {
            "unitId": "length",
            "kind": "input",
            "pinId": "a"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 126,
                "y": 71
              }
            },
            "1": {
              "ext": {
                "x": -28,
                "y": -93
              }
            },
            "2": {
              "ext": {
                "x": -107,
                "y": -5
              }
            }
          }
        }
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "slice",
            "pinId": "a",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 129,
                "y": 5
              }
            }
          }
        }
      },
      "head": {
        "plug": {
          "0": {
            "unitId": "first",
            "pinId": "a[0]",
            "kind": "output"
          }
        },
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 114,
                "y": -93
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "axe",
      "description": "remove the first element \`head\` of \`a\`",
      "position": {
        "data": {
          "x": 75,
          "y": -106
        },
        "merge": {
          "0": {
            "x": 13,
            "y": 19
          }
        }
      },
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "e9831075-2e62-43a4-84af-0653f7e707a9",
    "system": true
  },
  "c4de657d-0af7-45a0-b5a9-64127d78fb18": {
    "name": "at path",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a"
      },
      "loop0": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": true
          }
        }
      },
      "behead": {
        "id": "e9831075-2e62-43a4-84af-0653f7e707a9"
      },
      "loop1": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "local": {
            "ignored": true
          },
          "final": {
            "ignored": false
          }
        }
      },
      "isnotempty": {
        "id": "b74c6c04-8fe8-4009-9f61-b22f7a404342"
      }
    },
    "merges": {
      "0": {
        "loop0": {
          "input": {
            "test": true
          }
        },
        "isnotempty": {
          "output": {
            "test": true
          }
        },
        "loop1": {
          "input": {
            "test": true
          }
        }
      },
      "1": {
        "loop0": {
          "output": {
            "local": true
          }
        },
        "isnotempty": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "loop0": {
          "output": {
            "current": true
          }
        },
        "behead": {
          "input": {
            "a": true
          }
        }
      },
      "phpjterjm": {
        "loop0": {
          "input": {
            "next": true
          }
        },
        "behead": {
          "output": {
            "a": true
          }
        }
      },
      "mage": {
        "behead": {
          "output": {
            "head": true
          }
        },
        "at": {
          "input": {
            "i": true
          }
        }
      },
      "tursgjdqc": {
        "at": {
          "input": {
            "a": true
          }
        },
        "loop1": {
          "output": {
            "current": true
          }
        }
      },
      "sdhxizrr": {
        "at": {
          "output": {
            "a[i]": true
          }
        },
        "loop1": {
          "input": {
            "next": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "get value of \`a\` at \`path\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "loop1",
            "pinId": "init"
          }
        },
        "functional": true
      },
      "path": {
        "plug": {
          "0": {
            "unitId": "loop0",
            "pinId": "init"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "value": {
        "plug": {
          "0": {
            "unitId": "loop1",
            "pinId": "final"
          }
        }
      }
    },
    "id": "c4de657d-0af7-45a0-b5a9-64127d78fb18",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "f962de3a-b87c-4018-bcb6-71921f93ce1d": {
    "name": "at or default",
    "units": {
      "at": {
        "id": "79f01345-4ed7-47e2-8882-fa3bd282c98a"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "if0": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8"
      },
      "ifnot": {
        "id": "439c6b56-a0b6-4b76-9131-c6dc23375fda"
      },
      "lengthgreaterthan": {
        "id": "603ebe2e-5329-446d-b422-78f3201ddd7a"
      }
    },
    "merges": {
      "0": {
        "ifnot": {
          "input": {
            "b": true
          }
        },
        "if": {
          "input": {
            "b": true
          }
        },
        "if0": {
          "input": {
            "b": true
          }
        },
        "lengthgreaterthan": {
          "output": {
            "test": true
          }
        }
      },
      "1": {
        "if0": {
          "input": {
            "a": true
          }
        },
        "lengthgreaterthan": {
          "input": {
            "b": true
          }
        }
      },
      "2": {
        "if": {
          "input": {
            "a": true
          }
        },
        "lengthgreaterthan": {
          "input": {
            "a": true
          }
        }
      },
      "3": {
        "if0": {
          "output": {
            "a if b": true
          }
        },
        "at": {
          "input": {
            "i": true
          }
        }
      },
      "xdocioal": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "at": {
          "input": {
            "a": true
          }
        }
      },
      "jgunro": {
        "at": {
          "output": {
            "a[i]": true
          }
        },
        "ifnot": {
          "output": {
            "a if not b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "brackets",
      "description": "get array \`a\` element at position \`at\` or \`d\` if not present",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "i": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "functional": true
      },
      "d": {
        "plug": {
          "0": {
            "unitId": "ifnot",
            "pinId": "a"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a[i] || d": {
        "plug": {
          "0": {
            "mergeId": "jgunro"
          }
        }
      }
    },
    "id": "f962de3a-b87c-4018-bcb6-71921f93ce1d",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "6db1905f-2343-4c63-97d3-07f4d946ef58": {
    "name": "array builder from",
    "units": {
      "append": {
        "id": "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc"
      },
      "loop": {
        "id": "3432494e-fab6-4e9d-a846-0c48a7c429cd",
        "output": {
          "final": {
            "ignored": false
          }
        }
      }
    },
    "merges": {
      "0": {
        "append": {
          "output": {
            "a": true
          }
        },
        "loop": {
          "input": {
            "next": true
          }
        }
      },
      "1": {
        "append": {
          "input": {
            "a": true
          }
        },
        "loop": {
          "output": {
            "current": true
          }
        }
      }
    },
    "metadata": {
      "icon": "array",
      "description": "build a list starting \`from\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "append",
            "pinId": "b"
          }
        }
      },
      "test": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "test"
          }
        }
      },
      "init": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "init"
          }
        }
      }
    },
    "outputs": {
      "acc": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        }
      },
      "a[]": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "final"
          }
        }
      },
      "local": {
        "plug": {
          "0": {
            "unitId": "loop",
            "pinId": "local"
          }
        }
      }
    },
    "id": "6db1905f-2343-4c63-97d3-07f4d946ef58",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4a065231-48e6-44ed-95bb-8f96c4643574": {
    "name": "array builder",
    "units": {
      "arraybuilderfrom": {
        "id": "6db1905f-2343-4c63-97d3-07f4d946ef58",
        "input": {
          "init": {
            "data": "[]",
            "constant": true
          }
        }
      }
    },
    "merges": {},
    "metadata": {
      "icon": "array",
      "description": "build a list from empty list",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "test": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "test"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "acc": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "acc"
          }
        }
      },
      "a[]": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "a[]"
          }
        }
      },
      "local": {
        "plug": {
          "0": {
            "unitId": "arraybuilderfrom",
            "pinId": "local"
          }
        }
      }
    },
    "id": "4a065231-48e6-44ed-95bb-8f96c4643574",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "765114be-2c5e-4ac8-b04e-27dbcb60ac12": {
    "name": "append if",
    "units": {
      "ifelse": {
        "id": "92760dd2-ecd9-46db-851f-70950a5b6bc3"
      },
      "if": {
        "id": "06bc3983-44b0-43d6-b041-2e9218ea89c8",
        "input": {
          "a": {
            "constant": false
          }
        }
      },
      "append": {
        "id": "fa7721eb-1dd6-482e-8c7a-6da35b5f88bc"
      }
    },
    "merges": {
      "0": {
        "if": {
          "input": {
            "b": true
          }
        },
        "ifelse": {
          "input": {
            "b": true
          }
        }
      },
      "1": {
        "ifelse": {
          "output": {
            "if": true
          }
        },
        "append": {
          "input": {
            "a": true
          }
        }
      },
      "2": {
        "if": {
          "output": {
            "a if b": true
          }
        },
        "append": {
          "input": {
            "b": true
          }
        }
      },
      "3": {
        "ifelse": {
          "output": {
            "else": true
          }
        },
        "append": {
          "output": {
            "a": true
          }
        }
      }
    },
    "metadata": {
      "icon": "chevrons-left",
      "description": "prepend element \`b\` to \`a\` if \`test\`",
      "tags": [
        "core",
        "array"
      ]
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "if",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "ifelse",
            "pinId": "a"
          }
        },
        "functional": true
      },
      "test": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "functional": true
      }
    },
    "outputs": {
      "a": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        }
      }
    },
    "id": "765114be-2c5e-4ac8-b04e-27dbcb60ac12",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "4d0fd348-9049-4733-95fd-b0d5fb166a4a": {
    "name": "add length",
    "units": {
      "length0": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "length1": {
        "id": "46d98b47-0fa4-409e-bbc6-bb3165d863d8"
      },
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      }
    },
    "merges": {
      "0": {
        "length0": {
          "output": {
            "length": true
          }
        },
        "add": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "length1": {
          "output": {
            "length": true
          }
        },
        "add": {
          "input": {
            "b": true
          }
        }
      }
    },
    "inputs": {
      "a": {
        "plug": {
          "0": {
            "unitId": "length0",
            "pinId": "a"
          }
        }
      },
      "b": {
        "plug": {
          "0": {
            "unitId": "length1",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "length": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a + b"
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "add arrays \`a\` and \`b\` lengths",
      "tags": [
        "core",
        "array"
      ]
    },
    "id": "4d0fd348-9049-4733-95fd-b0d5fb166a4a",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "51de3251-1bb6-454d-b9d6-6b8bcb1f56aa": {
    "name": "add 3",
    "units": {
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      },
      "add0": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf"
      }
    },
    "merges": {
      "0": {
        "add0": {
          "input": {
            "b": true
          }
        },
        "add": {
          "output": {
            "a + b": true
          }
        }
      }
    },
    "metadata": {
      "icon": "plus",
      "description": "add 3 numbers",
      "tags": [
        "core",
        "arithmetic"
      ]
    },
    "inputs": {
      "b": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "b"
          }
        }
      },
      "a": {
        "plug": {
          "0": {
            "unitId": "add",
            "pinId": "a"
          }
        }
      },
      "c": {
        "plug": {
          "0": {
            "unitId": "add0",
            "pinId": "a"
          }
        }
      }
    },
    "outputs": {
      "a + b + c": {
        "plug": {
          "0": {
            "unitId": "add0",
            "pinId": "a + b"
          }
        }
      }
    },
    "id": "51de3251-1bb6-454d-b9d6-6b8bcb1f56aa",
    "type": "\`U\`&\`G\`",
    "system": true
  },
  "5dbcc486-a865-452c-9f14-e0d26e3354d7": {
    "type": "\`U\`&\`G\`",
    "name": "animate forever",
    "units": {
      "animate": {
        "id": "1df77a6e-7632-44f0-9878-2aa5e0903928",
        "input": {
          "keyframes": {},
          "opt": {},
          "element": {},
          "done": {}
        },
        "output": {
          "animation": {}
        },
        "metadata": {
          "position": {
            "x": 54,
            "y": -10
          }
        }
      },
      "deepmerge": {
        "id": "2af12780-698c-40ca-baa9-5f3260377e0f",
        "input": {
          "a": {
            "constant": true,
            "data": "{\\"iterations\\":Infinity}"
          },
          "b": {
            "constant": false
          }
        },
        "output": {
          "ab": {}
        },
        "metadata": {
          "position": {
            "x": -55,
            "y": 9
          }
        }
      }
    },
    "merges": {
      "0": {
        "animate": {
          "input": {
            "opt": true
          }
        },
        "deepmerge": {
          "output": {
            "ab": true
          }
        }
      }
    },
    "inputs": {
      "opt": {
        "plug": {
          "0": {
            "unitId": "deepmerge",
            "pinId": "b",
            "kind": "input"
          }
        }
      },
      "keyframes": {
        "plug": {
          "0": {
            "unitId": "animate",
            "pinId": "keyframes",
            "kind": "input"
          }
        },
        "ref": false
      },
      "element": {
        "plug": {
          "0": {
            "unitId": "animate",
            "pinId": "element",
            "kind": "input"
          }
        },
        "ref": true
      },
      "done": {
        "plug": {
          "0": {
            "unitId": "animate",
            "pinId": "done",
            "kind": "input"
          }
        },
        "ref": false
      }
    },
    "outputs": {
      "animation": {
        "plug": {
          "0": {
            "unitId": "animate",
            "pinId": "animation",
            "kind": "output"
          }
        },
        "ref": true
      }
    },
    "metadata": {
      "icon": "timer",
      "description": "animate \`element\` forever",
      "tags": [
        "core",
        "animation"
      ]
    },
    "id": "5dbcc486-a865-452c-9f14-e0d26e3354d7",
    "system": true
  },
  "f1cde29c-2da3-410e-b4c7-737650475933": {
    "type": "\`U\`&\`G\`",
    "name": "pressed",
    "units": {
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": -19,
            "y": -29
          }
        }
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": "false",
            "metadata": {
              "position": {
                "x": 126,
                "y": -18
              }
            }
          }
        },
        "output": {
          "current": {
            "metadata": {
              "position": {
                "x": 126,
                "y": 18
              }
            }
          },
          "local": {
            "constant": false,
            "ignored": true,
            "metadata": {
              "position": {
                "x": 101,
                "y": -40
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 80,
            "y": 0
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": -19,
            "y": 29
          }
        }
      },
      "onpointerdown": {
        "id": "2beefe96-b1ee-11ea-960c-7f33e07a2ad6",
        "metadata": {
          "position": {
            "x": -122,
            "y": -31
          }
        }
      },
      "onpointerup": {
        "id": "43a9d452-b1ee-11ea-923f-efb4af36e68e",
        "metadata": {
          "position": {
            "x": -122,
            "y": 31
          }
        }
      }
    },
    "merges": {
      "0": {
        "onpointerdown": {
          "input": {
            "element": true
          }
        },
        "onpointerup": {
          "input": {
            "element": true
          }
        }
      },
      "1": {
        "false": {
          "input": {
            "any": true
          }
        },
        "onpointerup": {
          "output": {
            "event": true
          }
        }
      },
      "2": {
        "true": {
          "input": {
            "any": true
          }
        },
        "onpointerdown": {
          "output": {
            "event": true
          }
        }
      },
      "3": {
        "true": {
          "output": {
            "true": true
          }
        },
        "iterate": {
          "input": {
            "next": true
          }
        },
        "false": {
          "output": {
            "false": true
          }
        }
      }
    },
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -184,
                "y": 0
              }
            }
          }
        }
      },
      "next": {
        "plug": {
          "0": {
            "mergeId": "3"
          }
        },
        "defaultIgnored": true
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "current",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 144,
                "y": 33
              }
            }
          }
        }
      },
      "up": {
        "plug": {
          "0": {
            "mergeId": "1"
          }
        },
        "ref": false,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -72,
                "y": 62
              }
            }
          }
        }
      },
      "down": {
        "plug": {
          "0": {
            "mergeId": "2"
          }
        },
        "ref": false,
        "defaultIgnored": true,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -72,
                "y": -62
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "question",
      "description": "track element current pressed state",
      "tags": [
        "core"
      ],
      "position": {
        "merge": {
          "0": {
            "x": -161,
            "y": 0
          },
          "1": {
            "x": -71,
            "y": 38
          },
          "2": {
            "x": -71,
            "y": -38
          },
          "3": {
            "x": 25,
            "y": 0
          }
        }
      }
    },
    "id": "f1cde29c-2da3-410e-b4c7-737650475933",
    "system": true
  },
  "54d339fb-76af-4a37-9f0a-08015fb51850": {
    "type": "\`U\`&\`G\`",
    "name": "norm",
    "units": {
      "add": {
        "id": "6fe452f2-2ec1-4ee2-887d-751c3697e6bf",
        "input": {
          "a": {},
          "b": {}
        },
        "output": {
          "a + b": {}
        },
        "metadata": {
          "position": {
            "x": -7,
            "y": 11
          }
        }
      },
      "pow2": {
        "id": "8e017373-3a2b-4985-b60c-f6f0a94db200",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -128,
                "y": -69
              }
            }
          }
        },
        "output": {
          "a²": {}
        },
        "metadata": {
          "position": {
            "x": -81,
            "y": -56
          }
        }
      },
      "sqrt": {
        "id": "530e83d2-1d61-11eb-b472-53e545a06c92",
        "input": {
          "a": {}
        },
        "output": {
          "√a": {
            "metadata": {
              "position": {
                "x": 143,
                "y": 15
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 95,
            "y": 15
          }
        }
      },
      "pow20": {
        "id": "8e017373-3a2b-4985-b60c-f6f0a94db200",
        "input": {
          "a": {
            "metadata": {
              "position": {
                "x": -145,
                "y": 74
              }
            }
          }
        },
        "output": {
          "a²": {}
        },
        "metadata": {
          "position": {
            "x": -96,
            "y": 64
          }
        }
      }
    },
    "merges": {
      "0": {
        "add": {
          "output": {
            "a + b": true
          }
        },
        "sqrt": {
          "input": {
            "a": true
          }
        }
      },
      "1": {
        "add": {
          "input": {
            "a": true
          }
        },
        "pow2": {
          "output": {
            "a²": true
          }
        }
      },
      "2": {
        "add": {
          "input": {
            "b": true
          }
        },
        "pow20": {
          "output": {
            "a²": true
          }
        }
      }
    },
    "inputs": {
      "y": {
        "plug": {
          "0": {
            "unitId": "pow2",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -147,
                "y": -83
              }
            }
          }
        }
      },
      "x": {
        "plug": {
          "0": {
            "unitId": "pow20",
            "pinId": "a",
            "kind": "input"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": -166,
                "y": 83
              }
            }
          }
        }
      }
    },
    "outputs": {
      "d": {
        "plug": {
          "0": {
            "unitId": "sqrt",
            "pinId": "√a",
            "kind": "output"
          }
        },
        "ref": false,
        "metadata": {
          "position": {
            "0": {
              "ext": {
                "x": 166,
                "y": 17
              }
            }
          }
        }
      }
    },
    "metadata": {
      "icon": "ruler",
      "description": "length of vector x y",
      "position": {
        "merge": {
          "0": {
            "x": 45,
            "y": 13
          },
          "1": {
            "x": -39,
            "y": -28
          },
          "2": {
            "x": -49,
            "y": 42
          }
        }
      },
      "tags": [
        "core"
      ]
    },
    "id": "54d339fb-76af-4a37-9f0a-08015fb51850",
    "system": true
  },
  "9b9ba4bc-7f94-40db-8988-d23867a6b0c3": {
    "type": "\`U\`&\`G\`",
    "name": "hovered",
    "units": {
      "true": {
        "id": "984c4a44-86c7-464c-ad48-4759598c3be3",
        "input": {
          "any": {}
        },
        "output": {
          "true": {}
        },
        "metadata": {
          "position": {
            "x": 7,
            "y": 45
          }
        }
      },
      "iterate": {
        "id": "8a2b756a-25e4-11eb-860d-1f34c850b992",
        "input": {
          "next": {},
          "init": {
            "constant": true,
            "data": "false",
            "metadata": {
              "position": {
                "x": 100,
                "y": -16
              }
            }
          }
        },
        "output": {
          "current": {
            "metadata": {
              "position": {
                "x": 105,
                "y": 19
              }
            }
          },
          "local": {
            "constant": false,
            "ignored": true,
            "metadata": {
              "position": {
                "x": 113,
                "y": 1
              }
            }
          }
        },
        "metadata": {
          "position": {
            "x": 120,
            "y": 8
          }
        }
      },
      "false": {
        "id": "b4d20f6f-32dc-4d04-97d6-69518976bdea",
        "input": {
          "any": {}
        },
        "output": {
          "false": {}
        },
        "metadata": {
          "position": {
            "x": 95,
            "y": 36
          }
        }
      },
      "onpointerenter": {
        "id": "c0bb493a-af78-11ea-b6fa-3b893b757a39",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": -90,
            "y": 18
          }
        }
      },
      "onpointerleave": {
        "id": "c7dba94e-af78-11ea-b7d7-47e14ca215b5",
        "input": {
          "element": {}
        },
        "output": {
          "event": {}
        },
        "metadata": {
          "position": {
            "x": 1,
            "y": -15
          }
        }
      }
    },
    "merges": {
      "0": {
        "onpointerenter": {
          "input": {
            "element": true
          }
        },
        "onpointerleave": {
          "input": {
            "element": true
          }
        }
      },
      "1": {
        "false": {
          "input": {
            "any": true
          }
        },
        "onpointerleave": {
          "output": {
            "event": true
          }
        }
      },
      "2": {
        "true": {
          "input": {
            "any": true
          }
        },
        "onpointerenter": {
          "output": {
            "event": true
          }
        }
      },
      "3": {
        "true": {
          "output": {
            "true": true
          }
        },
        "iterate": {
          "input": {
            "next": true
          }
        },
        "false": {
          "output": {
            "false": true
          }
        }
      }
    },
    "inputs": {
      "element": {
        "plug": {
          "0": {
            "mergeId": "0"
          }
        },
        "ref": true
      }
    },
    "outputs": {
      "current": {
        "plug": {
          "0": {
            "unitId": "iterate",
            "pinId": "current",
            "kind": "output"
          }
        },
        "ref": false
      }
    },
    "metadata": {
      "icon": "question",
      "description": "track element current hovered state",
      "tags": [
        "core"
      ]
    },
    "id": "9b9ba4bc-7f94-40db-8988-d23867a6b0c3",
    "system": true
  },
  "e33e7dcd-9715-461c-a474-15ed2bda899e": {
    "name": "empty",
    "units": {},
    "merges": {},
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": null,
      "description": "empty graph",
      "tags": [
        "core"
      ]
    },
    "id": "e33e7dcd-9715-461c-a474-15ed2bda899e",
    "type": "\`U\`&\`G\`",
    "system": true
  }
}`)
